// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"dylud":[function(require,module,exports) {
/**
* vue v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>compileToFunction);
var _runtimeDom = require("@vue/runtime-dom");
parcelHelpers.exportAll(_runtimeDom, exports);
var _compilerDom = require("@vue/compiler-dom");
var _shared = require("@vue/shared");
function initDev() {
    (0, _runtimeDom.initCustomFormatter)();
}
const compileCache = /* @__PURE__ */ new WeakMap();
function getCache(options) {
    let c = compileCache.get(options != null ? options : (0, _shared.EMPTY_OBJ));
    if (!c) {
        c = /* @__PURE__ */ Object.create(null);
        compileCache.set(options != null ? options : (0, _shared.EMPTY_OBJ), c);
    }
    return c;
}
function compileToFunction(template, options) {
    if (!(0, _shared.isString)(template)) {
        if (template.nodeType) template = template.innerHTML;
        else return 0, _shared.NOOP;
    }
    const key = template;
    const cache = getCache(options);
    const cached = cache[key];
    if (cached) return cached;
    if (template[0] === "#") {
        const el = document.querySelector(template);
        template = el ? el.innerHTML : ``;
    }
    const opts = (0, _shared.extend)({
        hoistStatic: true,
        onError: void 0,
        onWarn: (0, _shared.NOOP)
    }, options);
    if (!opts.isCustomElement && typeof customElements !== "undefined") opts.isCustomElement = (tag)=>!!customElements.get(tag);
    const { code } = (0, _compilerDom.compile)(template, opts);
    function onError(err, asWarning = false) {
        const message = asWarning ? err.message : `Template compilation error: ${err.message}`;
        const codeFrame = err.loc && (0, _shared.generateCodeFrame)(template, err.loc.start.offset, err.loc.end.offset);
        (0, _runtimeDom.warn)(codeFrame ? `${message}
${codeFrame}` : message);
    }
    const render = new Function("Vue", code)(_runtimeDom);
    render._rc = true;
    return cache[key] = render;
}
(0, _runtimeDom.registerRuntimeCompiler)(compileToFunction);

},{"@vue/runtime-dom":"lgHax","@vue/compiler-dom":"OsNOm","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgHax":[function(require,module,exports) {
/**
* @vue/runtime-dom v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "TransitionGroup", ()=>TransitionGroup);
parcelHelpers.export(exports, "VueElement", ()=>VueElement);
parcelHelpers.export(exports, "createApp", ()=>createApp);
parcelHelpers.export(exports, "createSSRApp", ()=>createSSRApp);
parcelHelpers.export(exports, "defineCustomElement", ()=>defineCustomElement);
parcelHelpers.export(exports, "defineSSRCustomElement", ()=>defineSSRCustomElement);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "initDirectivesForSSR", ()=>initDirectivesForSSR);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "useCssModule", ()=>useCssModule);
parcelHelpers.export(exports, "useCssVars", ()=>useCssVars);
parcelHelpers.export(exports, "vModelCheckbox", ()=>vModelCheckbox);
parcelHelpers.export(exports, "vModelDynamic", ()=>vModelDynamic);
parcelHelpers.export(exports, "vModelRadio", ()=>vModelRadio);
parcelHelpers.export(exports, "vModelSelect", ()=>vModelSelect);
parcelHelpers.export(exports, "vModelText", ()=>vModelText);
parcelHelpers.export(exports, "vShow", ()=>vShow);
parcelHelpers.export(exports, "withKeys", ()=>withKeys);
parcelHelpers.export(exports, "withModifiers", ()=>withModifiers);
var _runtimeCore = require("@vue/runtime-core");
parcelHelpers.exportAll(_runtimeCore, exports);
var _shared = require("@vue/shared");
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, {
            is
        }) : doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>doc.createTextNode(text),
    createComment: (text)=>doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            templateContainer.innerHTML = namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content;
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = Symbol("_vtc");
const Transition = (props, { slots })=>(0, _runtimeCore.h)((0, _runtimeCore.BaseTransition), resolveTransitionProps(props), slots);
Transition.displayName = "Transition";
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = Transition.props = /* @__PURE__ */ (0, _shared.extend)({}, (0, _runtimeCore.BaseTransitionPropsValidators), DOMTransitionPropsValidators);
const callHook = (hook, args = [])=>{
    if ((0, _shared.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const hasExplicitCallback = (hook)=>{
    return hook ? (0, _shared.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            callHook(hook, [
                el,
                resolve
            ]);
            nextFrame(()=>{
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, _shared.extend)(baseProps, {
        onBeforeEnter (el) {
            callHook(onBeforeEnter, [
                el
            ]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            callHook(onBeforeAppear, [
                el
            ]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            addTransitionClass(el, leaveActiveClass);
            forceReflow();
            nextFrame(()=>{
                if (!el._isLeaving) return;
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, _shared.isObject)(duration)) return [
        NumberOf(duration.enter),
        NumberOf(duration.leave)
    ];
    else {
        const n = NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function NumberOf(val) {
    const res = (0, _shared.toNumber)(val);
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[vtcKey] = void 0;
    }
}
function nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${TRANSITION}Property`).toString());
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>toMs(d) + toMs(delays[i])));
}
function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
    return document.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
    beforeMount (el, { value }, { transition }) {
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else setDisplay(el, value);
    },
    mounted (el, { value }, { transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value, oldValue }, { transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                setDisplay(el, false);
            });
        } else setDisplay(el, value);
    },
    beforeUnmount (el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = ({ value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const CSS_VAR_TEXT = Symbol("");
function useCssVars(getter) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, _runtimeCore.onBeforeMount)(()=>{
        (0, _runtimeCore.watchPostEffect)(setVars);
    });
    (0, _runtimeCore.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, _runtimeCore.onUnmounted)(()=>ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, _runtimeCore.Fragment)) vnode.children.forEach((c)=>setVarsOnVNode(c, vars));
    else if (vnode.type === (0, _runtimeCore.Static)) {
        let { el, anchor } = vnode;
        while(el){
            setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, _shared.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, _shared.isString)(prev)) {
                for(const key in prev)if (next[key] == null) setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) style.display = "none";
    }
}
const semicolonRE = /[^\\];\s*$/;
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0, _shared.isArray)(val)) val.forEach((v)=>setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) style.setProperty((0, _shared.hyphenate)(prefixed), val.replace(importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) return cached;
    let name = (0, _runtimeCore.camelize)(rawName);
    if (name !== "filter" && name in style) return prefixCache[rawName] = name;
    name = (0, _shared.capitalize)(name);
    for(let i = 0; i < prefixes.length; i++){
        const prefixed = prefixes[i] + name;
        if (prefixed in style) return prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = (0, _shared.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS(xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, _shared.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, _shared.isSymbol)(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent) {
    if (key === "innerHTML" || key === "textContent") {
        if (value == null) return;
        el[key] = value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, _shared.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = createInvoker(nextValue, instance);
            addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match(optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, _shared.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = ()=>cachedNow || (p.then(()=>cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, _runtimeCore.callWithAsyncErrorHandling)(patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if ((0, _shared.isFunction)(value) || (0, _shared.isArray)(value)) return value;
    (0, _runtimeCore.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, _shared.NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if ((0, _shared.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") patchClass(el, nextValue, isSVG);
    else if (key === "style") patchStyle(el, prevValue, nextValue);
    else if ((0, _shared.isOn)(key)) {
        if (!(0, _shared.isModelListener)(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && isNativeOn(key) && (0, _shared.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if (isNativeOn(key) && (0, _shared.isString)(value)) return false;
    return key in el;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineCustomElement(options, extraOptions, hydrate2) {
    const Comp = (0, _runtimeCore.defineComponent)(options, extraOptions);
    class VueCustomElement extends VueElement {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ defineCustomElement(options, extraOptions, hydrate);
};
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._ob = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, _runtimeCore.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                render(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props, styles } = def;
            let numberProps;
            if (props && !(0, _shared.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, _shared.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, _shared.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props } = def;
        const declaredPropKeys = (0, _shared.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, _shared.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.hasAttribute(key) ? this.getAttribute(key) : void 0;
        const camelKey = (0, _shared.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, _shared.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, _shared.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, _shared.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, _shared.hyphenate)(key));
            }
        }
    }
    _update() {
        render(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, _runtimeCore.createVNode)(this._def, (0, _shared.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, _shared.hyphenate)(event) !== event) dispatch((0, _shared.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
}
function useCssModule(name = "$style") {
    {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        if (!instance) return 0, _shared.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, _shared.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, _shared.EMPTY_OBJ;
        return mod;
    }
}
const positionMap = /* @__PURE__ */ new WeakMap();
const newPositionMap = /* @__PURE__ */ new WeakMap();
const moveCbKey = Symbol("_moveCb");
const enterCbKey = Symbol("_enterCb");
const TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, _shared.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots }) {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        const state = (0, _runtimeCore.useTransitionState)();
        let prevChildren;
        let children;
        (0, _runtimeCore.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, _runtimeCore.toRaw)(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, _runtimeCore.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, _runtimeCore.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, _runtimeCore.createVNode)(tag, null, children);
        };
    }
};
const removeMode = (props)=>delete props.mode;
/* @__PURE__ */ removeMode(TransitionGroupImpl.props);
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) el[moveCbKey]();
    if (el[enterCbKey]) el[enterCbKey]();
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, _shared.isArray)(fn) ? (value)=>(0, _shared.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const assignKey = Symbol("_assign");
const vModelText = {
    created (el, { modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, _shared.looseToNumber)(domValue);
            el[assignKey](domValue);
        });
        if (trim) addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, _shared.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if ((0, _shared.isArray)(modelValue)) {
                const index = (0, _shared.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, _shared.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign(getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    if ((0, _shared.isArray)(value)) el.checked = (0, _shared.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, _shared.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, getCheckboxValue(el, true));
}
const vModelRadio = {
    created (el, { value }, vnode) {
        el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate (el, { value, oldValue }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0, _shared.isSet)(value);
        addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, _shared.looseToNumber)(getValue(o)) : getValue(o));
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, _runtimeCore.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value, modifiers: { number } }) {
        setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated (el, { value, modifiers: { number } }) {
        if (!el._assigning) setSelected(el, value);
    }
};
function setSelected(el, value, number) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, _shared.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, _shared.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, _shared.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, _shared.looseEqual)(getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch(type){
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value })=>({
            value
        });
    vModelRadio.getSSRProps = ({ value }, vnode)=>{
        if (vnode.props && (0, _shared.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode)=>{
        if ((0, _shared.isArray)(value)) {
            if (vnode.props && (0, _shared.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, _shared.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    vModelDynamic.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const withKeys = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, _shared.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || keyNames[k] === eventKey)) return fn(event);
    });
};
const rendererOptions = /* @__PURE__ */ (0, _shared.extend)({
    patchProp
}, nodeOps);
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = (0, _runtimeCore.createRenderer)(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : (0, _runtimeCore.createHydrationRenderer)(rendererOptions);
    enabledHydration = true;
    return renderer;
}
const render = (...args)=>{
    ensureRenderer().render(...args);
};
const hydrate = (...args)=>{
    ensureHydrationRenderer().hydrate(...args);
};
const createApp = (...args)=>{
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, _shared.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const createSSRApp = (...args)=>{
    const app = ensureHydrationRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, resolveRootNamespace(container));
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if ((0, _runtimeCore.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, _runtimeCore.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, _runtimeCore.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, _runtimeCore.warn)(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0, _shared.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let ssrDirectiveInitialized = false;
const initDirectivesForSSR = ()=>{
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};

},{"@vue/runtime-core":"jG196","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jG196":[function(require,module,exports) {
/**
* @vue/runtime-core v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>(0, _reactivity.EffectScope));
parcelHelpers.export(exports, "ReactiveEffect", ()=>(0, _reactivity.ReactiveEffect));
parcelHelpers.export(exports, "TrackOpTypes", ()=>(0, _reactivity.TrackOpTypes));
parcelHelpers.export(exports, "TriggerOpTypes", ()=>(0, _reactivity.TriggerOpTypes));
parcelHelpers.export(exports, "customRef", ()=>(0, _reactivity.customRef));
parcelHelpers.export(exports, "effect", ()=>(0, _reactivity.effect));
parcelHelpers.export(exports, "effectScope", ()=>(0, _reactivity.effectScope));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _reactivity.getCurrentScope));
parcelHelpers.export(exports, "isProxy", ()=>(0, _reactivity.isProxy));
parcelHelpers.export(exports, "isReactive", ()=>(0, _reactivity.isReactive));
parcelHelpers.export(exports, "isReadonly", ()=>(0, _reactivity.isReadonly));
parcelHelpers.export(exports, "isRef", ()=>(0, _reactivity.isRef));
parcelHelpers.export(exports, "isShallow", ()=>(0, _reactivity.isShallow));
parcelHelpers.export(exports, "markRaw", ()=>(0, _reactivity.markRaw));
parcelHelpers.export(exports, "onScopeDispose", ()=>(0, _reactivity.onScopeDispose));
parcelHelpers.export(exports, "proxyRefs", ()=>(0, _reactivity.proxyRefs));
parcelHelpers.export(exports, "reactive", ()=>(0, _reactivity.reactive));
parcelHelpers.export(exports, "readonly", ()=>(0, _reactivity.readonly));
parcelHelpers.export(exports, "ref", ()=>(0, _reactivity.ref));
parcelHelpers.export(exports, "shallowReactive", ()=>(0, _reactivity.shallowReactive));
parcelHelpers.export(exports, "shallowReadonly", ()=>(0, _reactivity.shallowReadonly));
parcelHelpers.export(exports, "shallowRef", ()=>(0, _reactivity.shallowRef));
parcelHelpers.export(exports, "stop", ()=>(0, _reactivity.stop));
parcelHelpers.export(exports, "toRaw", ()=>(0, _reactivity.toRaw));
parcelHelpers.export(exports, "toRef", ()=>(0, _reactivity.toRef));
parcelHelpers.export(exports, "toRefs", ()=>(0, _reactivity.toRefs));
parcelHelpers.export(exports, "toValue", ()=>(0, _reactivity.toValue));
parcelHelpers.export(exports, "triggerRef", ()=>(0, _reactivity.triggerRef));
parcelHelpers.export(exports, "unref", ()=>(0, _reactivity.unref));
parcelHelpers.export(exports, "camelize", ()=>(0, _shared.camelize));
parcelHelpers.export(exports, "capitalize", ()=>(0, _shared.capitalize));
parcelHelpers.export(exports, "normalizeClass", ()=>(0, _shared.normalizeClass));
parcelHelpers.export(exports, "normalizeProps", ()=>(0, _shared.normalizeProps));
parcelHelpers.export(exports, "normalizeStyle", ()=>(0, _shared.normalizeStyle));
parcelHelpers.export(exports, "toDisplayString", ()=>(0, _shared.toDisplayString));
parcelHelpers.export(exports, "toHandlerKey", ()=>(0, _shared.toHandlerKey));
parcelHelpers.export(exports, "BaseTransition", ()=>BaseTransition);
parcelHelpers.export(exports, "BaseTransitionPropsValidators", ()=>BaseTransitionPropsValidators);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "DeprecationTypes", ()=>DeprecationTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "ErrorTypeStrings", ()=>ErrorTypeStrings);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "KeepAlive", ()=>KeepAlive);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "Suspense", ()=>Suspense);
parcelHelpers.export(exports, "Teleport", ()=>Teleport);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "assertNumber", ()=>assertNumber);
parcelHelpers.export(exports, "callWithAsyncErrorHandling", ()=>callWithAsyncErrorHandling);
parcelHelpers.export(exports, "callWithErrorHandling", ()=>callWithErrorHandling);
parcelHelpers.export(exports, "cloneVNode", ()=>cloneVNode);
parcelHelpers.export(exports, "compatUtils", ()=>compatUtils);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "createBlock", ()=>createBlock);
parcelHelpers.export(exports, "createCommentVNode", ()=>createCommentVNode);
parcelHelpers.export(exports, "createElementBlock", ()=>createElementBlock);
parcelHelpers.export(exports, "createElementVNode", ()=>createBaseVNode);
parcelHelpers.export(exports, "createHydrationRenderer", ()=>createHydrationRenderer);
parcelHelpers.export(exports, "createPropsRestProxy", ()=>createPropsRestProxy);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "createSlots", ()=>createSlots);
parcelHelpers.export(exports, "createStaticVNode", ()=>createStaticVNode);
parcelHelpers.export(exports, "createTextVNode", ()=>createTextVNode);
parcelHelpers.export(exports, "createVNode", ()=>createVNode);
parcelHelpers.export(exports, "defineAsyncComponent", ()=>defineAsyncComponent);
parcelHelpers.export(exports, "defineComponent", ()=>defineComponent);
parcelHelpers.export(exports, "defineEmits", ()=>defineEmits);
parcelHelpers.export(exports, "defineExpose", ()=>defineExpose);
parcelHelpers.export(exports, "defineModel", ()=>defineModel);
parcelHelpers.export(exports, "defineOptions", ()=>defineOptions);
parcelHelpers.export(exports, "defineProps", ()=>defineProps);
parcelHelpers.export(exports, "defineSlots", ()=>defineSlots);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "getCurrentInstance", ()=>getCurrentInstance);
parcelHelpers.export(exports, "getTransitionRawChildren", ()=>getTransitionRawChildren);
parcelHelpers.export(exports, "guardReactiveProps", ()=>guardReactiveProps);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "hasInjectionContext", ()=>hasInjectionContext);
parcelHelpers.export(exports, "initCustomFormatter", ()=>initCustomFormatter);
parcelHelpers.export(exports, "inject", ()=>inject);
parcelHelpers.export(exports, "isMemoSame", ()=>isMemoSame);
parcelHelpers.export(exports, "isRuntimeOnly", ()=>isRuntimeOnly);
parcelHelpers.export(exports, "isVNode", ()=>isVNode);
parcelHelpers.export(exports, "mergeDefaults", ()=>mergeDefaults);
parcelHelpers.export(exports, "mergeModels", ()=>mergeModels);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "onActivated", ()=>onActivated);
parcelHelpers.export(exports, "onBeforeMount", ()=>onBeforeMount);
parcelHelpers.export(exports, "onBeforeUnmount", ()=>onBeforeUnmount);
parcelHelpers.export(exports, "onBeforeUpdate", ()=>onBeforeUpdate);
parcelHelpers.export(exports, "onDeactivated", ()=>onDeactivated);
parcelHelpers.export(exports, "onErrorCaptured", ()=>onErrorCaptured);
parcelHelpers.export(exports, "onMounted", ()=>onMounted);
parcelHelpers.export(exports, "onRenderTracked", ()=>onRenderTracked);
parcelHelpers.export(exports, "onRenderTriggered", ()=>onRenderTriggered);
parcelHelpers.export(exports, "onServerPrefetch", ()=>onServerPrefetch);
parcelHelpers.export(exports, "onUnmounted", ()=>onUnmounted);
parcelHelpers.export(exports, "onUpdated", ()=>onUpdated);
parcelHelpers.export(exports, "openBlock", ()=>openBlock);
parcelHelpers.export(exports, "popScopeId", ()=>popScopeId);
parcelHelpers.export(exports, "provide", ()=>provide);
parcelHelpers.export(exports, "pushScopeId", ()=>pushScopeId);
parcelHelpers.export(exports, "queuePostFlushCb", ()=>queuePostFlushCb);
parcelHelpers.export(exports, "registerRuntimeCompiler", ()=>registerRuntimeCompiler);
parcelHelpers.export(exports, "renderList", ()=>renderList);
parcelHelpers.export(exports, "renderSlot", ()=>renderSlot);
parcelHelpers.export(exports, "resolveComponent", ()=>resolveComponent);
parcelHelpers.export(exports, "resolveDirective", ()=>resolveDirective);
parcelHelpers.export(exports, "resolveDynamicComponent", ()=>resolveDynamicComponent);
parcelHelpers.export(exports, "resolveFilter", ()=>resolveFilter);
parcelHelpers.export(exports, "resolveTransitionHooks", ()=>resolveTransitionHooks);
parcelHelpers.export(exports, "setBlockTracking", ()=>setBlockTracking);
parcelHelpers.export(exports, "setDevtoolsHook", ()=>setDevtoolsHook);
parcelHelpers.export(exports, "setTransitionHooks", ()=>setTransitionHooks);
parcelHelpers.export(exports, "ssrContextKey", ()=>ssrContextKey);
parcelHelpers.export(exports, "ssrUtils", ()=>ssrUtils);
parcelHelpers.export(exports, "toHandlers", ()=>toHandlers);
parcelHelpers.export(exports, "transformVNodeArgs", ()=>transformVNodeArgs);
parcelHelpers.export(exports, "useAttrs", ()=>useAttrs);
parcelHelpers.export(exports, "useModel", ()=>useModel);
parcelHelpers.export(exports, "useSSRContext", ()=>useSSRContext);
parcelHelpers.export(exports, "useSlots", ()=>useSlots);
parcelHelpers.export(exports, "useTransitionState", ()=>useTransitionState);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "watch", ()=>watch);
parcelHelpers.export(exports, "watchEffect", ()=>watchEffect);
parcelHelpers.export(exports, "watchPostEffect", ()=>watchPostEffect);
parcelHelpers.export(exports, "watchSyncEffect", ()=>watchSyncEffect);
parcelHelpers.export(exports, "withAsyncContext", ()=>withAsyncContext);
parcelHelpers.export(exports, "withCtx", ()=>withCtx);
parcelHelpers.export(exports, "withDefaults", ()=>withDefaults);
parcelHelpers.export(exports, "withDirectives", ()=>withDirectives);
parcelHelpers.export(exports, "withMemo", ()=>withMemo);
parcelHelpers.export(exports, "withScopeId", ()=>withScopeId);
var _reactivity = require("@vue/reactivity");
var _shared = require("@vue/shared");
const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    (0, _reactivity.pauseTracking)();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) callWithErrorHandling(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode })=>`at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, _reactivity.resetTracking)();
    isWarning = false;
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function formatProp(key, value, raw) {
    if ((0, _shared.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, _reactivity.isRef)(value)) {
        value = formatProp(key, (0, _reactivity.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, _shared.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, _reactivity.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function assertNumber(val, type) {
    return;
}
const ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE"
};
const ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update"
};
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0, _shared.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0, _shared.isPromise)(res)) res.catch((err)=>{
            handleError(err, instance, type);
        });
        return res;
    }
    if ((0, _shared.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        return values;
    }
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            (0, _reactivity.pauseTracking)();
            callWithErrorHandling(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, _reactivity.resetTracking)();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev);
}
function logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let isFlushing = false;
let isFlushPending = false;
const queue = [];
let flushIndex = 0;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = queue[middle];
        const middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.pre) start = middle + 1;
        else end = middle;
    }
    return start;
}
function queueJob(job) {
    if (!queue.length || !queue.includes(job, isFlushing && job.allowRecurse ? flushIndex + 1 : flushIndex)) {
        if (job.id == null) queue.push(job);
        else queue.splice(findInsertionIndex(job.id), 0, job);
        queueFlush();
    }
}
function queueFlush() {
    if (!isFlushing && !isFlushPending) {
        isFlushPending = true;
        currentFlushPromise = resolvedPromise.then(flushJobs);
    }
}
function invalidateJob(job) {
    const i = queue.indexOf(job);
    if (i > flushIndex) queue.splice(i, 1);
}
function queuePostFlushCb(cb) {
    if (!(0, _shared.isArray)(cb)) {
        if (!activePostFlushCbs || !activePostFlushCbs.includes(cb, cb.allowRecurse ? postFlushIndex + 1 : postFlushIndex)) pendingPostFlushCbs.push(cb);
    } else pendingPostFlushCbs.push(...cb);
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i = isFlushing ? flushIndex + 1 : 0) {
    for(; i < queue.length; i++){
        const cb = queue[i];
        if (cb && cb.pre) {
            if (instance && cb.id !== instance.uid) continue;
            queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set(pendingPostFlushCbs)
        ].sort((a, b)=>getId(a) - getId(b));
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        for(postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++){
            const cb = activePostFlushCbs[postFlushIndex];
            if (cb.active !== false) cb();
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job)=>job.id == null ? Infinity : job.id;
const comparator = (a, b)=>{
    const diff = getId(a) - getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function flushJobs(seen) {
    isFlushPending = false;
    isFlushing = true;
    queue.sort(comparator);
    const check = (0, _shared.NOOP);
    try {
        for(flushIndex = 0; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job && job.active !== false) callWithErrorHandling(job, job.i, job.i ? 15 : 14);
        }
    } finally{
        flushIndex = 0;
        queue.length = 0;
        flushPostFlushCbs(seen);
        isFlushing = false;
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
    }
}
function checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > RECURSION_LIMIT) {
            const instance = fn.i;
            const componentName = instance && getComponentName(instance.type);
            handleError(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Map();
const map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) return false;
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        instance.effect.dirty = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = normalizeClassComponent(instance.type);
        let dirtyInstances = hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) updateComponentDef(oldComp, newComp);
            hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) {
            instance.parent.effect.dirty = true;
            queueJob(()=>{
                instance.parent.update();
                dirtyInstances.delete(instance);
            });
        } else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    queuePostFlushCb(()=>{
        hmrDirtyComponents.clear();
    });
}
function updateComponentDef(oldComp, newComp) {
    (0, _shared.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event, ...args) {
    if (devtools$1) devtools$1.emit(event, ...args);
    else if (!devtoolsNotInstalled) buffer.push({
        event,
        args
    });
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(({ event, args })=>devtools$1.emit(event, ...args));
        buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    } else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const devtoolsComponentRemoved = (component)=>{
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return (component)=>{
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
const withScopeId = (_id)=>withCtx;
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) setBlockTracking(-1);
        const prevInstance = setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) setBlockTracking(1);
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function validateDirectiveName(name) {
    if ((0, _shared.isBuiltInDirective)(name)) warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) return vnode;
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, _shared.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, _shared.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) traverse(value);
            bindings.push({
                dir,
                instance,
                value,
                oldValue: void 0,
                arg,
                modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, _reactivity.pauseTracking)();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, _reactivity.resetTracking)();
        }
    }
}
const leaveCbKey = Symbol("_leaveCb");
const enterCbKey = Symbol("_enterCb");
function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(()=>{
        state.isMounted = true;
    });
    onBeforeUnmount(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [
    Function,
    Array
];
const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        return ()=>{
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== Comment) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, _reactivity.toRaw)(props);
            const { mode } = rawProps;
            if (state.isLeaving) return emptyPlaceholder(child);
            const innerChild = getKeepAliveChild(child);
            if (!innerChild) return emptyPlaceholder(child);
            let enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            setTransitionHooks(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && getKeepAliveChild(oldChild);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild) && recursiveGetSubtree(instance).type !== Comment) {
                const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) {
                            instance.effect.dirty = true;
                            instance.update();
                        }
                    };
                    return emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== Comment) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[leaveCbKey] = ()=>{
                        earlyRemove();
                        el[leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, _shared.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[leaveCbKey]) el[leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) leavingVNode.el[leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[enterCbKey]) el[enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = resolveTransitionHooks(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getKeepAliveChild(vnode) {
    if (!isKeepAlive(vnode)) return vnode;
    const { shapeFlag, children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, _shared.isFunction)(children.default)) return children.default();
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) setTransitionHooks(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        } else if (keepComment || child.type !== Comment) ret.push(key != null ? cloneVNode(child, {
            key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return (0, _shared.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, _shared.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if ((0, _shared.isFunction)(source)) source = {
        loader: source
    };
    const { loader, loadingComponent, errorComponent, delay = 200, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = currentInstance;
            if (resolvedComp) return ()=>createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, _reactivity.ref)(false);
            const error = (0, _reactivity.ref)();
            const delayed = (0, _reactivity.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) {
                    instance.parent.effect.dirty = true;
                    queueJob(instance.parent.update);
                }
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return createVNode(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return createVNode(loadingComponent);
            };
        }
    });
}
function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, _shared.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(()=>{
                if (instance2.da) (0, _shared.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) unmount(cached);
            else if (current) resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        watch(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>matches(include, name));
            exclude && pruneCache((name)=>!matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if (isSuspense(instance.subTree.type)) queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(()=>{
            cache.forEach((cached)=>{
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) setTransitionHooks(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0, _shared.isArray)(pattern)) return pattern.some((p)=>matches(p, name));
    else if ((0, _shared.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, _shared.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(()=>{
        (0, _shared.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, _reactivity.pauseTracking)();
            const reset = setCurrentInstance(target);
            const res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            (0, _reactivity.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const createHook = (lifecycle)=>(hook, target = currentInstance)=>{
        if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
}
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if ((0, _shared.isString)(component)) return resolveAsset(COMPONENTS, component, false) || component;
    else return component || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, _shared.camelize)(name) || selfName === (0, _shared.capitalize)((0, _shared.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[(0, _shared.camelize)(name)] || registry[(0, _shared.capitalize)((0, _shared.camelize)(name))]);
}
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, _shared.isArray)(source) || (0, _shared.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, _shared.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function createSlots(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, _shared.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.isCE || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return createVNode("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const rendered = createBlock(Fragment, {
        key: (props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!isVNode(child)) return true;
        if (child.type === Comment) return false;
        if (child.type === Fragment && !ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, _shared.toHandlerKey)(key)] = obj[key];
    return ret;
}
const getPublicInstance = (i)=>{
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, _shared.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>getPublicInstance(i.parent),
    $root: (i)=>getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            i.effect.dirty = true;
            queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : (0, _shared.NOOP)
});
const isReservedPrefix = (key)=>key === "_" || key === "$";
const hasSetupBinding = (state, key)=>state !== (0, _shared.EMPTY_OBJ) && !state.__isScriptSetup && (0, _shared.hasOwn)(state, key);
const PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, _reactivity.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, _shared.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, _shared.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key) || (0, _shared.hasOwn)(ctx, key) || (0, _shared.hasOwn)(publicPropertiesMap, key) || (0, _shared.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, _shared.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var target;
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, _shared.extend)({}, PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, _shared.isGloballyAllowed)(key);
        return has;
    }
});
function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys(publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, _shared.NOOP)
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, _shared.NOOP)
        });
    });
}
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys((0, _reactivity.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, _shared.NOOP)
            });
        }
    });
}
const warnRuntimeUsage = (method)=>warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function defineProps() {
    return null;
}
function defineEmits() {
    return null;
}
function defineExpose(exposed) {}
function defineOptions(options) {}
function defineSlots() {
    return null;
}
function defineModel() {}
function withDefaults(props, defaults) {
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    const i = getCurrentInstance();
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return (0, _shared.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function mergeDefaults(raw, defaults) {
    const props = normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if ((0, _shared.isArray)(a) && (0, _shared.isArray)(b)) return a.concat(b);
    return (0, _shared.extend)({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if ((0, _shared.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>setCurrentInstance(ctx)
    ];
}
function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, // public API
    expose, inheritAttrs, // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, _shared.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, _shared.isObject)(data)) ;
        else instance.data = (0, _reactivity.reactive)(data);
    }
    shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, _shared.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, _shared.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, _shared.NOOP);
        const set = !(0, _shared.isFunction)(opt) && (0, _shared.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, _shared.NOOP);
        const c = computed({
            get,
            set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, _shared.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            provide(key, provides[key]);
        });
    }
    if (created) callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, _shared.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0, _shared.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, _shared.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, _shared.NOOP)) {
    if ((0, _shared.isArray)(injectOptions)) injectOptions = normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, _shared.isObject)(opt)) {
            if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
            else injected = inject(opt.from || key);
        } else injected = inject(opt);
        if ((0, _reactivity.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0, _shared.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, _shared.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, _shared.isFunction)(handler)) watch(getter, handler);
    } else if ((0, _shared.isFunction)(raw)) watch(getter, raw.bind(publicThis));
    else if ((0, _shared.isObject)(raw)) {
        if ((0, _shared.isArray)(raw)) raw.forEach((r)=>createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, _shared.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, _shared.isFunction)(handler)) watch(getter, handler, raw);
        }
    } else ;
}
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>mergeOptions(resolved, m, optionMergeStrategies, true));
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, _shared.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, _shared.extend)((0, _shared.isFunction)(to) ? to.call(this, this) : to, (0, _shared.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0, _shared.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, _shared.isArray)(to) && (0, _shared.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, _shared.extend)(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = mergeAsArray(to[key], from[key]);
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, _shared.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, _shared.isFunction)(rootComponent)) rootComponent = (0, _shared.extend)({}, rootComponent);
        if (rootProps != null && !(0, _shared.isObject)(rootProps)) rootProps = null;
        const context = createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        let isMounted = false;
        const app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, _shared.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, _shared.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = createVNode(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getComponentPublicInstance(vnode.component);
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                } finally{
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let currentApp = null;
function provide(key, value) {
    if (!currentInstance) ;
    else {
        let provides = currentInstance.provides;
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
        const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, _shared.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
}
const internalObjectProto = {};
const createInternalObject = ()=>Object.create(internalObjectProto);
const isInternalObject = (obj)=>Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, _reactivity.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = (0, _reactivity.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, _shared.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, _shared.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, _shared.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, _shared.hyphenate)(key)) === key || !(0, _shared.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, _shared.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, _reactivity.trigger)(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, _shared.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, _shared.hasOwn)(options, camelKey = (0, _shared.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, _reactivity.toRaw)(props);
        const castValues = rawCastValues || (0, _shared.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, _shared.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, _shared.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, _shared.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, _shared.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw2, appContext, true);
            (0, _shared.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, (0, _shared.EMPTY_ARR));
        return 0, _shared.EMPTY_ARR;
    }
    if ((0, _shared.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, _shared.camelize)(raw[i]);
        if (validatePropName(normalizedKey)) normalized[normalizedKey] = (0, _shared.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, _shared.camelize)(key);
        if (validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt) ? {
                type: opt
            } : (0, _shared.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, _shared.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, _shared.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, _shared.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, _shared.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, _shared.isObject)(comp)) cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !(0, _shared.isReservedProp)(key)) return true;
    return false;
}
function getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function validateProps(rawProps, props, instance) {
    const resolvedValues = (0, _reactivity.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        validateProp(key, resolvedValues[key], opt, resolvedValues, !(0, _shared.hasOwn)(rawProps, key) && !(0, _shared.hasOwn)(rawProps, (0, _shared.hyphenate)(key)));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    const { type, required, validator, skipCheck } = prop;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, _shared.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const isSimpleType = /* @__PURE__ */ (0, _shared.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, _shared.isObject)(value);
    else if (expectedType === "Array") valid = (0, _shared.isArray)(value);
    else if (expectedType === "null") valid = value === null;
    else valid = value instanceof type;
    return {
        valid,
        expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, _shared.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, _shared.toRawType)(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value)=>(0, _shared.isArray)(value) ? value.map(normalizeVNode) : [
        normalizeVNode(value)
    ];
const normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = withCtx((...args)=>{
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if (isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, _shared.isFunction)(value)) slots[key] = normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children)=>{
    const normalized = normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) (0, _shared.def)(slots, "_", type, true);
        } else normalizeObjectSlots(children, slots);
    } else if (children) normalizeVNodeSlots(instance, children);
};
const updateSlots = (instance, children, optimized)=>{
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, _shared.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, _shared.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>setRef(r, oldRawRef && ((0, _shared.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, _shared.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, _shared.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, _shared.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, _reactivity.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, _shared.isFunction)(ref)) callWithErrorHandling(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, _shared.isString)(ref);
        const _isRef = (0, _reactivity.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, _shared.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, _shared.isArray)(existing) && (0, _shared.remove)(existing, refValue);
                    else {
                        if (!(0, _shared.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, _shared.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if ((0, _shared.hasOwn)(setupState, ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type)=>type.__isTeleport;
const isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, _shared.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { shapeFlag, children, dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = resolveTarget(n2.props, querySelector);
            const targetAnchor = prepareAnchor(target, n2, createText, insert);
            if (target) {
                if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
                else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetStart, targetAnchor, target, props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector, insert, createText } }, hydrateChildren) {
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node && node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
let hasLoggedMismatchError = false;
const logMismatchError = ()=>{
    if (hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
};
const isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const getContainerType = (container)=>{
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
};
const isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, createText, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag, patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(node, "__vnode", vnode, true);
            (0, _shared.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case Text:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case Fragment:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if (isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = needTransition(parentSuspense, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    logMismatchError();
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                    logMismatchError();
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, _shared.isOn)(key) && !(0, _shared.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, _reactivity.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) queueEffectWithSuspense(()=>{
                vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            const isText = vnode.type === Text;
            if (node) {
                if (isText && !optimized) {
                    let next = children[i + 1];
                    if (next && (next = normalizeVNode(next)).type === Text) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                    warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                    hasWarned = true;
                }
                logMismatchError();
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 /* TEXT */  ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
        logMismatchError();
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 /* ELEMENT */  && node.tagName.toLowerCase() === "template";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, _shared.normalizeClass)(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) mismatchType = mismatchKey = `class`;
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, _shared.isString)(clientValue) ? clientValue : (0, _shared.stringifyStyle)((0, _shared.normalizeStyle)(clientValue));
        const actualMap = toStyleMap(actual);
        const expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir, value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) resolveCssVars(instance, vnode, expectedMap);
        if (!isMapEqual(actualMap, expectedMap)) mismatchType = mismatchKey = "style";
    } else if (el instanceof SVGElement && (0, _shared.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, _shared.isBooleanAttr)(key) || (0, _shared.isKnownHtmlAttr)(key))) {
        if ((0, _shared.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, _shared.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, _shared.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = `attribute`;
            mismatchKey = key;
        }
    }
    if (mismatchType) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${mismatchType} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${key}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        perf.mark(endTag);
        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
}
function isSupported() {
    if (supported !== void 0) return supported;
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    } else supported = false;
    return supported;
}
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    initFeatureFlags();
    const target = (0, _shared.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, _shared.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch(type){
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props, shapeFlag, transition, dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, _shared.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(el, "__vnode", vnode, true);
            (0, _shared.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag, dynamicChildren, dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, _shared.EMPTY_OBJ);
        const newProps = n2.props || (0, _shared.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, _shared.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, _shared.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, _shared.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                invalidateJob(instance.update);
                instance.effect.dirty = true;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) (0, _shared.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next, bu, u, parent, vnode } = instance;
                {
                    const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, _shared.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
                toggleRecurse(instance, true);
                const nextTree = renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) updateHOCHostEl(instance, nextTree.el);
                if (u) queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, _reactivity.ReactiveEffect)(componentUpdateFn, (0, _shared.NOOP), ()=>queueJob(update), instance.scope);
        const update = instance.update = ()=>{
            if (effect.dirty) effect.run();
        };
        update.i = instance;
        update.id = instance.uid;
        toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        (0, _reactivity.pauseTracking)();
        flushPreFlushCbs(instance);
        (0, _reactivity.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, _shared.EMPTY_ARR);
        c2 = c2 || (0, _shared.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : (0, _shared.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum, scope, update, subTree, um, m, a } = instance;
        invalidateMount(m);
        invalidateMount(a);
        if (bum) (0, _shared.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) queuePostRenderEffect(um, parentSuspense);
        queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs();
            flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, _shared.isArray)(ch1) && (0, _shared.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) c2.el = c1.el;
    }
}
function getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return locateNonHydratedAsyncRoot(subComponent);
    }
}
function invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].active = false;
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = ()=>{
    {
        const ctx = inject(ssrContextKey);
        ctx;
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "post"
    });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "sync"
    });
}
const INITIAL_WATCHER_VALUE = {};
function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, { immediate, deep, flush, once, onTrack, onTrigger } = (0, _shared.EMPTY_OBJ)) {
    if (cb && once) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            unwatch();
        };
    }
    const warnInvalidSource = (s)=>{
        warn$1(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = currentInstance;
    const reactiveGetter = (source2)=>deep === true ? source2 : // for deep: false, only traverse root-level properties
        traverse(source2, deep === false ? 1 : void 0);
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, _reactivity.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, _reactivity.isShallow)(source);
    } else if ((0, _reactivity.isReactive)(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, _shared.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, _reactivity.isReactive)(s) || (0, _reactivity.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, _reactivity.isRef)(s)) return s.value;
                else if ((0, _reactivity.isReactive)(s)) return reactiveGetter(s);
                else if ((0, _shared.isFunction)(s)) return callWithErrorHandling(s, instance, 2);
            });
    } else if ((0, _shared.isFunction)(source)) {
        if (cb) getter = ()=>callWithErrorHandling(source, instance, 2);
        else getter = ()=>{
            if (cleanup) cleanup();
            return callWithAsyncErrorHandling(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, _shared.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            callWithErrorHandling(fn, instance, 4);
            cleanup = effect.onStop = void 0;
        };
    };
    let ssrCleanup;
    if (isInSSRComponentSetup) {
        onCleanup = (0, _shared.NOOP);
        if (!cb) getter();
        else if (immediate) callWithAsyncErrorHandling(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, _shared.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active || !effect.dirty) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, _shared.hasChanged)(v1, oldValue[i])) : (0, _shared.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                callWithAsyncErrorHandling(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>queueJob(job);
    }
    const effect = new (0, _reactivity.ReactiveEffect)(getter, (0, _shared.NOOP), scheduler);
    const scope = (0, _reactivity.getCurrentScope)();
    const unwatch = ()=>{
        effect.stop();
        if (scope) (0, _shared.remove)(scope.effects, effect);
    };
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, _shared.isString)(source) ? source.includes(".") ? createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, _shared.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, _shared.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if ((0, _reactivity.isRef)(value)) traverse(value.value, depth, seen);
    else if ((0, _shared.isArray)(value)) for(let i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, _shared.isSet)(value) || (0, _shared.isMap)(value)) value.forEach((v1)=>{
        traverse(v1, depth, seen);
    });
    else if ((0, _shared.isPlainObject)(value)) {
        for(const key in value)traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
    }
    return value;
}
function useModel(props, name, options = (0, _shared.EMPTY_OBJ)) {
    const i = getCurrentInstance();
    const camelizedName = (0, _shared.camelize)(name);
    const hyphenatedName = (0, _shared.hyphenate)(name);
    const modifiers = getModelModifiers(props, name);
    const res = (0, _reactivity.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, _shared.EMPTY_OBJ);
        let prevEmittedValue;
        watchSyncEffect(()=>{
            const propValue = props[name];
            if ((0, _shared.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, _shared.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, _shared.hasChanged)(value, emittedValue) && (0, _shared.hasChanged)(value, prevSetValue) && !(0, _shared.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, _shared.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, _shared.camelize)(modelName)}Modifiers`] || props[`${(0, _shared.hyphenate)(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, _shared.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, _shared.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, _shared.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, _shared.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, _shared.toHandlerKey)((0, _shared.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, _shared.toHandlerKey)((0, _shared.hyphenate)(event))];
    if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, _shared.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, _shared.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, _shared.extend)(normalized, raw);
    if ((0, _shared.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !(0, _shared.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, _shared.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, _shared.hasOwn)(options, (0, _shared.hyphenate)(key)) || (0, _shared.hasOwn)(options, key);
}
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = normalizeVNode(render2.length > 1 ? render2(props, {
                attrs,
                slots,
                emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, _shared.isModelListener))) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    setCurrentRenderingInstance(prev);
    return result;
}
const getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        normalizeVNode(childRoot),
        setRoot
    ];
};
function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, _shared.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, _shared.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const isSuspense = (type)=>type.__isSuspense;
let suspenseId = 0;
const SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
};
const Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, _shared.isFunction)(eventListener)) eventListener();
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        setActiveBranch(suspense, newBranch);
    } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout, pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, _shared.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode,
        parent: parentSuspense,
        parentComponent,
        namespace,
        container,
        hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch, pendingBranch, pendingId, effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        queuePostFlushCb(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) !== suspense.hiddenContainer) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) queuePostFlushCb(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                handleError(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0, _shared.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0, _shared.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, _shared.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else queuePostFlushCb(fn);
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || (0, _shared.EMPTY_ARR) : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args)=>{
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
};
const normalizeKey = ({ key })=>key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, _shared.isString)(ref) || (0, _reactivity.isRef)(ref) || (0, _shared.isFunction)(ref) ? {
        i: currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, _shared.isString)(children) ? 8 : 16;
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) currentBlock.push(vnode);
    return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
    if (isVNode(type)) {
        const cloned = cloneVNode(type, props, true);
        if (children) normalizeChildren(cloned, children);
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
            else currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if (isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0, _shared.isString)(klass)) props.class = (0, _shared.normalizeClass)(klass);
        if ((0, _shared.isObject)(style)) {
            if ((0, _reactivity.isProxy)(style) && !(0, _shared.isArray)(style)) style = (0, _shared.extend)({}, style);
            props.style = (0, _shared.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, _shared.isString)(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : (0, _shared.isObject)(type) ? 4 : (0, _shared.isFunction)(type) ? 2 : 0;
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props) return null;
    return (0, _reactivity.isProxy)(props) || isInternalObject(props) ? (0, _shared.extend)({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, _shared.isArray)(ref) ? ref.concat(normalizeRef(extraProps)) : [
            ref,
            normalizeRef(extraProps)
        ] : normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
    return cloned;
}
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if ((0, _shared.isArray)(vnode.children)) cloned.children = vnode.children.map(deepCloneVNode);
    return cloned;
}
function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return createVNode(Comment);
    else if ((0, _shared.isArray)(child)) return createVNode(Fragment, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return cloneIfMounted(child);
    else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, _shared.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, _shared.isFunction)(children)) {
        children = {
            default: children,
            _ctx: currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                createTextVNode(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, _shared.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, _shared.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, _shared.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, _shared.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, _reactivity.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, _shared.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, _shared.EMPTY_OBJ),
        data: (0, _shared.EMPTY_OBJ),
        props: (0, _shared.EMPTY_OBJ),
        attrs: (0, _shared.EMPTY_OBJ),
        slots: (0, _shared.EMPTY_OBJ),
        refs: (0, _shared.EMPTY_OBJ),
        setupState: (0, _shared.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let currentInstance = null;
const getCurrentInstance = ()=>currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
    const g = (0, _shared.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>currentInstance = v1);
    setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>isInSSRComponentSetup = v1);
}const setCurrentInstance = (instance)=>{
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
const unsetCurrentInstance = ()=>{
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
const isBuiltInTag = /* @__PURE__ */ (0, _shared.makeMap)("slot,component");
function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        const setupResult = callWithErrorHandling(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, _reactivity.resetTracking)();
        reset();
        if ((0, _shared.isPromise)(setupResult)) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                handleError(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else handleSetupResult(instance, setupResult, isSSR);
    } else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0, _shared.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, _shared.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, _reactivity.proxyRefs)(setupResult);
    }
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const isRuntimeOnly = ()=>!compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            const template = Component.template || resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, _shared.extend)((0, _shared.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, _shared.NOOP);
        if (installWithProxy) installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        try {
            applyOptions(instance);
        } finally{
            (0, _reactivity.resetTracking)();
            reset();
        }
    }
}
const attrsProxyHandlers = {
    get (target, key) {
        (0, _reactivity.track)(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, _reactivity.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
    };
}
function getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, _reactivity.proxyRefs)((0, _reactivity.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
    return (0, _shared.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0, _shared.isFunction)(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions)=>{
    const c = (0, _reactivity.computed)(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
};
function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, _shared.isObject)(propsOrChildren) && !(0, _shared.isArray)(propsOrChildren)) {
            if (isVNode(propsOrChildren)) return createVNode(type, null, [
                propsOrChildren
            ]);
            return createVNode(type, propsOrChildren);
        } else return createVNode(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && isVNode(children)) children = [
            children
        ];
        return createVNode(type, propsOrChildren, children);
    }
}
function initCustomFormatter() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, _reactivity.toRaw)(instance.props)));
        if (instance.setupState !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, _reactivity.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, _shared.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, _shared.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, _reactivity.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, _shared.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, _shared.isArray)(opts) && opts.includes(key) || (0, _shared.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, _reactivity.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, _shared.hasChanged)(prev[i], memo[i])) return false;
    }
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(cached);
    return true;
}
const version = "3.4.38";
const warn = (0, _shared.NOOP);
const ErrorTypeStrings = ErrorTypeStrings$1;
const devtools = devtools$1;
const setDevtoolsHook = setDevtoolsHook$1;
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode
};
const ssrUtils = _ssrUtils;
const resolveFilter = null;
const compatUtils = null;
const DeprecationTypes = null;

},{"@vue/reactivity":"7Rc3Y","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Rc3Y":[function(require,module,exports) {
/**
* @vue/reactivity v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>EffectScope);
parcelHelpers.export(exports, "ITERATE_KEY", ()=>ITERATE_KEY);
parcelHelpers.export(exports, "ReactiveEffect", ()=>ReactiveEffect);
parcelHelpers.export(exports, "ReactiveFlags", ()=>ReactiveFlags);
parcelHelpers.export(exports, "TrackOpTypes", ()=>TrackOpTypes);
parcelHelpers.export(exports, "TriggerOpTypes", ()=>TriggerOpTypes);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "customRef", ()=>customRef);
parcelHelpers.export(exports, "deferredComputed", ()=>deferredComputed);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "effectScope", ()=>effectScope);
parcelHelpers.export(exports, "enableTracking", ()=>enableTracking);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "isProxy", ()=>isProxy);
parcelHelpers.export(exports, "isReactive", ()=>isReactive);
parcelHelpers.export(exports, "isReadonly", ()=>isReadonly);
parcelHelpers.export(exports, "isRef", ()=>isRef);
parcelHelpers.export(exports, "isShallow", ()=>isShallow);
parcelHelpers.export(exports, "markRaw", ()=>markRaw);
parcelHelpers.export(exports, "onScopeDispose", ()=>onScopeDispose);
parcelHelpers.export(exports, "pauseScheduling", ()=>pauseScheduling);
parcelHelpers.export(exports, "pauseTracking", ()=>pauseTracking);
parcelHelpers.export(exports, "proxyRefs", ()=>proxyRefs);
parcelHelpers.export(exports, "reactive", ()=>reactive);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "resetScheduling", ()=>resetScheduling);
parcelHelpers.export(exports, "resetTracking", ()=>resetTracking);
parcelHelpers.export(exports, "shallowReactive", ()=>shallowReactive);
parcelHelpers.export(exports, "shallowReadonly", ()=>shallowReadonly);
parcelHelpers.export(exports, "shallowRef", ()=>shallowRef);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toRaw", ()=>toRaw);
parcelHelpers.export(exports, "toRef", ()=>toRef);
parcelHelpers.export(exports, "toRefs", ()=>toRefs);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "triggerRef", ()=>triggerRef);
parcelHelpers.export(exports, "unref", ()=>unref);
var _shared = require("@vue/shared");
function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally{
                activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function recordEffectScope(effect, scope = activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
let activeEffect;
class ReactiveEffect {
    constructor(fn, trigger, scheduler, scope){
        this.fn = fn;
        this.trigger = trigger;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        /**
     * @internal
     */ this._dirtyLevel = 4;
        /**
     * @internal
     */ this._trackId = 0;
        /**
     * @internal
     */ this._runnings = 0;
        /**
     * @internal
     */ this._shouldSchedule = false;
        /**
     * @internal
     */ this._depsLength = 0;
        recordEffectScope(this, scope);
    }
    get dirty() {
        if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
            this._dirtyLevel = 1;
            pauseTracking();
            for(let i = 0; i < this._depsLength; i++){
                const dep = this.deps[i];
                if (dep.computed) {
                    triggerComputed(dep.computed);
                    if (this._dirtyLevel >= 4) break;
                }
            }
            if (this._dirtyLevel === 1) this._dirtyLevel = 0;
            resetTracking();
        }
        return this._dirtyLevel >= 4;
    }
    set dirty(v) {
        this._dirtyLevel = v ? 4 : 0;
    }
    run() {
        this._dirtyLevel = 0;
        if (!this.active) return this.fn();
        let lastShouldTrack = shouldTrack;
        let lastEffect = activeEffect;
        try {
            shouldTrack = true;
            activeEffect = this;
            this._runnings++;
            preCleanupEffect(this);
            return this.fn();
        } finally{
            postCleanupEffect(this);
            this._runnings--;
            activeEffect = lastEffect;
            shouldTrack = lastShouldTrack;
        }
    }
    stop() {
        if (this.active) {
            preCleanupEffect(this);
            postCleanupEffect(this);
            this.onStop && this.onStop();
            this.active = false;
        }
    }
}
function triggerComputed(computed) {
    return computed.value;
}
function preCleanupEffect(effect2) {
    effect2._trackId++;
    effect2._depsLength = 0;
}
function postCleanupEffect(effect2) {
    if (effect2.deps.length > effect2._depsLength) {
        for(let i = effect2._depsLength; i < effect2.deps.length; i++)cleanupDepEffect(effect2.deps[i], effect2);
        effect2.deps.length = effect2._depsLength;
    }
}
function cleanupDepEffect(dep, effect2) {
    const trackId = dep.get(effect2);
    if (trackId !== void 0 && effect2._trackId !== trackId) {
        dep.delete(effect2);
        if (dep.size === 0) dep.cleanup();
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    const _effect = new ReactiveEffect(fn, (0, _shared.NOOP), ()=>{
        if (_effect.dirty) _effect.run();
    });
    if (options) {
        (0, _shared.extend)(_effect, options);
        if (options.scope) recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
let pauseScheduleStack = 0;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function pauseScheduling() {
    pauseScheduleStack++;
}
function resetScheduling() {
    pauseScheduleStack--;
    while(!pauseScheduleStack && queueEffectSchedulers.length)queueEffectSchedulers.shift()();
}
function trackEffect(effect2, dep, debuggerEventExtraInfo) {
    var _a;
    if (dep.get(effect2) !== effect2._trackId) {
        dep.set(effect2, effect2._trackId);
        const oldDep = effect2.deps[effect2._depsLength];
        if (oldDep !== dep) {
            if (oldDep) cleanupDepEffect(oldDep, effect2);
            effect2.deps[effect2._depsLength++] = dep;
        } else effect2._depsLength++;
    }
}
const queueEffectSchedulers = [];
function triggerEffects(dep, dirtyLevel, debuggerEventExtraInfo) {
    var _a;
    pauseScheduling();
    for (const effect2 of dep.keys()){
        let tracking;
        if (effect2._dirtyLevel < dirtyLevel && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2._shouldSchedule || (effect2._shouldSchedule = effect2._dirtyLevel === 0);
            effect2._dirtyLevel = dirtyLevel;
        }
        if (effect2._shouldSchedule && (tracking != null ? tracking : tracking = dep.get(effect2) === effect2._trackId)) {
            effect2.trigger();
            if ((!effect2._runnings || effect2.allowRecurse) && effect2._dirtyLevel !== 2) {
                effect2._shouldSchedule = false;
                if (effect2.scheduler) queueEffectSchedulers.push(effect2.scheduler);
            }
        }
    }
    resetScheduling();
}
const createDep = (cleanup, computed)=>{
    const dep = /* @__PURE__ */ new Map();
    dep.cleanup = cleanup;
    dep.computed = computed;
    return dep;
};
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeEffect) {
        let depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = createDep(()=>depsMap.delete(key)));
        trackEffect(activeEffect, dep, void 0);
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, _shared.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || !(0, _shared.isSymbol)(key2) && key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, _shared.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, _shared.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                } else if ((0, _shared.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, _shared.isArray)(target)) {
                    deps.push(depsMap.get(ITERATE_KEY));
                    if ((0, _shared.isMap)(target)) deps.push(depsMap.get(MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, _shared.isMap)(target)) deps.push(depsMap.get(ITERATE_KEY));
                break;
        }
    }
    pauseScheduling();
    for (const dep of deps)if (dep) triggerEffects(dep, 4, void 0);
    resetScheduling();
}
function getDepFromReactive(object, key) {
    const depsMap = targetMap.get(object);
    return depsMap && depsMap.get(key);
}
const isNonTrackableKeys = /* @__PURE__ */ (0, _shared.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, _shared.isSymbol)));
const arrayInstrumentations = /* @__PURE__ */ createArrayInstrumentations();
function createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map(toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            pauseTracking();
            pauseScheduling();
            const res = toRaw(this)[key].apply(this, args);
            resetScheduling();
            resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function hasOwnProperty(key) {
    if (!(0, _shared.isSymbol)(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, _shared.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, _shared.hasOwn)(arrayInstrumentations, key)) return Reflect.get(arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, _shared.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly2) track(target, "get", key);
        if (isShallow2) return res;
        if (isRef(res)) return targetIsArray && (0, _shared.isIntegerKey)(key) ? res : res.value;
        if ((0, _shared.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
        return res;
    }
}
class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = isReadonly(oldValue);
            if (!isShallow(value) && !isReadonly(value)) {
                oldValue = toRaw(oldValue);
                value = toRaw(value);
            }
            if (!(0, _shared.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, _shared.isArray)(target) && (0, _shared.isIntegerKey)(key) ? Number(key) < target.length : (0, _shared.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, _shared.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, _shared.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        track(target, "iterate", (0, _shared.isArray)(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value)=>value;
const getProto = (v)=>Reflect.getPrototypeOf(v);
function get(target, key, isReadonly2 = false, isShallow2 = false) {
    target = target["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (!isReadonly2) {
        if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
        track(rawTarget, "get", rawKey);
    }
    const { has: has2 } = getProto(rawTarget);
    const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function has(key, isReadonly2 = false) {
    const target = this["__v_raw"];
    const rawTarget = toRaw(target);
    const rawKey = toRaw(key);
    if (!isReadonly2) {
        if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
        track(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function size(target, isReadonly2 = false) {
    target = target["__v_raw"];
    !isReadonly2 && track(toRaw(target), "iterate", ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function add(value, _isShallow = false) {
    if (!_isShallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
    const target = toRaw(this);
    const proto = getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        trigger(target, "add", value, value);
    }
    return this;
}
function set(key, value, _isShallow = false) {
    if (!_isShallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
    const target = toRaw(this);
    const { has: has2, get: get2 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) trigger(target, "add", key, value);
    else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
    return this;
}
function deleteEntry(key) {
    const target = toRaw(this);
    const { has: has2, get: get2 } = getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = toRaw(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function clear() {
    const target = toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function createForEach(isReadonly2, isShallow2) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = toRaw(target);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = toRaw(target);
        const targetIsMap = (0, _shared.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value, done } = innerIterator.next();
                return done ? {
                    value,
                    done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return get(this, key);
        },
        get size () {
            return size(this);
        },
        has,
        add,
        set,
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return get(this, key, false, true);
        },
        get size () {
            return size(this);
        },
        has,
        add (value) {
            return add.call(this, value, true);
        },
        set (key, value) {
            return set.call(this, key, value, true);
        },
        delete: deleteEntry,
        clear,
        forEach: createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return get(this, key, true);
        },
        get size () {
            return size(this, true);
        },
        has (key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return get(this, key, true, true);
        },
        get size () {
            return size(this, true);
        },
        has (key) {
            return has.call(this, key, true);
        },
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear"),
        forEach: createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [mutableInstrumentations, readonlyInstrumentations, shallowInstrumentations, shallowReadonlyInstrumentations] = /* @__PURE__ */ createInstrumentations();
function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = shallow ? isReadonly2 ? shallowReadonlyInstrumentations : shallowInstrumentations : isReadonly2 ? readonlyInstrumentations : mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, _shared.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has2, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, _shared.toRawType)(target);
        warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, _shared.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, _shared.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (Object.isExtensible(value)) (0, _shared.def)(value, "__v_skip", true);
    return value;
}
const toReactive = (value)=>(0, _shared.isObject)(value) ? reactive(value) : value;
const toReadonly = (value)=>(0, _shared.isObject)(value) ? readonly(value) : value;
const COMPUTED_SIDE_EFFECT_WARN = `Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free`;
class ComputedRefImpl {
    constructor(getter, _setter, isReadonly, isSSR){
        this.getter = getter;
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this.effect = new ReactiveEffect(()=>getter(this._value), ()=>triggerRefValue(this, this.effect._dirtyLevel === 2 ? 2 : 3));
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    get value() {
        const self = toRaw(this);
        if ((!self._cacheable || self.effect.dirty) && (0, _shared.hasChanged)(self._value, self._value = self.effect.run())) triggerRefValue(self, 4);
        trackRefValue(self);
        if (self.effect._dirtyLevel >= 2) triggerRefValue(self, 2);
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
    get _dirty() {
        return this.effect.dirty;
    }
    set _dirty(v) {
        this.effect.dirty = v;
    }
}
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, _shared.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, _shared.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
function trackRefValue(ref2) {
    var _a;
    if (shouldTrack && activeEffect) {
        ref2 = toRaw(ref2);
        trackEffect(activeEffect, (_a = ref2.dep) != null ? _a : ref2.dep = createDep(()=>ref2.dep = void 0, ref2 instanceof ComputedRefImpl ? ref2 : void 0), void 0);
    }
}
function triggerRefValue(ref2, dirtyLevel = 4, newVal, oldVal) {
    ref2 = toRaw(ref2);
    const dep = ref2.dep;
    if (dep) triggerEffects(dep, dirtyLevel, void 0);
}
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : toRaw(value);
        this._value = __v_isShallow ? value : toReactive(value);
    }
    get value() {
        trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || isShallow(newVal) || isReadonly(newVal);
        newVal = useDirectValue ? newVal : toRaw(newVal);
        if ((0, _shared.hasChanged)(newVal, this._rawValue)) {
            const oldVal = this._rawValue;
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : toReactive(newVal);
            triggerRefValue(this, 4, newVal, oldVal);
        }
    }
}
function triggerRef(ref2) {
    triggerRefValue(ref2, 4, void 0);
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, _shared.isFunction)(source) ? source() : unref(source);
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver)=>unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get, set } = factory(()=>trackRefValue(this), ()=>triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    const ret = (0, _shared.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
class ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return getDepFromReactive(toRaw(this._object), this._key);
    }
}
class GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    get value() {
        return this._getter();
    }
}
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, _shared.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, _shared.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
const deferredComputed = computed;
const TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw"
};

},{"@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqBjR":[function(require,module,exports) {
/**
* @vue/shared v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_ARR", ()=>EMPTY_ARR);
parcelHelpers.export(exports, "EMPTY_OBJ", ()=>EMPTY_OBJ);
parcelHelpers.export(exports, "NO", ()=>NO);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
parcelHelpers.export(exports, "PatchFlagNames", ()=>PatchFlagNames);
parcelHelpers.export(exports, "PatchFlags", ()=>PatchFlags);
parcelHelpers.export(exports, "ShapeFlags", ()=>ShapeFlags);
parcelHelpers.export(exports, "SlotFlags", ()=>SlotFlags);
parcelHelpers.export(exports, "camelize", ()=>camelize);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "def", ()=>def);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "escapeHtmlComment", ()=>escapeHtmlComment);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "genPropsAccessExp", ()=>genPropsAccessExp);
parcelHelpers.export(exports, "generateCodeFrame", ()=>generateCodeFrame);
parcelHelpers.export(exports, "getGlobalThis", ()=>getGlobalThis);
parcelHelpers.export(exports, "hasChanged", ()=>hasChanged);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "hyphenate", ()=>hyphenate);
parcelHelpers.export(exports, "includeBooleanAttr", ()=>includeBooleanAttr);
parcelHelpers.export(exports, "invokeArrayFns", ()=>invokeArrayFns);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBooleanAttr", ()=>isBooleanAttr);
parcelHelpers.export(exports, "isBuiltInDirective", ()=>isBuiltInDirective);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isGloballyAllowed", ()=>isGloballyAllowed);
parcelHelpers.export(exports, "isGloballyWhitelisted", ()=>isGloballyWhitelisted);
parcelHelpers.export(exports, "isHTMLTag", ()=>isHTMLTag);
parcelHelpers.export(exports, "isIntegerKey", ()=>isIntegerKey);
parcelHelpers.export(exports, "isKnownHtmlAttr", ()=>isKnownHtmlAttr);
parcelHelpers.export(exports, "isKnownSvgAttr", ()=>isKnownSvgAttr);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isMathMLTag", ()=>isMathMLTag);
parcelHelpers.export(exports, "isModelListener", ()=>isModelListener);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isOn", ()=>isOn);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRenderableAttrValue", ()=>isRenderableAttrValue);
parcelHelpers.export(exports, "isReservedProp", ()=>isReservedProp);
parcelHelpers.export(exports, "isSSRSafeAttrName", ()=>isSSRSafeAttrName);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSpecialBooleanAttr", ()=>isSpecialBooleanAttr);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isVoidTag", ()=>isVoidTag);
parcelHelpers.export(exports, "looseEqual", ()=>looseEqual);
parcelHelpers.export(exports, "looseIndexOf", ()=>looseIndexOf);
parcelHelpers.export(exports, "looseToNumber", ()=>looseToNumber);
parcelHelpers.export(exports, "makeMap", ()=>makeMap);
parcelHelpers.export(exports, "normalizeClass", ()=>normalizeClass);
parcelHelpers.export(exports, "normalizeProps", ()=>normalizeProps);
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "objectToString", ()=>objectToString);
parcelHelpers.export(exports, "parseStringStyle", ()=>parseStringStyle);
parcelHelpers.export(exports, "propsToAttrMap", ()=>propsToAttrMap);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "slotFlagsText", ()=>slotFlagsText);
parcelHelpers.export(exports, "stringifyStyle", ()=>stringifyStyle);
parcelHelpers.export(exports, "toDisplayString", ()=>toDisplayString);
parcelHelpers.export(exports, "toHandlerKey", ()=>toHandlerKey);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toRawType", ()=>toRawType);
parcelHelpers.export(exports, "toTypeString", ()=>toTypeString);
var global = arguments[3];
function makeMap(str, expectsLowerCase) {
    const set = new Set(str.split(","));
    return expectsLowerCase ? (val)=>set.has(val.toLowerCase()) : (val)=>set.has(val);
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = ()=>{};
const NO = ()=>false;
const isOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key)=>key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key)=>hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val)=>toTypeString(val) === "[object Map]";
const isSet = (val)=>toTypeString(val) === "[object Set]";
const isDate = (val)=>toTypeString(val) === "[object Date]";
const isRegExp = (val)=>toTypeString(val) === "[object RegExp]";
const isFunction = (val)=>typeof val === "function";
const isString = (val)=>typeof val === "string";
const isSymbol = (val)=>typeof val === "symbol";
const isObject = (val)=>val !== null && typeof val === "object";
const isPromise = (val)=>{
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value)=>objectToString.call(value);
const toRawType = (value)=>{
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val)=>toTypeString(val) === "[object Object]";
const isIntegerKey = (key)=>isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str)=>{
    return str.replace(camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str)=>str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction((str)=>{
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
});
const hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const def = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
};
const looseToNumber = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const toNumber = (val)=>{
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = ()=>{
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
const identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function genPropsAccessExp(name) {
    return identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const PatchFlags = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "HOISTED": -1,
    "-1": "HOISTED",
    "BAIL": -2,
    "-2": "BAIL"
};
const PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const ShapeFlags = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const SlotFlags = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error";
const isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
const isGloballyWhitelisted = isGloballyAllowed;
const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - range; j <= i + range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if (isString(value) || isObject(value)) return value;
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    let ret = "";
    if (!styles || isString(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if (isString(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = "";
    if (isString(value)) res = value;
    else if (isArray(value)) for(let i = 0; i < value.length; i++){
        const normalized = normalizeClass(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if (isObject(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) props.class = normalizeClass(klass);
    if (style) props.style = normalizeStyle(style);
    return props;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
const isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
const isBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function includeBooleanAttr(value) {
    return !!value || value === "";
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) return attrValidationCache[name];
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return attrValidationCache[name] = !isUnsafe;
}
const propsToAttrMap = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const isKnownHtmlAttr = /* @__PURE__ */ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const isKnownSvgAttr = /* @__PURE__ */ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
function isRenderableAttrValue(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = "" + string;
    const match = escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, "");
}
function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = looseEqual(a[i], b[i]);
    return equal;
}
function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) return a === b;
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex((item)=>looseEqual(item, val));
}
const isRef = (val)=>{
    return !!(val && val.__v_isRef === true);
};
const toDisplayString = (val)=>{
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val)=>{
    if (isRef(val)) return replacer(_key, val.value);
    else if (isMap(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if (isSet(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>stringifySymbol(v))
    };
    else if (isSymbol(val)) return stringifySymbol(val);
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
    return val;
};
const stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"OsNOm":[function(require,module,exports) {
/**
* @vue/compiler-dom v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMDirectiveTransforms", ()=>DOMDirectiveTransforms);
parcelHelpers.export(exports, "DOMErrorCodes", ()=>DOMErrorCodes);
parcelHelpers.export(exports, "DOMErrorMessages", ()=>DOMErrorMessages);
parcelHelpers.export(exports, "DOMNodeTransforms", ()=>DOMNodeTransforms);
parcelHelpers.export(exports, "TRANSITION", ()=>TRANSITION);
parcelHelpers.export(exports, "TRANSITION_GROUP", ()=>TRANSITION_GROUP);
parcelHelpers.export(exports, "V_MODEL_CHECKBOX", ()=>V_MODEL_CHECKBOX);
parcelHelpers.export(exports, "V_MODEL_DYNAMIC", ()=>V_MODEL_DYNAMIC);
parcelHelpers.export(exports, "V_MODEL_RADIO", ()=>V_MODEL_RADIO);
parcelHelpers.export(exports, "V_MODEL_SELECT", ()=>V_MODEL_SELECT);
parcelHelpers.export(exports, "V_MODEL_TEXT", ()=>V_MODEL_TEXT);
parcelHelpers.export(exports, "V_ON_WITH_KEYS", ()=>V_ON_WITH_KEYS);
parcelHelpers.export(exports, "V_ON_WITH_MODIFIERS", ()=>V_ON_WITH_MODIFIERS);
parcelHelpers.export(exports, "V_SHOW", ()=>V_SHOW);
parcelHelpers.export(exports, "compile", ()=>compile);
parcelHelpers.export(exports, "createDOMCompilerError", ()=>createDOMCompilerError);
parcelHelpers.export(exports, "parse", ()=>parse);
parcelHelpers.export(exports, "parserOptions", ()=>parserOptions);
parcelHelpers.export(exports, "transformStyle", ()=>transformStyle);
var _compilerCore = require("@vue/compiler-core");
parcelHelpers.exportAll(_compilerCore, exports);
var _shared = require("@vue/shared");
const V_MODEL_RADIO = Symbol(``);
const V_MODEL_CHECKBOX = Symbol(``);
const V_MODEL_TEXT = Symbol(``);
const V_MODEL_SELECT = Symbol(``);
const V_MODEL_DYNAMIC = Symbol(``);
const V_ON_WITH_MODIFIERS = Symbol(``);
const V_ON_WITH_KEYS = Symbol(``);
const V_SHOW = Symbol(``);
const TRANSITION = Symbol(``);
const TRANSITION_GROUP = Symbol(``);
(0, _compilerCore.registerRuntimeHelpers)({
    [V_MODEL_RADIO]: `vModelRadio`,
    [V_MODEL_CHECKBOX]: `vModelCheckbox`,
    [V_MODEL_TEXT]: `vModelText`,
    [V_MODEL_SELECT]: `vModelSelect`,
    [V_MODEL_DYNAMIC]: `vModelDynamic`,
    [V_ON_WITH_MODIFIERS]: `withModifiers`,
    [V_ON_WITH_KEYS]: `withKeys`,
    [V_SHOW]: `vShow`,
    [TRANSITION]: `Transition`,
    [TRANSITION_GROUP]: `TransitionGroup`
});
let decoder;
function decodeHtmlBrowser(raw, asAttr = false) {
    if (!decoder) decoder = document.createElement("div");
    if (asAttr) {
        decoder.innerHTML = `<div foo="${raw.replace(/"/g, "&quot;")}">`;
        return decoder.children[0].getAttribute("foo");
    } else {
        decoder.innerHTML = raw;
        return decoder.textContent;
    }
}
const parserOptions = {
    parseMode: "html",
    isVoidTag: (0, _shared.isVoidTag),
    isNativeTag: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
    isPreTag: (tag)=>tag === "pre",
    decodeEntities: decodeHtmlBrowser,
    isBuiltInComponent: (tag)=>{
        if (tag === "Transition" || tag === "transition") return TRANSITION;
        else if (tag === "TransitionGroup" || tag === "transition-group") return TRANSITION_GROUP;
    },
    // https://html.spec.whatwg.org/multipage/parsing.html#tree-construction-dispatcher
    getNamespace (tag, parent, rootNamespace) {
        let ns = parent ? parent.ns : rootNamespace;
        if (parent && ns === 2) {
            if (parent.tag === "annotation-xml") {
                if (tag === "svg") return 1;
                if (parent.props.some((a)=>a.type === 6 && a.name === "encoding" && a.value != null && (a.value.content === "text/html" || a.value.content === "application/xhtml+xml"))) ns = 0;
            } else if (/^m(?:[ions]|text)$/.test(parent.tag) && tag !== "mglyph" && tag !== "malignmark") ns = 0;
        } else if (parent && ns === 1) {
            if (parent.tag === "foreignObject" || parent.tag === "desc" || parent.tag === "title") ns = 0;
        }
        if (ns === 0) {
            if (tag === "svg") return 1;
            if (tag === "math") return 2;
        }
        return ns;
    }
};
const transformStyle = (node)=>{
    if (node.type === 1) node.props.forEach((p, i)=>{
        if (p.type === 6 && p.name === "style" && p.value) node.props[i] = {
            type: 7,
            name: `bind`,
            arg: (0, _compilerCore.createSimpleExpression)(`style`, true, p.loc),
            exp: parseInlineCSS(p.value.content, p.loc),
            modifiers: [],
            loc: p.loc
        };
    });
};
const parseInlineCSS = (cssText, loc)=>{
    const normalized = (0, _shared.parseStringStyle)(cssText);
    return (0, _compilerCore.createSimpleExpression)(JSON.stringify(normalized), false, loc, 3);
};
function createDOMCompilerError(code, loc) {
    return (0, _compilerCore.createCompilerError)(code, loc, void 0);
}
const DOMErrorCodes = {
    "X_V_HTML_NO_EXPRESSION": 53,
    "53": "X_V_HTML_NO_EXPRESSION",
    "X_V_HTML_WITH_CHILDREN": 54,
    "54": "X_V_HTML_WITH_CHILDREN",
    "X_V_TEXT_NO_EXPRESSION": 55,
    "55": "X_V_TEXT_NO_EXPRESSION",
    "X_V_TEXT_WITH_CHILDREN": 56,
    "56": "X_V_TEXT_WITH_CHILDREN",
    "X_V_MODEL_ON_INVALID_ELEMENT": 57,
    "57": "X_V_MODEL_ON_INVALID_ELEMENT",
    "X_V_MODEL_ARG_ON_ELEMENT": 58,
    "58": "X_V_MODEL_ARG_ON_ELEMENT",
    "X_V_MODEL_ON_FILE_INPUT_ELEMENT": 59,
    "59": "X_V_MODEL_ON_FILE_INPUT_ELEMENT",
    "X_V_MODEL_UNNECESSARY_VALUE": 60,
    "60": "X_V_MODEL_UNNECESSARY_VALUE",
    "X_V_SHOW_NO_EXPRESSION": 61,
    "61": "X_V_SHOW_NO_EXPRESSION",
    "X_TRANSITION_INVALID_CHILDREN": 62,
    "62": "X_TRANSITION_INVALID_CHILDREN",
    "X_IGNORED_SIDE_EFFECT_TAG": 63,
    "63": "X_IGNORED_SIDE_EFFECT_TAG",
    "__EXTEND_POINT__": 64,
    "64": "__EXTEND_POINT__"
};
const DOMErrorMessages = {
    [53]: `v-html is missing expression.`,
    [54]: `v-html will override element children.`,
    [55]: `v-text is missing expression.`,
    [56]: `v-text will override element children.`,
    [57]: `v-model can only be used on <input>, <textarea> and <select> elements.`,
    [58]: `v-model argument is not supported on plain elements.`,
    [59]: `v-model cannot be used on file inputs since they are read-only. Use a v-on:change listener instead.`,
    [60]: `Unnecessary value binding used alongside v-model. It will interfere with v-model's behavior.`,
    [61]: `v-show is missing expression.`,
    [62]: `<Transition> expects exactly one child element or component.`,
    [63]: `Tags with side effect (<script> and <style>) are ignored in client component templates.`
};
const transformVHtml = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(53, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(54, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`innerHTML`, true, loc), exp || (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformVText = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(55, loc));
    if (node.children.length) {
        context.onError(createDOMCompilerError(56, loc));
        node.children.length = 0;
    }
    return {
        props: [
            (0, _compilerCore.createObjectProperty)((0, _compilerCore.createSimpleExpression)(`textContent`, true), exp ? (0, _compilerCore.getConstantType)(exp, context) > 0 ? exp : (0, _compilerCore.createCallExpression)(context.helperString((0, _compilerCore.TO_DISPLAY_STRING)), [
                exp
            ], loc) : (0, _compilerCore.createSimpleExpression)("", true))
        ]
    };
};
const transformModel = (dir, node, context)=>{
    const baseResult = (0, _compilerCore.transformModel)(dir, node, context);
    if (!baseResult.props.length || node.tagType === 1) return baseResult;
    if (dir.arg) context.onError(createDOMCompilerError(58, dir.arg.loc));
    function checkDuplicatedValue() {
        const value = (0, _compilerCore.findDir)(node, "bind");
        if (value && (0, _compilerCore.isStaticArgOf)(value.arg, "value")) context.onError(createDOMCompilerError(60, value.loc));
    }
    const { tag } = node;
    const isCustomElement = context.isCustomElement(tag);
    if (tag === "input" || tag === "textarea" || tag === "select" || isCustomElement) {
        let directiveToUse = V_MODEL_TEXT;
        let isInvalidType = false;
        if (tag === "input" || isCustomElement) {
            const type = (0, _compilerCore.findProp)(node, `type`);
            if (type) {
                if (type.type === 7) directiveToUse = V_MODEL_DYNAMIC;
                else if (type.value) switch(type.value.content){
                    case "radio":
                        directiveToUse = V_MODEL_RADIO;
                        break;
                    case "checkbox":
                        directiveToUse = V_MODEL_CHECKBOX;
                        break;
                    case "file":
                        isInvalidType = true;
                        context.onError(createDOMCompilerError(59, dir.loc));
                        break;
                    default:
                        break;
                }
            } else if ((0, _compilerCore.hasDynamicKeyVBind)(node)) directiveToUse = V_MODEL_DYNAMIC;
        } else if (tag === "select") directiveToUse = V_MODEL_SELECT;
        if (!isInvalidType) baseResult.needRuntime = context.helper(directiveToUse);
    } else context.onError(createDOMCompilerError(57, dir.loc));
    baseResult.props = baseResult.props.filter((p)=>!(p.key.type === 4 && p.key.content === "modelValue"));
    return baseResult;
};
const isEventOptionModifier = /* @__PURE__ */ (0, _shared.makeMap)(`passive,once,capture`);
const isNonKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)(// event propagation management
`stop,prevent,self,ctrl,shift,alt,meta,exact,middle`);
const maybeKeyModifier = /* @__PURE__ */ (0, _shared.makeMap)("left,right");
const isKeyboardEvent = /* @__PURE__ */ (0, _shared.makeMap)(`onkeyup,onkeydown,onkeypress`, true);
const resolveModifiers = (key, modifiers, context, loc)=>{
    const keyModifiers = [];
    const nonKeyModifiers = [];
    const eventOptionModifiers = [];
    for(let i = 0; i < modifiers.length; i++){
        const modifier = modifiers[i];
        if (modifier === "native" && (0, _compilerCore.checkCompatEnabled)("COMPILER_V_ON_NATIVE", context, loc)) eventOptionModifiers.push(modifier);
        else if (isEventOptionModifier(modifier)) eventOptionModifiers.push(modifier);
        else {
            if (maybeKeyModifier(modifier)) {
                if ((0, _compilerCore.isStaticExp)(key)) {
                    if (isKeyboardEvent(key.content)) keyModifiers.push(modifier);
                    else nonKeyModifiers.push(modifier);
                } else {
                    keyModifiers.push(modifier);
                    nonKeyModifiers.push(modifier);
                }
            } else if (isNonKeyModifier(modifier)) nonKeyModifiers.push(modifier);
            else keyModifiers.push(modifier);
        }
    }
    return {
        keyModifiers,
        nonKeyModifiers,
        eventOptionModifiers
    };
};
const transformClick = (key, event)=>{
    const isStaticClick = (0, _compilerCore.isStaticExp)(key) && key.content.toLowerCase() === "onclick";
    return isStaticClick ? (0, _compilerCore.createSimpleExpression)(event, true) : key.type !== 4 ? (0, _compilerCore.createCompoundExpression)([
        `(`,
        key,
        `) === "onClick" ? "${event}" : (`,
        key,
        `)`
    ]) : key;
};
const transformOn = (dir, node, context)=>{
    return (0, _compilerCore.transformOn)(dir, node, context, (baseResult)=>{
        const { modifiers } = dir;
        if (!modifiers.length) return baseResult;
        let { key, value: handlerExp } = baseResult.props[0];
        const { keyModifiers, nonKeyModifiers, eventOptionModifiers } = resolveModifiers(key, modifiers, context, dir.loc);
        if (nonKeyModifiers.includes("right")) key = transformClick(key, `onContextmenu`);
        if (nonKeyModifiers.includes("middle")) key = transformClick(key, `onMouseup`);
        if (nonKeyModifiers.length) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_MODIFIERS), [
            handlerExp,
            JSON.stringify(nonKeyModifiers)
        ]);
        if (keyModifiers.length && // if event name is dynamic, always wrap with keys guard
        (!(0, _compilerCore.isStaticExp)(key) || isKeyboardEvent(key.content))) handlerExp = (0, _compilerCore.createCallExpression)(context.helper(V_ON_WITH_KEYS), [
            handlerExp,
            JSON.stringify(keyModifiers)
        ]);
        if (eventOptionModifiers.length) {
            const modifierPostfix = eventOptionModifiers.map((0, _shared.capitalize)).join("");
            key = (0, _compilerCore.isStaticExp)(key) ? (0, _compilerCore.createSimpleExpression)(`${key.content}${modifierPostfix}`, true) : (0, _compilerCore.createCompoundExpression)([
                `(`,
                key,
                `) + "${modifierPostfix}"`
            ]);
        }
        return {
            props: [
                (0, _compilerCore.createObjectProperty)(key, handlerExp)
            ]
        };
    });
};
const transformShow = (dir, node, context)=>{
    const { exp, loc } = dir;
    if (!exp) context.onError(createDOMCompilerError(61, loc));
    return {
        props: [],
        needRuntime: context.helper(V_SHOW)
    };
};
const transformTransition = (node, context)=>{
    if (node.type === 1 && node.tagType === 1) {
        const component = context.isBuiltInComponent(node.tag);
        if (component === TRANSITION) return ()=>{
            if (!node.children.length) return;
            if (hasMultipleChildren(node)) context.onError(createDOMCompilerError(62, {
                start: node.children[0].loc.start,
                end: node.children[node.children.length - 1].loc.end,
                source: ""
            }));
            const child = node.children[0];
            if (child.type === 1) {
                for (const p of child.props)if (p.type === 7 && p.name === "show") node.props.push({
                    type: 6,
                    name: "persisted",
                    nameLoc: node.loc,
                    value: void 0,
                    loc: node.loc
                });
            }
        };
    }
};
function hasMultipleChildren(node) {
    const children = node.children = node.children.filter((c)=>c.type !== 3 && !(c.type === 2 && !c.content.trim()));
    const child = children[0];
    return children.length !== 1 || child.type === 11 || child.type === 9 && child.branches.some(hasMultipleChildren);
}
const ignoreSideEffectTags = (node, context)=>{
    if (node.type === 1 && node.tagType === 0 && (node.tag === "script" || node.tag === "style")) context.removeNode();
};
const DOMNodeTransforms = [
    transformStyle
];
const DOMDirectiveTransforms = {
    cloak: (0, _compilerCore.noopDirectiveTransform),
    html: transformVHtml,
    text: transformVText,
    model: transformModel,
    // override compiler-core
    on: transformOn,
    // override compiler-core
    show: transformShow
};
function compile(src, options = {}) {
    return (0, _compilerCore.baseCompile)(src, (0, _shared.extend)({}, parserOptions, options, {
        nodeTransforms: [
            // ignore <script> and <tag>
            // this is not put inside DOMNodeTransforms because that list is used
            // by compiler-ssr to generate vnode fallback branches
            ignoreSideEffectTags,
            ...DOMNodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, DOMDirectiveTransforms, options.directiveTransforms || {}),
        transformHoist: null
    }));
}
function parse(template, options = {}) {
    return (0, _compilerCore.baseParse)(template, (0, _shared.extend)({}, parserOptions, options));
}

},{"@vue/compiler-core":"kZqdU","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kZqdU":[function(require,module,exports) {
/**
* @vue/compiler-core v3.4.38
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateCodeFrame", ()=>(0, _shared.generateCodeFrame));
parcelHelpers.export(exports, "BASE_TRANSITION", ()=>BASE_TRANSITION);
parcelHelpers.export(exports, "BindingTypes", ()=>BindingTypes);
parcelHelpers.export(exports, "CAMELIZE", ()=>CAMELIZE);
parcelHelpers.export(exports, "CAPITALIZE", ()=>CAPITALIZE);
parcelHelpers.export(exports, "CREATE_BLOCK", ()=>CREATE_BLOCK);
parcelHelpers.export(exports, "CREATE_COMMENT", ()=>CREATE_COMMENT);
parcelHelpers.export(exports, "CREATE_ELEMENT_BLOCK", ()=>CREATE_ELEMENT_BLOCK);
parcelHelpers.export(exports, "CREATE_ELEMENT_VNODE", ()=>CREATE_ELEMENT_VNODE);
parcelHelpers.export(exports, "CREATE_SLOTS", ()=>CREATE_SLOTS);
parcelHelpers.export(exports, "CREATE_STATIC", ()=>CREATE_STATIC);
parcelHelpers.export(exports, "CREATE_TEXT", ()=>CREATE_TEXT);
parcelHelpers.export(exports, "CREATE_VNODE", ()=>CREATE_VNODE);
parcelHelpers.export(exports, "CompilerDeprecationTypes", ()=>CompilerDeprecationTypes);
parcelHelpers.export(exports, "ConstantTypes", ()=>ConstantTypes);
parcelHelpers.export(exports, "ElementTypes", ()=>ElementTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "FRAGMENT", ()=>FRAGMENT);
parcelHelpers.export(exports, "GUARD_REACTIVE_PROPS", ()=>GUARD_REACTIVE_PROPS);
parcelHelpers.export(exports, "IS_MEMO_SAME", ()=>IS_MEMO_SAME);
parcelHelpers.export(exports, "IS_REF", ()=>IS_REF);
parcelHelpers.export(exports, "KEEP_ALIVE", ()=>KEEP_ALIVE);
parcelHelpers.export(exports, "MERGE_PROPS", ()=>MERGE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_CLASS", ()=>NORMALIZE_CLASS);
parcelHelpers.export(exports, "NORMALIZE_PROPS", ()=>NORMALIZE_PROPS);
parcelHelpers.export(exports, "NORMALIZE_STYLE", ()=>NORMALIZE_STYLE);
parcelHelpers.export(exports, "Namespaces", ()=>Namespaces);
parcelHelpers.export(exports, "NodeTypes", ()=>NodeTypes);
parcelHelpers.export(exports, "OPEN_BLOCK", ()=>OPEN_BLOCK);
parcelHelpers.export(exports, "POP_SCOPE_ID", ()=>POP_SCOPE_ID);
parcelHelpers.export(exports, "PUSH_SCOPE_ID", ()=>PUSH_SCOPE_ID);
parcelHelpers.export(exports, "RENDER_LIST", ()=>RENDER_LIST);
parcelHelpers.export(exports, "RENDER_SLOT", ()=>RENDER_SLOT);
parcelHelpers.export(exports, "RESOLVE_COMPONENT", ()=>RESOLVE_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_DIRECTIVE", ()=>RESOLVE_DIRECTIVE);
parcelHelpers.export(exports, "RESOLVE_DYNAMIC_COMPONENT", ()=>RESOLVE_DYNAMIC_COMPONENT);
parcelHelpers.export(exports, "RESOLVE_FILTER", ()=>RESOLVE_FILTER);
parcelHelpers.export(exports, "SET_BLOCK_TRACKING", ()=>SET_BLOCK_TRACKING);
parcelHelpers.export(exports, "SUSPENSE", ()=>SUSPENSE);
parcelHelpers.export(exports, "TELEPORT", ()=>TELEPORT);
parcelHelpers.export(exports, "TO_DISPLAY_STRING", ()=>TO_DISPLAY_STRING);
parcelHelpers.export(exports, "TO_HANDLERS", ()=>TO_HANDLERS);
parcelHelpers.export(exports, "TO_HANDLER_KEY", ()=>TO_HANDLER_KEY);
parcelHelpers.export(exports, "TS_NODE_TYPES", ()=>TS_NODE_TYPES);
parcelHelpers.export(exports, "UNREF", ()=>UNREF);
parcelHelpers.export(exports, "WITH_CTX", ()=>WITH_CTX);
parcelHelpers.export(exports, "WITH_DIRECTIVES", ()=>WITH_DIRECTIVES);
parcelHelpers.export(exports, "WITH_MEMO", ()=>WITH_MEMO);
parcelHelpers.export(exports, "advancePositionWithClone", ()=>advancePositionWithClone);
parcelHelpers.export(exports, "advancePositionWithMutation", ()=>advancePositionWithMutation);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "baseCompile", ()=>baseCompile);
parcelHelpers.export(exports, "baseParse", ()=>baseParse);
parcelHelpers.export(exports, "buildDirectiveArgs", ()=>buildDirectiveArgs);
parcelHelpers.export(exports, "buildProps", ()=>buildProps);
parcelHelpers.export(exports, "buildSlots", ()=>buildSlots);
parcelHelpers.export(exports, "checkCompatEnabled", ()=>checkCompatEnabled);
parcelHelpers.export(exports, "convertToBlock", ()=>convertToBlock);
parcelHelpers.export(exports, "createArrayExpression", ()=>createArrayExpression);
parcelHelpers.export(exports, "createAssignmentExpression", ()=>createAssignmentExpression);
parcelHelpers.export(exports, "createBlockStatement", ()=>createBlockStatement);
parcelHelpers.export(exports, "createCacheExpression", ()=>createCacheExpression);
parcelHelpers.export(exports, "createCallExpression", ()=>createCallExpression);
parcelHelpers.export(exports, "createCompilerError", ()=>createCompilerError);
parcelHelpers.export(exports, "createCompoundExpression", ()=>createCompoundExpression);
parcelHelpers.export(exports, "createConditionalExpression", ()=>createConditionalExpression);
parcelHelpers.export(exports, "createForLoopParams", ()=>createForLoopParams);
parcelHelpers.export(exports, "createFunctionExpression", ()=>createFunctionExpression);
parcelHelpers.export(exports, "createIfStatement", ()=>createIfStatement);
parcelHelpers.export(exports, "createInterpolation", ()=>createInterpolation);
parcelHelpers.export(exports, "createObjectExpression", ()=>createObjectExpression);
parcelHelpers.export(exports, "createObjectProperty", ()=>createObjectProperty);
parcelHelpers.export(exports, "createReturnStatement", ()=>createReturnStatement);
parcelHelpers.export(exports, "createRoot", ()=>createRoot);
parcelHelpers.export(exports, "createSequenceExpression", ()=>createSequenceExpression);
parcelHelpers.export(exports, "createSimpleExpression", ()=>createSimpleExpression);
parcelHelpers.export(exports, "createStructuralDirectiveTransform", ()=>createStructuralDirectiveTransform);
parcelHelpers.export(exports, "createTemplateLiteral", ()=>createTemplateLiteral);
parcelHelpers.export(exports, "createTransformContext", ()=>createTransformContext);
parcelHelpers.export(exports, "createVNodeCall", ()=>createVNodeCall);
parcelHelpers.export(exports, "errorMessages", ()=>errorMessages);
parcelHelpers.export(exports, "extractIdentifiers", ()=>extractIdentifiers);
parcelHelpers.export(exports, "findDir", ()=>findDir);
parcelHelpers.export(exports, "findProp", ()=>findProp);
parcelHelpers.export(exports, "forAliasRE", ()=>forAliasRE);
parcelHelpers.export(exports, "generate", ()=>generate);
parcelHelpers.export(exports, "getBaseTransformPreset", ()=>getBaseTransformPreset);
parcelHelpers.export(exports, "getConstantType", ()=>getConstantType);
parcelHelpers.export(exports, "getMemoedVNodeCall", ()=>getMemoedVNodeCall);
parcelHelpers.export(exports, "getVNodeBlockHelper", ()=>getVNodeBlockHelper);
parcelHelpers.export(exports, "getVNodeHelper", ()=>getVNodeHelper);
parcelHelpers.export(exports, "hasDynamicKeyVBind", ()=>hasDynamicKeyVBind);
parcelHelpers.export(exports, "hasScopeRef", ()=>hasScopeRef);
parcelHelpers.export(exports, "helperNameMap", ()=>helperNameMap);
parcelHelpers.export(exports, "injectProp", ()=>injectProp);
parcelHelpers.export(exports, "isCoreComponent", ()=>isCoreComponent);
parcelHelpers.export(exports, "isFnExpression", ()=>isFnExpression);
parcelHelpers.export(exports, "isFnExpressionBrowser", ()=>isFnExpressionBrowser);
parcelHelpers.export(exports, "isFnExpressionNode", ()=>isFnExpressionNode);
parcelHelpers.export(exports, "isFunctionType", ()=>isFunctionType);
parcelHelpers.export(exports, "isInDestructureAssignment", ()=>isInDestructureAssignment);
parcelHelpers.export(exports, "isInNewExpression", ()=>isInNewExpression);
parcelHelpers.export(exports, "isMemberExpression", ()=>isMemberExpression);
parcelHelpers.export(exports, "isMemberExpressionBrowser", ()=>isMemberExpressionBrowser);
parcelHelpers.export(exports, "isMemberExpressionNode", ()=>isMemberExpressionNode);
parcelHelpers.export(exports, "isReferencedIdentifier", ()=>isReferencedIdentifier);
parcelHelpers.export(exports, "isSimpleIdentifier", ()=>isSimpleIdentifier);
parcelHelpers.export(exports, "isSlotOutlet", ()=>isSlotOutlet);
parcelHelpers.export(exports, "isStaticArgOf", ()=>isStaticArgOf);
parcelHelpers.export(exports, "isStaticExp", ()=>isStaticExp);
parcelHelpers.export(exports, "isStaticProperty", ()=>isStaticProperty);
parcelHelpers.export(exports, "isStaticPropertyKey", ()=>isStaticPropertyKey);
parcelHelpers.export(exports, "isTemplateNode", ()=>isTemplateNode);
parcelHelpers.export(exports, "isText", ()=>isText$1);
parcelHelpers.export(exports, "isVSlot", ()=>isVSlot);
parcelHelpers.export(exports, "locStub", ()=>locStub);
parcelHelpers.export(exports, "noopDirectiveTransform", ()=>noopDirectiveTransform);
parcelHelpers.export(exports, "processExpression", ()=>processExpression);
parcelHelpers.export(exports, "processFor", ()=>processFor);
parcelHelpers.export(exports, "processIf", ()=>processIf);
parcelHelpers.export(exports, "processSlotOutlet", ()=>processSlotOutlet);
parcelHelpers.export(exports, "registerRuntimeHelpers", ()=>registerRuntimeHelpers);
parcelHelpers.export(exports, "resolveComponentType", ()=>resolveComponentType);
parcelHelpers.export(exports, "stringifyExpression", ()=>stringifyExpression);
parcelHelpers.export(exports, "toValidAssetId", ()=>toValidAssetId);
parcelHelpers.export(exports, "trackSlotScopes", ()=>trackSlotScopes);
parcelHelpers.export(exports, "trackVForSlotScopes", ()=>trackVForSlotScopes);
parcelHelpers.export(exports, "transform", ()=>transform);
parcelHelpers.export(exports, "transformBind", ()=>transformBind);
parcelHelpers.export(exports, "transformElement", ()=>transformElement);
parcelHelpers.export(exports, "transformExpression", ()=>transformExpression);
parcelHelpers.export(exports, "transformModel", ()=>transformModel);
parcelHelpers.export(exports, "transformOn", ()=>transformOn);
parcelHelpers.export(exports, "traverseNode", ()=>traverseNode);
parcelHelpers.export(exports, "unwrapTSNode", ()=>unwrapTSNode);
parcelHelpers.export(exports, "walkBlockDeclarations", ()=>walkBlockDeclarations);
parcelHelpers.export(exports, "walkFunctionParams", ()=>walkFunctionParams);
parcelHelpers.export(exports, "walkIdentifiers", ()=>walkIdentifiers);
parcelHelpers.export(exports, "warnDeprecation", ()=>warnDeprecation);
var _shared = require("@vue/shared");
const FRAGMENT = Symbol(``);
const TELEPORT = Symbol(``);
const SUSPENSE = Symbol(``);
const KEEP_ALIVE = Symbol(``);
const BASE_TRANSITION = Symbol(``);
const OPEN_BLOCK = Symbol(``);
const CREATE_BLOCK = Symbol(``);
const CREATE_ELEMENT_BLOCK = Symbol(``);
const CREATE_VNODE = Symbol(``);
const CREATE_ELEMENT_VNODE = Symbol(``);
const CREATE_COMMENT = Symbol(``);
const CREATE_TEXT = Symbol(``);
const CREATE_STATIC = Symbol(``);
const RESOLVE_COMPONENT = Symbol(``);
const RESOLVE_DYNAMIC_COMPONENT = Symbol(``);
const RESOLVE_DIRECTIVE = Symbol(``);
const RESOLVE_FILTER = Symbol(``);
const WITH_DIRECTIVES = Symbol(``);
const RENDER_LIST = Symbol(``);
const RENDER_SLOT = Symbol(``);
const CREATE_SLOTS = Symbol(``);
const TO_DISPLAY_STRING = Symbol(``);
const MERGE_PROPS = Symbol(``);
const NORMALIZE_CLASS = Symbol(``);
const NORMALIZE_STYLE = Symbol(``);
const NORMALIZE_PROPS = Symbol(``);
const GUARD_REACTIVE_PROPS = Symbol(``);
const TO_HANDLERS = Symbol(``);
const CAMELIZE = Symbol(``);
const CAPITALIZE = Symbol(``);
const TO_HANDLER_KEY = Symbol(``);
const SET_BLOCK_TRACKING = Symbol(``);
const PUSH_SCOPE_ID = Symbol(``);
const POP_SCOPE_ID = Symbol(``);
const WITH_CTX = Symbol(``);
const UNREF = Symbol(``);
const IS_REF = Symbol(``);
const WITH_MEMO = Symbol(``);
const IS_MEMO_SAME = Symbol(``);
const helperNameMap = {
    [FRAGMENT]: `Fragment`,
    [TELEPORT]: `Teleport`,
    [SUSPENSE]: `Suspense`,
    [KEEP_ALIVE]: `KeepAlive`,
    [BASE_TRANSITION]: `BaseTransition`,
    [OPEN_BLOCK]: `openBlock`,
    [CREATE_BLOCK]: `createBlock`,
    [CREATE_ELEMENT_BLOCK]: `createElementBlock`,
    [CREATE_VNODE]: `createVNode`,
    [CREATE_ELEMENT_VNODE]: `createElementVNode`,
    [CREATE_COMMENT]: `createCommentVNode`,
    [CREATE_TEXT]: `createTextVNode`,
    [CREATE_STATIC]: `createStaticVNode`,
    [RESOLVE_COMPONENT]: `resolveComponent`,
    [RESOLVE_DYNAMIC_COMPONENT]: `resolveDynamicComponent`,
    [RESOLVE_DIRECTIVE]: `resolveDirective`,
    [RESOLVE_FILTER]: `resolveFilter`,
    [WITH_DIRECTIVES]: `withDirectives`,
    [RENDER_LIST]: `renderList`,
    [RENDER_SLOT]: `renderSlot`,
    [CREATE_SLOTS]: `createSlots`,
    [TO_DISPLAY_STRING]: `toDisplayString`,
    [MERGE_PROPS]: `mergeProps`,
    [NORMALIZE_CLASS]: `normalizeClass`,
    [NORMALIZE_STYLE]: `normalizeStyle`,
    [NORMALIZE_PROPS]: `normalizeProps`,
    [GUARD_REACTIVE_PROPS]: `guardReactiveProps`,
    [TO_HANDLERS]: `toHandlers`,
    [CAMELIZE]: `camelize`,
    [CAPITALIZE]: `capitalize`,
    [TO_HANDLER_KEY]: `toHandlerKey`,
    [SET_BLOCK_TRACKING]: `setBlockTracking`,
    [PUSH_SCOPE_ID]: `pushScopeId`,
    [POP_SCOPE_ID]: `popScopeId`,
    [WITH_CTX]: `withCtx`,
    [UNREF]: `unref`,
    [IS_REF]: `isRef`,
    [WITH_MEMO]: `withMemo`,
    [IS_MEMO_SAME]: `isMemoSame`
};
function registerRuntimeHelpers(helpers) {
    Object.getOwnPropertySymbols(helpers).forEach((s)=>{
        helperNameMap[s] = helpers[s];
    });
}
const Namespaces = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
const NodeTypes = {
    "ROOT": 0,
    "0": "ROOT",
    "ELEMENT": 1,
    "1": "ELEMENT",
    "TEXT": 2,
    "2": "TEXT",
    "COMMENT": 3,
    "3": "COMMENT",
    "SIMPLE_EXPRESSION": 4,
    "4": "SIMPLE_EXPRESSION",
    "INTERPOLATION": 5,
    "5": "INTERPOLATION",
    "ATTRIBUTE": 6,
    "6": "ATTRIBUTE",
    "DIRECTIVE": 7,
    "7": "DIRECTIVE",
    "COMPOUND_EXPRESSION": 8,
    "8": "COMPOUND_EXPRESSION",
    "IF": 9,
    "9": "IF",
    "IF_BRANCH": 10,
    "10": "IF_BRANCH",
    "FOR": 11,
    "11": "FOR",
    "TEXT_CALL": 12,
    "12": "TEXT_CALL",
    "VNODE_CALL": 13,
    "13": "VNODE_CALL",
    "JS_CALL_EXPRESSION": 14,
    "14": "JS_CALL_EXPRESSION",
    "JS_OBJECT_EXPRESSION": 15,
    "15": "JS_OBJECT_EXPRESSION",
    "JS_PROPERTY": 16,
    "16": "JS_PROPERTY",
    "JS_ARRAY_EXPRESSION": 17,
    "17": "JS_ARRAY_EXPRESSION",
    "JS_FUNCTION_EXPRESSION": 18,
    "18": "JS_FUNCTION_EXPRESSION",
    "JS_CONDITIONAL_EXPRESSION": 19,
    "19": "JS_CONDITIONAL_EXPRESSION",
    "JS_CACHE_EXPRESSION": 20,
    "20": "JS_CACHE_EXPRESSION",
    "JS_BLOCK_STATEMENT": 21,
    "21": "JS_BLOCK_STATEMENT",
    "JS_TEMPLATE_LITERAL": 22,
    "22": "JS_TEMPLATE_LITERAL",
    "JS_IF_STATEMENT": 23,
    "23": "JS_IF_STATEMENT",
    "JS_ASSIGNMENT_EXPRESSION": 24,
    "24": "JS_ASSIGNMENT_EXPRESSION",
    "JS_SEQUENCE_EXPRESSION": 25,
    "25": "JS_SEQUENCE_EXPRESSION",
    "JS_RETURN_STATEMENT": 26,
    "26": "JS_RETURN_STATEMENT"
};
const ElementTypes = {
    "ELEMENT": 0,
    "0": "ELEMENT",
    "COMPONENT": 1,
    "1": "COMPONENT",
    "SLOT": 2,
    "2": "SLOT",
    "TEMPLATE": 3,
    "3": "TEMPLATE"
};
const ConstantTypes = {
    "NOT_CONSTANT": 0,
    "0": "NOT_CONSTANT",
    "CAN_SKIP_PATCH": 1,
    "1": "CAN_SKIP_PATCH",
    "CAN_HOIST": 2,
    "2": "CAN_HOIST",
    "CAN_STRINGIFY": 3,
    "3": "CAN_STRINGIFY"
};
const locStub = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    },
    source: ""
};
function createRoot(children, source = "") {
    return {
        type: 0,
        source,
        children,
        helpers: /* @__PURE__ */ new Set(),
        components: [],
        directives: [],
        hoists: [],
        imports: [],
        cached: 0,
        temps: 0,
        codegenNode: void 0,
        loc: locStub
    };
}
function createVNodeCall(context, tag, props, children, patchFlag, dynamicProps, directives, isBlock = false, disableTracking = false, isComponent = false, loc = locStub) {
    if (context) {
        if (isBlock) {
            context.helper(OPEN_BLOCK);
            context.helper(getVNodeBlockHelper(context.inSSR, isComponent));
        } else context.helper(getVNodeHelper(context.inSSR, isComponent));
        if (directives) context.helper(WITH_DIRECTIVES);
    }
    return {
        type: 13,
        tag,
        props,
        children,
        patchFlag,
        dynamicProps,
        directives,
        isBlock,
        disableTracking,
        isComponent,
        loc
    };
}
function createArrayExpression(elements, loc = locStub) {
    return {
        type: 17,
        loc,
        elements
    };
}
function createObjectExpression(properties, loc = locStub) {
    return {
        type: 15,
        loc,
        properties
    };
}
function createObjectProperty(key, value) {
    return {
        type: 16,
        loc: locStub,
        key: (0, _shared.isString)(key) ? createSimpleExpression(key, true) : key,
        value
    };
}
function createSimpleExpression(content, isStatic = false, loc = locStub, constType = 0) {
    return {
        type: 4,
        loc,
        content,
        isStatic,
        constType: isStatic ? 3 : constType
    };
}
function createInterpolation(content, loc) {
    return {
        type: 5,
        loc,
        content: (0, _shared.isString)(content) ? createSimpleExpression(content, false, loc) : content
    };
}
function createCompoundExpression(children, loc = locStub) {
    return {
        type: 8,
        loc,
        children
    };
}
function createCallExpression(callee, args = [], loc = locStub) {
    return {
        type: 14,
        loc,
        callee,
        arguments: args
    };
}
function createFunctionExpression(params, returns, newline = false, isSlot = false, loc = locStub) {
    return {
        type: 18,
        params,
        returns,
        newline,
        isSlot,
        loc
    };
}
function createConditionalExpression(test, consequent, alternate, newline = true) {
    return {
        type: 19,
        test,
        consequent,
        alternate,
        newline,
        loc: locStub
    };
}
function createCacheExpression(index, value, isVOnce = false) {
    return {
        type: 20,
        index,
        value,
        isVOnce,
        loc: locStub
    };
}
function createBlockStatement(body) {
    return {
        type: 21,
        body,
        loc: locStub
    };
}
function createTemplateLiteral(elements) {
    return {
        type: 22,
        elements,
        loc: locStub
    };
}
function createIfStatement(test, consequent, alternate) {
    return {
        type: 23,
        test,
        consequent,
        alternate,
        loc: locStub
    };
}
function createAssignmentExpression(left, right) {
    return {
        type: 24,
        left,
        right,
        loc: locStub
    };
}
function createSequenceExpression(expressions) {
    return {
        type: 25,
        expressions,
        loc: locStub
    };
}
function createReturnStatement(returns) {
    return {
        type: 26,
        returns,
        loc: locStub
    };
}
function getVNodeHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_VNODE : CREATE_ELEMENT_VNODE;
}
function getVNodeBlockHelper(ssr, isComponent) {
    return ssr || isComponent ? CREATE_BLOCK : CREATE_ELEMENT_BLOCK;
}
function convertToBlock(node, { helper, removeHelper, inSSR }) {
    if (!node.isBlock) {
        node.isBlock = true;
        removeHelper(getVNodeHelper(inSSR, node.isComponent));
        helper(OPEN_BLOCK);
        helper(getVNodeBlockHelper(inSSR, node.isComponent));
    }
}
const defaultDelimitersOpen = new Uint8Array([
    123,
    123
]);
const defaultDelimitersClose = new Uint8Array([
    125,
    125
]);
function isTagStartChar(c) {
    return c >= 97 && c <= 122 || c >= 65 && c <= 90;
}
function isWhitespace(c) {
    return c === 32 || c === 10 || c === 9 || c === 12 || c === 13;
}
function isEndOfTagSection(c) {
    return c === 47 || c === 62 || isWhitespace(c);
}
function toCharCodes(str) {
    const ret = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)ret[i] = str.charCodeAt(i);
    return ret;
}
const Sequences = {
    Cdata: new Uint8Array([
        67,
        68,
        65,
        84,
        65,
        91
    ]),
    // CDATA[
    CdataEnd: new Uint8Array([
        93,
        93,
        62
    ]),
    // ]]>
    CommentEnd: new Uint8Array([
        45,
        45,
        62
    ]),
    // `-->`
    ScriptEnd: new Uint8Array([
        60,
        47,
        115,
        99,
        114,
        105,
        112,
        116
    ]),
    // `<\/script`
    StyleEnd: new Uint8Array([
        60,
        47,
        115,
        116,
        121,
        108,
        101
    ]),
    // `</style`
    TitleEnd: new Uint8Array([
        60,
        47,
        116,
        105,
        116,
        108,
        101
    ]),
    // `</title`
    TextareaEnd: new Uint8Array([
        60,
        47,
        116,
        101,
        120,
        116,
        97,
        114,
        101,
        97
    ])
};
class Tokenizer {
    constructor(stack, cbs){
        this.stack = stack;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = 1;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** The start of the last entity. */ this.entityStart = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = 1;
        /** For special parsing behavior inside of script and style tags. */ this.inRCDATA = false;
        /** For disabling RCDATA tags handling */ this.inXML = false;
        /** For disabling interpolation parsing in v-pre */ this.inVPre = false;
        /** Record newline positions for fast line / column calculation */ this.newlines = [];
        this.mode = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
        this.delimiterIndex = -1;
        this.currentSequence = void 0;
        this.sequenceIndex = 0;
    }
    get inSFCRoot() {
        return this.mode === 2 && this.stack.length === 0;
    }
    reset() {
        this.state = 1;
        this.mode = 0;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = 1;
        this.inRCDATA = false;
        this.currentSequence = void 0;
        this.newlines.length = 0;
        this.delimiterOpen = defaultDelimitersOpen;
        this.delimiterClose = defaultDelimitersClose;
    }
    /**
   * Generate Position object with line / column information using recorded
   * newline positions. We know the index is always going to be an already
   * processed index, so all the newlines up to this index should have been
   * recorded.
   */ getPos(index) {
        let line = 1;
        let column = index + 1;
        for(let i = this.newlines.length - 1; i >= 0; i--){
            const newlineIndex = this.newlines[i];
            if (index > newlineIndex) {
                line = i + 2;
                column = index - newlineIndex;
                break;
            }
        }
        return {
            column,
            line,
            offset: index
        };
    }
    peek() {
        return this.buffer.charCodeAt(this.index + 1);
    }
    stateText(c) {
        if (c === 60) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!this.inVPre && c === this.delimiterOpen[0]) {
            this.state = 2;
            this.delimiterIndex = 0;
            this.stateInterpolationOpen(c);
        }
    }
    stateInterpolationOpen(c) {
        if (c === this.delimiterOpen[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterOpen.length - 1) {
                const start = this.index + 1 - this.delimiterOpen.length;
                if (start > this.sectionStart) this.cbs.ontext(this.sectionStart, start);
                this.state = 3;
                this.sectionStart = start;
            } else this.delimiterIndex++;
        } else if (this.inRCDATA) {
            this.state = 32;
            this.stateInRCDATA(c);
        } else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInterpolation(c) {
        if (c === this.delimiterClose[0]) {
            this.state = 4;
            this.delimiterIndex = 0;
            this.stateInterpolationClose(c);
        }
    }
    stateInterpolationClose(c) {
        if (c === this.delimiterClose[this.delimiterIndex]) {
            if (this.delimiterIndex === this.delimiterClose.length - 1) {
                this.cbs.oninterpolation(this.sectionStart, this.index + 1);
                if (this.inRCDATA) this.state = 32;
                else this.state = 1;
                this.sectionStart = this.index + 1;
            } else this.delimiterIndex++;
        } else {
            this.state = 3;
            this.stateInterpolation(c);
        }
    }
    stateSpecialStartSequence(c) {
        const isEnd = this.sequenceIndex === this.currentSequence.length;
        const isMatch = isEnd ? // If we are at the end of the sequence, make sure the tag name has ended
        isEndOfTagSection(c) : // Otherwise, do a case-insensitive comparison
        (c | 32) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.inRCDATA = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = 6;
        this.stateInTagName(c);
    }
    /** Look for an end tag. For <title> and <textarea>, also decode entities. */ stateInRCDATA(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === 62 || isWhitespace(c)) {
                const endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    const actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.sectionStart = endOfText + 2;
                this.stateInClosingTagName(c);
                this.inRCDATA = false;
                return;
            }
            this.sequenceIndex = 0;
        }
        if ((c | 32) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === Sequences.TitleEnd || this.currentSequence === Sequences.TextareaEnd && !this.inSFCRoot) {
                if (c === this.delimiterOpen[0]) {
                    this.state = 2;
                    this.delimiterIndex = 0;
                    this.stateInterpolationOpen(c);
                }
            } else if (this.fastForwardTo(60)) this.sequenceIndex = 1;
        } else this.sequenceIndex = Number(c === 60);
    }
    stateCDATASequence(c) {
        if (c === Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === Sequences.Cdata.length) {
                this.state = 28;
                this.currentSequence = Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = 23;
            this.stateInDeclaration(c);
        }
    }
    /**
   * When we wait for one specific character, we can speed things up
   * by skipping through the buffer until we find it.
   *
   * @returns Whether the character was found.
   */ fastForwardTo(c) {
        while(++this.index < this.buffer.length){
            const cc = this.buffer.charCodeAt(this.index);
            if (cc === 10) this.newlines.push(this.index);
            if (cc === c) return true;
        }
        this.index = this.buffer.length - 1;
        return false;
    }
    /**
   * Comments and CDATA end with `-->` and `]]>`.
   *
   * Their common qualities are:
   * - Their end sequences have a distinct character they start with.
   * - That character is then repeated, so we have to check multiple repeats.
   * - All characters but the start character of the sequence can be skipped.
   */ stateInCommentLike(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index - 2);
                else this.cbs.oncomment(this.sectionStart, this.index - 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = 1;
            }
        } else if (this.sequenceIndex === 0) {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) this.sequenceIndex = 0;
    }
    startSpecial(sequence, offset) {
        this.enterRCDATA(sequence, offset);
        this.state = 31;
    }
    enterRCDATA(sequence, offset) {
        this.inRCDATA = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
    }
    stateBeforeTagName(c) {
        if (c === 33) {
            this.state = 22;
            this.sectionStart = this.index + 1;
        } else if (c === 63) {
            this.state = 24;
            this.sectionStart = this.index + 1;
        } else if (isTagStartChar(c)) {
            this.sectionStart = this.index;
            if (this.mode === 0) this.state = 6;
            else if (this.inSFCRoot) this.state = 34;
            else if (!this.inXML) {
                if (c === 116) this.state = 30;
                else this.state = c === 115 ? 29 : 6;
            } else this.state = 6;
        } else if (c === 47) this.state = 8;
        else {
            this.state = 1;
            this.stateText(c);
        }
    }
    stateInTagName(c) {
        if (isEndOfTagSection(c)) this.handleTagName(c);
    }
    stateInSFCRootTagName(c) {
        if (isEndOfTagSection(c)) {
            const tag = this.buffer.slice(this.sectionStart, this.index);
            if (tag !== "template") this.enterRCDATA(toCharCodes(`</` + tag), 0);
            this.handleTagName(c);
        }
    }
    handleTagName(c) {
        this.cbs.onopentagname(this.sectionStart, this.index);
        this.sectionStart = -1;
        this.state = 11;
        this.stateBeforeAttrName(c);
    }
    stateBeforeClosingTagName(c) {
        if (isWhitespace(c)) ;
        else if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        } else {
            this.state = isTagStartChar(c) ? 9 : 27;
            this.sectionStart = this.index;
        }
    }
    stateInClosingTagName(c) {
        if (c === 62 || isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = 10;
            this.stateAfterClosingTagName(c);
        }
    }
    stateAfterClosingTagName(c) {
        if (c === 62) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeAttrName(c) {
        if (c === 62) {
            this.cbs.onopentagend(this.index);
            if (this.inRCDATA) this.state = 32;
            else this.state = 1;
            this.sectionStart = this.index + 1;
        } else if (c === 47) this.state = 7;
        else if (c === 60 && this.peek() === 47) {
            this.cbs.onopentagend(this.index);
            this.state = 5;
            this.sectionStart = this.index;
        } else if (!isWhitespace(c)) this.handleAttrStart(c);
    }
    handleAttrStart(c) {
        if (c === 118 && this.peek() === 45) {
            this.state = 13;
            this.sectionStart = this.index;
        } else if (c === 46 || c === 58 || c === 64 || c === 35) {
            this.cbs.ondirname(this.index, this.index + 1);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else {
            this.state = 12;
            this.sectionStart = this.index;
        }
    }
    stateInSelfClosingTag(c) {
        if (c === 62) {
            this.cbs.onselfclosingtag(this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
            this.inRCDATA = false;
        } else if (!isWhitespace(c)) {
            this.state = 11;
            this.stateBeforeAttrName(c);
        }
    }
    stateInAttrName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirName(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 58) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 14;
            this.sectionStart = this.index + 1;
        } else if (c === 46) {
            this.cbs.ondirname(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDirArg(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 91) this.state = 15;
        else if (c === 46) {
            this.cbs.ondirarg(this.sectionStart, this.index);
            this.state = 16;
            this.sectionStart = this.index + 1;
        }
    }
    stateInDynamicDirArg(c) {
        if (c === 93) this.state = 14;
        else if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirarg(this.sectionStart, this.index + 1);
            this.handleAttrNameEnd(c);
        }
    }
    stateInDirModifier(c) {
        if (c === 61 || isEndOfTagSection(c)) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.handleAttrNameEnd(c);
        } else if (c === 46) {
            this.cbs.ondirmodifier(this.sectionStart, this.index);
            this.sectionStart = this.index + 1;
        }
    }
    handleAttrNameEnd(c) {
        this.sectionStart = this.index;
        this.state = 17;
        this.cbs.onattribnameend(this.index);
        this.stateAfterAttrName(c);
    }
    stateAfterAttrName(c) {
        if (c === 61) this.state = 18;
        else if (c === 47 || c === 62) {
            this.cbs.onattribend(0, this.sectionStart);
            this.sectionStart = -1;
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (!isWhitespace(c)) {
            this.cbs.onattribend(0, this.sectionStart);
            this.handleAttrStart(c);
        }
    }
    stateBeforeAttrValue(c) {
        if (c === 34) {
            this.state = 19;
            this.sectionStart = this.index + 1;
        } else if (c === 39) {
            this.state = 20;
            this.sectionStart = this.index + 1;
        } else if (!isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = 21;
            this.stateInAttrValueNoQuotes(c);
        }
    }
    handleInAttrValue(c, quote) {
        if (c === quote || this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === 34 ? 3 : 2, this.index + 1);
            this.state = 11;
        }
    }
    stateInAttrValueDoubleQuotes(c) {
        this.handleInAttrValue(c, 34);
    }
    stateInAttrValueSingleQuotes(c) {
        this.handleInAttrValue(c, 39);
    }
    stateInAttrValueNoQuotes(c) {
        if (isWhitespace(c) || c === 62) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(1, this.index);
            this.state = 11;
            this.stateBeforeAttrName(c);
        } else if (c === 39 || c === 60 || c === 61 || c === 96) this.cbs.onerr(18, this.index);
    }
    stateBeforeDeclaration(c) {
        if (c === 91) {
            this.state = 26;
            this.sequenceIndex = 0;
        } else this.state = c === 45 ? 25 : 23;
    }
    stateInDeclaration(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateInProcessingInstruction(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeComment(c) {
        if (c === 45) {
            this.state = 28;
            this.currentSequence = Sequences.CommentEnd;
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = 23;
    }
    stateInSpecialComment(c) {
        if (c === 62 || this.fastForwardTo(62)) {
            this.cbs.oncomment(this.sectionStart, this.index);
            this.state = 1;
            this.sectionStart = this.index + 1;
        }
    }
    stateBeforeSpecialS(c) {
        if (c === Sequences.ScriptEnd[3]) this.startSpecial(Sequences.ScriptEnd, 4);
        else if (c === Sequences.StyleEnd[3]) this.startSpecial(Sequences.StyleEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    stateBeforeSpecialT(c) {
        if (c === Sequences.TitleEnd[3]) this.startSpecial(Sequences.TitleEnd, 4);
        else if (c === Sequences.TextareaEnd[3]) this.startSpecial(Sequences.TextareaEnd, 4);
        else {
            this.state = 6;
            this.stateInTagName(c);
        }
    }
    startEntity() {}
    stateInEntity() {}
    /**
   * Iterates through the buffer, calling the function corresponding to the current state.
   *
   * States that are more likely to be hit are higher up, as a performance improvement.
   */ parse(input) {
        this.buffer = input;
        while(this.index < this.buffer.length){
            const c = this.buffer.charCodeAt(this.index);
            if (c === 10) this.newlines.push(this.index);
            switch(this.state){
                case 1:
                    this.stateText(c);
                    break;
                case 2:
                    this.stateInterpolationOpen(c);
                    break;
                case 3:
                    this.stateInterpolation(c);
                    break;
                case 4:
                    this.stateInterpolationClose(c);
                    break;
                case 31:
                    this.stateSpecialStartSequence(c);
                    break;
                case 32:
                    this.stateInRCDATA(c);
                    break;
                case 26:
                    this.stateCDATASequence(c);
                    break;
                case 19:
                    this.stateInAttrValueDoubleQuotes(c);
                    break;
                case 12:
                    this.stateInAttrName(c);
                    break;
                case 13:
                    this.stateInDirName(c);
                    break;
                case 14:
                    this.stateInDirArg(c);
                    break;
                case 15:
                    this.stateInDynamicDirArg(c);
                    break;
                case 16:
                    this.stateInDirModifier(c);
                    break;
                case 28:
                    this.stateInCommentLike(c);
                    break;
                case 27:
                    this.stateInSpecialComment(c);
                    break;
                case 11:
                    this.stateBeforeAttrName(c);
                    break;
                case 6:
                    this.stateInTagName(c);
                    break;
                case 34:
                    this.stateInSFCRootTagName(c);
                    break;
                case 9:
                    this.stateInClosingTagName(c);
                    break;
                case 5:
                    this.stateBeforeTagName(c);
                    break;
                case 17:
                    this.stateAfterAttrName(c);
                    break;
                case 20:
                    this.stateInAttrValueSingleQuotes(c);
                    break;
                case 18:
                    this.stateBeforeAttrValue(c);
                    break;
                case 8:
                    this.stateBeforeClosingTagName(c);
                    break;
                case 10:
                    this.stateAfterClosingTagName(c);
                    break;
                case 29:
                    this.stateBeforeSpecialS(c);
                    break;
                case 30:
                    this.stateBeforeSpecialT(c);
                    break;
                case 21:
                    this.stateInAttrValueNoQuotes(c);
                    break;
                case 7:
                    this.stateInSelfClosingTag(c);
                    break;
                case 23:
                    this.stateInDeclaration(c);
                    break;
                case 22:
                    this.stateBeforeDeclaration(c);
                    break;
                case 25:
                    this.stateBeforeComment(c);
                    break;
                case 24:
                    this.stateInProcessingInstruction(c);
                    break;
                case 33:
                    this.stateInEntity();
                    break;
            }
            this.index++;
        }
        this.cleanup();
        this.finish();
    }
    /**
   * Remove data that has already been consumed from the buffer.
   */ cleanup() {
        if (this.sectionStart !== this.index) {
            if (this.state === 1 || this.state === 32 && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === 19 || this.state === 20 || this.state === 21) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    }
    finish() {
        this.handleTrailingData();
        this.cbs.onend();
    }
    /** Handle any trailing data. */ handleTrailingData() {
        const endIndex = this.buffer.length;
        if (this.sectionStart >= endIndex) return;
        if (this.state === 28) {
            if (this.currentSequence === Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex);
            else this.cbs.oncomment(this.sectionStart, endIndex);
        } else if (this.state === 6 || this.state === 11 || this.state === 18 || this.state === 17 || this.state === 12 || this.state === 13 || this.state === 14 || this.state === 15 || this.state === 16 || this.state === 20 || this.state === 19 || this.state === 21 || this.state === 9) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    }
    emitCodePoint(cp, consumed) {}
}
const CompilerDeprecationTypes = {
    "COMPILER_IS_ON_ELEMENT": "COMPILER_IS_ON_ELEMENT",
    "COMPILER_V_BIND_SYNC": "COMPILER_V_BIND_SYNC",
    "COMPILER_V_BIND_OBJECT_ORDER": "COMPILER_V_BIND_OBJECT_ORDER",
    "COMPILER_V_ON_NATIVE": "COMPILER_V_ON_NATIVE",
    "COMPILER_V_IF_V_FOR_PRECEDENCE": "COMPILER_V_IF_V_FOR_PRECEDENCE",
    "COMPILER_NATIVE_TEMPLATE": "COMPILER_NATIVE_TEMPLATE",
    "COMPILER_INLINE_TEMPLATE": "COMPILER_INLINE_TEMPLATE",
    "COMPILER_FILTERS": "COMPILER_FILTERS"
};
const deprecationData = {
    ["COMPILER_IS_ON_ELEMENT"]: {
        message: `Platform-native elements with "is" prop will no longer be treated as components in Vue 3 unless the "is" value is explicitly prefixed with "vue:".`,
        link: `https://v3-migration.vuejs.org/breaking-changes/custom-elements-interop.html`
    },
    ["COMPILER_V_BIND_SYNC"]: {
        message: (key)=>`.sync modifier for v-bind has been removed. Use v-model with argument instead. \`v-bind:${key}.sync\` should be changed to \`v-model:${key}\`.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-model.html`
    },
    ["COMPILER_V_BIND_OBJECT_ORDER"]: {
        message: `v-bind="obj" usage is now order sensitive and behaves like JavaScript object spread: it will now overwrite an existing non-mergeable attribute that appears before v-bind in the case of conflict. To retain 2.x behavior, move v-bind to make it the first attribute. You can also suppress this warning if the usage is intended.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-bind.html`
    },
    ["COMPILER_V_ON_NATIVE"]: {
        message: `.native modifier for v-on has been removed as is no longer necessary.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-on-native-modifier-removed.html`
    },
    ["COMPILER_V_IF_V_FOR_PRECEDENCE"]: {
        message: `v-if / v-for precedence when used on the same element has changed in Vue 3: v-if now takes higher precedence and will no longer have access to v-for scope variables. It is best to avoid the ambiguity with <template> tags or use a computed property that filters v-for data source.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/v-if-v-for.html`
    },
    ["COMPILER_NATIVE_TEMPLATE"]: {
        message: `<template> with no special directives will render as a native template element instead of its inner content in Vue 3.`
    },
    ["COMPILER_INLINE_TEMPLATE"]: {
        message: `"inline-template" has been removed in Vue 3.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/inline-template-attribute.html`
    },
    ["COMPILER_FILTERS"]: {
        message: `filters have been removed in Vue 3. The "|" symbol will be treated as native JavaScript bitwise OR operator. Use method calls or computed properties instead.`,
        link: `https://v3-migration.vuejs.org/breaking-changes/filters.html`
    }
};
function getCompatValue(key, { compatConfig }) {
    const value = compatConfig && compatConfig[key];
    if (key === "MODE") return value || 3;
    else return value;
}
function isCompatEnabled(key, context) {
    const mode = getCompatValue("MODE", context);
    const value = getCompatValue(key, context);
    return mode === 3 ? value === true : value !== false;
}
function checkCompatEnabled(key, context, loc, ...args) {
    const enabled = isCompatEnabled(key, context);
    return enabled;
}
function warnDeprecation(key, context, loc, ...args) {
    const val = getCompatValue(key, context);
    if (val === "suppress-warning") return;
    const { message, link } = deprecationData[key];
    const msg = `(deprecation ${key}) ${typeof message === "function" ? message(...args) : message}${link ? `
  Details: ${link}` : ``}`;
    const err = new SyntaxError(msg);
    err.code = key;
    if (loc) err.loc = loc;
    context.onWarn(err);
}
function defaultOnError(error) {
    throw error;
}
function defaultOnWarn(msg) {}
function createCompilerError(code, loc, messages, additionalMessage) {
    const msg = `https://vuejs.org/error-reference/#compiler-${code}`;
    const error = new SyntaxError(String(msg));
    error.code = code;
    error.loc = loc;
    return error;
}
const ErrorCodes = {
    "ABRUPT_CLOSING_OF_EMPTY_COMMENT": 0,
    "0": "ABRUPT_CLOSING_OF_EMPTY_COMMENT",
    "CDATA_IN_HTML_CONTENT": 1,
    "1": "CDATA_IN_HTML_CONTENT",
    "DUPLICATE_ATTRIBUTE": 2,
    "2": "DUPLICATE_ATTRIBUTE",
    "END_TAG_WITH_ATTRIBUTES": 3,
    "3": "END_TAG_WITH_ATTRIBUTES",
    "END_TAG_WITH_TRAILING_SOLIDUS": 4,
    "4": "END_TAG_WITH_TRAILING_SOLIDUS",
    "EOF_BEFORE_TAG_NAME": 5,
    "5": "EOF_BEFORE_TAG_NAME",
    "EOF_IN_CDATA": 6,
    "6": "EOF_IN_CDATA",
    "EOF_IN_COMMENT": 7,
    "7": "EOF_IN_COMMENT",
    "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT": 8,
    "8": "EOF_IN_SCRIPT_HTML_COMMENT_LIKE_TEXT",
    "EOF_IN_TAG": 9,
    "9": "EOF_IN_TAG",
    "INCORRECTLY_CLOSED_COMMENT": 10,
    "10": "INCORRECTLY_CLOSED_COMMENT",
    "INCORRECTLY_OPENED_COMMENT": 11,
    "11": "INCORRECTLY_OPENED_COMMENT",
    "INVALID_FIRST_CHARACTER_OF_TAG_NAME": 12,
    "12": "INVALID_FIRST_CHARACTER_OF_TAG_NAME",
    "MISSING_ATTRIBUTE_VALUE": 13,
    "13": "MISSING_ATTRIBUTE_VALUE",
    "MISSING_END_TAG_NAME": 14,
    "14": "MISSING_END_TAG_NAME",
    "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES": 15,
    "15": "MISSING_WHITESPACE_BETWEEN_ATTRIBUTES",
    "NESTED_COMMENT": 16,
    "16": "NESTED_COMMENT",
    "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME": 17,
    "17": "UNEXPECTED_CHARACTER_IN_ATTRIBUTE_NAME",
    "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE": 18,
    "18": "UNEXPECTED_CHARACTER_IN_UNQUOTED_ATTRIBUTE_VALUE",
    "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME": 19,
    "19": "UNEXPECTED_EQUALS_SIGN_BEFORE_ATTRIBUTE_NAME",
    "UNEXPECTED_NULL_CHARACTER": 20,
    "20": "UNEXPECTED_NULL_CHARACTER",
    "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME": 21,
    "21": "UNEXPECTED_QUESTION_MARK_INSTEAD_OF_TAG_NAME",
    "UNEXPECTED_SOLIDUS_IN_TAG": 22,
    "22": "UNEXPECTED_SOLIDUS_IN_TAG",
    "X_INVALID_END_TAG": 23,
    "23": "X_INVALID_END_TAG",
    "X_MISSING_END_TAG": 24,
    "24": "X_MISSING_END_TAG",
    "X_MISSING_INTERPOLATION_END": 25,
    "25": "X_MISSING_INTERPOLATION_END",
    "X_MISSING_DIRECTIVE_NAME": 26,
    "26": "X_MISSING_DIRECTIVE_NAME",
    "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END": 27,
    "27": "X_MISSING_DYNAMIC_DIRECTIVE_ARGUMENT_END",
    "X_V_IF_NO_EXPRESSION": 28,
    "28": "X_V_IF_NO_EXPRESSION",
    "X_V_IF_SAME_KEY": 29,
    "29": "X_V_IF_SAME_KEY",
    "X_V_ELSE_NO_ADJACENT_IF": 30,
    "30": "X_V_ELSE_NO_ADJACENT_IF",
    "X_V_FOR_NO_EXPRESSION": 31,
    "31": "X_V_FOR_NO_EXPRESSION",
    "X_V_FOR_MALFORMED_EXPRESSION": 32,
    "32": "X_V_FOR_MALFORMED_EXPRESSION",
    "X_V_FOR_TEMPLATE_KEY_PLACEMENT": 33,
    "33": "X_V_FOR_TEMPLATE_KEY_PLACEMENT",
    "X_V_BIND_NO_EXPRESSION": 34,
    "34": "X_V_BIND_NO_EXPRESSION",
    "X_V_ON_NO_EXPRESSION": 35,
    "35": "X_V_ON_NO_EXPRESSION",
    "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET": 36,
    "36": "X_V_SLOT_UNEXPECTED_DIRECTIVE_ON_SLOT_OUTLET",
    "X_V_SLOT_MIXED_SLOT_USAGE": 37,
    "37": "X_V_SLOT_MIXED_SLOT_USAGE",
    "X_V_SLOT_DUPLICATE_SLOT_NAMES": 38,
    "38": "X_V_SLOT_DUPLICATE_SLOT_NAMES",
    "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN": 39,
    "39": "X_V_SLOT_EXTRANEOUS_DEFAULT_SLOT_CHILDREN",
    "X_V_SLOT_MISPLACED": 40,
    "40": "X_V_SLOT_MISPLACED",
    "X_V_MODEL_NO_EXPRESSION": 41,
    "41": "X_V_MODEL_NO_EXPRESSION",
    "X_V_MODEL_MALFORMED_EXPRESSION": 42,
    "42": "X_V_MODEL_MALFORMED_EXPRESSION",
    "X_V_MODEL_ON_SCOPE_VARIABLE": 43,
    "43": "X_V_MODEL_ON_SCOPE_VARIABLE",
    "X_V_MODEL_ON_PROPS": 44,
    "44": "X_V_MODEL_ON_PROPS",
    "X_INVALID_EXPRESSION": 45,
    "45": "X_INVALID_EXPRESSION",
    "X_KEEP_ALIVE_INVALID_CHILDREN": 46,
    "46": "X_KEEP_ALIVE_INVALID_CHILDREN",
    "X_PREFIX_ID_NOT_SUPPORTED": 47,
    "47": "X_PREFIX_ID_NOT_SUPPORTED",
    "X_MODULE_MODE_NOT_SUPPORTED": 48,
    "48": "X_MODULE_MODE_NOT_SUPPORTED",
    "X_CACHE_HANDLER_NOT_SUPPORTED": 49,
    "49": "X_CACHE_HANDLER_NOT_SUPPORTED",
    "X_SCOPE_ID_NOT_SUPPORTED": 50,
    "50": "X_SCOPE_ID_NOT_SUPPORTED",
    "X_VNODE_HOOKS": 51,
    "51": "X_VNODE_HOOKS",
    "X_V_BIND_INVALID_SAME_NAME_ARGUMENT": 52,
    "52": "X_V_BIND_INVALID_SAME_NAME_ARGUMENT",
    "__EXTEND_POINT__": 53,
    "53": "__EXTEND_POINT__"
};
const errorMessages = {
    // parse errors
    [0]: "Illegal comment.",
    [1]: "CDATA section is allowed only in XML context.",
    [2]: "Duplicate attribute.",
    [3]: "End tag cannot have attributes.",
    [4]: "Illegal '/' in tags.",
    [5]: "Unexpected EOF in tag.",
    [6]: "Unexpected EOF in CDATA section.",
    [7]: "Unexpected EOF in comment.",
    [8]: "Unexpected EOF in script.",
    [9]: "Unexpected EOF in tag.",
    [10]: "Incorrectly closed comment.",
    [11]: "Incorrectly opened comment.",
    [12]: "Illegal tag name. Use '&lt;' to print '<'.",
    [13]: "Attribute value was expected.",
    [14]: "End tag name was expected.",
    [15]: "Whitespace was expected.",
    [16]: "Unexpected '<!--' in comment.",
    [17]: `Attribute name cannot contain U+0022 ("), U+0027 ('), and U+003C (<).`,
    [18]: "Unquoted attribute value cannot contain U+0022 (\"), U+0027 ('), U+003C (<), U+003D (=), and U+0060 (`).",
    [19]: "Attribute name cannot start with '='.",
    [21]: "'<?' is allowed only in XML context.",
    [20]: `Unexpected null character.`,
    [22]: "Illegal '/' in tags.",
    // Vue-specific parse errors
    [23]: "Invalid end tag.",
    [24]: "Element is missing end tag.",
    [25]: "Interpolation end sign was not found.",
    [27]: "End bracket for dynamic directive argument was not found. Note that dynamic directive argument cannot contain spaces.",
    [26]: "Legal directive name was expected.",
    // transform errors
    [28]: `v-if/v-else-if is missing expression.`,
    [29]: `v-if/else branches must use unique keys.`,
    [30]: `v-else/v-else-if has no adjacent v-if or v-else-if.`,
    [31]: `v-for is missing expression.`,
    [32]: `v-for has invalid expression.`,
    [33]: `<template v-for> key should be placed on the <template> tag.`,
    [34]: `v-bind is missing expression.`,
    [52]: `v-bind with same-name shorthand only allows static argument.`,
    [35]: `v-on is missing expression.`,
    [36]: `Unexpected custom directive on <slot> outlet.`,
    [37]: `Mixed v-slot usage on both the component and nested <template>. When there are multiple named slots, all slots should use <template> syntax to avoid scope ambiguity.`,
    [38]: `Duplicate slot names found. `,
    [39]: `Extraneous children found when component already has explicitly named default slot. These children will be ignored.`,
    [40]: `v-slot can only be used on components or <template> tags.`,
    [41]: `v-model is missing expression.`,
    [42]: `v-model value must be a valid JavaScript member expression.`,
    [43]: `v-model cannot be used on v-for or v-slot scope variables because they are not writable.`,
    [44]: `v-model cannot be used on a prop, because local prop bindings are not writable.
Use a v-bind binding combined with a v-on listener that emits update:x event instead.`,
    [45]: `Error parsing JavaScript expression: `,
    [46]: `<KeepAlive> expects exactly one child component.`,
    [51]: `@vnode-* hooks in templates are no longer supported. Use the vue: prefix instead. For example, @vnode-mounted should be changed to @vue:mounted. @vnode-* hooks support has been removed in 3.4.`,
    // generic errors
    [47]: `"prefixIdentifiers" option is not supported in this build of compiler.`,
    [48]: `ES module mode is not supported in this build of compiler.`,
    [49]: `"cacheHandlers" option is only supported when the "prefixIdentifiers" option is enabled.`,
    [50]: `"scopeId" option is only supported in module mode.`,
    // just to fulfill types
    [53]: ``
};
function walkIdentifiers(root, onIdentifier, includeAll = false, parentStack = [], knownIds = /* @__PURE__ */ Object.create(null)) {
    return;
}
function isReferencedIdentifier(id, parent, parentStack) {
    return false;
}
function isInDestructureAssignment(parent, parentStack) {
    if (parent && (parent.type === "ObjectProperty" || parent.type === "ArrayPattern")) {
        let i = parentStack.length;
        while(i--){
            const p = parentStack[i];
            if (p.type === "AssignmentExpression") return true;
            else if (p.type !== "ObjectProperty" && !p.type.endsWith("Pattern")) break;
        }
    }
    return false;
}
function isInNewExpression(parentStack) {
    let i = parentStack.length;
    while(i--){
        const p = parentStack[i];
        if (p.type === "NewExpression") return true;
        else if (p.type !== "MemberExpression") break;
    }
    return false;
}
function walkFunctionParams(node, onIdent) {
    for (const p of node.params)for (const id of extractIdentifiers(p))onIdent(id);
}
function walkBlockDeclarations(block, onIdent) {
    for (const stmt of block.body){
        if (stmt.type === "VariableDeclaration") {
            if (stmt.declare) continue;
            for (const decl of stmt.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
        } else if (stmt.type === "FunctionDeclaration" || stmt.type === "ClassDeclaration") {
            if (stmt.declare || !stmt.id) continue;
            onIdent(stmt.id);
        } else if (isForStatement(stmt)) walkForStatement(stmt, true, onIdent);
    }
}
function isForStatement(stmt) {
    return stmt.type === "ForOfStatement" || stmt.type === "ForInStatement" || stmt.type === "ForStatement";
}
function walkForStatement(stmt, isVar, onIdent) {
    const variable = stmt.type === "ForStatement" ? stmt.init : stmt.left;
    if (variable && variable.type === "VariableDeclaration" && (variable.kind === "var" ? isVar : !isVar)) {
        for (const decl of variable.declarations)for (const id of extractIdentifiers(decl.id))onIdent(id);
    }
}
function extractIdentifiers(param, nodes = []) {
    switch(param.type){
        case "Identifier":
            nodes.push(param);
            break;
        case "MemberExpression":
            let object = param;
            while(object.type === "MemberExpression")object = object.object;
            nodes.push(object);
            break;
        case "ObjectPattern":
            for (const prop of param.properties)if (prop.type === "RestElement") extractIdentifiers(prop.argument, nodes);
            else extractIdentifiers(prop.value, nodes);
            break;
        case "ArrayPattern":
            param.elements.forEach((element)=>{
                if (element) extractIdentifiers(element, nodes);
            });
            break;
        case "RestElement":
            extractIdentifiers(param.argument, nodes);
            break;
        case "AssignmentPattern":
            extractIdentifiers(param.left, nodes);
            break;
    }
    return nodes;
}
const isFunctionType = (node)=>{
    return /Function(?:Expression|Declaration)$|Method$/.test(node.type);
};
const isStaticProperty = (node)=>node && (node.type === "ObjectProperty" || node.type === "ObjectMethod") && !node.computed;
const isStaticPropertyKey = (node, parent)=>isStaticProperty(parent) && parent.key === node;
const TS_NODE_TYPES = [
    "TSAsExpression",
    // foo as number
    "TSTypeAssertion",
    // (<number>foo)
    "TSNonNullExpression",
    // foo!
    "TSInstantiationExpression",
    // foo<string>
    "TSSatisfiesExpression"
];
function unwrapTSNode(node) {
    if (TS_NODE_TYPES.includes(node.type)) return unwrapTSNode(node.expression);
    else return node;
}
const isStaticExp = (p)=>p.type === 4 && p.isStatic;
function isCoreComponent(tag) {
    switch(tag){
        case "Teleport":
        case "teleport":
            return TELEPORT;
        case "Suspense":
        case "suspense":
            return SUSPENSE;
        case "KeepAlive":
        case "keep-alive":
            return KEEP_ALIVE;
        case "BaseTransition":
        case "base-transition":
            return BASE_TRANSITION;
    }
}
const nonIdentifierRE = /^\d|[^\$\w\xA0-\uFFFF]/;
const isSimpleIdentifier = (name)=>!nonIdentifierRE.test(name);
const validFirstIdentCharRE = /[A-Za-z_$\xA0-\uFFFF]/;
const validIdentCharRE = /[\.\?\w$\xA0-\uFFFF]/;
const whitespaceRE = /\s+[.[]\s*|\s*[.[]\s+/g;
const getExpSource = (exp)=>exp.type === 4 ? exp.content : exp.loc.source;
const isMemberExpressionBrowser = (exp)=>{
    const path = getExpSource(exp).trim().replace(whitespaceRE, (s)=>s.trim());
    let state = 0 /* inMemberExp */ ;
    let stateStack = [];
    let currentOpenBracketCount = 0;
    let currentOpenParensCount = 0;
    let currentStringType = null;
    for(let i = 0; i < path.length; i++){
        const char = path.charAt(i);
        switch(state){
            case 0 /* inMemberExp */ :
                if (char === "[") {
                    stateStack.push(state);
                    state = 1 /* inBrackets */ ;
                    currentOpenBracketCount++;
                } else if (char === "(") {
                    stateStack.push(state);
                    state = 2 /* inParens */ ;
                    currentOpenParensCount++;
                } else if (!(i === 0 ? validFirstIdentCharRE : validIdentCharRE).test(char)) return false;
                break;
            case 1 /* inBrackets */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `[`) currentOpenBracketCount++;
                else if (char === `]`) {
                    if (!--currentOpenBracketCount) state = stateStack.pop();
                }
                break;
            case 2 /* inParens */ :
                if (char === `'` || char === `"` || char === "`") {
                    stateStack.push(state);
                    state = 3 /* inString */ ;
                    currentStringType = char;
                } else if (char === `(`) currentOpenParensCount++;
                else if (char === `)`) {
                    if (i === path.length - 1) return false;
                    if (!--currentOpenParensCount) state = stateStack.pop();
                }
                break;
            case 3 /* inString */ :
                if (char === currentStringType) {
                    state = stateStack.pop();
                    currentStringType = null;
                }
                break;
        }
    }
    return !currentOpenBracketCount && !currentOpenParensCount;
};
const isMemberExpressionNode = (0, _shared.NOOP);
const isMemberExpression = isMemberExpressionBrowser;
const fnExpRE = /^\s*(async\s*)?(\([^)]*?\)|[\w$_]+)\s*(:[^=]+)?=>|^\s*(async\s+)?function(?:\s+[\w$]+)?\s*\(/;
const isFnExpressionBrowser = (exp)=>fnExpRE.test(getExpSource(exp));
const isFnExpressionNode = (0, _shared.NOOP);
const isFnExpression = isFnExpressionBrowser;
function advancePositionWithClone(pos, source, numberOfCharacters = source.length) {
    return advancePositionWithMutation({
        offset: pos.offset,
        line: pos.line,
        column: pos.column
    }, source, numberOfCharacters);
}
function advancePositionWithMutation(pos, source, numberOfCharacters = source.length) {
    let linesCount = 0;
    let lastNewLinePos = -1;
    for(let i = 0; i < numberOfCharacters; i++)if (source.charCodeAt(i) === 10) {
        linesCount++;
        lastNewLinePos = i;
    }
    pos.offset += numberOfCharacters;
    pos.line += linesCount;
    pos.column = lastNewLinePos === -1 ? pos.column + numberOfCharacters : numberOfCharacters - lastNewLinePos;
    return pos;
}
function assert(condition, msg) {
    if (!condition) throw new Error(msg || `unexpected compiler condition`);
}
function findDir(node, name, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 7 && (allowEmpty || p.exp) && ((0, _shared.isString)(name) ? p.name === name : name.test(p.name))) return p;
    }
}
function findProp(node, name, dynamicOnly = false, allowEmpty = false) {
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (dynamicOnly) continue;
            if (p.name === name && (p.value || allowEmpty)) return p;
        } else if (p.name === "bind" && (p.exp || allowEmpty) && isStaticArgOf(p.arg, name)) return p;
    }
}
function isStaticArgOf(arg, name) {
    return !!(arg && isStaticExp(arg) && arg.content === name);
}
function hasDynamicKeyVBind(node) {
    return node.props.some((p)=>p.type === 7 && p.name === "bind" && (!p.arg || // v-bind="obj"
        p.arg.type !== 4 || // v-bind:[_ctx.foo]
        !p.arg.isStatic));
}
function isText$1(node) {
    return node.type === 5 || node.type === 2;
}
function isVSlot(p) {
    return p.type === 7 && p.name === "slot";
}
function isTemplateNode(node) {
    return node.type === 1 && node.tagType === 3;
}
function isSlotOutlet(node) {
    return node.type === 1 && node.tagType === 2;
}
const propsHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getUnnormalizedProps(props, callPath = []) {
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const callee = props.callee;
        if (!(0, _shared.isString)(callee) && propsHelperSet.has(callee)) return getUnnormalizedProps(props.arguments[0], callPath.concat(props));
    }
    return [
        props,
        callPath
    ];
}
function injectProp(node, prop, context) {
    let propsWithInjection;
    let props = node.type === 13 ? node.props : node.arguments[2];
    let callPath = [];
    let parentCall;
    if (props && !(0, _shared.isString)(props) && props.type === 14) {
        const ret = getUnnormalizedProps(props);
        props = ret[0];
        callPath = ret[1];
        parentCall = callPath[callPath.length - 1];
    }
    if (props == null || (0, _shared.isString)(props)) propsWithInjection = createObjectExpression([
        prop
    ]);
    else if (props.type === 14) {
        const first = props.arguments[0];
        if (!(0, _shared.isString)(first) && first.type === 15) {
            if (!hasProp(prop, first)) first.properties.unshift(prop);
        } else if (props.callee === TO_HANDLERS) propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        else props.arguments.unshift(createObjectExpression([
            prop
        ]));
        !propsWithInjection && (propsWithInjection = props);
    } else if (props.type === 15) {
        if (!hasProp(prop, props)) props.properties.unshift(prop);
        propsWithInjection = props;
    } else {
        propsWithInjection = createCallExpression(context.helper(MERGE_PROPS), [
            createObjectExpression([
                prop
            ]),
            props
        ]);
        if (parentCall && parentCall.callee === GUARD_REACTIVE_PROPS) parentCall = callPath[callPath.length - 2];
    }
    if (node.type === 13) {
        if (parentCall) parentCall.arguments[0] = propsWithInjection;
        else node.props = propsWithInjection;
    } else if (parentCall) parentCall.arguments[0] = propsWithInjection;
    else node.arguments[2] = propsWithInjection;
}
function hasProp(prop, props) {
    let result = false;
    if (prop.key.type === 4) {
        const propKeyName = prop.key.content;
        result = props.properties.some((p)=>p.key.type === 4 && p.key.content === propKeyName);
    }
    return result;
}
function toValidAssetId(name, type) {
    return `_${type}_${name.replace(/[^\w]/g, (searchValue, replaceValue)=>{
        return searchValue === "-" ? "_" : name.charCodeAt(replaceValue).toString();
    })}`;
}
function hasScopeRef(node, ids) {
    if (!node || Object.keys(ids).length === 0) return false;
    switch(node.type){
        case 1:
            for(let i = 0; i < node.props.length; i++){
                const p = node.props[i];
                if (p.type === 7 && (hasScopeRef(p.arg, ids) || hasScopeRef(p.exp, ids))) return true;
            }
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 11:
            if (hasScopeRef(node.source, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 9:
            return node.branches.some((b)=>hasScopeRef(b, ids));
        case 10:
            if (hasScopeRef(node.condition, ids)) return true;
            return node.children.some((c)=>hasScopeRef(c, ids));
        case 4:
            return !node.isStatic && isSimpleIdentifier(node.content) && !!ids[node.content];
        case 8:
            return node.children.some((c)=>(0, _shared.isObject)(c) && hasScopeRef(c, ids));
        case 5:
        case 12:
            return hasScopeRef(node.content, ids);
        case 2:
        case 3:
            return false;
        default:
            return false;
    }
}
function getMemoedVNodeCall(node) {
    if (node.type === 14 && node.callee === WITH_MEMO) return node.arguments[1].returns;
    else return node;
}
const forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+(\S[\s\S]*)/;
const defaultParserOptions = {
    parseMode: "base",
    ns: 0,
    delimiters: [
        `{{`,
        `}}`
    ],
    getNamespace: ()=>0,
    isVoidTag: (0, _shared.NO),
    isPreTag: (0, _shared.NO),
    isCustomElement: (0, _shared.NO),
    onError: defaultOnError,
    onWarn: defaultOnWarn,
    comments: false,
    prefixIdentifiers: false
};
let currentOptions = defaultParserOptions;
let currentRoot = null;
let currentInput = "";
let currentOpenTag = null;
let currentProp = null;
let currentAttrValue = "";
let currentAttrStartIndex = -1;
let currentAttrEndIndex = -1;
let inPre = 0;
let inVPre = false;
let currentVPreBoundary = null;
const stack = [];
const tokenizer = new Tokenizer(stack, {
    onerr: emitError,
    ontext (start, end) {
        onText(getSlice(start, end), start, end);
    },
    ontextentity (char, start, end) {
        onText(char, start, end);
    },
    oninterpolation (start, end) {
        if (inVPre) return onText(getSlice(start, end), start, end);
        let innerStart = start + tokenizer.delimiterOpen.length;
        let innerEnd = end - tokenizer.delimiterClose.length;
        while(isWhitespace(currentInput.charCodeAt(innerStart)))innerStart++;
        while(isWhitespace(currentInput.charCodeAt(innerEnd - 1)))innerEnd--;
        let exp = getSlice(innerStart, innerEnd);
        if (exp.includes("&")) exp = currentOptions.decodeEntities(exp, false);
        addNode({
            type: 5,
            content: createExp(exp, false, getLoc(innerStart, innerEnd)),
            loc: getLoc(start, end)
        });
    },
    onopentagname (start, end) {
        const name = getSlice(start, end);
        currentOpenTag = {
            type: 1,
            tag: name,
            ns: currentOptions.getNamespace(name, stack[0], currentOptions.ns),
            tagType: 0,
            // will be refined on tag close
            props: [],
            children: [],
            loc: getLoc(start - 1, end),
            codegenNode: void 0
        };
    },
    onopentagend (end) {
        endOpenTag(end);
    },
    onclosetag (start, end) {
        const name = getSlice(start, end);
        if (!currentOptions.isVoidTag(name)) {
            let found = false;
            for(let i = 0; i < stack.length; i++){
                const e = stack[i];
                if (e.tag.toLowerCase() === name.toLowerCase()) {
                    found = true;
                    if (i > 0) emitError(24, stack[0].loc.start.offset);
                    for(let j = 0; j <= i; j++){
                        const el = stack.shift();
                        onCloseTag(el, end, j < i);
                    }
                    break;
                }
            }
            if (!found) emitError(23, backTrack(start, 60));
        }
    },
    onselfclosingtag (end) {
        const name = currentOpenTag.tag;
        currentOpenTag.isSelfClosing = true;
        endOpenTag(end);
        if (stack[0] && stack[0].tag === name) onCloseTag(stack.shift(), end);
    },
    onattribname (start, end) {
        currentProp = {
            type: 6,
            name: getSlice(start, end),
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
    },
    ondirname (start, end) {
        const raw = getSlice(start, end);
        const name = raw === "." || raw === ":" ? "bind" : raw === "@" ? "on" : raw === "#" ? "slot" : raw.slice(2);
        if (!inVPre && name === "") emitError(26, start);
        if (inVPre || name === "") currentProp = {
            type: 6,
            name: raw,
            nameLoc: getLoc(start, end),
            value: void 0,
            loc: getLoc(start)
        };
        else {
            currentProp = {
                type: 7,
                name,
                rawName: raw,
                exp: void 0,
                arg: void 0,
                modifiers: raw === "." ? [
                    "prop"
                ] : [],
                loc: getLoc(start)
            };
            if (name === "pre") {
                inVPre = tokenizer.inVPre = true;
                currentVPreBoundary = currentOpenTag;
                const props = currentOpenTag.props;
                for(let i = 0; i < props.length; i++)if (props[i].type === 7) props[i] = dirToAttr(props[i]);
            }
        }
    },
    ondirarg (start, end) {
        if (start === end) return;
        const arg = getSlice(start, end);
        if (inVPre) {
            currentProp.name += arg;
            setLocEnd(currentProp.nameLoc, end);
        } else {
            const isStatic = arg[0] !== `[`;
            currentProp.arg = createExp(isStatic ? arg : arg.slice(1, -1), isStatic, getLoc(start, end), isStatic ? 3 : 0);
        }
    },
    ondirmodifier (start, end) {
        const mod = getSlice(start, end);
        if (inVPre) {
            currentProp.name += "." + mod;
            setLocEnd(currentProp.nameLoc, end);
        } else if (currentProp.name === "slot") {
            const arg = currentProp.arg;
            if (arg) {
                arg.content += "." + mod;
                setLocEnd(arg.loc, end);
            }
        } else currentProp.modifiers.push(mod);
    },
    onattribdata (start, end) {
        currentAttrValue += getSlice(start, end);
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribentity (char, start, end) {
        currentAttrValue += char;
        if (currentAttrStartIndex < 0) currentAttrStartIndex = start;
        currentAttrEndIndex = end;
    },
    onattribnameend (end) {
        const start = currentProp.loc.start.offset;
        const name = getSlice(start, end);
        if (currentProp.type === 7) currentProp.rawName = name;
        if (currentOpenTag.props.some((p)=>(p.type === 7 ? p.rawName : p.name) === name)) emitError(2, start);
    },
    onattribend (quote, end) {
        if (currentOpenTag && currentProp) {
            setLocEnd(currentProp.loc, end);
            if (quote !== 0) {
                if (currentAttrValue.includes("&")) currentAttrValue = currentOptions.decodeEntities(currentAttrValue, true);
                if (currentProp.type === 6) {
                    if (currentProp.name === "class") currentAttrValue = condense(currentAttrValue).trim();
                    if (quote === 1 && !currentAttrValue) emitError(13, end);
                    currentProp.value = {
                        type: 2,
                        content: currentAttrValue,
                        loc: quote === 1 ? getLoc(currentAttrStartIndex, currentAttrEndIndex) : getLoc(currentAttrStartIndex - 1, currentAttrEndIndex + 1)
                    };
                    if (tokenizer.inSFCRoot && currentOpenTag.tag === "template" && currentProp.name === "lang" && currentAttrValue && currentAttrValue !== "html") tokenizer.enterRCDATA(toCharCodes(`</template`), 0);
                } else {
                    let expParseMode = 0 /* Normal */ ;
                    currentProp.exp = createExp(currentAttrValue, false, getLoc(currentAttrStartIndex, currentAttrEndIndex), 0, expParseMode);
                    if (currentProp.name === "for") currentProp.forParseResult = parseForExpression(currentProp.exp);
                    let syncIndex = -1;
                    if (currentProp.name === "bind" && (syncIndex = currentProp.modifiers.indexOf("sync")) > -1 && checkCompatEnabled("COMPILER_V_BIND_SYNC", currentOptions, currentProp.loc, currentProp.rawName)) {
                        currentProp.name = "model";
                        currentProp.modifiers.splice(syncIndex, 1);
                    }
                }
            }
            if (currentProp.type !== 7 || currentProp.name !== "pre") currentOpenTag.props.push(currentProp);
        }
        currentAttrValue = "";
        currentAttrStartIndex = currentAttrEndIndex = -1;
    },
    oncomment (start, end) {
        if (currentOptions.comments) addNode({
            type: 3,
            content: getSlice(start, end),
            loc: getLoc(start - 4, end + 3)
        });
    },
    onend () {
        const end = currentInput.length;
        for(let index = 0; index < stack.length; index++){
            onCloseTag(stack[index], end - 1);
            emitError(24, stack[index].loc.start.offset);
        }
    },
    oncdata (start, end) {
        if (stack[0].ns !== 0) onText(getSlice(start, end), start, end);
        else emitError(1, start - 9);
    },
    onprocessinginstruction (start) {
        if ((stack[0] ? stack[0].ns : currentOptions.ns) === 0) emitError(21, start - 1);
    }
});
const forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
const stripParensRE = /^\(|\)$/g;
function parseForExpression(input) {
    const loc = input.loc;
    const exp = input.content;
    const inMatch = exp.match(forAliasRE);
    if (!inMatch) return;
    const [, LHS, RHS] = inMatch;
    const createAliasExpression = (content, offset, asParam = false)=>{
        const start = loc.start.offset + offset;
        const end = start + content.length;
        return createExp(content, false, getLoc(start, end), 0, asParam ? 1 /* Params */  : 0 /* Normal */ );
    };
    const result = {
        source: createAliasExpression(RHS.trim(), exp.indexOf(RHS, LHS.length)),
        value: void 0,
        key: void 0,
        index: void 0,
        finalized: false
    };
    let valueContent = LHS.trim().replace(stripParensRE, "").trim();
    const trimmedOffset = LHS.indexOf(valueContent);
    const iteratorMatch = valueContent.match(forIteratorRE);
    if (iteratorMatch) {
        valueContent = valueContent.replace(forIteratorRE, "").trim();
        const keyContent = iteratorMatch[1].trim();
        let keyOffset;
        if (keyContent) {
            keyOffset = exp.indexOf(keyContent, trimmedOffset + valueContent.length);
            result.key = createAliasExpression(keyContent, keyOffset, true);
        }
        if (iteratorMatch[2]) {
            const indexContent = iteratorMatch[2].trim();
            if (indexContent) result.index = createAliasExpression(indexContent, exp.indexOf(indexContent, result.key ? keyOffset + keyContent.length : trimmedOffset + valueContent.length), true);
        }
    }
    if (valueContent) result.value = createAliasExpression(valueContent, trimmedOffset, true);
    return result;
}
function getSlice(start, end) {
    return currentInput.slice(start, end);
}
function endOpenTag(end) {
    if (tokenizer.inSFCRoot) currentOpenTag.innerLoc = getLoc(end + 1, end + 1);
    addNode(currentOpenTag);
    const { tag, ns } = currentOpenTag;
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre++;
    if (currentOptions.isVoidTag(tag)) onCloseTag(currentOpenTag, end);
    else {
        stack.unshift(currentOpenTag);
        if (ns === 1 || ns === 2) tokenizer.inXML = true;
    }
    currentOpenTag = null;
}
function onText(content, start, end) {
    {
        const tag = stack[0] && stack[0].tag;
        if (tag !== "script" && tag !== "style" && content.includes("&")) content = currentOptions.decodeEntities(content, false);
    }
    const parent = stack[0] || currentRoot;
    const lastNode = parent.children[parent.children.length - 1];
    if (lastNode && lastNode.type === 2) {
        lastNode.content += content;
        setLocEnd(lastNode.loc, end);
    } else parent.children.push({
        type: 2,
        content,
        loc: getLoc(start, end)
    });
}
function onCloseTag(el, end, isImplied = false) {
    if (isImplied) setLocEnd(el.loc, backTrack(end, 60));
    else setLocEnd(el.loc, lookAhead(end, 62) + 1);
    if (tokenizer.inSFCRoot) {
        if (el.children.length) el.innerLoc.end = (0, _shared.extend)({}, el.children[el.children.length - 1].loc.end);
        else el.innerLoc.end = (0, _shared.extend)({}, el.innerLoc.start);
        el.innerLoc.source = getSlice(el.innerLoc.start.offset, el.innerLoc.end.offset);
    }
    const { tag, ns } = el;
    if (!inVPre) {
        if (tag === "slot") el.tagType = 2;
        else if (isFragmentTemplate(el)) el.tagType = 3;
        else if (isComponent(el)) el.tagType = 1;
    }
    if (!tokenizer.inRCDATA) el.children = condenseWhitespace(el.children, el.tag);
    if (ns === 0 && currentOptions.isPreTag(tag)) inPre--;
    if (currentVPreBoundary === el) {
        inVPre = tokenizer.inVPre = false;
        currentVPreBoundary = null;
    }
    if (tokenizer.inXML && (stack[0] ? stack[0].ns : currentOptions.ns) === 0) tokenizer.inXML = false;
    {
        const props = el.props;
        if (!tokenizer.inSFCRoot && isCompatEnabled("COMPILER_NATIVE_TEMPLATE", currentOptions) && el.tag === "template" && !isFragmentTemplate(el)) {
            const parent = stack[0] || currentRoot;
            const index = parent.children.indexOf(el);
            parent.children.splice(index, 1, ...el.children);
        }
        const inlineTemplateProp = props.find((p)=>p.type === 6 && p.name === "inline-template");
        if (inlineTemplateProp && checkCompatEnabled("COMPILER_INLINE_TEMPLATE", currentOptions, inlineTemplateProp.loc) && el.children.length) inlineTemplateProp.value = {
            type: 2,
            content: getSlice(el.children[0].loc.start.offset, el.children[el.children.length - 1].loc.end.offset),
            loc: inlineTemplateProp.loc
        };
    }
}
function lookAhead(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i < currentInput.length - 1)i++;
    return i;
}
function backTrack(index, c) {
    let i = index;
    while(currentInput.charCodeAt(i) !== c && i >= 0)i--;
    return i;
}
const specialTemplateDir = /* @__PURE__ */ new Set([
    "if",
    "else",
    "else-if",
    "for",
    "slot"
]);
function isFragmentTemplate({ tag, props }) {
    if (tag === "template") for(let i = 0; i < props.length; i++){
        if (props[i].type === 7 && specialTemplateDir.has(props[i].name)) return true;
    }
    return false;
}
function isComponent({ tag, props }) {
    if (currentOptions.isCustomElement(tag)) return false;
    if (tag === "component" || isUpperCase(tag.charCodeAt(0)) || isCoreComponent(tag) || currentOptions.isBuiltInComponent && currentOptions.isBuiltInComponent(tag) || currentOptions.isNativeTag && !currentOptions.isNativeTag(tag)) return true;
    for(let i = 0; i < props.length; i++){
        const p = props[i];
        if (p.type === 6) {
            if (p.name === "is" && p.value) {
                if (p.value.content.startsWith("vue:")) return true;
                else if (checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "is") && checkCompatEnabled("COMPILER_IS_ON_ELEMENT", currentOptions, p.loc)) return true;
    }
    return false;
}
function isUpperCase(c) {
    return c > 64 && c < 91;
}
const windowsNewlineRE = /\r\n/g;
function condenseWhitespace(nodes, tag) {
    const shouldCondense = currentOptions.whitespace !== "preserve";
    let removedWhitespace = false;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (node.type === 2) {
            if (!inPre) {
                if (isAllWhitespace(node.content)) {
                    const prev = nodes[i - 1] && nodes[i - 1].type;
                    const next = nodes[i + 1] && nodes[i + 1].type;
                    if (!prev || !next || shouldCondense && (prev === 3 && (next === 3 || next === 1) || prev === 1 && (next === 3 || next === 1 && hasNewlineChar(node.content)))) {
                        removedWhitespace = true;
                        nodes[i] = null;
                    } else node.content = " ";
                } else if (shouldCondense) node.content = condense(node.content);
            } else node.content = node.content.replace(windowsNewlineRE, "\n");
        }
    }
    if (inPre && tag && currentOptions.isPreTag(tag)) {
        const first = nodes[0];
        if (first && first.type === 2) first.content = first.content.replace(/^\r?\n/, "");
    }
    return removedWhitespace ? nodes.filter(Boolean) : nodes;
}
function isAllWhitespace(str) {
    for(let i = 0; i < str.length; i++){
        if (!isWhitespace(str.charCodeAt(i))) return false;
    }
    return true;
}
function hasNewlineChar(str) {
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c === 10 || c === 13) return true;
    }
    return false;
}
function condense(str) {
    let ret = "";
    let prevCharIsWhitespace = false;
    for(let i = 0; i < str.length; i++){
        if (isWhitespace(str.charCodeAt(i))) {
            if (!prevCharIsWhitespace) {
                ret += " ";
                prevCharIsWhitespace = true;
            }
        } else {
            ret += str[i];
            prevCharIsWhitespace = false;
        }
    }
    return ret;
}
function addNode(node) {
    (stack[0] || currentRoot).children.push(node);
}
function getLoc(start, end) {
    return {
        start: tokenizer.getPos(start),
        // @ts-expect-error allow late attachment
        end: end == null ? end : tokenizer.getPos(end),
        // @ts-expect-error allow late attachment
        source: end == null ? end : getSlice(start, end)
    };
}
function setLocEnd(loc, end) {
    loc.end = tokenizer.getPos(end);
    loc.source = getSlice(loc.start.offset, end);
}
function dirToAttr(dir) {
    const attr = {
        type: 6,
        name: dir.rawName,
        nameLoc: getLoc(dir.loc.start.offset, dir.loc.start.offset + dir.rawName.length),
        value: void 0,
        loc: dir.loc
    };
    if (dir.exp) {
        const loc = dir.exp.loc;
        if (loc.end.offset < dir.loc.end.offset) {
            loc.start.offset--;
            loc.start.column--;
            loc.end.offset++;
            loc.end.column++;
        }
        attr.value = {
            type: 2,
            content: dir.exp.content,
            loc
        };
    }
    return attr;
}
function createExp(content, isStatic = false, loc, constType = 0, parseMode = 0 /* Normal */ ) {
    const exp = createSimpleExpression(content, isStatic, loc, constType);
    return exp;
}
function emitError(code, index, message) {
    currentOptions.onError(createCompilerError(code, getLoc(index, index), void 0, message));
}
function reset() {
    tokenizer.reset();
    currentOpenTag = null;
    currentProp = null;
    currentAttrValue = "";
    currentAttrStartIndex = -1;
    currentAttrEndIndex = -1;
    stack.length = 0;
}
function baseParse(input, options) {
    reset();
    currentInput = input;
    currentOptions = (0, _shared.extend)({}, defaultParserOptions);
    if (options) {
        let key;
        for(key in options)if (options[key] != null) currentOptions[key] = options[key];
    }
    tokenizer.mode = currentOptions.parseMode === "html" ? 1 : currentOptions.parseMode === "sfc" ? 2 : 0;
    tokenizer.inXML = currentOptions.ns === 1 || currentOptions.ns === 2;
    const delimiters = options && options.delimiters;
    if (delimiters) {
        tokenizer.delimiterOpen = toCharCodes(delimiters[0]);
        tokenizer.delimiterClose = toCharCodes(delimiters[1]);
    }
    const root = currentRoot = createRoot([], input);
    tokenizer.parse(currentInput);
    root.loc = getLoc(0, input.length);
    root.children = condenseWhitespace(root.children);
    currentRoot = null;
    return root;
}
function hoistStatic(root, context) {
    walk(root, context, // Root node is unfortunately non-hoistable due to potential parent
    // fallthrough attributes.
    isSingleElementRoot(root, root.children[0]));
}
function isSingleElementRoot(root, child) {
    const { children } = root;
    return children.length === 1 && child.type === 1 && !isSlotOutlet(child);
}
function walk(node, context, doNotHoistNode = false) {
    const { children } = node;
    const originalCount = children.length;
    let hoistedCount = 0;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (child.type === 1 && child.tagType === 0) {
            const constantType = doNotHoistNode ? 0 : getConstantType(child, context);
            if (constantType > 0) {
                if (constantType >= 2) {
                    child.codegenNode.patchFlag = -1;
                    child.codegenNode = context.hoist(child.codegenNode);
                    hoistedCount++;
                    continue;
                }
            } else {
                const codegenNode = child.codegenNode;
                if (codegenNode.type === 13) {
                    const flag = codegenNode.patchFlag;
                    if ((flag === void 0 || flag === 512 || flag === 1) && getGeneratedPropsConstantType(child, context) >= 2) {
                        const props = getNodeProps(child);
                        if (props) codegenNode.props = context.hoist(props);
                    }
                    if (codegenNode.dynamicProps) codegenNode.dynamicProps = context.hoist(codegenNode.dynamicProps);
                }
            }
        }
        if (child.type === 1) {
            const isComponent = child.tagType === 1;
            if (isComponent) context.scopes.vSlot++;
            walk(child, context);
            if (isComponent) context.scopes.vSlot--;
        } else if (child.type === 11) walk(child, context, child.children.length === 1);
        else if (child.type === 9) for(let i2 = 0; i2 < child.branches.length; i2++)walk(child.branches[i2], context, child.branches[i2].children.length === 1);
    }
    if (hoistedCount && context.transformHoist) context.transformHoist(children, context, node);
    if (hoistedCount && hoistedCount === originalCount && node.type === 1 && node.tagType === 0 && node.codegenNode && node.codegenNode.type === 13 && (0, _shared.isArray)(node.codegenNode.children)) {
        const hoisted = context.hoist(createArrayExpression(node.codegenNode.children));
        if (context.hmr) hoisted.content = `[...${hoisted.content}]`;
        node.codegenNode.children = hoisted;
    }
}
function getConstantType(node, context) {
    const { constantCache } = context;
    switch(node.type){
        case 1:
            if (node.tagType !== 0) return 0;
            const cached = constantCache.get(node);
            if (cached !== void 0) return cached;
            const codegenNode = node.codegenNode;
            if (codegenNode.type !== 13) return 0;
            if (codegenNode.isBlock && node.tag !== "svg" && node.tag !== "foreignObject" && node.tag !== "math") return 0;
            if (codegenNode.patchFlag === void 0) {
                let returnType2 = 3;
                const generatedPropsType = getGeneratedPropsConstantType(node, context);
                if (generatedPropsType === 0) {
                    constantCache.set(node, 0);
                    return 0;
                }
                if (generatedPropsType < returnType2) returnType2 = generatedPropsType;
                for(let i = 0; i < node.children.length; i++){
                    const childType = getConstantType(node.children[i], context);
                    if (childType === 0) {
                        constantCache.set(node, 0);
                        return 0;
                    }
                    if (childType < returnType2) returnType2 = childType;
                }
                if (returnType2 > 1) for(let i = 0; i < node.props.length; i++){
                    const p = node.props[i];
                    if (p.type === 7 && p.name === "bind" && p.exp) {
                        const expType = getConstantType(p.exp, context);
                        if (expType === 0) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                        if (expType < returnType2) returnType2 = expType;
                    }
                }
                if (codegenNode.isBlock) {
                    for(let i = 0; i < node.props.length; i++){
                        const p = node.props[i];
                        if (p.type === 7) {
                            constantCache.set(node, 0);
                            return 0;
                        }
                    }
                    context.removeHelper(OPEN_BLOCK);
                    context.removeHelper(getVNodeBlockHelper(context.inSSR, codegenNode.isComponent));
                    codegenNode.isBlock = false;
                    context.helper(getVNodeHelper(context.inSSR, codegenNode.isComponent));
                }
                constantCache.set(node, returnType2);
                return returnType2;
            } else {
                constantCache.set(node, 0);
                return 0;
            }
        case 2:
        case 3:
            return 3;
        case 9:
        case 11:
        case 10:
            return 0;
        case 5:
        case 12:
            return getConstantType(node.content, context);
        case 4:
            return node.constType;
        case 8:
            let returnType = 3;
            for(let i = 0; i < node.children.length; i++){
                const child = node.children[i];
                if ((0, _shared.isString)(child) || (0, _shared.isSymbol)(child)) continue;
                const childType = getConstantType(child, context);
                if (childType === 0) return 0;
                else if (childType < returnType) returnType = childType;
            }
            return returnType;
        default:
            return 0;
    }
}
const allowHoistedHelperSet = /* @__PURE__ */ new Set([
    NORMALIZE_CLASS,
    NORMALIZE_STYLE,
    NORMALIZE_PROPS,
    GUARD_REACTIVE_PROPS
]);
function getConstantTypeOfHelperCall(value, context) {
    if (value.type === 14 && !(0, _shared.isString)(value.callee) && allowHoistedHelperSet.has(value.callee)) {
        const arg = value.arguments[0];
        if (arg.type === 4) return getConstantType(arg, context);
        else if (arg.type === 14) return getConstantTypeOfHelperCall(arg, context);
    }
    return 0;
}
function getGeneratedPropsConstantType(node, context) {
    let returnType = 3;
    const props = getNodeProps(node);
    if (props && props.type === 15) {
        const { properties } = props;
        for(let i = 0; i < properties.length; i++){
            const { key, value } = properties[i];
            const keyType = getConstantType(key, context);
            if (keyType === 0) return keyType;
            if (keyType < returnType) returnType = keyType;
            let valueType;
            if (value.type === 4) valueType = getConstantType(value, context);
            else if (value.type === 14) valueType = getConstantTypeOfHelperCall(value, context);
            else valueType = 0;
            if (valueType === 0) return valueType;
            if (valueType < returnType) returnType = valueType;
        }
    }
    return returnType;
}
function getNodeProps(node) {
    const codegenNode = node.codegenNode;
    if (codegenNode.type === 13) return codegenNode.props;
}
function createTransformContext(root, { filename = "", prefixIdentifiers = false, hoistStatic: hoistStatic2 = false, hmr = false, cacheHandlers = false, nodeTransforms = [], directiveTransforms = {}, transformHoist = null, isBuiltInComponent = (0, _shared.NOOP), isCustomElement = (0, _shared.NOOP), expressionPlugins = [], scopeId = null, slotted = true, ssr = false, inSSR = false, ssrCssVars = ``, bindingMetadata = (0, _shared.EMPTY_OBJ), inline = false, isTS = false, onError = defaultOnError, onWarn = defaultOnWarn, compatConfig }) {
    const nameMatch = filename.replace(/\?.*$/, "").match(/([^/\\]+)\.\w+$/);
    const context = {
        // options
        filename,
        selfName: nameMatch && (0, _shared.capitalize)((0, _shared.camelize)(nameMatch[1])),
        prefixIdentifiers,
        hoistStatic: hoistStatic2,
        hmr,
        cacheHandlers,
        nodeTransforms,
        directiveTransforms,
        transformHoist,
        isBuiltInComponent,
        isCustomElement,
        expressionPlugins,
        scopeId,
        slotted,
        ssr,
        inSSR,
        ssrCssVars,
        bindingMetadata,
        inline,
        isTS,
        onError,
        onWarn,
        compatConfig,
        // state
        root,
        helpers: /* @__PURE__ */ new Map(),
        components: /* @__PURE__ */ new Set(),
        directives: /* @__PURE__ */ new Set(),
        hoists: [],
        imports: [],
        constantCache: /* @__PURE__ */ new WeakMap(),
        temps: 0,
        cached: 0,
        identifiers: /* @__PURE__ */ Object.create(null),
        scopes: {
            vFor: 0,
            vSlot: 0,
            vPre: 0,
            vOnce: 0
        },
        parent: null,
        grandParent: null,
        currentNode: root,
        childIndex: 0,
        inVOnce: false,
        // methods
        helper (name) {
            const count = context.helpers.get(name) || 0;
            context.helpers.set(name, count + 1);
            return name;
        },
        removeHelper (name) {
            const count = context.helpers.get(name);
            if (count) {
                const currentCount = count - 1;
                if (!currentCount) context.helpers.delete(name);
                else context.helpers.set(name, currentCount);
            }
        },
        helperString (name) {
            return `_${helperNameMap[context.helper(name)]}`;
        },
        replaceNode (node) {
            context.parent.children[context.childIndex] = context.currentNode = node;
        },
        removeNode (node) {
            const list = context.parent.children;
            const removalIndex = node ? list.indexOf(node) : context.currentNode ? context.childIndex : -1;
            if (!node || node === context.currentNode) {
                context.currentNode = null;
                context.onNodeRemoved();
            } else if (context.childIndex > removalIndex) {
                context.childIndex--;
                context.onNodeRemoved();
            }
            context.parent.children.splice(removalIndex, 1);
        },
        onNodeRemoved: (0, _shared.NOOP),
        addIdentifiers (exp) {},
        removeIdentifiers (exp) {},
        hoist (exp) {
            if ((0, _shared.isString)(exp)) exp = createSimpleExpression(exp);
            context.hoists.push(exp);
            const identifier = createSimpleExpression(`_hoisted_${context.hoists.length}`, false, exp.loc, 2);
            identifier.hoisted = exp;
            return identifier;
        },
        cache (exp, isVNode = false) {
            return createCacheExpression(context.cached++, exp, isVNode);
        }
    };
    context.filters = /* @__PURE__ */ new Set();
    return context;
}
function transform(root, options) {
    const context = createTransformContext(root, options);
    traverseNode(root, context);
    if (options.hoistStatic) hoistStatic(root, context);
    if (!options.ssr) createRootCodegen(root, context);
    root.helpers = /* @__PURE__ */ new Set([
        ...context.helpers.keys()
    ]);
    root.components = [
        ...context.components
    ];
    root.directives = [
        ...context.directives
    ];
    root.imports = context.imports;
    root.hoists = context.hoists;
    root.temps = context.temps;
    root.cached = context.cached;
    root.transformed = true;
    root.filters = [
        ...context.filters
    ];
}
function createRootCodegen(root, context) {
    const { helper } = context;
    const { children } = root;
    if (children.length === 1) {
        const child = children[0];
        if (isSingleElementRoot(root, child) && child.codegenNode) {
            const codegenNode = child.codegenNode;
            if (codegenNode.type === 13) convertToBlock(codegenNode, context);
            root.codegenNode = codegenNode;
        } else root.codegenNode = child;
    } else if (children.length > 1) {
        let patchFlag = 64;
        let patchFlagText = (0, _shared.PatchFlagNames)[64];
        root.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, root.children, patchFlag, void 0, void 0, true, void 0, false);
    }
}
function traverseChildren(parent, context) {
    let i = 0;
    const nodeRemoved = ()=>{
        i--;
    };
    for(; i < parent.children.length; i++){
        const child = parent.children[i];
        if ((0, _shared.isString)(child)) continue;
        context.grandParent = context.parent;
        context.parent = parent;
        context.childIndex = i;
        context.onNodeRemoved = nodeRemoved;
        traverseNode(child, context);
    }
}
function traverseNode(node, context) {
    context.currentNode = node;
    const { nodeTransforms } = context;
    const exitFns = [];
    for(let i2 = 0; i2 < nodeTransforms.length; i2++){
        const onExit = nodeTransforms[i2](node, context);
        if (onExit) {
            if ((0, _shared.isArray)(onExit)) exitFns.push(...onExit);
            else exitFns.push(onExit);
        }
        if (!context.currentNode) return;
        else node = context.currentNode;
    }
    switch(node.type){
        case 3:
            if (!context.ssr) context.helper(CREATE_COMMENT);
            break;
        case 5:
            if (!context.ssr) context.helper(TO_DISPLAY_STRING);
            break;
        case 9:
            for(let i2 = 0; i2 < node.branches.length; i2++)traverseNode(node.branches[i2], context);
            break;
        case 10:
        case 11:
        case 1:
        case 0:
            traverseChildren(node, context);
            break;
    }
    context.currentNode = node;
    let i = exitFns.length;
    while(i--)exitFns[i]();
}
function createStructuralDirectiveTransform(name, fn) {
    const matches = (0, _shared.isString)(name) ? (n)=>n === name : (n)=>name.test(n);
    return (node, context)=>{
        if (node.type === 1) {
            const { props } = node;
            if (node.tagType === 3 && props.some(isVSlot)) return;
            const exitFns = [];
            for(let i = 0; i < props.length; i++){
                const prop = props[i];
                if (prop.type === 7 && matches(prop.name)) {
                    props.splice(i, 1);
                    i--;
                    const onExit = fn(node, prop, context);
                    if (onExit) exitFns.push(onExit);
                }
            }
            return exitFns;
        }
    };
}
const PURE_ANNOTATION = `/*#__PURE__*/`;
const aliasHelper = (s)=>`${helperNameMap[s]}: _${helperNameMap[s]}`;
function createCodegenContext(ast, { mode = "function", prefixIdentifiers = mode === "module", sourceMap = false, filename = `template.vue.html`, scopeId = null, optimizeImports = false, runtimeGlobalName = `Vue`, runtimeModuleName = `vue`, ssrRuntimeModuleName = "vue/server-renderer", ssr = false, isTS = false, inSSR = false }) {
    const context = {
        mode,
        prefixIdentifiers,
        sourceMap,
        filename,
        scopeId,
        optimizeImports,
        runtimeGlobalName,
        runtimeModuleName,
        ssrRuntimeModuleName,
        ssr,
        isTS,
        inSSR,
        source: ast.source,
        code: ``,
        column: 1,
        line: 1,
        offset: 0,
        indentLevel: 0,
        pure: false,
        map: void 0,
        helper (key) {
            return `_${helperNameMap[key]}`;
        },
        push (code, newlineIndex = -2 /* None */ , node) {
            context.code += code;
        },
        indent () {
            newline(++context.indentLevel);
        },
        deindent (withoutNewLine = false) {
            if (withoutNewLine) --context.indentLevel;
            else newline(--context.indentLevel);
        },
        newline () {
            newline(context.indentLevel);
        }
    };
    function newline(n) {
        context.push("\n" + `  `.repeat(n), 0 /* Start */ );
    }
    return context;
}
function generate(ast, options = {}) {
    const context = createCodegenContext(ast, options);
    if (options.onContextCreated) options.onContextCreated(context);
    const { mode, push, prefixIdentifiers, indent, deindent, newline, scopeId, ssr } = context;
    const helpers = Array.from(ast.helpers);
    const hasHelpers = helpers.length > 0;
    const useWithBlock = !prefixIdentifiers && mode !== "module";
    const preambleContext = context;
    genFunctionPreamble(ast, preambleContext);
    const functionName = ssr ? `ssrRender` : `render`;
    const args = ssr ? [
        "_ctx",
        "_push",
        "_parent",
        "_attrs"
    ] : [
        "_ctx",
        "_cache"
    ];
    const signature = args.join(", ");
    push(`function ${functionName}(${signature}) {`);
    indent();
    if (useWithBlock) {
        push(`with (_ctx) {`);
        indent();
        if (hasHelpers) {
            push(`const { ${helpers.map(aliasHelper).join(", ")} } = _Vue
`, -1 /* End */ );
            newline();
        }
    }
    if (ast.components.length) {
        genAssets(ast.components, "component", context);
        if (ast.directives.length || ast.temps > 0) newline();
    }
    if (ast.directives.length) {
        genAssets(ast.directives, "directive", context);
        if (ast.temps > 0) newline();
    }
    if (ast.filters && ast.filters.length) {
        newline();
        genAssets(ast.filters, "filter", context);
        newline();
    }
    if (ast.temps > 0) {
        push(`let `);
        for(let i = 0; i < ast.temps; i++)push(`${i > 0 ? `, ` : ``}_temp${i}`);
    }
    if (ast.components.length || ast.directives.length || ast.temps) {
        push(`
`, 0 /* Start */ );
        newline();
    }
    if (!ssr) push(`return `);
    if (ast.codegenNode) genNode(ast.codegenNode, context);
    else push(`null`);
    if (useWithBlock) {
        deindent();
        push(`}`);
    }
    deindent();
    push(`}`);
    return {
        ast,
        code: context.code,
        preamble: ``,
        map: context.map ? context.map.toJSON() : void 0
    };
}
function genFunctionPreamble(ast, context) {
    const { ssr, prefixIdentifiers, push, newline, runtimeModuleName, runtimeGlobalName, ssrRuntimeModuleName } = context;
    const VueBinding = runtimeGlobalName;
    const helpers = Array.from(ast.helpers);
    if (helpers.length > 0) {
        push(`const _Vue = ${VueBinding}
`, -1 /* End */ );
        if (ast.hoists.length) {
            const staticHelpers = [
                CREATE_VNODE,
                CREATE_ELEMENT_VNODE,
                CREATE_COMMENT,
                CREATE_TEXT,
                CREATE_STATIC
            ].filter((helper)=>helpers.includes(helper)).map(aliasHelper).join(", ");
            push(`const { ${staticHelpers} } = _Vue
`, -1 /* End */ );
        }
    }
    genHoists(ast.hoists, context);
    newline();
    push(`return `);
}
function genAssets(assets, type, { helper, push, newline, isTS }) {
    const resolver = helper(type === "filter" ? RESOLVE_FILTER : type === "component" ? RESOLVE_COMPONENT : RESOLVE_DIRECTIVE);
    for(let i = 0; i < assets.length; i++){
        let id = assets[i];
        const maybeSelfReference = id.endsWith("__self");
        if (maybeSelfReference) id = id.slice(0, -6);
        push(`const ${toValidAssetId(id, type)} = ${resolver}(${JSON.stringify(id)}${maybeSelfReference ? `, true` : ``})${isTS ? `!` : ``}`);
        if (i < assets.length - 1) newline();
    }
}
function genHoists(hoists, context) {
    if (!hoists.length) return;
    context.pure = true;
    const { push, newline, helper, scopeId, mode } = context;
    newline();
    for(let i = 0; i < hoists.length; i++){
        const exp = hoists[i];
        if (exp) {
            push(`const _hoisted_${i + 1} = ${``}`);
            genNode(exp, context);
            newline();
        }
    }
    context.pure = false;
}
function isText(n) {
    return (0, _shared.isString)(n) || n.type === 4 || n.type === 2 || n.type === 5 || n.type === 8;
}
function genNodeListAsArray(nodes, context) {
    const multilines = nodes.length > 3 || false;
    context.push(`[`);
    multilines && context.indent();
    genNodeList(nodes, context, multilines);
    multilines && context.deindent();
    context.push(`]`);
}
function genNodeList(nodes, context, multilines = false, comma = true) {
    const { push, newline } = context;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if ((0, _shared.isString)(node)) push(node, -3 /* Unknown */ );
        else if ((0, _shared.isArray)(node)) genNodeListAsArray(node, context);
        else genNode(node, context);
        if (i < nodes.length - 1) {
            if (multilines) {
                comma && push(",");
                newline();
            } else comma && push(", ");
        }
    }
}
function genNode(node, context) {
    if ((0, _shared.isString)(node)) {
        context.push(node, -3 /* Unknown */ );
        return;
    }
    if ((0, _shared.isSymbol)(node)) {
        context.push(context.helper(node));
        return;
    }
    switch(node.type){
        case 1:
        case 9:
        case 11:
            genNode(node.codegenNode, context);
            break;
        case 2:
            genText(node, context);
            break;
        case 4:
            genExpression(node, context);
            break;
        case 5:
            genInterpolation(node, context);
            break;
        case 12:
            genNode(node.codegenNode, context);
            break;
        case 8:
            genCompoundExpression(node, context);
            break;
        case 3:
            genComment(node, context);
            break;
        case 13:
            genVNodeCall(node, context);
            break;
        case 14:
            genCallExpression(node, context);
            break;
        case 15:
            genObjectExpression(node, context);
            break;
        case 17:
            genArrayExpression(node, context);
            break;
        case 18:
            genFunctionExpression(node, context);
            break;
        case 19:
            genConditionalExpression(node, context);
            break;
        case 20:
            genCacheExpression(node, context);
            break;
        case 21:
            genNodeList(node.body, context, true, false);
            break;
        case 22:
            break;
        case 23:
            break;
        case 24:
            break;
        case 25:
            break;
        case 26:
            break;
        case 10:
            break;
        default:
    }
}
function genText(node, context) {
    context.push(JSON.stringify(node.content), -3 /* Unknown */ , node);
}
function genExpression(node, context) {
    const { content, isStatic } = node;
    context.push(isStatic ? JSON.stringify(content) : content, -3 /* Unknown */ , node);
}
function genInterpolation(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(TO_DISPLAY_STRING)}(`);
    genNode(node.content, context);
    push(`)`);
}
function genCompoundExpression(node, context) {
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if ((0, _shared.isString)(child)) context.push(child, -3 /* Unknown */ );
        else genNode(child, context);
    }
}
function genExpressionAsPropertyKey(node, context) {
    const { push } = context;
    if (node.type === 8) {
        push(`[`);
        genCompoundExpression(node, context);
        push(`]`);
    } else if (node.isStatic) {
        const text = isSimpleIdentifier(node.content) ? node.content : JSON.stringify(node.content);
        push(text, -2 /* None */ , node);
    } else push(`[${node.content}]`, -3 /* Unknown */ , node);
}
function genComment(node, context) {
    const { push, helper, pure } = context;
    if (pure) push(PURE_ANNOTATION);
    push(`${helper(CREATE_COMMENT)}(${JSON.stringify(node.content)})`, -3 /* Unknown */ , node);
}
function genVNodeCall(node, context) {
    const { push, helper, pure } = context;
    const { tag, props, children, patchFlag, dynamicProps, directives, isBlock, disableTracking, isComponent } = node;
    let patchFlagString;
    if (patchFlag) patchFlagString = String(patchFlag);
    if (directives) push(helper(WITH_DIRECTIVES) + `(`);
    if (isBlock) push(`(${helper(OPEN_BLOCK)}(${disableTracking ? `true` : ``}), `);
    if (pure) push(PURE_ANNOTATION);
    const callHelper = isBlock ? getVNodeBlockHelper(context.inSSR, isComponent) : getVNodeHelper(context.inSSR, isComponent);
    push(helper(callHelper) + `(`, -2 /* None */ , node);
    genNodeList(genNullableArgs([
        tag,
        props,
        children,
        patchFlagString,
        dynamicProps
    ]), context);
    push(`)`);
    if (isBlock) push(`)`);
    if (directives) {
        push(`, `);
        genNode(directives, context);
        push(`)`);
    }
}
function genNullableArgs(args) {
    let i = args.length;
    while(i--){
        if (args[i] != null) break;
    }
    return args.slice(0, i + 1).map((arg)=>arg || `null`);
}
function genCallExpression(node, context) {
    const { push, helper, pure } = context;
    const callee = (0, _shared.isString)(node.callee) ? node.callee : helper(node.callee);
    if (pure) push(PURE_ANNOTATION);
    push(callee + `(`, -2 /* None */ , node);
    genNodeList(node.arguments, context);
    push(`)`);
}
function genObjectExpression(node, context) {
    const { push, indent, deindent, newline } = context;
    const { properties } = node;
    if (!properties.length) {
        push(`{}`, -2 /* None */ , node);
        return;
    }
    const multilines = properties.length > 1 || false;
    push(multilines ? `{` : `{ `);
    multilines && indent();
    for(let i = 0; i < properties.length; i++){
        const { key, value } = properties[i];
        genExpressionAsPropertyKey(key, context);
        push(`: `);
        genNode(value, context);
        if (i < properties.length - 1) {
            push(`,`);
            newline();
        }
    }
    multilines && deindent();
    push(multilines ? `}` : ` }`);
}
function genArrayExpression(node, context) {
    genNodeListAsArray(node.elements, context);
}
function genFunctionExpression(node, context) {
    const { push, indent, deindent } = context;
    const { params, returns, body, newline, isSlot } = node;
    if (isSlot) push(`_${helperNameMap[WITH_CTX]}(`);
    push(`(`, -2 /* None */ , node);
    if ((0, _shared.isArray)(params)) genNodeList(params, context);
    else if (params) genNode(params, context);
    push(`) => `);
    if (newline || body) {
        push(`{`);
        indent();
    }
    if (returns) {
        if (newline) push(`return `);
        if ((0, _shared.isArray)(returns)) genNodeListAsArray(returns, context);
        else genNode(returns, context);
    } else if (body) genNode(body, context);
    if (newline || body) {
        deindent();
        push(`}`);
    }
    if (isSlot) {
        if (node.isNonScopedSlot) push(`, undefined, true`);
        push(`)`);
    }
}
function genConditionalExpression(node, context) {
    const { test, consequent, alternate, newline: needNewline } = node;
    const { push, indent, deindent, newline } = context;
    if (test.type === 4) {
        const needsParens = !isSimpleIdentifier(test.content);
        needsParens && push(`(`);
        genExpression(test, context);
        needsParens && push(`)`);
    } else {
        push(`(`);
        genNode(test, context);
        push(`)`);
    }
    needNewline && indent();
    context.indentLevel++;
    needNewline || push(` `);
    push(`? `);
    genNode(consequent, context);
    context.indentLevel--;
    needNewline && newline();
    needNewline || push(` `);
    push(`: `);
    const isNested = alternate.type === 19;
    if (!isNested) context.indentLevel++;
    genNode(alternate, context);
    if (!isNested) context.indentLevel--;
    needNewline && deindent(true);
}
function genCacheExpression(node, context) {
    const { push, helper, indent, deindent, newline } = context;
    push(`_cache[${node.index}] || (`);
    if (node.isVOnce) {
        indent();
        push(`${helper(SET_BLOCK_TRACKING)}(-1),`);
        newline();
        push(`(`);
    }
    push(`_cache[${node.index}] = `);
    genNode(node.value, context);
    if (node.isVOnce) {
        push(`).cacheIndex = ${node.index},`);
        newline();
        push(`${helper(SET_BLOCK_TRACKING)}(1),`);
        newline();
        push(`_cache[${node.index}]`);
        deindent();
    }
    push(`)`);
}
const prohibitedKeywordRE = new RegExp("\\b" + "arguments,await,break,case,catch,class,const,continue,debugger,default,delete,do,else,export,extends,finally,for,function,if,import,let,new,return,super,switch,throw,try,var,void,while,with,yield".split(",").join("\\b|\\b") + "\\b");
const stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
function validateBrowserExpression(node, context, asParams = false, asRawStatements = false) {
    const exp = node.content;
    if (!exp.trim()) return;
    try {
        new Function(asRawStatements ? ` ${exp} ` : `return ${asParams ? `(${exp}) => {}` : `(${exp})`}`);
    } catch (e) {
        let message = e.message;
        const keywordMatch = exp.replace(stripStringRE, "").match(prohibitedKeywordRE);
        if (keywordMatch) message = `avoid using JavaScript keyword as property name: "${keywordMatch[0]}"`;
        context.onError(createCompilerError(45, node.loc, void 0, message));
    }
}
const transformExpression = (node, context)=>{
    if (node.type === 5) node.content = processExpression(node.content, context);
    else if (node.type === 1) for(let i = 0; i < node.props.length; i++){
        const dir = node.props[i];
        if (dir.type === 7 && dir.name !== "for") {
            const exp = dir.exp;
            const arg = dir.arg;
            if (exp && exp.type === 4 && !(dir.name === "on" && arg)) dir.exp = processExpression(exp, context, // slot args must be processed as function params
            dir.name === "slot");
            if (arg && arg.type === 4 && !arg.isStatic) dir.arg = processExpression(arg, context);
        }
    }
};
function processExpression(node, context, asParams = false, asRawStatements = false, localVars = Object.create(context.identifiers)) {
    return node;
}
function stringifyExpression(exp) {
    if ((0, _shared.isString)(exp)) return exp;
    else if (exp.type === 4) return exp.content;
    else return exp.children.map(stringifyExpression).join("");
}
const transformIf = createStructuralDirectiveTransform(/^(if|else|else-if)$/, (node, dir, context)=>{
    return processIf(node, dir, context, (ifNode, branch, isRoot)=>{
        const siblings = context.parent.children;
        let i = siblings.indexOf(ifNode);
        let key = 0;
        while(i-- >= 0){
            const sibling = siblings[i];
            if (sibling && sibling.type === 9) key += sibling.branches.length;
        }
        return ()=>{
            if (isRoot) ifNode.codegenNode = createCodegenNodeForBranch(branch, key, context);
            else {
                const parentCondition = getParentCondition(ifNode.codegenNode);
                parentCondition.alternate = createCodegenNodeForBranch(branch, key + ifNode.branches.length - 1, context);
            }
        };
    });
});
function processIf(node, dir, context, processCodegen) {
    if (dir.name !== "else" && (!dir.exp || !dir.exp.content.trim())) {
        const loc = dir.exp ? dir.exp.loc : node.loc;
        context.onError(createCompilerError(28, dir.loc));
        dir.exp = createSimpleExpression(`true`, false, loc);
    }
    if (dir.name === "if") {
        const branch = createIfBranch(node, dir);
        const ifNode = {
            type: 9,
            loc: node.loc,
            branches: [
                branch
            ]
        };
        context.replaceNode(ifNode);
        if (processCodegen) return processCodegen(ifNode, branch, true);
    } else {
        const siblings = context.parent.children;
        const comments = [];
        let i = siblings.indexOf(node);
        while(i-- >= -1){
            const sibling = siblings[i];
            if (sibling && sibling.type === 3) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 2 && !sibling.content.trim().length) {
                context.removeNode(sibling);
                continue;
            }
            if (sibling && sibling.type === 9) {
                if (dir.name === "else-if" && sibling.branches[sibling.branches.length - 1].condition === void 0) context.onError(createCompilerError(30, node.loc));
                context.removeNode();
                const branch = createIfBranch(node, dir);
                var userKey;
                sibling.branches.push(branch);
                const onExit = processCodegen && processCodegen(sibling, branch, false);
                traverseNode(branch, context);
                if (onExit) onExit();
                context.currentNode = null;
            } else context.onError(createCompilerError(30, node.loc));
            break;
        }
    }
}
function createIfBranch(node, dir) {
    const isTemplateIf = node.tagType === 3;
    return {
        type: 10,
        loc: node.loc,
        condition: dir.name === "else" ? void 0 : dir.exp,
        children: isTemplateIf && !findDir(node, "for") ? node.children : [
            node
        ],
        userKey: findProp(node, `key`),
        isTemplateIf
    };
}
function createCodegenNodeForBranch(branch, keyIndex, context) {
    if (branch.condition) return createConditionalExpression(branch.condition, createChildrenCodegenNode(branch, keyIndex, context), // make sure to pass in asBlock: true so that the comment node call
    // closes the current block.
    createCallExpression(context.helper(CREATE_COMMENT), [
        '""',
        "true"
    ]));
    else return createChildrenCodegenNode(branch, keyIndex, context);
}
function createChildrenCodegenNode(branch, keyIndex, context) {
    const { helper } = context;
    const keyProperty = createObjectProperty(`key`, createSimpleExpression(`${keyIndex}`, false, locStub, 2));
    const { children } = branch;
    const firstChild = children[0];
    const needFragmentWrapper = children.length !== 1 || firstChild.type !== 1;
    if (needFragmentWrapper) {
        if (children.length === 1 && firstChild.type === 11) {
            const vnodeCall = firstChild.codegenNode;
            injectProp(vnodeCall, keyProperty, context);
            return vnodeCall;
        } else {
            let patchFlag = 64;
            let patchFlagText = (0, _shared.PatchFlagNames)[64];
            return createVNodeCall(context, helper(FRAGMENT), createObjectExpression([
                keyProperty
            ]), children, patchFlag, void 0, void 0, true, false, false, branch.loc);
        }
    } else {
        const ret = firstChild.codegenNode;
        const vnodeCall = getMemoedVNodeCall(ret);
        if (vnodeCall.type === 13) convertToBlock(vnodeCall, context);
        injectProp(vnodeCall, keyProperty, context);
        return ret;
    }
}
function isSameKey(a, b) {
    if (!a || a.type !== b.type) return false;
    if (a.type === 6) {
        if (a.value.content !== b.value.content) return false;
    } else {
        const exp = a.exp;
        const branchExp = b.exp;
        if (exp.type !== branchExp.type) return false;
        if (exp.type !== 4 || exp.isStatic !== branchExp.isStatic || exp.content !== branchExp.content) return false;
    }
    return true;
}
function getParentCondition(node) {
    while(true){
        if (node.type === 19) {
            if (node.alternate.type === 19) node = node.alternate;
            else return node;
        } else if (node.type === 20) node = node.value;
    }
}
const transformBind = (dir, _node, context)=>{
    const { modifiers, loc } = dir;
    const arg = dir.arg;
    let { exp } = dir;
    if (exp && exp.type === 4 && !exp.content.trim()) exp = void 0;
    if (!exp) {
        if (arg.type !== 4 || !arg.isStatic) {
            context.onError(createCompilerError(52, arg.loc));
            return {
                props: [
                    createObjectProperty(arg, createSimpleExpression("", true, loc))
                ]
            };
        }
        transformBindShorthand(dir);
        exp = dir.exp;
    }
    if (arg.type !== 4) {
        arg.children.unshift(`(`);
        arg.children.push(`) || ""`);
    } else if (!arg.isStatic) arg.content = `${arg.content} || ""`;
    if (modifiers.includes("camel")) {
        if (arg.type === 4) {
            if (arg.isStatic) arg.content = (0, _shared.camelize)(arg.content);
            else arg.content = `${context.helperString(CAMELIZE)}(${arg.content})`;
        } else {
            arg.children.unshift(`${context.helperString(CAMELIZE)}(`);
            arg.children.push(`)`);
        }
    }
    if (!context.inSSR) {
        if (modifiers.includes("prop")) injectPrefix(arg, ".");
        if (modifiers.includes("attr")) injectPrefix(arg, "^");
    }
    return {
        props: [
            createObjectProperty(arg, exp)
        ]
    };
};
const transformBindShorthand = (dir, context)=>{
    const arg = dir.arg;
    const propName = (0, _shared.camelize)(arg.content);
    dir.exp = createSimpleExpression(propName, false, arg.loc);
};
const injectPrefix = (arg, prefix)=>{
    if (arg.type === 4) {
        if (arg.isStatic) arg.content = prefix + arg.content;
        else arg.content = `\`${prefix}\${${arg.content}}\``;
    } else {
        arg.children.unshift(`'${prefix}' + (`);
        arg.children.push(`)`);
    }
};
const transformFor = createStructuralDirectiveTransform("for", (node, dir, context)=>{
    const { helper, removeHelper } = context;
    return processFor(node, dir, context, (forNode)=>{
        const renderExp = createCallExpression(helper(RENDER_LIST), [
            forNode.source
        ]);
        const isTemplate = isTemplateNode(node);
        const memo = findDir(node, "memo");
        const keyProp = findProp(node, `key`, false, true);
        if (keyProp && keyProp.type === 7 && !keyProp.exp) transformBindShorthand(keyProp);
        const keyExp = keyProp && (keyProp.type === 6 ? keyProp.value ? createSimpleExpression(keyProp.value.content, true) : void 0 : keyProp.exp);
        const keyProperty = keyProp && keyExp ? createObjectProperty(`key`, keyExp) : null;
        const isStableFragment = forNode.source.type === 4 && forNode.source.constType > 0;
        const fragmentFlag = isStableFragment ? 64 : keyProp ? 128 : 256;
        forNode.codegenNode = createVNodeCall(context, helper(FRAGMENT), void 0, renderExp, fragmentFlag, void 0, void 0, true, !isStableFragment, false, node.loc);
        return ()=>{
            let childBlock;
            const { children } = forNode;
            var c;
            const needFragmentWrapper = children.length !== 1 || children[0].type !== 1;
            const slotOutlet = isSlotOutlet(node) ? node : isTemplate && node.children.length === 1 && isSlotOutlet(node.children[0]) ? node.children[0] : null;
            if (slotOutlet) {
                childBlock = slotOutlet.codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
            } else if (needFragmentWrapper) childBlock = createVNodeCall(context, helper(FRAGMENT), keyProperty ? createObjectExpression([
                keyProperty
            ]) : void 0, node.children, 64, void 0, void 0, true, void 0, false);
            else {
                childBlock = children[0].codegenNode;
                if (isTemplate && keyProperty) injectProp(childBlock, keyProperty, context);
                if (childBlock.isBlock !== !isStableFragment) {
                    if (childBlock.isBlock) {
                        removeHelper(OPEN_BLOCK);
                        removeHelper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                    } else removeHelper(getVNodeHelper(context.inSSR, childBlock.isComponent));
                }
                childBlock.isBlock = !isStableFragment;
                if (childBlock.isBlock) {
                    helper(OPEN_BLOCK);
                    helper(getVNodeBlockHelper(context.inSSR, childBlock.isComponent));
                } else helper(getVNodeHelper(context.inSSR, childBlock.isComponent));
            }
            if (memo) {
                const loop = createFunctionExpression(createForLoopParams(forNode.parseResult, [
                    createSimpleExpression(`_cached`)
                ]));
                loop.body = createBlockStatement([
                    createCompoundExpression([
                        `const _memo = (`,
                        memo.exp,
                        `)`
                    ]),
                    createCompoundExpression([
                        `if (_cached`,
                        ...keyExp ? [
                            ` && _cached.key === `,
                            keyExp
                        ] : [],
                        ` && ${context.helperString(IS_MEMO_SAME)}(_cached, _memo)) return _cached`
                    ]),
                    createCompoundExpression([
                        `const _item = `,
                        childBlock
                    ]),
                    createSimpleExpression(`_item.memo = _memo`),
                    createSimpleExpression(`return _item`)
                ]);
                renderExp.arguments.push(loop, createSimpleExpression(`_cache`), createSimpleExpression(String(context.cached++)));
            } else renderExp.arguments.push(createFunctionExpression(createForLoopParams(forNode.parseResult), childBlock, true));
        };
    });
});
function processFor(node, dir, context, processCodegen) {
    if (!dir.exp) {
        context.onError(createCompilerError(31, dir.loc));
        return;
    }
    const parseResult = dir.forParseResult;
    if (!parseResult) {
        context.onError(createCompilerError(32, dir.loc));
        return;
    }
    finalizeForParseResult(parseResult, context);
    const { addIdentifiers, removeIdentifiers, scopes } = context;
    const { source, value, key, index } = parseResult;
    const forNode = {
        type: 11,
        loc: dir.loc,
        source,
        valueAlias: value,
        keyAlias: key,
        objectIndexAlias: index,
        parseResult,
        children: isTemplateNode(node) ? node.children : [
            node
        ]
    };
    context.replaceNode(forNode);
    scopes.vFor++;
    const onExit = processCodegen && processCodegen(forNode);
    return ()=>{
        scopes.vFor--;
        if (onExit) onExit();
    };
}
function finalizeForParseResult(result, context) {
    if (result.finalized) return;
    result.finalized = true;
}
function createForLoopParams({ value, key, index }, memoArgs = []) {
    return createParamsList([
        value,
        key,
        index,
        ...memoArgs
    ]);
}
function createParamsList(args) {
    let i = args.length;
    while(i--){
        if (args[i]) break;
    }
    return args.slice(0, i + 1).map((arg, i2)=>arg || createSimpleExpression(`_`.repeat(i2 + 1), false));
}
const defaultFallback = createSimpleExpression(`undefined`, false);
const trackSlotScopes = (node, context)=>{
    if (node.type === 1 && (node.tagType === 1 || node.tagType === 3)) {
        const vSlot = findDir(node, "slot");
        if (vSlot) {
            vSlot.exp;
            context.scopes.vSlot++;
            return ()=>{
                context.scopes.vSlot--;
            };
        }
    }
};
const trackVForSlotScopes = (node, context)=>{
    let vFor;
    if (isTemplateNode(node) && node.props.some(isVSlot) && (vFor = findDir(node, "for"))) {
        const result = vFor.forParseResult;
        if (result) {
            finalizeForParseResult(result, context);
            const { value, key, index } = result;
            const { addIdentifiers, removeIdentifiers } = context;
            value && addIdentifiers(value);
            key && addIdentifiers(key);
            index && addIdentifiers(index);
            return ()=>{
                value && removeIdentifiers(value);
                key && removeIdentifiers(key);
                index && removeIdentifiers(index);
            };
        }
    }
};
const buildClientSlotFn = (props, _vForExp, children, loc)=>createFunctionExpression(props, children, false, true, children.length ? children[0].loc : loc);
function buildSlots(node, context, buildSlotFn = buildClientSlotFn) {
    context.helper(WITH_CTX);
    const { children, loc } = node;
    const slotsProperties = [];
    const dynamicSlots = [];
    let hasDynamicSlots = context.scopes.vSlot > 0 || context.scopes.vFor > 0;
    const onComponentSlot = findDir(node, "slot", true);
    if (onComponentSlot) {
        const { arg, exp } = onComponentSlot;
        if (arg && !isStaticExp(arg)) hasDynamicSlots = true;
        slotsProperties.push(createObjectProperty(arg || createSimpleExpression("default", true), buildSlotFn(exp, void 0, children, loc)));
    }
    let hasTemplateSlots = false;
    let hasNamedDefaultSlot = false;
    const implicitDefaultChildren = [];
    const seenSlotNames = /* @__PURE__ */ new Set();
    let conditionalBranchIndex = 0;
    for(let i = 0; i < children.length; i++){
        const slotElement = children[i];
        let slotDir;
        if (!isTemplateNode(slotElement) || !(slotDir = findDir(slotElement, "slot", true))) {
            if (slotElement.type !== 3) implicitDefaultChildren.push(slotElement);
            continue;
        }
        if (onComponentSlot) {
            context.onError(createCompilerError(37, slotDir.loc));
            break;
        }
        hasTemplateSlots = true;
        const { children: slotChildren, loc: slotLoc } = slotElement;
        const { arg: slotName = createSimpleExpression(`default`, true), exp: slotProps, loc: dirLoc } = slotDir;
        let staticSlotName;
        if (isStaticExp(slotName)) staticSlotName = slotName ? slotName.content : `default`;
        else hasDynamicSlots = true;
        const vFor = findDir(slotElement, "for");
        const slotFunction = buildSlotFn(slotProps, vFor, slotChildren, slotLoc);
        let vIf;
        let vElse;
        if (vIf = findDir(slotElement, "if")) {
            hasDynamicSlots = true;
            dynamicSlots.push(createConditionalExpression(vIf.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback));
        } else if (vElse = findDir(slotElement, /^else(-if)?$/, true)) {
            let j = i;
            let prev;
            while(j--){
                prev = children[j];
                if (prev.type !== 3) break;
            }
            if (prev && isTemplateNode(prev) && findDir(prev, /^(else-)?if$/)) {
                let conditional = dynamicSlots[dynamicSlots.length - 1];
                while(conditional.alternate.type === 19)conditional = conditional.alternate;
                conditional.alternate = vElse.exp ? createConditionalExpression(vElse.exp, buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++), defaultFallback) : buildDynamicSlot(slotName, slotFunction, conditionalBranchIndex++);
            } else context.onError(createCompilerError(30, vElse.loc));
        } else if (vFor) {
            hasDynamicSlots = true;
            const parseResult = vFor.forParseResult;
            if (parseResult) {
                finalizeForParseResult(parseResult, context);
                dynamicSlots.push(createCallExpression(context.helper(RENDER_LIST), [
                    parseResult.source,
                    createFunctionExpression(createForLoopParams(parseResult), buildDynamicSlot(slotName, slotFunction), true)
                ]));
            } else context.onError(createCompilerError(32, vFor.loc));
        } else {
            if (staticSlotName) {
                if (seenSlotNames.has(staticSlotName)) {
                    context.onError(createCompilerError(38, dirLoc));
                    continue;
                }
                seenSlotNames.add(staticSlotName);
                if (staticSlotName === "default") hasNamedDefaultSlot = true;
            }
            slotsProperties.push(createObjectProperty(slotName, slotFunction));
        }
    }
    if (!onComponentSlot) {
        const buildDefaultSlotProperty = (props, children2)=>{
            const fn = buildSlotFn(props, void 0, children2, loc);
            if (context.compatConfig) fn.isNonScopedSlot = true;
            return createObjectProperty(`default`, fn);
        };
        if (!hasTemplateSlots) slotsProperties.push(buildDefaultSlotProperty(void 0, children));
        else if (implicitDefaultChildren.length && // #3766
        // with whitespace: 'preserve', whitespaces between slots will end up in
        // implicitDefaultChildren. Ignore if all implicit children are whitespaces.
        implicitDefaultChildren.some((node2)=>isNonWhitespaceContent(node2))) {
            if (hasNamedDefaultSlot) context.onError(createCompilerError(39, implicitDefaultChildren[0].loc));
            else slotsProperties.push(buildDefaultSlotProperty(void 0, implicitDefaultChildren));
        }
    }
    const slotFlag = hasDynamicSlots ? 2 : hasForwardedSlots(node.children) ? 3 : 1;
    let slots = createObjectExpression(slotsProperties.concat(createObjectProperty(`_`, // 2 = compiled but dynamic = can skip normalization, but must run diff
    // 1 = compiled and static = can skip normalization AND diff as optimized
    createSimpleExpression(slotFlag + ``, false))), loc);
    if (dynamicSlots.length) slots = createCallExpression(context.helper(CREATE_SLOTS), [
        slots,
        createArrayExpression(dynamicSlots)
    ]);
    return {
        slots,
        hasDynamicSlots
    };
}
function buildDynamicSlot(name, fn, index) {
    const props = [
        createObjectProperty(`name`, name),
        createObjectProperty(`fn`, fn)
    ];
    if (index != null) props.push(createObjectProperty(`key`, createSimpleExpression(String(index), true)));
    return createObjectExpression(props);
}
function hasForwardedSlots(children) {
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        switch(child.type){
            case 1:
                if (child.tagType === 2 || hasForwardedSlots(child.children)) return true;
                break;
            case 9:
                if (hasForwardedSlots(child.branches)) return true;
                break;
            case 10:
            case 11:
                if (hasForwardedSlots(child.children)) return true;
                break;
        }
    }
    return false;
}
function isNonWhitespaceContent(node) {
    if (node.type !== 2 && node.type !== 12) return true;
    return node.type === 2 ? !!node.content.trim() : isNonWhitespaceContent(node.content);
}
const directiveImportMap = /* @__PURE__ */ new WeakMap();
const transformElement = (node, context)=>{
    return function postTransformElement() {
        node = context.currentNode;
        if (!(node.type === 1 && (node.tagType === 0 || node.tagType === 1))) return;
        const { tag, props } = node;
        const isComponent = node.tagType === 1;
        let vnodeTag = isComponent ? resolveComponentType(node, context) : `"${tag}"`;
        const isDynamicComponent = (0, _shared.isObject)(vnodeTag) && vnodeTag.callee === RESOLVE_DYNAMIC_COMPONENT;
        let vnodeProps;
        let vnodeChildren;
        let patchFlag = 0;
        let vnodeDynamicProps;
        let dynamicPropNames;
        let vnodeDirectives;
        let shouldUseBlock = // dynamic component may resolve to plain elements
        isDynamicComponent || vnodeTag === TELEPORT || vnodeTag === SUSPENSE || !isComponent && // <svg> and <foreignObject> must be forced into blocks so that block
        // updates inside get proper isSVG flag at runtime. (#639, #643)
        // This is technically web-specific, but splitting the logic out of core
        // leads to too much unnecessary complexity.
        (tag === "svg" || tag === "foreignObject" || tag === "math");
        if (props.length > 0) {
            const propsBuildResult = buildProps(node, context, void 0, isComponent, isDynamicComponent);
            vnodeProps = propsBuildResult.props;
            patchFlag = propsBuildResult.patchFlag;
            dynamicPropNames = propsBuildResult.dynamicPropNames;
            const directives = propsBuildResult.directives;
            vnodeDirectives = directives && directives.length ? createArrayExpression(directives.map((dir)=>buildDirectiveArgs(dir, context))) : void 0;
            if (propsBuildResult.shouldUseBlock) shouldUseBlock = true;
        }
        if (node.children.length > 0) {
            if (vnodeTag === KEEP_ALIVE) {
                shouldUseBlock = true;
                patchFlag |= 1024;
            }
            const shouldBuildAsSlots = isComponent && // Teleport is not a real component and has dedicated runtime handling
            vnodeTag !== TELEPORT && // explained above.
            vnodeTag !== KEEP_ALIVE;
            if (shouldBuildAsSlots) {
                const { slots, hasDynamicSlots } = buildSlots(node, context);
                vnodeChildren = slots;
                if (hasDynamicSlots) patchFlag |= 1024;
            } else if (node.children.length === 1 && vnodeTag !== TELEPORT) {
                const child = node.children[0];
                const type = child.type;
                const hasDynamicTextChild = type === 5 || type === 8;
                if (hasDynamicTextChild && getConstantType(child, context) === 0) patchFlag |= 1;
                if (hasDynamicTextChild || type === 2) vnodeChildren = child;
                else vnodeChildren = node.children;
            } else vnodeChildren = node.children;
        }
        if (dynamicPropNames && dynamicPropNames.length) vnodeDynamicProps = stringifyDynamicPropNames(dynamicPropNames);
        node.codegenNode = createVNodeCall(context, vnodeTag, vnodeProps, vnodeChildren, patchFlag === 0 ? void 0 : patchFlag, vnodeDynamicProps, vnodeDirectives, !!shouldUseBlock, false, isComponent, node.loc);
    };
};
function resolveComponentType(node, context, ssr = false) {
    let { tag } = node;
    const isExplicitDynamic = isComponentTag(tag);
    const isProp = findProp(node, "is", false, true);
    if (isProp) {
        if (isExplicitDynamic || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context)) {
            let exp;
            if (isProp.type === 6) exp = isProp.value && createSimpleExpression(isProp.value.content, true);
            else {
                exp = isProp.exp;
                if (!exp) exp = createSimpleExpression(`is`, false, isProp.arg.loc);
            }
            if (exp) return createCallExpression(context.helper(RESOLVE_DYNAMIC_COMPONENT), [
                exp
            ]);
        } else if (isProp.type === 6 && isProp.value.content.startsWith("vue:")) tag = isProp.value.content.slice(4);
    }
    const builtIn = isCoreComponent(tag) || context.isBuiltInComponent(tag);
    if (builtIn) {
        if (!ssr) context.helper(builtIn);
        return builtIn;
    }
    context.helper(RESOLVE_COMPONENT);
    context.components.add(tag);
    return toValidAssetId(tag, `component`);
}
function buildProps(node, context, props = node.props, isComponent, isDynamicComponent, ssr = false) {
    const { tag, loc: elementLoc, children } = node;
    let properties = [];
    const mergeArgs = [];
    const runtimeDirectives = [];
    const hasChildren = children.length > 0;
    let shouldUseBlock = false;
    let patchFlag = 0;
    let hasRef = false;
    let hasClassBinding = false;
    let hasStyleBinding = false;
    let hasHydrationEventBinding = false;
    let hasDynamicKeys = false;
    let hasVnodeHook = false;
    const dynamicPropNames = [];
    const pushMergeArg = (arg)=>{
        if (properties.length) {
            mergeArgs.push(createObjectExpression(dedupeProperties(properties), elementLoc));
            properties = [];
        }
        if (arg) mergeArgs.push(arg);
    };
    const pushRefVForMarker = ()=>{
        if (context.scopes.vFor > 0) properties.push(createObjectProperty(createSimpleExpression("ref_for", true), createSimpleExpression("true")));
    };
    const analyzePatchFlag = ({ key, value })=>{
        if (isStaticExp(key)) {
            const name = key.content;
            const isEventHandler = (0, _shared.isOn)(name);
            if (isEventHandler && (!isComponent || isDynamicComponent) && // omit the flag for click handlers because hydration gives click
            // dedicated fast path.
            name.toLowerCase() !== "onclick" && // omit v-model handlers
            name !== "onUpdate:modelValue" && // omit onVnodeXXX hooks
            !(0, _shared.isReservedProp)(name)) hasHydrationEventBinding = true;
            if (isEventHandler && (0, _shared.isReservedProp)(name)) hasVnodeHook = true;
            if (isEventHandler && value.type === 14) value = value.arguments[0];
            if (value.type === 20 || (value.type === 4 || value.type === 8) && getConstantType(value, context) > 0) return;
            if (name === "ref") hasRef = true;
            else if (name === "class") hasClassBinding = true;
            else if (name === "style") hasStyleBinding = true;
            else if (name !== "key" && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
            if (isComponent && (name === "class" || name === "style") && !dynamicPropNames.includes(name)) dynamicPropNames.push(name);
        } else hasDynamicKeys = true;
    };
    for(let i = 0; i < props.length; i++){
        const prop = props[i];
        if (prop.type === 6) {
            const { loc, name, nameLoc, value } = prop;
            let isStatic = true;
            if (name === "ref") {
                hasRef = true;
                pushRefVForMarker();
            }
            if (name === "is" && (isComponentTag(tag) || value && value.content.startsWith("vue:") || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            properties.push(createObjectProperty(createSimpleExpression(name, true, nameLoc), createSimpleExpression(value ? value.content : "", isStatic, value ? value.loc : loc)));
        } else {
            const { name, arg, exp, loc, modifiers } = prop;
            const isVBind = name === "bind";
            const isVOn = name === "on";
            if (name === "slot") {
                if (!isComponent) context.onError(createCompilerError(40, loc));
                continue;
            }
            if (name === "once" || name === "memo") continue;
            if (name === "is" || isVBind && isStaticArgOf(arg, "is") && (isComponentTag(tag) || isCompatEnabled("COMPILER_IS_ON_ELEMENT", context))) continue;
            if (isVOn && ssr) continue;
            if (// #938: elements with dynamic keys should be forced into blocks
            isVBind && isStaticArgOf(arg, "key") || // inline before-update hooks need to force block so that it is invoked
            // before children
            isVOn && hasChildren && isStaticArgOf(arg, "vue:before-update")) shouldUseBlock = true;
            if (isVBind && isStaticArgOf(arg, "ref")) pushRefVForMarker();
            if (!arg && (isVBind || isVOn)) {
                hasDynamicKeys = true;
                if (exp) {
                    if (isVBind) {
                        pushRefVForMarker();
                        pushMergeArg();
                        if (isCompatEnabled("COMPILER_V_BIND_OBJECT_ORDER", context)) {
                            mergeArgs.unshift(exp);
                            continue;
                        }
                        mergeArgs.push(exp);
                    } else pushMergeArg({
                        type: 14,
                        loc,
                        callee: context.helper(TO_HANDLERS),
                        arguments: isComponent ? [
                            exp
                        ] : [
                            exp,
                            `true`
                        ]
                    });
                } else context.onError(createCompilerError(isVBind ? 34 : 35, loc));
                continue;
            }
            if (isVBind && modifiers.includes("prop")) patchFlag |= 32;
            const directiveTransform = context.directiveTransforms[name];
            if (directiveTransform) {
                const { props: props2, needRuntime } = directiveTransform(prop, node, context);
                !ssr && props2.forEach(analyzePatchFlag);
                if (isVOn && arg && !isStaticExp(arg)) pushMergeArg(createObjectExpression(props2, elementLoc));
                else properties.push(...props2);
                if (needRuntime) {
                    runtimeDirectives.push(prop);
                    if ((0, _shared.isSymbol)(needRuntime)) directiveImportMap.set(prop, needRuntime);
                }
            } else if (!(0, _shared.isBuiltInDirective)(name)) {
                runtimeDirectives.push(prop);
                if (hasChildren) shouldUseBlock = true;
            }
        }
    }
    let propsExpression = void 0;
    if (mergeArgs.length) {
        pushMergeArg();
        if (mergeArgs.length > 1) propsExpression = createCallExpression(context.helper(MERGE_PROPS), mergeArgs, elementLoc);
        else propsExpression = mergeArgs[0];
    } else if (properties.length) propsExpression = createObjectExpression(dedupeProperties(properties), elementLoc);
    if (hasDynamicKeys) patchFlag |= 16;
    else {
        if (hasClassBinding && !isComponent) patchFlag |= 2;
        if (hasStyleBinding && !isComponent) patchFlag |= 4;
        if (dynamicPropNames.length) patchFlag |= 8;
        if (hasHydrationEventBinding) patchFlag |= 32;
    }
    if (!shouldUseBlock && (patchFlag === 0 || patchFlag === 32) && (hasRef || hasVnodeHook || runtimeDirectives.length > 0)) patchFlag |= 512;
    if (!context.inSSR && propsExpression) switch(propsExpression.type){
        case 15:
            let classKeyIndex = -1;
            let styleKeyIndex = -1;
            let hasDynamicKey = false;
            for(let i = 0; i < propsExpression.properties.length; i++){
                const key = propsExpression.properties[i].key;
                if (isStaticExp(key)) {
                    if (key.content === "class") classKeyIndex = i;
                    else if (key.content === "style") styleKeyIndex = i;
                } else if (!key.isHandlerKey) hasDynamicKey = true;
            }
            const classProp = propsExpression.properties[classKeyIndex];
            const styleProp = propsExpression.properties[styleKeyIndex];
            if (!hasDynamicKey) {
                if (classProp && !isStaticExp(classProp.value)) classProp.value = createCallExpression(context.helper(NORMALIZE_CLASS), [
                    classProp.value
                ]);
                if (styleProp && // the static style is compiled into an object,
                // so use `hasStyleBinding` to ensure that it is a dynamic style binding
                (hasStyleBinding || styleProp.value.type === 4 && styleProp.value.content.trim()[0] === `[` || // v-bind:style and style both exist,
                // v-bind:style with static literal object
                styleProp.value.type === 17)) styleProp.value = createCallExpression(context.helper(NORMALIZE_STYLE), [
                    styleProp.value
                ]);
            } else propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                propsExpression
            ]);
            break;
        case 14:
            break;
        default:
            propsExpression = createCallExpression(context.helper(NORMALIZE_PROPS), [
                createCallExpression(context.helper(GUARD_REACTIVE_PROPS), [
                    propsExpression
                ])
            ]);
            break;
    }
    return {
        props: propsExpression,
        directives: runtimeDirectives,
        patchFlag,
        dynamicPropNames,
        shouldUseBlock
    };
}
function dedupeProperties(properties) {
    const knownProps = /* @__PURE__ */ new Map();
    const deduped = [];
    for(let i = 0; i < properties.length; i++){
        const prop = properties[i];
        if (prop.key.type === 8 || !prop.key.isStatic) {
            deduped.push(prop);
            continue;
        }
        const name = prop.key.content;
        const existing = knownProps.get(name);
        if (existing) {
            if (name === "style" || name === "class" || (0, _shared.isOn)(name)) mergeAsArray(existing, prop);
        } else {
            knownProps.set(name, prop);
            deduped.push(prop);
        }
    }
    return deduped;
}
function mergeAsArray(existing, incoming) {
    if (existing.value.type === 17) existing.value.elements.push(incoming.value);
    else existing.value = createArrayExpression([
        existing.value,
        incoming.value
    ], existing.loc);
}
function buildDirectiveArgs(dir, context) {
    const dirArgs = [];
    const runtime = directiveImportMap.get(dir);
    if (runtime) dirArgs.push(context.helperString(runtime));
    else {
        context.helper(RESOLVE_DIRECTIVE);
        context.directives.add(dir.name);
        dirArgs.push(toValidAssetId(dir.name, `directive`));
    }
    const { loc } = dir;
    if (dir.exp) dirArgs.push(dir.exp);
    if (dir.arg) {
        if (!dir.exp) dirArgs.push(`void 0`);
        dirArgs.push(dir.arg);
    }
    if (Object.keys(dir.modifiers).length) {
        if (!dir.arg) {
            if (!dir.exp) dirArgs.push(`void 0`);
            dirArgs.push(`void 0`);
        }
        const trueExpression = createSimpleExpression(`true`, false, loc);
        dirArgs.push(createObjectExpression(dir.modifiers.map((modifier)=>createObjectProperty(modifier, trueExpression)), loc));
    }
    return createArrayExpression(dirArgs, dir.loc);
}
function stringifyDynamicPropNames(props) {
    let propsNamesString = `[`;
    for(let i = 0, l = props.length; i < l; i++){
        propsNamesString += JSON.stringify(props[i]);
        if (i < l - 1) propsNamesString += ", ";
    }
    return propsNamesString + `]`;
}
function isComponentTag(tag) {
    return tag === "component" || tag === "Component";
}
const transformSlotOutlet = (node, context)=>{
    if (isSlotOutlet(node)) {
        const { children, loc } = node;
        const { slotName, slotProps } = processSlotOutlet(node, context);
        const slotArgs = [
            context.prefixIdentifiers ? `_ctx.$slots` : `$slots`,
            slotName,
            "{}",
            "undefined",
            "true"
        ];
        let expectedLen = 2;
        if (slotProps) {
            slotArgs[2] = slotProps;
            expectedLen = 3;
        }
        if (children.length) {
            slotArgs[3] = createFunctionExpression([], children, false, false, loc);
            expectedLen = 4;
        }
        if (context.scopeId && !context.slotted) expectedLen = 5;
        slotArgs.splice(expectedLen);
        node.codegenNode = createCallExpression(context.helper(RENDER_SLOT), slotArgs, loc);
    }
};
function processSlotOutlet(node, context) {
    let slotName = `"default"`;
    let slotProps = void 0;
    const nonNameProps = [];
    for(let i = 0; i < node.props.length; i++){
        const p = node.props[i];
        if (p.type === 6) {
            if (p.value) {
                if (p.name === "name") slotName = JSON.stringify(p.value.content);
                else {
                    p.name = (0, _shared.camelize)(p.name);
                    nonNameProps.push(p);
                }
            }
        } else if (p.name === "bind" && isStaticArgOf(p.arg, "name")) {
            if (p.exp) slotName = p.exp;
            else if (p.arg && p.arg.type === 4) {
                const name = (0, _shared.camelize)(p.arg.content);
                slotName = p.exp = createSimpleExpression(name, false, p.arg.loc);
            }
        } else {
            if (p.name === "bind" && p.arg && isStaticExp(p.arg)) p.arg.content = (0, _shared.camelize)(p.arg.content);
            nonNameProps.push(p);
        }
    }
    if (nonNameProps.length > 0) {
        const { props, directives } = buildProps(node, context, nonNameProps, false, false);
        slotProps = props;
        if (directives.length) context.onError(createCompilerError(36, directives[0].loc));
    }
    return {
        slotName,
        slotProps
    };
}
const transformOn = (dir, node, context, augmentor)=>{
    const { loc, modifiers, arg } = dir;
    if (!dir.exp && !modifiers.length) context.onError(createCompilerError(35, loc));
    let eventName;
    if (arg.type === 4) {
        if (arg.isStatic) {
            let rawName = arg.content;
            if (rawName.startsWith("vue:")) rawName = `vnode-${rawName.slice(4)}`;
            const eventString = node.tagType !== 0 || rawName.startsWith("vnode") || !/[A-Z]/.test(rawName) ? // for non-element and vnode lifecycle event listeners, auto convert
            // it to camelCase. See issue #2249
            (0, _shared.toHandlerKey)((0, _shared.camelize)(rawName)) : // preserve case for plain element listeners that have uppercase
            // letters, as these may be custom elements' custom events
            `on:${rawName}`;
            eventName = createSimpleExpression(eventString, true, arg.loc);
        } else eventName = createCompoundExpression([
            `${context.helperString(TO_HANDLER_KEY)}(`,
            arg,
            `)`
        ]);
    } else {
        eventName = arg;
        eventName.children.unshift(`${context.helperString(TO_HANDLER_KEY)}(`);
        eventName.children.push(`)`);
    }
    let exp = dir.exp;
    if (exp && !exp.content.trim()) exp = void 0;
    let shouldCache = context.cacheHandlers && !exp && !context.inVOnce;
    if (exp) {
        const isMemberExp = isMemberExpression(exp);
        const isInlineStatement = !(isMemberExp || isFnExpression(exp));
        const hasMultipleStatements = exp.content.includes(`;`);
        if (isInlineStatement || shouldCache && isMemberExp) exp = createCompoundExpression([
            `${isInlineStatement ? `$event` : `${``}(...args)`} => ${hasMultipleStatements ? `{` : `(`}`,
            exp,
            hasMultipleStatements ? `}` : `)`
        ]);
    }
    let ret = {
        props: [
            createObjectProperty(eventName, exp || createSimpleExpression(`() => {}`, false, loc))
        ]
    };
    if (augmentor) ret = augmentor(ret);
    if (shouldCache) ret.props[0].value = context.cache(ret.props[0].value);
    ret.props.forEach((p)=>p.key.isHandlerKey = true);
    return ret;
};
const transformText = (node, context)=>{
    if (node.type === 0 || node.type === 1 || node.type === 11 || node.type === 10) return ()=>{
        const children = node.children;
        let currentContainer = void 0;
        let hasText = false;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child)) {
                hasText = true;
                for(let j = i + 1; j < children.length; j++){
                    const next = children[j];
                    if (isText$1(next)) {
                        if (!currentContainer) currentContainer = children[i] = createCompoundExpression([
                            child
                        ], child.loc);
                        currentContainer.children.push(` + `, next);
                        children.splice(j, 1);
                        j--;
                    } else {
                        currentContainer = void 0;
                        break;
                    }
                }
            }
        }
        if (!hasText || // if this is a plain element with a single text child, leave it
        // as-is since the runtime has dedicated fast path for this by directly
        // setting textContent of the element.
        // for component root it's always normalized anyway.
        children.length === 1 && (node.type === 0 || node.type === 1 && node.tagType === 0 && // #3756
        // custom directives can potentially add DOM elements arbitrarily,
        // we need to avoid setting textContent of the element at runtime
        // to avoid accidentally overwriting the DOM elements added
        // by the user through custom directives.
        !node.props.find((p)=>p.type === 7 && !context.directiveTransforms[p.name]) && // in compat mode, <template> tags with no special directives
        // will be rendered as a fragment so its children must be
        // converted into vnodes.
        !(node.tag === "template"))) return;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (isText$1(child) || child.type === 8) {
                const callArgs = [];
                if (child.type !== 2 || child.content !== " ") callArgs.push(child);
                if (!context.ssr && getConstantType(child, context) === 0) callArgs.push(1 + ``);
                children[i] = {
                    type: 12,
                    content: child,
                    loc: child.loc,
                    codegenNode: createCallExpression(context.helper(CREATE_TEXT), callArgs)
                };
            }
        }
    };
};
const seen$1 = /* @__PURE__ */ new WeakSet();
const transformOnce = (node, context)=>{
    if (node.type === 1 && findDir(node, "once", true)) {
        if (seen$1.has(node) || context.inVOnce || context.inSSR) return;
        seen$1.add(node);
        context.inVOnce = true;
        context.helper(SET_BLOCK_TRACKING);
        return ()=>{
            context.inVOnce = false;
            const cur = context.currentNode;
            if (cur.codegenNode) cur.codegenNode = context.cache(cur.codegenNode, true);
        };
    }
};
const transformModel = (dir, node, context)=>{
    const { exp, arg } = dir;
    if (!exp) {
        context.onError(createCompilerError(41, dir.loc));
        return createTransformProps();
    }
    const rawExp = exp.loc.source;
    const expString = exp.type === 4 ? exp.content : rawExp;
    const bindingType = context.bindingMetadata[rawExp];
    if (bindingType === "props" || bindingType === "props-aliased") {
        context.onError(createCompilerError(44, exp.loc));
        return createTransformProps();
    }
    const maybeRef = false;
    if (!expString.trim() || !isMemberExpression(exp) && !maybeRef) {
        context.onError(createCompilerError(42, exp.loc));
        return createTransformProps();
    }
    const propName = arg ? arg : createSimpleExpression("modelValue", true);
    const eventName = arg ? isStaticExp(arg) ? `onUpdate:${(0, _shared.camelize)(arg.content)}` : createCompoundExpression([
        '"onUpdate:" + ',
        arg
    ]) : `onUpdate:modelValue`;
    let assignmentExp;
    const eventArg = context.isTS ? `($event: any)` : `$event`;
    assignmentExp = createCompoundExpression([
        `${eventArg} => ((`,
        exp,
        `) = $event)`
    ]);
    const props = [
        // modelValue: foo
        createObjectProperty(propName, dir.exp),
        // "onUpdate:modelValue": $event => (foo = $event)
        createObjectProperty(eventName, assignmentExp)
    ];
    if (dir.modifiers.length && node.tagType === 1) {
        const modifiers = dir.modifiers.map((m)=>(isSimpleIdentifier(m) ? m : JSON.stringify(m)) + `: true`).join(`, `);
        const modifiersKey = arg ? isStaticExp(arg) ? `${arg.content}Modifiers` : createCompoundExpression([
            arg,
            ' + "Modifiers"'
        ]) : `modelModifiers`;
        props.push(createObjectProperty(modifiersKey, createSimpleExpression(`{ ${modifiers} }`, false, dir.loc, 2)));
    }
    return createTransformProps(props);
};
function createTransformProps(props = []) {
    return {
        props
    };
}
const validDivisionCharRE = /[\w).+\-_$\]]/;
const transformFilter = (node, context)=>{
    if (!isCompatEnabled("COMPILER_FILTERS", context)) return;
    if (node.type === 5) rewriteFilter(node.content, context);
    else if (node.type === 1) node.props.forEach((prop)=>{
        if (prop.type === 7 && prop.name !== "for" && prop.exp) rewriteFilter(prop.exp, context);
    });
};
function rewriteFilter(node, context) {
    if (node.type === 4) parseFilter(node, context);
    else for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (typeof child !== "object") continue;
        if (child.type === 4) parseFilter(child, context);
        else if (child.type === 8) rewriteFilter(node, context);
        else if (child.type === 5) rewriteFilter(child.content, context);
    }
}
function parseFilter(node, context) {
    const exp = node.content;
    let inSingle = false;
    let inDouble = false;
    let inTemplateString = false;
    let inRegex = false;
    let curly = 0;
    let square = 0;
    let paren = 0;
    let lastFilterIndex = 0;
    let c, prev, i, expression, filters = [];
    for(i = 0; i < exp.length; i++){
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 39 && prev !== 92) inSingle = false;
        } else if (inDouble) {
            if (c === 34 && prev !== 92) inDouble = false;
        } else if (inTemplateString) {
            if (c === 96 && prev !== 92) inTemplateString = false;
        } else if (inRegex) {
            if (c === 47 && prev !== 92) inRegex = false;
        } else if (c === 124 && // pipe
        exp.charCodeAt(i + 1) !== 124 && exp.charCodeAt(i - 1) !== 124 && !curly && !square && !paren) {
            if (expression === void 0) {
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            } else pushFilter();
        } else {
            switch(c){
                case 34:
                    inDouble = true;
                    break;
                case 39:
                    inSingle = true;
                    break;
                case 96:
                    inTemplateString = true;
                    break;
                case 40:
                    paren++;
                    break;
                case 41:
                    paren--;
                    break;
                case 91:
                    square++;
                    break;
                case 93:
                    square--;
                    break;
                case 123:
                    curly++;
                    break;
                case 125:
                    curly--;
                    break;
            }
            if (c === 47) {
                let j = i - 1;
                let p;
                for(; j >= 0; j--){
                    p = exp.charAt(j);
                    if (p !== " ") break;
                }
                if (!p || !validDivisionCharRE.test(p)) inRegex = true;
            }
        }
    }
    if (expression === void 0) expression = exp.slice(0, i).trim();
    else if (lastFilterIndex !== 0) pushFilter();
    function pushFilter() {
        filters.push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters.length) {
        for(i = 0; i < filters.length; i++)expression = wrapFilter(expression, filters[i], context);
        node.content = expression;
        node.ast = void 0;
    }
}
function wrapFilter(exp, filter, context) {
    context.helper(RESOLVE_FILTER);
    const i = filter.indexOf("(");
    if (i < 0) {
        context.filters.add(filter);
        return `${toValidAssetId(filter, "filter")}(${exp})`;
    } else {
        const name = filter.slice(0, i);
        const args = filter.slice(i + 1);
        context.filters.add(name);
        return `${toValidAssetId(name, "filter")}(${exp}${args !== ")" ? "," + args : args}`;
    }
}
const seen = /* @__PURE__ */ new WeakSet();
const transformMemo = (node, context)=>{
    if (node.type === 1) {
        const dir = findDir(node, "memo");
        if (!dir || seen.has(node)) return;
        seen.add(node);
        return ()=>{
            const codegenNode = node.codegenNode || context.currentNode.codegenNode;
            if (codegenNode && codegenNode.type === 13) {
                if (node.tagType !== 1) convertToBlock(codegenNode, context);
                node.codegenNode = createCallExpression(context.helper(WITH_MEMO), [
                    dir.exp,
                    createFunctionExpression(void 0, codegenNode),
                    `_cache`,
                    String(context.cached++)
                ]);
            }
        };
    }
};
function getBaseTransformPreset(prefixIdentifiers) {
    return [
        [
            transformOnce,
            transformIf,
            transformMemo,
            transformFor,
            transformFilter,
            transformSlotOutlet,
            transformElement,
            trackSlotScopes,
            transformText
        ],
        {
            on: transformOn,
            bind: transformBind,
            model: transformModel
        }
    ];
}
function baseCompile(source, options = {}) {
    const onError = options.onError || defaultOnError;
    const isModuleMode = options.mode === "module";
    if (options.prefixIdentifiers === true) onError(createCompilerError(47));
    else if (isModuleMode) onError(createCompilerError(48));
    const prefixIdentifiers = false;
    if (options.cacheHandlers) onError(createCompilerError(49));
    if (options.scopeId && !isModuleMode) onError(createCompilerError(50));
    const resolvedOptions = (0, _shared.extend)({}, options, {
        prefixIdentifiers
    });
    const ast = (0, _shared.isString)(source) ? baseParse(source, resolvedOptions) : source;
    const [nodeTransforms, directiveTransforms] = getBaseTransformPreset();
    transform(ast, (0, _shared.extend)({}, resolvedOptions, {
        nodeTransforms: [
            ...nodeTransforms,
            ...options.nodeTransforms || []
        ],
        directiveTransforms: (0, _shared.extend)({}, directiveTransforms, options.directiveTransforms || {})
    }));
    return generate(ast, resolvedOptions);
}
const BindingTypes = {
    "DATA": "data",
    "PROPS": "props",
    "PROPS_ALIASED": "props-aliased",
    "SETUP_LET": "setup-let",
    "SETUP_CONST": "setup-const",
    "SETUP_REACTIVE_CONST": "setup-reactive-const",
    "SETUP_MAYBE_REF": "setup-maybe-ref",
    "SETUP_REF": "setup-ref",
    "OPTIONS": "options",
    "LITERAL_CONST": "literal-const"
};
const noopDirectiveTransform = ()=>({
        props: []
    });

},{"@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"czVrE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>(0, _indexEQIWrqYJs.C));
parcelHelpers.export(exports, "DialogProgrammatic", ()=>(0, _dialogJs.DialogProgrammatic));
parcelHelpers.export(exports, "LoadingProgrammatic", ()=>(0, _loadingJs.LoadingProgrammatic));
parcelHelpers.export(exports, "ModalProgrammatic", ()=>(0, _modalJs.ModalProgrammatic));
parcelHelpers.export(exports, "NotificationProgrammatic", ()=>(0, _notificationJs.NotificationProgrammatic));
parcelHelpers.export(exports, "SnackbarProgrammatic", ()=>(0, _snackbarJs.SnackbarProgrammatic));
parcelHelpers.export(exports, "ToastProgrammatic", ()=>(0, _toastJs.ToastProgrammatic));
parcelHelpers.export(exports, "bound", ()=>(0, _helpersO9H6ICOJs.b));
parcelHelpers.export(exports, "copyAppContext", ()=>(0, _helpersO9H6ICOJs.A));
parcelHelpers.export(exports, "createAbsoluteElement", ()=>(0, _helpersO9H6ICOJs.d));
parcelHelpers.export(exports, "createNewEvent", ()=>(0, _helpersO9H6ICOJs.l));
parcelHelpers.export(exports, "escapeRegExpChars", ()=>(0, _helpersO9H6ICOJs.f));
parcelHelpers.export(exports, "getComponentFromVNode", ()=>(0, _helpersO9H6ICOJs.z));
parcelHelpers.export(exports, "getMonthNames", ()=>(0, _helpersO9H6ICOJs.n));
parcelHelpers.export(exports, "getValueByPath", ()=>(0, _helpersO9H6ICOJs.g));
parcelHelpers.export(exports, "getWeekdayNames", ()=>(0, _helpersO9H6ICOJs.o));
parcelHelpers.export(exports, "hasFlag", ()=>(0, _helpersO9H6ICOJs.h));
parcelHelpers.export(exports, "indexOf", ()=>(0, _helpersO9H6ICOJs.i));
parcelHelpers.export(exports, "isCustomElement", ()=>(0, _helpersO9H6ICOJs.u));
parcelHelpers.export(exports, "isDefined", ()=>(0, _helpersO9H6ICOJs.v));
parcelHelpers.export(exports, "isFragment", ()=>(0, _helpersO9H6ICOJs.x));
parcelHelpers.export(exports, "isMobile", ()=>(0, _helpersO9H6ICOJs.c));
parcelHelpers.export(exports, "isNil", ()=>(0, _helpersO9H6ICOJs.w));
parcelHelpers.export(exports, "isTag", ()=>(0, _helpersO9H6ICOJs.y));
parcelHelpers.export(exports, "isVueComponent", ()=>(0, _helpersO9H6ICOJs.e));
parcelHelpers.export(exports, "isWebpSupported", ()=>(0, _helpersO9H6ICOJs.q));
parcelHelpers.export(exports, "matchWithGroups", ()=>(0, _helpersO9H6ICOJs.p));
parcelHelpers.export(exports, "mod", ()=>(0, _helpersO9H6ICOJs.a));
parcelHelpers.export(exports, "multiColumnSort", ()=>(0, _helpersO9H6ICOJs.k));
parcelHelpers.export(exports, "removeDiacriticsFromString", ()=>(0, _helpersO9H6ICOJs.j));
parcelHelpers.export(exports, "removeElement", ()=>(0, _helpersO9H6ICOJs.r));
parcelHelpers.export(exports, "sign", ()=>(0, _helpersO9H6ICOJs.s));
parcelHelpers.export(exports, "toCssWidth", ()=>(0, _helpersO9H6ICOJs.t));
parcelHelpers.export(exports, "translateTouchAsDragEvent", ()=>(0, _helpersO9H6ICOJs.B));
parcelHelpers.export(exports, "Autocomplete", ()=>(0, _autocompleteJsDefault.default));
parcelHelpers.export(exports, "Breadcrumb", ()=>(0, _breadcrumbJsDefault.default));
parcelHelpers.export(exports, "Button", ()=>(0, _buttonJsDefault.default));
parcelHelpers.export(exports, "Carousel", ()=>(0, _carouselJsDefault.default));
parcelHelpers.export(exports, "Checkbox", ()=>(0, _checkboxJsDefault.default));
parcelHelpers.export(exports, "Clockpicker", ()=>(0, _clockpickerJsDefault.default));
parcelHelpers.export(exports, "Collapse", ()=>(0, _collapseJsDefault.default));
parcelHelpers.export(exports, "Colorpicker", ()=>(0, _indexEQIWrqYJs.P));
parcelHelpers.export(exports, "ConfigProgrammatic", ()=>(0, _configJsDefault.default));
parcelHelpers.export(exports, "Datepicker", ()=>(0, _datepickerJsDefault.default));
parcelHelpers.export(exports, "Datetimepicker", ()=>(0, _datetimepickerJsDefault.default));
parcelHelpers.export(exports, "Dialog", ()=>(0, _dialogJsDefault.default));
parcelHelpers.export(exports, "Dropdown", ()=>(0, _dropdownJsDefault.default));
parcelHelpers.export(exports, "Field", ()=>(0, _fieldJsDefault.default));
parcelHelpers.export(exports, "Icon", ()=>(0, _iconJsDefault.default));
parcelHelpers.export(exports, "Image", ()=>(0, _imageJsDefault.default));
parcelHelpers.export(exports, "Input", ()=>(0, _inputJsDefault.default));
parcelHelpers.export(exports, "Loading", ()=>(0, _loadingJsDefault.default));
parcelHelpers.export(exports, "Menu", ()=>(0, _menuJsDefault.default));
parcelHelpers.export(exports, "Message", ()=>(0, _messageJsDefault.default));
parcelHelpers.export(exports, "Modal", ()=>(0, _modalJsDefault.default));
parcelHelpers.export(exports, "Navbar", ()=>(0, _navbarJsDefault.default));
parcelHelpers.export(exports, "Notification", ()=>(0, _notificationJsDefault.default));
parcelHelpers.export(exports, "Numberinput", ()=>(0, _numberinputJsDefault.default));
parcelHelpers.export(exports, "Pagination", ()=>(0, _paginationJsDefault.default));
parcelHelpers.export(exports, "Progress", ()=>(0, _progressJsDefault.default));
parcelHelpers.export(exports, "Radio", ()=>(0, _radioJsDefault.default));
parcelHelpers.export(exports, "Rate", ()=>(0, _rateJsDefault.default));
parcelHelpers.export(exports, "Select", ()=>(0, _selectJsDefault.default));
parcelHelpers.export(exports, "Sidebar", ()=>(0, _sidebarJsDefault.default));
parcelHelpers.export(exports, "Skeleton", ()=>(0, _skeletonJsDefault.default));
parcelHelpers.export(exports, "Slider", ()=>(0, _sliderJsDefault.default));
parcelHelpers.export(exports, "Snackbar", ()=>(0, _snackbarJsDefault.default));
parcelHelpers.export(exports, "Steps", ()=>(0, _stepsJsDefault.default));
parcelHelpers.export(exports, "Switch", ()=>(0, _switchJsDefault.default));
parcelHelpers.export(exports, "Table", ()=>(0, _tableJsDefault.default));
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabsJsDefault.default));
parcelHelpers.export(exports, "Tag", ()=>(0, _tagJsDefault.default));
parcelHelpers.export(exports, "Taginput", ()=>(0, _taginputJsDefault.default));
parcelHelpers.export(exports, "Timepicker", ()=>(0, _timepickerJsDefault.default));
parcelHelpers.export(exports, "Toast", ()=>(0, _toastJsDefault.default));
parcelHelpers.export(exports, "Tooltip", ()=>(0, _tooltipJsDefault.default));
parcelHelpers.export(exports, "Upload", ()=>(0, _uploadJsDefault.default));
parcelHelpers.export(exports, "default", ()=>Buefy);
parcelHelpers.export(exports, "merge", ()=>(0, _helpersO9H6ICOJs.m));
var _autocompleteJs = require("./autocomplete.js");
var _autocompleteJsDefault = parcelHelpers.interopDefault(_autocompleteJs);
var _breadcrumbJs = require("./breadcrumb.js");
var _breadcrumbJsDefault = parcelHelpers.interopDefault(_breadcrumbJs);
var _buttonJs = require("./button.js");
var _buttonJsDefault = parcelHelpers.interopDefault(_buttonJs);
var _carouselJs = require("./carousel.js");
var _carouselJsDefault = parcelHelpers.interopDefault(_carouselJs);
var _checkboxJs = require("./checkbox.js");
var _checkboxJsDefault = parcelHelpers.interopDefault(_checkboxJs);
var _collapseJs = require("./collapse.js");
var _collapseJsDefault = parcelHelpers.interopDefault(_collapseJs);
var _clockpickerJs = require("./clockpicker.js");
var _clockpickerJsDefault = parcelHelpers.interopDefault(_clockpickerJs);
var _indexEQIWrqYJs = require("./index-eQI_WrqY.js");
var _datepickerJs = require("./datepicker.js");
var _datepickerJsDefault = parcelHelpers.interopDefault(_datepickerJs);
var _datetimepickerJs = require("./datetimepicker.js");
var _datetimepickerJsDefault = parcelHelpers.interopDefault(_datetimepickerJs);
var _dialogJs = require("./dialog.js");
var _dialogJsDefault = parcelHelpers.interopDefault(_dialogJs);
var _dropdownJs = require("./dropdown.js");
var _dropdownJsDefault = parcelHelpers.interopDefault(_dropdownJs);
var _fieldJs = require("./field.js");
var _fieldJsDefault = parcelHelpers.interopDefault(_fieldJs);
var _iconJs = require("./icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
var _imageJs = require("./image.js");
var _imageJsDefault = parcelHelpers.interopDefault(_imageJs);
var _inputJs = require("./input.js");
var _inputJsDefault = parcelHelpers.interopDefault(_inputJs);
var _loadingJs = require("./loading.js");
var _loadingJsDefault = parcelHelpers.interopDefault(_loadingJs);
var _menuJs = require("./menu.js");
var _menuJsDefault = parcelHelpers.interopDefault(_menuJs);
var _messageJs = require("./message.js");
var _messageJsDefault = parcelHelpers.interopDefault(_messageJs);
var _modalJs = require("./modal.js");
var _modalJsDefault = parcelHelpers.interopDefault(_modalJs);
var _notificationJs = require("./notification.js");
var _notificationJsDefault = parcelHelpers.interopDefault(_notificationJs);
var _navbarJs = require("./navbar.js");
var _navbarJsDefault = parcelHelpers.interopDefault(_navbarJs);
var _numberinputJs = require("./numberinput.js");
var _numberinputJsDefault = parcelHelpers.interopDefault(_numberinputJs);
var _paginationJs = require("./pagination.js");
var _paginationJsDefault = parcelHelpers.interopDefault(_paginationJs);
var _progressJs = require("./progress.js");
var _progressJsDefault = parcelHelpers.interopDefault(_progressJs);
var _radioJs = require("./radio.js");
var _radioJsDefault = parcelHelpers.interopDefault(_radioJs);
var _rateJs = require("./rate.js");
var _rateJsDefault = parcelHelpers.interopDefault(_rateJs);
var _selectJs = require("./select.js");
var _selectJsDefault = parcelHelpers.interopDefault(_selectJs);
var _skeletonJs = require("./skeleton.js");
var _skeletonJsDefault = parcelHelpers.interopDefault(_skeletonJs);
var _sidebarJs = require("./sidebar.js");
var _sidebarJsDefault = parcelHelpers.interopDefault(_sidebarJs);
var _sliderJs = require("./slider.js");
var _sliderJsDefault = parcelHelpers.interopDefault(_sliderJs);
var _snackbarJs = require("./snackbar.js");
var _snackbarJsDefault = parcelHelpers.interopDefault(_snackbarJs);
var _stepsJs = require("./steps.js");
var _stepsJsDefault = parcelHelpers.interopDefault(_stepsJs);
var _switchJs = require("./switch.js");
var _switchJsDefault = parcelHelpers.interopDefault(_switchJs);
var _tableJs = require("./table.js");
var _tableJsDefault = parcelHelpers.interopDefault(_tableJs);
var _tabsJs = require("./tabs.js");
var _tabsJsDefault = parcelHelpers.interopDefault(_tabsJs);
var _tagJs = require("./tag.js");
var _tagJsDefault = parcelHelpers.interopDefault(_tagJs);
var _taginputJs = require("./taginput.js");
var _taginputJsDefault = parcelHelpers.interopDefault(_taginputJs);
var _timepickerJs = require("./timepicker.js");
var _timepickerJsDefault = parcelHelpers.interopDefault(_timepickerJs);
var _toastJs = require("./toast.js");
var _toastJsDefault = parcelHelpers.interopDefault(_toastJs);
var _tooltipJs = require("./tooltip.js");
var _tooltipJsDefault = parcelHelpers.interopDefault(_tooltipJs);
var _uploadJs = require("./upload.js");
var _uploadJsDefault = parcelHelpers.interopDefault(_uploadJs);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configJs = require("./config.js");
var _configJsDefault = parcelHelpers.interopDefault(_configJs);
var _autocompletePtCdVo0Js = require("./Autocomplete-PtCdVo_0.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var _buttonKVoJ7JHHJs = require("./Button-KVoJ7jHH.js");
var _injectedChildMixin95VbgK7Js = require("./InjectedChildMixin-95-VbgK7.js");
var _imageS3BlktdgJs = require("./Image-s3Blktdg.js");
var _checkboxO2PhGepRJs = require("./Checkbox-o2PhGepR.js");
var _checkRadioMixinI9QgrPGQJs = require("./CheckRadioMixin-I9QgrPGQ.js");
var _timepickerMixinMPQh7UTJs = require("./TimepickerMixin-M_pQh7UT.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _tooltipWHq2LJasJs = require("./Tooltip-WHq2LJas.js");
var _datepickerR7KMGxsCJs = require("./Datepicker-r7KMGxsC.js");
var _timepickerSqpkdcr1Js = require("./Timepicker-sqpkdcr1.js");
var _modalAu57IFsUJs = require("./Modal-au57IFsU.js");
var _loadingP2Sa5IKEJs = require("./Loading-p2sa5IKE.js");
var _ssrJg9YOstJs = require("./ssr-jg9-YOst.js");
var _messageMixinKdZp92IJs = require("./MessageMixin-KdZp92I_.js");
var _progress7Ux1HulHJs = require("./Progress-7Ux1HulH.js");
var _noticeMixin6CQVv2Js = require("./NoticeMixin-6c_QVv-2.js");
var _paginationFX3EMQVPJs = require("./Pagination-FX3EMQVP.js");
var _tabbedChildMixinFoL4CKMJs = require("./TabbedChildMixin-foL4cK-M.js");
var _slotComponentBRURhcxzJs = require("./SlotComponent-bRURhcxz.js");
var _tag0I8NdmgDJs = require("./Tag-0i8ndmgD.js");
var components = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Autocomplete: (0, _autocompleteJsDefault.default),
    Breadcrumb: (0, _breadcrumbJsDefault.default),
    Button: (0, _buttonJsDefault.default),
    Carousel: (0, _carouselJsDefault.default),
    Checkbox: (0, _checkboxJsDefault.default),
    Clockpicker: (0, _clockpickerJsDefault.default),
    Collapse: (0, _collapseJsDefault.default),
    Colorpicker: (0, _indexEQIWrqYJs.P),
    Datepicker: (0, _datepickerJsDefault.default),
    Datetimepicker: (0, _datetimepickerJsDefault.default),
    Dialog: (0, _dialogJsDefault.default),
    Dropdown: (0, _dropdownJsDefault.default),
    Field: (0, _fieldJsDefault.default),
    Icon: (0, _iconJsDefault.default),
    Image: (0, _imageJsDefault.default),
    Input: (0, _inputJsDefault.default),
    Loading: (0, _loadingJsDefault.default),
    Menu: (0, _menuJsDefault.default),
    Message: (0, _messageJsDefault.default),
    Modal: (0, _modalJsDefault.default),
    Navbar: (0, _navbarJsDefault.default),
    Notification: (0, _notificationJsDefault.default),
    Numberinput: (0, _numberinputJsDefault.default),
    Pagination: (0, _paginationJsDefault.default),
    Progress: (0, _progressJsDefault.default),
    Radio: (0, _radioJsDefault.default),
    Rate: (0, _rateJsDefault.default),
    Select: (0, _selectJsDefault.default),
    Sidebar: (0, _sidebarJsDefault.default),
    Skeleton: (0, _skeletonJsDefault.default),
    Slider: (0, _sliderJsDefault.default),
    Snackbar: (0, _snackbarJsDefault.default),
    Steps: (0, _stepsJsDefault.default),
    Switch: (0, _switchJsDefault.default),
    Table: (0, _tableJsDefault.default),
    Tabs: (0, _tabsJsDefault.default),
    Tag: (0, _tagJsDefault.default),
    Taginput: (0, _taginputJsDefault.default),
    Timepicker: (0, _timepickerJsDefault.default),
    Toast: (0, _toastJsDefault.default),
    Tooltip: (0, _tooltipJsDefault.default),
    Upload: (0, _uploadJsDefault.default)
});
var Buefy = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // Options
        (0, _configNHWiBviwJs.s)((0, _helpersO9H6ICOJs.m)((0, _configNHWiBviwJs.c), options, true));
        // Components
        for(var componentKey in components)Vue.use(components[componentKey]);
        // Config component
        (0, _pluginsC7548X21Js.r)(Vue, "config", (0, _configJsDefault.default));
        Vue.config.globalProperties.$buefy.globalNoticeInterval = null;
    }
};

},{"./autocomplete.js":"5LIvm","./breadcrumb.js":"i1tF2","./button.js":"iw9j6","./carousel.js":"jYhoE","./checkbox.js":"j3TI6","./collapse.js":"e4ZT5","./clockpicker.js":"kkLVT","./index-eQI_WrqY.js":"3YgE2","./datepicker.js":"e0NE6","./datetimepicker.js":"cJ5xk","./dialog.js":"7cKRp","./dropdown.js":"bxKm4","./field.js":"jbn2q","./icon.js":"2k3k7","./image.js":"79D7W","./input.js":"4iQu4","./loading.js":"aLwPW","./menu.js":"lBgqY","./message.js":"ihoJF","./modal.js":"iYlHE","./notification.js":"l9jMV","./navbar.js":"ls7RG","./numberinput.js":"fmTLo","./pagination.js":"edaWG","./progress.js":"hNYrG","./radio.js":"9UItO","./rate.js":"7L9eD","./select.js":"dynuy","./skeleton.js":"gCNso","./sidebar.js":"jr71Z","./slider.js":"eoFzC","./snackbar.js":"i9FSC","./steps.js":"g741Z","./switch.js":"6Gaai","./table.js":"jKt6N","./tabs.js":"gfrpy","./tag.js":"33MT4","./taginput.js":"8eICK","./timepicker.js":"479Le","./toast.js":"hUP8f","./tooltip.js":"hHbzl","./upload.js":"lrgmG","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","./plugins-C7548x21.js":"fuYWh","./config.js":"anYU9","./Autocomplete-PtCdVo_0.js":"bRfNi","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./Input-0ivJhXUC.js":"jYQke","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","./Button-KVoJ7jHH.js":"l7xXn","./InjectedChildMixin-95-VbgK7.js":"3Zi8S","./Image-s3Blktdg.js":"4Orx2","./Checkbox-o2PhGepR.js":"jf5YD","./CheckRadioMixin-I9QgrPGQ.js":"1U5Xe","./TimepickerMixin-M_pQh7UT.js":"gf5bH","./DropdownItem-yQcaSZL4.js":"jPdf6","./trapFocus-IMs77O3T.js":"jBg9U","./Field-CMd66v8h.js":"h48jl","./typeof-Z4rCTFCZ.js":"cvqjf","./classCallCheck-E4khD9xn.js":"fYU5v","./Select-DY-wGhZc.js":"hHgPZ","./Tooltip-WHq2LJas.js":"6mgq3","./Datepicker-r7KMGxsC.js":"24fex","./Timepicker-sqpkdcr1.js":"6LEC6","./Modal-au57IFsU.js":"7FChN","./Loading-p2sa5IKE.js":"1xQL0","./ssr-jg9-YOst.js":"8rU16","./MessageMixin-KdZp92I_.js":"braJY","./Progress-7Ux1HulH.js":"226jd","./NoticeMixin-6c_QVv-2.js":"73Jf4","./Pagination-FX3EMQVP.js":"kMAX1","./TabbedChildMixin-foL4cK-M.js":"jmgfx","./SlotComponent-bRURhcxz.js":"2TjGq","./Tag-0i8ndmgD.js":"fLiwF","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5LIvm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BAutocomplete", ()=>(0, _autocompletePtCdVo0Js.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _autocompletePtCdVo0Js = require("./Autocomplete-PtCdVo_0.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _autocompletePtCdVo0Js.s));
    }
};

},{"./Autocomplete-PtCdVo_0.js":"bRfNi","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./config-nHWiBviw.js":"4fneA","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./Input-0ivJhXUC.js":"jYQke","./Icon-fJqkx1gN.js":"gKXjn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bRfNi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _vue = require("vue");
var script = {
    name: "BAutocomplete",
    components: {
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: [
            Number,
            String
        ],
        data: {
            type: Array,
            default: ()=>[]
        },
        field: {
            type: String,
            default: "value"
        },
        keepFirst: Boolean,
        clearOnSelect: Boolean,
        openOnFocus: Boolean,
        customFormatter: Function,
        checkInfiniteScroll: Boolean,
        keepOpen: Boolean,
        selectOnClickOutside: Boolean,
        clearable: Boolean,
        maxHeight: [
            String,
            Number
        ],
        dropdownPosition: {
            type: String,
            default: "auto"
        },
        groupField: String,
        groupOptions: String,
        iconRight: String,
        iconRightClickable: Boolean,
        appendToBody: Boolean,
        type: {
            type: String,
            default: "text"
        },
        confirmKeys: {
            type: Array,
            default: ()=>[
                    "Tab",
                    "Enter"
                ]
        },
        selectableHeader: Boolean,
        selectableFooter: Boolean
    },
    emits: [
        "active",
        "blur",
        "focus",
        "icon-click",
        "icon-right-click",
        "infinite-scroll",
        "select",
        "select-footer",
        "select-header",
        "typing",
        "update:modelValue"
    ],
    data () {
        return {
            selected: null,
            hovered: null,
            headerHovered: null,
            footerHovered: null,
            isActive: false,
            newValue: this.modelValue,
            newAutocomplete: this.autocomplete || "off",
            ariaAutocomplete: this.keepFirst ? "both" : "list",
            isListInViewportVertically: true,
            hasFocus: false,
            style: {},
            _isAutocomplete: true,
            _elementRef: "input",
            _bodyEl: undefined,
            timeOutID: null
        };
    },
    computed: {
        computedData () {
            if (this.groupField) {
                if (this.groupOptions) {
                    const newData = [];
                    this.data.forEach((option)=>{
                        const group = (0, _helpersO9H6ICOJs.g)(option, this.groupField);
                        const items = (0, _helpersO9H6ICOJs.g)(option, this.groupOptions);
                        newData.push({
                            group,
                            items
                        });
                    });
                    return newData;
                } else {
                    const tmp = {};
                    this.data.forEach((option)=>{
                        const group = (0, _helpersO9H6ICOJs.g)(option, this.groupField);
                        if (!tmp[group]) tmp[group] = [];
                        tmp[group].push(option);
                    });
                    const newData = [];
                    Object.keys(tmp).forEach((group)=>{
                        newData.push({
                            group,
                            items: tmp[group]
                        });
                    });
                    return newData;
                }
            }
            return [
                {
                    items: this.data
                }
            ];
        },
        isEmpty () {
            if (!this.computedData) return true;
            return !this.computedData.some((element)=>element.items && element.items.length);
        },
        /**
         * White-listed items to not close when clicked.
         * Add input, dropdown and all children.
         */ whiteList () {
            const whiteList = [];
            whiteList.push(this.$refs.input.$el.querySelector("input"));
            whiteList.push(this.$refs.dropdown);
            // Add all children from dropdown
            if (this.$refs.dropdown != null) {
                const children = this.$refs.dropdown.querySelectorAll("*");
                for (const child of children)whiteList.push(child);
            }
            if (this.$parent.$data._isTaginput) {
                // Add taginput container
                whiteList.push(this.$parent.$el);
                // Add .tag and .delete
                const tagInputChildren = this.$parent.$el.querySelectorAll("*");
                for (const tagInputChild of tagInputChildren)whiteList.push(tagInputChild);
            }
            return whiteList;
        },
        /**
         * Check if exists default slot
         */ hasDefaultSlot () {
            return !!this.$slots.default;
        },
        /**
         * Check if exists group slot
         */ hasGroupSlot () {
            return !!this.$slots.group;
        },
        /**
         * Check if exists "empty" slot
         */ hasEmptySlot () {
            return !!this.$slots.empty;
        },
        /**
         * Check if exists "header" slot
         */ hasHeaderSlot () {
            return !!this.$slots.header;
        },
        /**
         * Check if exists "footer" slot
         */ hasFooterSlot () {
            return !!this.$slots.footer;
        },
        /**
         * Apply dropdownPosition property
         */ isOpenedTop () {
            return this.dropdownPosition === "top" || this.dropdownPosition === "auto" && !this.isListInViewportVertically;
        },
        newIconRight () {
            if (this.clearable && this.newValue) return "close-circle";
            return this.iconRight;
        },
        newIconRightClickable () {
            if (this.clearable) return true;
            return this.iconRightClickable;
        },
        contentStyle () {
            return {
                maxHeight: (0, _helpersO9H6ICOJs.t)(this.maxHeight)
            };
        }
    },
    watch: {
        /**
         * When dropdown is toggled, check the visibility to know when
         * to open upwards.
         */ isActive (active) {
            if (this.dropdownPosition === "auto") {
                if (active) this.calcDropdownInViewportVertical();
                else // Timeout to wait for the animation to finish before recalculating
                this.timeOutID = setTimeout(()=>{
                    this.calcDropdownInViewportVertical();
                }, 100);
            }
            this.$nextTick(()=>{
                this.$emit("active", active);
            });
        },
        /**
         * When checkInfiniteScroll property changes scroll event should be removed or added
         */ checkInfiniteScroll (checkInfiniteScroll) {
            if ((this.$refs.dropdown && this.$refs.dropdown.querySelector(".dropdown-content")) === false) return;
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            if (checkInfiniteScroll === true) {
                list.addEventListener("scroll", this.checkIfReachedTheEndOfScroll);
                return;
            }
            list.removeEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        },
        /**
         * When updating input's value
         *   1. Emit changes
         *   2. If value isn't the same as selected, set null
         *   3. Close dropdown if value is clear or else open it
         */ newValue (value) {
            this.$emit("update:modelValue", value);
            // Check if selected is invalid
            const currentValue = this.getValue(this.selected);
            if (currentValue && currentValue !== value) this.setSelected(null, false);
            // Close dropdown if input is clear or else open it
            if (this.hasFocus && (!this.openOnFocus || value)) this.isActive = !!value;
        },
        /**
         * When v-model is changed:
         *   1. Update internal value.
         *   2. If it's invalid, validate again.
         */ modelValue (value) {
            this.newValue = value;
        },
        /**
         * Select first option if "keep-first
         */ data () {
            // Keep first option always pre-selected
            if (this.keepFirst) this.$nextTick(()=>{
                if (this.isActive) this.selectFirstOption(this.computedData);
                else this.setHovered(null);
            });
            else if (this.hovered) {
                // reset hovered if list doesn't contain it
                const hoveredValue = this.getValue(this.hovered);
                const data = this.computedData.map((d)=>d.items).reduce((a, b)=>[
                        ...a,
                        ...b
                    ], []);
                if (!data.some((d)=>this.getValue(d) === hoveredValue)) this.setHovered(null);
            }
        }
    },
    methods: {
        /**
         * Set which option is currently hovered.
         */ setHovered (option) {
            if (option === undefined) return;
            this.hovered = option;
        },
        /**
         * Set which option is currently selected, update v-model,
         * update input value and close dropdown.
         */ setSelected (option, closeDropdown = true, event) {
            if (option === undefined) return;
            this.selected = option;
            this.$emit("select", this.selected, event);
            if (this.selected !== null) {
                if (this.clearOnSelect) {
                    const input = this.$refs.input;
                    input.newValue = "";
                    input.$refs.input.value = "";
                } else this.newValue = this.getValue(this.selected);
                this.setHovered(null);
            }
            closeDropdown && this.$nextTick(()=>{
                this.isActive = false;
            });
            this.checkValidity();
        },
        /**
         * Select first option
         */ selectFirstOption (computedData) {
            this.$nextTick(()=>{
                const nonEmptyElements = computedData.filter((element)=>element.items && element.items.length);
                if (nonEmptyElements.length) {
                    const option = nonEmptyElements[0].items[0];
                    this.setHovered(option);
                } else this.setHovered(null);
            });
        },
        keydown (event) {
            const { key } = event; // cannot destructure preventDefault (https://stackoverflow.com/a/49616808/2774496)
            // prevent emit submit event
            if (key === "Enter") event.preventDefault();
            // Close dropdown on Tab & no hovered
            if (key === "Escape" || key === "Tab") this.isActive = false;
            if (this.confirmKeys.indexOf(key) >= 0) {
                // If adding by comma, don't add the comma to the input
                if (key === ",") event.preventDefault();
                // Close dropdown on select by Tab
                const closeDropdown = !this.keepOpen || key === "Tab";
                if (this.hovered === null) {
                    // header and footer uses headerHovered && footerHovered. If header or footer
                    // was selected then fire event otherwise just return so a value isn't selected
                    this.checkIfHeaderOrFooterSelected(event, null, closeDropdown);
                    return;
                }
                this.setSelected(this.hovered, closeDropdown, event);
            }
        },
        selectHeaderOrFoterByClick (event, origin) {
            this.checkIfHeaderOrFooterSelected(event, {
                origin
            });
        },
        /**
         * Check if header or footer was selected.
         */ checkIfHeaderOrFooterSelected (event, triggerClick, closeDropdown = true) {
            if (this.selectableHeader && (this.headerHovered || triggerClick && triggerClick.origin === "header")) {
                this.$emit("select-header", event);
                this.headerHovered = false;
                if (triggerClick) this.setHovered(null);
                if (closeDropdown) this.isActive = false;
            }
            if (this.selectableFooter && (this.footerHovered || triggerClick && triggerClick.origin === "footer")) {
                this.$emit("select-footer", event);
                this.footerHovered = false;
                if (triggerClick) this.setHovered(null);
                if (closeDropdown) this.isActive = false;
            }
        },
        /**
         * Close dropdown if clicked outside.
         */ clickedOutside (event) {
            const target = (0, _helpersO9H6ICOJs.u)(this) ? event.composedPath()[0] : event.target;
            if (!this.hasFocus && this.whiteList.indexOf(target) < 0) {
                if (this.keepFirst && this.hovered && this.selectOnClickOutside) this.setSelected(this.hovered, true);
                else this.isActive = false;
            }
        },
        /**
         * Return display text for the input.
         * If object, get value from path, or else just the value.
         */ getValue (option) {
            if (option === null) return;
            if (typeof this.customFormatter !== "undefined") return this.customFormatter(option);
            return typeof option === "object" ? (0, _helpersO9H6ICOJs.g)(option, this.field) : option;
        },
        /**
         * Check if the scroll list inside the dropdown
         * reached it's end.
         */ checkIfReachedTheEndOfScroll () {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            const footerHeight = this.hasFooterSlot ? list.querySelectorAll("div.dropdown-footer")[0].clientHeight : 0;
            if (list.clientHeight !== list.scrollHeight && list.scrollTop + list.parentElement.clientHeight + footerHeight >= list.scrollHeight) this.$emit("infinite-scroll");
        },
        /**
         * Calculate if the dropdown is vertically visible when activated,
         * otherwise it is openened upwards.
         */ calcDropdownInViewportVertical () {
            this.$nextTick(()=>{
                /**
                 * this.$refs.dropdown may be undefined
                 * when Autocomplete is conditional rendered
                 */ if (this.$refs.dropdown == null) return;
                const rect = this.$refs.dropdown.getBoundingClientRect();
                this.isListInViewportVertically = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
                if (this.appendToBody) this.updateAppendToBody();
            });
        },
        /**
         * Arrows keys listener.
         * If dropdown is active, set hovered option, or else just open.
         */ keyArrows (direction) {
            const sum = direction === "down" ? 1 : -1;
            if (this.isActive) {
                const data = this.computedData.map((d)=>d.items).reduce((a, b)=>[
                        ...a,
                        ...b
                    ], []);
                if (this.hasHeaderSlot && this.selectableHeader) data.unshift(undefined);
                if (this.hasFooterSlot && this.selectableFooter) data.push(undefined);
                let index;
                if (this.headerHovered) index = 0 + sum;
                else if (this.footerHovered) index = data.length - 1 + sum;
                else index = data.indexOf(this.hovered) + sum;
                index = index > data.length - 1 ? data.length - 1 : index;
                index = index < 0 ? 0 : index;
                this.footerHovered = false;
                this.headerHovered = false;
                this.setHovered(data[index] !== undefined ? data[index] : null);
                if (this.hasFooterSlot && this.selectableFooter && index === data.length - 1) this.footerHovered = true;
                if (this.hasHeaderSlot && this.selectableHeader && index === 0) this.headerHovered = true;
                const list = this.$refs.dropdown.querySelector(".dropdown-content");
                let querySelectorText = "a.dropdown-item:not(.is-disabled)";
                if (this.hasHeaderSlot && this.selectableHeader) querySelectorText += ",div.dropdown-header";
                if (this.hasFooterSlot && this.selectableFooter) querySelectorText += ",div.dropdown-footer";
                const element = list.querySelectorAll(querySelectorText)[index];
                if (!element) return;
                const visMin = list.scrollTop;
                const visMax = list.scrollTop + list.clientHeight - element.clientHeight;
                if (element.offsetTop < visMin) list.scrollTop = element.offsetTop;
                else if (element.offsetTop >= visMax) list.scrollTop = element.offsetTop - list.clientHeight + element.clientHeight;
            } else this.isActive = true;
        },
        /**
         * Focus listener.
         * If value is the same as selected, select all text.
         */ focused (event) {
            if (this.getValue(this.selected) === this.newValue) this.$el.querySelector("input").select();
            if (this.openOnFocus) {
                this.isActive = true;
                if (this.keepFirst) // If open on focus, update the hovered
                this.selectFirstOption(this.computedData);
            }
            this.hasFocus = true;
            this.$emit("focus", event);
        },
        /**
         * Blur listener.
         */ onBlur (event) {
            this.hasFocus = false;
            this.$emit("blur", event);
        },
        onInput () {
            const currentValue = this.getValue(this.selected);
            if (currentValue && currentValue === this.newValue) return;
            this.$emit("typing", this.newValue);
            this.checkValidity();
        },
        rightIconClick (event) {
            if (this.clearable) {
                this.newValue = "";
                this.setSelected(null, false);
                if (this.openOnFocus) this.$refs.input.$el.focus();
            } else this.$emit("icon-right-click", event);
        },
        checkValidity () {
            if (this.useHtml5Validation) this.$nextTick(()=>{
                this.checkHtml5Validity();
            });
        },
        updateAppendToBody () {
            const dropdownMenu = this.$refs.dropdown;
            const trigger = this.$parent.$data._isTaginput ? this.$parent.$el : this.$refs.input.$el;
            if (dropdownMenu && trigger) {
                // update wrapper dropdown
                const root = this.$data._bodyEl;
                root.classList.forEach((item)=>root.classList.remove(item));
                root.classList.add("autocomplete");
                root.classList.add("control");
                if (this.expandend) root.classList.add("is-expandend");
                const rect = trigger.getBoundingClientRect();
                let top = rect.top + window.scrollY;
                const left = rect.left + window.scrollX;
                if (!this.isOpenedTop) top += trigger.clientHeight;
                else top -= dropdownMenu.clientHeight;
                this.style = {
                    position: "absolute",
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${trigger.clientWidth}px`,
                    maxWidth: `${trigger.clientWidth}px`,
                    zIndex: "99"
                };
            }
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            if (this.dropdownPosition === "auto") window.addEventListener("resize", this.calcDropdownInViewportVertical);
        }
    },
    mounted () {
        if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector(".dropdown-content")) {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            list.addEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        }
        if (this.appendToBody) {
            this.$data._bodyEl = (0, _helpersO9H6ICOJs.d)(this.$refs.dropdown);
            this.updateAppendToBody();
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            if (this.dropdownPosition === "auto") window.removeEventListener("resize", this.calcDropdownInViewportVertical);
        }
        if (this.checkInfiniteScroll && this.$refs.dropdown && this.$refs.dropdown.querySelector(".dropdown-content")) {
            const list = this.$refs.dropdown.querySelector(".dropdown-content");
            list.removeEventListener("scroll", this.checkIfReachedTheEndOfScroll);
        }
        if (this.appendToBody) (0, _helpersO9H6ICOJs.r)(this.$data._bodyEl);
        clearTimeout(this.timeOutID);
    }
};
const _hoisted_1 = {
    key: 1,
    class: "has-text-weight-bold"
};
const _hoisted_2 = [
    "onClick"
];
const _hoisted_3 = {
    key: 1
};
const _hoisted_4 = {
    key: 1,
    class: "dropdown-item is-disabled"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "autocomplete control",
            {
                "is-expanded": _ctx.expanded
            }
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
            modelValue: $data.newValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.newValue = $event),
            ref: "input",
            type: $props.type,
            size: _ctx.size,
            loading: _ctx.loading,
            rounded: _ctx.rounded,
            icon: _ctx.icon,
            "icon-right": $options.newIconRight,
            "icon-right-clickable": $options.newIconRightClickable,
            "icon-pack": _ctx.iconPack,
            maxlength: _ctx.maxlength,
            autocomplete: $data.newAutocomplete,
            "use-html5-validation": false,
            "aria-autocomplete": $data.ariaAutocomplete
        }, _ctx.fallthroughAttrs, {
            "onUpdate:modelValue": $options.onInput,
            onFocus: $options.focused,
            onBlur: $options.onBlur,
            onKeydown: [
                $options.keydown,
                _cache[1] || (_cache[1] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>$options.keyArrows("up"), [
                    "prevent"
                ]), [
                    "up"
                ])),
                _cache[2] || (_cache[2] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>$options.keyArrows("down"), [
                    "prevent"
                ]), [
                    "down"
                ]))
            ],
            onIconRightClick: $options.rightIconClick,
            onIconClick: _cache[3] || (_cache[3] = (event)=>_ctx.$emit("icon-click", event))
        }), null, 16 /* FULL_PROPS */ , [
            "modelValue",
            "type",
            "size",
            "loading",
            "rounded",
            "icon",
            "icon-right",
            "icon-right-clickable",
            "icon-pack",
            "maxlength",
            "autocomplete",
            "aria-autocomplete",
            "onUpdate:modelValue",
            "onFocus",
            "onBlur",
            "onKeydown",
            "onIconRightClick"
        ]),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade",
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        class: (0, _vue.normalizeClass)([
                            "dropdown-menu",
                            {
                                "is-opened-top": $options.isOpenedTop && !$props.appendToBody
                            }
                        ]),
                        style: (0, _vue.normalizeStyle)($data.style),
                        ref: "dropdown"
                    }, [
                        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                            class: "dropdown-content",
                            style: (0, _vue.normalizeStyle)($options.contentStyle)
                        }, [
                            $options.hasHeaderSlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 0,
                                class: (0, _vue.normalizeClass)([
                                    "dropdown-item dropdown-header",
                                    {
                                        "is-hovered": $data.headerHovered
                                    }
                                ]),
                                role: "button",
                                tabindex: "0",
                                onClick: _cache[4] || (_cache[4] = ($event)=>$options.selectHeaderOrFoterByClick($event, "header"))
                            }, [
                                (0, _vue.renderSlot)(_ctx.$slots, "header")
                            ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true),
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.computedData, (element, groupindex)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
                                    element.group ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: groupindex + "group",
                                        class: "dropdown-item"
                                    }, [
                                        $options.hasGroupSlot ? (0, _vue.renderSlot)(_ctx.$slots, "group", {
                                            key: 0,
                                            group: element.group,
                                            index: groupindex
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1, (0, _vue.toDisplayString)(element.group), 1 /* TEXT */ ))
                                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(element.items, (option, index)=>{
                                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                                            key: groupindex + ":" + index,
                                            class: (0, _vue.normalizeClass)([
                                                "dropdown-item",
                                                {
                                                    "is-hovered": option === $data.hovered
                                                }
                                            ]),
                                            role: "button",
                                            tabindex: "0",
                                            onClick: (0, _vue.withModifiers)(($event)=>$options.setSelected(option, !$props.keepOpen, $event), [
                                                "stop"
                                            ])
                                        }, [
                                            $options.hasDefaultSlot ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                                key: 0,
                                                option: option,
                                                index: index
                                            }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_3, (0, _vue.toDisplayString)($options.getValue(option, true)), 1 /* TEXT */ ))
                                        ], 10 /* CLASS, PROPS */ , _hoisted_2);
                                    }), 128 /* KEYED_FRAGMENT */ ))
                                ], 64 /* STABLE_FRAGMENT */ );
                            }), 256 /* UNKEYED_FRAGMENT */ )),
                            $options.isEmpty && $options.hasEmptySlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, [
                                (0, _vue.renderSlot)(_ctx.$slots, "empty")
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            $options.hasFooterSlot ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                key: 2,
                                class: (0, _vue.normalizeClass)([
                                    "dropdown-item dropdown-footer",
                                    {
                                        "is-hovered": $data.footerHovered
                                    }
                                ]),
                                role: "button",
                                tabindex: "0",
                                onClick: _cache[5] || (_cache[5] = ($event)=>$options.selectHeaderOrFoterByClick($event, "footer"))
                            }, [
                                (0, _vue.renderSlot)(_ctx.$slots, "footer")
                            ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 4 /* STYLE */ ), [
                            [
                                (0, _vue.vShow),
                                $data.isActive
                            ]
                        ])
                    ], 6 /* CLASS, STYLE */ ), [
                        [
                            (0, _vue.vShow),
                            $data.isActive && (!$options.isEmpty || $options.hasEmptySlot || $options.hasHeaderSlot || $options.hasFooterSlot)
                        ]
                    ])
                ]),
            _: 3 /* FORWARDED */ 
        })
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/autocomplete/Autocomplete.vue";

},{"./helpers-O9h6_ICO.js":"9IzVa","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./Input-0ivJhXUC.js":"jYQke","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IzVa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>copyAppContext);
parcelHelpers.export(exports, "B", ()=>translateTouchAsDragEvent);
parcelHelpers.export(exports, "C", ()=>_toPropertyKey);
parcelHelpers.export(exports, "_", ()=>_defineProperty);
parcelHelpers.export(exports, "a", ()=>mod);
parcelHelpers.export(exports, "b", ()=>bound);
parcelHelpers.export(exports, "c", ()=>isMobile);
parcelHelpers.export(exports, "d", ()=>createAbsoluteElement);
parcelHelpers.export(exports, "e", ()=>isVueComponent);
parcelHelpers.export(exports, "f", ()=>escapeRegExpChars);
parcelHelpers.export(exports, "g", ()=>getValueByPath);
parcelHelpers.export(exports, "h", ()=>hasFlag);
parcelHelpers.export(exports, "i", ()=>indexOf);
parcelHelpers.export(exports, "j", ()=>removeDiacriticsFromString);
parcelHelpers.export(exports, "k", ()=>multiColumnSort);
parcelHelpers.export(exports, "l", ()=>createNewEvent);
parcelHelpers.export(exports, "m", ()=>merge);
parcelHelpers.export(exports, "n", ()=>getMonthNames);
parcelHelpers.export(exports, "o", ()=>getWeekdayNames);
parcelHelpers.export(exports, "p", ()=>matchWithGroups);
parcelHelpers.export(exports, "q", ()=>isWebpSupported);
parcelHelpers.export(exports, "r", ()=>removeElement);
parcelHelpers.export(exports, "s", ()=>sign);
parcelHelpers.export(exports, "t", ()=>toCssWidth);
parcelHelpers.export(exports, "u", ()=>isCustomElement);
parcelHelpers.export(exports, "v", ()=>isDefined);
parcelHelpers.export(exports, "w", ()=>isNil);
parcelHelpers.export(exports, "x", ()=>isFragment);
parcelHelpers.export(exports, "y", ()=>isTag);
parcelHelpers.export(exports, "z", ()=>getComponentFromVNode);
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
function _toPrimitive(input, hint) {
    if ((0, _typeofZ4RCTFCZJs._)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeofZ4RCTFCZJs._)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return (0, _typeofZ4RCTFCZJs._)(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * +/- function to native math sign
 */ function signPoly(value) {
    if (value < 0) return -1;
    return value > 0 ? 1 : 0;
}
var sign = Math.sign || signPoly;
/**
 * Checks if the flag is set
 * @param val
 * @param flag
 * @returns {boolean}
 */ function hasFlag(val, flag) {
    return (val & flag) === flag;
}
/**
 * Native modulo bug with negative numbers
 * @param n
 * @param mod
 * @returns {number}
 */ function mod(n, mod) {
    return (n % mod + mod) % mod;
}
/**
 * Asserts a value is beetween min and max
 * @param val
 * @param min
 * @param max
 * @returns {number}
 */ function bound(val, min, max) {
    return Math.max(min, Math.min(max, val));
}
/**
 * Get value of an object property/path even if it's nested
 */ function getValueByPath(obj, path) {
    return path.split(".").reduce(function(o, i) {
        return o ? o[i] : null;
    }, obj);
}
/**
 * Extension of indexOf method by equality function if specified
 */ function indexOf(array, obj, fn) {
    if (!array) return -1;
    if (!fn || typeof fn !== "function") return array.indexOf(obj);
    for(var i = 0; i < array.length; i++){
        if (fn(array[i], obj)) return i;
    }
    return -1;
}
/**
 * Merge function to replace Object.assign with deep merging possibility
 */ var isObject = function isObject(item) {
    return (0, _typeofZ4RCTFCZJs._)(item) === "object" && !Array.isArray(item);
};
var mergeFn = function mergeFn(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (deep || !Object.assign) {
        var isDeep = function isDeep(prop) {
            return isObject(source[prop]) && target !== null && Object.prototype.hasOwnProperty.call(target, prop) && isObject(target[prop]);
        };
        var replaced = Object.getOwnPropertyNames(source).map(function(prop) {
            return _defineProperty({}, prop, isDeep(prop) ? mergeFn(target[prop], source[prop], deep) : source[prop]);
        }).reduce(function(a, b) {
            return _objectSpread(_objectSpread({}, a), b);
        }, {});
        return _objectSpread(_objectSpread({}, target), replaced);
    } else return Object.assign(target, source);
};
var merge = mergeFn;
/**
 * Mobile detection
 * https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
 */ var isMobile = {
    Android: function Android() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function BlackBerry() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function iOS() {
        return typeof window !== "undefined" && (window.navigator.userAgent.match(/iPhone|iPad|iPod/i) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
    },
    Opera: function Opera() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function Windows() {
        return typeof window !== "undefined" && window.navigator.userAgent.match(/IEMobile/i);
    },
    any: function any() {
        return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    }
};
function removeElement(el) {
    if (typeof el.remove !== "undefined") el.remove();
    else if (typeof el.parentNode !== "undefined" && el.parentNode !== null) el.parentNode.removeChild(el);
}
function createAbsoluteElement(el) {
    var root = document.createElement("div");
    root.style.position = "absolute";
    root.style.left = "0px";
    root.style.top = "0px";
    root.style.width = "100%";
    var wrapper = document.createElement("div");
    root.appendChild(wrapper);
    wrapper.appendChild(el);
    document.body.appendChild(root);
    return root;
}
function isVueComponent(c) {
    return c && c.$ != null && c.$.vnode != null;
}
/**
 * Escape regex characters
 * http://stackoverflow.com/a/6969486
 */ function escapeRegExpChars(value) {
    if (!value) return value;
    // eslint-disable-next-line
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
/**
 * Remove accents/diacritics in a string in JavaScript
 * https://stackoverflow.com/a/37511463
 */ function removeDiacriticsFromString(value) {
    if (!value) return value;
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function multiColumnSort(inputArray, sortingPriority) {
    // NOTE: this function is intended to be used by BTable
    // clone it to prevent the any watchers from triggering every sorting iteration
    var array = JSON.parse(JSON.stringify(inputArray));
    var fieldSorter = function fieldSorter(fields) {
        return function(a, b) {
            return fields.map(function(o) {
                var field = o.field, order = o.order, customSort = o.customSort;
                if (typeof customSort === "function") return customSort(a, b, order !== "desc");
                else {
                    var aValue = getValueByPath(a, field);
                    var bValue = getValueByPath(b, field);
                    var ord = aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                    return order === "desc" ? -ord : ord;
                }
            }).reduce(function(p, n) {
                return p || n;
            }, 0);
        };
    };
    return array.sort(fieldSorter(sortingPriority));
}
function createNewEvent(eventName) {
    var event;
    if (typeof Event === "function") event = new Event(eventName);
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
    }
    return event;
}
function toCssWidth(width) {
    return width === undefined ? null : isNaN(width) ? width : width + "px";
}
/**
 * Return month names according to a specified locale
 * @param  {String} locale A bcp47 localerouter. undefined will use the user browser locale
 * @param  {String} format long (ex. March), short (ex. Mar) or narrow (M)
 * @return {Array<String>} An array of month names
 */ function getMonthNames() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "long";
    var dates = [];
    for(var i = 0; i < 12; i++)dates.push(new Date(2000, i, 15));
    var dtf = new Intl.DateTimeFormat(locale, {
        month: format
    });
    return dates.map(function(d) {
        return dtf.format(d);
    });
}
/**
 * Return weekday names according to a specified locale
 * @param  {String} locale A bcp47 localerouter. undefined will use the user browser locale
 * @param  {String} format long (ex. Thursday), short (ex. Thu) or narrow (T)
 * @return {Array<String>} An array of weekday names
 */ function getWeekdayNames() {
    var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "narrow";
    var dates = [];
    for(var i = 0; i < 7; i++){
        var dt = new Date(2000, 0, i + 1);
        dates[dt.getDay()] = dt;
    }
    var dtf = new Intl.DateTimeFormat(locale, {
        weekday: format
    });
    return dates.map(function(d) {
        return dtf.format(d);
    });
}
/**
 * Accept a regex with group names and return an object
 * ex. matchWithGroups(/((?!=<year>)\d+)\/((?!=<month>)\d+)\/((?!=<day>)\d+)/, '2000/12/25')
 * will return { year: 2000, month: 12, day: 25 }
 * @param  {String} includes injections of (?!={groupname}) for each group
 * @param  {String} the string to run regex
 * @return {Object} an object with a property for each group having the group's match as the value
 */ function matchWithGroups(pattern, str) {
    var matches = str.match(pattern);
    return pattern// get the pattern as a string
    .toString()// suss out the groups
    .match(/<(.+?)>/g)// remove the braces
    .map(function(group) {
        var groupMatches = group.match(/<(.+)>/);
        if (!groupMatches || groupMatches.length <= 0) return null;
        return group.match(/<(.+)>/)[1];
    })// create an object with a property for each group having the group's match as the value
    .reduce(function(acc, curr, index, arr) {
        if (matches && matches.length > index) acc[curr] = matches[index + 1];
        else acc[curr] = null;
        return acc;
    }, {});
}
/**
 * Based on
 * https://github.com/fregante/supports-webp
 */ function isWebpSupported() {
    return new Promise(function(resolve) {
        var image = new Image();
        image.onerror = function() {
            return resolve(false);
        };
        image.onload = function() {
            return resolve(image.width === 1);
        };
        image.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=";
    })["catch"](function() {
        return false;
    });
}
function isCustomElement(vm) {
    return "shadowRoot" in vm.$root.$options;
}
var isDefined = function isDefined(d) {
    return d !== undefined;
};
/**
 * Checks if a value is null or undefined.
 * Based on
 * https://github.com/lodash/lodash/blob/master/isNil.js
 */ var isNil = function isNil(value) {
    return value === null || value === undefined;
};
function isFragment(vnode) {
    return vnode.type === (0, _vue.Fragment);
}
// TODO: replacement of vnode.tag test
function isTag(vnode) {
    return vnode.type !== (0, _vue.Comment) && vnode.type !== (0, _vue.Text) && vnode.type !== (0, _vue.Static);
}
// references
// - https://github.com/vuejs/core/blob/1c525f75a3d17a6356d5f66765623c0ae7c0ebcc/packages/runtime-core/src/apiCreateApp.ts#L361
// - https://github.com/vuejs/core/blob/1c525f75a3d17a6356d5f66765623c0ae7c0ebcc/packages/runtime-core/src/component.ts#L1036-L1054
//
// we cannot access getExposeProxy since it is not exported from `vue`, though,
// its purpose seems to be one-time initialization of component.exposeProxy,
// which should have been done by this function call
function getComponentFromVNode(vnode) {
    if (!vnode) return undefined;
    var component = vnode.component;
    if (!component) return undefined;
    return component.exposed && component.exposeProxy || component.proxy;
}
// Copies the context from a given app to another app.
//
// This function is necessary to programmatically mount a component; e.g.,
// Modal.
// Since Vue 3's app can mount only one component, we have to create a new app
// to mount another new component.
// If we create a new app with `createApp` API, no context (e.g., installed
// components, directives) is available on the new app.
// This function can copy the context from the host app to the new app.
//
// Depends on what Vue internally does: https://github.com/vuejs/core/blob/b775b71c788499ec7ee58bc2cf4cd04ed388e072/packages/runtime-core/src/apiCreateApp.ts#L170-L190
//
// This function also should take care of compatiblity with other plugins.
// We need a generic solution, though, it fixes compatiblity issues of
// individual plugins for now.
function copyAppContext(src, dest) {
    // replacing _context won't work because methods of app bypasses app._context
    var srcContext = src._context;
    var destContext = dest._context;
    destContext.config = srcContext.config;
    destContext.mixins = srcContext.mixins;
    destContext.components = srcContext.components;
    destContext.directives = srcContext.directives;
    destContext.provides = srcContext.provides;
    destContext.optionsCache = srcContext.optionsCache;
    destContext.propsCache = srcContext.propsCache;
    destContext.emitsCache = srcContext.emitsCache;
    // vue-i18n support: https://github.com/ntohq/buefy-next/issues/153
    if ("__VUE_I18N_SYMBOL__" in src) dest.__VUE_I18N_SYMBOL__ = src.__VUE_I18N_SYMBOL__;
}
/**
 * Translates a touch event as a drag event.
 *
 * `event` must be a touch event.
 *
 * `options` must be an object with the following properties:
 * - `type`: new event type (required). must be one of the following:
 *     - `"dragstart"`
 *     - `"dragend"`
 *     - `"drop"`
 *     - `"dragover"`
 *     - `"dragleave"`
 * - `target`: new target element (optional). `clientX` and `clientY` will be
 *   translated if `target` is different from `event.target`.
 *
 * This function only works with single-touch events for now.
 */ var translateTouchAsDragEvent = function translateTouchAsDragEvent(event, options) {
    var type = options.type, target = options.target;
    var translateX = 0;
    var translateY = 0;
    if (target != null && target !== event.target) {
        var baseRect = event.target.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        translateX = targetRect.left - baseRect.left;
        translateY = targetRect.top - baseRect.top;
    }
    var touch = event.touches[0] || event.changedTouches[0];
    return new DragEvent(type, {
        dataTransfer: new DataTransfer(),
        bubbles: true,
        screenX: touch.screenX,
        screenY: touch.screenY,
        clientX: touch.clientX + translateX,
        clientY: touch.clientY + translateY,
        ctrlKey: event.ctrlKey,
        shiftKey: event.shiftKey,
        altKey: event.altKey,
        metaKey: event.metaKey
    });
};

},{"./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cvqjf":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9b7J5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CompatFallthroughMixin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var _excluded = [
    "style",
    "class",
    "id"
];
var CompatFallthroughMixin = {
    inheritAttrs: false,
    props: {
        compatFallthrough: {
            type: Boolean,
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultCompatFallthrough;
            }
        }
    },
    computed: {
        rootAttrs: function rootAttrs() {
            return this.compatFallthrough ? {
                "class": this.$attrs["class"],
                style: this.$attrs.style,
                id: this.$attrs.id
            } : {};
        },
        fallthroughAttrs: function fallthroughAttrs() {
            if (this.compatFallthrough) {
                var _this$$attrs = this.$attrs;
                _this$$attrs.style;
                _this$$attrs["class"];
                _this$$attrs.id;
                var rest = _objectWithoutProperties(_this$$attrs, _excluded);
                return rest;
            } else return this.$attrs;
        }
    }
};

},{"./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4fneA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", ()=>config);
parcelHelpers.export(exports, "s", ()=>setOptions);
var config = {
    defaultContainerElement: null,
    defaultIconPack: "mdi",
    defaultIconComponent: null,
    defaultIconPrev: "chevron-left",
    defaultIconNext: "chevron-right",
    defaultLocale: undefined,
    defaultDialogConfirmText: null,
    defaultDialogCancelText: null,
    defaultSnackbarDuration: 3500,
    defaultSnackbarPosition: null,
    defaultToastDuration: 2000,
    defaultToastPosition: null,
    defaultNotificationDuration: 2000,
    defaultNotificationPosition: null,
    defaultTooltipType: "is-primary",
    defaultTooltipDelay: null,
    defaultTooltipCloseDelay: null,
    defaultSidebarDelay: null,
    defaultInputAutocomplete: "on",
    defaultDateFormatter: null,
    defaultDateParser: null,
    defaultDateCreator: null,
    defaultTimeCreator: null,
    defaultDayNames: null,
    defaultMonthNames: null,
    defaultFirstDayOfWeek: null,
    defaultUnselectableDaysOfWeek: null,
    defaultTimeFormatter: null,
    defaultTimeParser: null,
    defaultModalCanCancel: [
        "escape",
        "x",
        "outside",
        "button"
    ],
    defaultModalScroll: null,
    defaultDatepickerMobileNative: true,
    defaultTimepickerMobileNative: true,
    defaultTimepickerMobileModal: true,
    defaultNoticeQueue: true,
    defaultInputHasCounter: true,
    /**
   * Whether `class`, `style`, and `id` are applied to the root element in
   * components that are affected by Vue 3 change in fallthgourh beahvior.
   * See: https://github.com/ntohq/buefy-next/issues/16
   */ defaultCompatFallthrough: true,
    defaultTaginputHasCounter: true,
    defaultUseHtml5Validation: true,
    defaultDropdownMobileModal: true,
    defaultFieldLabelPosition: null,
    defaultDatepickerYearsRange: [
        -100,
        10
    ],
    defaultDatepickerNearbyMonthDays: true,
    defaultDatepickerNearbySelectableMonthDays: false,
    defaultDatepickerShowWeekNumber: false,
    defaultDatepickerWeekNumberClickable: false,
    defaultDatepickerMobileModal: true,
    defaultTrapFocus: true,
    defaultAutoFocus: true,
    defaultButtonRounded: false,
    defaultSwitchRounded: true,
    defaultCarouselInterval: 3500,
    defaultTabsExpanded: false,
    defaultTabsAnimated: true,
    defaultTabsType: null,
    defaultStatusIcon: true,
    defaultProgrammaticPromise: false,
    defaultLinkTags: [
        "a",
        "button",
        "input",
        "router-link",
        "nuxt-link",
        "n-link",
        "RouterLink",
        "NuxtLink",
        "NLink"
    ],
    defaultImageWebpFallback: null,
    defaultImageLazy: true,
    defaultImageResponsive: true,
    defaultImageRatio: null,
    defaultImageSrcsetFormatter: null,
    defaultBreadcrumbTag: "a",
    defaultBreadcrumbAlign: "is-left",
    defaultBreadcrumbSeparator: "",
    defaultBreadcrumbSize: "is-medium",
    customIconPacks: null
};
var setOptions = function setOptions(options) {
    config = options;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5s7Sr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "F", ()=>FormElementMixin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var FormElementMixin = {
    props: {
        size: String,
        expanded: Boolean,
        loading: Boolean,
        rounded: Boolean,
        icon: String,
        iconPack: String,
        // Native options to use in HTML5 validation
        autocomplete: String,
        maxlength: [
            Number,
            String
        ],
        useHtml5Validation: {
            type: Boolean,
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultUseHtml5Validation;
            }
        },
        validationMessage: String,
        locale: {
            type: [
                String,
                Array
            ],
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultLocale;
            }
        },
        statusIcon: {
            type: Boolean,
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultStatusIcon;
            }
        }
    },
    emits: [
        "blur",
        "focus"
    ],
    data: function data() {
        return {
            isValid: true,
            isFocused: false,
            newIconPack: this.iconPack || (0, _configNHWiBviwJs.c).defaultIconPack
        };
    },
    computed: {
        /**
     * Find parent Field, max 3 levels deep.
     */ parentField: function parentField() {
            var parent = this.$parent;
            for(var i = 0; i < 3; i++)if (parent && !parent.$data._isField) parent = parent.$parent;
            return parent;
        },
        /**
     * Get the type prop from parent if it's a Field.
     */ statusType: function statusType() {
            var _ref = this.parentField || {}, newType = _ref.newType;
            if (!newType) return;
            if (typeof newType === "string") return newType;
            else for(var key in newType){
                if (newType[key]) return key;
            }
        },
        /**
     * Get the message prop from parent if it's a Field.
     */ statusMessage: function statusMessage() {
            if (!this.parentField) return;
            return this.parentField.newMessage || this.parentField.$slots.message;
        },
        /**
     * Fix icon size for inputs, large was too big
     */ iconSize: function iconSize() {
            switch(this.size){
                case "is-small":
                    return this.size;
                case "is-medium":
                    return;
                case "is-large":
                    return this.newIconPack === "mdi" ? "is-medium" : "";
            }
        }
    },
    methods: {
        /**
     * Focus method that work dynamically depending on the component.
     */ focus: function focus() {
            var el = this.getElement();
            if (el === undefined) return;
            this.$nextTick(function() {
                if (el) el.focus();
            });
        },
        onBlur: function onBlur($event) {
            this.isFocused = false;
            this.$emit("blur", $event);
            this.checkHtml5Validity();
        },
        onFocus: function onFocus($event) {
            this.isFocused = true;
            this.$emit("focus", $event);
        },
        getElement: function getElement() {
            var el = this.$refs[this.$data._elementRef];
            while(el != null && "$refs" in el)el = el.$refs[el.$data._elementRef];
            return el;
        },
        setInvalid: function setInvalid() {
            var type = "is-danger";
            var message = this.validationMessage || this.getElement().validationMessage;
            this.setValidity(type, message);
        },
        setValidity: function setValidity(type, message) {
            var _this = this;
            this.$nextTick(function() {
                if (_this.parentField) {
                    // Set type only if not defined
                    if (!_this.parentField.type) _this.parentField.newType = type;
                    // Set message only if not defined
                    if (!_this.parentField.message) _this.parentField.newMessage = message;
                }
            });
        },
        /**
     * Check HTML5 validation, set isValid property.
     * If validation fail, send 'is-danger' type,
     * and error message to parent if it's a Field.
     */ checkHtml5Validity: function checkHtml5Validity() {
            if (!this.useHtml5Validation) return;
            var el = this.getElement();
            if (el == null) return;
            if (!el.checkValidity()) {
                this.setInvalid();
                this.isValid = false;
            } else {
                this.setValidity(null, null);
                this.isValid = true;
            }
            return this.isValid;
        }
    }
};

},{"./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYQke":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _vue = require("vue");
var script = {
    name: "BInput",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: [
            Number,
            String
        ],
        type: {
            type: String,
            default: "text"
        },
        lazy: {
            type: Boolean,
            default: false
        },
        passwordReveal: Boolean,
        iconClickable: Boolean,
        hasCounter: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultInputHasCounter
        },
        customClass: {
            type: String,
            default: ""
        },
        iconRight: String,
        iconRightClickable: Boolean,
        iconRightType: String
    },
    emits: [
        "icon-click",
        "icon-right-click",
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            newType: this.type,
            newAutocomplete: this.autocomplete || (0, _configNHWiBviwJs.c).defaultInputAutocomplete,
            isPasswordVisible: false,
            _elementRef: this.type === "textarea" ? "textarea" : "input"
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        rootClasses () {
            return [
                this.iconPosition,
                this.size,
                {
                    "is-expanded": this.expanded,
                    "is-loading": this.loading,
                    "is-clearfix": !this.hasMessage
                }
            ];
        },
        inputClasses () {
            return [
                this.statusType,
                this.size,
                {
                    "is-rounded": this.rounded
                }
            ];
        },
        hasIconRight () {
            return this.passwordReveal || this.loading || this.statusIcon && this.statusTypeIcon || this.iconRight;
        },
        rightIcon () {
            if (this.passwordReveal) return this.passwordVisibleIcon;
            else if (this.iconRight) return this.iconRight;
            return this.statusTypeIcon;
        },
        rightIconType () {
            if (this.passwordReveal) return "is-primary";
            else if (this.iconRight) return this.iconRightType || null;
            return this.statusType;
        },
        /**
        * Position of the icon or if it's both sides.
        */ iconPosition () {
            let iconClasses = "";
            if (this.icon) iconClasses += "has-icons-left ";
            if (this.hasIconRight) iconClasses += "has-icons-right";
            return iconClasses;
        },
        /**
        * Icon name (MDI) based on the type.
        */ statusTypeIcon () {
            switch(this.statusType){
                case "is-success":
                    return "check";
                case "is-danger":
                    return "alert-circle";
                case "is-info":
                    return "information";
                case "is-warning":
                    return "alert";
                default:
                    return undefined;
            }
        },
        /**
        * Check if have any message prop from parent if it's a Field.
        */ hasMessage () {
            return !!this.statusMessage;
        },
        /**
        * Current password-reveal icon name.
        */ passwordVisibleIcon () {
            return !this.isPasswordVisible ? "eye" : "eye-off";
        },
        /**
        * Get value length
        */ valueLength () {
            if (typeof this.computedValue === "string") return Array.from(this.computedValue).length;
            else if (typeof this.computedValue === "number") return this.computedValue.toString().length;
            return 0;
        }
    },
    watch: {
        /**
        * When v-model is changed:
        *   1. Set internal value.
        *   2. Validate it if the value came from outside;
        *      i.e., not equal to computedValue
        */ modelValue (value) {
            const fromOutside = this.computedValue != value; // eslint-disable-line eqeqeq
            this.newValue = value;
            if (fromOutside) // validation must wait for DOM updated
            this.$nextTick(()=>{
                !this.isValid && this.checkHtml5Validity();
            });
        },
        type (type) {
            this.newType = type;
        }
    },
    methods: {
        /**
        * Toggle the visibility of a password-reveal input
        * by changing the type and focus the input right away.
        */ togglePasswordVisibility () {
            this.isPasswordVisible = !this.isPasswordVisible;
            this.newType = this.isPasswordVisible ? "text" : "password";
            this.$nextTick(()=>{
                this.focus();
            });
        },
        iconClick (emit, event) {
            this.$emit(emit, event);
            this.$nextTick(()=>{
                this.focus();
            });
        },
        rightIconClick (event) {
            if (this.passwordReveal) this.togglePasswordVisibility();
            else if (this.iconRightClickable) this.iconClick("icon-right-click", event);
        },
        onInput (event) {
            if (!this.lazy) {
                const value = event.target.value;
                this.updateValue(value);
            }
        },
        onChange (event) {
            if (this.lazy) {
                const value = event.target.value;
                this.updateValue(value);
            }
        },
        updateValue (value) {
            this.computedValue = value;
            !this.isValid && this.checkHtml5Validity();
        }
    }
};
const _hoisted_1 = [
    "type",
    "autocomplete",
    "maxlength",
    "value"
];
const _hoisted_2 = [
    "maxlength",
    "value"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "control",
            $options.rootClasses
        ]
    }, _ctx.rootAttrs), [
        $props.type !== "textarea" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", (0, _vue.mergeProps)({
            key: 0,
            ref: "input",
            class: [
                "input",
                [
                    $options.inputClasses,
                    $props.customClass
                ]
            ],
            type: $data.newType,
            autocomplete: $data.newAutocomplete,
            maxlength: _ctx.maxlength,
            value: $options.computedValue
        }, _ctx.fallthroughAttrs, {
            onInput: _cache[0] || (_cache[0] = (...args)=>$options.onInput && $options.onInput(...args)),
            onChange: _cache[1] || (_cache[1] = (...args)=>$options.onChange && $options.onChange(...args)),
            onBlur: _cache[2] || (_cache[2] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onFocus: _cache[3] || (_cache[3] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
        }), null, 16 /* FULL_PROPS */ , _hoisted_1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("textarea", (0, _vue.mergeProps)({
            key: 1,
            ref: "textarea",
            class: [
                "textarea",
                [
                    $options.inputClasses,
                    $props.customClass
                ]
            ],
            maxlength: _ctx.maxlength,
            value: $options.computedValue
        }, _ctx.fallthroughAttrs, {
            onInput: _cache[4] || (_cache[4] = (...args)=>$options.onInput && $options.onInput(...args)),
            onChange: _cache[5] || (_cache[5] = (...args)=>$options.onChange && $options.onChange(...args)),
            onBlur: _cache[6] || (_cache[6] = (...args)=>_ctx.onBlur && _ctx.onBlur(...args)),
            onFocus: _cache[7] || (_cache[7] = (...args)=>_ctx.onFocus && _ctx.onFocus(...args))
        }), null, 16 /* FULL_PROPS */ , _hoisted_2)),
        _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 2,
            class: (0, _vue.normalizeClass)([
                "is-left",
                {
                    "is-clickable": $props.iconClickable
                }
            ]),
            icon: _ctx.icon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize,
            onClick: _cache[8] || (_cache[8] = ($event)=>$options.iconClick("icon-click", $event))
        }, null, 8 /* PROPS */ , [
            "class",
            "icon",
            "pack",
            "size"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        !_ctx.loading && $options.hasIconRight ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 3,
            class: (0, _vue.normalizeClass)([
                "is-right",
                {
                    "is-clickable": $props.passwordReveal || $props.iconRightClickable
                }
            ]),
            icon: $options.rightIcon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize,
            type: $options.rightIconType,
            both: "",
            onClick: $options.rightIconClick
        }, null, 8 /* PROPS */ , [
            "class",
            "icon",
            "pack",
            "size",
            "type",
            "onClick"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        _ctx.maxlength && $props.hasCounter && $props.type !== "number" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", {
            key: 4,
            class: (0, _vue.normalizeClass)([
                "help counter",
                {
                    "is-invisible": !_ctx.isFocused
                }
            ])
        }, (0, _vue.toDisplayString)($options.valueLength) + " / " + (0, _vue.toDisplayString)(_ctx.maxlength), 3 /* TEXT, CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/input/Input.vue";

},{"./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gKXjn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var mdiIcons = {
    sizes: {
        "default": "mdi-24px",
        "is-small": null,
        "is-medium": "mdi-36px",
        "is-large": "mdi-48px"
    },
    iconPrefix: "mdi-"
};
var faIcons = function faIcons() {
    var faIconPrefix = (0, _configNHWiBviwJs.c) && (0, _configNHWiBviwJs.c).defaultIconComponent ? "" : "fa-";
    return {
        sizes: {
            "default": null,
            "is-small": null,
            "is-medium": faIconPrefix + "lg",
            "is-large": faIconPrefix + "2x"
        },
        iconPrefix: faIconPrefix,
        internalIcons: {
            information: "info-circle",
            alert: "exclamation-triangle",
            "alert-circle": "exclamation-circle",
            "chevron-right": "angle-right",
            "chevron-left": "angle-left",
            "chevron-down": "angle-down",
            "eye-off": "eye-slash",
            "menu-down": "caret-down",
            "menu-up": "caret-up",
            "close-circle": "times-circle"
        }
    };
};
var getIcons = function getIcons() {
    var icons = {
        mdi: mdiIcons,
        fa: faIcons(),
        fas: faIcons(),
        far: faIcons(),
        fad: faIcons(),
        fab: faIcons(),
        fal: faIcons(),
        "fa-solid": faIcons(),
        "fa-regular": faIcons(),
        "fa-light": faIcons(),
        "fa-thin": faIcons(),
        "fa-duotone": faIcons(),
        "fa-brands": faIcons()
    };
    if ((0, _configNHWiBviwJs.c) && (0, _configNHWiBviwJs.c).customIconPacks) icons = (0, _helpersO9H6ICOJs.m)(icons, (0, _configNHWiBviwJs.c).customIconPacks, true);
    return icons;
};
var getIcons$1 = getIcons;
var script = {
    name: "BIcon",
    props: {
        type: [
            String,
            Object
        ],
        component: String,
        pack: String,
        icon: String,
        size: String,
        customSize: String,
        customClass: String,
        both: Boolean // This is used internally to show both MDI and FA icon
    },
    computed: {
        iconConfig () {
            const allIcons = getIcons$1();
            return allIcons[this.newPack];
        },
        iconPrefix () {
            if (this.iconConfig && this.iconConfig.iconPrefix) return this.iconConfig.iconPrefix;
            return "";
        },
        /**
        * Internal icon name based on the pack.
        * If pack is 'fa', gets the equivalent FA icon name of the MDI,
        * internal icons are always MDI.
        */ newIcon () {
            return `${this.iconPrefix}${this.getEquivalentIconOf(this.icon)}`;
        },
        newPack () {
            return this.pack || (0, _configNHWiBviwJs.c).defaultIconPack;
        },
        newType () {
            if (!this.type) return;
            let splitType = [];
            if (typeof this.type === "string") splitType = this.type.split("-");
            else {
                for(const key in this.type)if (this.type[key]) {
                    splitType = key.split("-");
                    break;
                }
            }
            if (splitType.length <= 1) return;
            const [, ...type] = splitType;
            return `has-text-${type.join("-")}`;
        },
        newCustomSize () {
            return this.customSize || this.customSizeByPack;
        },
        customSizeByPack () {
            if (this.iconConfig && this.iconConfig.sizes) {
                if (this.size && this.iconConfig.sizes[this.size] !== undefined) return this.iconConfig.sizes[this.size];
                else if (this.iconConfig.sizes.default) return this.iconConfig.sizes.default;
            }
            return null;
        },
        useIconComponent () {
            return this.component || (0, _configNHWiBviwJs.c).defaultIconComponent;
        }
    },
    methods: {
        /**
        * Equivalent icon name of the MDI.
        */ getEquivalentIconOf (value) {
            // Only transform the class if the both prop is set to true
            if (!this.both) return value;
            if (this.iconConfig && this.iconConfig.internalIcons && this.iconConfig.internalIcons[value]) return this.iconConfig.internalIcons[value];
            return value;
        }
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        class: (0, _vue.normalizeClass)([
            "icon",
            [
                $options.newType,
                $props.size
            ]
        ])
    }, [
        !$options.useIconComponent ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("i", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                $options.newPack,
                $options.newIcon,
                $options.newCustomSize,
                $props.customClass
            ])
        }, null, 2 /* CLASS */ )) : ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($options.useIconComponent), {
            key: 1,
            icon: [
                $options.newPack,
                $options.newIcon
            ],
            size: $options.newCustomSize,
            class: (0, _vue.normalizeClass)([
                $props.customClass
            ])
        }, null, 8 /* PROPS */ , [
            "icon",
            "size",
            "class"
        ]))
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/icon/Icon.vue";

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fuYWh":[function(require,module,exports) {
// use `name` to register a Functional Component which will become unresolvable
// in production build due to name mangling.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>registerComponent);
parcelHelpers.export(exports, "r", ()=>registerComponentProgrammatic);
var registerComponent = function registerComponent(Vue, component, name) {
    Vue.component(name || component.name, component);
};
var registerComponentProgrammatic = function registerComponentProgrammatic(Vue, property, component) {
    if (!Vue.config.globalProperties.$buefy) Vue.config.globalProperties.$buefy = {};
    Vue.config.globalProperties.$buefy[property] = component;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i1tF2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BBreadcrumb", ()=>script$1);
parcelHelpers.export(exports, "BBreadcrumbItem", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var script$1 = {
    name: "BBreadcrumb",
    props: {
        align: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultBreadcrumbAlign;
            }
        },
        separator: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultBreadcrumbSeparator;
            }
        },
        size: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultBreadcrumbSize;
            }
        }
    },
    computed: {
        breadcrumbClasses () {
            return [
                "breadcrumb",
                this.align,
                this.separator,
                this.size
            ];
        }
    }
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", {
        class: (0, _vue.normalizeClass)($options.breadcrumbClasses)
    }, [
        (0, _vue.createElementVNode)("ul", null, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])
    ], 2 /* CLASS */ );
}
script$1.render = render$1;
script$1.__file = "src/components/breadcrumb/Breadcrumb.vue";
var script = {
    name: "BBreadcrumbItem",
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C)
    ],
    props: {
        tag: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultBreadcrumbTag;
            }
        },
        active: Boolean
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", (0, _vue.mergeProps)({
        class: {
            "is-active": $props.active
        }
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.tag), (0, _vue.normalizeProps)((0, _vue.guardReactiveProps)(_ctx.fallthroughAttrs)), {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3 /* FORWARDED */ 
        }, 16 /* FULL_PROPS */ ))
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/breadcrumb/BreadcrumbItem.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","vue":"dylud","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iw9j6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BButton", ()=>(0, _buttonKVoJ7JHHJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _buttonKVoJ7JHHJs = require("./Button-KVoJ7jHH.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _buttonKVoJ7JHHJs.s));
    }
};

},{"./Button-KVoJ7jHH.js":"l7xXn","./plugins-C7548x21.js":"fuYWh","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l7xXn":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var script = {
    name: "BButton",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    inheritAttrs: false,
    props: {
        type: [
            String,
            Object
        ],
        size: String,
        label: String,
        iconPack: String,
        iconLeft: String,
        iconRight: String,
        rounded: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultButtonRounded;
            }
        },
        loading: Boolean,
        outlined: Boolean,
        expanded: Boolean,
        inverted: Boolean,
        focused: Boolean,
        active: Boolean,
        hovered: Boolean,
        selected: Boolean,
        nativeType: {
            type: String,
            default: "button",
            validator: (value)=>{
                return [
                    "button",
                    "submit",
                    "reset"
                ].indexOf(value) >= 0;
            }
        },
        tag: {
            type: String,
            default: "button",
            validator: (value)=>{
                return (0, _configNHWiBviwJs.c).defaultLinkTags.indexOf(value) >= 0;
            }
        }
    },
    computed: {
        computedTag () {
            if (this.$attrs.disabled !== undefined && this.$attrs.disabled !== false) return "button";
            return this.tag;
        },
        iconSize () {
            if (!this.size || this.size === "is-medium") return "is-small";
            else if (this.size === "is-large") return "is-medium";
            return this.size;
        }
    }
};
const _hoisted_1 = {
    key: 1
};
const _hoisted_2 = {
    key: 2
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($options.computedTag), (0, _vue.mergeProps)({
        class: "button"
    }, _ctx.$attrs, {
        type: [
            "button",
            "input"
        ].includes($options.computedTag) ? $props.nativeType : undefined,
        class: [
            $props.size,
            $props.type,
            {
                "is-rounded": $props.rounded,
                "is-loading": $props.loading,
                "is-outlined": $props.outlined,
                "is-fullwidth": $props.expanded,
                "is-inverted": $props.inverted,
                "is-focused": $props.focused,
                "is-active": $props.active,
                "is-hovered": $props.hovered,
                "is-selected": $props.selected
            }
        ]
    }), {
        default: (0, _vue.withCtx)(()=>[
                $props.iconLeft ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 0,
                    pack: $props.iconPack,
                    icon: $props.iconLeft,
                    size: $options.iconSize
                }, null, 8 /* PROPS */ , [
                    "pack",
                    "icon",
                    "size"
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                $props.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1, (0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )) : _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2, [
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                $props.iconRight ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 3,
                    pack: $props.iconPack,
                    icon: $props.iconRight,
                    size: $options.iconSize
                }, null, 8 /* PROPS */ , [
                    "pack",
                    "icon",
                    "size"
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3 /* FORWARDED */ 
    }, 16 /* FULL_PROPS */ , [
        "type",
        "class"
    ]);
}
script.render = render;
script.__file = "src/components/button/Button.vue";

},{"./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jYhoE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BCarousel", ()=>script$2);
parcelHelpers.export(exports, "BCarouselItem", ()=>script$1);
parcelHelpers.export(exports, "BCarouselList", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _injectedChildMixin95VbgK7Js = require("./InjectedChildMixin-95-VbgK7.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var _imageS3BlktdgJs = require("./Image-s3Blktdg.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script$2 = {
    name: "BCarousel",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    mixins: [
        (0, _injectedChildMixin95VbgK7Js.P)("carousel", (0, _injectedChildMixin95VbgK7Js.S))
    ],
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        animated: {
            type: String,
            default: "slide"
        },
        interval: Number,
        hasDrag: {
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        pauseHover: {
            type: Boolean,
            default: true
        },
        pauseInfo: {
            type: Boolean,
            default: true
        },
        pauseInfoType: {
            type: String,
            default: "is-white"
        },
        pauseText: {
            type: String,
            default: "Pause"
        },
        arrow: {
            type: Boolean,
            default: true
        },
        arrowHover: {
            type: Boolean,
            default: true
        },
        repeat: {
            type: Boolean,
            default: true
        },
        iconPack: String,
        iconSize: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconNext;
            }
        },
        indicator: {
            type: Boolean,
            default: true
        },
        indicatorBackground: Boolean,
        indicatorCustom: Boolean,
        indicatorCustomSize: {
            type: String,
            default: "is-small"
        },
        indicatorInside: {
            type: Boolean,
            default: true
        },
        indicatorMode: {
            type: String,
            default: "click"
        },
        indicatorPosition: {
            type: String,
            default: "is-bottom"
        },
        indicatorStyle: {
            type: String,
            default: "is-dots"
        },
        overlay: Boolean,
        progress: Boolean,
        progressType: {
            type: String,
            default: "is-primary"
        },
        withCarouselList: Boolean
    },
    emits: [
        "change",
        "click",
        "update:modelValue"
    ],
    data () {
        return {
            transition: "next",
            activeChild: this.modelValue || 0,
            isPause: false,
            dragX: false,
            timer: null
        };
    },
    computed: {
        indicatorClasses () {
            return [
                {
                    "has-background": this.indicatorBackground,
                    "has-custom": this.indicatorCustom,
                    "is-inside": this.indicatorInside
                },
                this.indicatorCustom && this.indicatorCustomSize,
                this.indicatorInside && this.indicatorPosition
            ];
        },
        // checking arrows
        hasPrev () {
            return this.repeat || this.activeChild !== 0;
        },
        hasNext () {
            return this.repeat || this.activeChild < this.childItems.length - 1;
        },
        activeChildIndex () {
            const item = this.sortedItems[this.activeChild];
            return item != null ? item.index : undefined;
        }
    },
    watch: {
        /**
         * When v-model is changed set the new active item.
         */ modelValue (value) {
            this.changeActive(value);
        },
        /**
         * When carousel-items are updated, set active one.
         */ sortedItems (items) {
            if (this.activeChild >= items.length && this.activeChild > 0) this.changeActive(this.activeChild - 1);
        },
        /**
         *  When autoplay is changed, start or pause timer accordingly
         */ autoplay (status) {
            status ? this.startTimer() : this.pauseTimer();
        },
        /**
         *  Since the timer can get paused at the end, if repeat is changed we need to restart it
         */ repeat (status) {
            if (status) this.startTimer();
        }
    },
    methods: {
        startTimer () {
            if (!this.autoplay || this.timer) return;
            this.isPause = false;
            this.timer = setInterval(()=>{
                if (!this.repeat && this.activeChild >= this.childItems.length - 1) this.pauseTimer();
                else this.next();
            }, this.interval || (0, _configNHWiBviwJs.c).defaultCarouselInterval);
        },
        pauseTimer () {
            this.isPause = true;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        restartTimer () {
            this.pauseTimer();
            this.startTimer();
        },
        checkPause () {
            if (this.pauseHover && this.autoplay) this.pauseTimer();
        },
        /**
         * Change the active item and emit change event.
         * action only for animated slide, there true = next, false = prev
         */ changeActive (newIndex, direction = 0) {
            if (this.activeChild === newIndex || isNaN(newIndex)) return;
            direction = direction || newIndex - this.activeChild;
            newIndex = this.repeat ? (0, _helpersO9H6ICOJs.a)(newIndex, this.childItems.length) : (0, _helpersO9H6ICOJs.b)(newIndex, 0, this.childItems.length - 1);
            this.transition = direction > 0 ? "prev" : "next";
            // Transition names are reversed from the actual direction for correct effect
            this.activeChild = newIndex;
            if (newIndex !== this.modelValue) this.$emit("update:modelValue", newIndex);
            this.restartTimer();
            this.$emit("change", newIndex); // BC
        },
        // Indicator trigger when change active item.
        modeChange (trigger, value) {
            if (this.indicatorMode === trigger) return this.changeActive(value);
        },
        prev () {
            this.changeActive(this.activeChild - 1, -1);
        },
        next () {
            this.changeActive(this.activeChild + 1, 1);
        },
        // handle drag event
        dragStart (event) {
            if (!this.hasDrag || !event.target.draggable) return;
            this.dragX = event.touches ? event.changedTouches[0].pageX : event.pageX;
            if (event.touches) this.pauseTimer();
            else event.preventDefault();
        },
        dragEnd (event) {
            if (this.dragX === false) return;
            const detected = event.touches ? event.changedTouches[0].pageX : event.pageX;
            const diffX = detected - this.dragX;
            if (Math.abs(diffX) > 30) {
                if (diffX < 0) this.next();
                else this.prev();
            } else {
                event.target.click();
                this.sortedItems[this.activeChild].$emit("click");
                this.$emit("click");
            }
            if (event.touches) this.startTimer();
            this.dragX = false;
        }
    },
    mounted () {
        this.startTimer();
    },
    beforeUnmount () {
        this.pauseTimer();
    }
};
const _hoisted_1$2 = [
    "value",
    "max"
];
const _hoisted_2 = {
    key: 1,
    class: "carousel-pause"
};
const _hoisted_3 = [
    "onMouseover",
    "onClick"
];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "carousel",
            {
                "is-overlay": $props.overlay
            }
        ]),
        onMouseenter: _cache[4] || (_cache[4] = (...args)=>$options.checkPause && $options.checkPause(...args)),
        onMouseleave: _cache[5] || (_cache[5] = (...args)=>$options.startTimer && $options.startTimer(...args))
    }, [
        $props.progress ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("progress", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "progress",
                $props.progressType
            ]),
            value: $data.activeChild,
            max: _ctx.childItems.length - 1
        }, (0, _vue.toDisplayString)(_ctx.childItems.length - 1), 11 /* TEXT, CLASS, PROPS */ , _hoisted_1$2)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("div", {
            class: "carousel-items",
            onMousedown: _cache[0] || (_cache[0] = (...args)=>$options.dragStart && $options.dragStart(...args)),
            onMouseup: _cache[1] || (_cache[1] = (...args)=>$options.dragEnd && $options.dragEnd(...args)),
            onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>$options.dragStart && $options.dragStart(...args), [
                "stop"
            ])),
            onTouchend: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>$options.dragEnd && $options.dragEnd(...args), [
                "stop"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            $props.arrow ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                key: 0,
                class: (0, _vue.normalizeClass)([
                    "carousel-arrow",
                    {
                        "is-hovered": $props.arrowHover
                    }
                ])
            }, [
                (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                    class: "has-icons-left",
                    onClick: $options.prev,
                    pack: $props.iconPack,
                    icon: $props.iconPrev,
                    size: $props.iconSize,
                    both: ""
                }, null, 8 /* PROPS */ , [
                    "onClick",
                    "pack",
                    "icon",
                    "size"
                ]), [
                    [
                        (0, _vue.vShow),
                        $options.hasPrev
                    ]
                ]),
                (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                    class: "has-icons-right",
                    onClick: $options.next,
                    pack: $props.iconPack,
                    icon: $props.iconNext,
                    size: $props.iconSize,
                    both: ""
                }, null, 8 /* PROPS */ , [
                    "onClick",
                    "pack",
                    "icon",
                    "size"
                ]), [
                    [
                        (0, _vue.vShow),
                        $options.hasNext
                    ]
                ])
            ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
        ], 32 /* HYDRATE_EVENTS */ ),
        $props.autoplay && $props.pauseHover && $props.pauseInfo && $data.isPause ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
            (0, _vue.createElementVNode)("span", {
                class: (0, _vue.normalizeClass)([
                    "tag",
                    $props.pauseInfoType
                ])
            }, (0, _vue.toDisplayString)($props.pauseText), 3 /* TEXT, CLASS */ )
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        $props.withCarouselList && !$props.indicator ? (0, _vue.renderSlot)(_ctx.$slots, "list", {
            key: 2,
            active: $data.activeChild,
            switch: $options.changeActive
        }) : (0, _vue.createCommentVNode)("v-if", true),
        $props.indicator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 3,
            class: (0, _vue.normalizeClass)([
                "carousel-indicator",
                $options.indicatorClasses
            ])
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.sortedItems, (item, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                    class: (0, _vue.normalizeClass)([
                        "indicator-item",
                        {
                            "is-active": item.isActive
                        }
                    ]),
                    onMouseover: ($event)=>$options.modeChange("hover", index),
                    onClick: ($event)=>$options.modeChange("click", index),
                    key: item._uid
                }, [
                    (0, _vue.renderSlot)(_ctx.$slots, "indicators", {
                        i: index
                    }, ()=>[
                            (0, _vue.createElementVNode)("span", {
                                class: (0, _vue.normalizeClass)([
                                    "indicator-style",
                                    $props.indicatorStyle
                                ])
                            }, null, 2 /* CLASS */ )
                        ])
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_3);
            }), 128 /* KEYED_FRAGMENT */ ))
        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true),
        $props.overlay ? (0, _vue.renderSlot)(_ctx.$slots, "overlay", {
            key: 4
        }) : (0, _vue.createCommentVNode)("v-if", true)
    ], 34 /* CLASS, HYDRATE_EVENTS */ );
}
script$2.render = render$2;
script$2.__file = "src/components/carousel/Carousel.vue";
var script$1 = {
    name: "BCarouselItem",
    mixins: [
        (0, _injectedChildMixin95VbgK7Js.I)("carousel", (0, _injectedChildMixin95VbgK7Js.a))
    ],
    data () {
        return {
            transitionName: null
        };
    },
    computed: {
        transition () {
            if (this.parent.animated === "fade") return "fade";
            else if (this.parent.transition) return "slide-" + this.parent.transition;
            else return undefined;
        },
        isActive () {
            return this.parent.activeChildIndex === this.index;
        }
    }
};
const _hoisted_1$1 = {
    class: "carousel-item"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: $options.transition,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", _hoisted_1$1, [
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ], 512 /* NEED_PATCH */ ), [
                    [
                        (0, _vue.vShow),
                        $options.isActive
                    ]
                ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "name"
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/carousel/CarouselItem.vue";
var script = {
    name: "BCarouselList",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _imageS3BlktdgJs.s).name]: (0, _imageS3BlktdgJs.s)
    },
    props: {
        data: {
            type: Array,
            default: ()=>[]
        },
        modelValue: {
            type: Number,
            default: 0
        },
        scrollValue: {
            type: Number,
            default: 0
        },
        hasDrag: {
            type: Boolean,
            default: true
        },
        hasGrayscale: Boolean,
        hasOpacity: Boolean,
        repeat: Boolean,
        itemsToShow: {
            type: Number,
            default: 4
        },
        itemsToList: {
            type: Number,
            default: 1
        },
        asIndicator: Boolean,
        arrow: {
            type: Boolean,
            default: true
        },
        arrowHover: {
            type: Boolean,
            default: true
        },
        iconPack: String,
        iconSize: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconNext;
            }
        },
        breakpoints: {
            type: Object,
            default: ()=>({})
        }
    },
    emits: [
        "switch",
        "update:modelValue",
        "updated:scroll"
    ],
    data () {
        return {
            activeItem: this.modelValue,
            scrollIndex: this.asIndicator ? this.scrollValue : this.modelValue,
            delta: 0,
            dragX: false,
            hold: 0,
            windowWidth: 0,
            touch: false,
            observer: null,
            refresh_: 0
        };
    },
    computed: {
        dragging () {
            return this.dragX !== false;
        },
        listClass () {
            return [
                {
                    "has-grayscale": this.settings.hasGrayscale,
                    "has-opacity": this.settings.hasOpacity,
                    "is-dragging": this.dragging
                }
            ];
        },
        itemStyle () {
            return `width: ${this.itemWidth}px;`;
        },
        translation () {
            return -(0, _helpersO9H6ICOJs.b)(this.delta + this.scrollIndex * this.itemWidth, 0, (this.data.length - this.settings.itemsToShow) * this.itemWidth);
        },
        total () {
            return this.data.length - this.settings.itemsToShow;
        },
        hasPrev () {
            return this.settings.repeat || this.scrollIndex > 0;
        },
        hasNext () {
            return this.settings.repeat || this.scrollIndex < this.total;
        },
        breakpointKeys () {
            return Object.keys(this.breakpoints).sort((a, b)=>b - a);
        },
        settings () {
            const breakpoint = this.breakpointKeys.filter((breakpoint)=>{
                if (this.windowWidth >= breakpoint) return true;
                else return false;
            })[0];
            if (breakpoint) return {
                ...this.$props,
                ...this.breakpoints[breakpoint]
            };
            return this.$props;
        },
        itemWidth () {
            if (this.windowWidth) {
                /* eslint-disable-next-line */ this.refresh_; // We force the computed property to refresh if this prop is changed
                const rect = this.$el.getBoundingClientRect();
                return rect.width / this.settings.itemsToShow;
            }
            return 0;
        }
    },
    watch: {
        /**
         * When v-model is changed set the new active item.
         */ modelValue (value) {
            this.switchTo(this.asIndicator ? value - (this.itemsToShow - 3) / 2 : value);
            if (this.activeItem !== value) this.activeItem = (0, _helpersO9H6ICOJs.b)(value, 0, this.data.length - 1);
        },
        scrollValue (value) {
            this.switchTo(value);
        }
    },
    methods: {
        resized () {
            this.windowWidth = window.innerWidth;
        },
        switchTo (newIndex) {
            if (newIndex === this.scrollIndex || isNaN(newIndex)) return;
            if (this.settings.repeat) newIndex = (0, _helpersO9H6ICOJs.a)(newIndex, this.total + 1);
            newIndex = (0, _helpersO9H6ICOJs.b)(newIndex, 0, this.total);
            this.scrollIndex = newIndex;
            if (!this.asIndicator && this.modelValue !== newIndex) this.$emit("update:modelValue", newIndex);
            else if (this.scrollIndex !== newIndex) this.$emit("updated:scroll", newIndex);
        },
        next () {
            this.switchTo(this.scrollIndex + this.settings.itemsToList);
        },
        prev () {
            this.switchTo(this.scrollIndex - this.settings.itemsToList);
        },
        checkAsIndicator (value, event) {
            if (!this.asIndicator) return;
            const dragEndX = event.changedTouches ? event.changedTouches[0].clientX : event.clientX;
            if (this.hold - Date.now() > 2000 || Math.abs(this.dragX - dragEndX) > 10) return;
            this.dragX = false;
            this.hold = 0;
            event.preventDefault();
            // Make the item appear in the middle
            this.activeItem = value;
            this.$emit("switch", value);
        },
        // handle drag event
        dragStart (event) {
            if (this.dragging || !this.settings.hasDrag || event.button !== 0 && event.type !== "touchstart") return;
            this.hold = Date.now();
            this.touch = !!event.touches;
            this.dragX = this.touch ? event.touches[0].clientX : event.clientX;
            window.addEventListener(this.touch ? "touchmove" : "mousemove", this.dragMove);
            window.addEventListener(this.touch ? "touchend" : "mouseup", this.dragEnd);
        },
        dragMove (event) {
            if (!this.dragging) return;
            const dragEndX = event.touches ? (event.changedTouches[0] || event.touches[0]).clientX : event.clientX;
            this.delta = this.dragX - dragEndX;
            if (!event.touches) event.preventDefault();
        },
        dragEnd () {
            if (!this.dragging && !this.hold) return;
            if (this.hold) {
                const signCheck = (0, _helpersO9H6ICOJs.s)(this.delta);
                const results = Math.round(Math.abs(this.delta / this.itemWidth) + 0.15); // Hack
                this.switchTo(this.scrollIndex + signCheck * results);
            }
            this.delta = 0;
            this.dragX = false;
            window.removeEventListener(this.touch ? "touchmove" : "mousemove", this.dragMove);
            window.removeEventListener(this.touch ? "touchend" : "mouseup", this.dragEnd);
        },
        refresh () {
            this.$nextTick(()=>{
                this.refresh_++;
            });
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            if (window.ResizeObserver) {
                this.observer = new ResizeObserver(this.refresh);
                this.observer.observe(this.$el);
            }
            window.addEventListener("resize", this.resized);
            document.addEventListener("animationend", this.refresh);
            document.addEventListener("transitionend", this.refresh);
            document.addEventListener("transitionstart", this.refresh);
            this.resized();
        }
        if (this.$attrs.config) throw new Error("The config prop was removed, you need to use v-bind instead");
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            if (window.ResizeObserver) this.observer.disconnect();
            window.removeEventListener("resize", this.resized);
            document.removeEventListener("animationend", this.refresh);
            document.removeEventListener("transitionend", this.refresh);
            document.removeEventListener("transitionstart", this.refresh);
            this.dragEnd();
        }
    }
};
const _hoisted_1 = [
    "onMouseup",
    "onTouchend"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_image = (0, _vue.resolveComponent)("b-image");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "carousel-list",
            {
                "has-shadow": $data.scrollIndex > 0
            }
        ]),
        onMousedown: _cache[0] || (_cache[0] = (0, _vue.withModifiers)((...args)=>$options.dragStart && $options.dragStart(...args), [
            "prevent"
        ])),
        onTouchstart: _cache[1] || (_cache[1] = (...args)=>$options.dragStart && $options.dragStart(...args))
    }, [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "carousel-slides",
                $options.listClass
            ]),
            style: (0, _vue.normalizeStyle)("transform:translateX(" + $options.translation + "px)")
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.data, (list, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    class: (0, _vue.normalizeClass)([
                        "carousel-slide",
                        {
                            "is-active": $props.asIndicator ? $data.activeItem === index : $data.scrollIndex === index
                        }
                    ]),
                    onMouseup: ($event)=>$options.checkAsIndicator(index, $event),
                    onTouchend: ($event)=>$options.checkAsIndicator(index, $event),
                    key: index,
                    style: (0, _vue.normalizeStyle)($options.itemStyle)
                }, [
                    (0, _vue.renderSlot)(_ctx.$slots, "item", (0, _vue.mergeProps)({
                        index: index,
                        active: $data.activeItem,
                        scroll: $data.scrollIndex
                    }, list, {
                        list: list
                    }), ()=>[
                            (0, _vue.createVNode)(_component_b_image, (0, _vue.mergeProps)({
                                src: list.image
                            }, list), null, 16 /* FULL_PROPS */ , [
                                "src"
                            ])
                        ])
                ], 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */ , _hoisted_1);
            }), 128 /* KEYED_FRAGMENT */ ))
        ], 6 /* CLASS, STYLE */ ),
        $props.arrow ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "carousel-arrow",
                {
                    "is-hovered": $options.settings.arrowHover
                }
            ])
        }, [
            (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                class: "has-icons-left",
                onClick: (0, _vue.withModifiers)($options.prev, [
                    "prevent"
                ]),
                pack: $options.settings.iconPack,
                icon: $options.settings.iconPrev,
                size: $options.settings.iconSize,
                both: ""
            }, null, 8 /* PROPS */ , [
                "onClick",
                "pack",
                "icon",
                "size"
            ]), [
                [
                    (0, _vue.vShow),
                    $options.hasPrev
                ]
            ]),
            (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                class: "has-icons-right",
                onClick: (0, _vue.withModifiers)($options.next, [
                    "prevent"
                ]),
                pack: $options.settings.iconPack,
                icon: $options.settings.iconNext,
                size: $options.settings.iconSize,
                both: ""
            }, null, 8 /* PROPS */ , [
                "onClick",
                "pack",
                "icon",
                "size"
            ]), [
                [
                    (0, _vue.vShow),
                    $options.hasNext
                ]
            ])
        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
    ], 34 /* CLASS, HYDRATE_EVENTS */ );
}
script.render = render;
script.__file = "src/components/carousel/CarouselList.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$2);
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","./Icon-fJqkx1gN.js":"gKXjn","./InjectedChildMixin-95-VbgK7.js":"3Zi8S","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","./Image-s3Blktdg.js":"4Orx2","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3Zi8S":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I", ()=>InjectedChildMixin);
parcelHelpers.export(exports, "P", ()=>ProviderParentMixin);
parcelHelpers.export(exports, "S", ()=>Sorted$1);
parcelHelpers.export(exports, "a", ()=>Sorted);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
function ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var items = 1;
var sorted$1 = 3;
var Sorted$1 = sorted$1;
var ProviderParentMixin = function(itemName) {
    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var mixin = {
        provide: function provide() {
            return (0, _helpersO9H6ICOJs._)({}, "b" + itemName, this);
        }
    };
    if ((0, _helpersO9H6ICOJs.h)(flags, items)) {
        mixin.data = function() {
            return _objectSpread$1({
                childItems: []
            }, (0, _helpersO9H6ICOJs.h)(flags, sorted$1) ? {
                nextIndex: 0
            } : {});
        };
        mixin.methods = {
            _registerItem: function _registerItem(item) {
                if ((0, _helpersO9H6ICOJs.h)(flags, sorted$1)) {
                    // assigns a dynamic index.
                    // dynamic indices will be messed up if any child is
                    // unmounted.
                    // use the new `order` prop to maintain the ordering.
                    item.dynamicIndex = this.nextIndex;
                    ++this.nextIndex;
                }
                this.childItems.push(item);
            },
            _unregisterItem: function _unregisterItem(item) {
                this.childItems = this.childItems.filter(function(i) {
                    return i.uniqueValue !== item.uniqueValue;
                });
            }
        };
        if ((0, _helpersO9H6ICOJs.h)(flags, sorted$1)) mixin.computed = {
            /**
         * When items are added/removed sort them according to their position
         */ sortedItems: function sortedItems() {
                return this.childItems.slice().sort(function(i1, i2) {
                    return i1.index - i2.index;
                });
            }
        };
    }
    return mixin;
};
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var sorted = 1;
var optional = 2;
var Sorted = sorted;
var InjectedChildMixin = function(parentItemName) {
    var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var mixin = {
        inject: {
            parent: {
                from: "b" + parentItemName,
                "default": false
            }
        },
        props: {
            // if `value` is non-null, it must be unique among all the siblings.
            // see `uniqueValue`
            value: {
                type: String,
                "default": null
            }
        },
        computed: {
            // `ProviderParentMixin` uses `uniqueValue` computed value to
            // identify the child in its `childItems` collection.
            // so the value must be unique among all the siblings.
            // falls back to the `uid` internal field to ensure uniqueness.
            uniqueValue: function uniqueValue() {
                return this.value != null ? this.value : this.$.uid;
            }
        },
        created: function created() {
            if (!this.parent) {
                if (!(0, _helpersO9H6ICOJs.h)(flags, optional)) throw new Error("You should wrap " + this.$options.name + " in a " + parentItemName);
            } else if (this.parent._registerItem) this.parent._registerItem(this);
        },
        beforeUnmount: function beforeUnmount() {
            if (this.parent && this.parent._unregisterItem) this.parent._unregisterItem(this);
        }
    };
    if ((0, _helpersO9H6ICOJs.h)(flags, sorted)) {
        // a user can explicitly specify the `order` prop to keep the order of
        // children.
        // I can no longer rely on automatic indexing of children, because I
        // could not figure out how to calculate the index of a child in its
        // parent on Vue 3.
        // incomplete dynamic indexing is still available if any child is never
        // unmounted; e.g., not switched with `v-if`
        mixin.props = _objectSpread(_objectSpread({}, mixin.props), {}, {
            order: {
                type: Number,
                required: false
            }
        });
        mixin.data = function() {
            return {
                dynamicIndex: null
            };
        };
        mixin.computed = _objectSpread(_objectSpread({}, mixin.computed), {}, {
            index: function index() {
                return this.order != null ? this.order : this.dynamicIndex;
            }
        });
    }
    return mixin;
};

},{"./helpers-O9h6_ICO.js":"9IzVa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4Orx2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var script = {
    name: "BImage",
    props: {
        src: String,
        alt: String,
        srcFallback: String,
        webpFallback: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultImageWebpFallback;
            }
        },
        lazy: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultImageLazy;
            }
        },
        responsive: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultImageResponsive;
            }
        },
        ratio: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultImageRatio;
            }
        },
        placeholder: String,
        srcset: String,
        srcsetSizes: Array,
        srcsetFormatter: {
            type: Function,
            default: (src, size, vm)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultImageSrcsetFormatter === "function") return (0, _configNHWiBviwJs.c).defaultImageSrcsetFormatter(src, size);
                else return vm.formatSrcset(src, size);
            }
        },
        rounded: {
            type: Boolean,
            default: false
        },
        captionFirst: {
            type: Boolean,
            default: false
        },
        customClass: String
    },
    emits: [
        "load",
        "error"
    ],
    data () {
        return {
            clientWidth: 0,
            webpSupportVerified: false,
            webpSupported: false,
            useNativeLazy: false,
            observer: null,
            inViewPort: false,
            bulmaKnownRatio: [
                "square",
                "1by1",
                "5by4",
                "4by3",
                "3by2",
                "5by3",
                "16by9",
                "b2y1",
                "3by1",
                "4by5",
                "3by4",
                "2by3",
                "3by5",
                "9by16",
                "1by2",
                "1by3"
            ],
            loaded: false,
            failed: false
        };
    },
    computed: {
        ratioPattern () {
            return /([0-9]+)by([0-9]+)/;
        },
        hasRatio () {
            return this.ratio && this.ratioPattern.test(this.ratio);
        },
        figureClasses () {
            const classes = {
                image: this.responsive
            };
            if (this.hasRatio && this.bulmaKnownRatio.indexOf(this.ratio) >= 0) classes[`is-${this.ratio}`] = true;
            return classes;
        },
        figureStyles () {
            if (this.hasRatio && this.bulmaKnownRatio.indexOf(this.ratio) < 0) {
                const ratioValues = this.ratioPattern.exec(this.ratio);
                return {
                    paddingTop: `${ratioValues[2] / ratioValues[1] * 100}%`
                };
            }
            return undefined;
        },
        imgClasses () {
            return {
                "is-rounded": this.rounded,
                "has-ratio": this.hasRatio,
                [this.customClass]: !!this.customClass
            };
        },
        srcExt () {
            return this.getExt(this.src);
        },
        isWepb () {
            return this.srcExt === "webp";
        },
        computedSrc () {
            let src = this.src;
            if (this.failed && this.srcFallback) src = this.srcFallback;
            if (!this.webpSupported && this.isWepb && this.webpFallback) {
                if (this.webpFallback.startsWith(".")) return src.replace(/\.webp/gi, `${this.webpFallback}`);
                return this.webpFallback;
            }
            return src;
        },
        computedWidth () {
            if (this.responsive && this.clientWidth > 0) return this.clientWidth;
            return undefined;
        },
        computedNativeLazy () {
            if (this.lazy && this.useNativeLazy) return "lazy";
            return undefined;
        },
        isDisplayed () {
            return (this.webpSupportVerified || !this.isWepb) && (!this.lazy || this.useNativeLazy || this.inViewPort);
        },
        placeholderExt () {
            if (this.placeholder) return this.getExt(this.placeholder);
            return undefined;
        },
        isPlaceholderWepb () {
            if (this.placeholder) return this.placeholderExt === "webp";
            return false;
        },
        computedPlaceholder () {
            if (!this.webpSupported && this.isPlaceholderWepb && this.webpFallback && this.webpFallback.startsWith(".")) return this.placeholder.replace(/\.webp/gi, `${this.webpFallback}`);
            return this.placeholder;
        },
        isPlaceholderDisplayed () {
            return !this.loaded && (this.$slots.placeholder || this.placeholder && (this.webpSupportVerified || !this.isPlaceholderWepb));
        },
        computedSrcset () {
            if (this.srcset) {
                if (!this.webpSupported && this.isWepb && this.webpFallback && this.webpFallback.startsWith(".")) return this.srcset.replace(/\.webp/gi, `${this.webpFallback}`);
                return this.srcset;
            }
            if (this.srcsetSizes && Array.isArray(this.srcsetSizes) && this.srcsetSizes.length > 0) return this.srcsetSizes.map((size)=>{
                return `${this.srcsetFormatter(this.computedSrc, size, this)} ${size}w`;
            }).join(",");
            return undefined;
        },
        computedSizes () {
            if (this.computedSrcset && this.computedWidth) return `${this.computedWidth}px`;
            return undefined;
        },
        isCaptionFirst () {
            return this.$slots.caption && this.captionFirst;
        },
        isCaptionLast () {
            return this.$slots.caption && !this.captionFirst;
        }
    },
    methods: {
        getExt (filename, clean = true) {
            if (filename) {
                const noParam = clean ? filename.split("?")[0] : filename;
                return noParam.split(".").pop();
            }
            return "";
        },
        setWidth () {
            this.clientWidth = this.$el.clientWidth;
        },
        formatSrcset (src, size) {
            const ext = this.getExt(src, false);
            const name = src.split(".").slice(0, -1).join(".");
            return `${name}-${size}.${ext}`;
        },
        onLoad (event) {
            this.loaded = true;
            this.emit("load", event);
        },
        onError (event) {
            this.emit("error", event);
            if (!this.failed) this.failed = true;
        },
        emit (eventName, event) {
            const { target } = event;
            this.$emit(eventName, event, target.currentSrc || target.src || this.computedSrc);
        }
    },
    created () {
        if (this.isWepb) (0, _helpersO9H6ICOJs.q)().then((supported)=>{
            this.webpSupportVerified = true;
            this.webpSupported = supported;
        });
        if (this.lazy) {
            // We use native lazy loading if supported
            // We try to use Intersection Observer if native lazy loading is not supported
            // We use the lazy attribute anyway if we cannot detect support (SSR for example).
            const nativeLazySupported = typeof window !== "undefined" && "HTMLImageElement" in window && "loading" in HTMLImageElement.prototype;
            const intersectionObserverSupported = typeof window !== "undefined" && "IntersectionObserver" in window;
            if (!nativeLazySupported && intersectionObserverSupported) this.observer = new IntersectionObserver((events)=>{
                const { target, isIntersecting } = events[0];
                if (isIntersecting && !this.inViewPort) {
                    this.inViewPort = true;
                    this.observer.unobserve(target);
                }
            });
            else this.useNativeLazy = true;
        }
    },
    mounted () {
        if (this.lazy && this.observer) this.observer.observe(this.$el);
        this.setWidth();
        if (typeof window !== "undefined") window.addEventListener("resize", this.setWidth);
    },
    beforeUnmount () {
        if (this.observer) this.observer.disconnect();
        if (typeof window !== "undefined") window.removeEventListener("resize", this.setWidth);
    }
};
const _hoisted_1 = {
    key: 0
};
const _hoisted_2 = [
    "srcset",
    "src",
    "alt",
    "width",
    "sizes",
    "loading"
];
const _hoisted_3 = [
    "src",
    "alt"
];
const _hoisted_4 = {
    key: 1
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("figure", {
        class: (0, _vue.normalizeClass)([
            "b-image-wrapper",
            $options.figureClasses
        ]),
        style: (0, _vue.normalizeStyle)($options.figureStyles)
    }, [
        $options.isCaptionFirst ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("figcaption", _hoisted_1, [
            (0, _vue.renderSlot)(_ctx.$slots, "caption")
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade"
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $options.isDisplayed ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("img", {
                        key: 0,
                        srcset: $options.computedSrcset,
                        src: $options.computedSrc,
                        alt: $props.alt,
                        class: (0, _vue.normalizeClass)($options.imgClasses),
                        width: $options.computedWidth,
                        sizes: $options.computedSizes,
                        loading: $options.computedNativeLazy,
                        onLoad: _cache[0] || (_cache[0] = (...args)=>$options.onLoad && $options.onLoad(...args)),
                        onError: _cache[1] || (_cache[1] = (...args)=>$options.onError && $options.onError(...args))
                    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_2)) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 1 /* STABLE */ 
        }),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: "fade"
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $options.isPlaceholderDisplayed ? (0, _vue.renderSlot)(_ctx.$slots, "placeholder", {
                        key: 0
                    }, ()=>[
                            (0, _vue.createElementVNode)("img", {
                                src: $options.computedPlaceholder,
                                alt: $props.alt,
                                class: (0, _vue.normalizeClass)([
                                    $options.imgClasses,
                                    "placeholder"
                                ])
                            }, null, 10 /* CLASS, PROPS */ , _hoisted_3)
                        ]) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 3 /* FORWARDED */ 
        }),
        $options.isCaptionLast ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("figcaption", _hoisted_4, [
            (0, _vue.renderSlot)(_ctx.$slots, "caption")
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 6 /* CLASS, STYLE */ );
}
script.render = render;
script.__file = "src/components/image/Image.vue";

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"j3TI6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BCheckbox", ()=>(0, _checkboxO2PhGepRJs.s));
parcelHelpers.export(exports, "BCheckboxButton", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _checkboxO2PhGepRJs = require("./Checkbox-o2PhGepR.js");
var _checkRadioMixinI9QgrPGQJs = require("./CheckRadioMixin-I9QgrPGQ.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var script = {
    name: "BCheckboxButton",
    mixins: [
        (0, _checkRadioMixinI9QgrPGQJs.C)
    ],
    props: {
        type: {
            type: String,
            default: "is-primary"
        },
        expanded: Boolean
    },
    data () {
        return {
            isFocused: false
        };
    },
    computed: {
        checked () {
            if (Array.isArray(this.newValue)) return this.newValue.indexOf(this.nativeValue) >= 0;
            return this.newValue === this.nativeValue;
        }
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = [
    "disabled",
    "required",
    "name",
    "value"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "control",
            {
                "is-expanded": $props.expanded
            }
        ])
    }, [
        (0, _vue.createElementVNode)("label", {
            class: (0, _vue.normalizeClass)([
                "b-checkbox checkbox button",
                [
                    $options.checked ? $props.type : null,
                    _ctx.size,
                    {
                        "is-disabled": _ctx.disabled,
                        "is-focused": $data.isFocused
                    }
                ]
            ]),
            ref: "label",
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.focus && _ctx.focus(...args)),
            onKeydown: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                type: "checkbox",
                ref: "input",
                onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                    "stop"
                ])),
                disabled: _ctx.disabledOrUndefined,
                required: _ctx.requiredOrUndefined,
                name: _ctx.name,
                value: _ctx.nativeValue,
                onFocus: _cache[2] || (_cache[2] = ($event)=>$data.isFocused = true),
                onBlur: _cache[3] || (_cache[3] = ($event)=>$data.isFocused = false)
            }, null, 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_2), [
                [
                    (0, _vue.vModelCheckbox),
                    _ctx.computedValue
                ]
            ])
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/checkbox/CheckboxButton.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _checkboxO2PhGepRJs.s));
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./Checkbox-o2PhGepR.js":"jf5YD","./CheckRadioMixin-I9QgrPGQ.js":"1U5Xe","vue":"dylud","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jf5YD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _checkRadioMixinI9QgrPGQJs = require("./CheckRadioMixin-I9QgrPGQ.js");
var _vue = require("vue");
var script = {
    name: "BCheckbox",
    mixins: [
        (0, _checkRadioMixinI9QgrPGQJs.C)
    ],
    props: {
        indeterminate: Boolean,
        ariaLabelledby: String,
        trueValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array
            ],
            default: true
        },
        falseValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array
            ],
            default: false
        },
        autocomplete: {
            type: String,
            default: "on"
        },
        inputId: {
            type: String,
            default: ""
        }
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = [
    "id",
    ".indeterminate",
    "autocomplete",
    "disabled",
    "required",
    "name",
    "value",
    "true-value",
    "false-value",
    "aria-labelledby"
];
const _hoisted_3 = [
    "id"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "b-checkbox checkbox",
            [
                _ctx.size,
                {
                    "is-disabled": _ctx.disabled
                }
            ]
        ]),
        ref: "label",
        disabled: _ctx.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.focus && _ctx.focus(...args)),
        onKeydown: [
            _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ])),
            _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "space"
            ]))
        ]
    }, [
        (0, _vue.createCommentVNode)(" Checkbox needs to listen for a space event instead of a just a\n             click and enter event so that that using the keyboard spacebar will also\n             trigger the checkbox change in the b-table "),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
            id: $props.inputId,
            ".indeterminate": $props.indeterminate,
            type: "checkbox",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            autocomplete: $props.autocomplete,
            disabled: _ctx.disabledOrUndefined,
            required: _ctx.requiredOrUndefined,
            name: _ctx.name,
            value: _ctx.nativeValue,
            "true-value": $props.trueValue,
            "false-value": $props.falseValue,
            "aria-labelledby": $props.ariaLabelledby
        }, null, 8 /* PROPS */ , _hoisted_2), [
            [
                (0, _vue.vModelCheckbox),
                _ctx.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                _ctx.type
            ])
        }, null, 2 /* CLASS */ ),
        (0, _vue.createElementVNode)("span", {
            id: $props.ariaLabelledby,
            class: "control-label"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8 /* PROPS */ , _hoisted_3)
    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1);
}
script.render = render;
script.__file = "src/components/checkbox/Checkbox.vue";

},{"./CheckRadioMixin-I9QgrPGQ.js":"1U5Xe","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1U5Xe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>CheckRadioMixin);
var CheckRadioMixin = {
    props: {
        modelValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        nativeValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        type: String,
        disabled: Boolean,
        required: Boolean,
        name: String,
        size: String
    },
    emits: [
        "update:modelValue"
    ],
    data: function data() {
        return {
            newValue: this.modelValue
        };
    },
    computed: {
        computedValue: {
            get: function get() {
                return this.newValue;
            },
            set: function set(value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        disabledOrUndefined: function disabledOrUndefined() {
            // On Vue 3, setting a boolean attribute `false` does not remove it.
            // To remove it, `null` or `undefined` has to be given.
            // Setting `false` ends up with a grayed out component.
            return this.disabled || undefined;
        },
        requiredOrUndefined: function requiredOrUndefined() {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.required || undefined;
        }
    },
    watch: {
        /**
    * When v-model change, set internal value.
    */ modelValue: function modelValue(value) {
            this.newValue = value;
        }
    },
    methods: {
        focus: function focus() {
            // MacOS FireFox and Safari do not focus when clicked
            this.$refs.input.focus();
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e4ZT5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BCollapse", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var script = {
    name: "BCollapse",
    props: {
        modelValue: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        ariaId: {
            type: String,
            default: ""
        },
        position: {
            type: String,
            default: "is-top",
            validator (value) {
                return [
                    "is-top",
                    "is-bottom"
                ].indexOf(value) > -1;
            }
        }
    },
    emits: [
        "close",
        "open",
        "update:modelValue"
    ],
    data () {
        return {
            isOpen: this.modelValue
        };
    },
    watch: {
        modelValue (value) {
            this.isOpen = value;
        }
    },
    methods: {
        /**
        * Toggle and emit events
        */ toggle () {
            this.isOpen = !this.isOpen;
            this.$emit("update:modelValue", this.isOpen);
            this.$emit(this.isOpen ? "open" : "close");
        }
    },
    render () {
        const trigger = (0, _vue.h)("div", {
            class: "collapse-trigger",
            onClick: this.toggle
        }, this.$slots.trigger ? this.$slots.trigger({
            open: this.isOpen
        }) : undefined);
        const content = (0, _vue.withDirectives)((0, _vue.h)((0, _vue.Transition), {
            name: this.animation
        }, ()=>[
                (0, _vue.h)("div", {
                    class: "collapse-content",
                    id: this.ariaId
                }, this.$slots)
            ]), [
            [
                (0, _vue.vShow),
                this.isOpen
            ]
        ]);
        return (0, _vue.h)("div", {
            class: "collapse"
        }, this.position === "is-top" ? [
            trigger,
            content
        ] : [
            content,
            trigger
        ]);
    }
};
script.__file = "src/components/collapse/Collapse.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"vue":"dylud","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kkLVT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BClockpicker", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _timepickerMixinMPQh7UTJs = require("./TimepickerMixin-M_pQh7UT.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
// These should match the variables in clockpicker.scss
const indicatorSize = 40;
const paddingInner = 5;
var script$1 = {
    name: "BClockpickerFace",
    props: {
        pickerSize: Number,
        min: Number,
        max: Number,
        double: Boolean,
        value: Number,
        faceNumbers: Array,
        disabledValues: Function
    },
    emits: [
        "change",
        "input"
    ],
    data () {
        return {
            isDragging: false,
            inputValue: this.value,
            prevAngle: 720
        };
    },
    computed: {
        /**
        * How many number indicators are shown on the face
        */ count () {
            return this.max - this.min + 1;
        },
        /**
        * How many number indicators are shown per ring on the face
        */ countPerRing () {
            return this.double ? this.count / 2 : this.count;
        },
        /**
        * Radius of the clock face
        */ radius () {
            return this.pickerSize / 2;
        },
        /**
        * Radius of the outer ring of number indicators
        */ outerRadius () {
            return this.radius - paddingInner - indicatorSize / 2;
        },
        /**
        * Radius of the inner ring of number indicators
        */ innerRadius () {
            return Math.max(this.outerRadius * 0.6, this.outerRadius - paddingInner - indicatorSize);
        // 48px gives enough room for the outer ring of numbers
        },
        /**
        * The angle for each selectable value
        * For hours this ends up being 30 degrees, for minutes 6 degrees
        */ degreesPerUnit () {
            return 360 / this.countPerRing;
        },
        /**
        * Used for calculating x/y grid location based on degrees
        */ degrees () {
            return this.degreesPerUnit * Math.PI / 180;
        },
        /**
        * Calculates the angle the clock hand should be rotated for the
        * selected value
        */ handRotateAngle () {
            let currentAngle = this.prevAngle;
            while(currentAngle < 0)currentAngle += 360;
            const targetAngle = this.calcHandAngle(this.displayedValue);
            const degreesDiff = this.shortestDistanceDegrees(currentAngle, targetAngle);
            const angle = this.prevAngle + degreesDiff;
            return angle;
        },
        /**
        * Determines how long the selector hand is based on if the
        * selected value is located along the outer or inner ring
        */ handScale () {
            return this.calcHandScale(this.displayedValue);
        },
        handStyle () {
            return {
                transform: `rotate(${this.handRotateAngle}deg) scaleY(${this.handScale})`,
                transition: ".3s cubic-bezier(.25,.8,.50,1)"
            };
        },
        /**
        * The value the hand should be pointing at
        */ displayedValue () {
            return this.inputValue == null ? this.min : this.inputValue;
        }
    },
    watch: {
        value (value) {
            if (value !== this.inputValue) this.prevAngle = this.handRotateAngle;
            this.inputValue = value;
        }
    },
    methods: {
        isDisabled (value) {
            return this.disabledValues && this.disabledValues(value);
        },
        /**
        * Calculates the distance between two points
        */ euclidean (p0, p1) {
            const dx = p1.x - p0.x;
            const dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
        },
        shortestDistanceDegrees (start, stop) {
            const modDiff = (stop - start) % 360;
            const shortestDistance = 180 - Math.abs(Math.abs(modDiff) - 180);
            return (modDiff + 360) % 360 < 180 ? shortestDistance * 1 : shortestDistance * -1;
        },
        /**
        * Calculates the angle of the line from the center point
        * to the given point.
        */ coordToAngle (center, p1) {
            const value = 2 * Math.atan2(p1.y - center.y - this.euclidean(center, p1), p1.x - center.x);
            return Math.abs(value * 180 / Math.PI);
        },
        /**
        * Generates the inline style translate() property for a
        * number indicator, which determines it's location on the
        * clock face
        */ getNumberTranslate (value) {
            const { x, y } = this.getNumberCoords(value);
            return `translate(${x}px, ${y}px)`;
        },
        /***
        * Calculates the coordinates on the clock face for a number
        * indicator value
        */ getNumberCoords (value) {
            const radius = this.isInnerRing(value) ? this.innerRadius : this.outerRadius;
            return {
                x: Math.round(radius * Math.sin((value - this.min) * this.degrees)),
                y: Math.round(-radius * Math.cos((value - this.min) * this.degrees))
            };
        },
        getFaceNumberClasses (num) {
            return {
                active: num.value === this.displayedValue,
                disabled: this.isDisabled(num.value)
            };
        },
        /**
        * Determines if a value resides on the inner ring
        */ isInnerRing (value) {
            return this.double && value - this.min >= this.countPerRing;
        },
        calcHandAngle (value) {
            let angle = this.degreesPerUnit * (value - this.min);
            if (this.isInnerRing(value)) angle -= 360;
            return angle;
        },
        calcHandScale (value) {
            return this.isInnerRing(value) ? this.innerRadius / this.outerRadius : 1;
        },
        onMouseDown (e) {
            e.preventDefault();
            this.isDragging = true;
            this.onDragMove(e);
        },
        onMouseUp () {
            this.isDragging = false;
            if (!this.isDisabled(this.inputValue)) this.$emit("change", this.inputValue);
        },
        onDragMove (e) {
            e.preventDefault();
            if (!this.isDragging && e.type !== "click") return;
            const { width, top, left } = this.$refs.clock.getBoundingClientRect();
            const { clientX, clientY } = "touches" in e ? e.touches[0] : e;
            const center = {
                x: width / 2,
                y: -width / 2
            };
            const coords = {
                x: clientX - left,
                y: top - clientY
            };
            const handAngle = Math.round(this.coordToAngle(center, coords) + 360) % 360;
            const insideClick = this.double && this.euclidean(center, coords) < (this.outerRadius + this.innerRadius) / 2 - 16;
            let value = Math.round(handAngle / this.degreesPerUnit) + this.min + (insideClick ? this.countPerRing : 0);
            // Necessary to fix edge case when selecting left part of max value
            if (handAngle >= 360 - this.degreesPerUnit / 2) value = insideClick ? this.max : this.min;
            this.update(value);
        },
        update (value) {
            if (this.inputValue !== value && !this.isDisabled(value)) {
                this.prevAngle = this.handRotateAngle;
                this.inputValue = value;
                this.$emit("input", value);
            }
        }
    }
};
const _hoisted_1$1 = {
    class: "b-clockpicker-face-outer-ring",
    ref: "clock"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-clockpicker-face",
        onMousedown: _cache[0] || (_cache[0] = (...args)=>$options.onMouseDown && $options.onMouseDown(...args)),
        onMouseup: _cache[1] || (_cache[1] = (...args)=>$options.onMouseUp && $options.onMouseUp(...args)),
        onMousemove: _cache[2] || (_cache[2] = (...args)=>$options.onDragMove && $options.onDragMove(...args)),
        onTouchstart: _cache[3] || (_cache[3] = (...args)=>$options.onMouseDown && $options.onMouseDown(...args)),
        onTouchend: _cache[4] || (_cache[4] = (...args)=>$options.onMouseUp && $options.onMouseUp(...args)),
        onTouchmove: _cache[5] || (_cache[5] = (...args)=>$options.onDragMove && $options.onDragMove(...args))
    }, [
        (0, _vue.createElementVNode)("div", _hoisted_1$1, [
            (0, _vue.createElementVNode)("div", {
                class: "b-clockpicker-face-hand",
                style: (0, _vue.normalizeStyle)($options.handStyle)
            }, null, 4 /* STYLE */ ),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.faceNumbers, (num, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
                    key: index,
                    class: (0, _vue.normalizeClass)([
                        "b-clockpicker-face-number",
                        $options.getFaceNumberClasses(num)
                    ]),
                    style: (0, _vue.normalizeStyle)({
                        transform: $options.getNumberTranslate(num.value)
                    })
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(num.label), 1 /* TEXT */ )
                ], 6 /* CLASS, STYLE */ );
            }), 128 /* KEYED_FRAGMENT */ ))
        ], 512 /* NEED_PATCH */ )
    ], 32 /* HYDRATE_EVENTS */ );
}
script$1.render = render$1;
script$1.__file = "src/components/clockpicker/ClockpickerFace.vue";
const outerPadding = 12;
var script = {
    name: "BClockpicker",
    components: {
        [script$1.name]: script$1,
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _fieldCMd66V8HJs.s).name]: (0, _fieldCMd66V8HJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _dropdownItemYQcaSZL4Js.s).name]: (0, _dropdownItemYQcaSZL4Js.s),
        [(0, _dropdownItemYQcaSZL4Js.a).name]: (0, _dropdownItemYQcaSZL4Js.a)
    },
    mixins: [
        (0, _timepickerMixinMPQh7UTJs.T)
    ],
    props: {
        pickerSize: {
            type: Number,
            default: 290
        },
        incrementMinutes: {
            type: Number,
            default: 5
        },
        autoSwitch: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: "is-primary"
        },
        hoursLabel: {
            type: String,
            default: ()=>(0, _configNHWiBviwJs.c).defaultClockpickerHoursLabel || "Hours"
        },
        minutesLabel: {
            type: String,
            default: ()=>(0, _configNHWiBviwJs.c).defaultClockpickerMinutesLabel || "Min"
        }
    },
    data () {
        return {
            isSelectingHour: true,
            isDragging: false,
            _isClockpicker: true
        };
    },
    computed: {
        hoursDisplay () {
            if (this.hoursSelected == null) return "--";
            if (this.isHourFormat24) return this.pad(this.hoursSelected);
            let display = this.hoursSelected;
            if (this.meridienSelected === this.pmString) display -= 12;
            if (display === 0) display = 12;
            return display;
        },
        minutesDisplay () {
            return this.minutesSelected == null ? "--" : this.pad(this.minutesSelected);
        },
        minFaceValue () {
            return this.isSelectingHour && !this.isHourFormat24 && this.meridienSelected === this.pmString ? 12 : 0;
        },
        maxFaceValue () {
            return this.isSelectingHour ? !this.isHourFormat24 && this.meridienSelected === this.amString ? 11 : 23 : 59;
        },
        faceSize () {
            return this.pickerSize - outerPadding * 2;
        },
        faceDisabledValues () {
            return this.isSelectingHour ? this.isHourDisabled : this.isMinuteDisabled;
        }
    },
    methods: {
        onClockInput (value) {
            if (this.isSelectingHour) {
                this.hoursSelected = value;
                this.onHoursChange(value);
            } else {
                this.minutesSelected = value;
                this.onMinutesChange(value);
            }
        },
        onClockChange (value) {
            if (this.autoSwitch && this.isSelectingHour) this.isSelectingHour = !this.isSelectingHour;
        },
        onMeridienClick (value) {
            if (this.meridienSelected !== value) {
                this.meridienSelected = value;
                this.onMeridienChange(value);
            }
        },
        /*
         * Avoid dropdown toggle when is already visible
         */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        }
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = {
    key: 0,
    class: "card-header"
};
const _hoisted_3 = {
    class: "b-clockpicker-header card-header-title"
};
const _hoisted_4 = {
    class: "b-clockpicker-time"
};
const _hoisted_5 = {
    key: 0,
    class: "b-clockpicker-period"
};
const _hoisted_6 = {
    class: "card-content"
};
const _hoisted_7 = {
    key: 0,
    class: "b-clockpicker-time"
};
const _hoisted_8 = {
    key: 1,
    class: "b-clockpicker-period"
};
const _hoisted_9 = {
    key: 1,
    class: "b-clockpicker-footer card-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_clockpicker_face = (0, _vue.resolveComponent)("b-clockpicker-face");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-clockpicker control",
            [
                _ctx.size,
                $props.type,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            disabled: _ctx.disabledOrUndefined,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createElementVNode)("div", {
                        class: "card",
                        disabled: _ctx.disabledOrUndefined,
                        custom: ""
                    }, [
                        _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_2, [
                            (0, _vue.createElementVNode)("div", _hoisted_3, [
                                (0, _vue.createElementVNode)("div", _hoisted_4, [
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: $data.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[3] || (_cache[3] = ($event)=>$data.isSelectingHour = true)
                                    }, (0, _vue.toDisplayString)($options.hoursDisplay), 3 /* TEXT, CLASS */ ),
                                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(_ctx.hourLiteral), 1 /* TEXT */ ),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: !$data.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[4] || (_cache[4] = ($event)=>$data.isSelectingHour = false)
                                    }, (0, _vue.toDisplayString)($options.minutesDisplay), 3 /* TEXT, CLASS */ )
                                ]),
                                !_ctx.isHourFormat24 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_5, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.amString || _ctx.meridienSelected === _ctx.AM
                                            }
                                        ]),
                                        onClick: _cache[5] || (_cache[5] = ($event)=>$options.onMeridienClick(_ctx.amString))
                                    }, (0, _vue.toDisplayString)(_ctx.amString), 3 /* TEXT, CLASS */ ),
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.pmString || _ctx.meridienSelected === _ctx.PM
                                            }
                                        ]),
                                        onClick: _cache[6] || (_cache[6] = ($event)=>$options.onMeridienClick(_ctx.pmString))
                                    }, (0, _vue.toDisplayString)(_ctx.pmString), 3 /* TEXT, CLASS */ )
                                ])) : (0, _vue.createCommentVNode)("v-if", true)
                            ])
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            (0, _vue.createElementVNode)("div", {
                                class: "b-clockpicker-body",
                                style: (0, _vue.normalizeStyle)({
                                    width: $options.faceSize + "px",
                                    height: $options.faceSize + "px"
                                })
                            }, [
                                !_ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: $data.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[7] || (_cache[7] = ($event)=>$data.isSelectingHour = true)
                                    }, (0, _vue.toDisplayString)($props.hoursLabel), 3 /* TEXT, CLASS */ ),
                                    (0, _vue.createElementVNode)("span", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: !$data.isSelectingHour
                                            }
                                        ]),
                                        onClick: _cache[8] || (_cache[8] = ($event)=>$data.isSelectingHour = false)
                                    }, (0, _vue.toDisplayString)($props.minutesLabel), 3 /* TEXT, CLASS */ )
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                !_ctx.isHourFormat24 && !_ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_8, [
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.amString || _ctx.meridienSelected === _ctx.AM
                                            }
                                        ]),
                                        onClick: _cache[9] || (_cache[9] = ($event)=>$options.onMeridienClick(_ctx.amString))
                                    }, (0, _vue.toDisplayString)(_ctx.amString), 3 /* TEXT, CLASS */ ),
                                    (0, _vue.createElementVNode)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "b-clockpicker-btn",
                                            {
                                                active: _ctx.meridienSelected === _ctx.pmString || _ctx.meridienSelected === _ctx.PM
                                            }
                                        ]),
                                        onClick: _cache[10] || (_cache[10] = ($event)=>$options.onMeridienClick(_ctx.pmString))
                                    }, (0, _vue.toDisplayString)(_ctx.pmString), 3 /* TEXT, CLASS */ )
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                (0, _vue.createVNode)(_component_b_clockpicker_face, {
                                    "picker-size": $options.faceSize,
                                    min: $options.minFaceValue,
                                    max: $options.maxFaceValue,
                                    "face-numbers": $data.isSelectingHour ? _ctx.hours : _ctx.minutes,
                                    "disabled-values": $options.faceDisabledValues,
                                    double: $data.isSelectingHour && _ctx.isHourFormat24,
                                    value: $data.isSelectingHour ? _ctx.hoursSelected : _ctx.minutesSelected,
                                    onInput: $options.onClockInput,
                                    onChange: $options.onClockChange
                                }, null, 8 /* PROPS */ , [
                                    "picker-size",
                                    "min",
                                    "max",
                                    "face-numbers",
                                    "disabled-values",
                                    "double",
                                    "value",
                                    "onInput",
                                    "onChange"
                                ])
                            ], 4 /* STYLE */ )
                        ]),
                        _ctx.$slots.default !== undefined && _ctx.$slots.default().length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", _hoisted_9, [
                            (0, _vue.renderSlot)(_ctx.$slots, "default")
                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 8 /* PROPS */ , _hoisted_1)
                ]),
            _: 2 /* DYNAMIC */ 
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    value: _ctx.formatValue(_ctx.computedValue),
                                    placeholder: _ctx.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-pack": _ctx.iconPack,
                                    loading: _ctx.loading,
                                    disabled: _ctx.disabledOrUndefined,
                                    readonly: !_ctx.editable,
                                    rounded: _ctx.rounded
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": _ctx.useHtml5Validation,
                                    onClick: $options.onInputClick,
                                    onKeyup: _cache[0] || (_cache[0] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.onChange($event.target.value)),
                                    onFocus: _ctx.handleOnFocus,
                                    onBlur: _cache[2] || (_cache[2] = ($event)=>_ctx.checkHtml5Validity())
                                }), null, 16 /* FULL_PROPS */ , [
                                    "value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-pack",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "rounded",
                                    "use-html5-validation",
                                    "onClick",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */ , [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: "time",
            autocomplete: "off",
            value: _ctx.formatHHMMSS(_ctx.computedValue),
            placeholder: _ctx.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            loading: _ctx.loading,
            max: _ctx.formatHHMMSS(_ctx.maxTime),
            min: _ctx.formatHHMMSS(_ctx.minTime),
            disabled: _ctx.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": _ctx.useHtml5Validation,
            onClick: _cache[11] || (_cache[11] = (0, _vue.withModifiers)(($event)=>_ctx.toggle(true), [
                "stop"
            ])),
            onKeyup: _cache[12] || (_cache[12] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                "enter"
            ])),
            onChange: _ctx.onChangeNativePicker,
            onFocus: _ctx.handleOnFocus,
            onBlur: _cache[13] || (_cache[13] = ($event)=>_ctx.onBlur() && _ctx.checkHtml5Validity())
        }), null, 16 /* FULL_PROPS */ , [
            "value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "loading",
            "max",
            "min",
            "disabled",
            "use-html5-validation",
            "onChange",
            "onFocus"
        ]))
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/clockpicker/Clockpicker.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./TimepickerMixin-M_pQh7UT.js":"gf5bH","./config-nHWiBviw.js":"4fneA","./DropdownItem-yQcaSZL4.js":"jPdf6","./Input-0ivJhXUC.js":"jYQke","./Field-CMd66v8h.js":"h48jl","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","./trapFocus-IMs77O3T.js":"jBg9U","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gf5bH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "T", ()=>TimepickerMixin);
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var AM = "AM";
var PM = "PM";
var HOUR_FORMAT_24 = "24";
var HOUR_FORMAT_12 = "12";
var defaultTimeFormatter = function defaultTimeFormatter(date, vm) {
    return vm.dtf.format(date);
};
var defaultTimeParser = function defaultTimeParser(timeString, vm) {
    if (timeString) {
        var d = null;
        if (vm.computedValue && !isNaN(vm.computedValue)) d = new Date(vm.computedValue);
        else {
            d = vm.timeCreator();
            d.setMilliseconds(0);
        }
        if (vm.dtf.formatToParts && typeof vm.dtf.formatToParts === "function") {
            var formatRegex = vm.dtf.formatToParts(d).map(function(part) {
                if (part.type === "literal") return part.value.replace(/ /g, "\\s?");
                else if (part.type === "dayPeriod") return "((?!=<".concat(part.type, ">)(").concat(vm.amString, "|").concat(vm.pmString, "|").concat(AM, "|").concat(PM, "|").concat(AM.toLowerCase(), "|").concat(PM.toLowerCase(), ")?)");
                return "((?!=<".concat(part.type, ">)\\d+)");
            }).join("");
            var timeGroups = (0, _helpersO9H6ICOJs.p)(formatRegex, timeString);
            // We do a simple validation for the group.
            // If it is not valid, it will fallback to Date.parse below
            timeGroups.hour = timeGroups.hour ? parseInt(timeGroups.hour, 10) : null;
            timeGroups.minute = timeGroups.minute ? parseInt(timeGroups.minute, 10) : null;
            timeGroups.second = timeGroups.second ? parseInt(timeGroups.second, 10) : null;
            if (timeGroups.hour && timeGroups.hour >= 0 && timeGroups.hour < 24 && timeGroups.minute && timeGroups.minute >= 0 && timeGroups.minute < 59) {
                if (timeGroups.dayPeriod && (timeGroups.dayPeriod.toLowerCase() === vm.pmString.toLowerCase() || timeGroups.dayPeriod.toLowerCase() === PM.toLowerCase()) && timeGroups.hour < 12) timeGroups.hour += 12;
                d.setHours(timeGroups.hour);
                d.setMinutes(timeGroups.minute);
                d.setSeconds(timeGroups.second || 0);
                return d;
            }
        }
        // Fallback if formatToParts is not supported or if we were not able to parse a valid date
        var am = false;
        if (vm.hourFormat === HOUR_FORMAT_12) {
            var dateString12 = timeString.split(" ");
            timeString = dateString12[0];
            am = dateString12[1] === vm.amString || dateString12[1] === AM;
        }
        var time = timeString.split(":");
        var hours = parseInt(time[0], 10);
        var minutes = parseInt(time[1], 10);
        var seconds = vm.enableSeconds ? parseInt(time[2], 10) : 0;
        if (isNaN(hours) || hours < 0 || hours > 23 || vm.hourFormat === HOUR_FORMAT_12 && (hours < 1 || hours > 12) || isNaN(minutes) || minutes < 0 || minutes > 59) return null;
        d.setSeconds(seconds);
        d.setMinutes(minutes);
        if (vm.hourFormat === HOUR_FORMAT_12) {
            if (am && hours === 12) hours = 0;
            else if (!am && hours !== 12) hours += 12;
        }
        d.setHours(hours);
        return new Date(d.getTime());
    }
    return null;
};
var TimepickerMixin = {
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: Date,
        inline: Boolean,
        minTime: Date,
        maxTime: Date,
        placeholder: String,
        editable: Boolean,
        disabled: Boolean,
        hourFormat: {
            type: String,
            validator: function validator(value) {
                return value === HOUR_FORMAT_24 || value === HOUR_FORMAT_12;
            }
        },
        incrementHours: {
            type: Number,
            "default": 1
        },
        incrementMinutes: {
            type: Number,
            "default": 1
        },
        incrementSeconds: {
            type: Number,
            "default": 1
        },
        timeFormatter: {
            type: Function,
            "default": function _default(date, vm) {
                if (typeof (0, _configNHWiBviwJs.c).defaultTimeFormatter === "function") return (0, _configNHWiBviwJs.c).defaultTimeFormatter(date);
                else return defaultTimeFormatter(date, vm);
            }
        },
        timeParser: {
            type: Function,
            "default": function _default(date, vm) {
                if (typeof (0, _configNHWiBviwJs.c).defaultTimeParser === "function") return (0, _configNHWiBviwJs.c).defaultTimeParser(date);
                else return defaultTimeParser(date, vm);
            }
        },
        mobileNative: {
            type: Boolean,
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultTimepickerMobileNative;
            }
        },
        mobileModal: {
            type: Boolean,
            "default": function _default() {
                return (0, _configNHWiBviwJs.c).defaultTimepickerMobileModal;
            }
        },
        timeCreator: {
            type: Function,
            "default": function _default() {
                if (typeof (0, _configNHWiBviwJs.c).defaultTimeCreator === "function") return (0, _configNHWiBviwJs.c).defaultTimeCreator();
                else return new Date();
            }
        },
        position: String,
        unselectableTimes: Array,
        openOnFocus: Boolean,
        enableSeconds: Boolean,
        defaultMinutes: Number,
        defaultSeconds: Number,
        focusable: {
            type: Boolean,
            "default": true
        },
        tzOffset: {
            type: Number,
            "default": 0
        },
        appendToBody: Boolean,
        resetOnMeridianChange: {
            type: Boolean,
            "default": false
        }
    },
    emits: [
        "update:modelValue"
    ],
    data: function data() {
        return {
            dateSelected: this.modelValue,
            hoursSelected: null,
            minutesSelected: null,
            secondsSelected: null,
            meridienSelected: null,
            _elementRef: "input",
            AM: AM,
            PM: PM,
            HOUR_FORMAT_24: HOUR_FORMAT_24,
            HOUR_FORMAT_12: HOUR_FORMAT_12
        };
    },
    computed: {
        computedValue: {
            get: function get() {
                return this.dateSelected;
            },
            set: function set(value) {
                this.dateSelected = value;
                this.$emit("update:modelValue", this.dateSelected);
            }
        },
        localeOptions: function localeOptions() {
            return new Intl.DateTimeFormat(this.locale, {
                hour: "numeric",
                minute: "numeric",
                second: this.enableSeconds ? "numeric" : undefined
            }).resolvedOptions();
        },
        dtf: function dtf() {
            return new Intl.DateTimeFormat(this.locale, {
                hour: this.localeOptions.hour || "numeric",
                minute: this.localeOptions.minute || "numeric",
                second: this.enableSeconds ? this.localeOptions.second || "numeric" : undefined,
                // Fixes 12 hour display github.com/buefy/buefy/issues/3418
                hourCycle: !this.isHourFormat24 ? "h12" : "h23"
            });
        },
        newHourFormat: function newHourFormat() {
            return this.hourFormat || (this.localeOptions.hour12 ? HOUR_FORMAT_12 : HOUR_FORMAT_24);
        },
        sampleTime: function sampleTime() {
            var d = this.timeCreator();
            d.setHours(10);
            d.setSeconds(0);
            d.setMinutes(0);
            d.setMilliseconds(0);
            return d;
        },
        hourLiteral: function hourLiteral() {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                var d = this.sampleTime;
                var parts = this.dtf.formatToParts(d);
                var literal = parts.find(function(part, idx) {
                    return idx > 0 && parts[idx - 1].type === "hour";
                });
                if (literal) return literal.value;
            }
            return ":";
        },
        minuteLiteral: function minuteLiteral() {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                var d = this.sampleTime;
                var parts = this.dtf.formatToParts(d);
                var literal = parts.find(function(part, idx) {
                    return idx > 0 && parts[idx - 1].type === "minute";
                });
                if (literal) return literal.value;
            }
            return ":";
        },
        secondLiteral: function secondLiteral() {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                var d = this.sampleTime;
                var parts = this.dtf.formatToParts(d);
                var literal = parts.find(function(part, idx) {
                    return idx > 0 && parts[idx - 1].type === "second";
                });
                if (literal) return literal.value;
            }
        },
        amString: function amString() {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                var d = this.sampleTime;
                d.setHours(10);
                var dayPeriod = this.dtf.formatToParts(d).find(function(part) {
                    return part.type === "dayPeriod";
                });
                if (dayPeriod) return dayPeriod.value;
            }
            return AM;
        },
        pmString: function pmString() {
            if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                var d = this.sampleTime;
                d.setHours(20);
                var dayPeriod = this.dtf.formatToParts(d).find(function(part) {
                    return part.type === "dayPeriod";
                });
                if (dayPeriod) return dayPeriod.value;
            }
            return PM;
        },
        hours: function hours() {
            if (!this.incrementHours || this.incrementHours < 1) throw new Error("Hour increment cannot be null or less than 1.");
            var hours = [];
            var numberOfHours = this.isHourFormat24 ? 24 : 12;
            for(var i = 0; i < numberOfHours; i += this.incrementHours){
                var value = i;
                var label = value;
                if (!this.isHourFormat24) {
                    value = i + 1;
                    label = value;
                    if (this.meridienSelected === this.amString) {
                        if (value === 12) value = 0;
                    } else if (this.meridienSelected === this.pmString) {
                        if (value !== 12) value += 12;
                    }
                }
                hours.push({
                    label: this.formatNumber(label),
                    value: value
                });
            }
            return hours;
        },
        minutes: function minutes() {
            if (!this.incrementMinutes || this.incrementMinutes < 1) throw new Error("Minute increment cannot be null or less than 1.");
            var minutes = [];
            for(var i = 0; i < 60; i += this.incrementMinutes)minutes.push({
                label: this.formatNumber(i, true),
                value: i
            });
            return minutes;
        },
        seconds: function seconds() {
            if (!this.incrementSeconds || this.incrementSeconds < 1) throw new Error("Second increment cannot be null or less than 1.");
            var seconds = [];
            for(var i = 0; i < 60; i += this.incrementSeconds)seconds.push({
                label: this.formatNumber(i, true),
                value: i
            });
            return seconds;
        },
        meridiens: function meridiens() {
            return [
                this.amString,
                this.pmString
            ];
        },
        isMobile: function isMobile$1() {
            return this.mobileNative && (0, _helpersO9H6ICOJs.c).any();
        },
        isHourFormat24: function isHourFormat24() {
            return this.newHourFormat === HOUR_FORMAT_24;
        },
        disabledOrUndefined: function disabledOrUndefined() {
            return this.disabled || undefined;
        }
    },
    watch: {
        hourFormat: function hourFormat() {
            if (this.hoursSelected !== null) this.meridienSelected = this.hoursSelected >= 12 ? this.pmString : this.amString;
        },
        locale: function locale() {
            // see updateInternalState default
            if (!this.value) this.meridienSelected = this.amString;
        },
        /**
     * When v-model is changed:
     *   1. Update internal value.
     *   2. If it's invalid, validate again.
     */ modelValue: {
            handler: function handler(value) {
                this.updateInternalState(value);
                !this.isValid && this.$refs.input.checkHtml5Validity();
            },
            immediate: true
        }
    },
    methods: {
        onMeridienChange: function onMeridienChange(value) {
            if (this.hoursSelected !== null && this.resetOnMeridianChange) {
                this.hoursSelected = null;
                this.minutesSelected = null;
                this.secondsSelected = null;
                this.computedValue = null;
            } else if (this.hoursSelected !== null) {
                if (value === this.pmString) this.hoursSelected += 12;
                else if (value === this.amString) this.hoursSelected -= 12;
            }
            this.updateDateSelected(this.hoursSelected, this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, value);
        },
        onHoursChange: function onHoursChange(value) {
            if (!this.minutesSelected && typeof this.defaultMinutes !== "undefined") this.minutesSelected = this.defaultMinutes;
            if (!this.secondsSelected && typeof this.defaultSeconds !== "undefined") this.secondsSelected = this.defaultSeconds;
            this.updateDateSelected(parseInt(value, 10), this.minutesSelected, this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
        },
        onMinutesChange: function onMinutesChange(value) {
            if (!this.secondsSelected && this.defaultSeconds) this.secondsSelected = this.defaultSeconds;
            this.updateDateSelected(this.hoursSelected, parseInt(value, 10), this.enableSeconds ? this.secondsSelected : 0, this.meridienSelected);
        },
        onSecondsChange: function onSecondsChange(value) {
            this.updateDateSelected(this.hoursSelected, this.minutesSelected, parseInt(value, 10), this.meridienSelected);
        },
        updateDateSelected: function updateDateSelected(hours, minutes, seconds, meridiens) {
            if (hours != null && minutes != null && (!this.isHourFormat24 && meridiens !== null || this.isHourFormat24)) {
                var time = null;
                if (this.computedValue && !isNaN(this.computedValue)) time = new Date(this.computedValue);
                else {
                    time = this.timeCreator();
                    time.setMilliseconds(0);
                }
                time.setHours(hours);
                time.setMinutes(minutes);
                time.setSeconds(seconds);
                if (!isNaN(time.getTime())) this.computedValue = new Date(time.getTime());
            }
        },
        updateInternalState: function updateInternalState(value) {
            if (value) {
                this.hoursSelected = value.getHours();
                this.minutesSelected = value.getMinutes();
                this.secondsSelected = value.getSeconds();
                this.meridienSelected = value.getHours() >= 12 ? this.pmString : this.amString;
            } else {
                this.hoursSelected = null;
                this.minutesSelected = null;
                this.secondsSelected = null;
                this.meridienSelected = this.amString;
            }
            this.dateSelected = value;
        },
        isHourDisabled: function isHourDisabled(hour) {
            var _this = this;
            var disabled = false;
            if (this.minTime) {
                var minHours = this.minTime.getHours();
                var noMinutesAvailable = this.minutes.every(function(minute) {
                    return _this.isMinuteDisabledForHour(hour, minute.value);
                });
                disabled = hour < minHours || noMinutesAvailable;
            }
            if (this.maxTime) {
                if (!disabled) {
                    var maxHours = this.maxTime.getHours();
                    disabled = hour > maxHours;
                }
            }
            if (this.unselectableTimes) {
                if (!disabled) {
                    var unselectable = this.unselectableTimes.filter(function(time) {
                        if (_this.enableSeconds && _this.secondsSelected !== null) return time.getHours() === hour && time.getMinutes() === _this.minutesSelected && time.getSeconds() === _this.secondsSelected;
                        else if (_this.minutesSelected !== null) return time.getHours() === hour && time.getMinutes() === _this.minutesSelected;
                        return false;
                    });
                    if (unselectable.length > 0) disabled = true;
                    else disabled = this.minutes.every(function(minute) {
                        return _this.unselectableTimes.filter(function(time) {
                            return time.getHours() === hour && time.getMinutes() === minute.value;
                        }).length > 0;
                    });
                }
            }
            return disabled;
        },
        isMinuteDisabledForHour: function isMinuteDisabledForHour(hour, minute) {
            var disabled = false;
            if (this.minTime) {
                var minHours = this.minTime.getHours();
                var minMinutes = this.minTime.getMinutes();
                disabled = hour === minHours && minute < minMinutes;
            }
            if (this.maxTime) {
                if (!disabled) {
                    var maxHours = this.maxTime.getHours();
                    var maxMinutes = this.maxTime.getMinutes();
                    disabled = hour === maxHours && minute > maxMinutes;
                }
            }
            return disabled;
        },
        isMinuteDisabled: function isMinuteDisabled(minute) {
            var _this2 = this;
            var disabled = false;
            if (this.hoursSelected !== null) {
                if (this.isHourDisabled(this.hoursSelected)) disabled = true;
                else disabled = this.isMinuteDisabledForHour(this.hoursSelected, minute);
                if (this.unselectableTimes) {
                    if (!disabled) {
                        var unselectable = this.unselectableTimes.filter(function(time) {
                            if (_this2.enableSeconds && _this2.secondsSelected !== null) return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute && time.getSeconds() === _this2.secondsSelected;
                            else return time.getHours() === _this2.hoursSelected && time.getMinutes() === minute;
                        });
                        disabled = unselectable.length > 0;
                    }
                }
            }
            return disabled;
        },
        isSecondDisabled: function isSecondDisabled(second) {
            var _this3 = this;
            var disabled = false;
            if (this.minutesSelected !== null) {
                if (this.isMinuteDisabled(this.minutesSelected)) disabled = true;
                else {
                    if (this.minTime) {
                        var minHours = this.minTime.getHours();
                        var minMinutes = this.minTime.getMinutes();
                        var minSeconds = this.minTime.getSeconds();
                        disabled = this.hoursSelected === minHours && this.minutesSelected === minMinutes && second < minSeconds;
                    }
                    if (this.maxTime) {
                        if (!disabled) {
                            var maxHours = this.maxTime.getHours();
                            var maxMinutes = this.maxTime.getMinutes();
                            var maxSeconds = this.maxTime.getSeconds();
                            disabled = this.hoursSelected === maxHours && this.minutesSelected === maxMinutes && second > maxSeconds;
                        }
                    }
                }
                if (this.unselectableTimes) {
                    if (!disabled) {
                        var unselectable = this.unselectableTimes.filter(function(time) {
                            return time.getHours() === _this3.hoursSelected && time.getMinutes() === _this3.minutesSelected && time.getSeconds() === second;
                        });
                        disabled = unselectable.length > 0;
                    }
                }
            }
            return disabled;
        },
        /*
     * Parse string into date
     */ onChange: function onChange(value) {
            var date = this.timeParser(value, this);
            this.updateInternalState(date);
            if (date && !isNaN(date)) this.computedValue = date;
            else {
                // Force refresh input value when not valid date
                this.computedValue = null;
                this.$refs.input.newValue = this.computedValue;
            }
        },
        /*
     * Toggle timepicker
     */ toggle: function toggle(active) {
            if (this.$refs.dropdown) this.$refs.dropdown.isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
        },
        /*
     * Close timepicker
     */ close: function close() {
            this.toggle(false);
        },
        /*
     * Call default onFocus method and show timepicker
     */ handleOnFocus: function handleOnFocus() {
            this.onFocus();
            if (this.openOnFocus) this.toggle(true);
        },
        /*
     * Format date into string 'HH-MM-SS'
     */ formatHHMMSS: function formatHHMMSS(value) {
            var date = new Date(value);
            if (value && !isNaN(date)) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var seconds = date.getSeconds();
                return this.formatNumber(hours, true) + ":" + this.formatNumber(minutes, true) + ":" + this.formatNumber(seconds, true);
            }
            return "";
        },
        /*
     * Parse time from string
     */ onChangeNativePicker: function onChangeNativePicker(event) {
            var date = event.target.value;
            if (date) {
                var time = null;
                if (this.computedValue && !isNaN(this.computedValue)) time = new Date(this.computedValue);
                else {
                    time = new Date();
                    time.setMilliseconds(0);
                }
                var t = date.split(":");
                time.setHours(parseInt(t[0], 10));
                time.setMinutes(parseInt(t[1], 10));
                time.setSeconds(t[2] ? parseInt(t[2], 10) : 0);
                this.computedValue = new Date(time.getTime());
            } else this.computedValue = null;
        },
        formatNumber: function formatNumber(value, prependZero) {
            return this.isHourFormat24 || prependZero ? this.pad(value) : value;
        },
        pad: function pad(value) {
            return (value < 10 ? "0" : "") + value;
        },
        /*
     * Format date into string
     */ formatValue: function formatValue(date) {
            if (date && !isNaN(date)) return this.timeFormatter(date, this);
            else return null;
        },
        /**
     * Keypress event that is bound to the document.
     */ keyPress: function keyPress(_ref) {
            var key = _ref.key;
            if (this.$refs.dropdown && this.$refs.dropdown.isActive && (key === "Escape" || key === "Esc")) this.toggle(false);
        },
        /**
     * Emit 'blur' event on dropdown is not active (closed)
     */ onActiveChange: function onActiveChange(value) {
            if (!value) this.onBlur();
        }
    },
    created: function created() {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    beforeUnmounted: function beforeUnmounted() {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
};

},{"./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jPdf6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>script);
parcelHelpers.export(exports, "s", ()=>script$1);
var _vue = require("vue");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
const DEFAULT_CLOSE_OPTIONS = [
    "escape",
    "outside"
];
const DROPDOWN_INJECTION_KEY = Symbol("bdropdown");
var script$1 = {
    name: "BDropdown",
    directives: {
        trapFocus: (0, _trapFocusIMs77O3TJs.t)
    },
    provide () {
        return {
            [DROPDOWN_INJECTION_KEY]: this
        };
    },
    props: {
        modelValue: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function
            ],
            default: null
        },
        disabled: Boolean,
        inline: Boolean,
        scrollable: Boolean,
        maxHeight: {
            type: [
                String,
                Number
            ],
            default: 200
        },
        position: {
            type: String,
            validator (value) {
                return [
                    "is-top-right",
                    "is-top-left",
                    "is-bottom-left",
                    "is-bottom-right"
                ].indexOf(value) > -1;
            }
        },
        triggers: {
            type: Array,
            default: ()=>[
                    "click"
                ]
        },
        mobileModal: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultDropdownMobileModal;
            }
        },
        ariaRole: {
            type: String,
            validator (value) {
                return [
                    "menu",
                    "list",
                    "dialog"
                ].indexOf(value) > -1;
            },
            default: null
        },
        animation: {
            type: String,
            default: "fade"
        },
        multiple: Boolean,
        trapFocus: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTrapFocus;
            }
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        canClose: {
            type: [
                Array,
                Boolean
            ],
            default: true
        },
        expanded: Boolean,
        appendToBody: Boolean,
        appendToBodyCopyParent: Boolean,
        triggerTabindex: {
            type: Number,
            default: 0
        }
    },
    emits: [
        "active-change",
        "change",
        "update:modelValue"
    ],
    data () {
        return {
            selected: this.modelValue,
            style: {},
            isActive: false,
            isHoverable: false,
            maybeTap: false,
            isTouchEnabled: false,
            _bodyEl: undefined,
            timeOutID: null,
            timeOutID2: null
        };
    },
    computed: {
        rootClasses () {
            return [
                this.position,
                {
                    "is-disabled": this.disabled,
                    "is-hoverable": this.hoverable,
                    "is-inline": this.inline,
                    "is-active": this.isActive || this.inline,
                    "is-mobile-modal": this.isMobileModal,
                    "is-expanded": this.expanded,
                    "is-touch-enabled": this.isTouchEnabled
                }
            ];
        },
        isMobileModal () {
            return this.mobileModal && !this.inline;
        },
        cancelOptions () {
            return typeof this.canClose === "boolean" ? this.canClose ? DEFAULT_CLOSE_OPTIONS : [] : this.canClose;
        },
        contentStyle () {
            return {
                maxHeight: this.scrollable ? (0, _helpersO9H6ICOJs.t)(this.maxHeight) : null,
                overflow: this.scrollable ? "auto" : null
            };
        },
        hoverable () {
            return this.triggers.indexOf("hover") >= 0;
        }
    },
    watch: {
        /**
        * When v-model is changed set the new selected item.
        */ modelValue (value) {
            this.selected = value;
        },
        /**
        * Emit event when isActive value is changed.
        *
        * Also resets `isTouchEnabled` when it turns inactive.
        */ isActive (value) {
            this.$emit("active-change", value);
            if (!value) // delays to reset the touch enabled flag until the dropdown
            // menu disappears to avoid glitches
            // also takes care of chattering, e.g., repeated quick taps,
            // otherwise the flag may become inconsistent with the actual
            // state of the dropdown menu
            this.timeOutID = setTimeout(()=>{
                if (!this.isActive) this.isTouchEnabled = false;
            }, 250);
            this.handleScroll();
            if (this.appendToBody) this.$nextTick(()=>{
                this.updateAppendToBody();
            });
        },
        isHoverable (value) {
            if (this.hoverable) this.$emit("active-change", value);
        }
    },
    methods: {
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.isMobileModal) {
                if (this.isActive) document.documentElement.classList.add("is-clipped-touch");
                else document.documentElement.classList.remove("is-clipped-touch");
            }
        },
        /**
         * Click listener from DropdownItem.
         *   1. Set new selected item.
         *   2. Emit input event to update the user v-model.
         *   3. Close the dropdown.
         */ selectItem (value) {
            if (this.multiple) {
                if (this.selected) {
                    if (this.selected.indexOf(value) === -1) // Add value
                    this.selected = [
                        ...this.selected,
                        value
                    ];
                    else // Remove value
                    this.selected = this.selected.filter((val)=>val !== value);
                } else this.selected = [
                    value
                ];
                this.$emit("change", this.selected);
            } else if (this.selected !== value) {
                this.selected = value;
                this.$emit("change", this.selected);
            }
            this.$emit("update:modelValue", this.selected);
            if (!this.multiple) {
                this.isActive = !this.closeOnClick;
                if (this.hoverable && this.closeOnClick) this.isHoverable = false;
            }
        },
        /**
        * White-listed items to not close when clicked.
        */ isInWhiteList (el) {
            if (el === this.$refs.dropdownMenu) return true;
            if (el === this.$refs.trigger) return true;
            // All chidren from dropdown
            if (this.$refs.dropdownMenu != null) {
                const children = this.$refs.dropdownMenu.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            // All children from trigger
            if (this.$refs.trigger != null) {
                const children = this.$refs.trigger.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            return false;
        },
        /**
        * Close dropdown if clicked outside.
        */ clickedOutside (event) {
            if (this.cancelOptions.indexOf("outside") < 0) return;
            if (this.inline) return;
            const target = (0, _helpersO9H6ICOJs.u)(this) ? event.composedPath()[0] : event.target;
            if (!this.isInWhiteList(target)) this.isActive = false;
        },
        /**
         * Keypress event that is bound to the document
         */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) {
                if (this.cancelOptions.indexOf("escape") < 0) return;
                this.isActive = false;
            }
        },
        onClick () {
            // hover precedes
            if (this.triggers.indexOf("hover") !== -1) return;
            if (this.triggers.indexOf("click") < 0) return;
            this.toggle();
        },
        onContextMenu () {
            if (this.triggers.indexOf("contextmenu") < 0) return;
            this.toggle();
        },
        onHover () {
            if (this.triggers.indexOf("hover") < 0) return;
            // touch precedes
            if (this.isTouchEnabled) return;
            this.isHoverable = true;
        },
        // takes care of touch-enabled devices
        // - does nothing if hover trigger is disabled
        // - suppresses hover trigger by setting isTouchEnabled
        // - handles only a tap; i.e., touchstart on the trigger immediately
        //   folowed by touchend
        onTouchStart () {
            this.maybeTap = true;
        },
        onTouchMove () {
            this.maybeTap = false;
        },
        onTouchEnd (e) {
            if (this.triggers.indexOf("hover") === -1) return;
            if (!this.maybeTap) return;
            // tap on dropdown contents may happen without preventDefault
            e.preventDefault();
            this.maybeTap = false;
            this.isTouchEnabled = true;
            this.toggle();
        },
        onFocus () {
            if (this.triggers.indexOf("focus") < 0) return;
            this.toggle();
        },
        /**
        * Toggle dropdown if it's not disabled.
        */ toggle () {
            if (this.disabled) return;
            if (!this.isActive) // if not active, toggle after clickOutside event
            // this fixes toggling programmatic
            // $nextTick may not wait for other events since Vue 3.
            this.timeOutID2 = setTimeout(()=>{
                const value = !this.isActive;
                this.isActive = value;
            });
            else this.isActive = !this.isActive;
        },
        updateAppendToBody () {
            const dropdown = this.$refs.dropdown;
            const dropdownMenu = this.$refs.dropdownMenu;
            const trigger = this.$refs.trigger;
            if (dropdownMenu && trigger) {
                // update wrapper dropdown
                const dropdownWrapper = this.$data._bodyEl.children[0];
                dropdownWrapper.classList.forEach((item)=>dropdownWrapper.classList.remove(item));
                dropdownWrapper.classList.add("dropdown");
                dropdownWrapper.classList.add("dropdown-menu-animation");
                // TODO: the following test never becomes true on Vue 3.
                //       I have no idea about the intention of it.
                if (this.$vnode && this.$vnode.data && this.$vnode.data.staticClass) dropdownWrapper.classList.add(this.$vnode.data.staticClass);
                this.rootClasses.forEach((item)=>{
                    // skip position prop
                    if (item && typeof item === "object") {
                        for(const key in item)if (item[key]) dropdownWrapper.classList.add(key);
                    }
                });
                if (this.appendToBodyCopyParent) {
                    const parentNode = this.$refs.dropdown.parentNode;
                    const parent = this.$data._bodyEl;
                    parent.classList.forEach((item)=>parent.classList.remove(item));
                    parentNode.classList.forEach((item)=>{
                        parent.classList.add(item);
                    });
                }
                const rect = trigger.getBoundingClientRect();
                let top = rect.top + window.scrollY;
                let left = rect.left + window.scrollX;
                if (!this.position || this.position.indexOf("bottom") >= 0) top += trigger.clientHeight;
                else top -= dropdownMenu.clientHeight;
                if (this.position && this.position.indexOf("left") >= 0) left -= dropdownMenu.clientWidth - trigger.clientWidth;
                this.style = {
                    position: "absolute",
                    top: `${top}px`,
                    left: `${left}px`,
                    zIndex: "99",
                    width: this.expanded ? `${dropdown.offsetWidth}px` : undefined
                };
            }
        }
    },
    mounted () {
        if (this.appendToBody) {
            this.$data._bodyEl = (0, _helpersO9H6ICOJs.d)(this.$refs.dropdownMenu);
            this.updateAppendToBody();
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            document.removeEventListener("keyup", this.keyPress);
        }
        if (this.appendToBody) (0, _helpersO9H6ICOJs.r)(this.$data._bodyEl);
        clearTimeout(this.timeOutID);
        clearTimeout(this.timeOutID2);
    }
};
const _hoisted_1$1 = [
    "tabindex"
];
const _hoisted_2$1 = [
    "aria-hidden"
];
const _hoisted_3$1 = [
    "aria-hidden"
];
const _hoisted_4 = [
    "role",
    "aria-modal"
];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "dropdown dropdown-menu-animation",
            $options.rootClasses
        ]),
        ref: "dropdown",
        onMouseleave: _cache[7] || (_cache[7] = ($event)=>$data.isHoverable = false)
    }, [
        !$props.inline ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            tabindex: $props.disabled ? false : $props.triggerTabindex,
            ref: "trigger",
            class: "dropdown-trigger",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.onClick && $options.onClick(...args)),
            onContextmenu: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>$options.onContextMenu && $options.onContextMenu(...args), [
                "prevent"
            ])),
            onMouseenter: _cache[2] || (_cache[2] = (...args)=>$options.onHover && $options.onHover(...args)),
            onFocusCapture: _cache[3] || (_cache[3] = (...args)=>$options.onFocus && $options.onFocus(...args)),
            onTouchstart: _cache[4] || (_cache[4] = (...args)=>$options.onTouchStart && $options.onTouchStart(...args)),
            onTouchmove: _cache[5] || (_cache[5] = (...args)=>$options.onTouchMove && $options.onTouchMove(...args)),
            onTouchend: _cache[6] || (_cache[6] = (...args)=>$options.onTouchEnd && $options.onTouchEnd(...args)),
            "aria-haspopup": "true"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "trigger", {
                active: $data.isActive
            })
        ], 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_1$1)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: $props.animation
        }, {
            default: (0, _vue.withCtx)(()=>[
                    $options.isMobileModal ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 0,
                        class: "background",
                        "aria-hidden": !$data.isActive
                    }, null, 8 /* PROPS */ , _hoisted_2$1)), [
                        [
                            (0, _vue.vShow),
                            $data.isActive
                        ]
                    ]) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "name"
        ]),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: $props.animation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        ref: "dropdownMenu",
                        class: "dropdown-menu",
                        style: (0, _vue.normalizeStyle)($data.style),
                        "aria-hidden": !$data.isActive
                    }, [
                        (0, _vue.createElementVNode)("div", {
                            class: "dropdown-content",
                            role: $props.ariaRole,
                            "aria-modal": !$props.inline,
                            style: (0, _vue.normalizeStyle)($options.contentStyle)
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "default")
                        ], 12 /* STYLE, PROPS */ , _hoisted_4)
                    ], 12 /* STYLE, PROPS */ , _hoisted_3$1)), [
                        [
                            (0, _vue.vShow),
                            !$props.disabled && ($data.isActive || $data.isHoverable) || $props.inline
                        ],
                        [
                            _directive_trap_focus,
                            $props.trapFocus
                        ]
                    ])
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "name"
        ])
    ], 34 /* CLASS, HYDRATE_EVENTS */ );
}
script$1.render = render$1;
script$1.__file = "src/components/dropdown/Dropdown.vue";
var script = {
    name: "BDropdownItem",
    inject: {
        parent: {
            from: DROPDOWN_INJECTION_KEY,
            default: undefined
        }
    },
    props: {
        value: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function
            ],
            default: null
        },
        separator: Boolean,
        disabled: Boolean,
        custom: Boolean,
        focusable: {
            type: Boolean,
            default: true
        },
        paddingless: Boolean,
        hasLink: Boolean,
        ariaRole: {
            type: String,
            default: ""
        }
    },
    emits: [
        "click"
    ],
    computed: {
        anchorClasses () {
            return {
                "is-disabled": this.parent.disabled || this.disabled,
                "is-paddingless": this.paddingless,
                "is-active": this.isActive
            };
        },
        itemClasses () {
            return {
                "dropdown-item": !this.hasLink,
                "is-disabled": this.disabled,
                "is-paddingless": this.paddingless,
                "is-active": this.isActive,
                "has-link": this.hasLink
            };
        },
        ariaRoleItem () {
            return this.ariaRole === "menuitem" || this.ariaRole === "listitem" ? this.ariaRole : null;
        },
        isClickable () {
            return !this.parent.disabled && !this.separator && !this.disabled && !this.custom;
        },
        isActive () {
            if (this.parent.selected === null) return false;
            if (this.parent.multiple) return this.parent.selected.indexOf(this.value) >= 0;
            return this.value === this.parent.selected;
        },
        isFocusable () {
            return this.hasLink ? false : this.focusable;
        }
    },
    methods: {
        /**
        * Click listener, select the item.
        */ selectItem () {
            if (!this.isClickable) return;
            this.parent.selectItem(this.value);
            this.$emit("click");
        }
    }
};
const _hoisted_1 = {
    key: 0,
    class: "dropdown-divider"
};
const _hoisted_2 = [
    "role",
    "tabindex"
];
const _hoisted_3 = [
    "role",
    "tabindex"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return $props.separator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("hr", _hoisted_1)) : !$props.custom && !$props.hasLink ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
        key: 1,
        class: (0, _vue.normalizeClass)([
            "dropdown-item",
            $options.anchorClasses
        ]),
        onClick: _cache[0] || (_cache[0] = (...args)=>$options.selectItem && $options.selectItem(...args)),
        role: $options.ariaRoleItem,
        tabindex: $options.isFocusable ? 0 : null
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 10 /* CLASS, PROPS */ , _hoisted_2)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        key: 2,
        class: (0, _vue.normalizeClass)($options.itemClasses),
        onClick: _cache[1] || (_cache[1] = (...args)=>$options.selectItem && $options.selectItem(...args)),
        role: $options.ariaRoleItem,
        tabindex: $options.isFocusable ? 0 : null
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 10 /* CLASS, PROPS */ , _hoisted_3));
}
script.render = render;
script.__file = "src/components/dropdown/DropdownItem.vue";

},{"vue":"dylud","./trapFocus-IMs77O3T.js":"jBg9U","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jBg9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "t", ()=>trapFocus);
var findFocusable = function findFocusable(element) {
    var programmatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!element) return null;
    if (programmatic) return element.querySelectorAll('*[tabindex="-1"]');
    return element.querySelectorAll('a[href]:not([tabindex="-1"]),\n                                     area[href],\n                                     input:not([disabled]),\n                                     select:not([disabled]),\n                                     textarea:not([disabled]),\n                                     button:not([disabled]),\n                                     iframe,\n                                     object,\n                                     embed,\n                                     *[tabindex]:not([tabindex="-1"]),\n                                     *[contenteditable]');
};
var onKeyDown;
var beforeMount = function beforeMount(el, _ref) {
    var _ref$value = _ref.value, value = _ref$value === void 0 ? true : _ref$value;
    if (value) {
        var focusable = findFocusable(el);
        var focusableProg = findFocusable(el, true);
        if (focusable && focusable.length > 0) {
            onKeyDown = function onKeyDown(event) {
                // Need to get focusable each time since it can change between key events
                // ex. changing month in a datepicker
                focusable = findFocusable(el);
                focusableProg = findFocusable(el, true);
                var firstFocusable = focusable[0];
                var lastFocusable = focusable[focusable.length - 1];
                if (event.target === firstFocusable && event.shiftKey && event.key === "Tab") {
                    event.preventDefault();
                    lastFocusable.focus();
                } else if ((event.target === lastFocusable || Array.from(focusableProg).indexOf(event.target) >= 0) && !event.shiftKey && event.key === "Tab") {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            };
            el.addEventListener("keydown", onKeyDown);
        }
    }
};
var unmounted = function unmounted(el) {
    el.removeEventListener("keydown", onKeyDown);
};
var directive = {
    beforeMount: beforeMount,
    unmounted: unmounted
};
var trapFocus = directive;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h48jl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var script$1 = {
    name: "BFieldBody",
    inject: {
        parent: {
            from: "BField",
            default: null
        }
    },
    props: {
        message: {
            type: [
                String,
                Array
            ]
        },
        type: {
            type: [
                String,
                Object
            ]
        }
    },
    render () {
        let first = true;
        // wraps the default slot (children) with `b-field`.
        // children may be given in a fragment and should be extracted.
        let children = typeof this.$slots.default === "function" ? this.$slots.default() : this.$slots.default;
        if (children != null && children.length === 1 && children[0].type === (0, _vue.Fragment)) children = children[0].children;
        return (0, _vue.h)("div", {
            class: "field-body"
        }, {
            default: ()=>{
                return children != null && children.map((element)=>{
                    // skip returns(?) and comments
                    if (element.type === (0, _vue.Comment) || element.type === (0, _vue.Text)) return element;
                    let message;
                    if (first) {
                        message = this.message;
                        first = false;
                    }
                    return (0, _vue.h)(this.parent ? this.parent.$.type : (0, _vue.resolveComponent)("b-field"), {
                        type: this.type,
                        message
                    }, ()=>element);
                });
            }
        });
    }
};
script$1.__file = "src/components/field/FieldBody.vue";
var script = {
    name: "BField",
    components: {
        [script$1.name]: script$1
    },
    provide () {
        return {
            BField: this
        };
    },
    inject: {
        parent: {
            from: "BField",
            default: false
        }
    },
    props: {
        type: [
            String,
            Object
        ],
        label: String,
        labelFor: String,
        message: [
            String,
            Array,
            Object
        ],
        grouped: Boolean,
        groupMultiline: Boolean,
        position: String,
        expanded: Boolean,
        horizontal: Boolean,
        addons: {
            type: Boolean,
            default: true
        },
        customClass: String,
        labelPosition: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultFieldLabelPosition;
            }
        }
    },
    data () {
        return {
            newType: this.type,
            newMessage: this.message,
            fieldLabelSize: null,
            numberInputClasses: [],
            _isField: true // Used internally by Input and Select
        };
    },
    computed: {
        rootClasses () {
            return [
                {
                    "is-expanded": this.expanded,
                    "is-horizontal": this.horizontal,
                    "is-floating-in-label": this.hasLabel && !this.horizontal && this.labelPosition === "inside",
                    "is-floating-label": this.hasLabel && !this.horizontal && this.labelPosition === "on-border"
                },
                this.numberInputClasses
            ];
        },
        innerFieldClasses () {
            return [
                this.fieldType(),
                this.newPosition,
                {
                    "is-grouped-multiline": this.groupMultiline
                }
            ];
        },
        hasInnerField () {
            return this.grouped || this.groupMultiline || this.hasAddons();
        },
        /**
        * Correct Bulma class for the side of the addon or group.
        *
        * This is not kept like the others (is-small, etc.),
        * because since 'has-addons' is set automatically it
        * doesn't make sense to teach users what addons are exactly.
        */ newPosition () {
            if (this.position === undefined) return;
            const position = this.position.split("-");
            if (position.length < 1) return;
            const prefix = this.grouped ? "is-grouped-" : "has-addons-";
            if (this.position) return prefix + position[1];
            return undefined;
        },
        /**
        * Formatted message in case it's an array
        * (each element is separated by <br> tag)
        */ formattedMessage () {
            if (this.parent && this.parent.hasInnerField) return "" // Message will be displayed in parent field
            ;
            if (typeof this.newMessage === "string") return [
                this.newMessage
            ];
            const messages = [];
            if (Array.isArray(this.newMessage)) this.newMessage.forEach((message)=>{
                if (typeof message === "string") messages.push(message);
                else {
                    for(const key in message)if (message[key]) messages.push(key);
                }
            });
            else {
                for(const key in this.newMessage)if (this.newMessage[key]) messages.push(key);
            }
            return messages.filter((m)=>!!m);
        },
        hasLabel () {
            return this.label || this.$slots.label;
        },
        hasMessage () {
            return (!this.parent || !this.parent.hasInnerField) && this.newMessage || this.$slots.message;
        }
    },
    watch: {
        /**
        * Set internal type when prop change.
        */ type (value) {
            this.newType = value;
        },
        /**
        * Set internal message when prop change.
        */ message (value) {
            // we deep comparison here becase an innner Field of another Field
            // receives the message as a brand new array every time, so simple
            // identity check won't work and will end up with infinite
            // recursions
            // https://github.com/buefy/buefy/issues/4018#issuecomment-1985026234
            if (JSON.stringify(value) !== JSON.stringify(this.newMessage)) this.newMessage = value;
        },
        /**
        * Set parent message if we use Field in Field.
        */ newMessage (value) {
            if (this.parent && this.parent.hasInnerField) {
                if (!this.parent.type) this.parent.newType = this.newType;
                if (!this.parent.message) this.parent.newMessage = value;
            }
        }
    },
    methods: {
        /**
        * Field has addons if there are more than one slot
        * (element / component) in the Field.
        * Or is grouped when prop is set.
        * Is a method to be called when component re-render.
        */ fieldType () {
            if (this.grouped) return "is-grouped";
            if (this.hasAddons()) return "has-addons";
        },
        hasAddons () {
            let renderedNode = 0;
            if (this.$slots.default) renderedNode = this.$slots.default().reduce((i, node)=>(0, _helpersO9H6ICOJs.y)(node) ? i + 1 : i, 0);
            return renderedNode > 1 && this.addons && !this.horizontal;
        },
        // called by a number input if it is a direct child.
        wrapNumberinput ({ controlsPosition, size }) {
            const classes = [
                "has-numberinput"
            ];
            if (controlsPosition) classes.push(`has-numberinput-${controlsPosition}`);
            if (size) classes.push(`has-numberinput-${size}`);
            this.numberInputClasses = classes;
        }
    },
    mounted () {
        if (this.horizontal) {
            // Bulma docs: .is-normal for any .input or .button
            const elements = this.$el.querySelectorAll(".input, .select, .button, .textarea, .b-slider");
            if (elements.length > 0) this.fieldLabelSize = "is-normal";
        }
    }
};
const _hoisted_1 = [
    "for"
];
const _hoisted_2 = [
    "for"
];
const _hoisted_3 = {
    key: 3,
    class: "field-body"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_field_body = (0, _vue.resolveComponent)("b-field-body");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "field",
            $options.rootClasses
        ])
    }, [
        $props.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "field-label",
                [
                    $props.customClass,
                    $data.fieldLabelSize
                ]
            ])
        }, [
            $options.hasLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
                key: 0,
                for: $props.labelFor,
                class: (0, _vue.normalizeClass)([
                    $props.customClass,
                    "label"
                ])
            }, [
                _ctx.$slots.label ? (0, _vue.renderSlot)(_ctx.$slots, "label", {
                    key: 0
                }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ ))
            ], 10 /* CLASS, PROPS */ , _hoisted_1)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 2 /* CLASS */ )) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
            key: 1
        }, [
            $options.hasLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
                key: 0,
                for: $props.labelFor,
                class: (0, _vue.normalizeClass)([
                    $props.customClass,
                    "label"
                ])
            }, [
                _ctx.$slots.label ? (0, _vue.renderSlot)(_ctx.$slots, "label", {
                    key: 0
                }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ ))
            ], 10 /* CLASS, PROPS */ , _hoisted_2)) : (0, _vue.createCommentVNode)("v-if", true)
        ], 64 /* STABLE_FRAGMENT */ )),
        $props.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_field_body, {
            key: 2,
            message: $data.newMessage ? $options.formattedMessage : "",
            type: $data.newType
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "message",
            "type"
        ])) : $options.hasInnerField ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
            (0, _vue.createVNode)(_component_b_field, {
                addons: false,
                type: $props.type,
                class: (0, _vue.normalizeClass)($options.innerFieldClasses)
            }, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ]),
                _: 3 /* FORWARDED */ 
            }, 8 /* PROPS */ , [
                "type",
                "class"
            ])
        ])) : (0, _vue.renderSlot)(_ctx.$slots, "default", {
            key: 4
        }),
        $options.hasMessage && !$props.horizontal ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
            key: 5,
            class: (0, _vue.normalizeClass)([
                "help",
                $data.newType
            ])
        }, [
            _ctx.$slots.message ? (0, _vue.renderSlot)(_ctx.$slots, "message", {
                key: 0,
                messages: $options.formattedMessage
            }) : ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, (0, _vue.renderList)($options.formattedMessage, (mess, i)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)(mess) + " ", 1 /* TEXT */ ),
                    i + 1 < $options.formattedMessage.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("br", {
                        key: i
                    })) : (0, _vue.createCommentVNode)("v-if", true)
                ], 64 /* STABLE_FRAGMENT */ );
            }), 256 /* UNKEYED_FRAGMENT */ ))
        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/field/Field.vue";

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"3YgE2":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "C", ()=>Color$1);
parcelHelpers.export(exports, "P", ()=>Plugin);
parcelHelpers.export(exports, "s", ()=>script);
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _buttonKVoJ7JHHJs = require("./Button-KVoJ7jHH.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var _tooltipWHq2LJasJs = require("./Tooltip-WHq2LJas.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && ((0, _typeofZ4RCTFCZJs._)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct$1()) _construct = Reflect.construct.bind();
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var colorChannels = [
    "red",
    "green",
    "blue",
    "alpha"
];
var colorsNammed = {
    transparent: "#00000000",
    black: "#000000",
    silver: "#c0c0c0",
    gray: "#808080",
    white: "#ffffff",
    maroon: "#800000",
    red: "#ff0000",
    purple: "#800080",
    fuchsia: "#ff00ff",
    green: "#008000",
    lime: "#00ff00",
    olive: "#808000",
    yellow: "#ffff00",
    navy: "#000080",
    blue: "#0000ff",
    teal: "#008080",
    aqua: "#00ffff",
    orange: "#ffa500",
    aliceblue: "#f0f8ff",
    antiquewhite: "#faebd7",
    aquamarine: "#7fffd4",
    azure: "#f0ffff",
    beige: "#f5f5dc",
    bisque: "#ffe4c4",
    blanchedalmond: "#ffebcd",
    blueviolet: "#8a2be2",
    brown: "#a52a2a",
    burlywood: "#deb887",
    cadetblue: "#5f9ea0",
    chartreuse: "#7fff00",
    chocolate: "#d2691e",
    coral: "#ff7f50",
    cornflowerblue: "#6495ed",
    cornsilk: "#fff8dc",
    crimson: "#dc143c",
    cyan: "#00ffff",
    darkblue: "#00008b",
    darkcyan: "#008b8b",
    darkgoldenrod: "#b8860b",
    darkgray: "#a9a9a9",
    darkgreen: "#006400",
    darkgrey: "#a9a9a9",
    darkkhaki: "#bdb76b",
    darkmagenta: "#8b008b",
    darkolivegreen: "#556b2f",
    darkorange: "#ff8c00",
    darkorchid: "#9932cc",
    darkred: "#8b0000",
    darksalmon: "#e9967a",
    darkseagreen: "#8fbc8f",
    darkslateblue: "#483d8b",
    darkslategray: "#2f4f4f",
    darkslategrey: "#2f4f4f",
    darkturquoise: "#00ced1",
    darkviolet: "#9400d3",
    deeppink: "#ff1493",
    deepskyblue: "#00bfff",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1e90ff",
    firebrick: "#b22222",
    floralwhite: "#fffaf0",
    forestgreen: "#228b22",
    gainsboro: "#dcdcdc",
    ghostwhite: "#f8f8ff",
    gold: "#ffd700",
    goldenrod: "#daa520",
    greenyellow: "#adff2f",
    grey: "#808080",
    honeydew: "#f0fff0",
    hotpink: "#ff69b4",
    indianred: "#cd5c5c",
    indigo: "#4b0082",
    ivory: "#fffff0",
    khaki: "#f0e68c",
    lavender: "#e6e6fa",
    lavenderblush: "#fff0f5",
    lawngreen: "#7cfc00",
    lemonchiffon: "#fffacd",
    lightblue: "#add8e6",
    lightcoral: "#f08080",
    lightcyan: "#e0ffff",
    lightgoldenrodyellow: "#fafad2",
    lightgray: "#d3d3d3",
    lightgreen: "#90ee90",
    lightgrey: "#d3d3d3",
    lightpink: "#ffb6c1",
    lightsalmon: "#ffa07a",
    lightseagreen: "#20b2aa",
    lightskyblue: "#87cefa",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#b0c4de",
    lightyellow: "#ffffe0",
    limegreen: "#32cd32",
    linen: "#faf0e6",
    magenta: "#ff00ff",
    mediumaquamarine: "#66cdaa",
    mediumblue: "#0000cd",
    mediumorchid: "#ba55d3",
    mediumpurple: "#9370db",
    mediumseagreen: "#3cb371",
    mediumslateblue: "#7b68ee",
    mediumspringgreen: "#00fa9a",
    mediumturquoise: "#48d1cc",
    mediumvioletred: "#c71585",
    midnightblue: "#191970",
    mintcream: "#f5fffa",
    mistyrose: "#ffe4e1",
    moccasin: "#ffe4b5",
    navajowhite: "#ffdead",
    oldlace: "#fdf5e6",
    olivedrab: "#6b8e23",
    orangered: "#ff4500",
    orchid: "#da70d6",
    palegoldenrod: "#eee8aa",
    palegreen: "#98fb98",
    paleturquoise: "#afeeee",
    palevioletred: "#db7093",
    papayawhip: "#ffefd5",
    peachpuff: "#ffdab9",
    peru: "#cd853f",
    pink: "#ffc0cb",
    plum: "#dda0dd",
    powderblue: "#b0e0e6",
    rosybrown: "#bc8f8f",
    royalblue: "#4169e1",
    saddlebrown: "#8b4513",
    salmon: "#fa8072",
    sandybrown: "#f4a460",
    seagreen: "#2e8b57",
    seashell: "#fff5ee",
    sienna: "#a0522d",
    skyblue: "#87ceeb",
    slateblue: "#6a5acd",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#fffafa",
    springgreen: "#00ff7f",
    steelblue: "#4682b4",
    tan: "#d2b48c",
    thistle: "#d8bfd8",
    tomato: "#ff6347",
    turquoise: "#40e0d0",
    violet: "#ee82ee",
    wheat: "#f5deb3",
    whitesmoke: "#f5f5f5",
    yellowgreen: "#9acd32",
    rebeccapurple: "#663399"
};
var ColorTypeError = /*#__PURE__*/ function(_Error) {
    _inherits(ColorTypeError, _Error);
    var _super = _createSuper(ColorTypeError);
    function ColorTypeError() {
        (0, _classCallCheckE4KhD9XnJs.a)(this, ColorTypeError);
        return _super.call(this, "ColorTypeError: type must be hex(a), rgb(a) or hsl(a)");
    }
    return (0, _classCallCheckE4KhD9XnJs._)(ColorTypeError);
}(/*#__PURE__*/ _wrapNativeSuper(Error));
var Color = /*#__PURE__*/ function(_Symbol$toString) {
    function Color() {
        var _this = this;
        (0, _classCallCheckE4KhD9XnJs.a)(this, Color);
        if (arguments.length > 0) return Color.parse.apply(Color, arguments);
        this.$channels = new Uint8Array(colorChannels.length);
        colorChannels.forEach(function(channel, index) {
            Object.defineProperty(_this, channel, {
                get: function get() {
                    return _this.$channels[index];
                },
                set: function set(_byte) {
                    if (!Number.isNaN(_byte / 1)) _this.$channels[index] = Math.min(255, Math.max(0, _byte));
                },
                enumerable: true,
                configurable: true
            });
        });
        [
            "hue",
            "saturation",
            "lightness"
        ].forEach(function(name) {
            var capitalizedName = name.replace(/^./, function(m) {
                return m.toUpperCase();
            });
            Object.defineProperty(_this, name, {
                get: function get() {
                    return _this["get".concat(capitalizedName)]();
                },
                set: function set(value) {
                    if (!Number.isNaN(value / 1)) _this["set".concat(capitalizedName)](value);
                },
                enumerable: true,
                configurable: true
            });
        });
    }
    (0, _classCallCheckE4KhD9XnJs._)(Color, [
        {
            key: "getHue",
            value: function getHue() {
                var _Array$from$map = Array.from(this.$channels).map(function(c) {
                    return c / 255;
                }), _Array$from$map2 = _slicedToArray(_Array$from$map, 3), red = _Array$from$map2[0], green = _Array$from$map2[1], blue = _Array$from$map2[2];
                var _ref = [
                    Math.min(red, green, blue),
                    Math.max(red, green, blue)
                ], min = _ref[0], max = _ref[1];
                var delta = max - min;
                var hue = 0;
                if (delta === 0) return hue;
                if (red === max) hue = (green - blue) / delta % 6;
                else if (green === max) hue = (blue - red) / delta + 2;
                else hue = (red - green) / delta + 4;
                hue *= 60;
                while(hue !== -Infinity && hue < 0)hue += 360;
                return Math.round(hue % 360);
            }
        },
        {
            key: "setHue",
            value: function setHue(value) {
                var color = Color.fromHSL(value, this.saturation, this.lightness, this.alpha / 255);
                for(var i = 0; i < this.$channels.length; i++)this.$channels[i] = Number(color.$channels[i]);
            }
        },
        {
            key: "getSaturation",
            value: function getSaturation() {
                var _Array$from$map3 = Array.from(this.$channels).map(function(c) {
                    return c / 255;
                }), _Array$from$map4 = _slicedToArray(_Array$from$map3, 3), red = _Array$from$map4[0], green = _Array$from$map4[1], blue = _Array$from$map4[2];
                var _ref2 = [
                    Math.min(red, green, blue),
                    Math.max(red, green, blue)
                ], min = _ref2[0], max = _ref2[1];
                var delta = max - min;
                return delta !== 0 ? Math.round(delta / (1 - Math.abs(2 * this.lightness - 1)) * 100) / 100 : 0;
            }
        },
        {
            key: "setSaturation",
            value: function setSaturation(value) {
                var _this2 = this;
                var color = Color.fromHSL(this.hue, value, this.lightness, this.alpha / 255);
                colorChannels.forEach(function(_, i) {
                    return _this2.$channels[i] = color.$channels[i];
                });
            }
        },
        {
            key: "getLightness",
            value: function getLightness() {
                var _Array$from$map5 = Array.from(this.$channels).map(function(c) {
                    return c / 255;
                }), _Array$from$map6 = _slicedToArray(_Array$from$map5, 3), red = _Array$from$map6[0], green = _Array$from$map6[1], blue = _Array$from$map6[2];
                var _ref3 = [
                    Math.min(red, green, blue),
                    Math.max(red, green, blue)
                ], min = _ref3[0], max = _ref3[1];
                return Math.round((max + min) / 2 * 100) / 100;
            }
        },
        {
            key: "setLightness",
            value: function setLightness(value) {
                var _this3 = this;
                var color = Color.fromHSL(this.hue, this.lightness, value, this.alpha / 255);
                colorChannels.forEach(function(_, i) {
                    return _this3.$channels[i] = color.$channels[i];
                });
            }
        },
        {
            key: "clone",
            value: function clone() {
                var _this4 = this;
                var color = new Color();
                colorChannels.forEach(function(_, i) {
                    return color.$channels[i] = _this4.$channels[i];
                });
                return color;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var _this5 = this;
                var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "hex";
                switch(String(type).toLowerCase()){
                    case "hex":
                        return "#" + colorChannels.slice(0, 3).map(function(channel) {
                            return _this5[channel].toString(16).padStart(2, "0");
                        }).join("");
                    case "hexa":
                        return "#" + colorChannels.map(function(channel) {
                            return _this5[channel].toString(16).padStart(2, "0");
                        }).join("");
                    case "rgb":
                        return "rgb(".concat(this.red, ", ").concat(this.green, ", ").concat(this.blue, ")");
                    case "rgba":
                        return "rgba(".concat(this.red, ", ").concat(this.green, ", ").concat(this.blue, ", ").concat(Math.round(this.alpha / 2.55) / 100, ")");
                    case "hsl":
                        return "hsl(".concat(Math.round(this.hue), "deg, ").concat(Math.round(this.saturation * 100), "%, ").concat(Math.round(this.lightness * 100), "%)");
                    case "hsla":
                        return "hsla(".concat(Math.round(this.hue), "deg, ").concat(Math.round(this.saturation * 100), "%, ").concat(Math.round(this.lightness * 100), "%, ").concat(Math.round(this.alpha / 2.55) / 100, ")");
                    default:
                        throw new ColorTypeError();
                }
            }
        },
        {
            key: _Symbol$toString,
            get: function get() {
                return this.toString("hex");
            }
        }
    ], [
        {
            key: "parse",
            value: function parse() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if ((0, _typeofZ4RCTFCZJs._)(args[0]) === "object") return Color.parseObject(args[0]);
                else if (args.every(function(arg) {
                    return !Number.isNaN(arg / 1);
                })) {
                    var color = new Color();
                    if (args.length > 3) {
                        color.red = args[0];
                        color.green = args[1];
                        color.blue = args[2];
                        if (args[3]) color.alpha = args[3];
                    } else if (args.length === 1) {
                        var index = Number(args[0]);
                        return Color.parseIndex(index, index > Math.pow(2, 24) ? 3 : 4);
                    }
                } else if (typeof args[0] === "string") {
                    var match = null;
                    if (typeof colorsNammed[args[0].toLowerCase()] === "string") return Color.parseHex(colorsNammed[args[0].toLowerCase()]);
                    else if ((match = args[0].match(/^(#|&h|0x)?(([a-f0-9]{3,4}){1,2})$/i)) !== null) return Color.parseHex(match[2]);
                    else if ((match = args[0].match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)(\s*,\s*(\d*\.?\d+))?\s*\)$/i)) !== null) {
                        var channels = [
                            match[1],
                            match[2],
                            match[3],
                            typeof match[5] !== "undefined" ? match[5] : 1
                        ];
                        return Color.fromRGB.apply(Color, _toConsumableArray(channels.map(function(value) {
                            return Number(value);
                        })));
                    } else if (args[0].match(/^(h(sl|wb)a?|lab|color|cmyk)\(/i)) throw new Error("Color expression not implemented yet");
                }
                throw new Error("Invalid color expression");
            }
        },
        {
            key: "parseObject",
            value: function parseObject(object) {
                var color = new Color();
                if (object === null || (0, _typeofZ4RCTFCZJs._)(object) !== "object") return color;
                if (Color.isColor(object)) return object.clone();
                colorChannels.forEach(function(channel) {
                    if (!Number.isNaN(object[channel])) color[channel] = object[channel];
                });
                return color;
            }
        },
        {
            key: "parseHex",
            value: function parseHex(hex) {
                if (typeof hex !== "string") throw new Error("Hex expression must be a string");
                hex = hex.trim().replace(/^(0x|&h|#)/i, "");
                if (hex.length === 3 || hex.length === 4) hex = hex.split("").map(function(c) {
                    return c.repeat(2);
                }).join("");
                if (!(hex.length === 6 || hex.length === 8)) throw new Error("Incorrect Hex expression length");
                var chans = hex.split(/(..)/).filter(function(value) {
                    return value;
                }).map(function(value) {
                    return Number.parseInt(value, 16);
                });
                if (typeof chans[3] === "number") chans[3] /= 255;
                return Color.fromRGB.apply(Color, _toConsumableArray(chans));
            }
        },
        {
            key: "parseIndex",
            value: function parseIndex(value) {
                var channels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
                var color = new Color();
                for(var i = 0; i < 4; i++)color[colorChannels[i]] = value >> (channels - i) * 8 && 0xff;
                return color;
            }
        },
        {
            key: "fromRGB",
            value: function fromRGB(red, green, blue) {
                var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                if ([
                    red,
                    green,
                    blue,
                    alpha
                ].some(function(arg) {
                    return Number.isNaN(arg / 1);
                })) throw new Error("Invalid arguments");
                alpha *= 255;
                var color = new Color();
                [
                    red,
                    green,
                    blue,
                    alpha
                ].forEach(function(value, index) {
                    color[colorChannels[index]] = value;
                });
                return color;
            }
        },
        {
            key: "fromHSL",
            value: function fromHSL(hue, saturation, lightness) {
                var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
                if ([
                    hue,
                    saturation,
                    lightness,
                    alpha
                ].some(function(arg) {
                    return Number.isNaN(arg);
                })) throw new Error("Invalid arguments");
                while(hue < 0 && hue !== -Infinity)hue += 360;
                hue = hue % 360;
                saturation = Math.max(0, Math.min(1, saturation));
                lightness = Math.max(0, Math.min(1, lightness));
                alpha = Math.max(0, Math.min(1, alpha));
                var c = (1 - Math.abs(2 * lightness - 1)) * saturation;
                var x = c * (1 - Math.abs(hue / 60 % 2 - 1));
                var m = lightness - c / 2;
                var _ref4 = hue < 60 ? [
                    c,
                    x,
                    0
                ] : hue < 120 ? [
                    x,
                    c,
                    0
                ] : hue < 180 ? [
                    0,
                    c,
                    x
                ] : hue < 240 ? [
                    0,
                    x,
                    c
                ] : hue < 300 ? [
                    x,
                    0,
                    c
                ] : [
                    c,
                    0,
                    x
                ], _ref5 = _slicedToArray(_ref4, 3), r = _ref5[0], g = _ref5[1], b = _ref5[2];
                return Color.fromRGB((r + m) * 255, (g + m) * 255, (b + m) * 255, alpha);
            }
        },
        {
            key: "isColor",
            value: function isColor(arg) {
                return arg instanceof Color;
            }
        }
    ]);
    return Color;
}(Symbol.toString);
var Color$1 = Color;
const cos30 = 0.86602540378;
const sin30 = 0.5;
let id = 0;
var script$3 = {
    name: "BColorpickerHSLRepresentationTriangle",
    props: {
        value: {
            type: Object,
            required: true,
            validator (value) {
                return typeof value.hue === "number" && typeof value.saturation === "number" && typeof value.lightness === "number";
            }
        },
        size: {
            type: Number,
            default: 200
        },
        thickness: {
            type: Number,
            default: 20
        }
    },
    emits: [
        "input"
    ],
    data () {
        return {
            id: id++,
            hue: this.value.hue,
            saturation: this.value.saturation,
            lightness: this.value.lightness,
            captureMouse: false,
            captureType: "hue",
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            },
            cos30,
            sin30,
            debounce: 0
        };
    },
    computed: {
        viewBox () {
            const { size } = this;
            return `0 0 ${size} ${size}`;
        },
        internalRadius () {
            return this.size / 2 - this.thickness;
        },
        haloPath () {
            const { size, thickness } = this;
            const radius = size / 2 - 2; // 2px padding
            const thicknessRadius = radius - thickness;
            const center = size / 2;
            return `M${center - radius} ${center}a${radius}  ${radius}  0 1 1 ${2 * radius} 0` + `h${-thickness}` + `a${-thicknessRadius}  ${thicknessRadius}  0 1 0 ${-2 * thicknessRadius} 0` + `a${thicknessRadius}  ${thicknessRadius}  0 1 0 ${2 * thicknessRadius} 0` + `h${thickness}` + `a${radius}  ${radius}  0 1 1 ${-2 * radius} 0z`;
        },
        trianglePath () {
            const { size, thickness } = this;
            const radius = size - 4;
            const thicknessRadius = (radius - 2 * thickness) / 2;
            return `M0 ${-thicknessRadius}` + `L${cos30 * thicknessRadius} ${sin30 * thicknessRadius}` + `H${-cos30 * thicknessRadius}z`;
        }
    },
    watch: {
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                // Caching offset
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        },
        value: {
            deep: true,
            handler (newColor) {
                const { hue, saturation, lightness } = newColor;
                window.clearTimeout(this.debounce);
                this.debounce = window.setTimeout(()=>{
                    if (lightness >= 0.03 && lightness <= 0.97 && saturation > 0) this.hue = hue;
                    this.saturation = saturation;
                    this.lightness = lightness;
                }, 200);
            }
        }
    },
    methods: {
        increaseHue (value = 1) {
            this.hue = (this.hue + value) % 360;
        },
        decreaseHue (value = 1) {
            this.hue = (360 + this.hue - value) % 360;
        },
        increaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation + value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        decreaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation - value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        increaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness + value));
        },
        decreaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness - value));
        },
        hueKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseHue();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseHue();
                    handled = true;
                    break;
                case "Home":
                    this.increaseHue(360 - this.hue);
                    handled = true;
                    break;
                case "End":
                    this.decreaseHue(this.hue);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseHue(60 - this.hue % 60);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseHue(60 + this.hue % 60);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        slKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                    this.decreaseLightness();
                    handled = true;
                    break;
                case "ArrowUp":
                    this.increaseSaturation();
                    handled = true;
                    break;
                case "ArrowLeft":
                    this.increaseLightness();
                    handled = true;
                    break;
                case "ArrowDown":
                    this.decreaseSaturation();
                    handled = true;
                    break;
                case "Home":
                    this.increaseLightness(1 - this.lightness);
                    handled = true;
                    break;
                case "End":
                    this.decreaseLightness(this.lightness);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseSaturation(1 - this.saturation);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseSaturation(this.saturation);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        clickHue (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.hueCursor.focus();
        },
        clickSL (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.slCursor.focus();
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            let [mouseX, mouseY] = [
                0,
                0
            ];
            if (typeof event.touches !== "undefined" && event.touches.length) [mouseX, mouseY] = [
                event.touches[0].clientX,
                event.touches[0].clientY
            ];
            else [mouseX, mouseY] = [
                event.clientX,
                event.clientY
            ];
            const angle = Math.atan2(mouseY - this.clientOffset.cy, mouseX - this.clientOffset.cx);
            if (this.captureType === "sl") {
                const d = Math.sqrt(Math.pow(mouseX - this.clientOffset.cx, 2) + Math.pow(mouseY - this.clientOffset.cy, 2));
                const ratio = this.size / this.clientOffset.width;
                const dx = d * Math.cos(angle - this.hue / 180 * Math.PI) * ratio;
                const dy = d * Math.sin(angle - this.hue / 180 * Math.PI) * ratio;
                const radius = this.internalRadius;
                const saturation = 1 - (Math.min(radius * sin30, Math.max(-radius, dy)) + radius) / (radius + radius * sin30);
                const lightness = (Math.min(radius * cos30 * (1 - saturation), Math.max(-radius * cos30 * (1 - saturation), dx)) + radius * cos30) / (radius * 2 * cos30);
                this.saturation = Math.round(saturation * 1000) / 1000;
                this.lightness = 1 - Math.round(lightness * 1000) / 1000;
            } else this.hue = Math.round(angle / Math.PI * 180 + 90) % 360;
            this.emitColor();
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
            if (event.target.closest(".colorpicker-triangle-slider-sl") !== null) this.captureType = "sl";
            else this.captureType = "hue";
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs[this.captureType === "sl" ? "slCursor" : "hueCursor"].focus();
            }
            this.captureMouse = false;
        },
        emitColor () {
            const { hue, saturation, lightness } = this;
            this.$emit("input", Color$1.fromHSL(hue, saturation, lightness));
            window.clearTimeout(this.debounce);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
        clearTimeout(this.debounce);
    }
};
const _hoisted_1$3 = [
    "viewBox"
];
const _hoisted_2$1 = [
    "id"
];
const _hoisted_3$1 = /*#__PURE__*/ (0, _vue.createElementVNode)("stop", {
    offset: "0%",
    "stop-color": "#fff"
}, null, -1 /* HOISTED */ );
const _hoisted_4$1 = /*#__PURE__*/ (0, _vue.createElementVNode)("stop", {
    offset: "100%",
    "stop-color": "#000"
}, null, -1 /* HOISTED */ );
const _hoisted_5 = [
    _hoisted_3$1,
    _hoisted_4$1
];
const _hoisted_6 = [
    "id"
];
const _hoisted_7 = [
    "stop-color"
];
const _hoisted_8 = [
    "stop-color"
];
const _hoisted_9 = [
    "id"
];
const _hoisted_10 = [
    "d"
];
const _hoisted_11 = {
    class: "colorpicker-triangle-slider-hue"
};
const _hoisted_12 = [
    "width",
    "height",
    "clip-path"
];
const _hoisted_13 = [
    "x",
    "height"
];
const _hoisted_14 = [
    "aria-valuenow"
];
const _hoisted_15 = [
    "d",
    "fill"
];
const _hoisted_16 = [
    "d",
    "fill"
];
const _hoisted_17 = [
    "x",
    "y"
];
const _hoisted_18 = [
    "aria-datavalues"
];
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("svg", {
        viewBox: $options.viewBox,
        class: "b-colorpicker-triangle"
    }, [
        (0, _vue.createElementVNode)("defs", null, [
            (0, _vue.createElementVNode)("linearGradient", {
                id: `cp-triangle-gradient-ligthness-${$data.id}`,
                x1: "0",
                y1: "0",
                x2: "1",
                y2: "0"
            }, [
                ..._hoisted_5
            ], 8 /* PROPS */ , _hoisted_2$1),
            (0, _vue.createElementVNode)("linearGradient", {
                id: `cp-triangle-gradient-saturation-${$data.id}`,
                x1: "0",
                y1: "0",
                x2: "0",
                y2: "1"
            }, [
                (0, _vue.createElementVNode)("stop", {
                    offset: "0%",
                    "stop-color": `hsl(${$data.hue}deg, 100%, 50%)`,
                    "stop-opacity": "1"
                }, null, 8 /* PROPS */ , _hoisted_7),
                (0, _vue.createElementVNode)("stop", {
                    offset: "100%",
                    "stop-color": `hsl(${$data.hue}deg, 100%, 50%)`,
                    "stop-opacity": "0"
                }, null, 8 /* PROPS */ , _hoisted_8)
            ], 8 /* PROPS */ , _hoisted_6),
            (0, _vue.createElementVNode)("clipPath", {
                id: `cp-triangle-clip-${$data.id}`
            }, [
                (0, _vue.createElementVNode)("path", {
                    d: $options.haloPath
                }, null, 8 /* PROPS */ , _hoisted_10)
            ], 8 /* PROPS */ , _hoisted_9)
        ]),
        (0, _vue.createElementVNode)("g", _hoisted_11, [
            ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                x: 0,
                y: 0,
                width: $props.size,
                height: $props.size,
                "clip-path": `url(#cp-triangle-clip-${$data.id})`
            }, [
                (0, _vue.createElementVNode)("div", {
                    class: "colorpicker-triangle-hue",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.clickHue && $options.clickHue(...args)),
                    onMousedown: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                        "prevent"
                    ])),
                    onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                        "prevent"
                    ]))
                }, null, 32 /* HYDRATE_EVENTS */ )
            ], 8 /* PROPS */ , _hoisted_12)),
            (0, _vue.createElementVNode)("g", {
                style: (0, _vue.normalizeStyle)(`transform: rotate(${$data.hue}deg)`)
            }, [
                ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                    x: $props.size / 2 - 4,
                    y: 0,
                    width: "8",
                    height: $props.thickness + 4
                }, [
                    (0, _vue.createElementVNode)("div", {
                        ref: "hueCursor",
                        class: "hue-range-thumb",
                        style: (0, _vue.normalizeStyle)(`background-color: hsl(${$data.hue}deg, 100%, 50%)`),
                        role: "slider",
                        tabindex: "0",
                        "aria-label": "Hue",
                        "aria-valuemin": "0",
                        "aria-valuenow": $data.hue,
                        "aria-valuemax": "360",
                        onClick: _cache[3] || (_cache[3] = (...args)=>$options.clickHue && $options.clickHue(...args)),
                        onKeydown: _cache[4] || (_cache[4] = (...args)=>$options.hueKeyPress && $options.hueKeyPress(...args)),
                        onMousedown: _cache[5] || (_cache[5] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                            "prevent"
                        ])),
                        onTouchstart: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                            "prevent"
                        ]))
                    }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */ , _hoisted_14)
                ], 8 /* PROPS */ , _hoisted_13))
            ], 4 /* STYLE */ )
        ]),
        (0, _vue.createElementVNode)("g", {
            class: "colorpicker-triangle-slider-sl",
            style: (0, _vue.normalizeStyle)(`transform: rotate(${$data.hue}deg) translate(50%, 50%)`),
            role: "graphics-datagroup",
            "aria-datascales": "lightness, saturation"
        }, [
            (0, _vue.createElementVNode)("path", {
                d: $options.trianglePath,
                fill: `url(#cp-triangle-gradient-ligthness-${$data.id})`
            }, null, 8 /* PROPS */ , _hoisted_15),
            (0, _vue.createElementVNode)("path", {
                d: $options.trianglePath,
                fill: `url(#cp-triangle-gradient-saturation-${$data.id})`,
                style: {
                    "mix-blend-mode": "overlay"
                },
                onClick: _cache[7] || (_cache[7] = (...args)=>$options.clickSL && $options.clickSL(...args)),
                onMousedown: _cache[8] || (_cache[8] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                    "prevent"
                ])),
                onTouchstart: _cache[9] || (_cache[9] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                    "prevent"
                ]))
            }, null, 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_16),
            ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("foreignObject", {
                x: ($options.internalRadius - 3) * $data.cos30 * (-$data.lightness + 0.5) * 2 - 6,
                y: -$options.internalRadius + (1 - $data.saturation) * ($options.internalRadius - 3) * 1.5 - 3,
                width: "12",
                height: "12"
            }, [
                (0, _vue.createElementVNode)("div", {
                    ref: "slCursor",
                    class: "sl-range-thumb",
                    style: (0, _vue.normalizeStyle)({
                        backgroundColor: `hsl(${$data.hue}deg, ${$data.saturation * 100}%, ${$data.lightness * 100}%)`
                    }),
                    tabindex: "0",
                    "aria-datavalues": `${$data.saturation * 100}%, ${$data.lightness * 100}%`,
                    onClick: _cache[10] || (_cache[10] = (...args)=>$options.clickSL && $options.clickSL(...args)),
                    onKeydown: _cache[11] || (_cache[11] = (...args)=>$options.slKeyPress && $options.slKeyPress(...args)),
                    onMousedown: _cache[12] || (_cache[12] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                        "prevent"
                    ])),
                    onTouchstart: _cache[13] || (_cache[13] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                        "prevent"
                    ]))
                }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */ , _hoisted_18)
            ], 8 /* PROPS */ , _hoisted_17))
        ], 4 /* STYLE */ )
    ], 8 /* PROPS */ , _hoisted_1$3);
}
script$3.render = render$3;
script$3.__file = "src/components/colorpicker/ColorpickerHSLRepresentationTriangle.vue";
const precision = (strs, ...values)=>{
    const tmp = [];
    strs.forEach((str, i)=>{
        tmp.push(str);
        if (values[i]) tmp.push(Number.isNaN(values[i] / 1) ? values[i] : Math.round(values * 10) / 10);
    });
    return tmp.join("");
};
var script$2 = {
    name: "BColorpickerHSLRepresentationSquare",
    props: {
        value: {
            type: Object,
            required: true,
            validator (value) {
                return typeof value.hue === "number" && typeof value.saturation === "number" && typeof value.lightness === "number";
            }
        },
        size: {
            type: Number,
            default: 200
        },
        thickness: {
            type: Number,
            default: 20
        }
    },
    emits: [
        "input"
    ],
    data () {
        return {
            hue: this.value.hue,
            saturation: this.value.saturation,
            lightness: this.value.lightness,
            captureMouse: false,
            captureType: "hue",
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            },
            debounce: 0
        };
    },
    computed: {
        hueThumbStyle () {
            const { hue, size, thickness } = this;
            const side = size - thickness;
            const offset = size / 2;
            const angle = (hue + 720 + 90) % 360 / 180 * Math.PI;
            const ciq = 1 / Math.cos(Math.PI / 4);
            const { x, y } = {
                x: -Math.min(1, Math.max(-1, ciq * Math.cos(angle))) / 2 * side + offset,
                y: -Math.min(1, Math.max(-1, ciq * Math.sin(angle))) / 2 * side + offset
            };
            return {
                background: `hsl(${hue}deg, 100%, 50%)`,
                left: precision`${x}px`,
                top: precision`${y}px`,
                width: precision`${thickness - 2}px`
            };
        },
        slThumbStyle () {
            let { hue, saturation, lightness } = this;
            saturation = Math.max(0, Math.min(1, saturation));
            lightness = Math.max(0, Math.min(1, lightness));
            return {
                background: `hsl(${hue}deg, ${saturation * 100}%, ${lightness * 100}%)`,
                left: `${saturation * 100}%`,
                top: `${(1 - lightness) * 100}%`
            };
        },
        SLBackground () {
            const { hue } = this;
            return `linear-gradient(90deg, hsl(${hue}deg, 0%, 50%), hsl(${hue}deg, 100%, 50%))`;
        }
    },
    watch: {
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                // Caching offset
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        },
        value: {
            deep: true,
            handler (newColor) {
                const { hue, saturation, lightness } = newColor;
                window.clearTimeout(this.debounce);
                this.debounce = window.setTimeout(()=>{
                    this.hue = hue;
                    this.saturation = saturation;
                    this.lightness = lightness;
                }, 200);
            }
        }
    },
    methods: {
        increaseHue (value = 1) {
            this.hue = (this.hue + value) % 360;
        },
        decreaseHue (value = 1) {
            this.hue = (360 + this.hue - value) % 360;
        },
        increaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation + value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        decreaseSaturation (value = 0.01) {
            this.saturation = Math.min(1, Math.max(0, this.saturation - value));
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness));
        },
        increaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness + value));
        },
        decreaseLightness (value = 0.01) {
            this.lightness = Math.min(0.5 + (1 - this.saturation) * 0.5, Math.max(0.5 - (1 - this.saturation) * 0.5, this.lightness - value));
        },
        hueKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseHue();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseHue();
                    handled = true;
                    break;
                case "Home":
                    this.increaseHue(360 - this.hue);
                    handled = true;
                    break;
                case "End":
                    this.decreaseHue(this.hue);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseHue(60 - this.hue % 60);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseHue(60 + this.hue % 60);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        slKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                    this.increaseSaturation();
                    handled = true;
                    break;
                case "ArrowUp":
                    this.increaseLightness();
                    handled = true;
                    break;
                case "ArrowLeft":
                    this.decreaseSaturation();
                    handled = true;
                    break;
                case "ArrowDown":
                    this.decreaseLightness();
                    handled = true;
                    break;
                case "Home":
                    this.increaseLightness(1 - this.lightness);
                    handled = true;
                    break;
                case "End":
                    this.decreaseLightness(this.lightness);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseSaturation(1 - this.saturation);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseSaturation(this.saturation);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitColor();
            }
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
            if (event.target.closest(".colorpicker-square-slider-sl") !== null) this.captureType = "sl";
            else this.captureType = "hue";
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs[this.captureType === "sl" ? "slCursor" : "hueCursor"].focus();
            }
            this.captureMouse = false;
        },
        clickHue (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.hueCursor.focus();
        },
        clickSL (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.slCursor.focus();
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            let [mouseX, mouseY] = [
                0,
                0
            ];
            if (typeof event.touches !== "undefined" && event.touches.length) [mouseX, mouseY] = [
                event.touches[0].clientX,
                event.touches[0].clientY
            ];
            else [mouseX, mouseY] = [
                event.clientX,
                event.clientY
            ];
            const angle = Math.atan2(mouseY - this.clientOffset.cy, mouseX - this.clientOffset.cx);
            if (this.captureType === "sl") {
                const saturation = (mouseX - this.clientOffset.cx) / (this.clientOffset.width - this.thickness * 2) + 0.5;
                const lightness = (mouseY - this.clientOffset.cy) / (this.clientOffset.height - this.thickness * 2) + 0.5;
                this.saturation = Math.round(Math.min(1, Math.max(0, saturation)) * 1000) / 1000;
                this.lightness = 1 - Math.round(Math.min(1, Math.max(0, lightness)) * 1000) / 1000;
            } else this.hue = Math.round(angle / Math.PI * 180 + 90) % 360;
            this.emitColor();
        },
        emitColor () {
            const { hue, saturation, lightness } = this;
            this.$emit("input", Color$1.fromHSL(hue, saturation, lightness));
            window.clearTimeout(this.debounce);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
        clearTimeout(this.debounce);
    }
};
const _hoisted_1$2 = [
    "aria-datavalues"
];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-colorpicker-square",
        style: (0, _vue.normalizeStyle)({
            width: `${$props.size}px`
        })
    }, [
        (0, _vue.createElementVNode)("div", {
            class: "colorpicker-square-slider-hue",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.clickHue && $options.clickHue(...args)),
            onMousedown: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                "prevent"
            ])),
            onTouchstart: _cache[2] || (_cache[2] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.createElementVNode)("div", {
                ref: "hueCursor",
                role: "slider",
                class: "hue-range-thumb",
                tabindex: "0",
                "aria-label": "Hue",
                "aria-valuemin": "0",
                "aria-valuemax": "359",
                style: (0, _vue.normalizeStyle)($options.hueThumbStyle)
            }, null, 4 /* STYLE */ )
        ], 32 /* HYDRATE_EVENTS */ ),
        (0, _vue.createElementVNode)("div", {
            class: "colorpicker-square-slider-sl",
            style: (0, _vue.normalizeStyle)({
                background: $options.SLBackground,
                margin: `${$props.thickness}px`
            }),
            "aria-datascales": "lightness, saturation",
            onClick: _cache[7] || (_cache[7] = (...args)=>$options.clickSL && $options.clickSL(...args)),
            onMousedown: _cache[8] || (_cache[8] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                "prevent"
            ])),
            onTouchstart: _cache[9] || (_cache[9] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.createElementVNode)("div", {
                ref: "slCursor",
                role: "slider",
                class: "sl-range-thumb",
                tabindex: "0",
                "aria-datavalues": `${$data.saturation * 100}%, ${$data.lightness * 100}%`,
                style: (0, _vue.normalizeStyle)($options.slThumbStyle),
                onClick: _cache[3] || (_cache[3] = (...args)=>$options.clickSL && $options.clickSL(...args)),
                onKeydown: _cache[4] || (_cache[4] = (...args)=>$options.slKeyPress && $options.slKeyPress(...args)),
                onMousedown: _cache[5] || (_cache[5] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                    "prevent"
                ])),
                onTouchstart: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
                    "prevent"
                ]))
            }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */ , _hoisted_1$2)
        ], 36 /* STYLE, HYDRATE_EVENTS */ )
    ], 4 /* STYLE */ );
}
script$2.render = render$2;
script$2.__file = "src/components/colorpicker/ColorpickerHSLRepresentationSquare.vue";
var script$1 = {
    name: "BColorpickerAlphaSlider",
    components: {
        [(0, _tooltipWHq2LJasJs.s).name]: (0, _tooltipWHq2LJasJs.s)
    },
    props: {
        value: {
            type: Number,
            validator: (value)=>value >= 0 && value < 256
        },
        color: [
            String,
            Object
        ]
    },
    emits: [
        "input"
    ],
    data () {
        const color = Color$1.parse(this.color);
        color.alpha = 0;
        return {
            startColor: color.toString("hex"),
            endColor: color.toString("hexa"),
            percent: Math.round((1 - this.value / 255) * 100),
            captureMouse: false,
            clientOffset: {
                cx: -1,
                cy: -1,
                width: 0,
                height: 0
            }
        };
    },
    computed: {
        style () {
            return {
                backgroundImage: `linear-gradient(90deg, ${this.startColor} 0%, ${this.endColor} 100%),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7)`,
                backgroundSize: "100% 100%, 1em 1em, 1em 1em",
                backgroundPosition: "0 0, .5em .5em, 0 0"
            };
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue !== oldValue) this.percent = Math.round((1 - newValue / 255) * 100);
        },
        color (newColor) {
            const color = Color$1.parse(newColor);
            color.alpha = 0;
            this.startColor = color.toString("hex");
            this.endColor = color.toString("hexa");
        },
        captureMouse (newValue, oldValue) {
            if (oldValue === false && newValue !== false) {
                const rect = this.$el.getBoundingClientRect();
                // Caching offset
                this.clientOffset.cx = rect.x + rect.width / 2;
                this.clientOffset.cy = rect.y + rect.height / 2;
                this.clientOffset.width = rect.width;
                this.clientOffset.height = rect.height;
            }
        }
    },
    methods: {
        increaseAlpha (value = 1) {
            this.percent = Math.max(0, Math.min(100, this.percent + value));
        },
        decreaseAlpha (value = 0.01) {
            this.increaseAlpha(-value);
        },
        alphaKeyPress (event) {
            let handled = false;
            switch(event.key){
                case "ArrowRight":
                case "ArrowUp":
                    this.increaseAlpha();
                    handled = true;
                    break;
                case "ArrowLeft":
                case "ArrowDown":
                    this.decreaseAlpha();
                    handled = true;
                    break;
                case "Home":
                    this.decreaseAlpha(this.percent);
                    handled = true;
                    break;
                case "End":
                    this.increaseAlpha(100 - this.percent);
                    handled = true;
                    break;
                case "PageUp":
                    this.increaseAlpha(10 - this.percent % 10);
                    handled = true;
                    break;
                case "PageDown":
                    this.decreaseAlpha(this.percent % 10);
                    handled = true;
                    break;
            }
            if (handled) {
                event.preventDefault();
                event.stopPropagation();
                this.emitAlpha();
            }
        },
        clickAlpha (event) {
            this.startMouseCapture(event);
            this.trackMouse(event);
            this.stopMouseCapture(event);
            this.$refs.alphaCursor.focus();
        },
        startMouseCapture (event) {
            event.stopPropagation();
            this.captureMouse = true;
        },
        trackMouse (event) {
            if (this.captureMouse === false) return;
            event.preventDefault();
            event.stopPropagation();
            let [mouseX] = [
                0,
                0
            ];
            if (typeof event.touches !== "undefined" && event.touches.length) [mouseX] = [
                event.touches[0].clientX
            ];
            else [mouseX] = [
                event.clientX
            ];
            const ratio = 0.5 + (this.clientOffset.cx - mouseX) / this.clientOffset.width;
            this.percent = Math.round(100 - Math.max(0, Math.min(1, ratio)) * 100);
            this.emitAlpha();
        },
        stopMouseCapture (event) {
            if (this.captureMouse !== false) {
                event.preventDefault();
                event.stopPropagation();
                this.$refs.alphaCursor.focus();
            }
            this.captureMouse = false;
        },
        emitAlpha () {
            this.$emit("input", (1 - this.percent / 100) * 255);
        }
    },
    mounted () {
        window.addEventListener("mousemove", this.trackMouse);
        window.addEventListener("touchmove", this.trackMouse, {
            passive: false
        });
        window.addEventListener("mouseup", this.stopMouseCapture);
        window.addEventListener("touchend", this.stopMouseCapture);
    },
    beforeUnmount () {
        window.removeEventListener("mousemove", this.trackMouse);
        window.removeEventListener("touchmove", this.trackMouse);
        window.removeEventListener("mouseup", this.stopMouseCapture);
        window.removeEventListener("touchend", this.stopMouseCapture);
    }
};
const _hoisted_1$1 = [
    "aria-valuenow"
];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tooltip = (0, _vue.resolveComponent)("b-tooltip");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: "b-colorpicker-alpha-slider",
        style: (0, _vue.normalizeStyle)($options.style),
        onClick: _cache[0] || (_cache[0] = (...args)=>$options.clickAlpha && $options.clickAlpha(...args)),
        onKeydown: _cache[1] || (_cache[1] = (...args)=>$options.alphaKeyPress && $options.alphaKeyPress(...args)),
        onMousedown: _cache[2] || (_cache[2] = (...args)=>$options.startMouseCapture && $options.startMouseCapture(...args)),
        onTouchstart: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>$options.startMouseCapture && $options.startMouseCapture(...args), [
            "prevent"
        ]))
    }, [
        (0, _vue.createElementVNode)("div", {
            ref: "alphaCursor",
            role: "slider",
            class: "alpha-range-thumb",
            tabindex: "0",
            "aria-label": "Tranparency",
            "aria-valuemin": "0",
            "aria-valuenow": $data.percent,
            "aria-valuemax": "100",
            style: (0, _vue.normalizeStyle)({
                left: `${$data.percent}%`
            })
        }, [
            (0, _vue.createVNode)(_component_b_tooltip, {
                label: `${$data.percent}%`,
                always: $data.captureMouse
            }, {
                default: (0, _vue.withCtx)(()=>[
                        (0, _vue.createTextVNode)(" \xa0 ")
                    ]),
                _: 1 /* STABLE */ 
            }, 8 /* PROPS */ , [
                "label",
                "always"
            ])
        ], 12 /* STYLE, PROPS */ , _hoisted_1$1)
    ], 36 /* STYLE, HYDRATE_EVENTS */ );
}
script$1.render = render$1;
script$1.__file = "src/components/colorpicker/ColorpickerAlphaSlider.vue";
const defaultColorFormatter = (color, vm)=>{
    if (color.alpha < 1) return color.toString("hexa");
    else return color.toString("hex");
};
const defaultColorParser = (color, vm)=>{
    return Color$1.parse(color);
};
var script = {
    name: "BColorpicker",
    components: {
        [script$3.name]: script$3,
        [script$2.name]: script$2,
        [script$1.name]: script$1,
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _fieldCMd66V8HJs.s).name]: (0, _fieldCMd66V8HJs.s),
        [(0, _selectDYWGhZcJs.s).name]: (0, _selectDYWGhZcJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _buttonKVoJ7JHHJs.s).name]: (0, _buttonKVoJ7JHHJs.s),
        [(0, _dropdownItemYQcaSZL4Js.s).name]: (0, _dropdownItemYQcaSZL4Js.s),
        [(0, _dropdownItemYQcaSZL4Js.a).name]: (0, _dropdownItemYQcaSZL4Js.a)
    },
    mixins: [
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    inheritAttrs: false,
    provide () {
        return {
            $colorpicker: this
        };
    },
    props: {
        modelValue: {
            type: [
                String,
                Object
            ],
            validator (value) {
                return typeof value === "string" || typeof value === "object" && typeof value.red === "number" && typeof value.green === "number" && typeof value.blue === "number";
            }
        },
        mobileNative: {
            type: Boolean,
            default: false
        },
        representation: {
            type: String,
            default: "triangle",
            value (value) {
                return [
                    "triangle",
                    "square"
                ].some((r)=>r === value);
            }
        },
        inline: Boolean,
        disabled: Boolean,
        horizontalColorPicker: {
            type: Boolean,
            default: false
        },
        colorFormatter: {
            type: Function,
            default: (color, vm)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultColorFormatter === "function") return (0, _configNHWiBviwJs.c).defaultColorFormatter(color);
                else return defaultColorFormatter(color);
            }
        },
        colorParser: {
            type: Function,
            default: (color, vm)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultColorParser === "function") return (0, _configNHWiBviwJs.c).defaultColorParser(color);
                else return defaultColorParser(color);
            }
        },
        alpha: {
            type: Boolean,
            default: false
        },
        expanded: Boolean,
        position: String,
        mobileModal: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerMobileModal
        },
        focusable: {
            type: Boolean,
            default: true
        },
        trapFocus: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTrapFocus
        },
        appendToBody: Boolean
    },
    emits: [
        "active-change",
        "update:modelValue"
    ],
    data () {
        return {
            color: this.parseColor(this.modelValue)
        };
    },
    computed: {
        computedValue: {
            set (value) {
                this.color = this.parseColor(value);
            },
            get () {
                return this.color;
            }
        },
        background () {
            if (this.alpha) return `linear-gradient(
                    45deg,
                    ${this.computedValue.toString("hex")} 50%,
                    ${this.computedValue.toString("hexa")} 50%
                )`;
            else {
                const hex = this.computedValue.toString("hex");
                return `linear-gradient(
                    45deg,
                    ${hex} 50%,
                    ${hex} 50%
                )`;
            }
        },
        triggerStyle () {
            const { red, green, blue } = this.computedValue;
            const light = red * 0.299 + green * 0.587 + blue * 0.114 > 186;
            return {
                backgroundColor: "#ffffff",
                backgroundImage: `
                    ${this.background},
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7),
                    linear-gradient(45deg, #c7c7c7 25%, transparent 25%, transparent 75%, #c7c7c7 75%, #c7c7c7)
                `,
                backgroundSize: "100% 100%, 16px 16px, 16px 16px",
                backgroundPosition: "0 0, 8px 8px, 0 0",
                color: light ? "#000000" : "#FFFFFF",
                textShadow: `0 0 2px ${light ? "#FFFFFFAA" : "#000000AA"}`
            };
        },
        isMobile () {
            return this.mobileNative && (0, _helpersO9H6ICOJs.c).any();
        },
        ariaRole () {
            if (!this.inline) return "dialog";
            else return undefined;
        }
    },
    watch: {
        modelValue (value) {
            this.computedValue = new Color$1(value);
        }
    },
    methods: {
        parseColor (color) {
            try {
                return this.colorParser(color);
            } catch (e) {
                return new Color$1();
            }
        },
        updateColor (value) {
            value.alpha = this.computedValue.alpha;
            this.computedValue = value;
            this.$emit("update:modelValue", value);
        },
        updateAlpha (alpha) {
            this.computedValue.alpha = alpha;
            this.$emit("update:modelValue", this.computedValue);
        },
        updateRGB () {
            this.$emit("update:modelValue", this.computedValue);
        },
        /*
         * Format color into string
         */ formatValue (value) {
            return value ? this.colorFormatter(value, this) : null;
        },
        /*
         * Toggle datepicker
         */ togglePicker (active) {
            if (this.$refs.dropdown) {
                const isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
                if (isActive) this.$refs.dropdown.isActive = isActive;
                else if (this.closeOnClick) this.$refs.dropdown.isActive = isActive;
            }
        },
        /*
         * Call default onFocus method and show datepicker
         */ handleOnFocus (event) {
            this.onFocus(event);
            if (this.openOnFocus) this.togglePicker(true);
        },
        /*
         * Toggle dropdown
         */ toggle () {
            if (this.mobileNative && this.isMobile) {
                const input = this.$refs.input.$refs.input;
                input.focus();
                input.click();
                return;
            }
            this.$refs.dropdown.toggle();
        },
        /*
         * Avoid dropdown toggle when is already visible
         */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        },
        /**
         * Keypress event that is bound to the document.
         */ keyPress ({ key }) {
            if (this.$refs.dropdown && this.$refs.dropdown.isActive && (key === "Escape" || key === "Esc")) this.togglePicker(false);
        },
        /**
         * Emit 'blur' event on dropdown is not active (closed)
         */ onActiveChange (value) {
            if (!value) this.onBlur();
            /*
             * Emit 'active-change' when on dropdown active state change
             */ this.$emit("active-change", value);
        }
    }
};
const _hoisted_1 = {
    class: "color-name"
};
const _hoisted_2 = {
    class: "colorpicker-header"
};
const _hoisted_3 = {
    class: "colorpicker-content"
};
const _hoisted_4 = {
    class: "colorpicker-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _component_b_colorpicker_h_s_l_representation_square = (0, _vue.resolveComponent)("b-colorpicker-h-s-l-representation-square");
    const _component_b_colorpicker_h_s_l_representation_triangle = (0, _vue.resolveComponent)("b-colorpicker-h-s-l-representation-triangle");
    const _component_b_colorpicker_alpha_slider = (0, _vue.resolveComponent)("b-colorpicker-alpha-slider");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "colorpicker control",
            [
                _ctx.size,
                {
                    "is-expanded": $props.expanded
                }
            ]
        ])
    }, [
        !$options.isMobile || $props.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: $props.position,
            expanded: $props.expanded,
            disabled: $props.disabled,
            inline: $props.inline,
            "mobile-modal": $props.mobileModal,
            "trap-focus": $props.trapFocus,
            "aria-role": $options.ariaRole,
            "append-to-body": $props.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: $options.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: $props.disabled,
                        focusable: $props.focusable,
                        custom: "",
                        class: (0, _vue.normalizeClass)({
                            "dropdown-horizontal-colorpicker": $props.horizontalColorPicker
                        })
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("header", _hoisted_2, [
                                        _ctx.$slots.header !== undefined && _ctx.$slots.header.length ? (0, _vue.renderSlot)(_ctx.$slots, "header", {
                                            key: 0
                                        }) : (0, _vue.createCommentVNode)("v-if", true)
                                    ]),
                                    (0, _vue.createElementVNode)("div", _hoisted_3, [
                                        $props.representation === "square" ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_h_s_l_representation_square, {
                                            key: 0,
                                            value: $options.computedValue,
                                            onInput: $options.updateColor
                                        }, null, 8 /* PROPS */ , [
                                            "value",
                                            "onInput"
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_h_s_l_representation_triangle, {
                                            key: 1,
                                            value: $options.computedValue,
                                            onInput: $options.updateColor
                                        }, null, 8 /* PROPS */ , [
                                            "value",
                                            "onInput"
                                        ]))
                                    ])
                                ]),
                                (0, _vue.createElementVNode)("footer", _hoisted_4, [
                                    $props.alpha ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_colorpicker_alpha_slider, {
                                        key: 0,
                                        value: $options.computedValue.alpha,
                                        onInput: $options.updateAlpha,
                                        color: $options.computedValue
                                    }, null, 8 /* PROPS */ , [
                                        "value",
                                        "onInput",
                                        "color"
                                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                                    (0, _vue.renderSlot)(_ctx.$slots, "footer", {
                                        color: $options.computedValue
                                    }, ()=>[
                                            (0, _vue.createVNode)(_component_b_field, {
                                                class: "colorpicker-fields",
                                                grouped: ""
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "R"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: $options.computedValue.red,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[0] || (_cache[0] = ($event)=>$options.computedValue.red = $event),
                                                                            $options.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Red"
                                                                    }, null, 8 /* PROPS */ , [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1 /* STABLE */ 
                                                        }),
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "G"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: $options.computedValue.green,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[1] || (_cache[1] = ($event)=>$options.computedValue.green = $event),
                                                                            $options.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Green"
                                                                    }, null, 8 /* PROPS */ , [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1 /* STABLE */ 
                                                        }),
                                                        (0, _vue.createVNode)(_component_b_field, {
                                                            horizontal: "",
                                                            label: "B"
                                                        }, {
                                                            default: (0, _vue.withCtx)(()=>[
                                                                    (0, _vue.createVNode)(_component_b_input, {
                                                                        type: "number",
                                                                        modelValue: $options.computedValue.blue,
                                                                        "onUpdate:modelValue": [
                                                                            _cache[2] || (_cache[2] = ($event)=>$options.computedValue.blue = $event),
                                                                            $options.updateRGB
                                                                        ],
                                                                        modelModifiers: {
                                                                            number: true
                                                                        },
                                                                        size: "is-small",
                                                                        "aria-label": "Blue"
                                                                    }, null, 8 /* PROPS */ , [
                                                                        "modelValue",
                                                                        "onUpdate:modelValue"
                                                                    ])
                                                                ]),
                                                            _: 1 /* STABLE */ 
                                                        })
                                                    ]),
                                                _: 1 /* STABLE */ 
                                            })
                                        ])
                                ])
                            ]),
                        _: 3 /* FORWARDED */ 
                    }, 8 /* PROPS */ , [
                        "disabled",
                        "focusable",
                        "class"
                    ])
                ]),
            _: 2 /* DYNAMIC */ 
        }, [
            !$props.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_button, {
                                    style: (0, _vue.normalizeStyle)($options.triggerStyle),
                                    expanded: $props.expanded,
                                    disabled: $props.disabled
                                }, {
                                    default: (0, _vue.withCtx)(()=>[
                                            (0, _vue.createElementVNode)("span", _hoisted_1, (0, _vue.toDisplayString)($props.colorFormatter($options.computedValue)), 1 /* TEXT */ )
                                        ]),
                                    _: 1 /* STABLE */ 
                                }, 8 /* PROPS */ , [
                                    "style",
                                    "expanded",
                                    "disabled"
                                ])
                            ])
                    ]),
                key: "0"
            } : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */ , [
            "position",
            "expanded",
            "disabled",
            "inline",
            "mobile-modal",
            "trap-focus",
            "aria-role",
            "append-to-body",
            "onActiveChange"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/colorpicker/Colorpicker.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","./typeof-Z4rCTFCZ.js":"cvqjf","./classCallCheck-E4khD9xn.js":"fYU5v","./Button-KVoJ7jHH.js":"l7xXn","./DropdownItem-yQcaSZL4.js":"jPdf6","./Input-0ivJhXUC.js":"jYQke","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","./Tooltip-WHq2LJas.js":"6mgq3","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fYU5v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", ()=>_createClass);
parcelHelpers.export(exports, "a", ()=>_classCallCheck);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _helpersO9H6ICOJs.C)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"./helpers-O9h6_ICO.js":"9IzVa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHgPZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _vue = require("vue");
var script = {
    name: "BSelect",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: {
            type: [
                String,
                Number,
                Boolean,
                Object,
                Array,
                Function,
                Date
            ],
            default: null
        },
        placeholder: String,
        multiple: Boolean,
        nativeSize: [
            String,
            Number
        ]
    },
    emits: [
        "blur",
        "focus",
        "update:modelValue"
    ],
    data () {
        return {
            selected: this.modelValue,
            _elementRef: "select"
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.selected;
            },
            set (value) {
                this.selected = value;
                this.$emit("update:modelValue", value);
                !this.isValid && this.checkHtml5Validity();
            }
        },
        spanClasses () {
            return [
                this.size,
                this.statusType,
                {
                    "is-fullwidth": this.expanded,
                    "is-loading": this.loading,
                    "is-multiple": this.multiple,
                    "is-rounded": this.rounded,
                    "is-empty": this.selected === null
                }
            ];
        }
    },
    watch: {
        /**
        * When v-model is changed:
        *   1. Set the selected option.
        *   2. If it's invalid, validate again.
        */ modelValue (value) {
            this.selected = value;
            !this.isValid && this.checkHtml5Validity();
        }
    }
};
const _hoisted_1 = [
    "multiple",
    "size"
];
const _hoisted_2 = {
    key: 0,
    value: null,
    disabled: "",
    hidden: ""
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "control",
            {
                "is-expanded": _ctx.expanded,
                "has-icons-left": _ctx.icon
            }
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "select",
                $options.spanClasses
            ])
        }, [
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("select", (0, _vue.mergeProps)({
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.computedValue = $event),
                ref: "select",
                multiple: $props.multiple,
                size: $props.nativeSize
            }, _ctx.fallthroughAttrs, {
                onBlur: _cache[1] || (_cache[1] = ($event)=>_ctx.$emit("blur", $event) && _ctx.checkHtml5Validity()),
                onFocus: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("focus", $event))
            }), [
                $props.placeholder ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    $options.computedValue == null ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", _hoisted_2, (0, _vue.toDisplayString)($props.placeholder), 1 /* TEXT */ )) : (0, _vue.createCommentVNode)("v-if", true)
                ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true),
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ], 16 /* FULL_PROPS */ , _hoisted_1), [
                [
                    (0, _vue.vModelSelect),
                    $options.computedValue
                ]
            ])
        ], 2 /* CLASS */ ),
        _ctx.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 0,
            class: "is-left",
            icon: _ctx.icon,
            pack: _ctx.iconPack,
            size: _ctx.iconSize
        }, null, 8 /* PROPS */ , [
            "icon",
            "pack",
            "size"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/select/Select.vue";

},{"./Icon-fJqkx1gN.js":"gKXjn","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6mgq3":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var script = {
    name: "BTooltip",
    props: {
        active: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTooltipType
        },
        label: String,
        delay: {
            type: Number,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTooltipDelay
        },
        closeDelay: {
            type: Number,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTooltipCloseDelay
        },
        position: {
            type: String,
            default: "is-top",
            validator (value) {
                return [
                    "is-top",
                    "is-bottom",
                    "is-left",
                    "is-right"
                ].indexOf(value) > -1;
            }
        },
        triggers: {
            type: Array,
            default: ()=>[
                    "hover"
                ]
        },
        always: Boolean,
        square: Boolean,
        dashed: Boolean,
        multilined: Boolean,
        size: {
            type: String,
            default: "is-medium"
        },
        appendToBody: Boolean,
        animated: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        contentClass: String,
        autoClose: {
            type: [
                Array,
                Boolean
            ],
            default: true
        }
    },
    emits: [
        "close",
        "open"
    ],
    data () {
        return {
            isActive: false,
            triggerStyle: {},
            timer: null,
            _bodyEl: undefined,
            resizeObserver: undefined,
            resizeListener: undefined,
            timeOutID: null
        };
    },
    computed: {
        rootClasses () {
            return [
                "b-tooltip",
                this.type,
                this.position,
                this.size,
                {
                    "is-square": this.square,
                    "is-always": this.always,
                    "is-multiline": this.multilined,
                    "is-dashed": this.dashed
                }
            ];
        },
        newAnimation () {
            return this.animated ? this.animation : undefined;
        }
    },
    watch: {
        isActive () {
            this.$emit(this.isActive ? "open" : "close");
            if (this.appendToBody) this.updateAppendToBody();
        }
    },
    methods: {
        updateAppendToBody () {
            const tooltip = this.$refs.tooltip;
            const trigger = this.$refs.trigger;
            if (tooltip && trigger) {
                // update wrapper tooltip
                const tooltipEl = this.$data._bodyEl.children[0];
                tooltipEl.classList.forEach((item)=>tooltipEl.classList.remove(item));
                if (this.$vnode && this.$vnode.data && this.$vnode.data.staticClass) tooltipEl.classList.add(this.$vnode.data.staticClass);
                this.rootClasses.forEach((item)=>{
                    if (typeof item === "object") {
                        for(const key in item)if (item[key]) tooltipEl.classList.add(key);
                    } else tooltipEl.classList.add(item);
                });
                const rect = trigger.getBoundingClientRect();
                const top = rect.top + window.scrollY;
                const left = rect.left + window.scrollX;
                // `tooltipEl` will be placed relative to `wrapper`
                // because `wrapper` should create a stacking context
                // as its z-index is non-auto
                tooltipEl.style.position = "absolute";
                switch(this.position){
                    case "is-top":
                        tooltipEl.style.width = `${trigger.clientWidth}px`;
                        tooltipEl.style.height = "0px";
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-bottom":
                        tooltipEl.style.width = `${trigger.clientWidth}px`;
                        tooltipEl.style.height = "0px";
                        tooltipEl.style.top = `${trigger.clientHeight}px`;
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-left":
                        tooltipEl.style.width = "0px";
                        tooltipEl.style.height = `${trigger.clientHeight}px`;
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = "0px";
                        break;
                    case "is-right":
                        tooltipEl.style.width = "0px";
                        tooltipEl.style.height = `${trigger.clientHeight}px`;
                        tooltipEl.style.top = "0px";
                        tooltipEl.style.left = `${trigger.clientWidth}px`;
                        break;
                }
                const wrapper = this.$data._bodyEl;
                wrapper.style.position = "absolute";
                wrapper.style.top = `${top}px`;
                wrapper.style.left = `${left}px`;
                wrapper.style.width = "0px";
                wrapper.style.zIndex = this.isActive || this.always ? "99" : "-1";
                this.triggerStyle = {
                    zIndex: this.isActive || this.always ? "100" : undefined
                };
            }
        },
        onClick () {
            if (this.triggers.indexOf("click") < 0) return;
            // if not active, toggle after clickOutside event
            // this fixes toggling programmatic
            this.$nextTick(()=>{
                this.timeOutID = setTimeout(()=>this.open());
            });
        },
        onHover () {
            if (this.triggers.indexOf("hover") < 0) return;
            this.open();
        },
        onContextMenu (e) {
            if (this.triggers.indexOf("contextmenu") < 0) return;
            e.preventDefault();
            this.open();
        },
        onFocus () {
            if (this.triggers.indexOf("focus") < 0) return;
            this.open();
        },
        open () {
            if (this.delay) this.timer = setTimeout(()=>{
                this.isActive = true;
                this.timer = null;
            }, this.delay);
            else this.isActive = true;
        },
        close () {
            if (typeof this.autoClose === "boolean") {
                if (this.autoClose && this.timer) clearTimeout(this.timer);
                if (this.closeDelay) this.timer = setTimeout(()=>{
                    this.isActive = !this.autoClose;
                    this.timer = null;
                }, this.closeDelay);
                else this.isActive = !this.autoClose;
            }
        },
        /**
        * Close tooltip if clicked outside.
        */ clickedOutside (event) {
            if (this.isActive) {
                if (Array.isArray(this.autoClose)) {
                    if (this.autoClose.includes("outside")) {
                        if (!this.isInWhiteList(event.target)) {
                            this.isActive = false;
                            return;
                        }
                    }
                    if (this.autoClose.includes("inside")) {
                        if (this.isInWhiteList(event.target)) this.isActive = false;
                    }
                }
            }
        },
        /**
         * Keypress event that is bound to the document
         */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) {
                if (Array.isArray(this.autoClose)) {
                    if (this.autoClose.indexOf("escape") >= 0) this.isActive = false;
                }
            }
        },
        /**
        * White-listed items to not close when clicked.
        */ isInWhiteList (el) {
            if (el === this.$refs.content) return true;
            // All chidren from content
            if (this.$refs.content != null) {
                const children = this.$refs.content.querySelectorAll("*");
                for (const child of children){
                    if (el === child) return true;
                }
            }
            return false;
        }
    },
    mounted () {
        if (this.appendToBody && typeof window !== "undefined") {
            this.controller = new window.AbortController();
            this.$data._bodyEl = (0, _helpersO9H6ICOJs.d)(this.$refs.content);
            this.updateAppendToBody();
            // updates the tooltip position if the tooltip is inside
            // `.animation-content`
            const animation = this.$el.closest(".animation-content");
            if (animation != null) {
                const listener = ()=>{
                    this.updateAppendToBody();
                    animation.removeEventListener("transitionend", listener);
                };
                animation.addEventListener("transitionend", listener, {
                    signal: this.controller.signal
                });
            }
            // observes changes in the window size
            this.resizeListener = ()=>this.updateAppendToBody();
            window.addEventListener("resize", this.resizeListener);
            // observes changes in the size of the immediate parent
            this.resizeObserver = new ResizeObserver(this.resizeListener);
            if (this.$el.parentNode != null && this.$el.parentNode.nodeType === Node.ELEMENT_NODE) this.resizeObserver.observe(this.$el.parentNode);
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("click", this.clickedOutside);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("click", this.clickedOutside);
            document.removeEventListener("keyup", this.keyPress);
        }
        if (this.resizeListener != null) window.removeEventListener("resize", this.resizeListener);
        if (this.resizeObserver != null) this.resizeObserver.disconnect();
        if (this.appendToBody) (0, _helpersO9H6ICOJs.r)(this.$data._bodyEl);
        if (this.controller != null) this.controller.abort();
        clearTimeout(this.timer);
        clearTimeout(this.timeOutID);
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        ref: "tooltip",
        class: (0, _vue.normalizeClass)($options.rootClasses)
    }, [
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: $options.newAnimation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        ref: "content",
                        class: (0, _vue.normalizeClass)([
                            "tooltip-content",
                            $props.contentClass
                        ])
                    }, [
                        $props.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: 0
                        }, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                        ], 64 /* STABLE_FRAGMENT */ )) : _ctx.$slots.content ? (0, _vue.renderSlot)(_ctx.$slots, "content", {
                            key: 1
                        }) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 2 /* CLASS */ ), [
                        [
                            (0, _vue.vShow),
                            $props.active && ($data.isActive || $props.always)
                        ]
                    ])
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "name"
        ]),
        (0, _vue.createElementVNode)("div", {
            ref: "trigger",
            class: "tooltip-trigger",
            style: (0, _vue.normalizeStyle)($data.triggerStyle),
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.onClick && $options.onClick(...args)),
            onContextmenu: _cache[1] || (_cache[1] = (...args)=>$options.onContextMenu && $options.onContextMenu(...args)),
            onMouseenter: _cache[2] || (_cache[2] = (...args)=>$options.onHover && $options.onHover(...args)),
            onFocusCapture: _cache[3] || (_cache[3] = (...args)=>$options.onFocus && $options.onFocus(...args)),
            onBlurCapture: _cache[4] || (_cache[4] = (...args)=>$options.close && $options.close(...args)),
            onMouseleave: _cache[5] || (_cache[5] = (...args)=>$options.close && $options.close(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {
                ref: "slot"
            })
        ], 36 /* STYLE, HYDRATE_EVENTS */ )
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/tooltip/Tooltip.vue";

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0NE6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BDatepicker", ()=>(0, _datepickerR7KMGxsCJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _datepickerR7KMGxsCJs = require("./Datepicker-r7KMGxsC.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _datepickerR7KMGxsCJs.s));
    }
};

},{"./Datepicker-r7KMGxsC.js":"24fex","./plugins-C7548x21.js":"fuYWh","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./config-nHWiBviw.js":"4fneA","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","./DropdownItem-yQcaSZL4.js":"jPdf6","./trapFocus-IMs77O3T.js":"jBg9U","./Input-0ivJhXUC.js":"jYQke","./Icon-fJqkx1gN.js":"gKXjn","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"24fex":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var script$3 = {
    name: "BDatepickerTableRow",
    inject: {
        $datepicker: {
            name: "$datepicker",
            default: false
        }
    },
    props: {
        selectedDate: {
            type: [
                Date,
                Array
            ]
        },
        hoveredDateRange: Array,
        day: {
            type: Number
        },
        week: {
            type: Array,
            required: true
        },
        month: {
            type: Number,
            required: true
        },
        minDate: Date,
        maxDate: Date,
        disabled: Boolean,
        unselectableDates: [
            Array,
            Function
        ],
        unselectableDaysOfWeek: Array,
        selectableDates: [
            Array,
            Function
        ],
        events: Array,
        indicators: String,
        dateCreator: Function,
        nearbyMonthDays: Boolean,
        nearbySelectableMonthDays: Boolean,
        showWeekNumber: Boolean,
        weekNumberClickable: Boolean,
        range: Boolean,
        multiple: Boolean,
        rulesForFirstWeek: Number,
        firstDayOfWeek: Number
    },
    emits: [
        "change-focus",
        "rangeHoverEndDate",
        "select"
    ],
    watch: {
        day (day) {
            const refName = `day-${this.month}-${day}`;
            this.$nextTick(()=>{
                // Vue ≥ v3.0 < v3.2.25, refs in v-for are stored as a single object,
                // but ≥ v3.2.25, refs in v-for are stored in an array (same as Vue 2)
                let cell;
                if (Array.isArray(this.$refs[refName])) cell = this.$refs[refName][0];
                else cell = this.$refs[refName];
                if (cell) cell.focus();
            }); // $nextTick needed when month is changed
        }
    },
    methods: {
        firstWeekOffset (year, dow, doy) {
            // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            const fwd = 7 + dow - doy;
            // first-week day local weekday -- which local weekday is fwd
            const firstJanuary = new Date(year, 0, fwd);
            const fwdlw = (7 + firstJanuary.getDay() - dow) % 7;
            return -fwdlw + fwd - 1;
        },
        daysInYear (year) {
            return this.isLeapYear(year) ? 366 : 365;
        },
        isLeapYear (year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        },
        getSetDayOfYear (input) {
            return Math.round((input - new Date(input.getFullYear(), 0, 1)) / 864e5) + 1;
        },
        weeksInYear (year, dow, doy) {
            const weekOffset = this.firstWeekOffset(year, dow, doy);
            const weekOffsetNext = this.firstWeekOffset(year + 1, dow, doy);
            return (this.daysInYear(year) - weekOffset + weekOffsetNext) / 7;
        },
        getWeekNumber (mom) {
            const dow = this.firstDayOfWeek; // first day of week
            // Rules for the first week : 1 for the 1st January, 4 for the 4th January
            const doy = this.rulesForFirstWeek;
            const weekOffset = this.firstWeekOffset(mom.getFullYear(), dow, doy);
            const week = Math.floor((this.getSetDayOfYear(mom) - weekOffset - 1) / 7) + 1;
            let resWeek;
            let resYear;
            if (week < 1) {
                resYear = mom.getFullYear() - 1;
                resWeek = week + this.weeksInYear(resYear, dow, doy);
            } else if (week > this.weeksInYear(mom.getFullYear(), dow, doy)) {
                resWeek = week - this.weeksInYear(mom.getFullYear(), dow, doy);
                resYear = mom.getFullYear() + 1;
            } else {
                resYear = mom.getFullYear();
                resWeek = week;
            }
            return {
                week: resWeek,
                year: resYear
            };
        },
        clickWeekNumber (weekData) {
            if (this.weekNumberClickable) this.$datepicker.$emit("week-number-click", weekData.week, weekData.year);
        },
        /*
         * Check that selected day is within earliest/latest params and
         * is within this month
         */ selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) validity.push(day.getMonth() === this.month);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        /*
        * Emit select event with chosen date as payload
        */ emitChosenDate (day) {
            if (this.disabled) return;
            if (this.selectableDate(day)) this.$emit("select", day);
        },
        eventsDateMatch (day) {
            if (!this.events || !this.events.length) return false;
            const dayEvents = [];
            for(let i = 0; i < this.events.length; i++)if (this.events[i].date.getDay() === day.getDay()) dayEvents.push(this.events[i]);
            if (!dayEvents.length) return false;
            return dayEvents;
        },
        /*
        * Build classObject for cell using validations
        */ classObject (day) {
            function dateMatch(dateOne, dateTwo, multiple) {
                // if either date is null or undefined, return false
                // if using multiple flag, return false
                if (!dateOne || !dateTwo || multiple) return false;
                if (Array.isArray(dateTwo)) return dateTwo.some((date)=>dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
                return dateOne.getDate() === dateTwo.getDate() && dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
            }
            function dateWithin(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || multiple) return false;
                return dateOne > dates[0] && dateOne < dates[1];
            }
            return {
                "is-selected": dateMatch(day, this.selectedDate) || dateWithin(day, this.selectedDate, this.multiple),
                "is-first-selected": dateMatch(day, Array.isArray(this.selectedDate) && this.selectedDate[0], this.multiple),
                "is-within-selected": dateWithin(day, this.selectedDate, this.multiple),
                "is-last-selected": dateMatch(day, Array.isArray(this.selectedDate) && this.selectedDate[1], this.multiple),
                "is-within-hovered-range": this.hoveredDateRange && this.hoveredDateRange.length === 2 && (dateMatch(day, this.hoveredDateRange) || dateWithin(day, this.hoveredDateRange)),
                "is-first-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[0]),
                "is-within-hovered": dateWithin(day, this.hoveredDateRange),
                "is-last-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[1]),
                "is-today": dateMatch(day, this.dateCreator()),
                "is-selectable": this.selectableDate(day) && !this.disabled,
                "is-unselectable": !this.selectableDate(day) || this.disabled,
                "is-invisible": !this.nearbyMonthDays && day.getMonth() !== this.month,
                "is-nearby": this.nearbySelectableMonthDays && day.getMonth() !== this.month,
                "has-event": this.eventsDateMatch(day),
                [this.indicators]: this.eventsDateMatch(day)
            };
        },
        setRangeHoverEndDate (day) {
            if (this.range) this.$emit("rangeHoverEndDate", day);
        },
        manageKeydown (event, weekDay) {
            // https://developer.mozilla.org/fr/docs/Web/API/KeyboardEvent/key/Key_Values#Navigation_keys
            const { key } = event;
            let preventDefault = true;
            switch(key){
                case "Tab":
                    preventDefault = false;
                    break;
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.emitChosenDate(weekDay);
                    break;
                case "ArrowLeft":
                case "Left":
                    this.changeFocus(weekDay, -1);
                    break;
                case "ArrowRight":
                case "Right":
                    this.changeFocus(weekDay, 1);
                    break;
                case "ArrowUp":
                case "Up":
                    this.changeFocus(weekDay, -7);
                    break;
                case "ArrowDown":
                case "Down":
                    this.changeFocus(weekDay, 7);
                    break;
            }
            if (preventDefault) event.preventDefault();
        },
        changeFocus (day, inc) {
            const nextDay = new Date(day.getTime());
            nextDay.setDate(day.getDate() + inc);
            while((!this.minDate || nextDay > this.minDate) && (!this.maxDate || nextDay < this.maxDate) && !this.selectableDate(nextDay))nextDay.setDate(nextDay.getDate() + Math.sign(inc));
            this.setRangeHoverEndDate(nextDay);
            this.$emit("change-focus", nextDay);
        }
    }
};
const _hoisted_1$3 = {
    class: "datepicker-row"
};
const _hoisted_2$3 = [
    "disabled",
    "onClick",
    "onMouseenter",
    "onKeydown",
    "tabindex"
];
const _hoisted_3$2 = {
    key: 0,
    class: "events"
};
const _hoisted_4$2 = {
    key: 0,
    class: "events"
};
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$3, [
        $props.showWeekNumber ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "datepicker-cell is-week-number",
                {
                    "is-clickable": $props.weekNumberClickable
                }
            ]),
            onClick: _cache[0] || (_cache[0] = (0, _vue.withModifiers)(($event)=>$options.clickWeekNumber($options.getWeekNumber($props.week[6])), [
                "prevent"
            ]))
        }, [
            (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($options.getWeekNumber($props.week[6]).week), 1 /* TEXT */ )
        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true),
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.week, (weekDay, index)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: index
            }, [
                $options.selectableDate(weekDay) && !$props.disabled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                    key: 0,
                    ref_for: true,
                    ref: `day-${weekDay.getMonth()}-${weekDay.getDate()}`,
                    class: (0, _vue.normalizeClass)([
                        $options.classObject(weekDay),
                        "datepicker-cell"
                    ]),
                    role: "button",
                    href: "#",
                    disabled: $props.disabled || undefined,
                    onClick: (0, _vue.withModifiers)(($event)=>$options.emitChosenDate(weekDay), [
                        "prevent"
                    ]),
                    onMouseenter: ($event)=>$options.setRangeHoverEndDate(weekDay),
                    onKeydown: ($event)=>$options.manageKeydown($event, weekDay),
                    tabindex: $props.day === weekDay.getDate() && $props.month === weekDay.getMonth() ? null : -1
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(weekDay.getDate()), 1 /* TEXT */ ),
                    $options.eventsDateMatch(weekDay) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3$2, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.eventsDateMatch(weekDay), (event, evIdx)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                class: (0, _vue.normalizeClass)([
                                    "event",
                                    event.type
                                ]),
                                key: evIdx
                            }, null, 2 /* CLASS */ );
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_2$3)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 1,
                    class: (0, _vue.normalizeClass)([
                        $options.classObject(weekDay),
                        "datepicker-cell"
                    ])
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(weekDay.getDate()), 1 /* TEXT */ ),
                    $options.eventsDateMatch(weekDay) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$2, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.eventsDateMatch(weekDay), (event, evIdx)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                class: (0, _vue.normalizeClass)([
                                    "event",
                                    event.type
                                ]),
                                key: evIdx
                            }, null, 2 /* CLASS */ );
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ ))
            ], 64 /* STABLE_FRAGMENT */ );
        }), 128 /* KEYED_FRAGMENT */ ))
    ]);
}
script$3.render = render$3;
script$3.__file = "src/components/datepicker/DatepickerTableRow.vue";
var script$2 = {
    name: "BDatepickerTable",
    components: {
        [script$3.name]: script$3
    },
    props: {
        modelValue: {
            type: [
                Date,
                Array
            ]
        },
        dayNames: Array,
        monthNames: Array,
        firstDayOfWeek: Number,
        events: Array,
        indicators: String,
        minDate: Date,
        maxDate: Date,
        focused: Object,
        disabled: Boolean,
        dateCreator: Function,
        unselectableDates: [
            Array,
            Function
        ],
        unselectableDaysOfWeek: Array,
        selectableDates: [
            Array,
            Function
        ],
        nearbyMonthDays: Boolean,
        nearbySelectableMonthDays: Boolean,
        showWeekNumber: Boolean,
        weekNumberClickable: Boolean,
        rulesForFirstWeek: Number,
        range: Boolean,
        multiple: Boolean
    },
    emits: [
        "range-end",
        "range-start",
        "update:focused",
        "update:modelValue"
    ],
    data () {
        return {
            selectedBeginDate: undefined,
            selectedEndDate: undefined,
            hoveredEndDate: undefined
        };
    },
    computed: {
        multipleSelectedDates: {
            get () {
                return this.multiple && this.modelValue ? this.modelValue : [];
            },
            set (value) {
                this.$emit("update:modelValue", value);
            }
        },
        visibleDayNames () {
            const visibleDayNames = [];
            let index = this.firstDayOfWeek;
            while(visibleDayNames.length < this.dayNames.length){
                const currentDayName = this.dayNames[index % this.dayNames.length];
                visibleDayNames.push(currentDayName);
                index++;
            }
            if (this.showWeekNumber) visibleDayNames.unshift("");
            return visibleDayNames;
        },
        hasEvents () {
            return this.events && this.events.length;
        },
        /*
        * Return array of all events in the specified month
        */ eventsInThisMonth () {
            if (!this.events) return [];
            const monthEvents = [];
            for(let i = 0; i < this.events.length; i++){
                let event = this.events[i];
                if (!Object.prototype.hasOwnProperty.call(event, "date")) event = {
                    date: event
                };
                if (!Object.prototype.hasOwnProperty.call(event, "type")) event.type = "is-primary";
                if (event.date.getMonth() === this.focused.month && event.date.getFullYear() === this.focused.year) monthEvents.push(event);
            }
            return monthEvents;
        },
        /*
        * Return array of all weeks in the specified month
        */ weeksInThisMonth () {
            this.validateFocusedDay();
            const month = this.focused.month;
            const year = this.focused.year;
            const weeksInThisMonth = [];
            let startingDay = 1;
            while(weeksInThisMonth.length < 6){
                const newWeek = this.weekBuilder(startingDay, month, year);
                weeksInThisMonth.push(newWeek);
                startingDay += 7;
            }
            return weeksInThisMonth;
        },
        hoveredDateRange () {
            if (!this.range) return [];
            if (!isNaN(this.selectedEndDate)) return [];
            if (this.hoveredEndDate < this.selectedBeginDate) return [
                this.hoveredEndDate,
                this.selectedBeginDate
            ].filter((0, _helpersO9H6ICOJs.v));
            return [
                this.selectedBeginDate,
                this.hoveredEndDate
            ].filter((0, _helpersO9H6ICOJs.v));
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    methods: {
        /*
        * Emit input event with selected date as payload for v-model in parent
        */ updateSelectedDate (date) {
            if (!this.range && !this.multiple) this.$emit("update:modelValue", date);
            else if (this.range) this.handleSelectRangeDate(date);
            else if (this.multiple) this.handleSelectMultipleDates(date);
        },
        /*
        * If both begin and end dates are set, reset the end date and set the begin date.
        * If only begin date is selected, emit an array of the begin date and the new date.
        * If not set, only set the begin date.
        */ handleSelectRangeDate (date) {
            if (this.selectedBeginDate && this.selectedEndDate) {
                this.selectedBeginDate = date;
                this.selectedEndDate = undefined;
                this.$emit("range-start", date);
            } else if (this.selectedBeginDate && !this.selectedEndDate) {
                if (this.selectedBeginDate > date) {
                    this.selectedEndDate = this.selectedBeginDate;
                    this.selectedBeginDate = date;
                } else this.selectedEndDate = date;
                this.$emit("range-end", date);
                this.$emit("update:modelValue", [
                    this.selectedBeginDate,
                    this.selectedEndDate
                ]);
            } else {
                this.selectedBeginDate = date;
                this.$emit("range-start", date);
            }
        },
        /*
        * If selected date already exists list of selected dates, remove it from the list
        * Otherwise, add date to list of selected dates
        */ handleSelectMultipleDates (date) {
            const multipleSelect = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth());
            if (multipleSelect.length) this.multipleSelectedDates = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth());
            else this.multipleSelectedDates = [
                ...this.multipleSelectedDates,
                date
            ];
        },
        /*
         * Return array of all days in the week that the startingDate is within
         */ weekBuilder (startingDate, month, year) {
            const thisMonth = new Date(year, month);
            const thisWeek = [];
            const dayOfWeek = new Date(year, month, startingDate).getDay();
            const end = dayOfWeek >= this.firstDayOfWeek ? dayOfWeek - this.firstDayOfWeek : 7 - this.firstDayOfWeek + dayOfWeek;
            let daysAgo = 1;
            for(let i = 0; i < end; i++){
                thisWeek.unshift(new Date(thisMonth.getFullYear(), thisMonth.getMonth(), startingDate - daysAgo));
                daysAgo++;
            }
            thisWeek.push(new Date(year, month, startingDate));
            let daysForward = 1;
            while(thisWeek.length < 7){
                thisWeek.push(new Date(year, month, startingDate + daysForward));
                daysForward++;
            }
            return thisWeek;
        },
        validateFocusedDay () {
            const focusedDate = new Date(this.focused.year, this.focused.month, this.focused.day);
            if (this.selectableDate(focusedDate)) return;
            let day = 0;
            // Number of days in the current month
            const monthDays = new Date(this.focused.year, this.focused.month + 1, 0).getDate();
            let firstFocusable = null;
            while(!firstFocusable && ++day < monthDays){
                const date = new Date(this.focused.year, this.focused.month, day);
                if (this.selectableDate(date)) {
                    firstFocusable = focusedDate;
                    const focused = {
                        day: date.getDate(),
                        month: date.getMonth(),
                        year: date.getFullYear()
                    };
                    this.$emit("update:focused", focused);
                }
            }
        },
        /*
         * Check that selected day is within earliest/latest params and
         * is within this month
         */ selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            if (this.nearbyMonthDays && !this.nearbySelectableMonthDays) validity.push(day.getMonth() === this.focused.month);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getDate() === enabledDate.getDate() && day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getDate() !== disabledDate.getDate() || day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        eventsInThisWeek (week) {
            return this.eventsInThisMonth.filter((event)=>{
                const stripped = new Date(Date.parse(event.date));
                stripped.setHours(0, 0, 0, 0);
                const timed = stripped.getTime();
                return week.some((weekDate)=>weekDate.getTime() === timed);
            });
        },
        setRangeHoverEndDate (day) {
            this.hoveredEndDate = day;
        },
        changeFocus (day) {
            const focused = {
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear()
            };
            this.$emit("update:focused", focused);
        }
    }
};
const _hoisted_1$2 = {
    class: "datepicker-table"
};
const _hoisted_2$2 = {
    class: "datepicker-header"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_datepicker_table_row = (0, _vue.resolveComponent)("b-datepicker-table-row");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_1$2, [
        (0, _vue.createElementVNode)("header", _hoisted_2$2, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleDayNames, (day, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: index,
                    class: "datepicker-cell"
                }, [
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(day), 1 /* TEXT */ )
                ]);
            }), 128 /* KEYED_FRAGMENT */ ))
        ]),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "datepicker-body",
                {
                    "has-events": $options.hasEvents
                }
            ])
        }, [
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.weeksInThisMonth, (week, index)=>{
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_datepicker_table_row, {
                    key: index,
                    "selected-date": $props.modelValue,
                    day: $props.focused.day,
                    week: week,
                    month: $props.focused.month,
                    "min-date": $props.minDate,
                    "max-date": $props.maxDate,
                    disabled: $options.disabledOrUndefined,
                    "unselectable-dates": $props.unselectableDates,
                    "unselectable-days-of-week": $props.unselectableDaysOfWeek,
                    "selectable-dates": $props.selectableDates,
                    events: $options.eventsInThisWeek(week),
                    indicators: $props.indicators,
                    "date-creator": $props.dateCreator,
                    "nearby-month-days": $props.nearbyMonthDays,
                    "nearby-selectable-month-days": $props.nearbySelectableMonthDays,
                    "show-week-number": $props.showWeekNumber,
                    "week-number-clickable": $props.weekNumberClickable,
                    "first-day-of-week": $props.firstDayOfWeek,
                    "rules-for-first-week": $props.rulesForFirstWeek,
                    range: $props.range,
                    "hovered-date-range": $options.hoveredDateRange,
                    onSelect: $options.updateSelectedDate,
                    onRangeHoverEndDate: $options.setRangeHoverEndDate,
                    multiple: $props.multiple,
                    onChangeFocus: $options.changeFocus
                }, null, 8 /* PROPS */ , [
                    "selected-date",
                    "day",
                    "week",
                    "month",
                    "min-date",
                    "max-date",
                    "disabled",
                    "unselectable-dates",
                    "unselectable-days-of-week",
                    "selectable-dates",
                    "events",
                    "indicators",
                    "date-creator",
                    "nearby-month-days",
                    "nearby-selectable-month-days",
                    "show-week-number",
                    "week-number-clickable",
                    "first-day-of-week",
                    "rules-for-first-week",
                    "range",
                    "hovered-date-range",
                    "onSelect",
                    "onRangeHoverEndDate",
                    "multiple",
                    "onChangeFocus"
                ]);
            }), 128 /* KEYED_FRAGMENT */ ))
        ], 2 /* CLASS */ )
    ]);
}
script$2.render = render$2;
script$2.__file = "src/components/datepicker/DatepickerTable.vue";
var script$1 = {
    name: "BDatepickerMonth",
    props: {
        modelValue: {
            type: [
                Date,
                Array
            ]
        },
        monthNames: Array,
        events: Array,
        indicators: String,
        minDate: Date,
        maxDate: Date,
        focused: Object,
        disabled: Boolean,
        dateCreator: Function,
        unselectableDates: [
            Array,
            Function
        ],
        unselectableDaysOfWeek: Array,
        selectableDates: [
            Array,
            Function
        ],
        range: Boolean,
        multiple: Boolean
    },
    emits: [
        "change-focus",
        "range-end",
        "range-start",
        "update:modelValue"
    ],
    data () {
        return {
            selectedBeginDate: undefined,
            selectedEndDate: undefined,
            hoveredEndDate: undefined,
            multipleSelectedDates: this.multiple && this.modelValue ? this.modelValue : []
        };
    },
    computed: {
        hasEvents () {
            return this.events && this.events.length;
        },
        /*
        * Return array of all events in the specified month
        */ eventsInThisYear () {
            if (!this.events) return [];
            const yearEvents = [];
            for(let i = 0; i < this.events.length; i++){
                let event = this.events[i];
                if (!Object.prototype.hasOwnProperty.call(event, "date")) event = {
                    date: event
                };
                if (!Object.prototype.hasOwnProperty.call(event, "type")) event.type = "is-primary";
                if (event.date.getFullYear() === this.focused.year) yearEvents.push(event);
            }
            return yearEvents;
        },
        monthDates () {
            const year = this.focused.year;
            const months = [];
            for(let i = 0; i < 12; i++){
                const d = new Date(year, i, 1);
                d.setHours(0, 0, 0, 0);
                months.push(d);
            }
            return months;
        },
        focusedMonth () {
            return this.focused.month;
        },
        hoveredDateRange () {
            if (!this.range) return [];
            if (!isNaN(this.selectedEndDate)) return [];
            if (this.hoveredEndDate < this.selectedBeginDate) return [
                this.hoveredEndDate,
                this.selectedBeginDate
            ].filter((0, _helpersO9H6ICOJs.v));
            return [
                this.selectedBeginDate,
                this.hoveredEndDate
            ].filter((0, _helpersO9H6ICOJs.v));
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        focusedMonth (month) {
            const refName = `month-${month}`;
            this.$nextTick(()=>{
                // Vue ≥ v3.0 < v3.2.25, refs in v-for are stored as a single object,
                // but ≥ v3.2.25, refs in v-for are stored in an array (same as Vue 2)
                let cell;
                if (Array.isArray(this.$refs[refName])) cell = this.$refs[refName][0];
                else cell = this.$refs[refName];
                if (cell) cell.focus();
            }); // $nextTick needed when year is changed
        }
    },
    methods: {
        selectMultipleDates (date) {
            const multipleSelect = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() === date.getDate() && selectedDate.getFullYear() === date.getFullYear() && selectedDate.getMonth() === date.getMonth());
            if (multipleSelect.length) this.multipleSelectedDates = this.multipleSelectedDates.filter((selectedDate)=>selectedDate.getDate() !== date.getDate() || selectedDate.getFullYear() !== date.getFullYear() || selectedDate.getMonth() !== date.getMonth());
            else this.multipleSelectedDates.push(date);
            this.$emit("update:modelValue", this.multipleSelectedDates);
        },
        selectableDate (day) {
            const validity = [];
            if (this.minDate) validity.push(day >= this.minDate);
            if (this.maxDate) validity.push(day <= this.maxDate);
            validity.push(day.getFullYear() === this.focused.year);
            if (this.selectableDates) {
                if (typeof this.selectableDates === "function") {
                    if (this.selectableDates(day)) return true;
                    else validity.push(false);
                } else for(let i = 0; i < this.selectableDates.length; i++){
                    const enabledDate = this.selectableDates[i];
                    if (day.getFullYear() === enabledDate.getFullYear() && day.getMonth() === enabledDate.getMonth()) return true;
                    else validity.push(false);
                }
            }
            if (this.unselectableDates) {
                if (typeof this.unselectableDates === "function") validity.push(!this.unselectableDates(day));
                else for(let i = 0; i < this.unselectableDates.length; i++){
                    const disabledDate = this.unselectableDates[i];
                    validity.push(day.getFullYear() !== disabledDate.getFullYear() || day.getMonth() !== disabledDate.getMonth());
                }
            }
            if (this.unselectableDaysOfWeek) for(let i = 0; i < this.unselectableDaysOfWeek.length; i++){
                const dayOfWeek = this.unselectableDaysOfWeek[i];
                validity.push(day.getDay() !== dayOfWeek);
            }
            return validity.indexOf(false) < 0;
        },
        eventsDateMatch (day) {
            if (!this.eventsInThisYear.length) return false;
            const monthEvents = [];
            for(let i = 0; i < this.eventsInThisYear.length; i++)if (this.eventsInThisYear[i].date.getMonth() === day.getMonth()) monthEvents.push(this.events[i]);
            if (!monthEvents.length) return false;
            return monthEvents;
        },
        /*
        * Build classObject for cell using validations
        */ classObject (day) {
            function dateMatch(dateOne, dateTwo, multiple) {
                // if either date is null or undefined, return false
                if (!dateOne || !dateTwo || multiple) return false;
                if (Array.isArray(dateTwo)) return dateTwo.some((date)=>dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
                return dateOne.getFullYear() === dateTwo.getFullYear() && dateOne.getMonth() === dateTwo.getMonth();
            }
            function dateWithin(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || multiple) return false;
                return dateOne > dates[0] && dateOne < dates[1];
            }
            function dateMultipleSelected(dateOne, dates, multiple) {
                if (!Array.isArray(dates) || !multiple) return false;
                return dates.some((date)=>dateOne.getDate() === date.getDate() && dateOne.getFullYear() === date.getFullYear() && dateOne.getMonth() === date.getMonth());
            }
            return {
                "is-selected": dateMatch(day, this.modelValue, this.multiple) || dateWithin(day, this.modelValue, this.multiple) || dateMultipleSelected(day, this.multipleSelectedDates, this.multiple),
                "is-first-selected": dateMatch(day, Array.isArray(this.modelValue) && this.modelValue[0], this.multiple),
                "is-within-selected": dateWithin(day, this.modelValue, this.multiple),
                "is-last-selected": dateMatch(day, Array.isArray(this.modelValue) && this.modelValue[1], this.multiple),
                "is-within-hovered-range": this.hoveredDateRange && this.hoveredDateRange.length === 2 && (dateMatch(day, this.hoveredDateRange) || dateWithin(day, this.hoveredDateRange)),
                "is-first-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[0]),
                "is-within-hovered": dateWithin(day, this.hoveredDateRange),
                "is-last-hovered": dateMatch(day, Array.isArray(this.hoveredDateRange) && this.hoveredDateRange[1]),
                "is-today": dateMatch(day, this.dateCreator()),
                "is-selectable": this.selectableDate(day) && !this.disabled,
                "is-unselectable": !this.selectableDate(day) || this.disabled
            };
        },
        manageKeydown ({ key }, date) {
            // https://developer.mozilla.org/fr/docs/Web/API/KeyboardEvent/key/Key_Values#Navigation_keys
            switch(key){
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.updateSelectedDate(date);
                    break;
                case "ArrowLeft":
                case "Left":
                    this.changeFocus(date, -1);
                    break;
                case "ArrowRight":
                case "Right":
                    this.changeFocus(date, 1);
                    break;
                case "ArrowUp":
                case "Up":
                    this.changeFocus(date, -3);
                    break;
                case "ArrowDown":
                case "Down":
                    this.changeFocus(date, 3);
                    break;
            }
        },
        /*
        * Emit input event with selected date as payload for v-model in parent
        */ updateSelectedDate (date) {
            if (!this.range && !this.multiple) this.emitChosenDate(date);
            else if (this.range) this.handleSelectRangeDate(date);
            else if (this.multiple) this.selectMultipleDates(date);
        },
        /*
         * Emit select event with chosen date as payload
         */ emitChosenDate (day) {
            if (this.disabled) return;
            if (!this.multiple) {
                if (this.selectableDate(day)) this.$emit("update:modelValue", day);
            } else this.selectMultipleDates(day);
        },
        /*
        * If both begin and end dates are set, reset the end date and set the begin date.
        * If only begin date is selected, emit an array of the begin date and the new date.
        * If not set, only set the begin date.
        */ handleSelectRangeDate (date) {
            if (this.disabled) return;
            if (this.selectedBeginDate && this.selectedEndDate) {
                this.selectedBeginDate = date;
                this.selectedEndDate = undefined;
                this.$emit("range-start", date);
            } else if (this.selectedBeginDate && !this.selectedEndDate) {
                if (this.selectedBeginDate > date) {
                    this.selectedEndDate = this.selectedBeginDate;
                    this.selectedBeginDate = date;
                } else this.selectedEndDate = date;
                this.$emit("range-end", date);
                this.$emit("update:modelValue", [
                    this.selectedBeginDate,
                    this.selectedEndDate
                ]);
            } else {
                this.selectedBeginDate = date;
                this.$emit("range-start", date);
            }
        },
        setRangeHoverEndDate (day) {
            if (this.range) this.hoveredEndDate = day;
        },
        changeFocus (month, inc) {
            const nextMonth = month;
            nextMonth.setMonth(month.getMonth() + inc);
            this.$emit("change-focus", nextMonth);
        }
    }
};
const _hoisted_1$1 = {
    class: "datepicker-table"
};
const _hoisted_2$1 = {
    class: "datepicker-months"
};
const _hoisted_3$1 = [
    "disabled",
    "onClick",
    "onMouseenter",
    "onKeydown",
    "tabindex"
];
const _hoisted_4$1 = {
    key: 0,
    class: "events"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_1$1, [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "datepicker-body",
                {
                    "has-events": $options.hasEvents
                }
            ])
        }, [
            (0, _vue.createElementVNode)("div", _hoisted_2$1, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.monthDates, (date, index)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: index
                    }, [
                        $options.selectableDate(date) && !$props.disabled ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                            key: 0,
                            ref_for: true,
                            ref: `month-${date.getMonth()}`,
                            class: (0, _vue.normalizeClass)([
                                [
                                    $options.classObject(date),
                                    {
                                        "has-event": $options.eventsDateMatch(date)
                                    },
                                    $props.indicators
                                ],
                                "datepicker-cell"
                            ]),
                            role: "button",
                            href: "#",
                            disabled: $options.disabledOrUndefined,
                            onClick: (0, _vue.withModifiers)(($event)=>$options.updateSelectedDate(date), [
                                "prevent"
                            ]),
                            onMouseenter: ($event)=>$options.setRangeHoverEndDate(date),
                            onKeydown: (0, _vue.withModifiers)(($event)=>$options.manageKeydown($event, date), [
                                "prevent"
                            ]),
                            tabindex: $props.focused.month === date.getMonth() ? null : -1
                        }, [
                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.monthNames[date.getMonth()]) + " ", 1 /* TEXT */ ),
                            $options.eventsDateMatch(date) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$1, [
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.eventsDateMatch(date), (event, evIdx)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        class: (0, _vue.normalizeClass)([
                                            "event",
                                            event.type
                                        ]),
                                        key: evIdx
                                    }, null, 2 /* CLASS */ );
                                }), 128 /* KEYED_FRAGMENT */ ))
                            ])) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_3$1)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                $options.classObject(date),
                                "datepicker-cell"
                            ])
                        }, (0, _vue.toDisplayString)($props.monthNames[date.getMonth()]), 3 /* TEXT, CLASS */ ))
                    ], 64 /* STABLE_FRAGMENT */ );
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
        ], 2 /* CLASS */ )
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/datepicker/DatepickerMonth.vue";
const defaultDateFormatter = (date, vm)=>{
    const targetDates = Array.isArray(date) ? date : [
        date
    ];
    const dates = targetDates.map((date)=>{
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
        return !vm.isTypeMonth ? vm.dtf.format(d) : vm.dtfMonth.format(d);
    });
    return !vm.multiple ? dates.join(" - ") : dates.join(", ");
};
const defaultDateParser = (date, vm)=>{
    if (vm.dtf.formatToParts && typeof vm.dtf.formatToParts === "function") {
        const formatRegex = (vm.isTypeMonth ? vm.dtfMonth : vm.dtf).formatToParts(new Date(2000, 11, 25)).map((part)=>{
            if (part.type === "literal") return part.value;
            return `((?!=<${part.type}>)\\d+)`;
        }).join("");
        const dateGroups = (0, _helpersO9H6ICOJs.p)(formatRegex, date);
        // We do a simple validation for the group.
        // If it is not valid, it will fallback to Date.parse below
        if (dateGroups.year && dateGroups.year.length === 4 && dateGroups.month && dateGroups.month <= 12) {
            if (vm.isTypeMonth) return new Date(dateGroups.year, dateGroups.month - 1);
            else if (dateGroups.day && dateGroups.day <= 31) return new Date(dateGroups.year, dateGroups.month - 1, dateGroups.day, 12);
        }
    }
    // Fallback if formatToParts is not supported or if we were not able to parse a valid date
    if (!vm.isTypeMonth) return new Date(Date.parse(date));
    if (date) {
        const s = date.split("/");
        const year = s[0].length === 4 ? s[0] : s[1];
        const month = s[0].length === 2 ? s[0] : s[1];
        if (year && month) return new Date(parseInt(year, 10), parseInt(month - 1, 10), 1, 0, 0, 0, 0);
    }
    return null;
};
var script = {
    name: "BDatepicker",
    components: {
        [script$2.name]: script$2,
        [script$1.name]: script$1,
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _fieldCMd66V8HJs.s).name]: (0, _fieldCMd66V8HJs.s),
        [(0, _selectDYWGhZcJs.s).name]: (0, _selectDYWGhZcJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _dropdownItemYQcaSZL4Js.s).name]: (0, _dropdownItemYQcaSZL4Js.s),
        [(0, _dropdownItemYQcaSZL4Js.a).name]: (0, _dropdownItemYQcaSZL4Js.a)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    provide () {
        return {
            $datepicker: this
        };
    },
    props: {
        modelValue: {
            type: [
                Date,
                Array
            ]
        },
        dayNames: {
            type: Array,
            default: ()=>{
                if (!Array.isArray((0, _configNHWiBviwJs.c).defaultDayNames)) return undefined;
                return (0, _configNHWiBviwJs.c).defaultDayNames;
            }
        },
        monthNames: {
            type: Array,
            default: ()=>{
                if (!Array.isArray((0, _configNHWiBviwJs.c).defaultMonthNames)) return undefined;
                return (0, _configNHWiBviwJs.c).defaultMonthNames;
            }
        },
        firstDayOfWeek: {
            type: Number,
            default: ()=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultFirstDayOfWeek === "number") return (0, _configNHWiBviwJs.c).defaultFirstDayOfWeek;
                else return 0;
            }
        },
        inline: Boolean,
        minDate: Date,
        maxDate: Date,
        focusedDate: Date,
        placeholder: String,
        editable: Boolean,
        disabled: Boolean,
        horizontalTimePicker: Boolean,
        unselectableDates: [
            Array,
            Function
        ],
        unselectableDaysOfWeek: {
            type: Array,
            default: ()=>(0, _configNHWiBviwJs.c).defaultUnselectableDaysOfWeek
        },
        selectableDates: [
            Array,
            Function
        ],
        dateFormatter: {
            type: Function,
            default: (date, vm)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultDateFormatter === "function") return (0, _configNHWiBviwJs.c).defaultDateFormatter(date);
                else return defaultDateFormatter(date, vm);
            }
        },
        dateParser: {
            type: Function,
            default: (date, vm)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultDateParser === "function") return (0, _configNHWiBviwJs.c).defaultDateParser(date);
                else return defaultDateParser(date, vm);
            }
        },
        dateCreator: {
            type: Function,
            default: ()=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultDateCreator === "function") return (0, _configNHWiBviwJs.c).defaultDateCreator();
                else return new Date();
            }
        },
        mobileNative: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerMobileNative
        },
        position: String,
        iconRight: String,
        iconRightClickable: Boolean,
        events: Array,
        indicators: {
            type: String,
            default: "dots"
        },
        openOnFocus: Boolean,
        iconPrev: {
            type: String,
            default: ()=>(0, _configNHWiBviwJs.c).defaultIconPrev
        },
        iconNext: {
            type: String,
            default: ()=>(0, _configNHWiBviwJs.c).defaultIconNext
        },
        yearsRange: {
            type: Array,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerYearsRange
        },
        type: {
            type: String,
            validator: (value)=>{
                return [
                    "month"
                ].indexOf(value) >= 0;
            }
        },
        nearbyMonthDays: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerNearbyMonthDays
        },
        nearbySelectableMonthDays: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerNearbySelectableMonthDays
        },
        showWeekNumber: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerShowWeekNumber
        },
        weekNumberClickable: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerWeekNumberClickable
        },
        rulesForFirstWeek: {
            type: Number,
            default: ()=>4
        },
        range: {
            type: Boolean,
            default: false
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        mobileModal: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultDatepickerMobileModal
        },
        focusable: {
            type: Boolean,
            default: true
        },
        trapFocus: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTrapFocus
        },
        appendToBody: Boolean,
        ariaNextLabel: String,
        ariaPreviousLabel: String
    },
    emits: [
        "active-change",
        "change-month",
        "change-year",
        "icon-right-click",
        "range-end",
        "range-start",
        "update:modelValue",
        "week-number-click" // emitted from `DatepickerTableRow`
    ],
    data () {
        const focusedDate = (Array.isArray(this.modelValue) ? this.modelValue[0] : this.modelValue) || this.focusedDate || this.dateCreator();
        if (!this.modelValue && this.maxDate && this.maxDate.getFullYear() < focusedDate.getFullYear()) focusedDate.setFullYear(this.maxDate.getFullYear());
        return {
            dateSelected: this.modelValue,
            focusedDateData: {
                day: focusedDate.getDate(),
                month: focusedDate.getMonth(),
                year: focusedDate.getFullYear()
            },
            _elementRef: "input",
            _isDatepicker: true
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.dateSelected;
            },
            set (value) {
                this.updateInternalState(value);
                if (!this.multiple) this.togglePicker(false);
                this.$emit("update:modelValue", value);
                if (this.useHtml5Validation) this.$nextTick(()=>{
                    this.checkHtml5Validity();
                });
            }
        },
        formattedValue () {
            return this.formatValue(this.computedValue);
        },
        localeOptions () {
            return new Intl.DateTimeFormat(this.locale, {
                year: "numeric",
                month: "numeric"
            }).resolvedOptions();
        },
        dtf () {
            return new Intl.DateTimeFormat(this.locale);
        },
        dtfMonth () {
            return new Intl.DateTimeFormat(this.locale, {
                year: this.localeOptions.year || "numeric",
                month: this.localeOptions.month || "2-digit"
            });
        },
        newMonthNames () {
            if (Array.isArray(this.monthNames)) return this.monthNames;
            return (0, _helpersO9H6ICOJs.n)(this.locale);
        },
        newDayNames () {
            if (Array.isArray(this.dayNames)) return this.dayNames;
            return (0, _helpersO9H6ICOJs.o)(this.locale);
        },
        listOfMonths () {
            let minMonth = 0;
            let maxMonth = 12;
            if (this.minDate && this.focusedDateData.year === this.minDate.getFullYear()) minMonth = this.minDate.getMonth();
            if (this.maxDate && this.focusedDateData.year === this.maxDate.getFullYear()) maxMonth = this.maxDate.getMonth();
            return this.newMonthNames.map((name, index)=>{
                return {
                    name,
                    index,
                    disabled: index < minMonth || index > maxMonth
                };
            });
        },
        /*
         * Returns an array of years for the year dropdown. If earliest/latest
         * dates are set by props, range of years will fall within those dates.
         */ listOfYears () {
            let latestYear = this.focusedDateData.year + this.yearsRange[1];
            if (this.maxDate && this.maxDate.getFullYear() < latestYear) latestYear = Math.max(this.maxDate.getFullYear(), this.focusedDateData.year);
            let earliestYear = this.focusedDateData.year + this.yearsRange[0];
            if (this.minDate && this.minDate.getFullYear() > earliestYear) earliestYear = Math.min(this.minDate.getFullYear(), this.focusedDateData.year);
            const arrayOfYears = [];
            for(let i = earliestYear; i <= latestYear; i++)arrayOfYears.push(i);
            return arrayOfYears.reverse();
        },
        showPrev () {
            if (!this.minDate) return false;
            if (this.isTypeMonth) return this.focusedDateData.year <= this.minDate.getFullYear();
            const dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
            const date = new Date(this.minDate.getFullYear(), this.minDate.getMonth());
            return dateToCheck <= date;
        },
        showNext () {
            if (!this.maxDate) return false;
            if (this.isTypeMonth) return this.focusedDateData.year >= this.maxDate.getFullYear();
            const dateToCheck = new Date(this.focusedDateData.year, this.focusedDateData.month);
            const date = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth());
            return dateToCheck >= date;
        },
        isMobile () {
            return this.mobileNative && (0, _helpersO9H6ICOJs.c).any();
        },
        isTypeMonth () {
            return this.type === "month";
        },
        ariaRole () {
            if (!this.inline) return "dialog";
            else return undefined;
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        /**
         * When v-model is changed:
         *   1. Update internal value.
         *   2. If it's invalid, validate again.
         */ modelValue (value) {
            this.updateInternalState(value);
            if (!this.multiple) this.togglePicker(false);
        },
        focusedDate (value) {
            if (value) this.focusedDateData = {
                day: value.getDate(),
                month: value.getMonth(),
                year: value.getFullYear()
            };
        },
        /*
         * Emit input event on month and/or year change
         */ "focusedDateData.month" (value) {
            this.$emit("change-month", value);
        },
        "focusedDateData.year" (value) {
            this.$emit("change-year", value);
        }
    },
    methods: {
        /*
         * Parse string into date
         */ onChange (value) {
            const date = this.dateParser(value, this);
            if (date && (!isNaN(date) || Array.isArray(date) && date.length === 2 && !isNaN(date[0]) && !isNaN(date[1]))) this.computedValue = date;
            else {
                // Force refresh input value when not valid date
                this.computedValue = null;
                if (this.$refs.input) this.$refs.input.newValue = this.computedValue;
            }
        },
        /*
         * Format date into string
         */ formatValue (value) {
            if (Array.isArray(value)) {
                const isArrayWithValidDates = Array.isArray(value) && value.every((v)=>!isNaN(v));
                return isArrayWithValidDates ? this.dateFormatter([
                    ...value
                ], this) : null;
            }
            return value && !isNaN(value) ? this.dateFormatter(value, this) : null;
        },
        /*
         * Either decrement month by 1 if not January or decrement year by 1
         * and set month to 11 (December) or decrement year when 'month'
         */ prev () {
            if (this.disabled) return;
            if (this.isTypeMonth) this.focusedDateData.year -= 1;
            else if (this.focusedDateData.month > 0) this.focusedDateData.month -= 1;
            else {
                this.focusedDateData.month = 11;
                this.focusedDateData.year -= 1;
            }
        },
        /*
         * Either increment month by 1 if not December or increment year by 1
         * and set month to 0 (January) or increment year when 'month'
         */ next () {
            if (this.disabled) return;
            if (this.isTypeMonth) this.focusedDateData.year += 1;
            else if (this.focusedDateData.month < 11) this.focusedDateData.month += 1;
            else {
                this.focusedDateData.month = 0;
                this.focusedDateData.year += 1;
            }
        },
        formatNative (value) {
            return this.isTypeMonth ? this.formatYYYYMM(value) : this.formatYYYYMMDD(value);
        },
        /*
         * Format date into string 'YYYY-MM-DD'
         */ formatYYYYMMDD (value) {
            const date = new Date(value);
            if (value && !isNaN(date)) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                return year + "-" + ((month < 10 ? "0" : "") + month) + "-" + ((day < 10 ? "0" : "") + day);
            }
            return "";
        },
        /*
         * Format date into string 'YYYY-MM'
         */ formatYYYYMM (value) {
            const date = new Date(value);
            if (value && !isNaN(date)) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                return year + "-" + ((month < 10 ? "0" : "") + month);
            }
            return "";
        },
        /*
         * Parse date from string
         */ onChangeNativePicker (event) {
            const date = event.target.value;
            const s = date ? date.split("-") : [];
            if (s.length === 3) {
                const year = parseInt(s[0], 10);
                const month = parseInt(s[1]) - 1;
                const day = parseInt(s[2]);
                this.computedValue = new Date(year, month, day);
            } else this.computedValue = null;
        },
        updateInternalState (value) {
            if (this.dateSelected === value) return;
            const isArray = Array.isArray(value);
            const currentDate = isArray ? !value.length ? this.dateCreator() : value[value.length - 1] : !value ? this.dateCreator() : value;
            if (!isArray || isArray && this.dateSelected && value.length > this.dateSelected.length) this.focusedDateData = {
                day: currentDate.getDate(),
                month: currentDate.getMonth(),
                year: currentDate.getFullYear()
            };
            this.dateSelected = value;
        },
        /*
         * Toggle datepicker
         */ togglePicker (active) {
            if (this.$refs.dropdown) {
                const isActive = typeof active === "boolean" ? active : !this.$refs.dropdown.isActive;
                if (isActive) this.$refs.dropdown.isActive = isActive;
                else if (this.closeOnClick) this.$refs.dropdown.isActive = isActive;
            }
        },
        /*
         * Call default onFocus method and show datepicker
         */ handleOnFocus (event) {
            this.onFocus(event);
            if (this.openOnFocus) this.togglePicker(true);
        },
        /*
         * Toggle dropdown
         */ toggle () {
            if (this.mobileNative && this.isMobile) {
                const input = this.$refs.input.$refs.input;
                input.focus();
                input.click();
                return;
            }
            this.$refs.dropdown.toggle();
        },
        /*
         * Avoid dropdown toggle when is already visible
         */ onInputClick (event) {
            if (this.$refs.dropdown.isActive) event.stopPropagation();
        },
        /**
         * Keypress event that is bound to the document.
         */ keyPress ({ key }) {
            if (this.$refs.dropdown && this.$refs.dropdown.isActive && (key === "Escape" || key === "Esc")) this.togglePicker(false);
        },
        /**
         * Emit 'blur' event on dropdown is not active (closed)
         */ onActiveChange (value) {
            if (!value) this.onBlur();
            /*
             * Emit 'active-change' when on dropdown active state change
             */ this.$emit("active-change", value);
        },
        changeFocus (day) {
            this.focusedDateData = {
                day: day.getDate(),
                month: day.getMonth(),
                year: day.getFullYear()
            };
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    beforeUnmount () {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
};
const _hoisted_1 = {
    class: "datepicker-header"
};
const _hoisted_2 = [
    "disabled",
    "aria-label"
];
const _hoisted_3 = [
    "disabled",
    "aria-label"
];
const _hoisted_4 = {
    class: "pagination-list"
};
const _hoisted_5 = [
    "value",
    "disabled"
];
const _hoisted_6 = [
    "value"
];
const _hoisted_7 = {
    key: 1
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_datepicker_table = (0, _vue.resolveComponent)("b-datepicker-table");
    const _component_b_datepicker_month = (0, _vue.resolveComponent)("b-datepicker-month");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "datepicker control",
            [
                _ctx.size,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !$options.isMobile || $props.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: $props.position,
            disabled: $options.disabledOrUndefined,
            inline: $props.inline,
            "mobile-modal": $props.mobileModal,
            "trap-focus": $props.trapFocus,
            "aria-role": $options.ariaRole,
            "append-to-body": $props.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: $options.onActiveChange,
            "trigger-tabindex": -1
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: $options.disabledOrUndefined,
                        focusable: $props.focusable,
                        custom: "",
                        class: (0, _vue.normalizeClass)({
                            "dropdown-horizontal-timepicker": $props.horizontalTimePicker
                        })
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createElementVNode)("div", null, [
                                    (0, _vue.createElementVNode)("header", _hoisted_1, [
                                        _ctx.$slots.header !== undefined && _ctx.$slots.header().length ? (0, _vue.renderSlot)(_ctx.$slots, "header", {
                                            key: 0
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                            key: 1,
                                            class: (0, _vue.normalizeClass)([
                                                "pagination field is-centered",
                                                _ctx.size
                                            ])
                                        }, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("a", {
                                                class: "pagination-previous",
                                                role: "button",
                                                href: "#",
                                                disabled: $options.disabledOrUndefined,
                                                "aria-label": $props.ariaPreviousLabel,
                                                onClick: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>$options.prev && $options.prev(...args), [
                                                    "prevent"
                                                ])),
                                                onKeydown: [
                                                    _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.prev && $options.prev(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "enter"
                                                    ])),
                                                    _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.prev && $options.prev(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "space"
                                                    ]))
                                                ]
                                            }, [
                                                (0, _vue.createVNode)(_component_b_icon, {
                                                    icon: $props.iconPrev,
                                                    pack: _ctx.iconPack,
                                                    both: "",
                                                    type: "is-primary is-clickable"
                                                }, null, 8 /* PROPS */ , [
                                                    "icon",
                                                    "pack"
                                                ])
                                            ], 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_2), [
                                                [
                                                    (0, _vue.vShow),
                                                    !$options.showPrev && !$props.disabled
                                                ]
                                            ]),
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("a", {
                                                class: "pagination-next",
                                                role: "button",
                                                href: "#",
                                                disabled: $options.disabledOrUndefined,
                                                "aria-label": $props.ariaNextLabel,
                                                onClick: _cache[6] || (_cache[6] = (0, _vue.withModifiers)((...args)=>$options.next && $options.next(...args), [
                                                    "prevent"
                                                ])),
                                                onKeydown: [
                                                    _cache[7] || (_cache[7] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.next && $options.next(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "enter"
                                                    ])),
                                                    _cache[8] || (_cache[8] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.next && $options.next(...args), [
                                                        "prevent"
                                                    ]), [
                                                        "space"
                                                    ]))
                                                ]
                                            }, [
                                                (0, _vue.createVNode)(_component_b_icon, {
                                                    icon: $props.iconNext,
                                                    pack: _ctx.iconPack,
                                                    both: "",
                                                    type: "is-primary is-clickable"
                                                }, null, 8 /* PROPS */ , [
                                                    "icon",
                                                    "pack"
                                                ])
                                            ], 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_3), [
                                                [
                                                    (0, _vue.vShow),
                                                    !$options.showNext && !$props.disabled
                                                ]
                                            ]),
                                            (0, _vue.createElementVNode)("div", _hoisted_4, [
                                                (0, _vue.createVNode)(_component_b_field, null, {
                                                    default: (0, _vue.withCtx)(()=>[
                                                            !$options.isTypeMonth ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                                                                key: 0,
                                                                modelValue: $data.focusedDateData.month,
                                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$data.focusedDateData.month = $event),
                                                                disabled: $options.disabledOrUndefined,
                                                                size: _ctx.size
                                                            }, {
                                                                default: (0, _vue.withCtx)(()=>[
                                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.listOfMonths, (month)=>{
                                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                                value: month.index,
                                                                                key: month.name,
                                                                                disabled: month.disabled || undefined
                                                                            }, (0, _vue.toDisplayString)(month.name), 9 /* TEXT, PROPS */ , _hoisted_5);
                                                                        }), 128 /* KEYED_FRAGMENT */ ))
                                                                    ]),
                                                                _: 1 /* STABLE */ 
                                                            }, 8 /* PROPS */ , [
                                                                "modelValue",
                                                                "disabled",
                                                                "size"
                                                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                                                            (0, _vue.createVNode)(_component_b_select, {
                                                                modelValue: $data.focusedDateData.year,
                                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$data.focusedDateData.year = $event),
                                                                disabled: $options.disabledOrUndefined,
                                                                size: _ctx.size
                                                            }, {
                                                                default: (0, _vue.withCtx)(()=>[
                                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.listOfYears, (year)=>{
                                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                                value: year,
                                                                                key: year
                                                                            }, (0, _vue.toDisplayString)(year), 9 /* TEXT, PROPS */ , _hoisted_6);
                                                                        }), 128 /* KEYED_FRAGMENT */ ))
                                                                    ]),
                                                                _: 1 /* STABLE */ 
                                                            }, 8 /* PROPS */ , [
                                                                "modelValue",
                                                                "disabled",
                                                                "size"
                                                            ])
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                })
                                            ])
                                        ], 2 /* CLASS */ ))
                                    ]),
                                    !$options.isTypeMonth ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                                        key: 0,
                                        class: (0, _vue.normalizeClass)([
                                            "datepicker-content",
                                            {
                                                "content-horizontal-timepicker": $props.horizontalTimePicker
                                            }
                                        ])
                                    }, [
                                        (0, _vue.createVNode)(_component_b_datepicker_table, {
                                            modelValue: $options.computedValue,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$options.computedValue = $event),
                                            "day-names": $options.newDayNames,
                                            "month-names": $options.newMonthNames,
                                            "first-day-of-week": $props.firstDayOfWeek,
                                            "rules-for-first-week": $props.rulesForFirstWeek,
                                            "min-date": $props.minDate,
                                            "max-date": $props.maxDate,
                                            focused: $data.focusedDateData,
                                            disabled: $options.disabledOrUndefined,
                                            "unselectable-dates": $props.unselectableDates,
                                            "unselectable-days-of-week": $props.unselectableDaysOfWeek,
                                            "selectable-dates": $props.selectableDates,
                                            events: $props.events,
                                            indicators: $props.indicators,
                                            "date-creator": $props.dateCreator,
                                            "type-month": $options.isTypeMonth,
                                            "nearby-month-days": $props.nearbyMonthDays,
                                            "nearby-selectable-month-days": $props.nearbySelectableMonthDays,
                                            "show-week-number": $props.showWeekNumber,
                                            "week-number-clickable": $props.weekNumberClickable,
                                            range: $props.range,
                                            multiple: $props.multiple,
                                            onRangeStart: _cache[12] || (_cache[12] = (date)=>_ctx.$emit("range-start", date)),
                                            onRangeEnd: _cache[13] || (_cache[13] = (date)=>_ctx.$emit("range-end", date)),
                                            onClose: _cache[14] || (_cache[14] = ($event)=>$options.togglePicker(false)),
                                            "onUpdate:focused": _cache[15] || (_cache[15] = ($event)=>$data.focusedDateData = $event)
                                        }, null, 8 /* PROPS */ , [
                                            "modelValue",
                                            "day-names",
                                            "month-names",
                                            "first-day-of-week",
                                            "rules-for-first-week",
                                            "min-date",
                                            "max-date",
                                            "focused",
                                            "disabled",
                                            "unselectable-dates",
                                            "unselectable-days-of-week",
                                            "selectable-dates",
                                            "events",
                                            "indicators",
                                            "date-creator",
                                            "type-month",
                                            "nearby-month-days",
                                            "nearby-selectable-month-days",
                                            "show-week-number",
                                            "week-number-clickable",
                                            "range",
                                            "multiple"
                                        ])
                                    ], 2 /* CLASS */ )) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                                        (0, _vue.createVNode)(_component_b_datepicker_month, {
                                            modelValue: $options.computedValue,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>$options.computedValue = $event),
                                            "month-names": $options.newMonthNames,
                                            "min-date": $props.minDate,
                                            "max-date": $props.maxDate,
                                            focused: $data.focusedDateData,
                                            disabled: $options.disabledOrUndefined,
                                            "unselectable-dates": $props.unselectableDates,
                                            "unselectable-days-of-week": $props.unselectableDaysOfWeek,
                                            "selectable-dates": $props.selectableDates,
                                            events: $props.events,
                                            indicators: $props.indicators,
                                            "date-creator": $props.dateCreator,
                                            range: $props.range,
                                            multiple: $props.multiple,
                                            onRangeStart: _cache[17] || (_cache[17] = (date)=>_ctx.$emit("range-start", date)),
                                            onRangeEnd: _cache[18] || (_cache[18] = (date)=>_ctx.$emit("range-end", date)),
                                            onClose: _cache[19] || (_cache[19] = ($event)=>$options.togglePicker(false)),
                                            onChangeFocus: $options.changeFocus,
                                            "onUpdate:focused": _cache[20] || (_cache[20] = ($event)=>$data.focusedDateData = $event)
                                        }, null, 8 /* PROPS */ , [
                                            "modelValue",
                                            "month-names",
                                            "min-date",
                                            "max-date",
                                            "focused",
                                            "disabled",
                                            "unselectable-dates",
                                            "unselectable-days-of-week",
                                            "selectable-dates",
                                            "events",
                                            "indicators",
                                            "date-creator",
                                            "range",
                                            "multiple",
                                            "onChangeFocus"
                                        ])
                                    ]))
                                ]),
                                _ctx.$slots.default !== undefined && _ctx.$slots.default().length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", {
                                    key: 0,
                                    class: (0, _vue.normalizeClass)([
                                        "datepicker-footer",
                                        {
                                            "footer-horizontal-timepicker": $props.horizontalTimePicker
                                        }
                                    ])
                                }, [
                                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                                ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                        _: 3 /* FORWARDED */ 
                    }, 8 /* PROPS */ , [
                        "disabled",
                        "focusable",
                        "class"
                    ])
                ]),
            _: 2 /* DYNAMIC */ 
        }, [
            !$props.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)((props)=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", (0, _vue.normalizeProps)((0, _vue.guardReactiveProps)(props)), ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    "model-value": $options.formattedValue,
                                    placeholder: $props.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-right": $props.iconRight,
                                    "icon-right-clickable": $props.iconRightClickable,
                                    "icon-pack": _ctx.iconPack,
                                    rounded: _ctx.rounded,
                                    loading: _ctx.loading,
                                    disabled: $options.disabledOrUndefined,
                                    readonly: !$props.editable
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": false,
                                    onClick: $options.onInputClick,
                                    onIconRightClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit("icon-right-click", $event)),
                                    onKeyup: _cache[1] || (_cache[1] = (0, _vue.withKeys)(($event)=>$options.togglePicker(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[2] || (_cache[2] = ($event)=>$options.onChange($event.target.value)),
                                    onFocus: $options.handleOnFocus
                                }), null, 16 /* FULL_PROPS */ , [
                                    "model-value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-right",
                                    "icon-right-clickable",
                                    "icon-pack",
                                    "rounded",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "onClick",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */ , [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "trap-focus",
            "aria-role",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: !$options.isTypeMonth ? "date" : "month",
            autocomplete: "off",
            "model-value": $options.formatNative($options.computedValue),
            placeholder: $props.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            rounded: _ctx.rounded,
            loading: _ctx.loading,
            max: $options.formatNative($props.maxDate),
            min: $options.formatNative($props.minDate),
            disabled: $options.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": false,
            onChange: $options.onChangeNativePicker,
            onFocus: _ctx.onFocus,
            onBlur: _ctx.onBlur
        }), null, 16 /* FULL_PROPS */ , [
            "type",
            "model-value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "rounded",
            "loading",
            "max",
            "min",
            "disabled",
            "onChange",
            "onFocus",
            "onBlur"
        ]))
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/datepicker/Datepicker.vue";

},{"./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","./DropdownItem-yQcaSZL4.js":"jPdf6","./Input-0ivJhXUC.js":"jYQke","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cJ5xk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BDatetimepicker", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _datepickerR7KMGxsCJs = require("./Datepicker-r7KMGxsC.js");
var _timepickerSqpkdcr1Js = require("./Timepicker-sqpkdcr1.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _timepickerMixinMPQh7UTJs = require("./TimepickerMixin-M_pQh7UT.js");
const AM = "AM";
const PM = "PM";
var script = {
    name: "BDatetimepicker",
    components: {
        [(0, _datepickerR7KMGxsCJs.s).name]: (0, _datepickerR7KMGxsCJs.s),
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _timepickerSqpkdcr1Js.s).name]: (0, _timepickerSqpkdcr1Js.s)
    },
    mixins: [
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Date
        },
        editable: {
            type: Boolean,
            default: false
        },
        placeholder: String,
        horizontalTimePicker: Boolean,
        disabled: Boolean,
        firstDayOfWeek: {
            type: Number,
            default: ()=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultFirstDayOfWeek === "number") return (0, _configNHWiBviwJs.c).defaultFirstDayOfWeek;
                else return 0;
            }
        },
        rulesForFirstWeek: {
            type: Number,
            default: ()=>4
        },
        icon: String,
        iconRight: String,
        iconRightClickable: Boolean,
        iconPack: String,
        inline: Boolean,
        openOnFocus: Boolean,
        position: String,
        mobileNative: {
            type: Boolean,
            default: true
        },
        minDatetime: Date,
        maxDatetime: Date,
        nearbyMonthDays: {
            type: Boolean,
            default: (0, _configNHWiBviwJs.c).defaultDatepickerNearbyMonthDays
        },
        datetimeFormatter: {
            type: Function
        },
        datetimeParser: {
            type: Function
        },
        datetimeCreator: {
            type: Function,
            default: (date)=>{
                if (typeof (0, _configNHWiBviwJs.c).defaultDatetimeCreator === "function") return (0, _configNHWiBviwJs.c).defaultDatetimeCreator(date);
                else return date;
            }
        },
        datepicker: Object,
        timepicker: Object,
        tzOffset: {
            type: Number,
            default: 0
        },
        focusable: {
            type: Boolean,
            default: true
        },
        appendToBody: Boolean
    },
    emits: [
        "active-change",
        "change-month",
        "change-year",
        "icon-right-click",
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.adjustValue(this.modelValue)
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                if (value) {
                    let val = new Date(value.getTime());
                    if (this.newValue) // restore time part
                    {
                        if ((value.getDate() !== this.newValue.getDate() || value.getMonth() !== this.newValue.getMonth() || value.getFullYear() !== this.newValue.getFullYear()) && value.getHours() === 0 && value.getMinutes() === 0 && value.getSeconds() === 0) val.setHours(this.newValue.getHours(), this.newValue.getMinutes(), this.newValue.getSeconds(), 0);
                    } else val = this.datetimeCreator(value);
                    // check min and max range
                    if (this.minDatetime && val < this.adjustValue(this.minDatetime)) val = this.adjustValue(this.minDatetime);
                    else if (this.maxDatetime && val > this.adjustValue(this.maxDatetime)) val = this.adjustValue(this.maxDatetime);
                    this.newValue = new Date(val.getTime());
                } else this.newValue = this.adjustValue(value);
                const adjustedValue = this.adjustValue(this.newValue, true); // reverse adjust
                this.$emit("update:modelValue", adjustedValue);
            }
        },
        localeOptions () {
            return new Intl.DateTimeFormat(this.locale, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: this.enableSeconds() ? "numeric" : undefined
            }).resolvedOptions();
        },
        dtf () {
            return new Intl.DateTimeFormat(this.locale, {
                year: this.localeOptions.year || "numeric",
                month: this.localeOptions.month || "numeric",
                day: this.localeOptions.day || "numeric",
                hour: this.localeOptions.hour || "numeric",
                minute: this.localeOptions.minute || "numeric",
                second: this.enableSeconds() ? this.localeOptions.second || "numeric" : undefined,
                hourCycle: !this.isHourFormat24() ? "h12" : "h23"
            });
        },
        isMobileNative () {
            return this.mobileNative && this.tzOffset === 0;
        },
        isMobile () {
            return this.isMobileNative && (0, _helpersO9H6ICOJs.c).any();
        },
        minDate () {
            if (!this.minDatetime) return this.datepicker ? this.adjustValue(this.datepicker.minDate) : null;
            const adjMinDatetime = this.adjustValue(this.minDatetime);
            return new Date(adjMinDatetime.getFullYear(), adjMinDatetime.getMonth(), adjMinDatetime.getDate(), 0, 0, 0, 0);
        },
        maxDate () {
            if (!this.maxDatetime) return this.datepicker ? this.adjustValue(this.datepicker.maxDate) : null;
            const adjMaxDatetime = this.adjustValue(this.maxDatetime);
            return new Date(adjMaxDatetime.getFullYear(), adjMaxDatetime.getMonth(), adjMaxDatetime.getDate(), 0, 0, 0, 0);
        },
        minTime () {
            if (!this.minDatetime || this.newValue === null || typeof this.newValue === "undefined") return this.timepicker ? this.adjustValue(this.timepicker.minTime) : null;
            const adjMinDatetime = this.adjustValue(this.minDatetime);
            if (adjMinDatetime.getFullYear() === this.newValue.getFullYear() && adjMinDatetime.getMonth() === this.newValue.getMonth() && adjMinDatetime.getDate() === this.newValue.getDate()) return adjMinDatetime;
            return undefined;
        },
        maxTime () {
            if (!this.maxDatetime || this.newValue === null || typeof this.newValue === "undefined") return this.timepicker ? this.adjustValue(this.timepicker.maxTime) : null;
            const adjMaxDatetime = this.adjustValue(this.maxDatetime);
            if (adjMaxDatetime.getFullYear() === this.newValue.getFullYear() && adjMaxDatetime.getMonth() === this.newValue.getMonth() && adjMaxDatetime.getDate() === this.newValue.getDate()) return adjMaxDatetime;
            return undefined;
        },
        datepickerSize () {
            return this.datepicker && this.datepicker.size ? this.datepicker.size : this.size;
        },
        timepickerSize () {
            return this.timepicker && this.timepicker.size ? this.timepicker.size : this.size;
        },
        timepickerDisabled () {
            return this.timepicker && this.timepicker.disabled ? this.timepicker.disabled : this.disabled;
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        modelValue () {
            this.newValue = this.adjustValue(this.modelValue);
        },
        tzOffset () {
            this.newValue = this.adjustValue(this.modelValue);
        }
    },
    methods: {
        enableSeconds () {
            if (this.$refs.timepicker) return this.$refs.timepicker.enableSeconds;
            return false;
        },
        isHourFormat24 () {
            if (this.$refs.timepicker) return this.$refs.timepicker.isHourFormat24;
            return !this.localeOptions.hour12;
        },
        adjustValue (value, reverse = false) {
            if (!value) return value;
            if (reverse) return new Date(value.getTime() - this.tzOffset * 60000);
            else return new Date(value.getTime() + this.tzOffset * 60000);
        },
        defaultDatetimeParser (date) {
            if (typeof this.datetimeParser === "function") return this.datetimeParser(date);
            else if (typeof (0, _configNHWiBviwJs.c).defaultDatetimeParser === "function") return (0, _configNHWiBviwJs.c).defaultDatetimeParser(date);
            else {
                if (this.dtf.formatToParts && typeof this.dtf.formatToParts === "function") {
                    const dayPeriods = [
                        AM,
                        PM,
                        AM.toLowerCase(),
                        PM.toLowerCase()
                    ];
                    if (this.$refs.timepicker) {
                        dayPeriods.push(this.$refs.timepicker.amString);
                        dayPeriods.push(this.$refs.timepicker.pmString);
                    }
                    const parts = this.dtf.formatToParts(new Date());
                    const formatRegex = parts.map((part, idx)=>{
                        if (part.type === "literal") {
                            if (idx + 1 < parts.length && parts[idx + 1].type === "hour") return "[^\\d]+";
                            return part.value.replace(/ /g, "\\s?");
                        } else if (part.type === "dayPeriod") return `((?!=<${part.type}>)(${dayPeriods.join("|")})?)`;
                        return `((?!=<${part.type}>)\\d+)`;
                    }).join("");
                    const datetimeGroups = (0, _helpersO9H6ICOJs.p)(formatRegex, date);
                    // We do a simple validation for the group.
                    // If it is not valid, it will fallback to Date.parse below
                    if (datetimeGroups.year && datetimeGroups.year.length === 4 && datetimeGroups.month && datetimeGroups.month <= 12 && datetimeGroups.day && datetimeGroups.day <= 31 && datetimeGroups.hour && datetimeGroups.hour >= 0 && datetimeGroups.hour < 24 && datetimeGroups.minute && datetimeGroups.minute >= 0 && datetimeGroups.minute <= 59) {
                        const d = new Date(datetimeGroups.year, datetimeGroups.month - 1, datetimeGroups.day, datetimeGroups.hour, datetimeGroups.minute, datetimeGroups.second || 0);
                        return d;
                    }
                }
                return new Date(Date.parse(date));
            }
        },
        defaultDatetimeFormatter (date) {
            if (typeof this.datetimeFormatter === "function") return this.datetimeFormatter(date);
            else if (typeof (0, _configNHWiBviwJs.c).defaultDatetimeFormatter === "function") return (0, _configNHWiBviwJs.c).defaultDatetimeFormatter(date);
            else return this.dtf.format(date);
        },
        /*
        * Parse date from string
        */ onChangeNativePicker (event) {
            const date = event.target.value;
            const s = date ? date.split(/\D/) : [];
            if (s.length >= 5) {
                const year = parseInt(s[0], 10);
                const month = parseInt(s[1], 10) - 1;
                const day = parseInt(s[2], 10);
                const hours = parseInt(s[3], 10);
                const minutes = parseInt(s[4], 10);
                // Seconds are omitted intentionally; they are unsupported by input
                // type=datetime-local and cause the control to fail native validation
                this.computedValue = new Date(year, month, day, hours, minutes);
            } else this.computedValue = null;
        },
        /*
         * Emit 'active-change' on datepicker active state change
         */ onActiveChange (value) {
            this.$emit("active-change", value);
        },
        formatNative (value) {
            const date = new Date(value);
            if (value && !isNaN(date)) {
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const hours = date.getHours();
                const minutes = date.getMinutes();
                const seconds = date.getSeconds();
                return year + "-" + ((month < 10 ? "0" : "") + month) + "-" + ((day < 10 ? "0" : "") + day) + "T" + ((hours < 10 ? "0" : "") + hours) + ":" + ((minutes < 10 ? "0" : "") + minutes) + ":" + ((seconds < 10 ? "0" : "") + seconds);
            }
            return "";
        },
        toggle () {
            this.$refs.datepicker.toggle();
        }
    },
    mounted () {
        if (!this.isMobile || this.inline) // $refs attached, it's time to refresh datepicker (input)
        {
            if (this.newValue) this.$refs.datepicker.$forceUpdate();
        }
    }
};
const _hoisted_1 = {
    class: "level is-mobile"
};
const _hoisted_2 = {
    key: 0,
    class: "level-item has-text-centered"
};
const _hoisted_3 = {
    class: "level-item has-text-centered"
};
const _hoisted_4 = {
    key: 1,
    class: "level-item has-text-centered"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_timepicker = (0, _vue.resolveComponent)("b-timepicker");
    const _component_b_datepicker = (0, _vue.resolveComponent)("b-datepicker");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return !$options.isMobile || $props.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_datepicker, (0, _vue.mergeProps)({
        key: 0,
        ref: "datepicker",
        modelValue: $options.computedValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$options.computedValue = $event)
    }, $props.datepicker, {
        rounded: _ctx.rounded,
        "open-on-focus": $props.openOnFocus,
        position: $props.position,
        loading: _ctx.loading,
        inline: $props.inline,
        editable: $props.editable,
        expanded: _ctx.expanded,
        "close-on-click": false,
        "first-day-of-week": $props.firstDayOfWeek,
        "rules-for-first-week": $props.rulesForFirstWeek,
        "date-formatter": $options.defaultDatetimeFormatter,
        "date-parser": $options.defaultDatetimeParser,
        "min-date": $options.minDate,
        "max-date": $options.maxDate,
        "nearby-month-days": $props.nearbyMonthDays,
        icon: $props.icon,
        "icon-right": $props.iconRight,
        "icon-right-clickable": $props.iconRightClickable,
        "icon-pack": $props.iconPack,
        size: $options.datepickerSize,
        placeholder: $props.placeholder,
        "horizontal-time-picker": $props.horizontalTimePicker,
        range: false,
        disabled: $options.disabledOrUndefined,
        "mobile-native": $options.isMobileNative,
        locale: _ctx.locale,
        focusable: $props.focusable,
        "append-to-body": $props.appendToBody,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur,
        onActiveChange: $options.onActiveChange,
        onIconRightClick: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit("icon-right-click")),
        onChangeMonth: _cache[3] || (_cache[3] = ($event)=>_ctx.$emit("change-month", $event)),
        onChangeYear: _cache[4] || (_cache[4] = ($event)=>_ctx.$emit("change-year", $event))
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.createElementVNode)("nav", _hoisted_1, [
                    _ctx.$slots.left !== undefined ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
                        (0, _vue.renderSlot)(_ctx.$slots, "left")
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    (0, _vue.createElementVNode)("div", _hoisted_3, [
                        (0, _vue.createVNode)(_component_b_timepicker, (0, _vue.mergeProps)({
                            ref: "timepicker"
                        }, $props.timepicker, {
                            modelValue: $options.computedValue,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.computedValue = $event),
                            inline: "",
                            editable: $props.editable,
                            "min-time": $options.minTime,
                            "max-time": $options.maxTime,
                            size: $options.timepickerSize,
                            disabled: $options.timepickerDisabled || undefined,
                            focusable: $props.focusable,
                            "mobile-native": $options.isMobileNative,
                            locale: _ctx.locale
                        }), null, 16 /* FULL_PROPS */ , [
                            "modelValue",
                            "editable",
                            "min-time",
                            "max-time",
                            "size",
                            "disabled",
                            "focusable",
                            "mobile-native",
                            "locale"
                        ])
                    ]),
                    _ctx.$slots.right !== undefined ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4, [
                        (0, _vue.renderSlot)(_ctx.$slots, "right")
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 16 /* FULL_PROPS */ , [
        "modelValue",
        "rounded",
        "open-on-focus",
        "position",
        "loading",
        "inline",
        "editable",
        "expanded",
        "first-day-of-week",
        "rules-for-first-week",
        "date-formatter",
        "date-parser",
        "min-date",
        "max-date",
        "nearby-month-days",
        "icon",
        "icon-right",
        "icon-right-clickable",
        "icon-pack",
        "size",
        "placeholder",
        "horizontal-time-picker",
        "disabled",
        "mobile-native",
        "locale",
        "focusable",
        "append-to-body",
        "onFocus",
        "onBlur",
        "onActiveChange"
    ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
        key: 1,
        ref: "input",
        type: "datetime-local",
        autocomplete: "off",
        "model-value": $options.formatNative($options.computedValue),
        placeholder: $props.placeholder,
        size: _ctx.size,
        icon: $props.icon,
        "icon-pack": $props.iconPack,
        rounded: _ctx.rounded,
        loading: _ctx.loading,
        max: $options.formatNative($options.maxDate),
        min: $options.formatNative($options.minDate),
        disabled: $options.disabledOrUndefined,
        readonly: false
    }, _ctx.$attrs, {
        "use-html5-validation": _ctx.useHtml5Validation,
        onChange: $options.onChangeNativePicker,
        onFocus: _ctx.onFocus,
        onBlur: _ctx.onBlur
    }), null, 16 /* FULL_PROPS */ , [
        "model-value",
        "placeholder",
        "size",
        "icon",
        "icon-pack",
        "rounded",
        "loading",
        "max",
        "min",
        "disabled",
        "use-html5-validation",
        "onChange",
        "onFocus",
        "onBlur"
    ]));
}
script.render = render;
script.__file = "src/components/datetimepicker/Datetimepicker.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","./Input-0ivJhXUC.js":"jYQke","./Datepicker-r7KMGxsC.js":"24fex","./Timepicker-sqpkdcr1.js":"6LEC6","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./Icon-fJqkx1gN.js":"gKXjn","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./DropdownItem-yQcaSZL4.js":"jPdf6","./trapFocus-IMs77O3T.js":"jBg9U","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","./TimepickerMixin-M_pQh7UT.js":"gf5bH","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6LEC6":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _timepickerMixinMPQh7UTJs = require("./TimepickerMixin-M_pQh7UT.js");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var script = {
    name: "BTimepicker",
    components: {
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _fieldCMd66V8HJs.s).name]: (0, _fieldCMd66V8HJs.s),
        [(0, _selectDYWGhZcJs.s).name]: (0, _selectDYWGhZcJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _dropdownItemYQcaSZL4Js.s).name]: (0, _dropdownItemYQcaSZL4Js.s),
        [(0, _dropdownItemYQcaSZL4Js.a).name]: (0, _dropdownItemYQcaSZL4Js.a)
    },
    mixins: [
        (0, _timepickerMixinMPQh7UTJs.T)
    ],
    data () {
        return {
            _isTimepicker: true
        };
    },
    computed: {
        nativeStep () {
            if (this.enableSeconds) return "1";
            else return undefined;
        }
    }
};
const _hoisted_1 = [
    "value",
    "disabled"
];
const _hoisted_2 = {
    class: "control is-colon"
};
const _hoisted_3 = [
    "value",
    "disabled"
];
const _hoisted_4 = {
    class: "control is-colon"
};
const _hoisted_5 = [
    "value",
    "disabled"
];
const _hoisted_6 = {
    class: "control is-colon"
};
const _hoisted_7 = [
    "value"
];
const _hoisted_8 = {
    key: 0,
    class: "timepicker-footer"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_field = (0, _vue.resolveComponent)("b-field");
    const _component_b_dropdown_item = (0, _vue.resolveComponent)("b-dropdown-item");
    const _component_b_dropdown = (0, _vue.resolveComponent)("b-dropdown");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "timepicker control",
            [
                _ctx.size,
                {
                    "is-expanded": _ctx.expanded
                }
            ]
        ]
    }, _ctx.rootAttrs), [
        !_ctx.isMobile || _ctx.inline ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_dropdown, {
            key: 0,
            ref: "dropdown",
            position: _ctx.position,
            disabled: _ctx.disabledOrUndefined,
            inline: _ctx.inline,
            "mobile-modal": _ctx.mobileModal,
            "append-to-body": _ctx.appendToBody,
            "append-to-body-copy-parent": "",
            onActiveChange: _ctx.onActiveChange
        }, (0, _vue.createSlots)({
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_dropdown_item, {
                        disabled: _ctx.disabledOrUndefined,
                        focusable: _ctx.focusable,
                        custom: ""
                    }, {
                        default: (0, _vue.withCtx)(()=>[
                                (0, _vue.createVNode)(_component_b_field, {
                                    grouped: "",
                                    position: "is-centered"
                                }, {
                                    default: (0, _vue.withCtx)(()=>[
                                            (0, _vue.createVNode)(_component_b_select, {
                                                modelValue: _ctx.hoursSelected,
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>_ctx.hoursSelected = $event),
                                                onChange: _cache[3] || (_cache[3] = ($event)=>_ctx.onHoursChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined,
                                                placeholder: "00"
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.hours, (hour)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: hour.value,
                                                                key: hour.value,
                                                                disabled: _ctx.isHourDisabled(hour.value) || undefined
                                                            }, (0, _vue.toDisplayString)(hour.label), 9 /* TEXT, PROPS */ , _hoisted_1);
                                                        }), 128 /* KEYED_FRAGMENT */ ))
                                                    ]),
                                                _: 1 /* STABLE */ 
                                            }, 8 /* PROPS */ , [
                                                "modelValue",
                                                "disabled"
                                            ]),
                                            (0, _vue.createElementVNode)("span", _hoisted_2, (0, _vue.toDisplayString)(_ctx.hourLiteral), 1 /* TEXT */ ),
                                            (0, _vue.createVNode)(_component_b_select, {
                                                modelValue: _ctx.minutesSelected,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.minutesSelected = $event),
                                                onChange: _cache[5] || (_cache[5] = ($event)=>_ctx.onMinutesChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined,
                                                placeholder: "00"
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.minutes, (minute)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: minute.value,
                                                                key: minute.value,
                                                                disabled: _ctx.isMinuteDisabled(minute.value) || undefined
                                                            }, (0, _vue.toDisplayString)(minute.label), 9 /* TEXT, PROPS */ , _hoisted_3);
                                                        }), 128 /* KEYED_FRAGMENT */ ))
                                                    ]),
                                                _: 1 /* STABLE */ 
                                            }, 8 /* PROPS */ , [
                                                "modelValue",
                                                "disabled"
                                            ]),
                                            _ctx.enableSeconds ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                                key: 0
                                            }, [
                                                (0, _vue.createElementVNode)("span", _hoisted_4, (0, _vue.toDisplayString)(_ctx.minuteLiteral), 1 /* TEXT */ ),
                                                (0, _vue.createVNode)(_component_b_select, {
                                                    modelValue: _ctx.secondsSelected,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>_ctx.secondsSelected = $event),
                                                    onChange: _cache[7] || (_cache[7] = ($event)=>_ctx.onSecondsChange($event.target.value)),
                                                    disabled: _ctx.disabledOrUndefined,
                                                    placeholder: "00"
                                                }, {
                                                    default: (0, _vue.withCtx)(()=>[
                                                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.seconds, (second)=>{
                                                                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                    value: second.value,
                                                                    key: second.value,
                                                                    disabled: _ctx.isSecondDisabled(second.value) || undefined
                                                                }, (0, _vue.toDisplayString)(second.label), 9 /* TEXT, PROPS */ , _hoisted_5);
                                                            }), 128 /* KEYED_FRAGMENT */ ))
                                                        ]),
                                                    _: 1 /* STABLE */ 
                                                }, 8 /* PROPS */ , [
                                                    "modelValue",
                                                    "disabled"
                                                ]),
                                                (0, _vue.createElementVNode)("span", _hoisted_6, (0, _vue.toDisplayString)(_ctx.secondLiteral), 1 /* TEXT */ )
                                            ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true),
                                            !_ctx.isHourFormat24 ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                                                key: 1,
                                                modelValue: _ctx.meridienSelected,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>_ctx.meridienSelected = $event),
                                                onChange: _cache[9] || (_cache[9] = ($event)=>_ctx.onMeridienChange($event.target.value)),
                                                disabled: _ctx.disabledOrUndefined
                                            }, {
                                                default: (0, _vue.withCtx)(()=>[
                                                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.meridiens, (meridien)=>{
                                                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                                                value: meridien,
                                                                key: meridien
                                                            }, (0, _vue.toDisplayString)(meridien), 9 /* TEXT, PROPS */ , _hoisted_7);
                                                        }), 128 /* KEYED_FRAGMENT */ ))
                                                    ]),
                                                _: 1 /* STABLE */ 
                                            }, 8 /* PROPS */ , [
                                                "modelValue",
                                                "disabled"
                                            ])) : (0, _vue.createCommentVNode)("v-if", true)
                                        ]),
                                    _: 1 /* STABLE */ 
                                }),
                                _ctx.$slots.default !== undefined ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("footer", _hoisted_8, [
                                    (0, _vue.renderSlot)(_ctx.$slots, "default")
                                ])) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                        _: 3 /* FORWARDED */ 
                    }, 8 /* PROPS */ , [
                        "disabled",
                        "focusable"
                    ])
                ]),
            _: 2 /* DYNAMIC */ 
        }, [
            !_ctx.inline ? {
                name: "trigger",
                fn: (0, _vue.withCtx)(()=>[
                        (0, _vue.renderSlot)(_ctx.$slots, "trigger", {}, ()=>[
                                (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
                                    ref: "input",
                                    autocomplete: "off",
                                    "model-value": _ctx.formatValue(_ctx.computedValue),
                                    placeholder: _ctx.placeholder,
                                    size: _ctx.size,
                                    icon: _ctx.icon,
                                    "icon-pack": _ctx.iconPack,
                                    loading: _ctx.loading,
                                    disabled: _ctx.disabledOrUndefined,
                                    readonly: !_ctx.editable || undefined,
                                    rounded: _ctx.rounded
                                }, _ctx.fallthroughAttrs, {
                                    "use-html5-validation": _ctx.useHtml5Validation,
                                    onKeyup: _cache[0] || (_cache[0] = (0, _vue.withKeys)(($event)=>_ctx.toggle(true), [
                                        "enter"
                                    ])),
                                    onChange: _cache[1] || (_cache[1] = ($event)=>_ctx.onChange($event.target.value)),
                                    onFocus: _ctx.handleOnFocus
                                }), null, 16 /* FULL_PROPS */ , [
                                    "model-value",
                                    "placeholder",
                                    "size",
                                    "icon",
                                    "icon-pack",
                                    "loading",
                                    "disabled",
                                    "readonly",
                                    "rounded",
                                    "use-html5-validation",
                                    "onFocus"
                                ])
                            ])
                    ]),
                key: "0"
            } : undefined
        ]), 1032 /* PROPS, DYNAMIC_SLOTS */ , [
            "position",
            "disabled",
            "inline",
            "mobile-modal",
            "append-to-body",
            "onActiveChange"
        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
            key: 1,
            ref: "input",
            type: "time",
            step: $options.nativeStep,
            autocomplete: "off",
            "model-value": _ctx.formatHHMMSS(_ctx.computedValue),
            placeholder: _ctx.placeholder,
            size: _ctx.size,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            rounded: _ctx.rounded,
            loading: _ctx.loading,
            max: _ctx.formatHHMMSS(_ctx.maxTime),
            min: _ctx.formatHHMMSS(_ctx.minTime),
            disabled: _ctx.disabledOrUndefined,
            readonly: false
        }, _ctx.fallthroughAttrs, {
            "use-html5-validation": _ctx.useHtml5Validation,
            onChange: _cache[10] || (_cache[10] = ($event)=>_ctx.onChange($event.target.value)),
            onFocus: _ctx.handleOnFocus,
            onBlur: _cache[11] || (_cache[11] = ($event)=>_ctx.onBlur() && _ctx.checkHtml5Validity())
        }), null, 16 /* FULL_PROPS */ , [
            "step",
            "model-value",
            "placeholder",
            "size",
            "icon",
            "icon-pack",
            "rounded",
            "loading",
            "max",
            "min",
            "disabled",
            "use-html5-validation",
            "onFocus"
        ]))
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/timepicker/Timepicker.vue";

},{"./TimepickerMixin-M_pQh7UT.js":"gf5bH","./DropdownItem-yQcaSZL4.js":"jPdf6","./Input-0ivJhXUC.js":"jYQke","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7cKRp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BDialog", ()=>script);
parcelHelpers.export(exports, "DialogProgrammatic", ()=>DialogProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _modalAu57IFsUJs = require("./Modal-au57IFsU.js");
var _buttonKVoJ7JHHJs = require("./Button-KVoJ7jHH.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BDialog",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _buttonKVoJ7JHHJs.s).name]: (0, _buttonKVoJ7JHHJs.s)
    },
    directives: {
        trapFocus: (0, _trapFocusIMs77O3TJs.t)
    },
    extends: (0, _modalAu57IFsUJs.s),
    props: {
        title: String,
        message: [
            String,
            Array
        ],
        icon: String,
        iconPack: String,
        hasIcon: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        size: String,
        confirmText: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultDialogConfirmText ? (0, _configNHWiBviwJs.c).defaultDialogConfirmText : "OK";
            }
        },
        cancelText: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultDialogCancelText ? (0, _configNHWiBviwJs.c).defaultDialogCancelText : "Cancel";
            }
        },
        hasInput: Boolean,
        inputAttrs: {
            type: Object,
            default: ()=>({})
        },
        confirmCallback: {
            type: Function,
            default: ()=>{}
        },
        closeOnConfirm: {
            type: Boolean,
            default: true
        },
        container: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultContainerElement;
            }
        },
        focusOn: {
            type: String,
            default: "confirm"
        },
        trapFocus: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTrapFocus;
            }
        },
        ariaRole: {
            type: String,
            validator: (value)=>{
                return [
                    "dialog",
                    "alertdialog"
                ].indexOf(value) >= 0;
            }
        },
        ariaModal: Boolean
    },
    emits: [
        "confirm"
    ],
    data () {
        const prompt = this.hasInput ? this.inputAttrs.value || "" : "";
        return {
            prompt,
            isActive: false,
            validationMessage: "",
            isCompositing: false,
            isLoading: false
        };
    },
    computed: {
        // `safeInputAttrs` is a shallow copy of `inputAttrs` except for `value`
        // `value` should not be specified to `v-bind` of the input element
        // because it inhibits `v-model` of the input on Vue 3
        safeInputAttrs () {
            const attrs = {
                ...this.inputAttrs
            };
            delete attrs.value;
            if (typeof attrs.required === "undefined") attrs.required = true;
            return attrs;
        },
        dialogClass () {
            return [
                this.size,
                {
                    "has-custom-container": this.container !== null
                }
            ];
        },
        /**
        * Icon name (MDI) based on the type.
        */ iconByType () {
            switch(this.type){
                case "is-info":
                    return "information";
                case "is-success":
                    return "check-circle";
                case "is-warning":
                    return "alert";
                case "is-danger":
                    return "alert-circle";
                default:
                    return null;
            }
        },
        showCancel () {
            return this.cancelOptions.indexOf("button") >= 0;
        }
    },
    methods: {
        /**
        * If it's a prompt Dialog, validate the input.
        * Call the confirmCallback prop (function) and close the Dialog.
        */ confirm () {
            if (this.$refs.input !== undefined) {
                if (this.isCompositing) return;
                if (!this.$refs.input.checkValidity()) {
                    this.validationMessage = this.$refs.input.validationMessage;
                    this.$nextTick(()=>this.$refs.input.select());
                    return;
                }
            }
            this.$emit("confirm", this.prompt);
            this.confirmCallback(this.prompt, this);
            if (this.closeOnConfirm) this.close();
        },
        /**
        * Close the Dialog.
        */ close () {
            this.isActive = false;
            this.isLoading = false;
            // Timeout for the animation complete before destroying
            setTimeout(()=>{
                (0, _helpersO9H6ICOJs.r)(this.$el);
            }, 150);
        },
        /**
        * Start the Loading.
        */ startLoading () {
            this.isLoading = true;
        },
        /**
        * Cancel the Loading.
        */ cancelLoading () {
            this.isLoading = false;
        }
    },
    beforeMount () {
        // Insert the Dialog component in the element container
        if (typeof window !== "undefined") this.$nextTick(()=>{
            const container = document.querySelector(this.container) || document.body;
            container.appendChild(this.$el);
        });
    },
    mounted () {
        this.isActive = true;
        this.$nextTick(()=>{
            // Handle which element receives focus
            if (this.hasInput) this.$refs.input.focus();
            else if (this.focusOn === "cancel" && this.showCancel) this.$refs.cancelButton.$el.focus();
            else this.$refs.confirmButton.$el.focus();
        });
    }
};
const _hoisted_1 = [
    "role",
    "aria-modal"
];
const _hoisted_2 = {
    class: "modal-card animation-content"
};
const _hoisted_3 = {
    key: 0,
    class: "modal-card-head"
};
const _hoisted_4 = {
    class: "modal-card-title"
};
const _hoisted_5 = {
    class: "media"
};
const _hoisted_6 = {
    key: 0,
    class: "media-left"
};
const _hoisted_7 = {
    class: "media-content"
};
const _hoisted_8 = [
    "innerHTML"
];
const _hoisted_9 = {
    key: 0,
    class: "field"
};
const _hoisted_10 = {
    class: "control"
};
const _hoisted_11 = {
    class: "help is-danger"
};
const _hoisted_12 = {
    class: "modal-card-foot"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_button = (0, _vue.resolveComponent)("b-button");
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: _ctx.animation
    }, {
        default: (0, _vue.withCtx)(()=>[
                $data.isActive ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "dialog modal is-active",
                        $options.dialogClass
                    ]),
                    role: $props.ariaRole,
                    "aria-modal": $props.ariaModal
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "modal-background",
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.cancel("outside"))
                    }),
                    (0, _vue.createElementVNode)("div", _hoisted_2, [
                        $props.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_3, [
                            (0, _vue.createElementVNode)("p", _hoisted_4, (0, _vue.toDisplayString)($props.title), 1 /* TEXT */ )
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("section", {
                            class: (0, _vue.normalizeClass)([
                                "modal-card-body",
                                {
                                    "is-titleless": !$props.title,
                                    "is-flex": $props.hasIcon
                                }
                            ])
                        }, [
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                $props.hasIcon && ($props.icon || $options.iconByType) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_6, [
                                    (0, _vue.createVNode)(_component_b_icon, {
                                        icon: $props.icon ? $props.icon : $options.iconByType,
                                        pack: $props.iconPack,
                                        type: $props.type,
                                        both: !$props.icon,
                                        size: "is-large"
                                    }, null, 8 /* PROPS */ , [
                                        "icon",
                                        "pack",
                                        "type",
                                        "both"
                                    ])
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                (0, _vue.createElementVNode)("div", _hoisted_7, [
                                    (0, _vue.createElementVNode)("p", null, [
                                        _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                            key: 0
                                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                            key: 1
                                        }, [
                                            (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                                            (0, _vue.createElementVNode)("div", {
                                                innerHTML: $props.message
                                            }, null, 8 /* PROPS */ , _hoisted_8)
                                        ], 64 /* STABLE_FRAGMENT */ ))
                                    ]),
                                    $props.hasInput ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                                        (0, _vue.createElementVNode)("div", _hoisted_10, [
                                            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", (0, _vue.mergeProps)({
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.prompt = $event),
                                                class: [
                                                    "input",
                                                    {
                                                        "is-danger": $data.validationMessage
                                                    }
                                                ],
                                                ref: "input"
                                            }, $options.safeInputAttrs, {
                                                onCompositionstart: _cache[2] || (_cache[2] = ($event)=>$data.isCompositing = true),
                                                onCompositionend: _cache[3] || (_cache[3] = ($event)=>$data.isCompositing = false),
                                                onKeydown: _cache[4] || (_cache[4] = (0, _vue.withKeys)((...args)=>$options.confirm && $options.confirm(...args), [
                                                    "enter"
                                                ]))
                                            }), null, 16 /* FULL_PROPS */ ), [
                                                [
                                                    (0, _vue.vModelDynamic),
                                                    $data.prompt
                                                ]
                                            ])
                                        ]),
                                        (0, _vue.createElementVNode)("p", _hoisted_11, (0, _vue.toDisplayString)($data.validationMessage), 1 /* TEXT */ )
                                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                                ])
                            ])
                        ], 2 /* CLASS */ ),
                        (0, _vue.createElementVNode)("footer", _hoisted_12, [
                            $options.showCancel ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_button, {
                                key: 0,
                                ref: "cancelButton",
                                disabled: $data.isLoading,
                                onClick: _cache[5] || (_cache[5] = ($event)=>_ctx.cancel("button"))
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.cancelText), 1 /* TEXT */ )
                                    ]),
                                _: 1 /* STABLE */ 
                            }, 8 /* PROPS */ , [
                                "disabled"
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createVNode)(_component_b_button, {
                                type: $props.type,
                                ref: "confirmButton",
                                loading: $data.isLoading,
                                onClick: $options.confirm
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.confirmText), 1 /* TEXT */ )
                                    ]),
                                _: 1 /* STABLE */ 
                            }, 8 /* PROPS */ , [
                                "type",
                                "loading",
                                "onClick"
                            ])
                        ])
                    ])
                ], 10 /* CLASS, PROPS */ , _hoisted_1)), [
                    [
                        _directive_trap_focus,
                        $props.trapFocus
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "name"
    ]);
}
script.render = render;
script.__file = "src/components/dialog/Dialog.vue";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function open(propsData, app) {
    var slot;
    if (Array.isArray(propsData.message)) {
        slot = propsData.message;
        delete propsData.message;
    }
    function createDialog(_onConfirm, _onCancel) {
        var container = document.createElement("div");
        // Vue 3 requires a new app to mount another component
        var vueInstance = (0, _vue.createApp)({
            data: function data() {
                return {
                    dialogVNode: null
                };
            },
            methods: {
                close: function close() {
                    var dialog = (0, _helpersO9H6ICOJs.z)(this.dialogVNode);
                    if (dialog) dialog.close();
                },
                startLoading: function startLoading() {
                    var dialog = (0, _helpersO9H6ICOJs.z)(this.dialogVNode);
                    if (dialog) dialog.startLoading();
                },
                cancelLoading: function cancelLoading() {
                    var dialog = (0, _helpersO9H6ICOJs.z)(this.dialogVNode);
                    if (dialog) dialog.cancelLoading();
                }
            },
            render: function render() {
                this.dialogVNode = (0, _vue.h)(script, _objectSpread(_objectSpread({}, propsData), {}, {
                    // intentionally overrides propsData.onConfirm
                    // to prevent propsData.onConfirm from receiving a "confirm" event
                    onConfirm: function onConfirm() {
                        if (_onConfirm != null) _onConfirm.apply(void 0, arguments);
                    },
                    // intentionally override propsData.onCancel
                    // to prevent propsData.onCancel from receiving a "cancel" event
                    onCancel: function onCancel() {
                        if (_onCancel != null) _onCancel.apply(void 0, arguments);
                        vueInstance.unmount();
                    },
                    confirmCallback: function confirmCallback() {
                        if (propsData.onConfirm != null) propsData.onConfirm.apply(propsData, arguments);
                    },
                    cancelCallback: function cancelCallback() {
                        if (propsData.onCancel != null) propsData.onCancel.apply(propsData, arguments);
                    }
                }), slot ? {
                    "default": function _default() {
                        return slot;
                    }
                } : undefined);
                return this.dialogVNode;
            }
        });
        if (app) (0, _helpersO9H6ICOJs.A)(app, vueInstance);
        return vueInstance.mount(container);
    }
    if (!(0, _configNHWiBviwJs.c).defaultProgrammaticPromise) return createDialog();
    else return new Promise(function(resolve) {
        var dialog = createDialog(function(event) {
            return resolve({
                result: event || true,
                dialog: dialog
            });
        }, function() {
            return resolve({
                result: false,
                dialog: dialog
            });
        });
    });
}
var DialogProgrammatic = /*#__PURE__*/ function() {
    function DialogProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, DialogProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(DialogProgrammatic, [
        {
            key: "alert",
            value: function alert(params) {
                if (typeof params === "string") params = {
                    message: params
                };
                var defaultParam = {
                    canCancel: false
                };
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                return open(propsData, this.app);
            }
        },
        {
            key: "confirm",
            value: function confirm(params) {
                var defaultParam = {};
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                return open(propsData, this.app);
            }
        },
        {
            key: "prompt",
            value: function prompt(params) {
                var defaultParam = {
                    hasInput: true
                };
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                return open(propsData, this.app);
            }
        }
    ]);
    return DialogProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
        (0, _pluginsC7548X21Js.r)(Vue, "dialog", new DialogProgrammatic(Vue));
    }
};

},{"./classCallCheck-E4khD9xn.js":"fYU5v","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","./trapFocus-IMs77O3T.js":"jBg9U","./Icon-fJqkx1gN.js":"gKXjn","./Modal-au57IFsU.js":"7FChN","./Button-KVoJ7jHH.js":"l7xXn","./config-nHWiBviw.js":"4fneA","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7FChN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var script = {
    name: "BModal",
    directives: {
        trapFocus: (0, _trapFocusIMs77O3TJs.t)
    },
    props: {
        modelValue: Boolean,
        component: [
            Object,
            Function,
            String
        ],
        content: [
            String,
            Array
        ],
        programmatic: Boolean,
        props: Object,
        events: {
            type: Object,
            default () {
                return {};
            }
        },
        width: {
            type: [
                String,
                Number
            ],
            default: 960
        },
        hasModalCard: Boolean,
        animation: {
            type: String,
            default: "zoom-out"
        },
        canCancel: {
            type: [
                Array,
                Boolean
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultModalCanCancel;
            }
        },
        cancelCallback: {
            type: Function,
            default: ()=>{}
        },
        scroll: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultModalScroll ? (0, _configNHWiBviwJs.c).defaultModalScroll : "clip";
            },
            validator: (value)=>{
                return [
                    "clip",
                    "keep"
                ].indexOf(value) >= 0;
            }
        },
        fullScreen: Boolean,
        trapFocus: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTrapFocus;
            }
        },
        autoFocus: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultAutoFocus;
            }
        },
        customClass: String,
        customContentClass: [
            String,
            Array,
            Object
        ],
        ariaRole: {
            type: String,
            validator: (value)=>{
                return [
                    "dialog",
                    "alertdialog"
                ].indexOf(value) >= 0;
            }
        },
        ariaModal: Boolean,
        ariaLabel: {
            type: String,
            validator: (value)=>{
                return Boolean(value);
            }
        },
        closeButtonAriaLabel: String,
        destroyOnHide: {
            type: Boolean,
            default: true
        },
        renderOnMounted: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "after-enter",
        "after-leave",
        "cancel",
        "close",
        "update:modelValue"
    ],
    data () {
        return {
            isActive: this.modelValue || false,
            savedScrollTop: null,
            newWidth: typeof this.width === "number" ? this.width + "px" : this.width,
            animating: !this.modelValue,
            destroyed: !(this.modelValue || this.renderOnMounted)
        };
    },
    computed: {
        cancelOptions () {
            return typeof this.canCancel === "boolean" ? this.canCancel ? (0, _configNHWiBviwJs.c).defaultModalCanCancel : [] : this.canCancel;
        },
        showX () {
            return this.cancelOptions.indexOf("x") >= 0;
        },
        customStyle () {
            if (!this.fullScreen) return {
                maxWidth: this.newWidth
            };
            return null;
        }
    },
    watch: {
        modelValue (value) {
            this.isActive = value;
        },
        isActive (value) {
            if (value) this.destroyed = false;
            this.handleScroll();
            this.$nextTick(()=>{
                if (value && this.$el && this.$el.focus && this.autoFocus) this.$el.focus();
            });
        }
    },
    methods: {
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.scroll === "clip") {
                if (this.isActive) document.documentElement.classList.add("is-clipped");
                else document.documentElement.classList.remove("is-clipped");
                return;
            }
            this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            if (this.isActive) document.body.classList.add("is-noscroll");
            else document.body.classList.remove("is-noscroll");
            if (this.isActive) {
                document.body.style.top = `-${this.savedScrollTop}px`;
                return;
            }
            document.documentElement.scrollTop = this.savedScrollTop;
            document.body.style.top = null;
            this.savedScrollTop = null;
        },
        /**
        * Close the Modal if canCancel and call the cancelCallback prop (function).
        */ cancel (method) {
            if (this.cancelOptions.indexOf(method) < 0) return;
            this.$emit("cancel", arguments);
            this.cancelCallback.apply(null, arguments);
            this.close();
        },
        /**
        * Call the cancelCallback prop (function).
        * Emit events, and destroy modal if it's programmatic.
        */ close () {
            this.$emit("close");
            this.$emit("update:modelValue", false);
            // Timeout for the animation complete before destroying
            if (this.programmatic) {
                this.isActive = false;
                setTimeout(()=>{
                    (0, _helpersO9H6ICOJs.r)(this.$el);
                }, 150);
            }
        },
        /**
        * Keypress event that is bound to the document.
        */ keyPress ({ key }) {
            if (this.isActive && (key === "Escape" || key === "Esc")) this.cancel("escape");
        },
        /**
        * Transition after-enter hook
        */ afterEnter () {
            this.animating = false;
            this.$emit("after-enter");
        },
        /**
        * Transition before-leave hook
        */ beforeLeave () {
            this.animating = true;
        },
        /**
        * Transition after-leave hook
        */ afterLeave () {
            if (this.destroyOnHide) this.destroyed = true;
            this.$emit("after-leave");
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    mounted () {
        if (this.programmatic) {
            // Insert the Modal component in body tag
            // only if it's programmatic
            // the following line used be in `beforeMount`
            // but $el is null at `beforeMount`
            document.body.appendChild(this.$el);
            this.isActive = true;
        } else if (this.isActive) this.handleScroll();
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("keyup", this.keyPress);
            // reset scroll
            document.documentElement.classList.remove("is-clipped");
            const savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            document.body.classList.remove("is-noscroll");
            document.documentElement.scrollTop = savedScrollTop;
            document.body.style.top = null;
        }
    }
};
const _hoisted_1 = [
    "role",
    "aria-label",
    "aria-modal"
];
const _hoisted_2 = [
    "innerHTML"
];
const _hoisted_3 = [
    "aria-label"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_trap_focus = (0, _vue.resolveDirective)("trap-focus");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: $props.animation,
        onAfterEnter: $options.afterEnter,
        onBeforeLeave: $options.beforeLeave,
        onAfterLeave: $options.afterLeave
    }, {
        default: (0, _vue.withCtx)(()=>[
                !$data.destroyed ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "modal is-active",
                        [
                            {
                                "is-full-screen": $props.fullScreen
                            },
                            $props.customClass
                        ]
                    ]),
                    tabindex: "-1",
                    role: $props.ariaRole,
                    "aria-label": $props.ariaLabel,
                    "aria-modal": $props.ariaModal || undefined
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "modal-background",
                        onClick: _cache[0] || (_cache[0] = ($event)=>$options.cancel("outside"))
                    }),
                    (0, _vue.createElementVNode)("div", {
                        class: (0, _vue.normalizeClass)([
                            "animation-content",
                            [
                                {
                                    "modal-content": !$props.hasModalCard
                                },
                                $props.customContentClass
                            ]
                        ]),
                        style: (0, _vue.normalizeStyle)($options.customStyle)
                    }, [
                        $props.component ? ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.component), (0, _vue.mergeProps)({
                            key: 0
                        }, $props.props, (0, _vue.toHandlers)($props.events), {
                            "can-cancel": $props.canCancel,
                            onClose: $options.close
                        }), null, 16 /* FULL_PROPS */ , [
                            "can-cancel",
                            "onClose"
                        ])) : $props.content ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: 1
                        }, [
                            (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                            (0, _vue.createElementVNode)("div", {
                                innerHTML: $props.content
                            }, null, 8 /* PROPS */ , _hoisted_2)
                        ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.renderSlot)(_ctx.$slots, "default", {
                            key: 2,
                            canCancel: $props.canCancel,
                            close: $options.close
                        }),
                        $options.showX ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 3,
                            type: "button",
                            class: "modal-close is-large",
                            "aria-label": $props.closeButtonAriaLabel,
                            onClick: _cache[1] || (_cache[1] = ($event)=>$options.cancel("x"))
                        }, null, 8 /* PROPS */ , _hoisted_3)), [
                            [
                                (0, _vue.vShow),
                                !$data.animating
                            ]
                        ]) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 6 /* CLASS, STYLE */ )
                ], 10 /* CLASS, PROPS */ , _hoisted_1)), [
                    [
                        (0, _vue.vShow),
                        $data.isActive
                    ],
                    [
                        _directive_trap_focus,
                        $props.trapFocus
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "name",
        "onAfterEnter",
        "onBeforeLeave",
        "onAfterLeave"
    ]);
}
script.render = render;
script.__file = "src/components/modal/Modal.vue";

},{"./trapFocus-IMs77O3T.js":"jBg9U","./helpers-O9h6_ICO.js":"9IzVa","./config-nHWiBviw.js":"4fneA","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bxKm4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BDropdown", ()=>(0, _dropdownItemYQcaSZL4Js.s));
parcelHelpers.export(exports, "BDropdownItem", ()=>(0, _dropdownItemYQcaSZL4Js.a));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _vue = require("vue");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _dropdownItemYQcaSZL4Js.s));
        (0, _pluginsC7548X21Js.a)(Vue, (0, _dropdownItemYQcaSZL4Js.a));
    }
};

},{"./DropdownItem-yQcaSZL4.js":"jPdf6","./plugins-C7548x21.js":"fuYWh","vue":"dylud","./trapFocus-IMs77O3T.js":"jBg9U","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jbn2q":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BField", ()=>(0, _fieldCMd66V8HJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _fieldCMd66V8HJs.s));
    }
};

},{"./Field-CMd66v8h.js":"h48jl","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2k3k7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BIcon", ()=>(0, _iconFJqkx1GNJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _iconFJqkx1GNJs.s));
    }
};

},{"./Icon-fJqkx1gN.js":"gKXjn","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"79D7W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BImage", ()=>(0, _imageS3BlktdgJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _imageS3BlktdgJs = require("./Image-s3Blktdg.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _imageS3BlktdgJs.s));
    }
};

},{"./Image-s3Blktdg.js":"4Orx2","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4iQu4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BInput", ()=>(0, _input0IvJhXUCJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _input0IvJhXUCJs.s));
    }
};

},{"./Input-0ivJhXUC.js":"jYQke","./plugins-C7548x21.js":"fuYWh","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLwPW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLoading", ()=>(0, _loadingP2Sa5IKEJs.s));
parcelHelpers.export(exports, "LoadingProgrammatic", ()=>LoadingProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _vue = require("vue");
var _loadingP2Sa5IKEJs = require("./Loading-p2sa5IKE.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _ssrJg9YOstJs = require("./ssr-jg9-YOst.js");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var LoadingProgrammatic = /*#__PURE__*/ function() {
    function LoadingProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, LoadingProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(LoadingProgrammatic, [
        {
            key: "open",
            value: function open(params) {
                var defaultParam = {
                    programmatic: true
                };
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                var container = document.createElement("div");
                // Vue 3 requires a new app to mount another component
                var vueInstance = (0, _vue.createApp)({
                    data: function data() {
                        return {
                            loadingVNode: null
                        };
                    },
                    methods: {
                        close: function close() {
                            // TODO: too much dependence on Vue's internal structure?
                            var loading = (0, _helpersO9H6ICOJs.z)(this.loadingVNode);
                            if (loading) loading.close();
                        }
                    },
                    render: function render() {
                        this.loadingVNode = (0, _vue.h)((0, _loadingP2Sa5IKEJs.s), _objectSpread(_objectSpread({}, propsData), {}, {
                            onClose: function onClose() {
                                if (propsData.onClose) propsData.onClose.apply(propsData, arguments);
                                // timeout for the animation complete before destroying
                                setTimeout(function() {
                                    vueInstance.unmount();
                                }, 150);
                            }
                        }));
                        return this.loadingVNode;
                    }
                });
                if (this.app) (0, _helpersO9H6ICOJs.A)(this.app, vueInstance);
                return vueInstance.mount(container);
            }
        }
    ]);
    return LoadingProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _loadingP2Sa5IKEJs.s));
        (0, _pluginsC7548X21Js.r)(Vue, "loading", new LoadingProgrammatic(Vue));
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./classCallCheck-E4khD9xn.js":"fYU5v","vue":"dylud","./Loading-p2sa5IKE.js":"1xQL0","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./ssr-jg9-YOst.js":"8rU16","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1xQL0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _ssrJg9YOstJs = require("./ssr-jg9-YOst.js");
var _vue = require("vue");
var script = {
    name: "BLoading",
    props: {
        modelValue: Boolean,
        programmatic: Boolean,
        container: [
            Object,
            Function,
            (0, _ssrJg9YOstJs.H)
        ],
        isFullPage: {
            type: Boolean,
            default: true
        },
        animation: {
            type: String,
            default: "fade"
        },
        canCancel: {
            type: Boolean,
            default: false
        },
        onCancel: {
            type: Function,
            default: ()=>{}
        }
    },
    emits: [
        "close",
        "update:is-full-page",
        "update:modelValue"
    ],
    data () {
        return {
            isActive: this.modelValue || false,
            displayInFullPage: this.isFullPage
        };
    },
    watch: {
        modelValue (value) {
            this.isActive = value;
        },
        isFullPage (value) {
            this.displayInFullPage = value;
        }
    },
    methods: {
        /**
        * Close the Modal if canCancel.
        */ cancel () {
            if (!this.canCancel || !this.isActive) return;
            this.close();
        },
        /**
        * Emit events, and destroy modal if it's programmatic.
        */ close () {
            this.onCancel.apply(null, arguments);
            this.$emit("close");
            this.$emit("update:modelValue", false);
            // Timeout for the animation complete before destroying
            if (this.programmatic) {
                this.isActive = false;
                // TODO: should the following happen outside this component;
                // i.e., in index.js?
                setTimeout(()=>{
                    (0, _helpersO9H6ICOJs.r)(this.$el);
                }, 150);
            }
        },
        /**
        * Keypress event that is bound to the document.
        */ keyPress ({ key }) {
            if (key === "Escape" || key === "Esc") this.cancel();
        }
    },
    created () {
        if (typeof window !== "undefined") document.addEventListener("keyup", this.keyPress);
    },
    mounted () {
        // Insert the Loading component in body tag
        // only if it's programmatic
        // (moved from beforeMount because $el is not bound during beforeMount)
        // TODO: should this happen outside this component; i.e., in index.js?
        if (this.programmatic) {
            if (!this.container) document.body.appendChild(this.$el);
            else {
                this.displayInFullPage = false;
                this.$emit("update:is-full-page", false);
                this.container.appendChild(this.$el);
            }
            this.isActive = true;
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") document.removeEventListener("keyup", this.keyPress);
    }
};
const _hoisted_1 = /*#__PURE__*/ (0, _vue.createElementVNode)("div", {
    class: "loading-icon"
}, null, -1 /* HOISTED */ );
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: $props.animation
    }, {
        default: (0, _vue.withCtx)(()=>[
                $data.isActive ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                    key: 0,
                    class: (0, _vue.normalizeClass)([
                        "loading-overlay is-active",
                        {
                            "is-full-page": $data.displayInFullPage
                        }
                    ])
                }, [
                    (0, _vue.createElementVNode)("div", {
                        class: "loading-background",
                        onClick: _cache[0] || (_cache[0] = (...args)=>$options.cancel && $options.cancel(...args))
                    }),
                    (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                            _hoisted_1
                        ])
                ], 2 /* CLASS */ )), [
                    [
                        (0, _vue.vShow),
                        $data.isActive
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true)
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "name"
    ]);
}
script.render = render;
script.__file = "src/components/loading/Loading.vue";

},{"./helpers-O9h6_ICO.js":"9IzVa","./ssr-jg9-YOst.js":"8rU16","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8rU16":[function(require,module,exports) {
// Polyfills for SSR
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "F", ()=>File);
parcelHelpers.export(exports, "H", ()=>HTMLElement);
var isSSR = typeof window === "undefined";
var HTMLElement = isSSR ? Object : window.HTMLElement;
var File = isSSR ? Object : window.File;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lBgqY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BMenu", ()=>script$2);
parcelHelpers.export(exports, "BMenuItem", ()=>script);
parcelHelpers.export(exports, "BMenuList", ()=>script$1);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _vue = require("vue");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var MenuItemContainerMixin = {
    provide: function provide() {
        return {
            BMenuItemContainer: this
        };
    },
    data: function data() {
        return {
            menuItems: []
        };
    },
    methods: {
        appendMenuItem: function appendMenuItem(item) {
            this.menuItems.push(item);
        },
        removeMenuItem: function removeMenuItem(item) {
            var index = this.menuItems.indexOf(item);
            if (index !== -1) this.menuItems.splice(index, 1);
        }
    }
};
var script$2 = {
    name: "BMenu",
    mixins: [
        MenuItemContainerMixin
    ],
    props: {
        accordion: {
            type: Boolean,
            default: true
        },
        activable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            _isMenu: true // Used by MenuItem
        };
    }
};
const _hoisted_1$2 = {
    class: "menu"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$2, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ]);
}
script$2.render = render$2;
script$2.__file = "src/components/menu/Menu.vue";
var script$1 = {
    name: "BMenuList",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    props: {
        label: String,
        icon: String,
        iconPack: String,
        ariaRole: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "is-small"
        }
    }
};
const _hoisted_1$1 = {
    key: 0,
    class: "menu-label"
};
const _hoisted_2$1 = [
    "role"
];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        $props.label || _ctx.$slots.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_1$1, [
            $props.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                $props.icon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: $props.icon,
                        pack: $props.iconPack,
                        size: $props.size
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack",
                        "size"
                    ]),
                    (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ )) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 1
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                ], 64 /* STABLE_FRAGMENT */ ))
            ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                key: 1
            })
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("ul", {
            class: "menu-list",
            role: $props.ariaRole === "menu" ? $props.ariaRole : undefined
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8 /* PROPS */ , _hoisted_2$1)
    ], 64 /* STABLE_FRAGMENT */ );
}
script$1.render = render$1;
script$1.__file = "src/components/menu/MenuList.vue";
var script = {
    name: "BMenuItem",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        MenuItemContainerMixin
    ],
    inject: {
        parent: {
            from: "BMenuItemContainer",
            default: null
        }
    },
    // deprecated, to replace with default 'value' in the next breaking change
    props: {
        label: String,
        modelValue: Boolean,
        expanded: Boolean,
        disabled: Boolean,
        iconPack: String,
        icon: String,
        animation: {
            type: String,
            default: "slide"
        },
        tag: {
            type: String,
            default: "a",
            validator: (value)=>{
                return (0, _configNHWiBviwJs.c).defaultLinkTags.indexOf(value) >= 0;
            }
        },
        ariaRole: {
            type: String,
            default: ""
        },
        size: {
            type: String,
            default: "is-small"
        }
    },
    emits: [
        "update:modelValue",
        "update:expanded"
    ],
    data () {
        return {
            newActive: this.modelValue,
            newExpanded: this.expanded
        };
    },
    computed: {
        ariaRoleMenu () {
            return this.ariaRole === "menuitem" ? this.ariaRole : null;
        }
    },
    watch: {
        modelValue (value) {
            this.newActive = value;
        },
        expanded (value) {
            this.newExpanded = value;
        }
    },
    methods: {
        onClick (event) {
            if (this.disabled) return;
            const menu = this.getMenu();
            this.reset(this.parent, menu);
            this.newExpanded = this.$props.expanded || !this.newExpanded;
            this.$emit("update:expanded", this.newExpanded);
            if (menu && menu.activable) {
                this.newActive = true;
                this.$emit("update:modelValue", this.newActive);
            }
        },
        reset (parent, menu) {
            if (parent == null) return;
            parent.menuItems.forEach((item)=>{
                if (item !== this) {
                    this.reset(item, menu);
                    if (!parent.$data._isMenu || parent.$data._isMenu && parent.accordion) {
                        item.newExpanded = false;
                        item.$emit("update:expanded", item.newActive);
                    }
                    if (menu && menu.activable) {
                        item.newActive = false;
                        item.$emit("update:modelValue", item.newActive);
                    }
                }
            });
        },
        getMenu () {
            let parent = this.$parent;
            while(parent && !parent.$data._isMenu)parent = parent.$parent;
            return parent;
        }
    },
    mounted () {
        if (this.parent) this.parent.appendMenuItem(this);
    },
    beforeUnmount () {
        if (this.parent) this.parent.removeMenuItem(this);
    }
};
const _hoisted_1 = [
    "role"
];
const _hoisted_2 = {
    key: 1
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", (0, _vue.mergeProps)({
        role: $options.ariaRoleMenu
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.tag), (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
            class: {
                "is-active": $data.newActive,
                "is-expanded": $data.newExpanded,
                "is-disabled": $props.disabled,
                "icon-text": $props.icon
            },
            onClick: _cache[0] || (_cache[0] = ($event)=>$options.onClick($event))
        }), {
            default: (0, _vue.withCtx)(()=>[
                    $props.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                        key: 0,
                        icon: $props.icon,
                        pack: $props.iconPack,
                        size: $props.size
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack",
                        "size"
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    $props.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2, (0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                        key: 2,
                        expanded: $data.newExpanded,
                        active: $data.newActive
                    })
                ]),
            _: 3 /* FORWARDED */ 
        }, 16 /* FULL_PROPS */ , [
            "class"
        ])),
        (0, _vue.createCommentVNode)(" sub menu items "),
        _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
            key: 0,
            name: $props.animation,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("ul", null, [
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ], 512 /* NEED_PATCH */ ), [
                        [
                            (0, _vue.vShow),
                            $data.newExpanded
                        ]
                    ])
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "name"
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ , _hoisted_1);
}
script.render = render;
script.__file = "src/components/menu/MenuItem.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$2);
        // explicit `name` is needed to avoid name mangling of
        // Functional Component in production
        (0, _pluginsC7548X21Js.a)(Vue, script$1, "BMenuList");
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"vue":"dylud","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ihoJF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BMessage", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _messageMixinKdZp92IJs = require("./MessageMixin-KdZp92I_.js");
var _progress7Ux1HulHJs = require("./Progress-7Ux1HulH.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var script = {
    name: "BMessage",
    components: {
        [(0, _progress7Ux1HulHJs.s).name]: (0, _progress7Ux1HulHJs.s)
    },
    mixins: [
        (0, _messageMixinKdZp92IJs.M)
    ],
    props: {
        ariaCloseLabel: String
    }
};
const _hoisted_1 = {
    key: 0,
    class: "message-header"
};
const _hoisted_2 = {
    key: 0
};
const _hoisted_3 = {
    key: 1
};
const _hoisted_4 = [
    "aria-label"
];
const _hoisted_5 = {
    key: 1,
    class: "message-body"
};
const _hoisted_6 = {
    class: "media"
};
const _hoisted_7 = {
    key: 0,
    class: "media-left"
};
const _hoisted_8 = {
    class: "media-content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_progress = (0, _vue.resolveComponent)("b-progress");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: "fade",
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("article", {
                    class: (0, _vue.normalizeClass)([
                        "message",
                        [
                            _ctx.type,
                            _ctx.size
                        ]
                    ])
                }, [
                    _ctx.$slots.header || _ctx.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("header", _hoisted_1, [
                        _ctx.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
                            (0, _vue.renderSlot)(_ctx.$slots, "header")
                        ])) : _ctx.title ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_3, (0, _vue.toDisplayString)(_ctx.title), 1 /* TEXT */ )) : (0, _vue.createCommentVNode)("v-if", true),
                        _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 2,
                            type: "button",
                            class: "delete",
                            onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args)),
                            "aria-label": $props.ariaCloseLabel
                        }, null, 8 /* PROPS */ , _hoisted_4)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("section", _hoisted_5, [
                        (0, _vue.createElementVNode)("div", _hoisted_6, [
                            _ctx.computedIcon && _ctx.hasIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_7, [
                                (0, _vue.createVNode)(_component_b_icon, {
                                    icon: _ctx.computedIcon,
                                    pack: _ctx.iconPack,
                                    class: (0, _vue.normalizeClass)(_ctx.type),
                                    both: "",
                                    size: _ctx.newIconSize
                                }, null, 8 /* PROPS */ , [
                                    "icon",
                                    "pack",
                                    "class",
                                    "size"
                                ])
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createElementVNode)("div", _hoisted_8, [
                                (0, _vue.renderSlot)(_ctx.$slots, "default")
                            ])
                        ])
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.progressBar ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_progress, {
                        key: 2,
                        class: "auto-close-progress",
                        value: _ctx.remainingTime - 1,
                        max: _ctx.duration / 1000 - 1,
                        type: _ctx.type,
                        rounded: false
                    }, null, 8 /* PROPS */ , [
                        "value",
                        "max",
                        "type"
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ ), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3 /* FORWARDED */ 
    });
}
script.render = render;
script.__file = "src/components/message/Message.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./MessageMixin-KdZp92I_.js":"braJY","./Progress-7Ux1HulH.js":"226jd","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"braJY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "M", ()=>MessageMixin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var MessageMixin = {
    components: (0, _helpersO9H6ICOJs._)({}, (0, _iconFJqkx1GNJs.s).name, (0, _iconFJqkx1GNJs.s)),
    props: {
        modelValue: {
            type: Boolean,
            "default": true
        },
        title: String,
        closable: {
            type: Boolean,
            "default": true
        },
        message: String,
        type: String,
        hasIcon: Boolean,
        size: String,
        icon: String,
        iconPack: String,
        iconSize: String,
        autoClose: {
            type: Boolean,
            "default": false
        },
        duration: {
            type: Number,
            "default": 2000
        },
        progressBar: {
            type: Boolean,
            "default": false
        }
    },
    emits: [
        "click",
        "close",
        "update:modelValue"
    ],
    data: function data() {
        return {
            isActive: this.modelValue,
            remainingTime: this.duration / 1000,
            // in seconds
            newIconSize: this.iconSize || this.size || "is-large"
        };
    },
    watch: {
        modelValue: function modelValue(value) {
            this.isActive = value;
        },
        isActive: function isActive(value) {
            if (value) {
                this.setAutoClose();
                this.setDurationProgress();
            } else if (this.timer) clearTimeout(this.timer);
        }
    },
    computed: {
        /**
     * Icon name (MDI) based on type.
     */ computedIcon: function computedIcon() {
            if (this.icon) return this.icon;
            switch(this.type){
                case "is-info":
                    return "information";
                case "is-success":
                    return "check-circle";
                case "is-warning":
                    return "alert";
                case "is-danger":
                    return "alert-circle";
                default:
                    return null;
            }
        }
    },
    methods: {
        /**
     * Close the Message and emit events.
     */ close: function close() {
            this.isActive = false;
            this.resetDurationProgress();
            this.$emit("close");
            this.$emit("update:modelValue", false);
        },
        click: function click() {
            this.$emit("click");
        },
        /**
     * Set timer to auto close message
     */ setAutoClose: function setAutoClose() {
            var _this = this;
            if (this.autoClose) this.timer = setTimeout(function() {
                if (_this.isActive) _this.close();
            }, this.duration);
        },
        setDurationProgress: function setDurationProgress() {
            var _this2 = this;
            if (this.progressBar || this.autoClose) /**
         * Runs every one second to set the duration passed before
         * the alert will auto close to show it in the progress bar (Remaining Time)
         */ this.$buefy.globalNoticeInterval = setInterval(function() {
                if (_this2.remainingTime !== 0) _this2.remainingTime -= 1;
                else _this2.resetDurationProgress();
            }, 1000);
        },
        resetDurationProgress: function resetDurationProgress() {
            var _this3 = this;
            /**
       * Wait until the component get closed and then reset
       **/ setTimeout(function() {
                _this3.remainingTime = _this3.duration / 1000;
                clearInterval(_this3.$buefy.globalNoticeInterval);
            }, 100);
        }
    },
    mounted: function mounted() {
        this.setAutoClose();
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./Icon-fJqkx1gN.js":"gKXjn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"226jd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "P", ()=>PROGRESS_INJECTION_KEY);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
const PROGRESS_INJECTION_KEY = Symbol("bprogress");
var script = {
    name: "BProgress",
    provide () {
        return {
            [PROGRESS_INJECTION_KEY]: this
        };
    },
    props: {
        type: {
            type: [
                String,
                Object
            ],
            default: "is-darkgrey"
        },
        size: String,
        rounded: {
            type: Boolean,
            default: true
        },
        value: {
            type: Number,
            default: undefined
        },
        max: {
            type: Number,
            default: 100
        },
        showValue: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return [
                    "raw",
                    "percent"
                ].indexOf(value) >= 0;
            }
        },
        precision: {
            type: Number,
            default: 2
        },
        keepTrailingZeroes: {
            type: Boolean,
            default: false
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultLocale;
            }
        }
    },
    computed: {
        isIndeterminate () {
            return this.value === undefined || this.value === null;
        },
        newType () {
            return [
                this.size,
                this.type,
                {
                    "is-more-than-half": this.value && this.value > this.max / 2
                }
            ];
        },
        newValue () {
            return this.calculateValue(this.value);
        },
        isNative () {
            return this.$slots.bar === undefined;
        },
        wrapperClasses () {
            return {
                "is-not-native": !this.isNative,
                [this.size]: typeof this.size === "string" && !this.isNative
            };
        }
    },
    watch: {
        /**
         * When value is changed back to undefined, value of native progress get reset to 0.
         * Need to add and remove the value attribute to have the indeterminate or not.
         */ isIndeterminate (indeterminate) {
            this.$nextTick(()=>{
                if (this.$refs.progress) {
                    if (indeterminate) this.$refs.progress.removeAttribute("value");
                    else this.$refs.progress.setAttribute("value", this.value);
                }
            });
        }
    },
    methods: {
        calculateValue (value) {
            if (value === undefined || value === null || isNaN(value)) return undefined;
            const minimumFractionDigits = this.keepTrailingZeroes ? this.precision : 0;
            const maximumFractionDigits = this.precision;
            if (this.format === "percent") return new Intl.NumberFormat(this.locale, {
                style: "percent",
                minimumFractionDigits,
                maximumFractionDigits
            }).format(value / this.max);
            return new Intl.NumberFormat(this.locale, {
                minimumFractionDigits,
                maximumFractionDigits
            }).format(value);
        }
    }
};
const _hoisted_1 = [
    "max",
    "value"
];
const _hoisted_2 = {
    key: 2,
    class: "progress-value"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "progress-wrapper",
            [
                $options.wrapperClasses,
                {
                    "is-squared": !$props.rounded
                }
            ]
        ])
    }, [
        $options.isNative ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("progress", {
            key: 0,
            ref: "progress",
            class: (0, _vue.normalizeClass)([
                "progress",
                [
                    $options.newType,
                    {
                        "is-squared": !$props.rounded
                    }
                ]
            ]),
            max: $props.max,
            value: $props.value
        }, (0, _vue.toDisplayString)($options.newValue), 11 /* TEXT, CLASS, PROPS */ , _hoisted_1)) : (0, _vue.renderSlot)(_ctx.$slots, "bar", {
            key: 1
        }),
        $options.isNative && $props.showValue ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_2, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.newValue), 1 /* TEXT */ )
                ])
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/progress/Progress.vue";

},{"./config-nHWiBviw.js":"4fneA","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iYlHE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BModal", ()=>(0, _modalAu57IFsUJs.s));
parcelHelpers.export(exports, "ModalProgrammatic", ()=>ModalProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _vue = require("vue");
var _modalAu57IFsUJs = require("./Modal-au57IFsU.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var ModalProgrammatic = /*#__PURE__*/ function() {
    function ModalProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, ModalProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(ModalProgrammatic, [
        {
            key: "open",
            value: function open(params) {
                if (typeof params === "string") params = {
                    content: params
                };
                var defaultParam = {
                    programmatic: true
                };
                if (params.parent) delete params.parent;
                var slot;
                if (Array.isArray(params.content)) {
                    slot = params.content;
                    delete params.content;
                }
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                var container = document.createElement("div");
                // Vue 3 requires a new app to mount another component
                var vueInstance = (0, _vue.createApp)({
                    data: function data() {
                        return {
                            modalVNode: null
                        };
                    },
                    methods: {
                        close: function close() {
                            var modal = (0, _helpersO9H6ICOJs.z)(this.modalVNode);
                            if (modal) modal.close();
                        }
                    },
                    render: function render() {
                        this.modalVNode = (0, _vue.h)((0, _modalAu57IFsUJs.s), _objectSpread(_objectSpread({}, propsData), {}, {
                            onClose: function onClose() {
                                vueInstance.unmount();
                            },
                            // intentionally overrides propsData.onCancel
                            // to prevent propsData.onCancel from receiving a "cancel" event
                            onCancel: function onCancel() {},
                            cancelCallback: function cancelCallback() {
                                if (propsData.onCancel != null) propsData.onCancel.apply(propsData, arguments);
                            }
                        }), slot ? {
                            "default": function _default() {
                                return slot;
                            }
                        } : undefined);
                        return this.modalVNode;
                    }
                });
                if (this.app) (0, _helpersO9H6ICOJs.A)(this.app, vueInstance);
                return vueInstance.mount(container);
            }
        }
    ]);
    return ModalProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _modalAu57IFsUJs.s));
        (0, _pluginsC7548X21Js.r)(Vue, "modal", new ModalProgrammatic(Vue));
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./classCallCheck-E4khD9xn.js":"fYU5v","vue":"dylud","./Modal-au57IFsU.js":"7FChN","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./trapFocus-IMs77O3T.js":"jBg9U","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l9jMV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BNotification", ()=>script$1);
parcelHelpers.export(exports, "NotificationProgrammatic", ()=>NotificationProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _vue = require("vue");
var _progress7Ux1HulHJs = require("./Progress-7Ux1HulH.js");
var _messageMixinKdZp92IJs = require("./MessageMixin-KdZp92I_.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _noticeMixin6CQVv2Js = require("./NoticeMixin-6c_QVv-2.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var script$1 = {
    name: "BNotification",
    components: {
        // directly registers Progress
        // in case Notification is programmatically opened
        [(0, _progress7Ux1HulHJs.s).name]: (0, _progress7Ux1HulHJs.s)
    },
    mixins: [
        (0, _messageMixinKdZp92IJs.M)
    ],
    props: {
        position: String,
        ariaCloseLabel: String,
        animation: {
            type: String,
            default: "fade"
        }
    }
};
const _hoisted_1 = [
    "aria-label"
];
const _hoisted_2 = {
    key: 1,
    class: "media"
};
const _hoisted_3 = {
    key: 0,
    class: "media-left"
};
const _hoisted_4 = {
    class: "media-content"
};
const _hoisted_5 = [
    "innerHTML"
];
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_progress = (0, _vue.resolveComponent)("b-progress");
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        name: $props.animation,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("article", {
                    class: (0, _vue.normalizeClass)([
                        "notification",
                        [
                            _ctx.type,
                            $props.position
                        ]
                    ]),
                    onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.click && _ctx.click(...args))
                }, [
                    _ctx.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                        key: 0,
                        class: "delete",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args)),
                        "aria-label": $props.ariaCloseLabel
                    }, null, 8 /* PROPS */ , _hoisted_1)) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.$slots.default || _ctx.message ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2, [
                        _ctx.computedIcon && _ctx.hasIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_3, [
                            (0, _vue.createVNode)(_component_b_icon, {
                                icon: _ctx.computedIcon,
                                pack: _ctx.iconPack,
                                size: _ctx.newIconSize,
                                both: "",
                                "aria-hidden": ""
                            }, null, 8 /* PROPS */ , [
                                "icon",
                                "pack",
                                "size"
                            ])
                        ])) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.createElementVNode)("div", _hoisted_4, [
                            _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                key: 0
                            }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                key: 1
                            }, [
                                (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                                (0, _vue.createElementVNode)("p", {
                                    class: "text",
                                    innerHTML: _ctx.message
                                }, null, 8 /* PROPS */ , _hoisted_5)
                            ], 64 /* STABLE_FRAGMENT */ ))
                        ])
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    _ctx.progressBar ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_progress, {
                        key: 2,
                        class: "auto-close-progress",
                        value: _ctx.remainingTime - 1,
                        max: _ctx.duration / 1000 - 1,
                        type: _ctx.type,
                        rounded: false
                    }, null, 8 /* PROPS */ , [
                        "value",
                        "max",
                        "type"
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ], 2 /* CLASS */ ), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "name"
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/notification/Notification.vue";
function ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys$1(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// drops props not used by `NoticeMixin` itself
// - type
// - message
// - duration
var _NoticeMixin$props = (0, _noticeMixin6CQVv2Js.N).props, queue = _NoticeMixin$props.queue, indefinite = _NoticeMixin$props.indefinite, pauseOnHover = _NoticeMixin$props.pauseOnHover, position = _NoticeMixin$props.position, container = _NoticeMixin$props.container;
var NoticeMixinSubset = _objectSpread$1(_objectSpread$1({}, (0, _noticeMixin6CQVv2Js.N)), {}, {
    props: {
        queue: queue,
        indefinite: indefinite,
        pauseOnHover: pauseOnHover,
        position: position,
        container: container
    }
});
var script = {
    name: "BNotificationNotice",
    components: {
        [script$1.name]: script$1
    },
    mixins: [
        NoticeMixinSubset
    ],
    props: {
        duration: Number
    },
    emits: [
        "close"
    ],
    data () {
        return {
            newDuration: this.duration || (0, _configNHWiBviwJs.c).defaultNotificationDuration
        };
    },
    methods: {
        close () {
            if (!this.isPaused) {
                clearTimeout(this.timer);
                this.$refs.notification.isActive = false;
                this.$emit("close");
                // Timeout for the animation complete before destroying
                setTimeout(()=>{
                    (0, _helpersO9H6ICOJs.r)(this.$el);
                }, 150);
            }
        }
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_notification = (0, _vue.resolveComponent)("b-notification");
    return _ctx.$slots.default != null ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_notification, (0, _vue.mergeProps)({
        key: 0,
        ref: "notification",
        position: _ctx.position,
        "model-value": _ctx.isActive
    }, _ctx.$attrs, {
        duration: $props.duration,
        onClick: _ctx.click,
        onClose: $options.close,
        onMouseenter: _ctx.pause,
        onMouseleave: _ctx.removePause
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3 /* FORWARDED */ 
    }, 16 /* FULL_PROPS */ , [
        "position",
        "model-value",
        "duration",
        "onClick",
        "onClose",
        "onMouseenter",
        "onMouseleave"
    ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_notification, (0, _vue.mergeProps)({
        key: 1,
        ref: "notification",
        position: _ctx.position,
        "model-value": _ctx.isActive
    }, _ctx.$attrs, {
        duration: $props.duration,
        onClick: _ctx.click,
        onClose: $options.close,
        onMouseenter: _ctx.pause,
        onMouseleave: _ctx.removePause
    }), null, 16 /* FULL_PROPS */ , [
        "position",
        "model-value",
        "duration",
        "onClick",
        "onClose",
        "onMouseenter",
        "onMouseleave"
    ]));
}
script.render = render;
script.__file = "src/components/notification/NotificationNotice.vue";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var NotificationProgrammatic = /*#__PURE__*/ function() {
    function NotificationProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, NotificationProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(NotificationProgrammatic, [
        {
            key: "open",
            value: function open(params) {
                if (typeof params === "string") params = {
                    message: params
                };
                var defaultParam = {
                    position: (0, _configNHWiBviwJs.c).defaultNotificationPosition || "is-top-right"
                };
                if (params.parent) delete params.parent;
                var _onClose;
                if (typeof params.onClose === "function") {
                    _onClose = params.onClose;
                    delete params.onClose;
                }
                var slot;
                if (Array.isArray(params.message)) {
                    slot = params.message;
                    delete params.message;
                }
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                var container = document.createElement("div");
                // Vue 3 requires a new app to mount another component
                var vueInstance = (0, _vue.createApp)({
                    data: function data() {
                        return {
                            noticeVNode: null
                        };
                    },
                    methods: {
                        close: function close() {
                            var notice = (0, _helpersO9H6ICOJs.z)(this.noticeVNode);
                            if (notice) notice.close();
                        }
                    },
                    render: function render() {
                        this.noticeVNode = (0, _vue.h)(script, _objectSpread(_objectSpread({}, propsData), {}, {
                            onClose: function onClose() {
                                if (_onClose != null) _onClose();
                                // waits for a while in favor of animation
                                setTimeout(function() {
                                    vueInstance.unmount();
                                }, 150);
                            }
                        }), slot != null ? {
                            "default": function _default() {
                                return slot;
                            }
                        } : undefined);
                        return this.noticeVNode;
                    }
                });
                if (this.app) (0, _helpersO9H6ICOJs.A)(this.app, vueInstance);
                else // workaround for an error that
                // $buefy.globalNoticeInterval is not defined
                vueInstance.use({
                    install: function install(Vue) {
                        Vue.config.globalProperties.$buefy = {
                            globalNoticeInterval: null
                        };
                    }
                });
                return vueInstance.mount(container);
            }
        }
    ]);
    return NotificationProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.r)(Vue, "notification", new NotificationProgrammatic(Vue));
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./classCallCheck-E4khD9xn.js":"fYU5v","vue":"dylud","./Progress-7Ux1HulH.js":"226jd","./MessageMixin-KdZp92I_.js":"braJY","./config-nHWiBviw.js":"4fneA","./NoticeMixin-6c_QVv-2.js":"73Jf4","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./Icon-fJqkx1gN.js":"gKXjn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"73Jf4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "N", ()=>NoticeMixin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var NoticeMixin = {
    props: {
        type: {
            type: String,
            "default": "is-dark"
        },
        message: [
            String,
            Array
        ],
        duration: Number,
        queue: {
            type: Boolean,
            "default": undefined
        },
        indefinite: {
            type: Boolean,
            "default": false
        },
        pauseOnHover: {
            type: Boolean,
            "default": false
        },
        position: {
            type: String,
            "default": "is-top",
            validator: function validator(value) {
                return [
                    "is-top-right",
                    "is-top",
                    "is-top-left",
                    "is-bottom-right",
                    "is-bottom",
                    "is-bottom-left"
                ].indexOf(value) > -1;
            }
        },
        container: String
    },
    emits: [
        "click",
        "close"
    ],
    data: function data() {
        return {
            isActive: false,
            isPaused: false,
            parentTop: null,
            parentBottom: null,
            newContainer: this.container || (0, _configNHWiBviwJs.c).defaultContainerElement
        };
    },
    computed: {
        correctParent: function correctParent() {
            switch(this.position){
                case "is-top-right":
                case "is-top":
                case "is-top-left":
                    return this.parentTop;
                case "is-bottom-right":
                case "is-bottom":
                case "is-bottom-left":
                    return this.parentBottom;
            }
        },
        transition: function transition() {
            switch(this.position){
                case "is-top-right":
                case "is-top":
                case "is-top-left":
                    return {
                        enter: "fadeInDown",
                        leave: "fadeOut"
                    };
                case "is-bottom-right":
                case "is-bottom":
                case "is-bottom-left":
                    return {
                        enter: "fadeInUp",
                        leave: "fadeOut"
                    };
            }
        }
    },
    methods: {
        pause: function pause() {
            if (this.pauseOnHover && !this.indefinite) {
                this.isPaused = true;
                clearInterval(this.$buefy.globalNoticeInterval);
            }
        },
        removePause: function removePause() {
            if (this.pauseOnHover && !this.indefinite) {
                this.isPaused = false;
                this.close();
            }
        },
        shouldQueue: function shouldQueue() {
            var queue = this.queue !== undefined ? this.queue : (0, _configNHWiBviwJs.c).defaultNoticeQueue;
            if (!queue) return false;
            return this.parentTop.childElementCount > 0 || this.parentBottom.childElementCount > 0;
        },
        click: function click() {
            this.$emit("click");
        },
        close: function close() {
            var _this = this;
            if (!this.isPaused) {
                clearTimeout(this.timer);
                this.isActive = false;
                this.$emit("close");
                // Timeout for the animation complete before destroying
                setTimeout(function() {
                    (0, _helpersO9H6ICOJs.r)(_this.$el);
                }, 150);
            }
        },
        timeoutCallback: function timeoutCallback() {
            return this.close();
        },
        showNotice: function showNotice() {
            var _this2 = this;
            if (this.shouldQueue()) this.correctParent.innerHTML = "";
            this.correctParent.insertAdjacentElement("afterbegin", this.$el);
            this.isActive = true;
            if (!this.indefinite) this.timer = setTimeout(function() {
                return _this2.timeoutCallback();
            }, this.newDuration);
        },
        setupContainer: function setupContainer() {
            this.parentTop = document.querySelector((this.newContainer ? this.newContainer : "body") + ">.notices.is-top");
            this.parentBottom = document.querySelector((this.newContainer ? this.newContainer : "body") + ">.notices.is-bottom");
            if (this.parentTop && this.parentBottom) return;
            if (!this.parentTop) {
                this.parentTop = document.createElement("div");
                this.parentTop.className = "notices is-top";
            }
            if (!this.parentBottom) {
                this.parentBottom = document.createElement("div");
                this.parentBottom.className = "notices is-bottom";
            }
            var container = document.querySelector(this.newContainer) || document.body;
            container.appendChild(this.parentTop);
            container.appendChild(this.parentBottom);
            if (this.newContainer) {
                this.parentTop.classList.add("has-custom-container");
                this.parentBottom.classList.add("has-custom-container");
            }
        }
    },
    beforeMount: function beforeMount() {
        this.setupContainer();
    },
    mounted: function mounted() {
        this.showNotice();
    }
};

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ls7RG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BNavbar", ()=>script$2);
parcelHelpers.export(exports, "BNavbarDropdown", ()=>script);
parcelHelpers.export(exports, "BNavbarItem", ()=>script$1);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _vue = require("vue");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var script$3 = {
    name: "NavbarBurger",
    props: {
        isOpened: {
            type: Boolean,
            default: false
        }
    }
};
const _hoisted_1 = [
    "aria-expanded"
];
const _hoisted_2 = /*#__PURE__*/ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1 /* HOISTED */ );
const _hoisted_3 = /*#__PURE__*/ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1 /* HOISTED */ );
const _hoisted_4 = /*#__PURE__*/ (0, _vue.createElementVNode)("span", {
    "aria-hidden": "true"
}, null, -1 /* HOISTED */ );
const _hoisted_5 = [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", (0, _vue.mergeProps)({
        role: "button",
        class: [
            "navbar-burger burger",
            {
                "is-active": $props.isOpened
            }
        ],
        "aria-label": "menu",
        "aria-expanded": $props.isOpened || undefined
    }, _ctx.$attrs, {
        tabindex: "0"
    }), [
        ..._hoisted_5
    ], 16 /* FULL_PROPS */ , _hoisted_1);
}
script$3.render = render$2;
script$3.__file = "src/components/navbar/NavbarBurger.vue";
var isTouch = typeof window !== "undefined" && ("ontouchstart" in window || navigator.msMaxTouchPoints > 0);
var events = isTouch ? [
    "touchstart",
    "click"
] : [
    "click"
];
var instances = [];
function processArgs(bindingValue) {
    var isFunction = typeof bindingValue === "function";
    if (!isFunction && (0, _typeofZ4RCTFCZJs._)(bindingValue) !== "object") throw new Error("v-click-outside: Binding value should be a function or an object, ".concat((0, _typeofZ4RCTFCZJs._)(bindingValue), " given"));
    return {
        handler: isFunction ? bindingValue : bindingValue.handler,
        middleware: bindingValue.middleware || function(isClickOutside) {
            return isClickOutside;
        },
        events: bindingValue.events || events
    };
}
function onEvent(_ref) {
    var el = _ref.el, event = _ref.event, handler = _ref.handler, middleware = _ref.middleware;
    var isClickOutside = event.target !== el && !el.contains(event.target);
    if (!isClickOutside || !middleware(event, el)) return;
    handler(event, el);
}
function toggleEventListeners() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, eventHandlers = _ref2.eventHandlers;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "add";
    eventHandlers.forEach(function(_ref3) {
        var event = _ref3.event, handler = _ref3.handler;
        document["".concat(action, "EventListener")](event, handler);
    });
}
function beforeMount(el, _ref4) {
    var value = _ref4.value;
    var _processArgs = processArgs(value), _handler = _processArgs.handler, middleware = _processArgs.middleware, events = _processArgs.events;
    var instance = {
        el: el,
        eventHandlers: events.map(function(eventName) {
            return {
                event: eventName,
                handler: function handler(event) {
                    return onEvent({
                        event: event,
                        el: el,
                        handler: _handler,
                        middleware: middleware
                    });
                }
            };
        })
    };
    toggleEventListeners(instance, "add");
    instances.push(instance);
}
function updated(el, _ref5) {
    var value = _ref5.value;
    var _processArgs2 = processArgs(value), _handler2 = _processArgs2.handler, middleware = _processArgs2.middleware, events = _processArgs2.events;
    // `filter` instead of `find` for compat with IE
    var instance = instances.filter(function(instance) {
        return instance.el === el;
    })[0];
    toggleEventListeners(instance, "remove");
    instance.eventHandlers = events.map(function(eventName) {
        return {
            event: eventName,
            handler: function handler(event) {
                return onEvent({
                    event: event,
                    el: el,
                    handler: _handler2,
                    middleware: middleware
                });
            }
        };
    });
    toggleEventListeners(instance, "add");
}
function unmounted(el) {
    // `filter` instead of `find` for compat with IE
    var instance = instances.filter(function(instance) {
        return instance.el === el;
    })[0];
    toggleEventListeners(instance, "remove");
}
var directive = {
    beforeMount: beforeMount,
    updated: updated,
    unmounted: unmounted,
    instances: instances
};
var clickOutside = directive;
const FIXED_TOP_CLASS = "is-fixed-top";
const BODY_FIXED_TOP_CLASS = "has-navbar-fixed-top";
const BODY_SPACED_FIXED_TOP_CLASS = "has-spaced-navbar-fixed-top";
const FIXED_BOTTOM_CLASS = "is-fixed-bottom";
const BODY_FIXED_BOTTOM_CLASS = "has-navbar-fixed-bottom";
const BODY_SPACED_FIXED_BOTTOM_CLASS = "has-spaced-navbar-fixed-bottom";
const BODY_CENTERED_CLASS = "has-navbar-centered";
const isFilled = (str)=>!!str;
var script$2 = {
    name: "BNavbar",
    components: {
        NavbarBurger: script$3
    },
    directives: {
        clickOutside
    },
    props: {
        type: [
            String,
            Object
        ],
        transparent: {
            type: Boolean,
            default: false
        },
        fixedTop: {
            type: Boolean,
            default: false
        },
        fixedBottom: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Boolean,
            default: false
        },
        centered: {
            type: Boolean,
            default: false
        },
        wrapperClass: {
            type: [
                String,
                Array,
                Object
            ]
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        mobileBurger: {
            type: Boolean,
            default: true
        },
        spaced: Boolean,
        shadow: Boolean
    },
    emits: [
        "update:modelValue"
    ],
    data () {
        return {
            internalIsActive: this.modelValue,
            _isNavBar: true // Used internally by NavbarItem
        };
    },
    computed: {
        isOpened () {
            return this.internalIsActive;
        },
        computedClasses () {
            return [
                this.type,
                {
                    [FIXED_TOP_CLASS]: this.fixedTop,
                    [FIXED_BOTTOM_CLASS]: this.fixedBottom,
                    [BODY_CENTERED_CLASS]: this.centered,
                    "is-spaced": this.spaced,
                    "has-shadow": this.shadow,
                    "is-transparent": this.transparent
                }
            ];
        }
    },
    watch: {
        modelValue: {
            handler (active) {
                this.internalIsActive = active;
            },
            immediate: true
        },
        fixedTop (isSet) {
            // toggle body class only on update to handle multiple navbar
            this.setBodyFixedTopClass(isSet);
        },
        bottomTop (isSet) {
            // toggle body class only on update to handle multiple navbar
            this.setBodyFixedBottomClass(isSet);
        }
    },
    methods: {
        toggleActive () {
            this.internalIsActive = !this.internalIsActive;
            this.emitUpdateParentEvent();
        },
        closeMenu () {
            if (this.closeOnClick && this.internalIsActive) {
                this.internalIsActive = false;
                this.emitUpdateParentEvent();
            }
        },
        emitUpdateParentEvent () {
            this.$emit("update:modelValue", this.internalIsActive);
        },
        setBodyClass (className) {
            if (typeof window !== "undefined") document.body.classList.add(className);
        },
        removeBodyClass (className) {
            if (typeof window !== "undefined") document.body.classList.remove(className);
        },
        checkIfFixedPropertiesAreColliding () {
            const areColliding = this.fixedTop && this.fixedBottom;
            if (areColliding) throw new Error("You should choose if the BNavbar is fixed bottom or fixed top, but not both");
        },
        genNavbar () {
            const navBarSlots = [
                this.genNavbarBrandNode(),
                this.genNavbarSlotsNode()
            ];
            if (!isFilled(this.wrapperClass)) return this.genNavbarSlots(navBarSlots);
            // It wraps the slots into a div with the provided wrapperClass prop
            const navWrapper = (0, _vue.h)("div", {
                class: this.wrapperClass
            }, navBarSlots);
            return this.genNavbarSlots([
                navWrapper
            ]);
        },
        genNavbarSlots (slots) {
            const vnode = (0, _vue.h)("nav", {
                class: [
                    "navbar",
                    this.computedClasses
                ],
                role: "navigation",
                "aria-label": "main navigation"
            }, slots);
            return (0, _vue.withDirectives)(vnode, [
                [
                    (0, _vue.resolveDirective)("click-outside"),
                    this.closeMenu
                ]
            ]);
        },
        genNavbarBrandNode () {
            const children = this.$slots.brand != null ? [
                this.$slots.brand(),
                this.genBurgerNode()
            ] : this.genBurgerNode();
            return (0, _vue.h)("div", {
                class: "navbar-brand"
            }, children);
        },
        genBurgerNode () {
            if (this.mobileBurger) {
                const defaultBurgerNode = (0, _vue.h)((0, _vue.resolveComponent)("navbar-burger"), {
                    isOpened: this.isOpened,
                    onClick: this.toggleActive,
                    onKeyup: (event)=>{
                        if (event.keyCode !== 13) return;
                        this.toggleActive();
                    }
                });
                const hasBurgerSlot = !!this.$slots.burger;
                return hasBurgerSlot ? this.$slots.burger({
                    isOpened: this.isOpened,
                    toggleActive: this.toggleActive
                }) : defaultBurgerNode;
            }
        },
        genNavbarSlotsNode () {
            return (0, _vue.h)("div", {
                class: [
                    "navbar-menu",
                    {
                        "is-active": this.isOpened
                    }
                ]
            }, [
                this.genMenuPosition("start"),
                this.genMenuPosition("end")
            ]);
        },
        genMenuPosition (positionName) {
            return (0, _vue.h)("div", {
                class: `navbar-${positionName}`
            }, this.$slots[positionName] != null ? this.$slots[positionName]() : []);
        },
        setBodyFixedTopClass (isSet) {
            this.checkIfFixedPropertiesAreColliding();
            if (isSet) {
                // TODO Apply only one of the classes once PR is merged in Bulma:
                // https://github.com/jgthms/bulma/pull/2737
                this.setBodyClass(BODY_FIXED_TOP_CLASS);
                this.spaced && this.setBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
            } else {
                this.removeBodyClass(BODY_FIXED_TOP_CLASS);
                this.removeBodyClass(BODY_SPACED_FIXED_TOP_CLASS);
            }
        },
        setBodyFixedBottomClass (isSet) {
            this.checkIfFixedPropertiesAreColliding();
            if (isSet) {
                // TODO Apply only one of the classes once PR is merged in Bulma:
                // https://github.com/jgthms/bulma/pull/2737
                this.setBodyClass(BODY_FIXED_BOTTOM_CLASS);
                this.spaced && this.setBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
            } else {
                this.removeBodyClass(BODY_FIXED_BOTTOM_CLASS);
                this.removeBodyClass(BODY_SPACED_FIXED_BOTTOM_CLASS);
            }
        }
    },
    beforeMount () {
        this.fixedTop && this.setBodyFixedTopClass(true);
        this.fixedBottom && this.setBodyFixedBottomClass(true);
    },
    beforeUnmount () {
        if (this.fixedTop) {
            const className = this.spaced ? BODY_SPACED_FIXED_TOP_CLASS : BODY_FIXED_TOP_CLASS;
            this.removeBodyClass(className);
        } else if (this.fixedBottom) {
            const className = this.spaced ? BODY_SPACED_FIXED_BOTTOM_CLASS : BODY_FIXED_BOTTOM_CLASS;
            this.removeBodyClass(className);
        }
    },
    render () {
        return this.genNavbar();
    }
};
script$2.__file = "src/components/navbar/Navbar.vue";
const clickableWhiteList = [
    "div",
    "span",
    "input"
];
var script$1 = {
    name: "BNavbarItem",
    inheritAttrs: false,
    props: {
        tag: {
            type: String,
            default: "a"
        },
        active: Boolean
    },
    methods: {
        /**
         * Keypress event that is bound to the document
         */ keyPress ({ key }) {
            if (key === "Escape" || key === "Esc") this.closeMenuRecursive(this, [
                "NavBar"
            ]);
        },
        /**
         * Close parent if clicked outside.
         */ handleClickEvent (event) {
            const isOnWhiteList = clickableWhiteList.some((item)=>item === event.target.localName);
            if (!isOnWhiteList) {
                const parent = this.closeMenuRecursive(this, [
                    "NavbarDropdown",
                    "NavBar"
                ]);
                if (parent && parent.$data._isNavbarDropdown) this.closeMenuRecursive(parent, [
                    "NavBar"
                ]);
            }
        },
        /**
         * Close parent recursively
         */ closeMenuRecursive (current, targetComponents) {
            if (!current.$parent) return null;
            const foundItem = targetComponents.reduce((acc, item)=>{
                if (current.$parent.$data[`_is${item}`]) {
                    current.$parent.closeMenu();
                    return current.$parent;
                }
                return acc;
            }, null);
            return foundItem || this.closeMenuRecursive(current.$parent, targetComponents);
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            this.$el.addEventListener("click", this.handleClickEvent);
            document.addEventListener("keyup", this.keyPress);
        }
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            this.$el.removeEventListener("click", this.handleClickEvent);
            document.removeEventListener("keyup", this.keyPress);
        }
    }
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.tag), (0, _vue.mergeProps)({
        class: [
            "navbar-item",
            {
                "is-active": $props.active
            }
        ]
    }, _ctx.$attrs), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3 /* FORWARDED */ 
    }, 16 /* FULL_PROPS */ , [
        "class"
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/navbar/NavbarItem.vue";
var script = {
    name: "BNavbarDropdown",
    directives: {
        clickOutside
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C)
    ],
    props: {
        label: String,
        hoverable: Boolean,
        active: Boolean,
        right: Boolean,
        arrowless: Boolean,
        boxed: Boolean,
        closeOnClick: {
            type: Boolean,
            default: true
        },
        collapsible: Boolean,
        tag: {
            type: String,
            default: "a"
        }
    },
    emits: [
        "active-change"
    ],
    data () {
        return {
            newActive: this.active,
            isHoverable: this.hoverable,
            _isNavbarDropdown: true // Used internally by NavbarItem
        };
    },
    watch: {
        active (value) {
            this.newActive = value;
        },
        newActive (value) {
            this.$emit("active-change", value);
        }
    },
    methods: {
        toggleMenu () {
            this.newActive = !this.newActive;
        },
        showMenu () {
            this.newActive = true;
        },
        /**
        * See naming convetion of navbaritem
        */ closeMenu () {
            this.newActive = !this.closeOnClick;
            if (this.hoverable && this.closeOnClick) this.isHoverable = false;
        },
        checkHoverable () {
            if (this.hoverable) this.isHoverable = true;
        }
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _directive_click_outside = (0, _vue.resolveDirective)("click-outside");
    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "navbar-item has-dropdown",
            {
                "is-hoverable": $data.isHoverable,
                "is-active": $data.newActive
            }
        ],
        onMouseenter: _cache[0] || (_cache[0] = (...args)=>$options.checkHoverable && $options.checkHoverable(...args))
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.tag), (0, _vue.mergeProps)({
            class: [
                "navbar-link",
                {
                    "is-arrowless": $props.arrowless,
                    "is-active": $data.newActive && $props.collapsible
                }
            ]
        }, _ctx.fallthroughAttrs, {
            "aria-haspopup": "true",
            onClick: (0, _vue.withModifiers)($options.toggleMenu, [
                "prevent"
            ]),
            onKeyup: (0, _vue.withKeys)($options.toggleMenu, [
                "enter"
            ]),
            tabindex: "0"
        }), {
            default: (0, _vue.withCtx)(()=>[
                    $props.label ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 0
                    }, [
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.label), 1 /* TEXT */ )
                    ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.renderSlot)(_ctx.$slots, "label", {
                        key: 1
                    })
                ]),
            _: 3 /* FORWARDED */ 
        }, 16 /* FULL_PROPS */ , [
            "class",
            "onClick",
            "onKeyup"
        ])),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "navbar-dropdown",
                {
                    "is-right": $props.right,
                    "is-boxed": $props.boxed,
                    "is-hidden-touch": $props.collapsible && !$data.newActive
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2 /* CLASS */ )
    ], 16 /* FULL_PROPS */ )), [
        [
            _directive_click_outside,
            $options.closeMenu
        ]
    ]);
}
script.render = render;
script.__file = "src/components/navbar/NavbarDropdown.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$2);
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"vue":"dylud","./typeof-Z4rCTFCZ.js":"cvqjf","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fmTLo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BNumberinput", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BNumberinput",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    inject: {
        field: {
            from: "BField",
            default: false
        }
    },
    props: {
        modelValue: Number,
        min: {
            type: [
                Number,
                String
            ]
        },
        max: [
            Number,
            String
        ],
        step: [
            Number,
            String
        ],
        minStep: [
            Number,
            String
        ],
        exponential: [
            Boolean,
            Number
        ],
        disabled: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        editable: {
            type: Boolean,
            default: true
        },
        controls: {
            type: Boolean,
            default: true
        },
        controlsAlignment: {
            type: String,
            default: "center",
            validator: (value)=>{
                return [
                    "left",
                    "right",
                    "center"
                ].indexOf(value) >= 0;
            }
        },
        controlsRounded: {
            type: Boolean,
            default: false
        },
        controlsPosition: String,
        placeholder: [
            Number,
            String
        ],
        ariaMinusLabel: String,
        ariaPlusLabel: String,
        longPress: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        "blur",
        "focus",
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            newStep: this.step || 1,
            newMinStep: this.minStep,
            timesPressed: 1,
            _elementRef: "input"
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                // Parses the number, so that "0" => 0, and "invalid" => null
                let newValue = Number(value) === 0 ? 0 : Number(value) || null;
                if (value === "" || value === undefined || value === null) newValue = null;
                this.newValue = newValue;
                if (newValue === null) this.$emit("update:modelValue", newValue);
                else if (!isNaN(newValue) && newValue !== "-0") this.$emit("update:modelValue", Number(newValue));
                this.$nextTick(()=>{
                    if (this.$refs.input) this.$refs.input.checkHtml5Validity();
                });
            }
        },
        controlsLeft () {
            if (this.controls && this.controlsAlignment !== "right") return this.controlsAlignment === "left" ? [
                "minus",
                "plus"
            ] : [
                "minus"
            ];
            return [];
        },
        controlsRight () {
            if (this.controls && this.controlsAlignment !== "left") return this.controlsAlignment === "right" ? [
                "minus",
                "plus"
            ] : [
                "plus"
            ];
            return [];
        },
        fieldClasses () {
            return [
                {
                    "has-addons": this.controlsPosition === "compact"
                },
                {
                    "is-grouped": this.controlsPosition !== "compact"
                },
                {
                    "is-expanded": this.expanded
                }
            ];
        },
        buttonClasses () {
            return [
                this.type,
                this.size,
                {
                    "is-rounded": this.controlsRounded
                }
            ];
        },
        minNumber () {
            return typeof this.min === "string" ? parseFloat(this.min) : this.min;
        },
        maxNumber () {
            return typeof this.max === "string" ? parseFloat(this.max) : this.max;
        },
        stepNumber () {
            if (this.newStep === "any") return 1;
            return typeof this.newStep === "string" ? parseFloat(this.newStep) : this.newStep;
        },
        minStepNumber () {
            if (this.newStep === "any" && typeof this.newMinStep === "undefined") return "any";
            const step = typeof this.newMinStep !== "undefined" ? this.newMinStep : this.newStep;
            return typeof step === "string" ? parseFloat(step) : step;
        },
        disabledMin () {
            return this.computedValue - this.stepNumber < this.minNumber;
        },
        disabledMax () {
            return this.computedValue + this.stepNumber > this.maxNumber;
        },
        stepDecimals () {
            const step = this.minStepNumber.toString();
            const index = step.indexOf(".");
            if (index >= 0) return step.substring(index + 1).length;
            return 0;
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        /**
     * When v-model is changed:
     *   1. Set internal value.
     */ modelValue: {
            immediate: true,
            handler (value) {
                this.newValue = value;
            }
        },
        step (value) {
            this.newStep = value;
        },
        minStep (value) {
            this.newMinStep = value;
        }
    },
    methods: {
        isDisabled (control) {
            return this.disabled || (control === "plus" ? this.disabledMax : this.disabledMin);
        },
        decrement () {
            if (this.computedValue === null || typeof this.computedValue === "undefined") {
                if (this.maxNumber !== null && typeof this.maxNumber !== "undefined") {
                    this.computedValue = this.maxNumber;
                    return;
                }
                this.computedValue = 0;
            }
            if (typeof this.minNumber === "undefined" || this.computedValue - this.stepNumber >= this.minNumber) {
                const value = this.computedValue - this.stepNumber;
                this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
            }
        },
        increment () {
            if (this.computedValue === null || typeof this.computedValue === "undefined" || this.computedValue < this.minNumber) {
                if (this.minNumber !== null && typeof this.minNumber !== "undefined") {
                    this.computedValue = this.minNumber;
                    return;
                }
                this.computedValue = 0;
            }
            if (typeof this.maxNumber === "undefined" || this.computedValue + this.stepNumber <= this.maxNumber) {
                const value = this.computedValue + this.stepNumber;
                this.computedValue = parseFloat(value.toFixed(this.stepDecimals));
            }
        },
        onControlClick (event, inc) {
            // IE 11 -> filter click event
            if (event.detail !== 0 || event.type !== "click") return;
            if (inc) this.increment();
            else this.decrement();
        },
        longPressTick (inc) {
            if (inc) this.increment();
            else this.decrement();
            if (!this.longPress) return;
            this._$intervalRef = setTimeout(()=>{
                this.longPressTick(inc);
            }, this.exponential ? 250 / (this.exponential * this.timesPressed++) : 250);
        },
        onStartLongPress (event, inc) {
            if (event.button !== 0 && event.type !== "touchstart") return;
            clearTimeout(this._$intervalRef);
            this.longPressTick(inc);
        },
        onStopLongPress () {
            if (!this._$intervalRef) return;
            this.timesPressed = 1;
            clearTimeout(this._$intervalRef);
            this._$intervalRef = null;
        }
    },
    mounted () {
        // tells the field that it is wrapping a number input
        // if the field is the direct parent.
        if (this.field === this.$parent) this.$parent.wrapNumberinput({
            controlsPosition: this.controlsPosition,
            size: this.size
        });
    },
    beforeUnmount () {
        clearTimeout(this._$intervalRef);
    }
};
const _hoisted_1 = [
    "disabled",
    "aria-label",
    "onMousedown",
    "onTouchstart",
    "onClick"
];
const _hoisted_2 = [
    "disabled",
    "aria-label",
    "onMousedown",
    "onTouchstart",
    "onClick"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-numberinput field",
            $options.fieldClasses
        ]
    }, _ctx.rootAttrs), [
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.controlsLeft, (control)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
                key: control,
                class: (0, _vue.normalizeClass)([
                    "control",
                    control
                ]),
                onMouseup: _cache[0] || (_cache[0] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onMouseleave: _cache[1] || (_cache[1] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onTouchend: _cache[2] || (_cache[2] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onTouchcancel: _cache[3] || (_cache[3] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args))
            }, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "button",
                        $options.buttonClasses
                    ]),
                    disabled: $options.isDisabled(control) || undefined,
                    "aria-label": control === "plus" ? $props.ariaPlusLabel : $props.ariaMinusLabel,
                    onMousedown: ($event)=>!$options.isDisabled(control) && $options.onStartLongPress($event, control === "plus"),
                    onTouchstart: (0, _vue.withModifiers)(($event)=>!$options.isDisabled(control) && $options.onStartLongPress($event, control === "plus"), [
                        "prevent"
                    ]),
                    onClick: ($event)=>!$options.isDisabled(control) && $options.onControlClick($event, control === "plus")
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        both: "",
                        icon: control,
                        pack: _ctx.iconPack,
                        size: _ctx.iconSize
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack",
                        "size"
                    ])
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1)
            ], 34 /* CLASS, HYDRATE_EVENTS */ );
        }), 128 /* KEYED_FRAGMENT */ )),
        (0, _vue.createVNode)(_component_b_input, (0, _vue.mergeProps)({
            type: "number",
            ref: "input",
            modelValue: $options.computedValue,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$options.computedValue = $event)
        }, _ctx.fallthroughAttrs, {
            step: $options.minStepNumber,
            max: $props.max,
            min: $props.min,
            size: _ctx.size,
            disabled: $options.disabledOrUndefined,
            readonly: !$props.editable,
            loading: _ctx.loading,
            rounded: _ctx.rounded,
            icon: _ctx.icon,
            "icon-pack": _ctx.iconPack,
            autocomplete: _ctx.autocomplete,
            expanded: _ctx.expanded,
            placeholder: $props.placeholder,
            "use-html5-validation": _ctx.useHtml5Validation,
            onFocus: _cache[5] || (_cache[5] = ($event)=>_ctx.$emit("focus", $event)),
            onBlur: _cache[6] || (_cache[6] = ($event)=>_ctx.$emit("blur", $event))
        }), null, 16 /* FULL_PROPS */ , [
            "modelValue",
            "step",
            "max",
            "min",
            "size",
            "disabled",
            "readonly",
            "loading",
            "rounded",
            "icon",
            "icon-pack",
            "autocomplete",
            "expanded",
            "placeholder",
            "use-html5-validation"
        ]),
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.controlsRight, (control)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
                key: control,
                class: (0, _vue.normalizeClass)([
                    "control",
                    control
                ]),
                onMouseup: _cache[7] || (_cache[7] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onMouseleave: _cache[8] || (_cache[8] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onTouchend: _cache[9] || (_cache[9] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args)),
                onTouchcancel: _cache[10] || (_cache[10] = (...args)=>$options.onStopLongPress && $options.onStopLongPress(...args))
            }, [
                (0, _vue.createElementVNode)("button", {
                    type: "button",
                    class: (0, _vue.normalizeClass)([
                        "button",
                        $options.buttonClasses
                    ]),
                    disabled: $options.isDisabled(control) || undefined,
                    "aria-label": control === "plus" ? $props.ariaPlusLabel : $props.ariaMinusLabel,
                    onMousedown: ($event)=>!$options.isDisabled(control) && $options.onStartLongPress($event, control === "plus"),
                    onTouchstart: (0, _vue.withModifiers)(($event)=>!$options.isDisabled(control) && $options.onStartLongPress($event, control === "plus"), [
                        "prevent"
                    ]),
                    onClick: ($event)=>!$options.isDisabled(control) && $options.onControlClick($event, control === "plus")
                }, [
                    (0, _vue.createVNode)(_component_b_icon, {
                        both: "",
                        icon: control,
                        pack: _ctx.iconPack,
                        size: _ctx.iconSize
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack",
                        "size"
                    ])
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_2)
            ], 34 /* CLASS, HYDRATE_EVENTS */ );
        }), 128 /* KEYED_FRAGMENT */ ))
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/numberinput/Numberinput.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./Icon-fJqkx1gN.js":"gKXjn","./Input-0ivJhXUC.js":"jYQke","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"edaWG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BPagination", ()=>(0, _paginationFX3EMQVPJs.s));
parcelHelpers.export(exports, "BPaginationButton", ()=>(0, _paginationFX3EMQVPJs.a));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _paginationFX3EMQVPJs = require("./Pagination-FX3EMQVP.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _paginationFX3EMQVPJs.s));
        (0, _pluginsC7548X21Js.a)(Vue, (0, _paginationFX3EMQVPJs.a));
    }
};

},{"./Pagination-FX3EMQVP.js":"kMAX1","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","vue":"dylud","./Icon-fJqkx1gN.js":"gKXjn","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kMAX1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>script$1);
parcelHelpers.export(exports, "d", ()=>debounce);
parcelHelpers.export(exports, "s", ()=>script);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var script$1 = {
    name: "BPaginationButton",
    props: {
        page: {
            type: Object,
            required: true
        },
        tag: {
            type: String,
            default: "a",
            validator: (value)=>{
                return (0, _configNHWiBviwJs.c).defaultLinkTags.indexOf(value) >= 0;
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        href () {
            if (this.tag === "a") return "#";
            else return undefined;
        },
        isDisabled () {
            return this.disabled || this.page.disabled;
        },
        disabledOrUndefined () {
            return this.isDisabled || undefined;
        }
    }
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($props.tag), (0, _vue.mergeProps)({
        role: "button",
        href: $options.href,
        disabled: $options.disabledOrUndefined,
        class: [
            "pagination-link",
            {
                "is-current": $props.page.isCurrent,
                [$props.page.class]: true
            }
        ]
    }, _ctx.$attrs, {
        onClick: (0, _vue.withModifiers)($props.page.click, [
            "prevent"
        ]),
        "aria-label": $props.page["aria-label"],
        "aria-current": $props.page.isCurrent || undefined
    }), {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.page.number), 1 /* TEXT */ )
                    ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 16 /* FULL_PROPS */ , [
        "href",
        "disabled",
        "class",
        "onClick",
        "aria-label",
        "aria-current"
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/pagination/PaginationButton.vue";
function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this;
        var args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
var script = {
    name: "BPagination",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [script$1.name]: script$1
    },
    props: {
        total: [
            Number,
            String
        ],
        perPage: {
            type: [
                Number,
                String
            ],
            default: 20
        },
        modelValue: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        rangeBefore: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        rangeAfter: {
            type: [
                Number,
                String
            ],
            default: 1
        },
        size: String,
        simple: Boolean,
        rounded: Boolean,
        order: String,
        iconPack: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconNext;
            }
        },
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        pageInput: {
            type: Boolean,
            default: false
        },
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    data () {
        return {
            inputValue: this.modelValue
        };
    },
    emits: [
        "change",
        "update:modelValue"
    ],
    computed: {
        rootClasses () {
            return [
                this.order,
                this.size,
                this.pageInputPosition,
                {
                    "is-simple": this.simple,
                    "is-rounded": this.rounded,
                    "has-input": this.pageInput
                }
            ];
        },
        beforeCurrent () {
            return parseInt(this.rangeBefore);
        },
        afterCurrent () {
            return parseInt(this.rangeAfter);
        },
        /**
        * Total page size (count).
        */ pageCount () {
            return Math.ceil(this.total / this.perPage);
        },
        /**
        * First item of the page (count).
        */ firstItem () {
            const firstItem = this.modelValue * this.perPage - this.perPage + 1;
            return firstItem >= 0 ? firstItem : 0;
        },
        /**
        * Check if previous button is available.
        */ hasPrev () {
            return this.modelValue > 1;
        },
        /**
         * Check if first page button should be visible.
        */ hasFirst () {
            return this.modelValue >= 2 + this.beforeCurrent;
        },
        /**
        * Check if first ellipsis should be visible.
        */ hasFirstEllipsis () {
            return this.modelValue >= this.beforeCurrent + 4;
        },
        /**
        * Check if last page button should be visible.
        */ hasLast () {
            return this.modelValue <= this.pageCount - (1 + this.afterCurrent);
        },
        /**
        * Check if last ellipsis should be visible.
        */ hasLastEllipsis () {
            return this.modelValue < this.pageCount - (2 + this.afterCurrent);
        },
        /**
        * Check if next button is available.
        */ hasNext () {
            return this.modelValue < this.pageCount;
        },
        /**
        * Get near pages, 1 before and 1 after the current.
        * Also add the click event to the array.
        */ pagesInRange () {
            if (this.simple) return;
            let left = Math.max(1, this.modelValue - this.beforeCurrent);
            if (left - 1 === 2) left--; // Do not show the ellipsis if there is only one to hide
            let right = Math.min(this.modelValue + this.afterCurrent, this.pageCount);
            if (this.pageCount - right === 2) right++; // Do not show the ellipsis if there is only one to hide
            const pages = [];
            for(let i = left; i <= right; i++)pages.push(this.getPage(i));
            return pages;
        }
    },
    watch: {
        /**
        * If current page is trying to be greater than page count, set to last.
        */ pageCount (value) {
            if (this.modelValue > value) this.last();
        },
        modelValue (value) {
            this.inputValue = value;
        },
        debouncePageInput: {
            handler (value) {
                this.debounceHandlePageInput = debounce(this.handleOnInputPageChange, value);
            },
            immediate: true
        }
    },
    methods: {
        /**
        * Previous button click listener.
        */ prev (event) {
            this.changePage(this.modelValue - 1, event);
        },
        /**
         * Next button click listener.
        */ next (event) {
            this.changePage(this.modelValue + 1, event);
        },
        /**
         * First button click listener.
        */ first (event) {
            this.changePage(1, event);
        },
        /**
        * Last button click listener.
        */ last (event) {
            this.changePage(this.pageCount, event);
        },
        changePage (num, event) {
            if (this.modelValue === num || num < 1 || num > this.pageCount) return;
            this.$emit("update:modelValue", num);
            this.$emit("change", num);
            // Set focus on element to keep tab order
            if (event && event.target) this.$nextTick(()=>event.target.focus());
        },
        getPage (num, options = {}) {
            return {
                number: num,
                isCurrent: this.modelValue === num,
                click: (event)=>this.changePage(num, event),
                input: (event, inputNum)=>this.changePage(+inputNum, event),
                disabled: options.disabled || false,
                class: options.class || "",
                "aria-label": options["aria-label"] || this.getAriaPageLabel(num, this.modelValue === num)
            };
        },
        /**
        * Get text for aria-label according to page number.
        */ getAriaPageLabel (pageNumber, isCurrent) {
            if (this.ariaPageLabel && (!isCurrent || !this.ariaCurrentLabel)) return this.ariaPageLabel + " " + pageNumber + ".";
            else if (this.ariaPageLabel && isCurrent && this.ariaCurrentLabel) return this.ariaCurrentLabel + ", " + this.ariaPageLabel + " " + pageNumber + ".";
            return null;
        },
        handleOnInputPageChange (event) {
            this.getPage(this.inputValue).input(event, this.inputValue);
        },
        handleOnInputDebounce (event) {
            if (this.debouncePageInput) this.debounceHandlePageInput(event);
            else this.handleOnInputPageChange(event);
        },
        handleOnKeyPress (event) {
            // --- This is required to only allow numeric inputs for the page input - --- //
            // --- size attribute does not work with input type number. --- //
            const ASCIICode = event.which || event.keyCode;
            if (ASCIICode >= 48 && ASCIICode <= 57) return true;
            else return event.preventDefault();
        },
        handleAllowableInputPageRange (event) {
            if (+event.target.value > 0 && +event.target.value <= this.pageCount) this.handleOnInputValue(event);
            else {
                // --- It is nessacery to set inputValue to 1 and then to '' so that the DOM- --- //
                // --- will update the input component even when Backspace is used and then-
                // --- 0 us entered. --- //
                this.inputValue = 1;
                this.inputValue = "";
            }
        },
        handleOnInputValue (event) {
            const inputValue = +event.target.value;
            this.inputValue = inputValue;
            if (Number.isInteger(this.inputValue)) this.handleOnInputDebounce(event);
            else // --- if NaN, then set inputValue back to current --- //
            this.inputValue = this.modelValue;
        }
    }
};
const _hoisted_1 = {
    class: "control pagination-input"
};
const _hoisted_2 = [
    "value",
    "size",
    "maxlength"
];
const _hoisted_3 = {
    key: 4,
    class: "info"
};
const _hoisted_4 = {
    key: 5,
    class: "pagination-list"
};
const _hoisted_5 = {
    key: 0
};
const _hoisted_6 = {
    key: 1
};
const _hoisted_7 = /*#__PURE__*/ (0, _vue.createElementVNode)("span", {
    class: "pagination-ellipsis"
}, "\u2026", -1 /* HOISTED */ );
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = {
    key: 2
};
const _hoisted_10 = /*#__PURE__*/ (0, _vue.createElementVNode)("span", {
    class: "pagination-ellipsis"
}, "\u2026", -1 /* HOISTED */ );
const _hoisted_11 = [
    _hoisted_10
];
const _hoisted_12 = {
    key: 3
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_BPaginationButton = (0, _vue.resolveComponent)("BPaginationButton");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", {
        class: (0, _vue.normalizeClass)([
            "pagination",
            $options.rootClasses
        ])
    }, [
        _ctx.$slots.previous ? (0, _vue.renderSlot)(_ctx.$slots, "previous", {
            key: 0,
            page: $options.getPage($props.modelValue - 1, {
                disabled: !$options.hasPrev,
                class: "pagination-previous",
                "aria-label": $props.ariaPreviousLabel
            })
        }, ()=>[
                (0, _vue.createVNode)(_component_b_icon, {
                    icon: $props.iconPrev,
                    pack: $props.iconPack,
                    both: "",
                    "aria-hidden": "true"
                }, null, 8 /* PROPS */ , [
                    "icon",
                    "pack"
                ])
            ]) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
            key: 1,
            class: "pagination-previous",
            disabled: !$options.hasPrev,
            page: $options.getPage($props.modelValue - 1),
            "aria-label": $props.ariaPreviousLabel
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: $props.iconPrev,
                        pack: $props.iconPack,
                        both: "",
                        "aria-hidden": "true"
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack"
                    ])
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "disabled",
            "page",
            "aria-label"
        ])),
        _ctx.$slots.next ? (0, _vue.renderSlot)(_ctx.$slots, "next", {
            key: 2,
            page: $options.getPage($props.modelValue + 1, {
                disabled: !$options.hasNext,
                class: "pagination-next",
                "aria-label": $props.ariaNextLabel
            })
        }, ()=>[
                (0, _vue.createVNode)(_component_b_icon, {
                    icon: $props.iconNext,
                    pack: $props.iconPack,
                    both: "",
                    "aria-hidden": "true"
                }, null, 8 /* PROPS */ , [
                    "icon",
                    "pack"
                ])
            ]) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
            key: 3,
            class: "pagination-next",
            disabled: !$options.hasNext,
            page: $options.getPage($props.modelValue + 1),
            "aria-label": $props.ariaNextLabel
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createVNode)(_component_b_icon, {
                        icon: $props.iconNext,
                        pack: $props.iconPack,
                        both: "",
                        "aria-hidden": "true"
                    }, null, 8 /* PROPS */ , [
                        "icon",
                        "pack"
                    ])
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "disabled",
            "page",
            "aria-label"
        ])),
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            $props.pageInput ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("input", {
                key: 0,
                class: "input",
                value: $data.inputValue,
                onInput: _cache[0] || (_cache[0] = (...args)=>$options.handleAllowableInputPageRange && $options.handleAllowableInputPageRange(...args)),
                onKeypress: _cache[1] || (_cache[1] = (...args)=>$options.handleOnKeyPress && $options.handleOnKeyPress(...args)),
                size: $options.pageCount.toString().length,
                maxlength: $options.pageCount.toString().length
            }, null, 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_2)) : (0, _vue.createCommentVNode)("v-if", true)
        ]),
        $props.simple ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_3, [
            $props.perPage == 1 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.firstItem) + " / " + (0, _vue.toDisplayString)($props.total), 1 /* TEXT */ )
            ], 64 /* STABLE_FRAGMENT */ )) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.firstItem) + "-" + (0, _vue.toDisplayString)(Math.min($props.modelValue * $props.perPage, $props.total)) + " / " + (0, _vue.toDisplayString)($props.total), 1 /* TEXT */ )
            ], 64 /* STABLE_FRAGMENT */ ))
        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("ul", _hoisted_4, [
            (0, _vue.createCommentVNode)("First"),
            $options.hasFirst ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_5, [
                _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                    key: 0,
                    page: $options.getPage(1)
                }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                    key: 1,
                    page: $options.getPage(1)
                }, null, 8 /* PROPS */ , [
                    "page"
                ]))
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            $options.hasFirstEllipsis ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_6, [
                ..._hoisted_8
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.createCommentVNode)("Pages"),
            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.pagesInRange, (page)=>{
                return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                    key: page.number
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0,
                        page: page
                    }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                        key: 1,
                        page: page
                    }, null, 8 /* PROPS */ , [
                        "page"
                    ]))
                ]);
            }), 128 /* KEYED_FRAGMENT */ )),
            (0, _vue.createCommentVNode)("Last"),
            $options.hasLastEllipsis ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_9, [
                ..._hoisted_11
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            $options.hasLast ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", _hoisted_12, [
                _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                    key: 0,
                    page: $options.getPage($options.pageCount)
                }) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_BPaginationButton, {
                    key: 1,
                    page: $options.getPage($options.pageCount)
                }, null, 8 /* PROPS */ , [
                    "page"
                ]))
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ]))
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/pagination/Pagination.vue";

},{"./config-nHWiBviw.js":"4fneA","vue":"dylud","./Icon-fJqkx1gN.js":"gKXjn","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hNYrG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BProgress", ()=>(0, _progress7Ux1HulHJs.s));
parcelHelpers.export(exports, "BProgressBar", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _progress7Ux1HulHJs = require("./Progress-7Ux1HulH.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var script = {
    name: "BProgressBar",
    inject: {
        parent: {
            from: (0, _progress7Ux1HulHJs.P),
            default: undefined
        }
    },
    props: {
        type: {
            type: [
                String,
                Object
            ],
            default: undefined
        },
        value: {
            type: Number,
            default: undefined
        },
        showValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        newType () {
            return [
                this.parent.size,
                this.type || this.parent.type
            ];
        },
        newShowValue () {
            return this.showValue || this.parent.showValue;
        },
        newValue () {
            return this.parent.calculateValue(this.value);
        },
        barWidth () {
            return `${this.value * 100 / this.parent.max}%`;
        }
    }
};
const _hoisted_1 = [
    "aria-valuenow",
    "aria-valuemax"
];
const _hoisted_2 = {
    key: 0,
    class: "progress-value"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "progress-bar",
            $options.newType
        ]),
        role: "progressbar",
        "aria-valuenow": $props.value,
        "aria-valuemax": $options.parent.max,
        "aria-valuemin": "0",
        style: (0, _vue.normalizeStyle)({
            width: $options.barWidth
        })
    }, [
        $options.newShowValue ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", _hoisted_2, [
            (0, _vue.renderSlot)(_ctx.$slots, "default", {}, ()=>[
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.newValue), 1 /* TEXT */ )
                ])
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 14 /* CLASS, STYLE, PROPS */ , _hoisted_1);
}
script.render = render;
script.__file = "src/components/progress/ProgressBar.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _progress7Ux1HulHJs.s));
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./Progress-7Ux1HulH.js":"226jd","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9UItO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRadio", ()=>script$1);
parcelHelpers.export(exports, "BRadioButton", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _checkRadioMixinI9QgrPGQJs = require("./CheckRadioMixin-I9QgrPGQ.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var script$1 = {
    name: "BRadio",
    mixins: [
        (0, _checkRadioMixinI9QgrPGQJs.C)
    ]
};
const _hoisted_1$1 = [
    "disabled"
];
const _hoisted_2$1 = [
    "disabled",
    "required",
    "name",
    "value"
];
const _hoisted_3 = {
    class: "control-label"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "b-radio radio",
            [
                _ctx.size,
                {
                    "is-disabled": _ctx.disabled
                }
            ]
        ]),
        ref: "label",
        disabled: _ctx.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>_ctx.focus && _ctx.focus(...args)),
        onKeydown: _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
            "prevent"
        ]), [
            "enter"
        ]))
    }, [
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
            type: "radio",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            disabled: _ctx.disabledOrUndefined,
            required: _ctx.requiredOrUndefined,
            name: _ctx.name,
            value: _ctx.nativeValue
        }, null, 8 /* PROPS */ , _hoisted_2$1), [
            [
                (0, _vue.vModelRadio),
                _ctx.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                _ctx.type
            ])
        }, null, 2 /* CLASS */ ),
        (0, _vue.createElementVNode)("span", _hoisted_3, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])
    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1$1);
}
script$1.render = render$1;
script$1.__file = "src/components/radio/Radio.vue";
var script = {
    name: "BRadioButton",
    mixins: [
        (0, _checkRadioMixinI9QgrPGQJs.C)
    ],
    props: {
        type: {
            type: String,
            default: "is-primary"
        },
        expanded: Boolean
    },
    data () {
        return {
            isFocused: false
        };
    },
    computed: {
        isSelected () {
            return this.newValue === this.nativeValue;
        },
        labelClass () {
            return [
                this.isSelected ? this.type : null,
                this.size,
                {
                    "is-selected": this.isSelected,
                    "is-disabled": this.disabled,
                    "is-focused": this.isFocused
                }
            ];
        }
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = [
    "disabled",
    "required",
    "name",
    "value"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "control",
            {
                "is-expanded": $props.expanded
            }
        ])
    }, [
        (0, _vue.createElementVNode)("label", {
            class: (0, _vue.normalizeClass)([
                "b-radio radio button",
                $options.labelClass
            ]),
            ref: "label",
            disabled: _ctx.disabledOrUndefined,
            onClick: _cache[4] || (_cache[4] = (...args)=>_ctx.focus && _ctx.focus(...args)),
            onKeydown: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
                "prevent"
            ]), [
                "enter"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>_ctx.computedValue = $event),
                type: "radio",
                ref: "input",
                onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                    "stop"
                ])),
                disabled: _ctx.disabledOrUndefined,
                required: _ctx.requiredOrUndefined,
                name: _ctx.name,
                value: _ctx.nativeValue,
                onFocus: _cache[2] || (_cache[2] = ($event)=>$data.isFocused = true),
                onBlur: _cache[3] || (_cache[3] = ($event)=>$data.isFocused = false)
            }, null, 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_2), [
                [
                    (0, _vue.vModelRadio),
                    _ctx.computedValue
                ]
            ])
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/radio/RadioButton.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./CheckRadioMixin-I9QgrPGQ.js":"1U5Xe","vue":"dylud","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7L9eD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BRate", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BRate",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 5
        },
        icon: {
            type: String,
            default: "star"
        },
        iconPack: String,
        size: String,
        spaced: Boolean,
        rtl: Boolean,
        disabled: Boolean,
        showScore: Boolean,
        showText: Boolean,
        customText: String,
        texts: Array,
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultLocale;
            }
        }
    },
    emits: [
        "change",
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            hoverValue: 0
        };
    },
    computed: {
        halfStyle () {
            return `width:${this.valueDecimal}%`;
        },
        showMe () {
            let result = "";
            if (this.showScore) {
                result = this.disabled ? this.modelValue : this.newValue;
                if (result === 0) result = "";
                else result = new Intl.NumberFormat(this.locale).format(this.modelValue);
            } else if (this.showText) result = this.texts[Math.ceil(this.newValue) - 1];
            return result;
        },
        valueDecimal () {
            return this.modelValue * 100 - Math.floor(this.modelValue) * 100;
        }
    },
    watch: {
        // When v-model is changed set the new value.
        modelValue (value) {
            this.newValue = value;
        }
    },
    methods: {
        resetNewValue () {
            if (this.disabled) return;
            this.hoverValue = 0;
        },
        previewRate (index, event) {
            if (this.disabled) return;
            this.hoverValue = index;
            event.stopPropagation();
        },
        confirmValue (index) {
            if (this.disabled) return;
            this.newValue = index;
            this.$emit("change", this.newValue);
            this.$emit("update:modelValue", this.newValue);
        },
        checkHalf (index) {
            const showWhenDisabled = this.disabled && this.valueDecimal > 0 && index - 1 < this.modelValue && index > this.modelValue;
            return showWhenDisabled;
        },
        rateClass (index) {
            let output = "";
            const currentValue = this.hoverValue !== 0 ? this.hoverValue : this.newValue;
            if (index <= currentValue) output = "set-on";
            else if (this.disabled && Math.ceil(this.modelValue) === index) output = "set-half";
            return output;
        }
    }
};
const _hoisted_1 = [
    "onMousemove",
    "onClick"
];
const _hoisted_2 = {
    key: 0
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "rate",
            {
                "is-disabled": $props.disabled,
                "is-spaced": $props.spaced,
                "is-rtl": $props.rtl
            }
        ])
    }, [
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.max, (item, index)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                class: (0, _vue.normalizeClass)([
                    "rate-item",
                    $options.rateClass(item)
                ]),
                key: index,
                onMousemove: ($event)=>$options.previewRate(item, $event),
                onMouseleave: _cache[0] || (_cache[0] = (...args)=>$options.resetNewValue && $options.resetNewValue(...args)),
                onClick: (0, _vue.withModifiers)(($event)=>$options.confirmValue(item), [
                    "prevent"
                ])
            }, [
                (0, _vue.createVNode)(_component_b_icon, {
                    pack: $props.iconPack,
                    icon: $props.icon,
                    size: $props.size
                }, null, 8 /* PROPS */ , [
                    "pack",
                    "icon",
                    "size"
                ]),
                $options.checkHalf(item) ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                    key: 0,
                    class: "is-half",
                    pack: $props.iconPack,
                    icon: $props.icon,
                    size: $props.size,
                    style: (0, _vue.normalizeStyle)($options.halfStyle)
                }, null, 8 /* PROPS */ , [
                    "pack",
                    "icon",
                    "size",
                    "style"
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1);
        }), 128 /* KEYED_FRAGMENT */ )),
        $props.showText || $props.showScore || $props.customText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 0,
            class: (0, _vue.normalizeClass)([
                "rate-text",
                $props.size
            ])
        }, [
            (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)($options.showMe), 1 /* TEXT */ ),
            $props.customText && !$props.showText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2, (0, _vue.toDisplayString)($props.customText), 1 /* TEXT */ )) : (0, _vue.createCommentVNode)("v-if", true)
        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/rate/Rate.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dynuy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSelect", ()=>(0, _selectDYWGhZcJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _selectDYWGhZcJs.s));
    }
};

},{"./Select-DY-wGhZc.js":"hHgPZ","./plugins-C7548x21.js":"fuYWh","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gCNso":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSkeleton", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
const BSkeleton = (props)=>{
    if (!props.active) return;
    const items = [];
    const width = props.width;
    const height = props.height;
    for(let i = 0; i < props.count; i++)items.push((0, _vue.h)("div", {
        class: [
            "b-skeleton-item",
            {
                "is-rounded": props.rounded
            }
        ],
        key: i,
        style: {
            height: height === undefined ? null : isNaN(height) ? height : height + "px",
            width: width === undefined ? null : isNaN(width) ? width : width + "px",
            borderRadius: props.circle ? "50%" : null
        }
    }));
    return (0, _vue.h)("div", {
        class: [
            "b-skeleton",
            props.size,
            props.position,
            {
                "is-animated": props.animated
            }
        ]
    }, items);
};
BSkeleton.props = {
    active: {
        type: Boolean,
        default: true
    },
    animated: {
        type: Boolean,
        default: true
    },
    width: [
        Number,
        String
    ],
    height: [
        Number,
        String
    ],
    circle: Boolean,
    rounded: {
        type: Boolean,
        default: true
    },
    count: {
        type: Number,
        default: 1
    },
    position: {
        type: String,
        default: "",
        validator (value) {
            return [
                "",
                "is-centered",
                "is-right"
            ].indexOf(value) > -1;
        }
    },
    size: String
};
var script = BSkeleton;
script.__file = "src/components/skeleton/Skeleton.vue";
var Plugin = {
    install: function install(Vue) {
        // explicit `name` is needed to avoid name mangling of
        // Functional Component in production
        (0, _pluginsC7548X21Js.a)(Vue, script, "BSkeleton");
    }
};

},{"vue":"dylud","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jr71Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSidebar", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BSidebar",
    props: {
        modelValue: Boolean,
        type: [
            String,
            Object
        ],
        overlay: Boolean,
        position: {
            type: String,
            default: "fixed",
            validator: (value)=>{
                return [
                    "fixed",
                    "absolute",
                    "static"
                ].indexOf(value) >= 0;
            }
        },
        fullheight: Boolean,
        fullwidth: Boolean,
        right: Boolean,
        mobile: {
            type: String
        },
        reduce: Boolean,
        expandOnHover: Boolean,
        expandOnHoverFixed: Boolean,
        delay: {
            type: Number,
            default: ()=>(0, _configNHWiBviwJs.c).defaultSidebarDelay
        },
        canCancel: {
            type: [
                Array,
                Boolean
            ],
            default: ()=>[
                    "escape",
                    "outside"
                ]
        },
        onCancel: {
            type: Function,
            default: ()=>{}
        },
        scroll: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultModalScroll ? (0, _configNHWiBviwJs.c).defaultModalScroll : "clip";
            },
            validator: (value)=>{
                return [
                    "clip",
                    "keep"
                ].indexOf(value) >= 0;
            }
        }
    },
    emits: [
        "close",
        "update:modelValue"
    ],
    data () {
        return {
            isOpen: this.modelValue,
            isDelayOver: false,
            transitionName: null,
            animating: true,
            savedScrollTop: null,
            hasLeaved: false
        };
    },
    computed: {
        rootClasses () {
            return [
                this.type,
                {
                    "is-fixed": this.isFixed,
                    "is-static": this.isStatic,
                    "is-absolute": this.isAbsolute,
                    "is-fullheight": this.fullheight,
                    "is-fullwidth": this.fullwidth,
                    "is-right": this.right,
                    "is-mini": this.reduce && !this.isDelayOver,
                    "is-mini-expand": this.expandOnHover || this.isDelayOver,
                    "is-mini-expand-fixed": this.expandOnHover && this.expandOnHoverFixed || this.isDelayOver,
                    "is-mini-delayed": this.delay !== null,
                    "is-mini-mobile": this.mobile === "reduce",
                    "is-hidden-mobile": this.mobile === "hide",
                    "is-fullwidth-mobile": this.mobile === "fullwidth"
                }
            ];
        },
        cancelOptions () {
            return typeof this.canCancel === "boolean" ? this.canCancel ? [
                "escape",
                "outside"
            ] : [] : this.canCancel;
        },
        isStatic () {
            return this.position === "static";
        },
        isFixed () {
            return this.position === "fixed";
        },
        isAbsolute () {
            return this.position === "absolute";
        }
    },
    watch: {
        modelValue: {
            handler (value) {
                this.isOpen = value;
                if (this.overlay) this.handleScroll();
                const open = this.right ? !value : value;
                this.transitionName = !open ? "slide-prev" : "slide-next";
            },
            immediate: true
        }
    },
    methods: {
        /**
        * Keypress event that is bound to the document.
        */ keyPress ({ key }) {
            if (this.isFixed) {
                if (this.isOpen && (key === "Escape" || key === "Esc")) this.cancel("escape");
            }
        },
        /**
        * Close the Sidebar if canCancel and call the onCancel prop (function).
        */ cancel (method) {
            if (this.cancelOptions.indexOf(method) < 0) return;
            if (this.isStatic) return;
            this.onCancel.apply(null, arguments);
            this.close();
        },
        /**
        * Call the onCancel prop (function) and emit events
        */ close () {
            this.isOpen = false;
            this.$emit("close");
            this.$emit("update:modelValue", false);
        },
        /**
         * Close fixed sidebar if clicked outside.
         */ clickedOutside (event) {
            if (!this.isFixed || !this.isOpen || this.animating) return;
            if (!event.composedPath().includes(this.$refs.sidebarContent)) this.cancel("outside");
        },
        /**
        * Transition before-enter hook
        */ beforeEnter () {
            this.animating = true;
        },
        /**
        * Transition after-leave hook
        */ afterEnter () {
            this.animating = false;
        },
        handleScroll () {
            if (typeof window === "undefined") return;
            if (this.scroll === "clip") {
                if (this.modelValue) document.documentElement.classList.add("is-clipped");
                else document.documentElement.classList.remove("is-clipped");
                return;
            }
            this.savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
            if (this.modelValue) document.body.classList.add("is-noscroll");
            else document.body.classList.remove("is-noscroll");
            if (this.modelValue) {
                document.body.style.top = `-${this.savedScrollTop}px`;
                return;
            }
            document.documentElement.scrollTop = this.savedScrollTop;
            document.body.style.top = null;
            this.savedScrollTop = null;
        },
        onHover () {
            if (this.delay) {
                this.hasLeaved = false;
                this.timer = setTimeout(()=>{
                    if (!this.hasLeaved) this.isDelayOver = true;
                    this.timer = null;
                }, this.delay);
            } else this.isDelayOver = false;
        },
        onHoverLeave () {
            this.hasLeaved = true;
            this.timer = null;
            this.isDelayOver = false;
        },
        /**
         * Close sidebar if close button is clicked.
         */ clickedCloseButton () {
            if (this.isFixed) {
                if (this.isOpen && this.fullwidth) this.cancel("outside");
            }
        }
    },
    created () {
        if (typeof window !== "undefined") {
            document.addEventListener("keyup", this.keyPress);
            document.addEventListener("click", this.clickedOutside);
        }
    },
    mounted () {
        if (typeof window !== "undefined") {
            if (this.isFixed) document.body.appendChild(this.$el);
        }
        if (this.overlay && this.modelValue) this.handleScroll();
    },
    beforeUnmount () {
        if (typeof window !== "undefined") {
            document.removeEventListener("keyup", this.keyPress);
            document.removeEventListener("click", this.clickedOutside);
            if (this.overlay) {
                // reset scroll
                document.documentElement.classList.remove("is-clipped");
                const savedScrollTop = !this.savedScrollTop ? document.documentElement.scrollTop : this.savedScrollTop;
                document.body.classList.remove("is-noscroll");
                document.documentElement.scrollTop = savedScrollTop;
                document.body.style.top = null;
            }
        }
        if (this.isFixed) (0, _helpersO9H6ICOJs.r)(this.$el);
        clearTimeout(this.timer);
    }
};
const _hoisted_1 = {
    class: "b-sidebar"
};
const _hoisted_2 = {
    key: 0,
    class: "sidebar-background"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $props.overlay && $data.isOpen ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_2)) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createVNode)((0, _vue.Transition), {
            name: $data.transitionName,
            onBeforeEnter: $options.beforeEnter,
            onAfterEnter: $options.afterEnter,
            persisted: ""
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                        ref: "sidebarContent",
                        class: (0, _vue.normalizeClass)([
                            "sidebar-content",
                            $options.rootClasses
                        ]),
                        onMouseenter: _cache[1] || (_cache[1] = (...args)=>$options.onHover && $options.onHover(...args)),
                        onMouseleave: _cache[2] || (_cache[2] = (...args)=>$options.onHoverLeave && $options.onHoverLeave(...args))
                    }, [
                        $props.fullwidth ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            key: 0,
                            type: "button",
                            onClick: _cache[0] || (_cache[0] = (...args)=>$options.clickedCloseButton && $options.clickedCloseButton(...args)),
                            class: "modal-close is-large sidebar-close",
                            "aria-label": "Close"
                        })) : (0, _vue.createCommentVNode)("v-if", true),
                        (0, _vue.renderSlot)(_ctx.$slots, "default")
                    ], 34 /* CLASS, HYDRATE_EVENTS */ ), [
                        [
                            (0, _vue.vShow),
                            $data.isOpen
                        ]
                    ])
                ]),
            _: 3 /* FORWARDED */ 
        }, 8 /* PROPS */ , [
            "name",
            "onBeforeEnter",
            "onAfterEnter"
        ])
    ]);
}
script.render = render;
script.__file = "src/components/sidebar/Sidebar.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"eoFzC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSlider", ()=>script);
parcelHelpers.export(exports, "BSliderTick", ()=>script$1);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _tooltipWHq2LJasJs = require("./Tooltip-WHq2LJas.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _vue = require("vue");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script$2 = {
    name: "BSliderThumb",
    components: {
        [(0, _tooltipWHq2LJasJs.s).name]: (0, _tooltipWHq2LJasJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C)
    ],
    props: {
        modelValue: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: ""
        },
        tooltip: {
            type: Boolean,
            default: true
        },
        indicator: {
            type: Boolean,
            default: false
        },
        customFormatter: Function,
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return [
                    "raw",
                    "percent"
                ].indexOf(value) >= 0;
            }
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultLocale;
            }
        },
        tooltipAlways: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "dragend",
        "dragstart",
        "update:modelValue"
    ],
    data () {
        return {
            isFocused: false,
            dragging: false,
            startX: 0,
            startPosition: 0,
            newPosition: null,
            oldValue: this.modelValue
        };
    },
    computed: {
        disabled () {
            return this.$parent.disabled;
        },
        max () {
            return this.$parent.max;
        },
        min () {
            return this.$parent.min;
        },
        step () {
            return this.$parent.step;
        },
        precision () {
            return this.$parent.precision;
        },
        currentPosition () {
            return `${(this.modelValue - this.min) / (this.max - this.min) * 100}%`;
        },
        wrapperStyle () {
            return {
                left: this.currentPosition
            };
        },
        formattedValue () {
            if (typeof this.customFormatter !== "undefined") return this.customFormatter(this.modelValue);
            if (this.format === "percent") return new Intl.NumberFormat(this.locale, {
                style: "percent"
            }).format((this.modelValue - this.min) / (this.max - this.min));
            return new Intl.NumberFormat(this.locale).format(this.modelValue);
        }
    },
    methods: {
        onFocus () {
            this.isFocused = true;
        },
        onBlur () {
            this.isFocused = false;
        },
        onButtonDown (event) {
            if (this.disabled) return;
            event.preventDefault();
            this.onDragStart(event);
            if (typeof window !== "undefined") {
                document.addEventListener("mousemove", this.onDragging);
                document.addEventListener("touchmove", this.onDragging);
                document.addEventListener("mouseup", this.onDragEnd);
                document.addEventListener("touchend", this.onDragEnd);
                document.addEventListener("contextmenu", this.onDragEnd);
            }
        },
        onLeftKeyDown () {
            if (this.disabled || this.modelValue === this.min) return;
            this.newPosition = parseFloat(this.currentPosition) - this.step / (this.max - this.min) * 100;
            this.setPosition(this.newPosition);
            this.$parent.emitValue("change");
        },
        onRightKeyDown () {
            if (this.disabled || this.modelValue === this.max) return;
            this.newPosition = parseFloat(this.currentPosition) + this.step / (this.max - this.min) * 100;
            this.setPosition(this.newPosition);
            this.$parent.emitValue("change");
        },
        onHomeKeyDown () {
            if (this.disabled || this.modelValue === this.min) return;
            this.newPosition = 0;
            this.setPosition(this.newPosition);
            this.$parent.emitValue("change");
        },
        onEndKeyDown () {
            if (this.disabled || this.modelValue === this.max) return;
            this.newPosition = 100;
            this.setPosition(this.newPosition);
            this.$parent.emitValue("change");
        },
        onDragStart (event) {
            this.dragging = true;
            this.$emit("dragstart");
            if (event.type === "touchstart") event.clientX = event.touches[0].clientX;
            this.startX = event.clientX;
            this.startPosition = parseFloat(this.currentPosition);
            this.newPosition = this.startPosition;
        },
        onDragging (event) {
            if (this.dragging) {
                if (event.type === "touchmove") event.clientX = event.touches[0].clientX;
                const diff = (event.clientX - this.startX) / this.$parent.sliderSize() * 100;
                this.newPosition = this.startPosition + diff;
                this.setPosition(this.newPosition);
            }
        },
        onDragEnd () {
            this.dragging = false;
            this.$emit("dragend");
            if (this.modelValue !== this.oldValue) this.$parent.emitValue("change");
            this.setPosition(this.newPosition);
            if (typeof window !== "undefined") {
                document.removeEventListener("mousemove", this.onDragging);
                document.removeEventListener("touchmove", this.onDragging);
                document.removeEventListener("mouseup", this.onDragEnd);
                document.removeEventListener("touchend", this.onDragEnd);
                document.removeEventListener("contextmenu", this.onDragEnd);
            }
        },
        setPosition (percent) {
            if (percent === null || isNaN(percent)) return;
            if (percent < 0) percent = 0;
            else if (percent > 100) percent = 100;
            const stepLength = 100 / ((this.max - this.min) / this.step);
            const steps = Math.round(percent / stepLength);
            let value = steps * stepLength / 100 * (this.max - this.min) + this.min;
            value = parseFloat(value.toFixed(this.precision));
            this.$emit("update:modelValue", value);
            if (!this.dragging && value !== this.oldValue) this.oldValue = value;
        }
    },
    beforeUnmount () {
        document.removeEventListener("mousemove", this.onDragging);
        document.removeEventListener("touchmove", this.onDragging);
        document.removeEventListener("mouseup", this.onDragEnd);
        document.removeEventListener("touchend", this.onDragEnd);
        document.removeEventListener("contextmenu", this.onDragEnd);
    }
};
const _hoisted_1$2 = [
    "tabindex"
];
const _hoisted_2 = {
    key: 0
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tooltip = (0, _vue.resolveComponent)("b-tooltip");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "b-slider-thumb-wrapper",
            {
                "is-dragging": $data.dragging,
                "has-indicator": $props.indicator
            }
        ],
        style: $options.wrapperStyle
    }, _ctx.rootAttrs), [
        (0, _vue.createVNode)(_component_b_tooltip, {
            label: $options.formattedValue,
            type: $props.type,
            always: $data.dragging || $data.isFocused || $props.tooltipAlways,
            active: !$options.disabled && $props.tooltip
        }, {
            default: (0, _vue.withCtx)(()=>[
                    (0, _vue.createElementVNode)("div", (0, _vue.mergeProps)({
                        class: "b-slider-thumb",
                        tabindex: $options.disabled ? false : 0
                    }, _ctx.fallthroughAttrs, {
                        onMousedown: _cache[0] || (_cache[0] = (...args)=>$options.onButtonDown && $options.onButtonDown(...args)),
                        onTouchstart: _cache[1] || (_cache[1] = (...args)=>$options.onButtonDown && $options.onButtonDown(...args)),
                        onFocus: _cache[2] || (_cache[2] = (...args)=>$options.onFocus && $options.onFocus(...args)),
                        onBlur: _cache[3] || (_cache[3] = (...args)=>$options.onBlur && $options.onBlur(...args)),
                        onKeydown: [
                            _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onLeftKeyDown && $options.onLeftKeyDown(...args), [
                                "prevent"
                            ]), [
                                "left"
                            ])),
                            _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onRightKeyDown && $options.onRightKeyDown(...args), [
                                "prevent"
                            ]), [
                                "right"
                            ])),
                            _cache[6] || (_cache[6] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onLeftKeyDown && $options.onLeftKeyDown(...args), [
                                "prevent"
                            ]), [
                                "down"
                            ])),
                            _cache[7] || (_cache[7] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onRightKeyDown && $options.onRightKeyDown(...args), [
                                "prevent"
                            ]), [
                                "up"
                            ])),
                            _cache[8] || (_cache[8] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onHomeKeyDown && $options.onHomeKeyDown(...args), [
                                "prevent"
                            ]), [
                                "home"
                            ])),
                            _cache[9] || (_cache[9] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.onEndKeyDown && $options.onEndKeyDown(...args), [
                                "prevent"
                            ]), [
                                "end"
                            ]))
                        ]
                    }), [
                        $props.indicator ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_2, (0, _vue.toDisplayString)($options.formattedValue), 1 /* TEXT */ )) : (0, _vue.createCommentVNode)("v-if", true)
                    ], 16 /* FULL_PROPS */ , _hoisted_1$2)
                ]),
            _: 1 /* STABLE */ 
        }, 8 /* PROPS */ , [
            "label",
            "type",
            "always",
            "active"
        ])
    ], 16 /* FULL_PROPS */ );
}
script$2.render = render$2;
script$2.__file = "src/components/slider/SliderThumb.vue";
var script$1 = {
    name: "BSliderTick",
    props: {
        value: {
            type: Number,
            default: 0
        }
    },
    computed: {
        position () {
            const pos = (this.value - this.$parent.min) / (this.$parent.max - this.$parent.min) * 100;
            return pos >= 0 && pos <= 100 ? pos : 0;
        },
        hidden () {
            return this.value === this.$parent.min || this.value === this.$parent.max;
        }
    },
    methods: {
        getTickStyle (position) {
            return {
                left: position + "%"
            };
        }
    },
    created () {
        if (!this.$parent.$data._isSlider) throw new Error("You should wrap bSliderTick on a bSlider");
    }
};
const _hoisted_1$1 = {
    key: 0,
    class: "b-slider-tick-label"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-slider-tick",
            {
                "is-tick-hidden": $options.hidden
            }
        ]),
        style: (0, _vue.normalizeStyle)($options.getTickStyle($options.position))
    }, [
        _ctx.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_1$1, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 6 /* CLASS, STYLE */ );
}
script$1.render = render$1;
script$1.__file = "src/components/slider/SliderTick.vue";
var script = {
    name: "BSlider",
    components: {
        [script$2.name]: script$2,
        [script$1.name]: script$1
    },
    props: {
        modelValue: {
            type: [
                Number,
                Array
            ],
            default: 0
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: 100
        },
        step: {
            type: Number,
            default: 1
        },
        type: {
            type: String,
            default: "is-primary"
        },
        size: String,
        ticks: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: Boolean,
            default: true
        },
        tooltipType: String,
        rounded: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: false
        },
        customFormatter: Function,
        ariaLabel: [
            String,
            Array
        ],
        biggerSliderFocus: {
            type: Boolean,
            default: false
        },
        indicator: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: "raw",
            validator: (value)=>{
                return [
                    "raw",
                    "percent"
                ].indexOf(value) >= 0;
            }
        },
        locale: {
            type: [
                String,
                Array
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultLocale;
            }
        },
        tooltipAlways: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "change",
        "dragend",
        "dragging",
        "dragstart",
        "update:modelValue"
    ],
    data () {
        return {
            value1: null,
            value2: null,
            // internal is used to update value1 and value2 with a single shot.
            // internal is also used to stop unnecessary propagation of update.
            internal: {
                value1: null,
                value2: null
            },
            dragging: false,
            isRange: false,
            _isSlider: true,
            timeOutID: null
        };
    },
    computed: {
        newTooltipType () {
            return this.tooltipType ? this.tooltipType : this.type;
        },
        tickValues () {
            if (!this.ticks || this.min > this.max || this.step === 0) return [];
            const result = [];
            for(let i = this.min + this.step; i < this.max; i = i + this.step)result.push(i);
            return result;
        },
        minValue () {
            return Math.min(this.value1, this.value2);
        },
        maxValue () {
            return Math.max(this.value1, this.value2);
        },
        barSize () {
            return this.isRange ? `${100 * (this.maxValue - this.minValue) / (this.max - this.min)}%` : `${100 * (this.value1 - this.min) / (this.max - this.min)}%`;
        },
        barStart () {
            return this.isRange ? `${100 * (this.minValue - this.min) / (this.max - this.min)}%` : "0%";
        },
        precision () {
            const precisions = [
                this.min,
                this.max,
                this.step
            ].map((item)=>{
                const decimal = ("" + item).split(".")[1];
                return decimal ? decimal.length : 0;
            });
            return Math.max(...precisions);
        },
        barStyle () {
            return {
                width: this.barSize,
                left: this.barStart
            };
        },
        rootClasses () {
            return {
                "is-rounded": this.rounded,
                "is-dragging": this.dragging,
                "is-disabled": this.disabled,
                "slider-focus": this.biggerSliderFocus
            };
        }
    },
    watch: {
        /**
        * When v-model is changed set the new active step.
        */ modelValue (value) {
            this.setValues(value);
        },
        internal ({ value1, value2 }) {
            this.value1 = value1;
            this.value2 = value2;
        },
        value1 (newValue) {
            if (this.internal.value1 !== newValue) this.onInternalValueUpdate();
        },
        value2 (newValue) {
            if (this.internal.value2 !== newValue) this.onInternalValueUpdate();
        },
        min () {
            this.setValues(this.modelValue);
        },
        max () {
            this.setValues(this.modelValue);
        }
    },
    methods: {
        setValues (newValue) {
            if (this.min > this.max) return;
            if (Array.isArray(newValue)) {
                this.isRange = true;
                const smallValue = typeof newValue[0] !== "number" || isNaN(newValue[0]) ? this.min : (0, _helpersO9H6ICOJs.b)(newValue[0], this.min, this.max);
                const largeValue = typeof newValue[1] !== "number" || isNaN(newValue[1]) ? this.max : (0, _helpersO9H6ICOJs.b)(newValue[1], this.min, this.max);
                // premature update will be triggered and end up with circular
                // update, if value1 and value2 are updated one by one
                this.internal = {
                    value1: this.isThumbReversed ? largeValue : smallValue,
                    value2: this.isThumbReversed ? smallValue : largeValue
                };
            } else {
                this.isRange = false;
                this.internal = {
                    value1: isNaN(newValue) ? this.min : (0, _helpersO9H6ICOJs.b)(newValue, this.min, this.max),
                    value2: null
                };
            }
        },
        onInternalValueUpdate () {
            if (this.isRange) this.isThumbReversed = this.value1 > this.value2;
            if (!this.lazy || !this.dragging) this.emitValue("update:modelValue");
            if (this.dragging) this.emitValue("dragging");
        },
        sliderSize () {
            return this.$refs.slider.getBoundingClientRect().width;
        },
        onSliderClick (event) {
            if (this.disabled || this.isTrackClickDisabled) return;
            const sliderOffsetLeft = this.$refs.slider.getBoundingClientRect().left;
            const percent = (event.clientX - sliderOffsetLeft) / this.sliderSize() * 100;
            const targetValue = this.min + percent * (this.max - this.min) / 100;
            const diffFirst = Math.abs(targetValue - this.value1);
            if (!this.isRange) {
                if (diffFirst < this.step / 2) return;
                this.$refs.button1.setPosition(percent);
            } else {
                const diffSecond = Math.abs(targetValue - this.value2);
                if (diffFirst <= diffSecond) {
                    if (diffFirst < this.step / 2) return;
                    this.$refs.button1.setPosition(percent);
                } else {
                    if (diffSecond < this.step / 2) return;
                    this.$refs.button2.setPosition(percent);
                }
            }
            this.emitValue("change");
        },
        onDragStart () {
            this.dragging = true;
            this.$emit("dragstart");
        },
        onDragEnd () {
            this.isTrackClickDisabled = true;
            this.timeOutID = setTimeout(()=>{
                // avoid triggering onSliderClick after dragend
                this.isTrackClickDisabled = false;
            }, 0);
            this.dragging = false;
            this.$emit("dragend");
            if (this.lazy) this.emitValue("update:modelValue");
        },
        emitValue (type) {
            this.$emit(type, this.isRange ? [
                this.minValue,
                this.maxValue
            ] : this.value1);
        }
    },
    created () {
        this.isThumbReversed = false;
        this.isTrackClickDisabled = false;
        this.setValues(this.modelValue);
    },
    beforeUnmount () {
        clearTimeout(this.timeOutID);
    }
};
const _hoisted_1 = {
    class: "b-slider-track",
    ref: "slider"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_slider_tick = (0, _vue.resolveComponent)("b-slider-tick");
    const _component_b_slider_thumb = (0, _vue.resolveComponent)("b-slider-thumb");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-slider",
            [
                $props.size,
                $props.type,
                $options.rootClasses
            ]
        ]),
        onClick: _cache[2] || (_cache[2] = (...args)=>$options.onSliderClick && $options.onSliderClick(...args))
    }, [
        (0, _vue.createElementVNode)("div", _hoisted_1, [
            (0, _vue.createElementVNode)("div", {
                class: "b-slider-fill",
                style: (0, _vue.normalizeStyle)($options.barStyle)
            }, null, 4 /* STYLE */ ),
            $props.ticks ? ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, (0, _vue.renderList)($options.tickValues, (val, key)=>{
                return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slider_tick, {
                    key: key,
                    value: val
                }, null, 8 /* PROPS */ , [
                    "value"
                ]);
            }), 128 /* KEYED_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.renderSlot)(_ctx.$slots, "default"),
            (0, _vue.createVNode)(_component_b_slider_thumb, {
                "tooltip-always": $props.tooltipAlways,
                modelValue: $data.value1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.value1 = $event),
                type: $options.newTooltipType,
                tooltip: $props.tooltip,
                "custom-formatter": $props.customFormatter,
                indicator: $props.indicator,
                format: $props.format,
                locale: $props.locale,
                ref: "button1",
                role: "slider",
                "aria-valuenow": $data.value1,
                "aria-valuemin": $props.min,
                "aria-valuemax": $props.max,
                "aria-orientation": "horizontal",
                "aria-label": Array.isArray($props.ariaLabel) ? $props.ariaLabel[0] : $props.ariaLabel,
                "aria-disabled": $props.disabled || undefined,
                onDragstart: $options.onDragStart,
                onDragend: $options.onDragEnd
            }, null, 8 /* PROPS */ , [
                "tooltip-always",
                "modelValue",
                "type",
                "tooltip",
                "custom-formatter",
                "indicator",
                "format",
                "locale",
                "aria-valuenow",
                "aria-valuemin",
                "aria-valuemax",
                "aria-label",
                "aria-disabled",
                "onDragstart",
                "onDragend"
            ]),
            $data.isRange ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slider_thumb, {
                key: 1,
                "tooltip-always": $props.tooltipAlways,
                modelValue: $data.value2,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.value2 = $event),
                type: $options.newTooltipType,
                tooltip: $props.tooltip,
                "custom-formatter": $props.customFormatter,
                indicator: $props.indicator,
                format: $props.format,
                locale: $props.locale,
                ref: "button2",
                role: "slider",
                "aria-valuenow": $data.value2,
                "aria-valuemin": $props.min,
                "aria-valuemax": $props.max,
                "aria-orientation": "horizontal",
                "aria-label": Array.isArray($props.ariaLabel) ? $props.ariaLabel[1] : "",
                "aria-disabled": $props.disabled || undefined,
                onDragstart: $options.onDragStart,
                onDragend: $options.onDragEnd
            }, null, 8 /* PROPS */ , [
                "tooltip-always",
                "modelValue",
                "type",
                "tooltip",
                "custom-formatter",
                "indicator",
                "format",
                "locale",
                "aria-valuenow",
                "aria-valuemin",
                "aria-valuemax",
                "aria-label",
                "aria-disabled",
                "onDragstart",
                "onDragend"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 512 /* NEED_PATCH */ )
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/slider/Slider.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
    }
};

},{"./Tooltip-WHq2LJas.js":"6mgq3","./config-nHWiBviw.js":"4fneA","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","vue":"dylud","./helpers-O9h6_ICO.js":"9IzVa","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"i9FSC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSnackbar", ()=>script);
parcelHelpers.export(exports, "SnackbarProgrammatic", ()=>SnackbarProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _vue = require("vue");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _noticeMixin6CQVv2Js = require("./NoticeMixin-6c_QVv-2.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BSnackbar",
    mixins: [
        (0, _noticeMixin6CQVv2Js.N)
    ],
    props: {
        actionText: {
            type: String,
            default: "OK"
        },
        onAction: {
            type: Function,
            default: ()=>{}
        },
        cancelText: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            newDuration: this.duration || (0, _configNHWiBviwJs.c).defaultSnackbarDuration
        };
    },
    methods: {
        /**
        * Click listener.
        * Call action prop before closing (from Mixin).
        */ action () {
            this.onAction();
            this.close();
        }
    }
};
const _hoisted_1 = [
    "role"
];
const _hoisted_2 = [
    "innerHTML"
];
const _hoisted_3 = {
    class: "button"
};
const _hoisted_4 = {
    class: "button"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        "enter-active-class": _ctx.transition.enter,
        "leave-active-class": _ctx.transition.leave,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                    class: (0, _vue.normalizeClass)([
                        "snackbar",
                        [
                            _ctx.type,
                            _ctx.position
                        ]
                    ]),
                    onMouseenter: _cache[2] || (_cache[2] = (...args)=>_ctx.pause && _ctx.pause(...args)),
                    onMouseleave: _cache[3] || (_cache[3] = (...args)=>_ctx.removePause && _ctx.removePause(...args)),
                    role: $props.actionText ? "alertdialog" : "alert"
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0
                    }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 1
                    }, [
                        (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                        (0, _vue.createElementVNode)("div", {
                            class: "text",
                            innerHTML: _ctx.message
                        }, null, 8 /* PROPS */ , _hoisted_2)
                    ], 64 /* STABLE_FRAGMENT */ )),
                    $props.cancelText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 2,
                        class: "action is-light is-cancel",
                        onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.close && _ctx.close(...args))
                    }, [
                        (0, _vue.createElementVNode)("button", _hoisted_3, (0, _vue.toDisplayString)($props.cancelText), 1 /* TEXT */ )
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    $props.actionText ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
                        key: 3,
                        class: (0, _vue.normalizeClass)([
                            "action",
                            _ctx.type
                        ]),
                        onClick: _cache[1] || (_cache[1] = (...args)=>$options.action && $options.action(...args))
                    }, [
                        (0, _vue.createElementVNode)("button", _hoisted_4, (0, _vue.toDisplayString)($props.actionText), 1 /* TEXT */ )
                    ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "enter-active-class",
        "leave-active-class"
    ]);
}
script.render = render;
script.__file = "src/components/snackbar/Snackbar.vue";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var SnackbarProgrammatic = /*#__PURE__*/ function() {
    function SnackbarProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, SnackbarProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(SnackbarProgrammatic, [
        {
            key: "open",
            value: function open(params) {
                if (typeof params === "string") params = {
                    message: params
                };
                var defaultParam = {
                    type: "is-success",
                    position: (0, _configNHWiBviwJs.c).defaultSnackbarPosition || "is-bottom-right",
                    queue: true
                };
                if (params.parent) delete params.parent;
                var slot;
                if (Array.isArray(params.message)) {
                    slot = params.message;
                    delete params.message;
                }
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                var container = document.createElement("div");
                // Vue 3 requires a new app to mount another component
                var vueInstance = (0, _vue.createApp)({
                    data: function data() {
                        return {
                            snackbarVNode: null
                        };
                    },
                    methods: {
                        close: function close() {
                            var snackbar = (0, _helpersO9H6ICOJs.z)(this.snackbarVNode);
                            if (snackbar) snackbar.close();
                        }
                    },
                    render: function render() {
                        this.snackbarVNode = (0, _vue.h)(script, _objectSpread(_objectSpread({}, propsData), {}, {
                            onClose: function onClose() {
                                if (typeof propsData.onClose === "function") propsData.onClose();
                                // timeout for the animation complete
                                // before unmounting
                                setTimeout(function() {
                                    vueInstance.unmount();
                                }, 150);
                            }
                        }), slot != null ? {
                            "default": function _default() {
                                return slot;
                            }
                        } : undefined);
                        return this.snackbarVNode;
                    }
                });
                if (this.app) (0, _helpersO9H6ICOJs.A)(this.app, vueInstance);
                else // adds $buefy global property so that
                // this.$buefy.globalNoticeInterval is available
                vueInstance.config.globalProperties.$buefy = {};
                return vueInstance.mount(container);
            }
        }
    ]);
    return SnackbarProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.r)(Vue, "snackbar", new SnackbarProgrammatic(Vue));
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./classCallCheck-E4khD9xn.js":"fYU5v","vue":"dylud","./config-nHWiBviw.js":"4fneA","./NoticeMixin-6c_QVv-2.js":"73Jf4","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"g741Z":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BStepItem", ()=>script);
parcelHelpers.export(exports, "BSteps", ()=>script$1);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _tabbedChildMixinFoL4CKMJs = require("./TabbedChildMixin-foL4cK-M.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _slotComponentBRURhcxzJs = require("./SlotComponent-bRURhcxz.js");
var _injectedChildMixin95VbgK7Js = require("./InjectedChildMixin-95-VbgK7.js");
var script$1 = {
    name: "BSteps",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    mixins: [
        (0, _tabbedChildMixinFoL4CKMJs.T)("step")
    ],
    props: {
        type: [
            String,
            Object
        ],
        iconPack: String,
        iconPrev: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconPrev;
            }
        },
        iconNext: {
            type: String,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultIconNext;
            }
        },
        hasNavigation: {
            type: Boolean,
            default: true
        },
        labelPosition: {
            type: String,
            validator (value) {
                return [
                    "bottom",
                    "right",
                    "left"
                ].indexOf(value) > -1;
            },
            default: "bottom"
        },
        rounded: {
            type: Boolean,
            default: true
        },
        mobileMode: {
            type: String,
            validator (value) {
                return [
                    "minimalist",
                    "compact"
                ].indexOf(value) > -1;
            },
            default: "minimalist"
        },
        ariaNextLabel: String,
        ariaPreviousLabel: String
    },
    computed: {
        // Override mixin implementation to always have a value
        activeItem () {
            return this.childItems.filter((i)=>i.uniqueValue === this.activeId)[0] || this.items[0];
        },
        wrapperClasses () {
            return [
                this.size,
                {
                    "is-vertical": this.vertical,
                    [this.position]: this.position && this.vertical
                }
            ];
        },
        mainClasses () {
            return [
                this.type,
                {
                    "has-label-right": this.labelPosition === "right",
                    "has-label-left": this.labelPosition === "left",
                    "is-animated": this.animated,
                    "is-rounded": this.rounded,
                    [`mobile-${this.mobileMode}`]: this.mobileMode !== null
                }
            ];
        },
        /**
         * Check if previous button is available.
         */ hasPrev () {
            return this.prevItemIdx !== null;
        },
        /**
         * Retrieves the next visible item index
         */ nextItemIdx () {
            const idx = this.activeItem ? this.activeItem.index : 0;
            return this.getNextItemIdx(idx);
        },
        /**
         * Retrieves the next visible item
         */ nextItem () {
            let nextItem = null;
            if (this.nextItemIdx !== null) nextItem = this.items.find((i)=>i.index === this.nextItemIdx);
            return nextItem;
        },
        /**
        * Retrieves the next visible item index
        */ prevItemIdx () {
            if (!this.activeItem) return null;
            const idx = this.activeItem.index;
            return this.getPrevItemIdx(idx);
        },
        /**
         * Retrieves the previous visible item
         */ prevItem () {
            if (!this.activeItem) return null;
            let prevItem = null;
            if (this.prevItemIdx !== null) prevItem = this.items.find((i)=>i.index === this.prevItemIdx);
            return prevItem;
        },
        /**
         * Check if next button is available.
         */ hasNext () {
            return this.nextItemIdx !== null;
        },
        navigationProps () {
            return {
                previous: {
                    disabled: !this.hasPrev,
                    action: this.prev
                },
                next: {
                    disabled: !this.hasNext,
                    action: this.next
                }
            };
        }
    },
    methods: {
        /**
         * Return if the step should be clickable or not.
         */ isItemClickable (stepItem) {
            if (stepItem.clickable === undefined) return stepItem.index < this.activeItem.index;
            return stepItem.clickable;
        },
        /**
         * Previous button click listener.
         */ prev () {
            if (this.hasPrev) this.activeId = this.prevItem.uniqueValue;
        },
        /**
         * Previous button click listener.
         */ next () {
            if (this.hasNext) this.activeId = this.nextItem.uniqueValue;
        }
    }
};
const _hoisted_1 = {
    class: "step-items"
};
const _hoisted_2 = [
    "onClick"
];
const _hoisted_3 = {
    class: "step-marker"
};
const _hoisted_4 = {
    key: 1
};
const _hoisted_5 = {
    class: "step-details"
};
const _hoisted_6 = {
    class: "step-title"
};
const _hoisted_7 = {
    key: 0,
    class: "step-navigation"
};
const _hoisted_8 = [
    "disabled",
    "aria-label"
];
const _hoisted_9 = [
    "disabled",
    "aria-label"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-steps",
            $options.wrapperClasses
        ])
    }, [
        (0, _vue.createElementVNode)("nav", {
            class: (0, _vue.normalizeClass)([
                "steps",
                $options.mainClasses
            ])
        }, [
            (0, _vue.createElementVNode)("ul", _hoisted_1, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.items, (childItem)=>{
                    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                        key: childItem.uniqueValue,
                        class: (0, _vue.normalizeClass)([
                            "step-item",
                            [
                                childItem.type || $props.type,
                                childItem.headerClass,
                                {
                                    "is-active": childItem.isActive,
                                    "is-previous": $options.activeItem.index > childItem.index
                                }
                            ]
                        ])
                    }, [
                        (0, _vue.createElementVNode)("a", {
                            class: (0, _vue.normalizeClass)([
                                "step-link",
                                {
                                    "is-clickable": $options.isItemClickable(childItem)
                                }
                            ]),
                            onClick: ($event)=>$options.isItemClickable(childItem) && _ctx.childClick(childItem)
                        }, [
                            (0, _vue.createElementVNode)("div", _hoisted_3, [
                                childItem.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                    key: 0,
                                    icon: childItem.icon,
                                    pack: childItem.iconPack,
                                    size: _ctx.size
                                }, null, 8 /* PROPS */ , [
                                    "icon",
                                    "pack",
                                    "size"
                                ])) : childItem.step ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_4, (0, _vue.toDisplayString)(childItem.step), 1 /* TEXT */ )) : (0, _vue.createCommentVNode)("v-if", true)
                            ]),
                            (0, _vue.createElementVNode)("div", _hoisted_5, [
                                (0, _vue.createElementVNode)("span", _hoisted_6, (0, _vue.toDisplayString)(childItem.label), 1 /* TEXT */ )
                            ])
                        ], 10 /* CLASS, PROPS */ , _hoisted_2)
                    ], 2 /* CLASS */ )), [
                        [
                            (0, _vue.vShow),
                            childItem.visible
                        ]
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ])
        ], 2 /* CLASS */ ),
        (0, _vue.createElementVNode)("section", {
            class: (0, _vue.normalizeClass)([
                "step-content",
                {
                    "is-transitioning": _ctx.isTransitioning
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2 /* CLASS */ ),
        (0, _vue.renderSlot)(_ctx.$slots, "navigation", {
            previous: $options.navigationProps.previous,
            next: $options.navigationProps.next
        }, ()=>[
                $props.hasNavigation ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("nav", _hoisted_7, [
                    (0, _vue.createElementVNode)("a", {
                        role: "button",
                        class: "pagination-previous",
                        disabled: $options.navigationProps.previous.disabled || undefined,
                        onClick: _cache[0] || (_cache[0] = (0, _vue.withModifiers)((...args)=>$options.navigationProps.previous.action && $options.navigationProps.previous.action(...args), [
                            "prevent"
                        ])),
                        "aria-label": $props.ariaPreviousLabel
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: $props.iconPrev,
                            pack: $props.iconPack,
                            both: "",
                            "aria-hidden": "true"
                        }, null, 8 /* PROPS */ , [
                            "icon",
                            "pack"
                        ])
                    ], 8 /* PROPS */ , _hoisted_8),
                    (0, _vue.createElementVNode)("a", {
                        role: "button",
                        class: "pagination-next",
                        disabled: $options.navigationProps.next.disabled || undefined,
                        onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)((...args)=>$options.navigationProps.next.action && $options.navigationProps.next.action(...args), [
                            "prevent"
                        ])),
                        "aria-label": $props.ariaNextLabel
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: $props.iconNext,
                            pack: $props.iconPack,
                            both: "",
                            "aria-hidden": "true"
                        }, null, 8 /* PROPS */ , [
                            "icon",
                            "pack"
                        ])
                    ], 8 /* PROPS */ , _hoisted_9)
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ])
    ], 2 /* CLASS */ );
}
script$1.render = render;
script$1.__file = "src/components/steps/Steps.vue";
var script = {
    name: "BStepItem",
    mixins: [
        (0, _tabbedChildMixinFoL4CKMJs.a)("step")
    ],
    props: {
        step: [
            String,
            Number
        ],
        type: [
            String,
            Object
        ],
        clickable: {
            type: Boolean,
            default: undefined
        }
    },
    data () {
        return {
            elementClass: "step-item"
        };
    }
};
script.__file = "src/components/steps/StepItem.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./Icon-fJqkx1gN.js":"gKXjn","./TabbedChildMixin-foL4cK-M.js":"jmgfx","./config-nHWiBviw.js":"4fneA","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","./SlotComponent-bRURhcxz.js":"2TjGq","./InjectedChildMixin-95-VbgK7.js":"3Zi8S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jmgfx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "T", ()=>TabbedMixin);
parcelHelpers.export(exports, "a", ()=>TabbedChildMixin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _slotComponentBRURhcxzJs = require("./SlotComponent-bRURhcxz.js");
var _injectedChildMixin95VbgK7Js = require("./InjectedChildMixin-95-VbgK7.js");
var _vue = require("vue");
var TabbedMixin = function(cmp) {
    var _components;
    return {
        mixins: [
            (0, _injectedChildMixin95VbgK7Js.P)(cmp, (0, _injectedChildMixin95VbgK7Js.S))
        ],
        components: (_components = {}, (0, _helpersO9H6ICOJs._)(_components, (0, _iconFJqkx1GNJs.s).name, (0, _iconFJqkx1GNJs.s)), (0, _helpersO9H6ICOJs._)(_components, (0, _slotComponentBRURhcxzJs.S).name, (0, _slotComponentBRURhcxzJs.S)), _components),
        props: {
            modelValue: {
                type: [
                    String,
                    Number
                ],
                "default": undefined
            },
            size: String,
            animated: {
                type: Boolean,
                "default": true
            },
            animation: String,
            animateInitially: Boolean,
            vertical: {
                type: Boolean,
                "default": false
            },
            position: String,
            destroyOnHide: {
                type: Boolean,
                "default": false
            }
        },
        emits: [
            "update:modelValue"
        ],
        data: function data() {
            return {
                activeId: this.modelValue,
                // Internal state
                defaultSlots: [],
                contentHeight: 0,
                isTransitioning: false
            };
        },
        mounted: function mounted() {
            if (typeof this.modelValue === "number") {
                // Backward compatibility: converts the index value to an id
                var value = (0, _helpersO9H6ICOJs.b)(this.modelValue, 0, this.items.length - 1);
                this.activeId = this.items[value].uniqueValue;
            } else this.activeId = this.modelValue;
        },
        computed: {
            activeItem: function activeItem() {
                var _this = this;
                return this.activeId === undefined ? this.items[0] : this.activeId === null ? null : this.childItems.find(function(i) {
                    return i.uniqueValue === _this.activeId;
                });
            },
            items: function items() {
                return this.sortedItems;
            }
        },
        watch: {
            /**
       * When v-model is changed set the new active tab.
       */ modelValue: function modelValue(value) {
                if (typeof value === "number") {
                    // Backward compatibility: converts the index value to an id
                    value = (0, _helpersO9H6ICOJs.b)(value, 0, this.items.length - 1);
                    this.activeId = this.items[value].uniqueValue;
                } else this.activeId = value;
            },
            /**
       * Sync internal state with external state
       */ activeId: function activeId(val, oldValue) {
                var oldTab = oldValue !== undefined && oldValue !== null ? this.childItems.find(function(i) {
                    return i.uniqueValue === oldValue;
                }) : null;
                if (oldTab && this.activeItem) {
                    oldTab.deactivate(this.activeItem.index);
                    this.activeItem.activate(oldTab.index);
                }
                val = this.activeItem ? typeof this.modelValue === "number" ? this.items.indexOf(this.activeItem) : this.activeItem.uniqueValue : undefined;
                if (val !== this.modelValue) this.$emit("update:modelValue", val);
            }
        },
        methods: {
            /**
      * Child click listener, emit input event and change active child.
      */ childClick: function childClick(child) {
                this.activeId = child.uniqueValue;
            },
            getNextItemIdx: function getNextItemIdx(fromIdx) {
                var skipDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var nextItemIdx = null;
                for(var i = 0; i < this.items.length; i++){
                    var item = this.items[i];
                    if (fromIdx < item.index && item.visible && (!skipDisabled || skipDisabled && !item.disabled)) {
                        nextItemIdx = item.index;
                        break;
                    }
                }
                return nextItemIdx;
            },
            getPrevItemIdx: function getPrevItemIdx(fromIdx) {
                var skipDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var prevItemIdx = null;
                for(var i = this.items.length - 1; i >= 0; i--){
                    var item = this.items[i];
                    if (item.index < fromIdx && item.visible && (!skipDisabled || skipDisabled && !item.disabled)) {
                        prevItemIdx = item.index;
                        break;
                    }
                }
                return prevItemIdx;
            }
        }
    };
};
var TabbedChildMixin = function(parentCmp) {
    return {
        mixins: [
            (0, _injectedChildMixin95VbgK7Js.I)(parentCmp, (0, _injectedChildMixin95VbgK7Js.a))
        ],
        props: {
            label: String,
            icon: String,
            iconPack: String,
            visible: {
                type: Boolean,
                "default": true
            },
            headerClass: {
                type: [
                    String,
                    Array,
                    Object
                ],
                "default": null
            }
        },
        data: function data() {
            return {
                transitionName: null,
                elementClass: "item",
                elementRole: null
            };
        },
        computed: {
            isActive: function isActive() {
                return this.parent.activeItem === this;
            }
        },
        methods: {
            /**
       * Activate element, alter animation name based on the index.
       */ activate: function activate(oldIndex) {
                this.transitionName = this.index < oldIndex ? this.parent.vertical ? "slide-down" : "slide-next" : this.parent.vertical ? "slide-up" : "slide-prev";
            },
            /**
       * Deactivate element, alter animation name based on the index.
       */ deactivate: function deactivate(newIndex) {
                this.transitionName = newIndex < this.index ? this.parent.vertical ? "slide-down" : "slide-next" : this.parent.vertical ? "slide-up" : "slide-prev";
            }
        },
        render: function render() {
            var _this = this;
            // if destroy apply v-if
            if (this.parent.destroyOnHide) {
                if (!this.isActive || !this.visible) return;
            }
            var vnode = (0, _vue.withDirectives)((0, _vue.h)("div", {
                // NOTE: possible regression of #3272
                // https://github.com/buefy/buefy/issues/3272
                "class": this.elementClass,
                role: this.elementRole,
                id: "".concat(this.uniqueValue, "-content"),
                "aria-labelledby": this.elementRole ? "".concat(this.uniqueValue, "-label") : null,
                tabindex: this.isActive ? 0 : -1
            }, this.$slots), [
                [
                    (0, _vue.vShow),
                    this.isActive && this.visible
                ]
            ]);
            // check animated prop
            if (this.parent.animated) return (0, _vue.h)((0, _vue.Transition), {
                name: this.parent.animation || this.transitionName,
                appear: this.parent.animateInitially === true || undefined,
                onBeforeEnter: function onBeforeEnter() {
                    _this.parent.isTransitioning = true;
                },
                onAfterEnter: function onAfterEnter() {
                    _this.parent.isTransitioning = false;
                }
            }, {
                "default": function _default() {
                    return vnode;
                }
            });
            return vnode;
        }
    };
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./Icon-fJqkx1gN.js":"gKXjn","./SlotComponent-bRURhcxz.js":"2TjGq","./InjectedChildMixin-95-VbgK7.js":"3Zi8S","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2TjGq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", ()=>SlotComponent);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _vue = require("vue");
var _PatchFlagNames, _slotFlagsText;
var cacheStringFunction = function cacheStringFunction(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var camelizeRE = /-(\w)/g;
var camelize = cacheStringFunction(function(str) {
    return str.replace(camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cacheStringFunction(function(str) {
    return str.replace(hyphenateRE, "-$1").toLowerCase();
});
var capitalize = cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var toHandlerKey = cacheStringFunction(function(str) {
    var s = str ? "on".concat(capitalize(str)) : "";
    return s;
});
_PatchFlagNames = {}, (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 1, "TEXT"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 2, "CLASS"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 4, "STYLE"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 8, "PROPS"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 16, "FULL_PROPS"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 32, "HYDRATE_EVENTS"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 64, "STABLE_FRAGMENT"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 128, "KEYED_FRAGMENT"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 256, "UNKEYED_FRAGMENT"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 512, "NEED_PATCH"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 1024, "DYNAMIC_SLOTS"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, 2048, "DEV_ROOT_FRAGMENT"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, -1, "HOISTED"), (0, _helpersO9H6ICOJs._)(_PatchFlagNames, -2, "BAIL"), _PatchFlagNames;
_slotFlagsText = {}, (0, _helpersO9H6ICOJs._)(_slotFlagsText, 1, "STABLE"), (0, _helpersO9H6ICOJs._)(_slotFlagsText, 2, "DYNAMIC"), (0, _helpersO9H6ICOJs._)(_slotFlagsText, 3, "FORWARDED"), _slotFlagsText;
var SlotComponent = {
    name: "BSlotComponent",
    props: {
        component: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            "default": "default"
        },
        scoped: {
            type: Boolean
        },
        props: {
            type: Object
        },
        tag: {
            type: String,
            "default": "div"
        },
        event: {
            type: String,
            "default": "vue:updated"
        }
    },
    data: function data() {
        return {
            updatedHook: undefined,
            handlerKey: undefined
        };
    },
    methods: {
        refresh: function refresh() {
            this.$forceUpdate();
        }
    },
    created: function created() {
        if ((0, _helpersO9H6ICOJs.e)(this.component)) {
            if (this.event === "vue:updated") // lifecycle event cannot be captured as an ordinary event
            this.updatedHook = (0, _vue.onUpdated)(this.refresh, this.component.$);
            else {
                // directly manipuates the VNode
                // because Vue 3 no longer provides $on
                var vnode = this.component.$.vnode;
                var handlerKey = toHandlerKey(this.event);
                if (vnode.props == null) vnode.props = (0, _helpersO9H6ICOJs._)({}, handlerKey, this.refresh);
                else {
                    var props = vnode.props;
                    if (props[this.handlerKey] == null) {
                        // tries camelCase
                        handlerKey = toHandlerKey(camelize(this.event));
                        if (props[handlerKey] == null) // tries kebab-case
                        handlerKey = toHandlerKey(hyphenate(this.event));
                    }
                    if (props[handlerKey] == null) {
                        handlerKey = toHandlerKey(this.event);
                        props[handlerKey] = this.refresh;
                    } else // multiple handlers may be specified in an array
                    if (Array.isArray(props[handlerKey])) props[handlerKey].push(this.refresh);
                    else props[handlerKey] = [
                        props[handlerKey],
                        this.refresh
                    ];
                }
                this.handlerKey = handlerKey;
            }
        }
    },
    beforeUnmount: function beforeUnmount() {
        if ((0, _helpersO9H6ICOJs.e)(this.component)) {
            if (this.updatedHook != null) {
                // unfortunately, there is no counterpart of `onUpdated`.
                // so directly manipulates the internal instance.
                // see https://github.com/vuejs/core/blob/2ffe3d5b3e953b63d4743b1e2bc242d50916b545/packages/runtime-core/src/apiLifecycle.ts#L17-L64
                var index = this.component.$.u.indexOf(this.updatedHook);
                if (index !== -1) this.component.$.u.splice(index, 1);
            } else if (this.handlerKey != null) {
                // directly maniputates VNode
                // because Vue 3 no longer provides $off
                var props = this.component.$.vnode.props;
                if (props != null) {
                    if (Array.isArray(props[this.handlerKey])) {
                        var _index = props[this.handlerKey].indexOf(this.refresh);
                        if (_index > -1) {
                            props[this.handlerKey].splice(_index, 1);
                            if (props[this.handlerKey].length === 1) props[this.handlerKey] = props[this.handlerKey][0];
                        }
                    } else delete props[this.handlerKey];
                }
            }
        }
    },
    render: function render() {
        return (0, _vue.h)(this.tag, {}, this.component.$slots ? this.scoped ? this.component.$slots[this.name](this.props) : this.component.$slots[this.name]() : undefined);
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6Gaai":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BSwitch", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var script = {
    name: "BSwitch",
    props: {
        modelValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array,
            Date
        ],
        nativeValue: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array,
            Date
        ],
        disabled: Boolean,
        type: String,
        passiveType: String,
        name: String,
        required: Boolean,
        size: String,
        ariaLabelledby: String,
        trueValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array,
                Date
            ],
            default: true
        },
        falseValue: {
            type: [
                String,
                Number,
                Boolean,
                Function,
                Object,
                Array,
                Date
            ],
            default: false
        },
        rounded: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultSwitchRounded;
            }
        },
        outlined: {
            type: Boolean,
            default: false
        },
        leftLabel: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            isMouseDown: false
        };
    },
    computed: {
        computedValue: {
            get () {
                return this.newValue;
            },
            set (value) {
                this.newValue = value;
                this.$emit("update:modelValue", value);
            }
        },
        newClass () {
            return [
                this.size,
                {
                    "is-disabled": this.disabled,
                    "is-rounded": this.rounded,
                    "is-outlined": this.outlined,
                    "has-left-label": this.leftLabel
                }
            ];
        },
        checkClasses () {
            return [
                {
                    "is-elastic": this.isMouseDown && !this.disabled
                },
                this.passiveType && `${this.passiveType}-passive`,
                this.type
            ];
        },
        showControlLabel () {
            return !!this.$slots.default;
        },
        disabledOrUndefined () {
            // On Vue 3, setting boolean attribute `false` does not remove it.
            // To do so, `null` or `undefined` has to be specified instead.
            // Setting `disabled="false"` ends up with a grayed out switch.
            return this.disabled || undefined;
        }
    },
    watch: {
        /**
        * When v-model change, set internal value.
        */ modelValue (value) {
            this.newValue = value;
        }
    },
    methods: {
        focus () {
            // MacOS FireFox and Safari do not focus when clicked
            this.$refs.input.focus();
        }
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = [
    "disabled",
    "name",
    "required",
    "value",
    "true-value",
    "false-value",
    "aria-labelledby"
];
const _hoisted_3 = [
    "id"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", {
        class: (0, _vue.normalizeClass)([
            "switch",
            $options.newClass
        ]),
        ref: "label",
        disabled: $options.disabledOrUndefined,
        onClick: _cache[2] || (_cache[2] = (...args)=>$options.focus && $options.focus(...args)),
        onKeydown: _cache[3] || (_cache[3] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>_ctx.$refs.label.click(), [
            "prevent"
        ]), [
            "enter"
        ])),
        onMousedown: _cache[4] || (_cache[4] = ($event)=>$data.isMouseDown = true),
        onMouseup: _cache[5] || (_cache[5] = ($event)=>$data.isMouseDown = false),
        onMouseout: _cache[6] || (_cache[6] = ($event)=>$data.isMouseDown = false),
        onBlur: _cache[7] || (_cache[7] = ($event)=>$data.isMouseDown = false)
    }, [
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.computedValue = $event),
            type: "checkbox",
            ref: "input",
            onClick: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(()=>{}, [
                "stop"
            ])),
            disabled: $options.disabledOrUndefined,
            name: $props.name,
            required: $props.required,
            value: $props.nativeValue,
            "true-value": $props.trueValue,
            "false-value": $props.falseValue,
            "aria-labelledby": $props.ariaLabelledby
        }, null, 8 /* PROPS */ , _hoisted_2), [
            [
                (0, _vue.vModelCheckbox),
                $options.computedValue
            ]
        ]),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "check",
                $options.checkClasses
            ])
        }, null, 2 /* CLASS */ ),
        $options.showControlLabel ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
            key: 0,
            id: $props.ariaLabelledby,
            class: "control-label"
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 8 /* PROPS */ , _hoisted_3)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1);
}
script.render = render;
script.__file = "src/components/switch/Switch.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","vue":"dylud","./plugins-C7548x21.js":"fuYWh","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jKt6N":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTable", ()=>script);
parcelHelpers.export(exports, "BTableColumn", ()=>script$2);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _vue = require("vue");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _paginationFX3EMQVPJs = require("./Pagination-FX3EMQVP.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _checkboxO2PhGepRJs = require("./Checkbox-o2PhGepR.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _loadingP2Sa5IKEJs = require("./Loading-p2sa5IKE.js");
var _slotComponentBRURhcxzJs = require("./SlotComponent-bRURhcxz.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _checkRadioMixinI9QgrPGQJs = require("./CheckRadioMixin-I9QgrPGQ.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _ssrJg9YOstJs = require("./ssr-jg9-YOst.js");
var script$3 = {
    name: "BTableMobileSort",
    components: {
        [(0, _selectDYWGhZcJs.s).name]: (0, _selectDYWGhZcJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    props: {
        currentSortColumn: Object,
        sortMultipleData: Array,
        isAsc: Boolean,
        columns: Array,
        placeholder: String,
        iconPack: String,
        sortIcon: {
            type: String,
            default: "arrow-up"
        },
        sortIconSize: {
            type: String,
            default: "is-small"
        },
        sortMultiple: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "removePriority",
        "sort"
    ],
    data () {
        return {
            sortMultipleSelect: "",
            sortMultipleSelectIndex: -1,
            mobileSort: this.currentSortColumn,
            mobileSortIndex: this.columns ? this.columns.indexOf(this.currentSortColumn) : -1,
            defaultEvent: {
                shiftKey: true,
                altKey: true,
                ctrlKey: true
            },
            ignoreSort: false
        };
    },
    computed: {
        showPlaceholder () {
            return !this.columns || !this.columns.some((column)=>column === this.mobileSort);
        },
        sortableColumns () {
            return this.columns && this.columns.filter((column)=>column.sortable);
        }
    },
    watch: {
        sortMultipleSelect (column) {
            if (this.ignoreSort) this.ignoreSort = false;
            else this.$emit("sort", column, this.defaultEvent);
        },
        sortMultipleSelectIndex (index) {
            if (index !== -1) this.sortMultipleSelect = this.columns[index];
            else this.sortMultipleSelect = null;
        },
        mobileSort (column) {
            if (this.currentSortColumn === column) return;
            this.$emit("sort", column, this.defaultEvent);
        },
        mobileSortIndex (index) {
            if (index !== -1) this.mobileSort = this.columns[index];
        // `index` becomes -1 if `currentSortColumn` is not in `columns`
        // never resets to null but retains `mobileSort` in that case
        },
        currentSortColumn (column) {
            // replaces `mobileSort` whether `column` is in `columns` or not
            this.mobileSort = column;
            this.mobileSortIndex = this.columns ? this.columns.indexOf(column) : -1;
        },
        columns (newColumns) {
            if (this.sortMultiple) this.sortMultipleSelectIndex = newColumns.indexOf(this.sortMultipleSelect);
            else this.mobileSortIndex = newColumns.indexOf(this.mobileSort);
        }
    },
    methods: {
        removePriority () {
            this.$emit("removePriority", this.sortMultipleSelect);
            // ignore the watcher to sort when we just change whats displayed in the select
            // otherwise the direction will be flipped
            // The sort event is already triggered by the emit
            this.ignoreSort = true;
            // Select one of the other options when we reset one
            const remainingFields = this.sortMultipleData.filter((data)=>data.field !== this.sortMultipleSelect.field).map((data)=>data.field);
            this.sortMultipleSelectIndex = this.columns.findIndex((column)=>remainingFields.includes(column.field));
        },
        getSortingObjectOfColumn (column) {
            return this.sortMultipleData.filter((i)=>i.field === column.field)[0];
        },
        columnIsDesc (column) {
            const sortingObject = this.getSortingObjectOfColumn(column);
            if (sortingObject) return !!(sortingObject.order && sortingObject.order === "desc");
            return true;
        },
        getLabel (column) {
            const sortingObject = this.getSortingObjectOfColumn(column);
            if (sortingObject) return column.label + "(" + (this.sortMultipleData.indexOf(sortingObject) + 1) + ")";
            return column.label;
        },
        sort () {
            this.$emit("sort", this.sortMultiple ? this.sortMultipleSelect : this.mobileSort, this.defaultEvent);
        }
    }
};
const _hoisted_1$2 = {
    class: "field table-mobile-sort"
};
const _hoisted_2$2 = {
    class: "field has-addons"
};
const _hoisted_3$2 = [
    "value"
];
const _hoisted_4$2 = [
    "value"
];
const _hoisted_5$1 = {
    class: "control"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_select = (0, _vue.resolveComponent)("b-select");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$2, [
        (0, _vue.createElementVNode)("div", _hoisted_2$2, [
            $props.sortMultiple ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                key: 0,
                modelValue: $data.sortMultipleSelectIndex,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.sortMultipleSelectIndex = $event),
                expanded: ""
            }, {
                default: (0, _vue.withCtx)(()=>[
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.sortableColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                key: index,
                                value: index
                            }, [
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.getLabel(column)) + " ", 1 /* TEXT */ ),
                                $options.getSortingObjectOfColumn(column) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                    key: 0
                                }, [
                                    $options.columnIsDesc(column) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        (0, _vue.createTextVNode)(" \u2193 ")
                                    ], 64 /* STABLE_FRAGMENT */ )) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)(" \u2191 ")
                                    ], 64 /* STABLE_FRAGMENT */ ))
                                ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true)
                            ], 8 /* PROPS */ , _hoisted_3$2);
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ]),
                _: 1 /* STABLE */ 
            }, 8 /* PROPS */ , [
                "modelValue"
            ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_select, {
                key: 1,
                modelValue: $data.mobileSortIndex,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$data.mobileSortIndex = $event),
                expanded: ""
            }, {
                default: (0, _vue.withCtx)(()=>[
                        $props.placeholder ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                            key: 0,
                            value: {},
                            selected: "",
                            disabled: "",
                            hidden: ""
                        }, (0, _vue.toDisplayString)($props.placeholder), 513 /* TEXT, NEED_PATCH */ )), [
                            [
                                (0, _vue.vShow),
                                $options.showPlaceholder
                            ]
                        ]) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.sortableColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("option", {
                                key: index,
                                value: index
                            }, (0, _vue.toDisplayString)(column.label), 9 /* TEXT, PROPS */ , _hoisted_4$2);
                        }), 128 /* KEYED_FRAGMENT */ ))
                    ]),
                _: 1 /* STABLE */ 
            }, 8 /* PROPS */ , [
                "modelValue"
            ])),
            (0, _vue.createElementVNode)("div", _hoisted_5$1, [
                $props.sortMultiple && $props.sortMultipleData.length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                    key: 0
                }, [
                    (0, _vue.createElementVNode)("button", {
                        class: "button is-primary",
                        onClick: _cache[2] || (_cache[2] = (...args)=>$options.sort && $options.sort(...args))
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            class: (0, _vue.normalizeClass)({
                                "is-desc": $options.columnIsDesc($data.sortMultipleSelect)
                            }),
                            icon: $props.sortIcon,
                            pack: $props.iconPack,
                            size: $props.sortIconSize,
                            both: ""
                        }, null, 8 /* PROPS */ , [
                            "class",
                            "icon",
                            "pack",
                            "size"
                        ])
                    ]),
                    (0, _vue.createElementVNode)("button", {
                        class: "button is-primary",
                        onClick: _cache[3] || (_cache[3] = (...args)=>$options.removePriority && $options.removePriority(...args))
                    }, [
                        (0, _vue.createVNode)(_component_b_icon, {
                            icon: "delete",
                            size: $props.sortIconSize,
                            both: ""
                        }, null, 8 /* PROPS */ , [
                            "size"
                        ])
                    ])
                ], 64 /* STABLE_FRAGMENT */ )) : !$props.sortMultiple ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                    key: 1,
                    class: "button is-primary",
                    onClick: _cache[4] || (_cache[4] = (...args)=>$options.sort && $options.sort(...args))
                }, [
                    (0, _vue.withDirectives)((0, _vue.createVNode)(_component_b_icon, {
                        class: (0, _vue.normalizeClass)({
                            "is-desc": !$props.isAsc
                        }),
                        icon: $props.sortIcon,
                        pack: $props.iconPack,
                        size: $props.sortIconSize,
                        both: ""
                    }, null, 8 /* PROPS */ , [
                        "class",
                        "icon",
                        "pack",
                        "size"
                    ]), [
                        [
                            (0, _vue.vShow),
                            $props.currentSortColumn === $data.mobileSort
                        ]
                    ])
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ])
        ])
    ]);
}
script$3.render = render$2;
script$3.__file = "src/components/table/TableMobileSort.vue";
var script$2 = {
    name: "BTableColumn",
    inject: {
        $table: {
            name: "$table",
            default: false
        }
    },
    props: {
        label: String,
        customKey: [
            String,
            Number
        ],
        field: String,
        meta: [
            String,
            Number,
            Boolean,
            Function,
            Object,
            Array
        ],
        width: [
            Number,
            String
        ],
        numeric: Boolean,
        centered: Boolean,
        searchable: Boolean,
        sortable: Boolean,
        visible: {
            type: Boolean,
            default: true
        },
        subheading: [
            String,
            Number
        ],
        customSort: Function,
        customSearch: Function,
        sticky: Boolean,
        headerSelectable: Boolean,
        headerClass: String,
        cellClass: String,
        thAttrs: {
            type: Function,
            default: ()=>({})
        },
        tdAttrs: {
            type: Function,
            default: ()=>({})
        }
    },
    data () {
        return {
            newKey: this.customKey || this.label,
            _isTableColumn: true
        };
    },
    computed: {
        thClasses () {
            const attrs = this.thAttrs(this);
            const classes = [
                this.headerClass,
                {
                    "is-sortable": this.sortable,
                    "is-sticky": this.sticky,
                    "is-unselectable": this.isHeaderUnSelectable
                }
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        thStyle () {
            const attrs = this.thAttrs(this);
            const style = [
                this.style
            ];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        },
        thWrapStyle () {
            const width = (0, _helpersO9H6ICOJs.t)(this.width);
            // interestingly, percentage width on the th element has effect
            // so we won't apply it to .th-wrap
            if (width != null && !width.trim().endsWith("%")) return {
                width
            };
            else return {};
        },
        rootClasses () {
            return [
                this.cellClass,
                {
                    "has-text-right": this.numeric && !this.centered,
                    "has-text-centered": this.centered,
                    "is-sticky": this.sticky
                }
            ];
        },
        style () {
            return {
                width: (0, _helpersO9H6ICOJs.t)(this.width)
            };
        },
        hasDefaultSlot () {
            return !!this.$slots.default;
        },
        /**
         * Return if column header is un-selectable
         */ isHeaderUnSelectable () {
            return !this.headerSelectable && this.sortable;
        }
    },
    methods: {
        getRootClasses (row) {
            const attrs = this.tdAttrs(row, this);
            const classes = [
                this.rootClasses
            ];
            if (attrs && attrs.class) classes.push(attrs.class);
            return classes;
        },
        getRootStyle (row) {
            const attrs = this.tdAttrs(row, this);
            const style = [];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        }
    },
    created () {
        if (!this.$table) throw new Error("You should wrap bTableColumn on a bTable");
        this.$table._registerTableColumn(this);
    },
    beforeUnmount () {
        this.$table._unregisterTableColumn(this);
    },
    render (createElement) {
        // renderless
        return null;
    }
};
script$2.__file = "src/components/table/TableColumn.vue";
var script$1 = {
    name: "BTablePagination",
    components: {
        [(0, _paginationFX3EMQVPJs.s).name]: (0, _paginationFX3EMQVPJs.s)
    },
    props: {
        paginated: Boolean,
        total: [
            Number,
            String
        ],
        perPage: [
            Number,
            String
        ],
        currentPage: [
            Number,
            String
        ],
        paginationSimple: Boolean,
        paginationSize: String,
        rounded: Boolean,
        iconPack: String,
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        pageInput: Boolean,
        paginationOrder: String,
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    emits: [
        "page-change",
        "update:currentPage"
    ],
    data () {
        return {
            newCurrentPage: this.currentPage
        };
    },
    watch: {
        currentPage (newVal) {
            this.newCurrentPage = newVal;
        }
    },
    methods: {
        /**
        * Paginator change listener.
        */ pageChanged (page) {
            this.newCurrentPage = page > 0 ? page : 1;
            this.$emit("update:currentPage", this.newCurrentPage);
            this.$emit("page-change", this.newCurrentPage);
        }
    }
};
const _hoisted_1$1 = {
    class: "top level"
};
const _hoisted_2$1 = {
    class: "level-left"
};
const _hoisted_3$1 = {
    class: "level-right"
};
const _hoisted_4$1 = {
    key: 0,
    class: "level-item"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_pagination = (0, _vue.resolveComponent)("b-pagination");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1$1, [
        (0, _vue.createElementVNode)("div", _hoisted_2$1, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ]),
        (0, _vue.createElementVNode)("div", _hoisted_3$1, [
            $props.paginated ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_4$1, [
                (0, _vue.createVNode)(_component_b_pagination, {
                    "icon-pack": $props.iconPack,
                    total: $props.total,
                    "per-page": $props.perPage,
                    simple: $props.paginationSimple,
                    size: $props.paginationSize,
                    "model-value": $data.newCurrentPage,
                    rounded: $props.rounded,
                    onChange: $options.pageChanged,
                    "aria-next-label": $props.ariaNextLabel,
                    "aria-previous-label": $props.ariaPreviousLabel,
                    "aria-page-label": $props.ariaPageLabel,
                    "aria-current-label": $props.ariaCurrentLabel,
                    "page-input": $props.pageInput,
                    order: $props.paginationOrder,
                    "page-input-position": $props.pageInputPosition,
                    "debounce-page-input": $props.debouncePageInput
                }, null, 8 /* PROPS */ , [
                    "icon-pack",
                    "total",
                    "per-page",
                    "simple",
                    "size",
                    "model-value",
                    "rounded",
                    "onChange",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ])
    ]);
}
script$1.render = render$1;
script$1.__file = "src/components/table/TablePagination.vue";
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var tinyEmitter = {
    exports: {}
};
function E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
E.prototype = {
    on: function on(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function once(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function emit(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function off(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
tinyEmitter.exports = E;
tinyEmitter.exports.TinyEmitter = E;
var tinyEmitterExports = tinyEmitter.exports;
var Emitter = /*@__PURE__*/ getDefaultExportFromCjs(tinyEmitterExports);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function mockTableColumn(table, column) {
    var eventEmitter = new Emitter();
    var defaultProps = {
        label: undefined,
        customKey: undefined,
        field: undefined,
        meta: undefined,
        width: undefined,
        numeric: undefined,
        centered: undefined,
        searchable: undefined,
        sortable: undefined,
        visible: true,
        subheading: undefined,
        customSort: undefined,
        customSearch: undefined,
        sticky: undefined,
        headerSelectable: undefined,
        headerClass: undefined,
        thAttrs: function thAttrs() {
            return {};
        },
        tdAttrs: function tdAttrs() {
            return {};
        }
    };
    return _objectSpread(_objectSpread(_objectSpread({}, defaultProps), column), {}, {
        // data
        parent: table,
        newKey: column.customKey || column.label,
        _isTableColumn: true,
        // inject
        $table: table,
        // computed
        get thClasses () {
            var attrs = this.thAttrs(this);
            var classes = [
                this.headerClass,
                {
                    "is-sortable": this.sortable,
                    "is-sticky": this.sticky,
                    "is-unselectable": this.isHeaderUnSelectable
                }
            ];
            if (attrs && attrs["class"]) classes.push(attrs["class"]);
            return classes;
        },
        get thStyle () {
            var attrs1 = this.thAttrs(this);
            var style = [
                this.style
            ];
            if (attrs1 && attrs1.style) style.push(attrs1.style);
            return style;
        },
        get thWrapStyle () {
            return this.style;
        },
        get rootClasses () {
            return [
                this.cellClass,
                {
                    "has-text-right": this.numeric && !this.centered,
                    "has-text-centered": this.centered,
                    "is-sticky": this.sticky
                }
            ];
        },
        get style () {
            return {
                width: (0, _helpersO9H6ICOJs.t)(this.width)
            };
        },
        get hasDefaultSlot () {
            return !!this.$scopedSlots["default"];
        },
        get isHeaderUnSelectable () {
            return !this.headerSelectable && this.sortable;
        },
        // methods
        getRootClasses: function getRootClasses(row) {
            var attrs = this.tdAttrs(row, this);
            var classes = [
                this.rootClasses
            ];
            if (attrs && attrs["class"]) classes.push(attrs["class"]);
            return classes;
        },
        getRootStyle: function getRootStyle(row) {
            var attrs = this.tdAttrs(row, this);
            var style = [];
            if (attrs && attrs.style) style.push(attrs.style);
            return style;
        },
        $on: function $on() {
            return eventEmitter.on.apply(eventEmitter, arguments);
        },
        $once: function $once() {
            return eventEmitter.once.apply(eventEmitter, arguments);
        },
        $off: function $off() {
            return eventEmitter.off.apply(eventEmitter, arguments);
        },
        $emit: function $emit() {
            return eventEmitter.emit.apply(eventEmitter, arguments);
        },
        // special fields
        _isVue: true,
        $slots: {
            "default": function _default(props) {
                var vnode = (0, _vue.h)("span", {
                    innerHTML: (0, _helpersO9H6ICOJs.g)(props.row, column.field)
                });
                return [
                    vnode
                ];
            }
        }
    });
}
var script = {
    name: "BTable",
    components: {
        [(0, _checkboxO2PhGepRJs.s).name]: (0, _checkboxO2PhGepRJs.s),
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s),
        [(0, _input0IvJhXUCJs.s).name]: (0, _input0IvJhXUCJs.s),
        [(0, _loadingP2Sa5IKEJs.s).name]: (0, _loadingP2Sa5IKEJs.s),
        [(0, _slotComponentBRURhcxzJs.S).name]: (0, _slotComponentBRURhcxzJs.S),
        [script$3.name]: script$3,
        [script$2.name]: script$2,
        [script$1.name]: script$1
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C)
    ],
    provide () {
        return {
            $table: this
        };
    },
    props: {
        data: {
            type: Array,
            default: ()=>[]
        },
        columns: {
            type: Array,
            default: ()=>[]
        },
        bordered: Boolean,
        striped: Boolean,
        narrowed: Boolean,
        hoverable: Boolean,
        loading: Boolean,
        detailed: Boolean,
        checkable: Boolean,
        headerCheckable: {
            type: Boolean,
            default: true
        },
        checkboxType: {
            type: String,
            default: "is-primary"
        },
        checkboxPosition: {
            type: String,
            default: "left",
            validator: (value)=>{
                return [
                    "left",
                    "right"
                ].indexOf(value) >= 0;
            }
        },
        stickyCheckbox: {
            type: Boolean,
            default: false
        },
        selected: Object,
        isRowSelectable: {
            type: Function,
            default: ()=>true
        },
        focusable: Boolean,
        customIsChecked: Function,
        isRowCheckable: {
            type: Function,
            default: ()=>true
        },
        checkedRows: {
            type: Array,
            default: ()=>[]
        },
        mobileCards: {
            type: Boolean,
            default: true
        },
        defaultSort: [
            String,
            Array
        ],
        defaultSortDirection: {
            type: String,
            default: "asc"
        },
        sortIcon: {
            type: String,
            default: "arrow-up"
        },
        sortIconSize: {
            type: String,
            default: "is-small"
        },
        sortMultiple: {
            type: Boolean,
            default: false
        },
        sortMultipleData: {
            type: Array,
            default: ()=>[]
        },
        sortMultipleKey: {
            type: String,
            default: null
        },
        paginated: Boolean,
        currentPage: {
            type: Number,
            default: 1
        },
        perPage: {
            type: [
                Number,
                String
            ],
            default: 20
        },
        showDetailIcon: {
            type: Boolean,
            default: true
        },
        detailIcon: {
            type: String,
            default: "chevron-right"
        },
        paginationPosition: {
            type: String,
            default: "bottom",
            validator: (value)=>{
                return [
                    "bottom",
                    "top",
                    "both"
                ].indexOf(value) >= 0;
            }
        },
        paginationRounded: Boolean,
        backendSorting: Boolean,
        backendFiltering: Boolean,
        rowClass: {
            type: Function,
            default: ()=>""
        },
        openedDetailed: {
            type: Array,
            default: ()=>[]
        },
        hasDetailedVisible: {
            type: Function,
            default: ()=>true
        },
        detailKey: {
            type: String,
            default: ""
        },
        detailTransition: {
            type: String,
            default: ""
        },
        customDetailRow: {
            type: Boolean,
            default: false
        },
        backendPagination: Boolean,
        total: {
            type: [
                Number,
                String
            ],
            default: 0
        },
        iconPack: String,
        mobileSortPlaceholder: String,
        customRowKey: String,
        draggable: {
            type: Boolean,
            default: false
        },
        draggableColumn: {
            type: Boolean,
            default: false
        },
        scrollable: Boolean,
        ariaNextLabel: String,
        ariaPreviousLabel: String,
        ariaPageLabel: String,
        ariaCurrentLabel: String,
        stickyHeader: Boolean,
        height: [
            Number,
            String
        ],
        filtersEvent: {
            type: String,
            default: ""
        },
        cardLayout: Boolean,
        showHeader: {
            type: Boolean,
            default: true
        },
        debounceSearch: Number,
        caption: String,
        showCaption: {
            type: Boolean,
            default: true
        },
        pageInput: {
            type: Boolean,
            default: false
        },
        paginationOrder: String,
        pageInputPosition: String,
        debouncePageInput: [
            Number,
            String
        ]
    },
    emits: [
        "cellclick",
        "check",
        "check-all",
        "click",
        "columndragend",
        "columndragleave",
        "columndragover",
        "columndragstart",
        "columndrop",
        "contextmenu",
        "dblclick",
        "details-close",
        "details-open",
        "dragend",
        "dragleave",
        "dragover",
        "dragstart",
        "drop",
        "filters-change",
        "page-change",
        "select",
        "sort",
        "sorting-priority-removed",
        "update:checkedRows",
        "update:currentPage",
        "update:openedDetailed",
        "update:selected"
    ],
    data () {
        return {
            sortMultipleDataLocal: [],
            getValueByPath: (0, _helpersO9H6ICOJs.g),
            visibleDetailRows: this.openedDetailed,
            newData: this.data,
            newDataTotal: this.backendPagination ? this.total : this.data.length,
            newCheckedRows: [
                ...this.checkedRows
            ],
            lastCheckedRowIndex: null,
            newCurrentPage: this.currentPage,
            currentSortColumn: {},
            isAsc: true,
            filters: {},
            defaultSlots: [],
            firstTimeSort: true,
            _isTable: true,
            isDraggingRow: false,
            isDraggingColumn: false,
            // for touch-enabled devices
            _selectedRow: null,
            mayBeTouchDragging: false,
            touchDragoverTarget: null,
            _draggedCellEl: undefined,
            draggedCellContent: ""
        };
    },
    computed: {
        sortMultipleDataComputed () {
            return this.backendSorting ? this.sortMultipleData : this.sortMultipleDataLocal;
        },
        tableClasses () {
            return {
                "is-bordered": this.bordered,
                "is-striped": this.striped,
                "is-narrow": this.narrowed,
                "is-hoverable": (this.hoverable || this.focusable) && this.visibleData.length
            };
        },
        tableWrapperClasses () {
            return {
                "has-mobile-cards": this.mobileCards,
                "has-sticky-header": this.stickyHeader,
                "is-card-list": this.cardLayout,
                "table-container": this.isScrollable
            };
        },
        tableStyle () {
            return {
                height: (0, _helpersO9H6ICOJs.t)(this.height)
            };
        },
        touchDraggedCellClasses () {
            return {
                "has-mobile-cards": this.mobileCards
            };
        },
        /**
        * Splitted data based on the pagination.
        */ visibleData () {
            if (!this.paginated) return this.newData;
            const currentPage = this.newCurrentPage;
            const perPage = this.perPage;
            if (this.newData.length <= perPage) return this.newData;
            else {
                const start = (currentPage - 1) * perPage;
                const end = parseInt(start, 10) + parseInt(perPage, 10);
                return this.newData.slice(start, end);
            }
        },
        visibleColumns () {
            if (!this.newColumns) return this.newColumns;
            return this.newColumns.filter((column)=>{
                return column.visible || column.visible === undefined;
            });
        },
        /**
        * Check if all rows in the page are checked.
        */ isAllChecked () {
            const validVisibleData = this.visibleData.filter((row)=>this.isRowCheckable(row));
            if (validVisibleData.length === 0) return false;
            const isAllChecked = validVisibleData.some((currentVisibleRow)=>{
                return (0, _helpersO9H6ICOJs.i)(this.newCheckedRows, currentVisibleRow, this.customIsChecked) < 0;
            });
            return !isAllChecked;
        },
        /**
        * Check if all rows in the page are checkable.
        */ isAllUncheckable () {
            const validVisibleData = this.visibleData.filter((row)=>this.isRowCheckable(row));
            return validVisibleData.length === 0;
        },
        /**
        * Check if has any sortable column.
        */ hasSortablenewColumns () {
            return this.newColumns.some((column)=>{
                return column.sortable;
            });
        },
        /**
        * Check if has any searchable column.
        */ hasSearchablenewColumns () {
            return this.newColumns.some((column)=>{
                return column.searchable;
            });
        },
        /**
        * Check if has any column using subheading.
        */ hasCustomSubheadings () {
            if (this.$slots && this.$slots.subheading) return true;
            return this.newColumns.some((column)=>{
                return column.subheading || column.$slots.subheading;
            });
        },
        /**
        * Return total column count based if it's checkable or expanded
        */ columnCount () {
            let count = this.visibleColumns.length;
            count += this.checkable ? 1 : 0;
            count += this.detailed && this.showDetailIcon ? 1 : 0;
            return count;
        },
        /**
        * return if detailed row tabled
        * will be with chevron column & icon or not
        */ showDetailRowIcon () {
            return this.detailed && this.showDetailIcon;
        },
        /**
        * return if scrollable table
        */ isScrollable () {
            if (this.scrollable) return true;
            if (!this.newColumns) return false;
            return this.newColumns.some((column)=>{
                return column.sticky;
            });
        },
        newColumns () {
            if (this.columns && this.columns.length) return this.columns.map((column)=>{
                return mockTableColumn(this, column);
            });
            return this.defaultSlots;
        },
        canDragRow () {
            return this.draggable && !this.isDraggingColumn;
        },
        canDragColumn () {
            return this.draggableColumn && !this.isDraggingRow;
        }
    },
    watch: {
        /**
        * When data prop change:
        *   1. Update internal value.
        *   2. Filter data if it's not backend-filtered.
        *   3. Sort again if it's not backend-sorted.
        *   4. Set new total if it's not backend-paginated.
        */ data (value) {
            this.newData = value;
            if (!this.backendFiltering) this.newData = value.filter((row)=>this.isRowFiltered(row));
            if (!this.backendSorting) this.sort(this.currentSortColumn, true);
            if (!this.backendPagination) this.newDataTotal = this.newData.length;
        },
        /**
        * When Pagination total change, update internal total
        * only if it's backend-paginated.
        */ total (newTotal) {
            if (!this.backendPagination) return;
            this.newDataTotal = newTotal;
        },
        currentPage (newVal) {
            this.newCurrentPage = newVal;
        },
        newCurrentPage (newVal) {
            this.$emit("update:currentPage", newVal);
        },
        /**
        * When checkedRows prop change, update internal value without
        * mutating original data.
        */ checkedRows (rows) {
            this.newCheckedRows = [
                ...rows
            ];
        },
        /*
        newColumns(value) {
            this.checkSort()
        },
        */ debounceSearch: {
            handler (value) {
                this.debouncedHandleFiltersChange = (0, _paginationFX3EMQVPJs.d)(this.handleFiltersChange, value);
            },
            immediate: true
        },
        filters: {
            handler (value) {
                if (this.debounceSearch) this.debouncedHandleFiltersChange(value);
                else this.handleFiltersChange(value);
            },
            deep: true
        },
        /**
        * When the user wants to control the detailed rows via props.
        * Or wants to open the details of certain row with the router for example.
        */ openedDetailed (expandedRows) {
            this.visibleDetailRows = expandedRows;
        }
    },
    methods: {
        onFiltersEvent (event) {
            this.$emit(`filters-event-${this.filtersEvent}`, {
                event,
                filters: this.filters
            });
        },
        handleFiltersChange (value) {
            if (this.backendFiltering) this.$emit("filters-change", value);
            else {
                this.newData = this.data.filter((row)=>this.isRowFiltered(row));
                if (!this.backendPagination) this.newDataTotal = this.newData.length;
                if (!this.backendSorting) {
                    if (this.sortMultiple && this.sortMultipleDataLocal && this.sortMultipleDataLocal.length > 0) this.doSortMultiColumn();
                    else if (Object.keys(this.currentSortColumn).length > 0) this.doSortSingleColumn(this.currentSortColumn);
                }
            }
        },
        findIndexOfSortData (column) {
            const sortObj = this.sortMultipleDataComputed.filter((i)=>i.field === column.field)[0];
            return this.sortMultipleDataComputed.indexOf(sortObj) + 1;
        },
        removeSortingPriority (column) {
            if (this.backendSorting) this.$emit("sorting-priority-removed", column.field);
            else {
                this.sortMultipleDataLocal = this.sortMultipleDataLocal.filter((priority)=>priority.field !== column.field);
                if (this.sortMultipleDataLocal.length === 0) this.resetMultiSorting();
                else this.newData = (0, _helpersO9H6ICOJs.k)(this.newData, this.sortMultipleDataLocal);
            }
        },
        resetMultiSorting () {
            this.sortMultipleDataLocal = [];
            this.currentSortColumn = {};
            this.newData = this.data;
        },
        /**
        * Sort an array by key without mutating original data.
        * Call the user sort function if it was passed.
        */ sortBy (array, key, fn, isAsc) {
            let sorted = [];
            // Sorting without mutating original data
            if (fn && typeof fn === "function") sorted = [
                ...array
            ].sort((a, b)=>fn(a, b, isAsc));
            else sorted = [
                ...array
            ].sort((a, b)=>{
                // Get nested values from objects
                let newA = (0, _helpersO9H6ICOJs.g)(a, key);
                let newB = (0, _helpersO9H6ICOJs.g)(b, key);
                // sort boolean type
                if (typeof newA === "boolean" && typeof newB === "boolean") return isAsc ? newA - newB : newB - newA;
                // sort null values to the bottom when in asc order
                // and to the top when in desc order
                if (!(0, _helpersO9H6ICOJs.w)(newB) && (0, _helpersO9H6ICOJs.w)(newA)) return isAsc ? 1 : -1;
                if (!(0, _helpersO9H6ICOJs.w)(newA) && (0, _helpersO9H6ICOJs.w)(newB)) return isAsc ? -1 : 1;
                if (newA === newB) return 0;
                newA = typeof newA === "string" ? newA.toUpperCase() : newA;
                newB = typeof newB === "string" ? newB.toUpperCase() : newB;
                return isAsc ? newA > newB ? 1 : -1 : newA > newB ? -1 : 1;
            });
            return sorted;
        },
        sortMultiColumn (column) {
            this.currentSortColumn = {};
            if (!this.backendSorting) {
                const existingPriority = this.sortMultipleDataLocal.filter((i)=>i.field === column.field)[0];
                if (existingPriority) existingPriority.order = existingPriority.order === "desc" ? "asc" : "desc";
                else this.sortMultipleDataLocal.push({
                    field: column.field,
                    order: column.isAsc,
                    customSort: column.customSort
                });
                this.doSortMultiColumn();
            }
        },
        doSortMultiColumn () {
            this.newData = (0, _helpersO9H6ICOJs.k)(this.newData, this.sortMultipleDataLocal);
        },
        /**
        * Sort the column.
        * Toggle current direction on column if it's sortable
        * and not just updating the prop.
        */ sort (column, updatingData = false, event = null) {
            if (!column || !column.sortable) return;
            if (// if backend sorting is enabled, just emit the sort press like usual
            // if the correct key combination isnt pressed, sort like usual
            !this.backendSorting && this.sortMultiple && (this.sortMultipleKey && event[this.sortMultipleKey] || !this.sortMultipleKey)) {
                if (updatingData) this.doSortMultiColumn();
                else this.sortMultiColumn(column);
            } else {
                // sort multiple is enabled but the correct key combination isnt pressed so reset
                if (this.sortMultiple) this.sortMultipleDataLocal = [];
                if (!updatingData) this.isAsc = (0, _vue.toRaw)(column) === (0, _vue.toRaw)(this.currentSortColumn) ? !this.isAsc : this.defaultSortDirection.toLowerCase() !== "desc";
                if (!this.firstTimeSort) this.$emit("sort", column.field, this.isAsc ? "asc" : "desc", event);
                if (!this.backendSorting) this.doSortSingleColumn(column);
                this.currentSortColumn = column;
            }
        },
        doSortSingleColumn (column) {
            this.newData = this.sortBy(this.newData, column.field, column.customSort, this.isAsc);
        },
        isRowSelected (row, selected) {
            if (!selected) return false;
            if (this.customRowKey) return row[this.customRowKey] === selected[this.customRowKey];
            return row === selected;
        },
        /**
        * Check if the row is checked (is added to the array).
        */ isRowChecked (row) {
            return (0, _helpersO9H6ICOJs.i)(this.newCheckedRows, row, this.customIsChecked) >= 0;
        },
        /**
        * Remove a checked row from the array.
        */ removeCheckedRow (row) {
            const index = (0, _helpersO9H6ICOJs.i)(this.newCheckedRows, row, this.customIsChecked);
            if (index >= 0) this.newCheckedRows.splice(index, 1);
        },
        /**
        * Header checkbox click listener.
        * Add or remove all rows in current page.
        */ checkAll () {
            const isAllChecked = this.isAllChecked;
            this.visibleData.forEach((currentRow)=>{
                if (this.isRowCheckable(currentRow)) this.removeCheckedRow(currentRow);
                if (!isAllChecked) {
                    if (this.isRowCheckable(currentRow)) this.newCheckedRows.push(currentRow);
                }
            });
            this.$emit("check", this.newCheckedRows);
            this.$emit("check-all", this.newCheckedRows);
            // Emit checked rows to update user variable
            this.$emit("update:checkedRows", this.newCheckedRows);
        },
        /**
        * Row checkbox click listener.
        */ checkRow (row, index, event) {
            if (!this.isRowCheckable(row)) return;
            const lastIndex = this.lastCheckedRowIndex;
            this.lastCheckedRowIndex = index;
            if (event.shiftKey && lastIndex !== null && index !== lastIndex) this.shiftCheckRow(row, index, lastIndex);
            else if (!this.isRowChecked(row)) this.newCheckedRows.push(row);
            else this.removeCheckedRow(row);
            this.$emit("check", this.newCheckedRows, row);
            // Emit checked rows to update user variable
            this.$emit("update:checkedRows", this.newCheckedRows);
        },
        /**
         * Check row when shift is pressed.
         */ shiftCheckRow (row, index, lastCheckedRowIndex) {
            // Get the subset of the list between the two indicies
            const subset = this.visibleData.slice(Math.min(index, lastCheckedRowIndex), Math.max(index, lastCheckedRowIndex) + 1);
            // Determine the operation based on the state of the clicked checkbox
            const shouldCheck = !this.isRowChecked(row);
            subset.forEach((item)=>{
                this.removeCheckedRow(item);
                if (shouldCheck && this.isRowCheckable(item)) this.newCheckedRows.push(item);
            });
        },
        /**
        * Row click listener.
        * Emit all necessary events.
        */ selectRow (row, index) {
            this.$emit("click", row);
            this._selectedRow = row; // row must be clicked before dragging by touch
            if (this.selected === row) return;
            if (!this.isRowSelectable(row)) return;
            // Emit new and old row
            this.$emit("select", row, this.selected);
            // Emit new row to update user variable
            this.$emit("update:selected", row);
        },
        /**
        * Toggle to show/hide details slot
        */ toggleDetails (obj) {
            const found = this.isVisibleDetailRow(obj);
            if (found) {
                this.closeDetailRow(obj);
                this.$emit("details-close", obj);
            } else {
                this.openDetailRow(obj);
                this.$emit("details-open", obj);
            }
            // Syncs the detailed rows with the parent component
            this.$emit("update:openedDetailed", this.visibleDetailRows);
        },
        openDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            this.visibleDetailRows.push(index);
        },
        closeDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            const i = this.visibleDetailRows.indexOf(index);
            if (i >= 0) this.visibleDetailRows.splice(i, 1);
        },
        isVisibleDetailRow (obj) {
            const index = this.handleDetailKey(obj);
            return this.visibleDetailRows.indexOf(index) >= 0;
        },
        isActiveDetailRow (row) {
            return this.detailed && !this.customDetailRow && this.isVisibleDetailRow(row);
        },
        isActiveCustomDetailRow (row) {
            return this.detailed && this.customDetailRow && this.isVisibleDetailRow(row);
        },
        isRowFiltered (row) {
            for(const key in this.filters){
                if (!this.filters[key]) continue;
                const input = this.filters[key];
                const column = this.newColumns.filter((c)=>c.field === key)[0];
                if (column && column.customSearch && typeof column.customSearch === "function") {
                    if (!column.customSearch(row, input)) return false;
                } else {
                    const value = this.getValueByPath(row, key);
                    if (value == null) return false;
                    if (Number.isInteger(value)) {
                        if (value !== Number(input)) return false;
                    } else {
                        const re = new RegExp((0, _helpersO9H6ICOJs.f)(input), "i");
                        if (Array.isArray(value)) {
                            const valid = value.some((val)=>re.test((0, _helpersO9H6ICOJs.j)(val)) || re.test(val));
                            if (!valid) return false;
                        } else {
                            if (!re.test((0, _helpersO9H6ICOJs.j)(value)) && !re.test(value)) return false;
                        }
                    }
                }
            }
            return true;
        },
        /**
        * When the detailKey is defined we use the object[detailKey] as index.
        * If not, use the object reference by default.
        */ handleDetailKey (index) {
            const key = this.detailKey;
            return !key.length || !index ? index : index[key];
        },
        checkPredefinedDetailedRows () {
            const defaultExpandedRowsDefined = this.openedDetailed.length > 0;
            if (defaultExpandedRowsDefined && !this.detailKey.length) throw new Error('If you set a predefined opened-detailed, you must provide a unique key using the prop "detail-key"');
        },
        /**
        * Call initSort only first time (For example async data).
        */ checkSort () {
            if (this.newColumns.length && this.firstTimeSort) {
                this.initSort();
                this.firstTimeSort = false;
            } else if (this.newColumns.length) {
                if (Object.keys(this.currentSortColumn).length > 0) {
                    for(let i = 0; i < this.newColumns.length; i++)if (this.newColumns[i].field === this.currentSortColumn.field) {
                        this.currentSortColumn = this.newColumns[i];
                        break;
                    }
                }
            }
        },
        /**
        * Check if footer slot has custom content.
        *
        * Assumes that `$slots.footer` is specified.
        */ hasCustomFooterSlot () {
            const footer = this.$slots.footer();
            if (footer.length > 1) return true;
            // if a template is specified to `footer`, `footer.length` is 1
            // but should contain multiple elements.
            if ((0, _helpersO9H6ICOJs.x)(footer[0])) return true;
            const tag = footer[0].tag;
            if (tag !== "th" && tag !== "td") return false;
            return true;
        },
        /**
        * Check if bottom-left slot exists.
        */ hasBottomLeftSlot () {
            return typeof this.$slots["bottom-left"] !== "undefined";
        },
        /**
        * Table arrow keys listener, change selection.
        */ pressedArrow (pos) {
            if (!this.visibleData.length) return;
            let index = this.visibleData.indexOf(this.selected) + pos;
            // Prevent from going up from first and down from last
            index = index < 0 ? 0 : index > this.visibleData.length - 1 ? this.visibleData.length - 1 : index;
            const row = this.visibleData[index];
            if (!this.isRowSelectable(row)) {
                let newIndex = null;
                if (pos > 0) {
                    for(let i = index; i < this.visibleData.length && newIndex === null; i++)if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
                } else {
                    for(let i = index; i >= 0 && newIndex === null; i--)if (this.isRowSelectable(this.visibleData[i])) newIndex = i;
                }
                if (newIndex >= 0) this.selectRow(this.visibleData[newIndex]);
            } else this.selectRow(row);
        },
        /**
        * Focus table element if has selected prop.
        */ focus () {
            if (!this.focusable) return;
            this.$el.querySelector("table").focus();
        },
        /**
        * Initial sorted column based on the default-sort prop.
        */ initSort () {
            if (this.sortMultiple && this.sortMultipleData) this.sortMultipleData.forEach((column)=>{
                this.sortMultiColumn(column);
            });
            else {
                if (!this.defaultSort) return;
                let sortField = "";
                let sortDirection = this.defaultSortDirection;
                if (Array.isArray(this.defaultSort)) {
                    sortField = this.defaultSort[0];
                    if (this.defaultSort[1]) sortDirection = this.defaultSort[1];
                } else sortField = this.defaultSort;
                const sortColumn = this.newColumns.filter((column)=>column.field === sortField)[0];
                if (sortColumn) {
                    this.isAsc = sortDirection.toLowerCase() !== "desc";
                    this.sort(sortColumn, true);
                }
            }
        },
        /**
        * Emits drag start event (row)
        */ handleDragStart (event, row, index) {
            if (!this.canDragRow) return;
            this.isDraggingRow = true;
            this.$emit("dragstart", {
                event,
                row,
                index
            });
        },
        /**
        * Emits drag leave event (row)
        */ handleDragEnd (event, row, index) {
            if (!this.canDragRow) return;
            this.isDraggingRow = false;
            this.$emit("dragend", {
                event,
                row,
                index
            });
        },
        /**
        * Emits drop event (row)
        */ handleDrop (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("drop", {
                event,
                row,
                index
            });
        },
        /**
        * Emits drag over event (row)
        */ handleDragOver (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("dragover", {
                event,
                row,
                index
            });
        },
        /**
        * Emits drag leave event (row)
        */ handleDragLeave (event, row, index) {
            if (!this.canDragRow) return;
            this.$emit("dragleave", {
                event,
                row,
                index
            });
        },
        emitEventForRow (eventName, event, row) {
            // eventName should not be in `emits` because it is never included
            // in `$attrs` if it is listed in `emits`.
            return this.$attrs[`on${eventName}`] ? this.$emit(eventName, row, event) : null;
        },
        /**
        * Emits drag start event (column)
        */ handleColumnDragStart (event, column, index) {
            if (!this.canDragColumn) return;
            this.isDraggingColumn = true;
            this.$emit("columndragstart", {
                event,
                column,
                index
            });
        },
        /**
        * Emits drag leave event (column)
        */ handleColumnDragEnd (event, column, index) {
            if (!this.canDragColumn) return;
            this.isDraggingColumn = false;
            this.$emit("columndragend", {
                event,
                column,
                index
            });
        },
        /**
        * Emits drop event (column)
        */ handleColumnDrop (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndrop", {
                event,
                column,
                index
            });
        },
        /**
        * Emits drag over event (column)
        */ handleColumnDragOver (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndragover", {
                event,
                column,
                index
            });
        },
        /**
        * Emits drag leave event (column)
        */ handleColumnDragLeave (event, column, index) {
            if (!this.canDragColumn) return;
            this.$emit("columndragleave", {
                event,
                column,
                index
            });
        },
        /**
        * Starts monitoring drag-by-touch events (row on touch-enabled devices)
        */ handleTouchStart (event, row, index) {
            if (!this.canDragRow) return;
            if (this.isDraggingColumn) return;
            // drag won't start unless the row has been clicked (tapped)
            // I think trapping touch-scrolling is annoying
            if (this._selectedRow !== row) return;
            event.preventDefault();
            this.mayBeTouchDragging = true;
        },
        /**
        * Emits dragover and dragleave events (row on touch-enabled devices)
        *
        * Emits also dragstart if this is the first touchmove after touchstart.
        */ handleTouchMove (event, row, index) {
            if (!this.canDragRow) return;
            if (!this.mayBeTouchDragging) return;
            if (!this.isDraggingRow) {
                const tr = event.target.closest("tr");
                this.draggedCellContent = tr ? `<table class="table"><tr>${tr.innerHTML}</tr></table>` : event.target.innerHTML;
                this.$refs.draggedCell.style.width = tr ? `${tr.offsetWidth}px` : `${event.target.offsetWidth}px`;
                event.target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragstart"
                }));
            }
            const touch = event.touches[0];
            const target = document.elementFromPoint(touch.clientX, touch.clientY);
            if (target != null) {
                if (target !== this.touchDragoverTarget) {
                    if (this.touchDragoverTarget != null) this.touchDragoverTarget.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                        type: "dragleave",
                        target: this.touchDragoverTarget
                    }));
                    this.touchDragoverTarget = target;
                    target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                        type: "dragover",
                        target
                    }));
                }
            } else if (this.touchDragoverTarget != null) {
                this.touchDragoverTarget.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragleave",
                    target: this.touchDragoverTarget
                }));
                this.touchDragoverTarget = null;
            }
            this.updateDraggedCell(touch);
        },
        /**
        * Emits drop and dragend events (row on touch-enabled devices)
        */ handleTouchEnd (event, row, index) {
            if (!this.canDragRow) return;
            if (this.isDraggingRow) {
                const touch = event.changedTouches[0];
                const target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (target != null) target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "drop",
                    target
                }));
                event.target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragend"
                }));
                this._selectedRow = null;
            }
            this.mayBeTouchDragging = false;
        },
        /**
        * Starts monitoring drag-by-touch events (column on touch-enabled devices)
        */ handleColumnTouchStart (event, column, index) {
            if (!this.canDragColumn) return;
            if (this.isDraggingRow) return;
            event.preventDefault(); // otherwise triggers touch-scrolling
            this.mayBeTouchDragging = true;
        },
        /**
        * Emits dragover and dragleave events (column on touch-enabled devices)
        *
        * Also emits dragstart if this is the first touchmove after touchstart.
        */ handleColumnTouchMove (event, column, index) {
            if (!this.canDragColumn) return;
            if (!this.mayBeTouchDragging) return;
            if (!this.isDraggingColumn) {
                this.draggedCellContent = event.target.innerHTML;
                this.$refs.draggedCell.style.width = `${event.target.offsetWidth}px`;
                event.target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragstart"
                }));
            }
            const touch = event.touches[0];
            const target = document.elementFromPoint(touch.clientX, touch.clientY);
            if (target != null) {
                if (target !== this.touchDragoverTarget) {
                    if (this.touchDragoverTarget != null) this.touchDragoverTarget.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                        type: "dragleave",
                        target: this.touchDragoverTarget
                    }));
                    this.touchDragoverTarget = target;
                    target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                        type: "dragover",
                        target
                    }));
                }
            } else if (this.touchDragoverTarget != null) {
                this.touchDragoverTarget.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragleave",
                    target: this.touchDragoverTarget
                }));
                this.touchDragoverTarget = null;
            }
            this.updateDraggedCell(touch);
        },
        /**
        * Emits drop and dragend events (column on touch-enabled devices)
        */ handleColumnTouchEnd (event, column, index) {
            if (!this.canDragColumn) return;
            if (this.isDraggingColumn) {
                const touch = event.changedTouches[0];
                const target = document.elementFromPoint(touch.clientX, touch.clientY);
                if (target != null) target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "drop",
                    target
                }));
                event.target.dispatchEvent((0, _helpersO9H6ICOJs.B)(event, {
                    type: "dragend"
                }));
            }
            this.mayBeTouchDragging = false;
        },
        updateDraggedCell ({ clientX, clientY }) {
            const cellRect = this.$refs.draggedCell.getBoundingClientRect();
            const top = clientY + window.scrollY - cellRect.height / 2;
            const left = clientX + window.scrollX - cellRect.width / 2;
            this.$refs.draggedCell.style.top = `calc(${top}px)`;
            this.$refs.draggedCell.style.left = `calc(${left}px)`;
        },
        _registerTableColumn (column) {
            if (column._isTableColumn) this.defaultSlots.push(column);
        },
        _unregisterTableColumn (column) {
            const index = this.defaultSlots.indexOf(column);
            if (index !== -1) this.defaultSlots.splice(index, 1);
        }
    },
    mounted () {
        this.checkPredefinedDetailedRows();
        this.checkSort();
        // appends `draggedCell` to the body whenever `draggable` or
        // `draggableColumn` becomes true
        // starts watching here to make sure the DOM is ready
        function prepareDraggedCell(isDraggable) {
            if (isDraggable && this.$data._draggedCellEl == null) this.$data._draggedCellEl = (0, _helpersO9H6ICOJs.d)(this.$refs.draggedCell);
        }
        this.$watch("draggable", prepareDraggedCell, {
            immediate: true
        });
        this.$watch("draggableColumn", prepareDraggedCell, {
            immediate: true
        });
    },
    beforeUnmount () {
        if (this.$data._draggedCellEl) (0, _helpersO9H6ICOJs.r)(this.$data._draggedCellEl);
    }
};
const _hoisted_1 = [
    "tabindex"
];
const _hoisted_2 = {
    key: 1
};
const _hoisted_3 = {
    key: 0,
    width: "40px"
};
const _hoisted_4 = [
    "onClick",
    "draggable",
    "onDragstart",
    "onDragend",
    "onDrop",
    "onDragover",
    "onDragleave",
    "onTouchstart",
    "onTouchmove",
    "onTouchend"
];
const _hoisted_5 = {
    key: 0,
    class: "multi-sort-icons"
};
const _hoisted_6 = [
    "onClick"
];
const _hoisted_7 = {
    key: 0,
    class: "is-subheading"
};
const _hoisted_8 = {
    key: 0,
    width: "40px"
};
const _hoisted_9 = {
    key: 1
};
const _hoisted_10 = {
    key: 2
};
const _hoisted_11 = {
    key: 1
};
const _hoisted_12 = {
    key: 0,
    width: "40px"
};
const _hoisted_13 = {
    key: 1
};
const _hoisted_14 = {
    key: 2
};
const _hoisted_15 = [
    "onClick",
    "onDblclick",
    "onMouseenter",
    "onMouseleave",
    "onContextmenu",
    "draggable",
    "onDragstart",
    "onDragend",
    "onDrop",
    "onDragover",
    "onDragleave",
    "onTouchstart",
    "onTouchmove",
    "onTouchend"
];
const _hoisted_16 = {
    key: 0,
    class: "chevron-cell"
};
const _hoisted_17 = [
    "onClick"
];
const _hoisted_18 = {
    key: 0,
    class: "detail"
};
const _hoisted_19 = [
    "colspan"
];
const _hoisted_20 = {
    class: "detail-container"
};
const _hoisted_21 = {
    key: 0,
    class: "is-empty"
};
const _hoisted_22 = [
    "colspan"
];
const _hoisted_23 = {
    key: 2
};
const _hoisted_24 = {
    class: "table-footer"
};
const _hoisted_25 = [
    "colspan"
];
const _hoisted_26 = [
    "innerHTML"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_table_mobile_sort = (0, _vue.resolveComponent)("b-table-mobile-sort");
    const _component_b_table_pagination = (0, _vue.resolveComponent)("b-table-pagination");
    const _component_b_checkbox = (0, _vue.resolveComponent)("b-checkbox");
    const _component_b_slot_component = (0, _vue.resolveComponent)("b-slot-component");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    const _component_b_input = (0, _vue.resolveComponent)("b-input");
    const _component_b_loading = (0, _vue.resolveComponent)("b-loading");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: "b-table"
    }, _ctx.rootAttrs), [
        (0, _vue.renderSlot)(_ctx.$slots, "default"),
        $props.mobileCards && $options.hasSortablenewColumns ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_table_mobile_sort, {
            key: 0,
            "current-sort-column": $data.currentSortColumn,
            "sort-multiple": $props.sortMultiple,
            "sort-multiple-data": $options.sortMultipleDataComputed,
            "is-asc": $data.isAsc,
            columns: $options.newColumns,
            placeholder: $props.mobileSortPlaceholder,
            "icon-pack": $props.iconPack,
            "sort-icon": $props.sortIcon,
            "sort-icon-size": $props.sortIconSize,
            onSort: _cache[0] || (_cache[0] = (column, event)=>$options.sort(column, null, event)),
            onRemovePriority: _cache[1] || (_cache[1] = (column)=>$options.removeSortingPriority(column))
        }, null, 8 /* PROPS */ , [
            "current-sort-column",
            "sort-multiple",
            "sort-multiple-data",
            "is-asc",
            "columns",
            "placeholder",
            "icon-pack",
            "sort-icon",
            "sort-icon-size"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        $props.paginated && ($props.paginationPosition === "top" || $props.paginationPosition === "both") ? (0, _vue.renderSlot)(_ctx.$slots, "pagination", {
            key: 1
        }, ()=>[
                (0, _vue.createVNode)(_component_b_table_pagination, (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
                    "per-page": $props.perPage,
                    paginated: $props.paginated,
                    rounded: $props.paginationRounded,
                    "icon-pack": $props.iconPack,
                    total: $data.newDataTotal,
                    "current-page": $data.newCurrentPage,
                    "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event)=>$data.newCurrentPage = $event),
                    "aria-next-label": $props.ariaNextLabel,
                    "aria-previous-label": $props.ariaPreviousLabel,
                    "aria-page-label": $props.ariaPageLabel,
                    "aria-current-label": $props.ariaCurrentLabel,
                    onPageChange: _cache[3] || (_cache[3] = (event)=>_ctx.$emit("page-change", event)),
                    "page-input": $props.pageInput,
                    "pagination-order": $props.paginationOrder,
                    "page-input-position": $props.pageInputPosition,
                    "debounce-page-input": $props.debouncePageInput
                }), {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "top-left")
                        ]),
                    _: 3 /* FORWARDED */ 
                }, 16 /* FULL_PROPS */ , [
                    "per-page",
                    "paginated",
                    "rounded",
                    "icon-pack",
                    "total",
                    "current-page",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "pagination-order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ]) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "table-wrapper",
                $options.tableWrapperClasses
            ]),
            style: (0, _vue.normalizeStyle)($options.tableStyle)
        }, [
            (0, _vue.createElementVNode)("table", {
                class: (0, _vue.normalizeClass)([
                    "table",
                    $options.tableClasses
                ]),
                tabindex: !$props.focusable ? undefined : 0,
                onKeydown: [
                    _cache[4] || (_cache[4] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>$options.pressedArrow(-1), [
                        "self",
                        "prevent"
                    ]), [
                        "up"
                    ])),
                    _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)(($event)=>$options.pressedArrow(1), [
                        "self",
                        "prevent"
                    ]), [
                        "down"
                    ]))
                ]
            }, [
                $props.caption ? (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("caption", {
                    key: 0
                }, (0, _vue.toDisplayString)($props.caption), 513 /* TEXT, NEED_PATCH */ )), [
                    [
                        (0, _vue.vShow),
                        $props.showCaption
                    ]
                ]) : (0, _vue.createCommentVNode)("v-if", true),
                $options.newColumns.length && $props.showHeader ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("thead", _hoisted_2, [
                    (0, _vue.createElementVNode)("tr", null, [
                        $options.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_3)) : (0, _vue.createCommentVNode)("v-if", true),
                        $props.checkable && $props.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 1,
                            class: (0, _vue.normalizeClass)([
                                "checkbox-cell",
                                {
                                    "is-sticky": $props.stickyCheckbox
                                }
                            ])
                        }, [
                            $props.headerCheckable ? (0, _vue.renderSlot)(_ctx.$slots, "check-all", {
                                key: 0,
                                isAllChecked: $options.isAllChecked,
                                isAllUncheckable: $options.isAllUncheckable,
                                checkAll: $options.checkAll
                            }, ()=>[
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": $options.isAllChecked,
                                        type: $props.checkboxType,
                                        disabled: $options.isAllUncheckable,
                                        onChange: $options.checkAll
                                    }, null, 8 /* PROPS */ , [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onChange"
                                    ])
                                ]) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", (0, _vue.mergeProps)({
                                key: column.newKey + ":" + index + "header"
                            }, column.thAttrs(column), {
                                class: [
                                    column.thClasses,
                                    {
                                        "is-current-sort": !$props.sortMultiple && $data.currentSortColumn === column
                                    }
                                ],
                                style: column.thStyle,
                                onClick: (0, _vue.withModifiers)(($event)=>$options.sort(column, null, $event), [
                                    "stop"
                                ]),
                                draggable: $options.canDragColumn,
                                onDragstart: ($event)=>$options.handleColumnDragStart($event, column, index),
                                onDragend: ($event)=>$options.handleColumnDragEnd($event, column, index),
                                onDrop: ($event)=>$options.handleColumnDrop($event, column, index),
                                onDragover: ($event)=>$options.handleColumnDragOver($event, column, index),
                                onDragleave: ($event)=>$options.handleColumnDragLeave($event, column, index),
                                onTouchstart: ($event)=>$options.handleColumnTouchStart($event, column, index),
                                onTouchmove: ($event)=>$options.handleColumnTouchMove($event, column, index),
                                onTouchend: ($event)=>$options.handleColumnTouchEnd($event, column, index)
                            }), [
                                (0, _vue.createElementVNode)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "th-wrap is-relative",
                                        {
                                            "is-numeric": column.numeric,
                                            "is-centered": column.centered
                                        }
                                    ]),
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                        key: 0,
                                        component: column,
                                        scoped: "",
                                        name: "header",
                                        tag: "span",
                                        props: {
                                            column,
                                            index
                                        }
                                    }, null, 8 /* PROPS */ , [
                                        "component",
                                        "props"
                                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(column.label) + " ", 1 /* TEXT */ ),
                                        $props.sortMultiple && $options.sortMultipleDataComputed && $options.sortMultipleDataComputed.length > 0 && $options.sortMultipleDataComputed.filter((i)=>i.field === column.field).length > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_5, [
                                            (0, _vue.createVNode)(_component_b_icon, {
                                                icon: $props.sortIcon,
                                                pack: $props.iconPack,
                                                both: "",
                                                size: $props.sortIconSize,
                                                class: (0, _vue.normalizeClass)({
                                                    "is-desc": $options.sortMultipleDataComputed.filter((i)=>i.field === column.field)[0].order === "desc"
                                                })
                                            }, null, 8 /* PROPS */ , [
                                                "icon",
                                                "pack",
                                                "size",
                                                "class"
                                            ]),
                                            (0, _vue.createTextVNode)(" " + (0, _vue.toDisplayString)($options.findIndexOfSortData(column)) + " ", 1 /* TEXT */ ),
                                            (0, _vue.createElementVNode)("button", {
                                                class: "delete is-small multi-sort-cancel-icon",
                                                type: "button",
                                                onClick: (0, _vue.withModifiers)(($event)=>$options.removeSortingPriority(column), [
                                                    "stop"
                                                ])
                                            }, null, 8 /* PROPS */ , _hoisted_6)
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                            key: 1,
                                            icon: $props.sortIcon,
                                            pack: $props.iconPack,
                                            both: "",
                                            size: $props.sortIconSize,
                                            class: (0, _vue.normalizeClass)([
                                                "sort-icon",
                                                {
                                                    "is-desc": !$data.isAsc,
                                                    "is-invisible": $data.currentSortColumn !== column
                                                }
                                            ])
                                        }, null, 8 /* PROPS */ , [
                                            "icon",
                                            "pack",
                                            "size",
                                            "class"
                                        ]))
                                    ], 64 /* STABLE_FRAGMENT */ ))
                                ], 6 /* CLASS, STYLE */ )
                            ], 16 /* FULL_PROPS */ , _hoisted_4);
                        }), 128 /* KEYED_FRAGMENT */ )),
                        $props.checkable && $props.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 2,
                            class: (0, _vue.normalizeClass)([
                                "checkbox-cell",
                                {
                                    "is-sticky": $props.stickyCheckbox
                                }
                            ])
                        }, [
                            $props.headerCheckable ? (0, _vue.renderSlot)(_ctx.$slots, "check-all", {
                                key: 0,
                                isAllChecked: $options.isAllChecked,
                                isAllUncheckable: $options.isAllUncheckable,
                                checkAll: $options.checkAll
                            }, ()=>[
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": $options.isAllChecked,
                                        type: $props.checkboxType,
                                        disabled: $options.isAllUncheckable,
                                        onChange: $options.checkAll
                                    }, null, 8 /* PROPS */ , [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onChange"
                                    ])
                                ]) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
                    ]),
                    $options.hasCustomSubheadings ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_7, [
                        $options.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_8)) : (0, _vue.createCommentVNode)("v-if", true),
                        $props.checkable && $props.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_9)) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                                key: column.newKey + ":" + index + "subheading",
                                style: (0, _vue.normalizeStyle)(column.style)
                            }, [
                                (0, _vue.createElementVNode)("div", {
                                    class: (0, _vue.normalizeClass)([
                                        "th-wrap",
                                        {
                                            "is-numeric": column.numeric,
                                            "is-centered": column.centered
                                        }
                                    ]),
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.$slots.subheading ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                        key: 0,
                                        component: column,
                                        scoped: "",
                                        name: "subheading",
                                        tag: "span",
                                        props: {
                                            column,
                                            index
                                        }
                                    }, null, 8 /* PROPS */ , [
                                        "component",
                                        "props"
                                    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 1
                                    }, [
                                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(column.subheading), 1 /* TEXT */ )
                                    ], 64 /* STABLE_FRAGMENT */ ))
                                ], 6 /* CLASS, STYLE */ )
                            ], 4 /* STYLE */ );
                        }), 128 /* KEYED_FRAGMENT */ )),
                        $props.checkable && $props.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_10)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true),
                    $options.hasSearchablenewColumns ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_11, [
                        $options.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_12)) : (0, _vue.createCommentVNode)("v-if", true),
                        $props.checkable && $props.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_13)) : (0, _vue.createCommentVNode)("v-if", true),
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleColumns, (column, index)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", (0, _vue.mergeProps)({
                                key: column.newKey + ":" + index + "searchable"
                            }, column.thAttrs(column), {
                                style: column.thStyle,
                                class: {
                                    "is-sticky": column.sticky
                                }
                            }), [
                                (0, _vue.createElementVNode)("div", {
                                    class: "th-wrap",
                                    style: (0, _vue.normalizeStyle)(column.thWrapStyle)
                                }, [
                                    column.searchable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: 0
                                    }, [
                                        column.$slots.searchable ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                                            key: 0,
                                            component: column,
                                            scoped: true,
                                            name: "searchable",
                                            tag: "span",
                                            props: {
                                                column,
                                                filters: $data.filters
                                            }
                                        }, null, 8 /* PROPS */ , [
                                            "component",
                                            "props"
                                        ])) : ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_input, (0, _vue.mergeProps)({
                                            key: 1,
                                            [(0, _vue.toHandlerKey)($props.filtersEvent)]: $options.onFiltersEvent
                                        }, {
                                            modelValue: $data.filters[column.field],
                                            "onUpdate:modelValue": ($event)=>$data.filters[column.field] = $event,
                                            type: column.numeric ? "number" : "text"
                                        }), null, 16 /* FULL_PROPS */ , [
                                            "modelValue",
                                            "onUpdate:modelValue",
                                            "type"
                                        ]))
                                    ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true)
                                ], 4 /* STYLE */ )
                            ], 16 /* FULL_PROPS */ );
                        }), 128 /* KEYED_FRAGMENT */ )),
                        $props.checkable && $props.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", _hoisted_14)) : (0, _vue.createCommentVNode)("v-if", true)
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ])) : (0, _vue.createCommentVNode)("v-if", true),
                (0, _vue.createElementVNode)("tbody", null, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleData, (row, index)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                            key: $props.customRowKey ? row[$props.customRowKey] : index
                        }, [
                            (0, _vue.createElementVNode)("tr", {
                                class: (0, _vue.normalizeClass)([
                                    $props.rowClass(row, index),
                                    {
                                        "is-selected": $options.isRowSelected(row, $props.selected),
                                        "is-checked": $options.isRowChecked(row)
                                    }
                                ]),
                                onClick: ($event)=>$options.selectRow(row),
                                onDblclick: ($event)=>_ctx.$emit("dblclick", row),
                                onMouseenter: ($event)=>$options.emitEventForRow("mouseenter", $event, row),
                                onMouseleave: ($event)=>$options.emitEventForRow("mouseleave", $event, row),
                                onContextmenu: ($event)=>_ctx.$emit("contextmenu", row, $event),
                                draggable: $options.canDragRow,
                                onDragstart: ($event)=>$options.handleDragStart($event, row, index),
                                onDragend: ($event)=>$options.handleDragEnd($event, row, index),
                                onDrop: ($event)=>$options.handleDrop($event, row, index),
                                onDragover: ($event)=>$options.handleDragOver($event, row, index),
                                onDragleave: ($event)=>$options.handleDragLeave($event, row, index),
                                onTouchstart: ($event)=>$options.handleTouchStart($event, row, index),
                                onTouchmove: ($event)=>$options.handleTouchMove($event, row, index),
                                onTouchend: ($event)=>$options.handleTouchEnd($event, row, index)
                            }, [
                                $options.showDetailRowIcon ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", _hoisted_16, [
                                    $props.hasDetailedVisible(row) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                                        key: 0,
                                        role: "button",
                                        onClick: (0, _vue.withModifiers)(($event)=>$options.toggleDetails(row), [
                                            "stop"
                                        ])
                                    }, [
                                        (0, _vue.createVNode)(_component_b_icon, {
                                            icon: $props.detailIcon,
                                            pack: $props.iconPack,
                                            both: "",
                                            class: (0, _vue.normalizeClass)({
                                                "is-expanded": $options.isVisibleDetailRow(row)
                                            })
                                        }, null, 8 /* PROPS */ , [
                                            "icon",
                                            "pack",
                                            "class"
                                        ])
                                    ], 8 /* PROPS */ , _hoisted_17)) : (0, _vue.createCommentVNode)("v-if", true)
                                ])) : (0, _vue.createCommentVNode)("v-if", true),
                                $props.checkable && $props.checkboxPosition === "left" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", {
                                    key: 1,
                                    class: (0, _vue.normalizeClass)([
                                        "checkbox-cell",
                                        {
                                            "is-sticky": $props.stickyCheckbox
                                        }
                                    ])
                                }, [
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": $options.isRowChecked(row),
                                        type: $props.checkboxType,
                                        disabled: !$props.isRowCheckable(row),
                                        onClick: (0, _vue.withModifiers)(($event)=>$options.checkRow(row, index, $event), [
                                            "prevent",
                                            "stop"
                                        ])
                                    }, null, 8 /* PROPS */ , [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onClick"
                                    ])
                                ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true),
                                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($options.visibleColumns, (column, colindex)=>{
                                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                                        key: column.newKey + ":" + index + ":" + colindex
                                    }, [
                                        column.$slots.default ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, (0, _vue.mergeProps)({
                                            key: 0,
                                            component: column
                                        }, column.tdAttrs(row, column), {
                                            scoped: "",
                                            name: "default",
                                            tag: "td",
                                            class: column.getRootClasses(row),
                                            style: column.getRootStyle(row),
                                            "data-label": column.label,
                                            props: {
                                                row,
                                                column,
                                                index,
                                                colindex,
                                                toggleDetails: $options.toggleDetails,
                                                isActiveDetailRow: $options.isActiveDetailRow
                                            },
                                            onClick: ($event)=>_ctx.$emit("cellclick", row, column, index, colindex)
                                        }), null, 16 /* FULL_PROPS */ , [
                                            "component",
                                            "class",
                                            "style",
                                            "data-label",
                                            "props",
                                            "onClick"
                                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */ );
                                }), 128 /* KEYED_FRAGMENT */ )),
                                $props.checkable && $props.checkboxPosition === "right" ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("td", {
                                    key: 2,
                                    class: (0, _vue.normalizeClass)([
                                        "checkbox-cell",
                                        {
                                            "is-sticky": $props.stickyCheckbox
                                        }
                                    ])
                                }, [
                                    (0, _vue.createVNode)(_component_b_checkbox, {
                                        autocomplete: "off",
                                        "model-value": $options.isRowChecked(row),
                                        type: $props.checkboxType,
                                        disabled: !$props.isRowCheckable(row),
                                        onClick: (0, _vue.withModifiers)(($event)=>$options.checkRow(row, index, $event), [
                                            "prevent",
                                            "stop"
                                        ])
                                    }, null, 8 /* PROPS */ , [
                                        "model-value",
                                        "type",
                                        "disabled",
                                        "onClick"
                                    ])
                                ], 2 /* CLASS */ )) : (0, _vue.createCommentVNode)("v-if", true)
                            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_15),
                            (0, _vue.createVNode)((0, _vue.Transition), {
                                name: $props.detailTransition
                            }, {
                                default: (0, _vue.withCtx)(()=>[
                                        $options.isActiveDetailRow(row) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_18, [
                                            (0, _vue.createElementVNode)("td", {
                                                colspan: $options.columnCount
                                            }, [
                                                (0, _vue.createElementVNode)("div", _hoisted_20, [
                                                    (0, _vue.renderSlot)(_ctx.$slots, "detail", {
                                                        row: row,
                                                        index: index
                                                    })
                                                ])
                                            ], 8 /* PROPS */ , _hoisted_19)
                                        ])) : (0, _vue.createCommentVNode)("v-if", true)
                                    ]),
                                _: 2 /* DYNAMIC */ 
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                                "name"
                            ]),
                            $options.isActiveCustomDetailRow(row) ? (0, _vue.renderSlot)(_ctx.$slots, "detail", {
                                key: 0,
                                row: row,
                                index: index
                            }) : (0, _vue.createCommentVNode)("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */ );
                    }), 128 /* KEYED_FRAGMENT */ )),
                    !$options.visibleData.length ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_21, [
                        (0, _vue.createElementVNode)("td", {
                            colspan: $options.columnCount
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "empty")
                        ], 8 /* PROPS */ , _hoisted_22)
                    ])) : (0, _vue.createCommentVNode)("v-if", true)
                ]),
                _ctx.$slots.footer !== undefined ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tfoot", _hoisted_23, [
                    (0, _vue.createElementVNode)("tr", _hoisted_24, [
                        $options.hasCustomFooterSlot() ? (0, _vue.renderSlot)(_ctx.$slots, "footer", {
                            key: 0
                        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                            key: 1,
                            colspan: $options.columnCount
                        }, [
                            (0, _vue.renderSlot)(_ctx.$slots, "footer")
                        ], 8 /* PROPS */ , _hoisted_25))
                    ])
                ])) : (0, _vue.createCommentVNode)("v-if", true)
            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1),
            $props.loading ? (0, _vue.renderSlot)(_ctx.$slots, "loading", {
                key: 0
            }, ()=>[
                    (0, _vue.createVNode)(_component_b_loading, {
                        "is-full-page": false,
                        "model-value": $props.loading
                    }, null, 8 /* PROPS */ , [
                        "model-value"
                    ])
                ]) : (0, _vue.createCommentVNode)("v-if", true)
        ], 6 /* CLASS, STYLE */ ),
        $props.checkable && $options.hasBottomLeftSlot() || $props.paginated && ($props.paginationPosition === "bottom" || $props.paginationPosition === "both") ? (0, _vue.renderSlot)(_ctx.$slots, "pagination", {
            key: 2
        }, ()=>[
                (0, _vue.createVNode)(_component_b_table_pagination, (0, _vue.mergeProps)(_ctx.fallthroughAttrs, {
                    "per-page": $props.perPage,
                    paginated: $props.paginated,
                    rounded: $props.paginationRounded,
                    "icon-pack": $props.iconPack,
                    total: $data.newDataTotal,
                    "current-page": $data.newCurrentPage,
                    "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event)=>$data.newCurrentPage = $event),
                    "aria-next-label": $props.ariaNextLabel,
                    "aria-previous-label": $props.ariaPreviousLabel,
                    "aria-page-label": $props.ariaPageLabel,
                    "aria-current-label": $props.ariaCurrentLabel,
                    onPageChange: _cache[7] || (_cache[7] = (event)=>_ctx.$emit("page-change", event)),
                    "page-input": $props.pageInput,
                    "pagination-order": $props.paginationOrder,
                    "page-input-position": $props.pageInputPosition,
                    "debounce-page-input": $props.debouncePageInput
                }), {
                    default: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "bottom-left")
                        ]),
                    _: 3 /* FORWARDED */ 
                }, 16 /* FULL_PROPS */ , [
                    "per-page",
                    "paginated",
                    "rounded",
                    "icon-pack",
                    "total",
                    "current-page",
                    "aria-next-label",
                    "aria-previous-label",
                    "aria-page-label",
                    "aria-current-label",
                    "page-input",
                    "pagination-order",
                    "page-input-position",
                    "debounce-page-input"
                ])
            ]) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createCommentVNode)(" eslint-disable vue/no-v-html "),
        (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
            ref: "draggedCell",
            class: (0, _vue.normalizeClass)([
                "touch-dragged-cell",
                $options.touchDraggedCellClasses
            ]),
            innerHTML: $data.draggedCellContent
        }, null, 10 /* CLASS, PROPS */ , _hoisted_26), [
            [
                (0, _vue.vShow),
                $data.mayBeTouchDragging && ($data.isDraggingRow || $data.isDraggingColumn)
            ]
        ]),
        (0, _vue.createCommentVNode)(" eslint-enable vue/no-v-html ")
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/table/Table.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
        (0, _pluginsC7548X21Js.a)(Vue, script$2);
    }
};

},{"vue":"dylud","./helpers-O9h6_ICO.js":"9IzVa","./Pagination-FX3EMQVP.js":"kMAX1","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./Checkbox-o2PhGepR.js":"jf5YD","./Icon-fJqkx1gN.js":"gKXjn","./Input-0ivJhXUC.js":"jYQke","./Loading-p2sa5IKE.js":"1xQL0","./SlotComponent-bRURhcxz.js":"2TjGq","./Select-DY-wGhZc.js":"hHgPZ","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./config-nHWiBviw.js":"4fneA","./CheckRadioMixin-I9QgrPGQ.js":"1U5Xe","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./ssr-jg9-YOst.js":"8rU16","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gfrpy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTabItem", ()=>script);
parcelHelpers.export(exports, "BTabs", ()=>script$1);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _tabbedChildMixinFoL4CKMJs = require("./TabbedChildMixin-foL4cK-M.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _slotComponentBRURhcxzJs = require("./SlotComponent-bRURhcxz.js");
var _injectedChildMixin95VbgK7Js = require("./InjectedChildMixin-95-VbgK7.js");
var script$1 = {
    name: "BTabs",
    mixins: [
        (0, _tabbedChildMixinFoL4CKMJs.T)("tab")
    ],
    props: {
        expanded: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTabsExpanded;
            }
        },
        type: {
            type: [
                String,
                Object
            ],
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTabsType;
            }
        },
        animated: {
            type: Boolean,
            default: ()=>{
                return (0, _configNHWiBviwJs.c).defaultTabsAnimated;
            }
        },
        multiline: Boolean
    },
    data () {
        return {
            currentFocus: null
        };
    },
    computed: {
        mainClasses () {
            return {
                "is-fullwidth": this.expanded,
                "is-vertical": this.vertical,
                "is-multiline": this.multiline,
                [this.position]: this.position && this.vertical
            };
        },
        navClasses () {
            return [
                this.type,
                this.size,
                {
                    [this.position]: this.position && !this.vertical,
                    "is-fullwidth": this.expanded,
                    "is-toggle": this.type === "is-toggle-rounded"
                }
            ];
        }
    },
    methods: {
        giveFocusToTab (tab) {
            if (Array.isArray(tab)) {
                // Vue ≥ v3.0 < v3.2.25, refs in v-for are stored as a single object,
                // but ≥ v3.2.25, refs in v-for are stored in an array (same as Vue 2)
                tab = tab[0];
                if (tab == null) return;
            }
            if (tab.$el && tab.$el.focus) tab.$el.focus();
            else if (tab.focus) tab.focus();
        },
        manageTablistKeydown (event) {
            // https://developer.mozilla.org/fr/docs/Web/API/KeyboardEvent/key/Key_Values#Navigation_keys
            const { key } = event;
            switch(key){
                case this.vertical ? "ArrowUp" : "ArrowLeft":
                case this.vertical ? "Up" : "Left":
                    {
                        let prevIdx = this.getPrevItemIdx(this.currentFocus, true);
                        if (prevIdx === null) // We try to give focus back to the last visible element
                        prevIdx = this.getPrevItemIdx(Infinity, true);
                        const prevItem = this.items.find((i)=>i.index === prevIdx);
                        if (prevItem && this.$refs[`tabLink${prevIdx}`] && !prevItem.disabled) this.giveFocusToTab(this.$refs[`tabLink${prevIdx}`]);
                        event.preventDefault();
                        break;
                    }
                case this.vertical ? "ArrowDown" : "ArrowRight":
                case this.vertical ? "Down" : "Right":
                    {
                        let nextIdx = this.getNextItemIdx(this.currentFocus, true);
                        if (nextIdx === null) // We try to give focus back to the first visible element
                        nextIdx = this.getNextItemIdx(-1, true);
                        const nextItem = this.items.find((i)=>i.index === nextIdx);
                        if (nextItem && this.$refs[`tabLink${nextIdx}`] && !nextItem.disabled) this.giveFocusToTab(this.$refs[`tabLink${nextIdx}`]);
                        event.preventDefault();
                        break;
                    }
            }
        },
        manageTabKeydown (event, childItem) {
            // https://developer.mozilla.org/fr/docs/Web/API/KeyboardEvent/key/Key_Values#Navigation_keys
            const { key } = event;
            switch(key){
                case " ":
                case "Space":
                case "Spacebar":
                case "Enter":
                    this.childClick(childItem);
                    event.preventDefault();
                    break;
            }
        }
    }
};
const _hoisted_1 = [
    "aria-orientation"
];
const _hoisted_2 = [
    "aria-controls",
    "aria-selected"
];
const _hoisted_3 = [
    "id",
    "tabindex",
    "onFocus",
    "onClick",
    "onKeydown"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_slot_component = (0, _vue.resolveComponent)("b-slot-component");
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "b-tabs",
            $options.mainClasses
        ])
    }, [
        (0, _vue.createElementVNode)("nav", {
            class: (0, _vue.normalizeClass)([
                "tabs",
                $options.navClasses
            ]),
            onKeydown: _cache[0] || (_cache[0] = (...args)=>$options.manageTablistKeydown && $options.manageTablistKeydown(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "start"),
            (0, _vue.createElementVNode)("ul", {
                "aria-orientation": _ctx.vertical ? "vertical" : "horizontal",
                role: "tablist"
            }, [
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(_ctx.items, (childItem)=>{
                    return (0, _vue.withDirectives)(((0, _vue.openBlock)(), (0, _vue.createElementBlock)("li", {
                        key: childItem.uniqueValue,
                        class: (0, _vue.normalizeClass)([
                            childItem.headerClass,
                            {
                                "is-active": childItem.isActive,
                                "is-disabled": childItem.disabled
                            }
                        ]),
                        role: "tab",
                        "aria-controls": `${childItem.uniqueValue}-content`,
                        "aria-selected": `${childItem.isActive}`
                    }, [
                        childItem.$slots.header ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_slot_component, {
                            key: 0,
                            ref_for: true,
                            ref: `tabLink${childItem.index}`,
                            component: childItem,
                            name: "header",
                            tag: "a",
                            id: `${childItem.uniqueValue}-label`,
                            tabindex: childItem.isActive ? 0 : -1,
                            onFocus: ($event)=>$data.currentFocus = childItem.index,
                            onClick: ($event)=>_ctx.childClick(childItem),
                            onKeydown: ($event)=>$options.manageTabKeydown($event, childItem)
                        }, null, 8 /* PROPS */ , [
                            "component",
                            "id",
                            "tabindex",
                            "onFocus",
                            "onClick",
                            "onKeydown"
                        ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                            key: 1,
                            ref_for: true,
                            ref: `tabLink${childItem.index}`,
                            id: `${childItem.uniqueValue}-label`,
                            tabindex: childItem.isActive ? 0 : -1,
                            onFocus: ($event)=>$data.currentFocus = childItem.index,
                            onClick: ($event)=>_ctx.childClick(childItem),
                            onKeydown: ($event)=>$options.manageTabKeydown($event, childItem)
                        }, [
                            childItem.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                                key: 0,
                                icon: childItem.icon,
                                pack: childItem.iconPack,
                                size: _ctx.size
                            }, null, 8 /* PROPS */ , [
                                "icon",
                                "pack",
                                "size"
                            ])) : (0, _vue.createCommentVNode)("v-if", true),
                            (0, _vue.createElementVNode)("span", null, (0, _vue.toDisplayString)(childItem.label), 1 /* TEXT */ )
                        ], 40 /* PROPS, HYDRATE_EVENTS */ , _hoisted_3))
                    ], 10 /* CLASS, PROPS */ , _hoisted_2)), [
                        [
                            (0, _vue.vShow),
                            childItem.visible
                        ]
                    ]);
                }), 128 /* KEYED_FRAGMENT */ ))
            ], 8 /* PROPS */ , _hoisted_1),
            (0, _vue.renderSlot)(_ctx.$slots, "end")
        ], 34 /* CLASS, HYDRATE_EVENTS */ ),
        (0, _vue.createElementVNode)("section", {
            class: (0, _vue.normalizeClass)([
                "tab-content",
                {
                    "is-transitioning": _ctx.isTransitioning
                }
            ])
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2 /* CLASS */ )
    ], 2 /* CLASS */ );
}
script$1.render = render;
script$1.__file = "src/components/tabs/Tabs.vue";
var script = {
    name: "BTabItem",
    mixins: [
        (0, _tabbedChildMixinFoL4CKMJs.a)("tab")
    ],
    props: {
        disabled: Boolean
    },
    data () {
        return {
            elementClass: "tab-item",
            elementRole: "tabpanel"
        };
    }
};
script.__file = "src/components/tabs/TabItem.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script$1);
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./config-nHWiBviw.js":"4fneA","./TabbedChildMixin-foL4cK-M.js":"jmgfx","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","./Icon-fJqkx1gN.js":"gKXjn","./SlotComponent-bRURhcxz.js":"2TjGq","./InjectedChildMixin-95-VbgK7.js":"3Zi8S","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"33MT4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTag", ()=>(0, _tag0I8NdmgDJs.s));
parcelHelpers.export(exports, "BTaglist", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _tag0I8NdmgDJs = require("./Tag-0i8ndmgD.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BTaglist",
    props: {
        attached: Boolean
    }
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)([
            "tags",
            {
                "has-addons": $props.attached
            }
        ])
    }, [
        (0, _vue.renderSlot)(_ctx.$slots, "default")
    ], 2 /* CLASS */ );
}
script.render = render;
script.__file = "src/components/tag/Taglist.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _tag0I8NdmgDJs.s));
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./Tag-0i8ndmgD.js":"fLiwF","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./Icon-fJqkx1gN.js":"gKXjn","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fLiwF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "s", ()=>script);
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _vue = require("vue");
var script = {
    name: "BTag",
    components: {
        [(0, _iconFJqkx1GNJs.s).name]: (0, _iconFJqkx1GNJs.s)
    },
    props: {
        attached: Boolean,
        closable: Boolean,
        type: [
            String,
            Object
        ],
        size: String,
        rounded: Boolean,
        disabled: Boolean,
        ellipsis: Boolean,
        tabstop: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: String,
        icon: String,
        iconType: String,
        iconPack: String,
        closeType: String,
        closeIcon: String,
        closeIconPack: String,
        closeIconType: String
    },
    emits: [
        "click",
        "close"
    ],
    computed: {
        // setting a boolean attribute `false` does not remove it on Vue 3.
        // `null` or `undefined` has to be given to remove it.
        disabledOrUndefined () {
            return this.disabled || undefined;
        }
    },
    methods: {
        /**
        * Emit close event when delete button is clicked
        * or delete key is pressed.
        */ close (event) {
            if (this.disabled) return;
            this.$emit("close", event);
        },
        /**
        * Emit click event when tag is clicked.
        */ click (event) {
            if (this.disabled) return;
            this.$emit("click", event);
        }
    }
};
const _hoisted_1 = {
    key: 0,
    class: "tags has-addons inline-tags"
};
const _hoisted_2 = [
    "aria-label",
    "tabindex",
    "disabled"
];
const _hoisted_3 = [
    "aria-label",
    "disabled",
    "tabindex"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_icon = (0, _vue.resolveComponent)("b-icon");
    return $props.attached && $props.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)([
                "tag",
                [
                    $props.type,
                    $props.size,
                    {
                        "is-rounded": $props.rounded
                    }
                ]
            ])
        }, [
            $props.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                key: 0,
                icon: $props.icon,
                size: $props.size,
                type: $props.iconType,
                pack: $props.iconPack
            }, null, 8 /* PROPS */ , [
                "icon",
                "size",
                "type",
                "pack"
            ])) : (0, _vue.createCommentVNode)("v-if", true),
            (0, _vue.createElementVNode)("span", {
                class: (0, _vue.normalizeClass)({
                    "has-ellipsis": $props.ellipsis
                }),
                onClick: _cache[0] || (_cache[0] = (...args)=>$options.click && $options.click(...args))
            }, [
                (0, _vue.renderSlot)(_ctx.$slots, "default")
            ], 2 /* CLASS */ )
        ], 2 /* CLASS */ ),
        (0, _vue.createElementVNode)("a", {
            class: (0, _vue.normalizeClass)([
                "tag",
                [
                    $props.size,
                    $props.closeType,
                    {
                        "is-rounded": $props.rounded
                    },
                    $props.closeIcon ? "has-delete-icon" : "is-delete"
                ]
            ]),
            role: "button",
            "aria-label": $props.ariaCloseLabel,
            tabindex: $props.tabstop ? 0 : false,
            disabled: $options.disabledOrUndefined,
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.close && $options.close(...args)),
            onKeyup: _cache[2] || (_cache[2] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.close && $options.close(...args), [
                "prevent"
            ]), [
                "delete"
            ]))
        }, [
            $props.closeIcon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
                key: 0,
                "custom-class": "",
                icon: $props.closeIcon,
                size: $props.size,
                type: $props.closeIconType,
                pack: $props.closeIconPack
            }, null, 8 /* PROPS */ , [
                "icon",
                "size",
                "type",
                "pack"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_2)
    ])) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        key: 1,
        class: (0, _vue.normalizeClass)([
            "tag",
            [
                $props.type,
                $props.size,
                {
                    "is-rounded": $props.rounded
                }
            ]
        ])
    }, [
        $props.icon ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_icon, {
            key: 0,
            icon: $props.icon,
            size: $props.size,
            type: $props.iconType,
            pack: $props.iconPack
        }, null, 8 /* PROPS */ , [
            "icon",
            "size",
            "type",
            "pack"
        ])) : (0, _vue.createCommentVNode)("v-if", true),
        (0, _vue.createElementVNode)("span", {
            class: (0, _vue.normalizeClass)({
                "has-ellipsis": $props.ellipsis
            }),
            onClick: _cache[3] || (_cache[3] = (...args)=>$options.click && $options.click(...args))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 2 /* CLASS */ ),
        $props.closable ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
            key: 1,
            role: "button",
            "aria-label": $props.ariaCloseLabel,
            class: (0, _vue.normalizeClass)([
                "delete is-small",
                $props.closeType
            ]),
            disabled: $options.disabledOrUndefined,
            tabindex: $props.tabstop ? 0 : false,
            onClick: _cache[4] || (_cache[4] = (...args)=>$options.close && $options.close(...args)),
            onKeyup: _cache[5] || (_cache[5] = (0, _vue.withKeys)((0, _vue.withModifiers)((...args)=>$options.close && $options.close(...args), [
                "prevent"
            ]), [
                "delete"
            ]))
        }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_3)) : (0, _vue.createCommentVNode)("v-if", true)
    ], 2 /* CLASS */ ));
}
script.render = render;
script.__file = "src/components/tag/Tag.vue";

},{"./Icon-fJqkx1gN.js":"gKXjn","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8eICK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTaginput", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _tag0I8NdmgDJs = require("./Tag-0i8ndmgD.js");
var _autocompletePtCdVo0Js = require("./Autocomplete-PtCdVo_0.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var script = {
    name: "BTaginput",
    components: {
        [(0, _autocompletePtCdVo0Js.s).name]: (0, _autocompletePtCdVo0Js.s),
        [(0, _tag0I8NdmgDJs.s).name]: (0, _tag0I8NdmgDJs.s)
    },
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: {
            type: Array,
            default: ()=>[]
        },
        data: {
            type: Array,
            default: ()=>[]
        },
        type: String,
        closeType: String,
        rounded: {
            type: Boolean,
            default: false
        },
        attached: {
            type: Boolean,
            default: false
        },
        maxtags: {
            type: [
                Number,
                String
            ],
            required: false
        },
        hasCounter: {
            type: Boolean,
            default: ()=>(0, _configNHWiBviwJs.c).defaultTaginputHasCounter
        },
        field: {
            type: String,
            default: "value"
        },
        autocomplete: Boolean,
        groupField: String,
        groupOptions: String,
        nativeAutocomplete: String,
        openOnFocus: Boolean,
        keepOpen: {
            type: Boolean,
            default: true
        },
        keepFirst: Boolean,
        disabled: Boolean,
        ellipsis: Boolean,
        closable: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: String,
        confirmKeys: {
            type: Array,
            default: ()=>[
                    ",",
                    "Tab",
                    "Enter"
                ]
        },
        removeOnKeys: {
            type: Array,
            default: ()=>[
                    "Backspace"
                ]
        },
        allowNew: Boolean,
        onPasteSeparators: {
            type: Array,
            default: ()=>[
                    ","
                ]
        },
        beforeAdding: {
            type: Function,
            default: ()=>true
        },
        allowDuplicates: {
            type: Boolean,
            default: false
        },
        checkInfiniteScroll: {
            type: Boolean,
            default: false
        },
        createTag: {
            type: Function,
            default: (tag)=>tag
        },
        appendToBody: Boolean
    },
    emits: [
        "add",
        "infinite-scroll",
        "remove",
        "typing",
        "update:modelValue"
    ],
    data () {
        return {
            tags: Array.isArray(this.modelValue) ? this.modelValue.slice(0) : this.modelValue || [],
            newTag: "",
            isComposing: false,
            _elementRef: "autocomplete",
            _isTaginput: true,
            requestID: null
        };
    },
    computed: {
        rootClasses () {
            return {
                "is-expanded": this.expanded
            };
        },
        containerClasses () {
            return {
                "is-focused": this.isFocused,
                "is-focusable": this.hasInput
            };
        },
        valueLength () {
            return this.newTag.trim().length;
        },
        hasDefaultSlot () {
            return !!this.$slots.default;
        },
        hasEmptySlot () {
            return !!this.$slots.empty;
        },
        hasHeaderSlot () {
            return !!this.$slots.header;
        },
        hasFooterSlot () {
            return !!this.$slots.footer;
        },
        /**
         * Show the input field if a maxtags hasn't been set or reached.
         */ hasInput () {
            return this.maxtags == null || this.maxtags === 1 || this.tagsLength < this.maxtags;
        },
        tagsLength () {
            return this.tags.length;
        },
        /**
         * If Taginput has onPasteSeparators prop,
         * returning new RegExp used to split pasted string.
         */ separatorsAsRegExp () {
            const sep = this.onPasteSeparators;
            return sep.length ? new RegExp(sep.map((s)=>{
                return s ? s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&") : null;
            }).join("|"), "g") : null;
        },
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it.
            // `null` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        /**
         * When v-model is changed set internal value.
         */ modelValue (value) {
            this.tags = Array.isArray(value) ? value.slice(0) : value || [];
        },
        hasInput () {
            if (!this.hasInput) this.onBlur();
        }
    },
    methods: {
        addTag (tag) {
            const tagToAdd = tag || this.newTag.trim();
            if (tagToAdd) {
                if (!this.autocomplete) {
                    const reg = this.separatorsAsRegExp;
                    if (reg && tagToAdd.match(reg)) {
                        tagToAdd.split(reg).map((t)=>t.trim()).filter((t)=>t.length !== 0).map(this.addTag);
                        return;
                    }
                }
                // Add the tag input if it is not blank
                // or previously added (if not allowDuplicates).
                const add = !this.allowDuplicates ? this.tags.indexOf(tagToAdd) === -1 : true;
                if (add && this.beforeAdding(tagToAdd)) {
                    if (this.maxtags === 1) this.tags = []; // replace existing tag if only 1 is allowed
                    this.tags.push(this.createTag(tagToAdd));
                    this.$emit("update:modelValue", this.tags);
                    this.$emit("add", tagToAdd);
                }
                // after autocomplete events
                this.requestID = requestAnimationFrame(()=>{
                    this.newTag = "";
                    this.$emit("typing", "");
                });
            }
        },
        getNormalizedTagText (tag) {
            if (typeof tag === "object") tag = (0, _helpersO9H6ICOJs.g)(tag, this.field);
            return `${tag}`;
        },
        customOnBlur (event) {
            // Add tag on-blur if not select only
            if (!this.autocomplete) this.addTag();
            this.onBlur(event);
        },
        onSelect (option) {
            if (!option) return;
            this.addTag(option);
            this.$nextTick(()=>{
                this.newTag = "";
            });
        },
        removeTag (index, event) {
            const tag = this.tags.splice(index, 1)[0];
            this.$emit("update:modelValue", this.tags);
            this.$emit("remove", tag);
            if (event) event.stopPropagation();
            if (this.openOnFocus && this.$refs.autocomplete) this.$refs.autocomplete.focus();
            return tag;
        },
        removeLastTag () {
            if (this.tagsLength > 0) this.removeTag(this.tagsLength - 1);
        },
        keydown (event) {
            const { key } = event; // cannot destructure preventDefault (https://stackoverflow.com/a/49616808/2774496)
            if (this.removeOnKeys.indexOf(key) !== -1 && !this.newTag.length) this.removeLastTag();
            // Stop if is to accept select only
            if (this.autocomplete && !this.allowNew) return;
            if (this.confirmKeys.indexOf(key) >= 0) {
                // Allow Tab to advance to next field regardless
                if (key !== "Tab") event.preventDefault();
                if (key === "Enter" && this.isComposing) return;
                this.addTag();
            }
        },
        onTyping (event) {
            this.$emit("typing", event.trim());
        },
        emitInfiniteScroll () {
            this.$emit("infinite-scroll");
        }
    },
    beforeUnmount () {
        cancelAnimationFrame(this.requestID);
    }
};
const _hoisted_1 = [
    "disabled"
];
const _hoisted_2 = {
    key: 0,
    class: "help counter"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_tag = (0, _vue.resolveComponent)("b-tag");
    const _component_b_autocomplete = (0, _vue.resolveComponent)("b-autocomplete");
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", (0, _vue.mergeProps)({
        class: [
            "taginput control",
            $options.rootClasses
        ]
    }, _ctx.rootAttrs), [
        (0, _vue.createElementVNode)("div", {
            class: (0, _vue.normalizeClass)([
                "taginput-container",
                [
                    _ctx.statusType,
                    _ctx.size,
                    $options.containerClasses
                ]
            ]),
            disabled: $options.disabledOrUndefined,
            onClick: _cache[3] || (_cache[3] = ($event)=>$options.hasInput && _ctx.focus($event))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "selected", {
                tags: $data.tags
            }, ()=>[
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($data.tags, (tag, index)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_tag, {
                            key: $options.getNormalizedTagText(tag) + index,
                            type: $props.type,
                            "close-type": $props.closeType,
                            size: _ctx.size,
                            rounded: $props.rounded,
                            attached: $props.attached,
                            tabstop: false,
                            disabled: $options.disabledOrUndefined,
                            ellipsis: $props.ellipsis,
                            closable: $props.closable,
                            "aria-close-label": $props.ariaCloseLabel,
                            title: $props.ellipsis && $options.getNormalizedTagText(tag),
                            onClose: ($event)=>$options.removeTag(index, $event)
                        }, {
                            default: (0, _vue.withCtx)(()=>[
                                    (0, _vue.renderSlot)(_ctx.$slots, "tag", {
                                        tag: tag
                                    }, ()=>[
                                            (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.getNormalizedTagText(tag)), 1 /* TEXT */ )
                                        ])
                                ]),
                            _: 2 /* DYNAMIC */ 
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */ , [
                            "type",
                            "close-type",
                            "size",
                            "rounded",
                            "attached",
                            "disabled",
                            "ellipsis",
                            "closable",
                            "aria-close-label",
                            "title",
                            "onClose"
                        ]);
                    }), 128 /* KEYED_FRAGMENT */ ))
                ]),
            $options.hasInput ? ((0, _vue.openBlock)(), (0, _vue.createBlock)(_component_b_autocomplete, (0, _vue.mergeProps)({
                key: 0,
                ref: "autocomplete",
                modelValue: $data.newTag,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$data.newTag = $event)
            }, _ctx.fallthroughAttrs, {
                data: $props.data,
                field: $props.field,
                icon: _ctx.icon,
                "icon-pack": _ctx.iconPack,
                maxlength: _ctx.maxlength,
                "has-counter": false,
                size: _ctx.size,
                disabled: $options.disabledOrUndefined,
                loading: _ctx.loading,
                autocomplete: $props.nativeAutocomplete,
                "open-on-focus": $props.openOnFocus,
                "keep-open": $props.keepOpen,
                "keep-first": $props.keepFirst,
                "group-field": $props.groupField,
                "group-options": $props.groupOptions,
                "use-html5-validation": _ctx.useHtml5Validation,
                "check-infinite-scroll": $props.checkInfiniteScroll,
                "append-to-body": $props.appendToBody,
                "confirm-keys": $props.confirmKeys,
                onTyping: $options.onTyping,
                onFocus: _ctx.onFocus,
                onBlur: $options.customOnBlur,
                onKeydown: $options.keydown,
                onCompositionstart: _cache[1] || (_cache[1] = ($event)=>$data.isComposing = true),
                onCompositionend: _cache[2] || (_cache[2] = ($event)=>$data.isComposing = false),
                onSelect: $options.onSelect,
                onInfiniteScroll: $options.emitInfiniteScroll
            }), (0, _vue.createSlots)({
                _: 2 /* DYNAMIC */ 
            }, [
                $options.hasHeaderSlot ? {
                    name: "header",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "header")
                        ]),
                    key: "0"
                } : undefined,
                $options.hasDefaultSlot ? {
                    name: "default",
                    fn: (0, _vue.withCtx)((props)=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "default", {
                                option: props.option,
                                index: props.index
                            })
                        ]),
                    key: "1"
                } : undefined,
                $options.hasEmptySlot ? {
                    name: "empty",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "empty")
                        ]),
                    key: "2"
                } : undefined,
                $options.hasFooterSlot ? {
                    name: "footer",
                    fn: (0, _vue.withCtx)(()=>[
                            (0, _vue.renderSlot)(_ctx.$slots, "footer")
                        ]),
                    key: "3"
                } : undefined
            ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */ , [
                "modelValue",
                "data",
                "field",
                "icon",
                "icon-pack",
                "maxlength",
                "size",
                "disabled",
                "loading",
                "autocomplete",
                "open-on-focus",
                "keep-open",
                "keep-first",
                "group-field",
                "group-options",
                "use-html5-validation",
                "check-infinite-scroll",
                "append-to-body",
                "confirm-keys",
                "onTyping",
                "onFocus",
                "onBlur",
                "onKeydown",
                "onSelect",
                "onInfiniteScroll"
            ])) : (0, _vue.createCommentVNode)("v-if", true)
        ], 10 /* CLASS, PROPS */ , _hoisted_1),
        $props.hasCounter && ($props.maxtags || _ctx.maxlength) ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("small", _hoisted_2, [
            _ctx.maxlength && $options.valueLength > 0 ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 0
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.valueLength) + " / " + (0, _vue.toDisplayString)(_ctx.maxlength), 1 /* TEXT */ )
            ], 64 /* STABLE_FRAGMENT */ )) : $props.maxtags ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                key: 1
            }, [
                (0, _vue.createTextVNode)((0, _vue.toDisplayString)($options.tagsLength) + " / " + (0, _vue.toDisplayString)($props.maxtags), 1 /* TEXT */ )
            ], 64 /* STABLE_FRAGMENT */ )) : (0, _vue.createCommentVNode)("v-if", true)
        ])) : (0, _vue.createCommentVNode)("v-if", true)
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/taginput/Taginput.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./Tag-0i8ndmgD.js":"fLiwF","./Autocomplete-PtCdVo_0.js":"bRfNi","./config-nHWiBviw.js":"4fneA","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","./Icon-fJqkx1gN.js":"gKXjn","./Input-0ivJhXUC.js":"jYQke","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"479Le":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTimepicker", ()=>(0, _timepickerSqpkdcr1Js.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _timepickerSqpkdcr1Js = require("./Timepicker-sqpkdcr1.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _timepickerMixinMPQh7UTJs = require("./TimepickerMixin-M_pQh7UT.js");
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var _dropdownItemYQcaSZL4Js = require("./DropdownItem-yQcaSZL4.js");
var _trapFocusIMs77O3TJs = require("./trapFocus-IMs77O3T.js");
var _input0IvJhXUCJs = require("./Input-0ivJhXUC.js");
var _iconFJqkx1GNJs = require("./Icon-fJqkx1gN.js");
var _fieldCMd66V8HJs = require("./Field-CMd66v8h.js");
var _selectDYWGhZcJs = require("./Select-DY-wGhZc.js");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _timepickerSqpkdcr1Js.s));
    }
};

},{"./Timepicker-sqpkdcr1.js":"6LEC6","./plugins-C7548x21.js":"fuYWh","./TimepickerMixin-M_pQh7UT.js":"gf5bH","./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./config-nHWiBviw.js":"4fneA","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","./DropdownItem-yQcaSZL4.js":"jPdf6","./trapFocus-IMs77O3T.js":"jBg9U","./Input-0ivJhXUC.js":"jYQke","./Icon-fJqkx1gN.js":"gKXjn","./Field-CMd66v8h.js":"h48jl","./Select-DY-wGhZc.js":"hHgPZ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hUP8f":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BToast", ()=>script);
parcelHelpers.export(exports, "ToastProgrammatic", ()=>ToastProgrammatic);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _classCallCheckE4KhD9XnJs = require("./classCallCheck-E4khD9xn.js");
var _vue = require("vue");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _noticeMixin6CQVv2Js = require("./NoticeMixin-6c_QVv-2.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var script = {
    name: "BToast",
    mixins: [
        (0, _noticeMixin6CQVv2Js.N)
    ],
    data () {
        return {
            newDuration: this.duration || (0, _configNHWiBviwJs.c).defaultToastDuration
        };
    }
};
const _hoisted_1 = [
    "aria-hidden"
];
const _hoisted_2 = [
    "innerHTML"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.Transition), {
        "enter-active-class": _ctx.transition.enter,
        "leave-active-class": _ctx.transition.leave,
        persisted: ""
    }, {
        default: (0, _vue.withCtx)(()=>[
                (0, _vue.withDirectives)((0, _vue.createElementVNode)("div", {
                    onMouseenter: _cache[0] || (_cache[0] = (...args)=>_ctx.pause && _ctx.pause(...args)),
                    onMouseleave: _cache[1] || (_cache[1] = (...args)=>_ctx.removePause && _ctx.removePause(...args)),
                    class: (0, _vue.normalizeClass)([
                        "toast",
                        [
                            _ctx.type,
                            _ctx.position
                        ]
                    ]),
                    "aria-hidden": !_ctx.isActive,
                    role: "alert"
                }, [
                    _ctx.$slots.default ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
                        key: 0
                    }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), {
                        key: 1
                    }, [
                        (0, _vue.createCommentVNode)(" eslint-disable-next-line vue/no-v-html "),
                        (0, _vue.createElementVNode)("div", {
                            innerHTML: _ctx.message
                        }, null, 8 /* PROPS */ , _hoisted_2)
                    ], 64 /* STABLE_FRAGMENT */ ))
                ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */ , _hoisted_1), [
                    [
                        (0, _vue.vShow),
                        _ctx.isActive
                    ]
                ])
            ]),
        _: 3 /* FORWARDED */ 
    }, 8 /* PROPS */ , [
        "enter-active-class",
        "leave-active-class"
    ]);
}
script.render = render;
script.__file = "src/components/toast/Toast.vue";
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _helpersO9H6ICOJs._)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var ToastProgrammatic = /*#__PURE__*/ function() {
    function ToastProgrammatic(app) {
        (0, _classCallCheckE4KhD9XnJs.a)(this, ToastProgrammatic);
        this.app = app; // may be undefined in the testing environment
    }
    (0, _classCallCheckE4KhD9XnJs._)(ToastProgrammatic, [
        {
            key: "open",
            value: function open(params) {
                if (typeof params === "string") params = {
                    message: params
                };
                var defaultParam = {
                    position: (0, _configNHWiBviwJs.c).defaultToastPosition || "is-top"
                };
                if (params.parent) delete params.parent;
                var slot;
                if (Array.isArray(params.message)) {
                    slot = params.message;
                    delete params.message;
                }
                var propsData = (0, _helpersO9H6ICOJs.m)(defaultParam, params);
                var container = document.createElement("div");
                // Vue 3 requires a new app to mount another component
                var vueInstance = (0, _vue.createApp)({
                    data: function data() {
                        return {
                            toastVNode: null
                        };
                    },
                    methods: {
                        close: function close() {
                            var toast = (0, _helpersO9H6ICOJs.z)(this.toastVNode);
                            if (toast) toast.close();
                        }
                    },
                    render: function render() {
                        this.toastVNode = (0, _vue.h)(script, _objectSpread(_objectSpread({}, propsData), {}, {
                            // On Vue 3, $destroy is no longer available.
                            // A toast has to be unmounted manually.
                            onClose: function onClose() {
                                if (typeof propsData.onClose === "function") propsData.onClose();
                                // timeout for the animation complete
                                // before unmounting
                                setTimeout(function() {
                                    vueInstance.unmount();
                                }, 150);
                            }
                        }), slot != null ? {
                            "default": function _default() {
                                return slot;
                            }
                        } : undefined);
                        // we are interested in `toastVNode.component` but
                        // at this point `toastVNode.component` should be null
                        return this.toastVNode;
                    }
                });
                if (this.app) (0, _helpersO9H6ICOJs.A)(this.app, vueInstance);
                else // adds $buefy global property
                // so that $buefy.globalNoticeInterval is available on the new Vue app
                vueInstance.config.globalProperties.$buefy = {};
                return vueInstance.mount(container);
            }
        }
    ]);
    return ToastProgrammatic;
}();
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.r)(Vue, "toast", new ToastProgrammatic(Vue));
    }
};

},{"./helpers-O9h6_ICO.js":"9IzVa","./classCallCheck-E4khD9xn.js":"fYU5v","vue":"dylud","./config-nHWiBviw.js":"4fneA","./NoticeMixin-6c_QVv-2.js":"73Jf4","./plugins-C7548x21.js":"fuYWh","./typeof-Z4rCTFCZ.js":"cvqjf","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHbzl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BTooltip", ()=>(0, _tooltipWHq2LJasJs.s));
parcelHelpers.export(exports, "default", ()=>Plugin);
var _tooltipWHq2LJasJs = require("./Tooltip-WHq2LJas.js");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, (0, _tooltipWHq2LJasJs.s));
    }
};

},{"./Tooltip-WHq2LJas.js":"6mgq3","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lrgmG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BUpload", ()=>script);
parcelHelpers.export(exports, "default", ()=>Plugin);
var _compatFallthroughMixinEv2XGfi3Js = require("./CompatFallthroughMixin-Ev2XGfi3.js");
var _formElementMixinILDlgM3IJs = require("./FormElementMixin-ILDlgM3i.js");
var _ssrJg9YOstJs = require("./ssr-jg9-YOst.js");
var _vue = require("vue");
var _pluginsC7548X21Js = require("./plugins-C7548x21.js");
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var script = {
    name: "BUpload",
    mixins: [
        (0, _compatFallthroughMixinEv2XGfi3Js.C),
        (0, _formElementMixinILDlgM3IJs.F)
    ],
    props: {
        modelValue: {
            type: [
                Object,
                Function,
                (0, _ssrJg9YOstJs.F),
                Array
            ]
        },
        multiple: Boolean,
        disabled: Boolean,
        accept: String,
        dragDrop: Boolean,
        type: {
            type: String,
            default: "is-primary"
        },
        native: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        "invalid",
        "update:modelValue"
    ],
    data () {
        return {
            newValue: this.modelValue,
            dragDropFocus: false,
            _elementRef: "input"
        };
    },
    computed: {
        disabledOrUndefined () {
            // On Vue 3, setting a boolean attribute `false` does not remove it,
            // `true` or `undefined` has to be given to remove it.
            return this.disabled || undefined;
        }
    },
    watch: {
        /**
         *   When v-model is changed:
         *   1. Set internal value.
         *   2. Reset internal input file value
         *   3. If it's invalid, validate again.
         */ modelValue (value) {
            this.newValue = value;
            if (!value || Array.isArray(value) && value.length === 0) this.$refs.input.value = null;
            !this.isValid && !this.dragDrop && this.checkHtml5Validity();
        }
    },
    methods: {
        /**
        * Listen change event on input type 'file',
        * emit 'input' event and validate
        */ onFileChange (event) {
            if (this.disabled || this.loading) return;
            if (this.dragDrop) this.updateDragDropFocus(false);
            const value = event.target.files || event.dataTransfer.files;
            if (value.length === 0) {
                if (!this.newValue) return;
                if (this.native) this.newValue = null;
            } else if (!this.multiple) {
                // only one element in case drag drop mode and isn't multiple
                if (this.dragDrop && value.length !== 1) return;
                else {
                    const file = value[0];
                    if (this.checkType(file)) this.newValue = file;
                    else if (this.newValue) {
                        this.newValue = null;
                        this.clearInput();
                    } else {
                        // Force input back to empty state and recheck validity
                        this.clearInput();
                        this.checkHtml5Validity();
                        return;
                    }
                }
            } else {
                // always new values if native or undefined local
                let newValues = false;
                if (this.native || !this.newValue) {
                    this.newValue = [];
                    newValues = true;
                }
                for(let i = 0; i < value.length; i++){
                    const file = value[i];
                    if (this.checkType(file)) {
                        this.newValue.push(file);
                        newValues = true;
                    }
                }
                if (!newValues) return;
            }
            this.$emit("update:modelValue", this.newValue);
            !this.dragDrop && this.checkHtml5Validity();
        },
        /*
        * Reset file input value
        */ clearInput () {
            this.$refs.input.value = null;
        },
        /**
        * Listen drag-drop to update internal variable
        */ updateDragDropFocus (focus) {
            if (!this.disabled && !this.loading) this.dragDropFocus = focus;
        },
        /**
        * Check mime type of file
        */ checkType (file) {
            if (!this.accept) return true;
            const types = this.accept.split(",");
            if (types.length === 0) return true;
            let valid = false;
            for(let i = 0; i < types.length && !valid; i++){
                const type = types[i].trim();
                if (type) {
                    if (type.substring(0, 1) === ".") {
                        // check extension
                        const extension = file.name.toLowerCase().slice(-type.length);
                        if (extension === type.toLowerCase()) valid = true;
                    } else // check mime type
                    if (file.type.match(type)) valid = true;
                }
            }
            if (!valid) this.$emit("invalid");
            return valid;
        }
    }
};
const _hoisted_1 = [
    "multiple",
    "accept",
    "disabled"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("label", (0, _vue.mergeProps)({
        class: "upload control"
    }, _ctx.rootAttrs, {
        class: [
            {
                "is-expanded": $props.expanded,
                "is-rounded": $props.rounded
            }
        ]
    }), [
        !$props.dragDrop ? (0, _vue.renderSlot)(_ctx.$slots, "default", {
            key: 0
        }) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
            key: 1,
            class: (0, _vue.normalizeClass)([
                "upload-draggable",
                [
                    $props.type,
                    {
                        "is-loading": _ctx.loading,
                        "is-disabled": $props.disabled,
                        "is-hovered": $data.dragDropFocus,
                        "is-expanded": $props.expanded
                    }
                ]
            ]),
            onDragover: _cache[0] || (_cache[0] = (0, _vue.withModifiers)(($event)=>$options.updateDragDropFocus(true), [
                "prevent"
            ])),
            onDragleave: _cache[1] || (_cache[1] = (0, _vue.withModifiers)(($event)=>$options.updateDragDropFocus(false), [
                "prevent"
            ])),
            onDragenter: _cache[2] || (_cache[2] = (0, _vue.withModifiers)(($event)=>$options.updateDragDropFocus(true), [
                "prevent"
            ])),
            onDrop: _cache[3] || (_cache[3] = (0, _vue.withModifiers)((...args)=>$options.onFileChange && $options.onFileChange(...args), [
                "prevent"
            ]))
        }, [
            (0, _vue.renderSlot)(_ctx.$slots, "default")
        ], 34 /* CLASS, HYDRATE_EVENTS */ )),
        (0, _vue.createElementVNode)("input", (0, _vue.mergeProps)({
            ref: "input",
            type: "file"
        }, _ctx.fallthroughAttrs, {
            multiple: $props.multiple,
            accept: $props.accept,
            disabled: $options.disabledOrUndefined,
            onChange: _cache[4] || (_cache[4] = (...args)=>$options.onFileChange && $options.onFileChange(...args))
        }), null, 16 /* FULL_PROPS */ , _hoisted_1)
    ], 16 /* FULL_PROPS */ );
}
script.render = render;
script.__file = "src/components/upload/Upload.vue";
var Plugin = {
    install: function install(Vue) {
        (0, _pluginsC7548X21Js.a)(Vue, script);
    }
};

},{"./CompatFallthroughMixin-Ev2XGfi3.js":"9b7J5","./FormElementMixin-ILDlgM3i.js":"5s7Sr","./ssr-jg9-YOst.js":"8rU16","vue":"dylud","./plugins-C7548x21.js":"fuYWh","./config-nHWiBviw.js":"4fneA","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"anYU9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ConfigComponent);
var _configNHWiBviwJs = require("./config-nHWiBviw.js");
var _helpersO9H6ICOJs = require("./helpers-O9h6_ICO.js");
var _typeofZ4RCTFCZJs = require("./typeof-Z4rCTFCZ.js");
var _vue = require("vue");
var ConfigComponent = {
    getOptions: function getOptions() {
        return 0, _configNHWiBviwJs.c;
    },
    setOptions: function setOptions$1(options) {
        (0, _configNHWiBviwJs.s)((0, _helpersO9H6ICOJs.m)((0, _configNHWiBviwJs.c), options, true));
    }
};

},{"./config-nHWiBviw.js":"4fneA","./helpers-O9h6_ICO.js":"9IzVa","./typeof-Z4rCTFCZ.js":"cvqjf","vue":"dylud","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"13wIX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_URL", ()=>API_URL);
parcelHelpers.export(exports, "buefyConfig", ()=>buefyConfig);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isInsideIFrame", ()=>isInsideIFrame);
parcelHelpers.export(exports, "fetchJson", ()=>fetchJson);
parcelHelpers.export(exports, "fetchMessages", ()=>fetchMessages);
parcelHelpers.export(exports, "getDefaultLocale", ()=>getDefaultLocale);
parcelHelpers.export(exports, "pickLocaleFrom", ()=>pickLocaleFrom);
parcelHelpers.export(exports, "getTimezone", ()=>getTimezone);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var API_URL = "../de.elo.ix.plugin.rest/auth2";
var buefyConfig = {
    defaultIconPack: "e-icon"
};
function isEmpty(obj) {
    return !obj || Object.keys(obj).length === 0;
}
function isInsideIFrame() {
    return window.top !== window.self;
}
function fetchJson(url) {
    return __awaiter(this, void 0, Promise, function() {
        var req, json, e_1;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4 /*yield*/ ,
                        fetch(url)
                    ];
                case 1:
                    req = _a.sent();
                    if (!req.ok) throw "Unexpected response status: ".concat(req.status);
                    return [
                        4 /*yield*/ ,
                        req.json()
                    ];
                case 2:
                    json = _a.sent();
                    console.debug(json);
                    return [
                        2 /*return*/ ,
                        json
                    ];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    alert("Failed to fetch ".concat(url));
                    throw e_1;
                case 4:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
var DEFAULT_ELO_LOCALES = [
    "cs",
    "da",
    "de",
    "el",
    "en",
    "es",
    "es-419",
    "fi",
    "fr",
    "hu",
    "id",
    "it",
    "nl",
    "pl",
    "pt",
    "pt-BR",
    "ro",
    "sk",
    "sr",
    "sr-Cyrl",
    "tr"
];
function fetchMessages() {
    return __awaiter(this, void 0, Promise, function() {
        var locale, messages;
        return __generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    locale = pickLocaleFrom(DEFAULT_ELO_LOCALES);
                    return [
                        4 /*yield*/ ,
                        fetchJson("./locales/sign-in-".concat(locale, ".json"))
                    ];
                case 1:
                    messages = _a.sent();
                    messages["LOCALE"] = locale;
                    document.documentElement.lang = locale;
                    return [
                        2 /*return*/ ,
                        messages
                    ];
            }
        });
    });
}
function getDefaultLocale() {
    return pickLocaleFrom(DEFAULT_ELO_LOCALES);
}
function pickLocaleFrom(locales) {
    // contains the browser locales/languages by order of preference
    var langs = navigator.languages;
    if (!langs) langs = [
        navigator.language
    ];
    for(var _i = 0, langs_1 = langs; _i < langs_1.length; _i++){
        var lang = langs_1[_i];
        if (locales.includes(lang)) return lang;
        // Fallback to the more generic language (example "pt-BR" -> "pt")
        var shortCode = lang.split("-")[0];
        if (locales.includes(shortCode)) return shortCode;
    }
    return locales[0];
}
function getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},[], null, "parcelRequiree3ab")

//# sourceMappingURL=access-denied.d4507c60.js.map
